/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 249);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var getOwnPropertyDescriptor = __webpack_require__(26).f;
var createNonEnumerableProperty = __webpack_require__(28);
var defineBuiltIn = __webpack_require__(16);
var defineGlobalProperty = __webpack_require__(129);
var copyConstructorProperties = __webpack_require__(105);
var isForced = __webpack_require__(84);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(81);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(100)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(44);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(81);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(9);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__(148);
var DESCRIPTORS = __webpack_require__(4);
var global = __webpack_require__(3);
var isCallable = __webpack_require__(10);
var isObject = __webpack_require__(9);
var hasOwn = __webpack_require__(12);
var classof = __webpack_require__(44);
var tryToString = __webpack_require__(62);
var createNonEnumerableProperty = __webpack_require__(28);
var defineBuiltIn = __webpack_require__(16);
var defineBuiltInAccessor = __webpack_require__(24);
var isPrototypeOf = __webpack_require__(38);
var getPrototypeOf = __webpack_require__(34);
var setPrototypeOf = __webpack_require__(45);
var wellKnownSymbol = __webpack_require__(11);
var uid = __webpack_require__(71);
var InternalStateModule = __webpack_require__(22);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw new TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw new TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw new TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(10);
var $documentAll = __webpack_require__(169);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $documentAll = __webpack_require__(169);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var shared = __webpack_require__(70);
var hasOwn = __webpack_require__(12);
var uid = __webpack_require__(71);
var NATIVE_SYMBOL = __webpack_require__(69);
var USE_SYMBOL_AS_UID = __webpack_require__(170);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var toObject = __webpack_require__(13);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__(18);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__(32);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var isCallable = __webpack_require__(10);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(10);
var definePropertyModule = __webpack_require__(17);
var makeBuiltIn = __webpack_require__(130);
var defineGlobalProperty = __webpack_require__(129);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var IE8_DOM_DEFINE = __webpack_require__(172);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(173);
var anObject = __webpack_require__(7);
var toPropertyKey = __webpack_require__(57);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__(29);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(10);
var tryToString = __webpack_require__(62);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = false;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__(176);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(174);
var global = __webpack_require__(3);
var isObject = __webpack_require__(9);
var createNonEnumerableProperty = __webpack_require__(28);
var hasOwn = __webpack_require__(12);
var shared = __webpack_require__(128);
var sharedKey = __webpack_require__(104);
var hiddenKeys = __webpack_require__(82);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(68);
var requireObjectCoercible = __webpack_require__(18);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var makeBuiltIn = __webpack_require__(130);
var defineProperty = __webpack_require__(17);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(41);
var uncurryThis = __webpack_require__(2);
var IndexedObject = __webpack_require__(68);
var toObject = __webpack_require__(13);
var lengthOfArrayLike = __webpack_require__(14);
var arraySpeciesCreate = __webpack_require__(87);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var call = __webpack_require__(6);
var propertyIsEnumerableModule = __webpack_require__(101);
var createPropertyDescriptor = __webpack_require__(37);
var toIndexedObject = __webpack_require__(23);
var toPropertyKey = __webpack_require__(57);
var hasOwn = __webpack_require__(12);
var IE8_DOM_DEFINE = __webpack_require__(172);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var definePropertyModule = __webpack_require__(17);
var createPropertyDescriptor = __webpack_require__(37);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__(137);
var hasOwn = __webpack_require__(12);
var wrappedWellKnownSymbolModule = __webpack_require__(178);
var defineProperty = __webpack_require__(17).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(11);
var create = __webpack_require__(39);
var defineProperty = __webpack_require__(17).f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(21);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__(17).f;
var hasOwn = __webpack_require__(12);
var wellKnownSymbol = __webpack_require__(11);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(12);
var isCallable = __webpack_require__(10);
var toObject = __webpack_require__(13);
var sharedKey = __webpack_require__(104);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(139);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var requireObjectCoercible = __webpack_require__(18);
var toString = __webpack_require__(5);

var quot = /"/g;
var replace = uncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(7);
var definePropertiesModule = __webpack_require__(135);
var enumBugKeys = __webpack_require__(133);
var hiddenKeys = __webpack_require__(82);
var html = __webpack_require__(177);
var documentCreateElement = __webpack_require__(103);
var sharedKey = __webpack_require__(104);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(81);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(59);
var aCallable = __webpack_require__(19);
var NATIVE_BIND = __webpack_require__(81);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(21);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(134);
var isCallable = __webpack_require__(10);
var classofRaw = __webpack_require__(27);
var wellKnownSymbol = __webpack_require__(11);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(277);
var anObject = __webpack_require__(7);
var aPossiblePrototype = __webpack_require__(183);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(41);
var call = __webpack_require__(6);
var anObject = __webpack_require__(7);
var tryToString = __webpack_require__(62);
var isArrayIteratorMethod = __webpack_require__(140);
var lengthOfArrayLike = __webpack_require__(14);
var isPrototypeOf = __webpack_require__(38);
var getIterator = __webpack_require__(107);
var getIteratorMethod = __webpack_require__(90);
var iteratorClose = __webpack_require__(189);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isPrototypeOf = __webpack_require__(38);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw new $TypeError('Incorrect invocation');
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (options) {
  var mappedProps = options.mappedProps,
      name = options.name,
      ctr = options.ctr,
      ctrArgs = options.ctrArgs,
      events = options.events,
      beforeCreate = options.beforeCreate,
      afterCreate = options.afterCreate,
      props = options.props,
      rest = _objectWithoutProperties(options, ['mappedProps', 'name', 'ctr', 'ctrArgs', 'events', 'beforeCreate', 'afterCreate', 'props']);

  var promiseName = '$' + name + 'Promise';
  var instanceName = '$' + name + 'Object';

  assert(!(rest.props instanceof Array), '`props` should be an object, not Array');

  return _extends({}, typeof GENERATE_DOC !== 'undefined' ? { $vgmOptions: options } : {}, {
    mixins: [_mapElementMixin2.default],
    props: _extends({}, props, mappedPropsToVueProps(mappedProps)),
    render: function render() {
      return '';
    },
    provide: function provide() {
      var _this = this;

      var promise = this.$mapPromise.then(function (map) {
        // Infowindow needs this to be immediately available
        _this.$map = map;

        // Initialize the maps with the given options
        var options = _extends({}, _this.options, {
          map: map
        }, (0, _bindProps.getPropsValues)(_this, mappedProps));
        delete options.options; // delete the extra options

        if (beforeCreate) {
          var result = beforeCreate.bind(_this)(options);

          if (result instanceof Promise) {
            return result.then(function () {
              return { options: options };
            });
          }
        }
        return { options: options };
      }).then(function (_ref) {
        var _Function$prototype$b;

        var options = _ref.options;

        var ConstructorObject = ctr();
        // https://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
        _this[instanceName] = ctrArgs ? new ((_Function$prototype$b = Function.prototype.bind).call.apply(_Function$prototype$b, [ConstructorObject, null].concat(_toConsumableArray(ctrArgs(options, (0, _bindProps.getPropsValues)(_this, props || {}))))))() : new ConstructorObject(options);

        (0, _bindProps.bindProps)(_this, _this[instanceName], mappedProps);
        (0, _bindEvents2.default)(_this, _this[instanceName], events);

        if (afterCreate) {
          afterCreate.bind(_this)(_this[instanceName]);
        }
        return _this[instanceName];
      });
      this[promiseName] = promise;
      return _defineProperty({}, promiseName, promise);
    },
    destroyed: function destroyed() {
      // Note: not all Google Maps components support maps
      if (this[instanceName] && this[instanceName].setMap) {
        this[instanceName].setMap(null);
      }
    }
  }, rest);
};

exports.mappedPropsToVueProps = mappedPropsToVueProps;

var _bindEvents = __webpack_require__(166);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(99);

var _mapElementMixin = __webpack_require__(241);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 *
 * @param {Object} options
 * @param {Object} options.mappedProps - Definitions of props
 * @param {Object} options.mappedProps.PROP.type - Value type
 * @param {Boolean} options.mappedProps.PROP.twoWay
 *  - Whether the prop has a corresponding PROP_changed
 *   event
 * @param {Boolean} options.mappedProps.PROP.noBind
 *  - If true, do not apply the default bindProps / bindEvents.
 * However it will still be added to the list of component props
 * @param {Object} options.props - Regular Vue-style props.
 *  Note: must be in the Object form because it will be
 *  merged with the `mappedProps`
 *
 * @param {Object} options.events - Google Maps API events
 *  that are not bound to a corresponding prop
 * @param {String} options.name - e.g. `polyline`
 * @param {=> String} options.ctr - constructor, e.g.
 *  `google.maps.Polyline`. However, since this is not
 *  generally available during library load, this becomes
 *  a function instead, e.g. () => google.maps.Polyline
 *  which will be called only after the API has been loaded
 * @param {(MappedProps, OtherVueProps) => Array} options.ctrArgs -
 *   If the constructor in `ctr` needs to be called with
 *   arguments other than a single `options` object, e.g. for
 *   GroundOverlay, we call `new GroundOverlay(url, bounds, options)`
 *   then pass in a function that returns the argument list as an array
 *
 * Otherwise, the constructor will be called with an `options` object,
 *   with property and values merged from:
 *
 *   1. the `options` property, if any
 *   2. a `map` property with the Google Maps
 *   3. all the properties passed to the component in `mappedProps`
 * @param {Object => Any} options.beforeCreate -
 *  Hook to modify the options passed to the initializer
 * @param {(options.ctr, Object) => Any} options.afterCreate -
 *  Hook called when
 *
 */


function assert(v, message) {
  if (!v) throw new Error(message);
}

/**
 * Strips out the extraneous properties we have in our
 * props definitions
 * @param {Object} props
 */
function mappedPropsToVueProps(mappedProps) {
  return Object.entries(mappedProps).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        prop = _ref4[1];

    var value = {};

    if ('type' in prop) value.type = prop.type;
    if ('default' in prop) value.default = prop.default;
    if ('required' in prop) value.required = prop.required;

    return [key, value];
  }).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        val = _ref6[1];

    acc[key] = val;
    return acc;
  }, {});
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var userAgent = __webpack_require__(51);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(19);
var isNullOrUndefined = __webpack_require__(29);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(57);
var definePropertyModule = __webpack_require__(17);
var createPropertyDescriptor = __webpack_require__(37);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var classof = __webpack_require__(27);

module.exports = classof(global.process) === 'process';


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var call = __webpack_require__(6);
var DESCRIPTORS = __webpack_require__(4);
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(162);
var ArrayBufferViewCore = __webpack_require__(8);
var ArrayBufferModule = __webpack_require__(113);
var anInstance = __webpack_require__(47);
var createPropertyDescriptor = __webpack_require__(37);
var createNonEnumerableProperty = __webpack_require__(28);
var isIntegralNumber = __webpack_require__(154);
var toLength = __webpack_require__(32);
var toIndex = __webpack_require__(200);
var toOffset = __webpack_require__(223);
var toUint8Clamped = __webpack_require__(482);
var toPropertyKey = __webpack_require__(57);
var hasOwn = __webpack_require__(12);
var classof = __webpack_require__(44);
var isObject = __webpack_require__(9);
var isSymbol = __webpack_require__(61);
var create = __webpack_require__(39);
var isPrototypeOf = __webpack_require__(38);
var setPrototypeOf = __webpack_require__(45);
var getOwnPropertyNames = __webpack_require__(58).f;
var typedArrayFrom = __webpack_require__(224);
var forEach = __webpack_require__(25).forEach;
var setSpecies = __webpack_require__(76);
var defineBuiltInAccessor = __webpack_require__(24);
var definePropertyModule = __webpack_require__(17);
var getOwnPropertyDescriptorModule = __webpack_require__(26);
var InternalStateModule = __webpack_require__(22);
var inheritIfRequired = __webpack_require__(74);

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var enforceInternalState = InternalStateModule.enforce;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var RangeError = global.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  aTypedArrayConstructor(C);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  defineBuiltInAccessor(it, key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var isArrayBuffer = function (it) {
  var klass;
  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) === 'ArrayBuffer' || klass === 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && hasOwn(descriptor, 'value')
    && !hasOwn(descriptor, 'get')
    && !hasOwn(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwn(descriptor, 'writable') || descriptor.writable)
    && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? toUint8Clamped(value) : value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw new RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw new RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw new RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(102);
var isSymbol = __webpack_require__(61);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(175);
var enumBugKeys = __webpack_require__(133);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classofRaw = __webpack_require__(27);
var uncurryThis = __webpack_require__(2);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(27);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(15);
var isCallable = __webpack_require__(10);
var isPrototypeOf = __webpack_require__(38);
var USE_SYMBOL_AS_UID = __webpack_require__(170);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

module.exports = uncurryThis([].slice);


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var hiddenKeys = __webpack_require__(82);
var isObject = __webpack_require__(9);
var hasOwn = __webpack_require__(12);
var defineProperty = __webpack_require__(17).f;
var getOwnPropertyNamesModule = __webpack_require__(58);
var getOwnPropertyNamesExternalModule = __webpack_require__(136);
var isExtensible = __webpack_require__(152);
var uid = __webpack_require__(71);
var FREEZING = __webpack_require__(78);

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(19);

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(562)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(1);
var classof = __webpack_require__(27);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(50);
var fails = __webpack_require__(1);
var global = __webpack_require__(3);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(20);
var store = __webpack_require__(128);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.33.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.33.2/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var hasOwn = __webpack_require__(12);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(1);
var isCallable = __webpack_require__(10);
var classof = __webpack_require__(44);
var getBuiltIn = __webpack_require__(15);
var inspectSource = __webpack_require__(131);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(10);
var isObject = __webpack_require__(9);
var setPrototypeOf = __webpack_require__(45);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(15);
var defineBuiltInAccessor = __webpack_require__(24);
var wellKnownSymbol = __webpack_require__(11);
var DESCRIPTORS = __webpack_require__(4);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(7);
var aConstructor = __webpack_require__(150);
var isNullOrUndefined = __webpack_require__(29);
var wellKnownSymbol = __webpack_require__(11);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var requireObjectCoercible = __webpack_require__(18);
var toString = __webpack_require__(5);
var whitespaces = __webpack_require__(118);

var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);

module.exports = global.Promise;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(23);
var toAbsoluteIndex = __webpack_require__(43);
var lengthOfArrayLike = __webpack_require__(14);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);
var isCallable = __webpack_require__(10);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(175);
var enumBugKeys = __webpack_require__(133);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toAbsoluteIndex = __webpack_require__(43);
var lengthOfArrayLike = __webpack_require__(14);
var createProperty = __webpack_require__(53);

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  var n = 0;
  for (; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var arraySpeciesConstructor = __webpack_require__(257);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toString = __webpack_require__(5);

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(44);
var getMethod = __webpack_require__(52);
var isNullOrUndefined = __webpack_require__(29);
var Iterators = __webpack_require__(89);
var wellKnownSymbol = __webpack_require__(11);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);
var wellKnownSymbol = __webpack_require__(11);
var V8_VERSION = __webpack_require__(50);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(16);

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var NativePromiseConstructor = __webpack_require__(80);
var isCallable = __webpack_require__(10);
var isForced = __webpack_require__(84);
var inspectSource = __webpack_require__(131);
var wellKnownSymbol = __webpack_require__(11);
var IS_BROWSER = __webpack_require__(214);
var IS_DENO = __webpack_require__(155);
var IS_PURE = __webpack_require__(20);
var V8_VERSION = __webpack_require__(50);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(9);
var classof = __webpack_require__(27);
var wellKnownSymbol = __webpack_require__(11);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6);
var hasOwn = __webpack_require__(12);
var isPrototypeOf = __webpack_require__(38);
var regExpFlags = __webpack_require__(156);

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6);
var anObject = __webpack_require__(7);
var isCallable = __webpack_require__(10);
var classof = __webpack_require__(27);
var regexpExec = __webpack_require__(123);

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw new $TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropsValues = getPropsValues;
exports.bindProps = bindProps;

var _WatchPrimitiveProperties = __webpack_require__(167);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getPropsValues(vueInst, props) {
  return Object.keys(props).reduce(function (acc, prop) {
    if (vueInst[prop] !== undefined) {
      acc[prop] = vueInst[prop];
    }
    return acc;
  }, {});
}

/**
  * Binds the properties defined in props to the google maps instance.
  * If the prop is an Object type, and we wish to track the properties
  * of the object (e.g. the lat and lng of a LatLng), then we do a deep
  * watch. For deep watch, we also prevent the _changed event from being
  * emitted if the data source was external.
  */
function bindProps(vueInst, googleMapsInst, props) {
  var _loop = function (attribute) {
    var _props$attribute = props[attribute],
        twoWay = _props$attribute.twoWay,
        type = _props$attribute.type,
        trackProperties = _props$attribute.trackProperties,
        noBind = _props$attribute.noBind;


    if (noBind) return 'continue';

    var setMethodName = 'set' + capitalizeFirstLetter(attribute);
    var getMethodName = 'get' + capitalizeFirstLetter(attribute);
    var eventName = attribute.toLowerCase() + '_changed';
    var initialValue = vueInst[attribute];

    if (typeof googleMapsInst[setMethodName] === 'undefined') {
      throw new Error(setMethodName + ' is not a method of (the Maps object corresponding to) ' + vueInst.$options._componentTag);
    }

    // We need to avoid an endless
    // propChanged -> event emitted -> propChanged -> event emitted loop
    // although this may really be the user's responsibility
    if (type !== Object || !trackProperties) {
      // Track the object deeply
      vueInst.$watch(attribute, function () {
        var attributeValue = vueInst[attribute];

        googleMapsInst[setMethodName](attributeValue);
      }, {
        immediate: typeof initialValue !== 'undefined',
        deep: type === Object
      });
    } else {
      (0, _WatchPrimitiveProperties2.default)(vueInst, trackProperties.map(function (prop) {
        return attribute + '.' + prop;
      }), function () {
        googleMapsInst[setMethodName](vueInst[attribute]);
      }, vueInst[attribute] !== undefined);
    }

    if (twoWay && (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName])) {
      googleMapsInst.addListener(eventName, function () {
        // eslint-disable-line no-unused-vars
        vueInst.$emit(eventName, googleMapsInst[getMethodName]());
      });
    }
  };

  for (var attribute in props) {
    var _ret = _loop(attribute);

    if (_ret === 'continue') continue;
  }
}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6);
var isObject = __webpack_require__(9);
var isSymbol = __webpack_require__(61);
var getMethod = __webpack_require__(52);
var ordinaryToPrimitive = __webpack_require__(171);
var wellKnownSymbol = __webpack_require__(11);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var isObject = __webpack_require__(9);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__(70);
var uid = __webpack_require__(71);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(12);
var ownKeys = __webpack_require__(132);
var getOwnPropertyDescriptorModule = __webpack_require__(26);
var definePropertyModule = __webpack_require__(17);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6);
var aCallable = __webpack_require__(19);
var anObject = __webpack_require__(7);
var tryToString = __webpack_require__(62);
var getIteratorMethod = __webpack_require__(90);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw new $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var tryToString = __webpack_require__(62);

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(41);
var IndexedObject = __webpack_require__(68);
var toObject = __webpack_require__(13);
var lengthOfArrayLike = __webpack_require__(14);

// `Array.prototype.{ findLast, findLastIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_FIND_LAST_INDEX = TYPE === 1;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var index = lengthOfArrayLike(self);
    var value, result;
    while (index-- > 0) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (result) switch (TYPE) {
        case 0: return value; // findLast
        case 1: return index; // findLastIndex
      }
    }
    return IS_FIND_LAST_INDEX ? -1 : undefined;
  };
};

module.exports = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: createMethod(0),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: createMethod(1)
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(11);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(23);
var addToUnscopables = __webpack_require__(31);
var Iterators = __webpack_require__(89);
var InternalStateModule = __webpack_require__(22);
var defineProperty = __webpack_require__(17).f;
var defineIterator = __webpack_require__(142);
var createIterResultObject = __webpack_require__(92);
var IS_PURE = __webpack_require__(20);
var DESCRIPTORS = __webpack_require__(4);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(19);
var toObject = __webpack_require__(13);
var IndexedObject = __webpack_require__(68);
var lengthOfArrayLike = __webpack_require__(14);

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var uncurryThis = __webpack_require__(2);
var DESCRIPTORS = __webpack_require__(4);
var NATIVE_ARRAY_BUFFER = __webpack_require__(148);
var FunctionName = __webpack_require__(72);
var createNonEnumerableProperty = __webpack_require__(28);
var defineBuiltInAccessor = __webpack_require__(24);
var defineBuiltIns = __webpack_require__(93);
var fails = __webpack_require__(1);
var anInstance = __webpack_require__(47);
var toIntegerOrInfinity = __webpack_require__(21);
var toLength = __webpack_require__(32);
var toIndex = __webpack_require__(200);
var fround = __webpack_require__(201);
var IEEE754 = __webpack_require__(323);
var getPrototypeOf = __webpack_require__(34);
var setPrototypeOf = __webpack_require__(45);
var getOwnPropertyNames = __webpack_require__(58).f;
var arrayFill = __webpack_require__(141);
var arraySlice = __webpack_require__(86);
var setToStringTag = __webpack_require__(33);
var InternalStateModule = __webpack_require__(22);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var getInternalArrayBufferState = InternalStateModule.getterFor(ARRAY_BUFFER);
var getInternalDataViewState = InternalStateModule.getterFor(DATA_VIEW);
var setInternalState = InternalStateModule.set;
var NativeArrayBuffer = global[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array = global.Array;
var RangeError = global.RangeError;
var fill = uncurryThis(arrayFill);
var reverse = uncurryThis([].reverse);

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(fround(number), 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key, getInternalState) {
  defineBuiltInAccessor(Constructor[PROTOTYPE], key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var get = function (view, count, index, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex(index);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength) throw new RangeError(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySlice(bytes, start, start + count);
  return boolIsLittleEndian ? pack : reverse(pack);
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex(index);
  var pack = conversion(+value);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength) throw new RangeError(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  for (var i = 0; i < count; i++) bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, ArrayBufferPrototype);
    var byteLength = toIndex(length);
    setInternalState(this, {
      type: ARRAY_BUFFER,
      bytes: fill(Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) {
      this.byteLength = byteLength;
      this.detached = false;
    }
  };

  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, DataViewPrototype);
    anInstance(buffer, ArrayBufferPrototype);
    var bufferState = getInternalArrayBufferState(buffer);
    var bufferLength = bufferState.byteLength;
    var offset = toIntegerOrInfinity(byteOffset);
    if (offset < 0 || offset > bufferLength) throw new RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw new RangeError(WRONG_LENGTH);
    setInternalState(this, {
      type: DATA_VIEW,
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset,
      bytes: bufferState.bytes
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype = $DataView[PROTOTYPE];

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
    addGetter($DataView, 'buffer', getInternalDataViewState);
    addGetter($DataView, 'byteLength', getInternalDataViewState);
    addGetter($DataView, 'byteOffset', getInternalDataViewState);
  }

  defineBuiltIns(DataViewPrototype, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : false);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.length !== 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      return new NativeArrayBuffer(toIndex(length));
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }

    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf(DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(21);
var toString = __webpack_require__(5);
var requireObjectCoercible = __webpack_require__(18);

var $RangeError = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n === Infinity) throw new $RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var uncurryThis = __webpack_require__(2);
var isForced = __webpack_require__(84);
var defineBuiltIn = __webpack_require__(16);
var InternalMetadataModule = __webpack_require__(64);
var iterate = __webpack_require__(46);
var anInstance = __webpack_require__(47);
var isCallable = __webpack_require__(10);
var isNullOrUndefined = __webpack_require__(29);
var isObject = __webpack_require__(9);
var fails = __webpack_require__(1);
var checkCorrectnessOfIteration = __webpack_require__(110);
var setToStringTag = __webpack_require__(33);
var inheritIfRequired = __webpack_require__(74);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY === 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY === 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, constructor: true, forced: Constructor !== NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// eslint-disable-next-line es/no-math-expm1 -- safe
var $expm1 = Math.expm1;
var exp = Math.exp;

// `Math.expm1` method implementation
// https://tc39.es/ecma262/#sec-math.expm1
module.exports = (!$expm1
  // Old FF bug
  // eslint-disable-next-line no-loss-of-precision -- required for old engines
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) !== -2e-17
) ? function expm1(x) {
  var n = +x;
  return n === 0 ? n : n > -1e-6 && n < 1e-6 ? n + n * n / 2 : exp(n) - 1;
} : $expm1;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(20);
var global = __webpack_require__(3);
var fails = __webpack_require__(1);
var WEBKIT = __webpack_require__(146);

// Forced replacement object prototype accessors methods
module.exports = IS_PURE || !fails(function () {
  // This feature detection crashes old WebKit
  // https://github.com/zloirock/core-js/issues/232
  if (WEBKIT && WEBKIT < 535) return;
  var key = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call, es/no-legacy-object-prototype-accessor-methods -- required for testing
  __defineSetter__.call(null, key, function () { /* empty */ });
  delete global[key];
});


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var apply = __webpack_require__(40);
var bind = __webpack_require__(41);
var isCallable = __webpack_require__(10);
var hasOwn = __webpack_require__(12);
var fails = __webpack_require__(1);
var html = __webpack_require__(177);
var arraySlice = __webpack_require__(63);
var createElement = __webpack_require__(103);
var validateArgumentsLength = __webpack_require__(42);
var IS_IOS = __webpack_require__(211);
var IS_NODE = __webpack_require__(55);

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NativePromiseConstructor = __webpack_require__(80);
var checkCorrectnessOfIteration = __webpack_require__(110);
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(95).CONSTRUCTOR;

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);
var global = __webpack_require__(3);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__(6);
var uncurryThis = __webpack_require__(2);
var toString = __webpack_require__(5);
var regexpFlags = __webpack_require__(156);
var stickyHelpers = __webpack_require__(122);
var shared = __webpack_require__(70);
var create = __webpack_require__(39);
var getInternalState = __webpack_require__(22).get;
var UNSUPPORTED_DOT_ALL = __webpack_require__(157);
var UNSUPPORTED_NCG = __webpack_require__(217);

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var toIntegerOrInfinity = __webpack_require__(21);
var toString = __webpack_require__(5);
var requireObjectCoercible = __webpack_require__(18);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(158);
var uncurryThis = __webpack_require__(59);
var defineBuiltIn = __webpack_require__(16);
var regexpExec = __webpack_require__(123);
var fails = __webpack_require__(1);
var wellKnownSymbol = __webpack_require__(11);
var createNonEnumerableProperty = __webpack_require__(28);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(124).charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var speciesConstructor = __webpack_require__(77);

var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
module.exports = function (originalArray) {
  return aTypedArrayConstructor(speciesConstructor(originalArray, getTypedArrayConstructor(originalArray)));
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var defineGlobalProperty = __webpack_require__(129);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(1);
var isCallable = __webpack_require__(10);
var hasOwn = __webpack_require__(12);
var DESCRIPTORS = __webpack_require__(4);
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(72).CONFIGURABLE;
var inspectSource = __webpack_require__(131);
var InternalStateModule = __webpack_require__(22);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var isCallable = __webpack_require__(10);
var store = __webpack_require__(128);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(15);
var uncurryThis = __webpack_require__(2);
var getOwnPropertyNamesModule = __webpack_require__(58);
var getOwnPropertySymbolsModule = __webpack_require__(106);
var anObject = __webpack_require__(7);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(11);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(173);
var definePropertyModule = __webpack_require__(17);
var anObject = __webpack_require__(7);
var toIndexedObject = __webpack_require__(23);
var objectKeys = __webpack_require__(85);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__(27);
var toIndexedObject = __webpack_require__(23);
var $getOwnPropertyNames = __webpack_require__(58).f;
var arraySlice = __webpack_require__(86);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);

module.exports = global;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(11);
var Iterators = __webpack_require__(89);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(43);
var lengthOfArrayLike = __webpack_require__(14);

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var call = __webpack_require__(6);
var IS_PURE = __webpack_require__(20);
var FunctionName = __webpack_require__(72);
var isCallable = __webpack_require__(10);
var createIteratorConstructor = __webpack_require__(143);
var getPrototypeOf = __webpack_require__(34);
var setPrototypeOf = __webpack_require__(45);
var setToStringTag = __webpack_require__(33);
var createNonEnumerableProperty = __webpack_require__(28);
var defineBuiltIn = __webpack_require__(16);
var wellKnownSymbol = __webpack_require__(11);
var Iterators = __webpack_require__(89);
var IteratorsCore = __webpack_require__(194);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(194).IteratorPrototype;
var create = __webpack_require__(39);
var createPropertyDescriptor = __webpack_require__(37);
var setToStringTag = __webpack_require__(33);
var Iterators = __webpack_require__(89);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var isArray = __webpack_require__(60);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var arraySlice = __webpack_require__(86);

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(51);

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__(14);

module.exports = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
module.exports = Math.sign || function sign(x) {
  var n = +x;
  // eslint-disable-next-line no-self-compare -- NaN check
  return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isConstructor = __webpack_require__(73);
var tryToString = __webpack_require__(62);

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var uncurryThis = __webpack_require__(2);
var toLength = __webpack_require__(32);
var toString = __webpack_require__(5);
var $repeat = __webpack_require__(114);
var requireObjectCoercible = __webpack_require__(18);

var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = toString(requireObjectCoercible($this));
    var intMaxLength = toLength(maxLength);
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : toString(fillString);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr === '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringSlice(stringFiller, 0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

module.exports = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod(true)
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);
var isObject = __webpack_require__(9);
var classof = __webpack_require__(27);
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(153);

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__(1);

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(9);

var floor = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(7);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);
var global = __webpack_require__(3);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var exec = __webpack_require__(123);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isRegExp = __webpack_require__(96);

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(11);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PROPER_FUNCTION_NAME = __webpack_require__(72).PROPER;
var fails = __webpack_require__(1);
var whitespaces = __webpack_require__(118);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-new -- required for testing */
var global = __webpack_require__(3);
var fails = __webpack_require__(1);
var checkCorrectnessOfIteration = __webpack_require__(110);
var NATIVE_ARRAY_BUFFER_VIEWS = __webpack_require__(8).NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer = global.ArrayBuffer;
var Int8Array = global.Int8Array;

module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(102);

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
module.exports = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw new $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var apply = __webpack_require__(40);
var isCallable = __webpack_require__(10);
var ENGINE_IS_BUN = __webpack_require__(538);
var USER_AGENT = __webpack_require__(51);
var arraySlice = __webpack_require__(63);
var validateArgumentsLength = __webpack_require__(42);

var Function = global.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(USER_AGENT) || ENGINE_IS_BUN && (function () {
  var version = global.Bun.version.split('.');
  return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
})();

// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function (scheduler, hasTimeArg) {
  var firstParamIndex = hasTimeArg ? 2 : 1;
  return WRAP ? function (handler, timeout /* , ...arguments */) {
    var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
    var fn = isCallable(handler) ? handler : Function(handler);
    var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
    var callback = boundArgs ? function () {
      apply(fn, this, params);
    } : fn;
    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
  } : scheduler;
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);
var wellKnownSymbol = __webpack_require__(11);
var DESCRIPTORS = __webpack_require__(4);
var IS_PURE = __webpack_require__(20);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (IS_PURE || !DESCRIPTORS))
    || !params.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (vueInst, googleMapsInst, events) {
  var _loop = function (eventName) {
    if (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName]) {
      googleMapsInst.addListener(eventName, function (ev) {
        vueInst.$emit(eventName, ev);
      });
    }
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WatchPrimitiveProperties;
/**
 * Watch the individual properties of a PoD object, instead of the object
 * per se. This is different from a deep watch where both the reference
 * and the individual values are watched.
 *
 * In effect, it throttles the multiple $watch to execute at most once per tick.
 */
function WatchPrimitiveProperties(vueInst, propertiesToTrack, handler) {
  var immediate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var isHandled = false;

  function requestHandle() {
    if (!isHandled) {
      isHandled = true;
      vueInst.$nextTick(function () {
        isHandled = false;
        handler();
      });
    }
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = propertiesToTrack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var prop = _step.value;

      vueInst.$watch(prop, requestHandle, { immediate: immediate });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
Mixin for objects that are mounted by Google Maps
Javascript API.

These are objects that are sensitive to element resize
operations so it exposes a property which accepts a bus

*/

exports.default = {
  props: ['resizeBus'],

  data: function data() {
    return {
      _actualResizeBus: null
    };
  },
  created: function created() {
    if (typeof this.resizeBus === 'undefined') {
      this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
    } else {
      this.$data._actualResizeBus = this.resizeBus;
    }
  },


  methods: {
    _resizeCallback: function _resizeCallback() {
      this.resize();
    },
    _delayedResizeCallback: function _delayedResizeCallback() {
      var _this = this;

      this.$nextTick(function () {
        return _this._resizeCallback();
      });
    }
  },

  watch: {
    resizeBus: function resizeBus(newVal) {
      // eslint-disable-line no-unused-vars
      this.$data._actualResizeBus = newVal;
    },
    '$data._actualResizeBus': function $data_actualResizeBus(newVal, oldVal) {
      if (oldVal) {
        oldVal.$off('resize', this._delayedResizeCallback);
      }
      if (newVal) {
        newVal.$on('resize', this._delayedResizeCallback);
      }
    }
  },

  destroyed: function destroyed() {
    if (this.$data._actualResizeBus) {
      this.$data._actualResizeBus.$off('resize', this._delayedResizeCallback);
    }
  }
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(69);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6);
var isCallable = __webpack_require__(10);
var isObject = __webpack_require__(9);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var fails = __webpack_require__(1);
var createElement = __webpack_require__(103);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var fails = __webpack_require__(1);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var isCallable = __webpack_require__(10);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var hasOwn = __webpack_require__(12);
var toIndexedObject = __webpack_require__(23);
var indexOf = __webpack_require__(83).indexOf;
var hiddenKeys = __webpack_require__(82);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(15);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(11);

exports.f = wellKnownSymbol;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6);
var getBuiltIn = __webpack_require__(15);
var wellKnownSymbol = __webpack_require__(11);
var defineBuiltIn = __webpack_require__(16);

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_SYMBOL = __webpack_require__(69);

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var getBuiltIn = __webpack_require__(15);
var apply = __webpack_require__(40);
var call = __webpack_require__(6);
var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(1);
var isCallable = __webpack_require__(10);
var isSymbol = __webpack_require__(61);
var arraySlice = __webpack_require__(63);
var getReplacerFunction = __webpack_require__(260);
var NATIVE_SYMBOL = __webpack_require__(69);

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(15);
var hasOwn = __webpack_require__(12);
var createNonEnumerableProperty = __webpack_require__(28);
var isPrototypeOf = __webpack_require__(38);
var setPrototypeOf = __webpack_require__(45);
var copyConstructorProperties = __webpack_require__(105);
var proxyAccessor = __webpack_require__(184);
var inheritIfRequired = __webpack_require__(74);
var normalizeStringArgument = __webpack_require__(88);
var installErrorCause = __webpack_require__(185);
var installErrorStack = __webpack_require__(186);
var DESCRIPTORS = __webpack_require__(4);
var IS_PURE = __webpack_require__(20);

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(10);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__(17).f;

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(9);
var createNonEnumerableProperty = __webpack_require__(28);

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__(28);
var clearErrorStack = __webpack_require__(138);
var ERROR_STACK_INSTALLABLE = __webpack_require__(187);

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

module.exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);
var createPropertyDescriptor = __webpack_require__(37);

module.exports = !fails(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var fails = __webpack_require__(1);
var anObject = __webpack_require__(7);
var normalizeStringArgument = __webpack_require__(88);

var nativeErrorToString = Error.prototype.toString;

var INCORRECT_TO_STRING = fails(function () {
  if (DESCRIPTORS) {
    // Chrome 32- incorrectly call accessor
    // eslint-disable-next-line es/no-object-create, es/no-object-defineproperty -- safe
    var object = Object.create(Object.defineProperty({}, 'name', { get: function () {
      return this === object;
    } }));
    if (nativeErrorToString.call(object) !== 'true') return true;
  }
  // FF10- does not properly handle non-strings
  return nativeErrorToString.call({ message: 1, name: 2 }) !== '2: 1'
    // IE8 does not properly handle defaults
    || nativeErrorToString.call({}) !== 'Error';
});

module.exports = INCORRECT_TO_STRING ? function toString() {
  var O = anObject(this);
  var name = normalizeStringArgument(O.name, 'Error');
  var message = normalizeStringArgument(O.message);
  return !name ? message : !message ? name : name + ': ' + message;
} : nativeErrorToString;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6);
var anObject = __webpack_require__(7);
var getMethod = __webpack_require__(52);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(43);
var lengthOfArrayLike = __webpack_require__(14);
var deletePropertyOrThrow = __webpack_require__(108);

var min = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = lengthOfArrayLike(O);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else deletePropertyOrThrow(O, to);
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(60);
var lengthOfArrayLike = __webpack_require__(14);
var doesNotExceedSafeInteger = __webpack_require__(75);
var bind = __webpack_require__(41);

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        elementLen = lengthOfArrayLike(element);
        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(25).forEach;
var arrayMethodIsStrict = __webpack_require__(54);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(41);
var call = __webpack_require__(6);
var toObject = __webpack_require__(13);
var callWithSafeIterationClosing = __webpack_require__(296);
var isArrayIteratorMethod = __webpack_require__(140);
var isConstructor = __webpack_require__(73);
var lengthOfArrayLike = __webpack_require__(14);
var createProperty = __webpack_require__(53);
var getIterator = __webpack_require__(107);
var getIteratorMethod = __webpack_require__(90);

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);
var isCallable = __webpack_require__(10);
var isObject = __webpack_require__(9);
var create = __webpack_require__(39);
var getPrototypeOf = __webpack_require__(34);
var defineBuiltIn = __webpack_require__(16);
var wellKnownSymbol = __webpack_require__(11);
var IS_PURE = __webpack_require__(20);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var apply = __webpack_require__(40);
var toIndexedObject = __webpack_require__(23);
var toIntegerOrInfinity = __webpack_require__(21);
var lengthOfArrayLike = __webpack_require__(14);
var arrayMethodIsStrict = __webpack_require__(54);

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(51);

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UA = __webpack_require__(51);

module.exports = /MSIE|Trident/.test(UA);


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__(14);

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed
module.exports = function (O, C) {
  var len = lengthOfArrayLike(O);
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = O[len - k - 1];
  return A;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__(14);
var toIntegerOrInfinity = __webpack_require__(21);

var $RangeError = RangeError;

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
module.exports = function (O, C, index, value) {
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
  if (actualIndex >= len || actualIndex < 0) throw new $RangeError('Incorrect index');
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = k === actualIndex ? value : O[k];
  return A;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(21);
var toLength = __webpack_require__(32);

var $RangeError = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw new $RangeError('Wrong length or index');
  return length;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var floatRound = __webpack_require__(322);

var FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;

// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
module.exports = Math.fround || function fround(x) {
  return floatRound(x, FLOAT32_EPSILON, FLOAT32_MAX_VALUE, FLOAT32_MIN_VALUE);
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var aCallable = __webpack_require__(19);
var isObject = __webpack_require__(9);
var hasOwn = __webpack_require__(12);
var arraySlice = __webpack_require__(63);
var NATIVE_BIND = __webpack_require__(81);

var $Function = Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    var list = [];
    var i = 0;
    for (; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(39);
var defineBuiltInAccessor = __webpack_require__(24);
var defineBuiltIns = __webpack_require__(93);
var bind = __webpack_require__(41);
var anInstance = __webpack_require__(47);
var isNullOrUndefined = __webpack_require__(29);
var iterate = __webpack_require__(46);
var defineIterator = __webpack_require__(142);
var createIterResultObject = __webpack_require__(92);
var setSpecies = __webpack_require__(76);
var DESCRIPTORS = __webpack_require__(4);
var fastKey = __webpack_require__(64).fastKey;
var InternalStateModule = __webpack_require__(22);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key === key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first === entry) state.first = next;
          if (state.last === entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return createIterResultObject(undefined, true);
      }
      // return step by kind
      if (kind === 'keys') return createIterResultObject(entry.key, false);
      if (kind === 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var log = Math.log;

// `Math.log1p` method implementation
// https://tc39.es/ecma262/#sec-math.log1p
// eslint-disable-next-line es/no-math-log1p -- safe
module.exports = Math.log1p || function log1p(x) {
  var n = +x;
  return n > -1e-8 && n < 1e-8 ? n - n * n / 2 : log(1 + n);
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var log = Math.log;
var LOG10E = Math.LOG10E;

// eslint-disable-next-line es/no-math-log10 -- safe
module.exports = Math.log10 || function log10(x) {
  return log(x) * LOG10E;
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var fails = __webpack_require__(1);
var uncurryThis = __webpack_require__(2);
var toString = __webpack_require__(5);
var trim = __webpack_require__(79).trim;
var whitespaces = __webpack_require__(118);

var charAt = uncurryThis(''.charAt);
var $parseFloat = global.parseFloat;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseFloat(Object(ITERATOR)); }));

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
module.exports = FORCED ? function parseFloat(string) {
  var trimmedString = trim(toString(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && charAt(trimmedString, 0) === '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var fails = __webpack_require__(1);
var uncurryThis = __webpack_require__(2);
var toString = __webpack_require__(5);
var trim = __webpack_require__(79).trim;
var whitespaces = __webpack_require__(118);

var $parseInt = global.parseInt;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var uncurryThis = __webpack_require__(2);
var call = __webpack_require__(6);
var fails = __webpack_require__(1);
var objectKeys = __webpack_require__(85);
var getOwnPropertySymbolsModule = __webpack_require__(106);
var propertyIsEnumerableModule = __webpack_require__(101);
var toObject = __webpack_require__(13);
var IndexedObject = __webpack_require__(68);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var fails = __webpack_require__(1);
var uncurryThis = __webpack_require__(2);
var objectGetPrototypeOf = __webpack_require__(34);
var objectKeys = __webpack_require__(85);
var toIndexedObject = __webpack_require__(23);
var $propertyIsEnumerable = __webpack_require__(101).f;

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var IE_BUG = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-create -- safe
  var O = Object.create(null);
  O[2] = 2;
  return !propertyIsEnumerable(O, 2);
});

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(51);

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var bind = __webpack_require__(41);
var getOwnPropertyDescriptor = __webpack_require__(26).f;
var macrotask = __webpack_require__(120).set;
var Queue = __webpack_require__(213);
var IS_IOS = __webpack_require__(211);
var IS_IOS_PEBBLE = __webpack_require__(410);
var IS_WEBOS_WEBKIT = __webpack_require__(411);
var IS_NODE = __webpack_require__(55);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var microtask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_DENO = __webpack_require__(155);
var IS_NODE = __webpack_require__(55);

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(7);
var isObject = __webpack_require__(9);
var newPromiseCapability = __webpack_require__(65);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(12);

module.exports = function (descriptor) {
  return descriptor !== undefined && (hasOwn(descriptor, 'value') || hasOwn(descriptor, 'writable'));
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(1);
var global = __webpack_require__(3);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(124).charAt;
var toString = __webpack_require__(5);
var InternalStateModule = __webpack_require__(22);
var defineIterator = __webpack_require__(142);
var createIterResultObject = __webpack_require__(92);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zloirock/core-js/issues/280
var userAgent = __webpack_require__(51);

module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var toObject = __webpack_require__(13);

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $trimEnd = __webpack_require__(79).end;
var forcedStringTrimMethod = __webpack_require__(161);

// `String.prototype.{ trimEnd, trimRight }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright
module.exports = forcedStringTrimMethod('trimEnd') ? function trimEnd() {
  return $trimEnd(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimEnd;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $trimStart = __webpack_require__(79).start;
var forcedStringTrimMethod = __webpack_require__(161);

// `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
module.exports = forcedStringTrimMethod('trimStart') ? function trimStart() {
  return $trimStart(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPositiveInteger = __webpack_require__(481);

var $RangeError = RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw new $RangeError('Wrong offset');
  return offset;
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(41);
var call = __webpack_require__(6);
var aConstructor = __webpack_require__(150);
var toObject = __webpack_require__(13);
var lengthOfArrayLike = __webpack_require__(14);
var getIterator = __webpack_require__(107);
var getIteratorMethod = __webpack_require__(90);
var isArrayIteratorMethod = __webpack_require__(140);
var isBigIntArray = __webpack_require__(225);
var aTypedArrayConstructor = __webpack_require__(8).aTypedArrayConstructor;
var toBigInt = __webpack_require__(163);

module.exports = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = call(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike(O);
  result = new (aTypedArrayConstructor(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    // FF30- typed arrays doesn't properly convert objects to typed array values
    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
  }
  return result;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(44);

module.exports = function (it) {
  var klass = classof(it);
  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var defineBuiltIns = __webpack_require__(93);
var getWeakData = __webpack_require__(64).getWeakData;
var anInstance = __webpack_require__(47);
var anObject = __webpack_require__(7);
var isNullOrUndefined = __webpack_require__(29);
var isObject = __webpack_require__(9);
var iterate = __webpack_require__(46);
var ArrayIterationModule = __webpack_require__(25);
var hasOwn = __webpack_require__(12);
var InternalStateModule = __webpack_require__(22);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis([].splice);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (state) {
  return state.frozen || (state.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice(this.entries, index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    defineBuiltIns(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwn(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwn(data, state.id);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return Constructor;
  }
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var itoc = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
var ctoi = {};

for (var index = 0; index < 66; index++) ctoi[itoc.charAt(index)] = index;

module.exports = {
  itoc: itoc,
  ctoi: ctoi
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(103);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_NODE = __webpack_require__(55);

module.exports = function (name) {
  try {
    // eslint-disable-next-line no-new-func -- safe
    if (IS_NODE) return Function('return require("' + name + '")')();
  } catch (error) { /* empty */ }
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {
  IndexSizeError: { s: 'INDEX_SIZE_ERR', c: 1, m: 1 },
  DOMStringSizeError: { s: 'DOMSTRING_SIZE_ERR', c: 2, m: 0 },
  HierarchyRequestError: { s: 'HIERARCHY_REQUEST_ERR', c: 3, m: 1 },
  WrongDocumentError: { s: 'WRONG_DOCUMENT_ERR', c: 4, m: 1 },
  InvalidCharacterError: { s: 'INVALID_CHARACTER_ERR', c: 5, m: 1 },
  NoDataAllowedError: { s: 'NO_DATA_ALLOWED_ERR', c: 6, m: 0 },
  NoModificationAllowedError: { s: 'NO_MODIFICATION_ALLOWED_ERR', c: 7, m: 1 },
  NotFoundError: { s: 'NOT_FOUND_ERR', c: 8, m: 1 },
  NotSupportedError: { s: 'NOT_SUPPORTED_ERR', c: 9, m: 1 },
  InUseAttributeError: { s: 'INUSE_ATTRIBUTE_ERR', c: 10, m: 1 },
  InvalidStateError: { s: 'INVALID_STATE_ERR', c: 11, m: 1 },
  SyntaxError: { s: 'SYNTAX_ERR', c: 12, m: 1 },
  InvalidModificationError: { s: 'INVALID_MODIFICATION_ERR', c: 13, m: 1 },
  NamespaceError: { s: 'NAMESPACE_ERR', c: 14, m: 1 },
  InvalidAccessError: { s: 'INVALID_ACCESS_ERR', c: 15, m: 1 },
  ValidationError: { s: 'VALIDATION_ERR', c: 16, m: 0 },
  TypeMismatchError: { s: 'TYPE_MISMATCH_ERR', c: 17, m: 1 },
  SecurityError: { s: 'SECURITY_ERR', c: 18, m: 1 },
  NetworkError: { s: 'NETWORK_ERR', c: 19, m: 1 },
  AbortError: { s: 'ABORT_ERR', c: 20, m: 1 },
  URLMismatchError: { s: 'URL_MISMATCH_ERR', c: 21, m: 1 },
  QuotaExceededError: { s: 'QUOTA_EXCEEDED_ERR', c: 22, m: 1 },
  TimeoutError: { s: 'TIMEOUT_ERR', c: 23, m: 1 },
  InvalidNodeTypeError: { s: 'INVALID_NODE_TYPE_ERR', c: 24, m: 1 },
  DataCloneError: { s: 'DATA_CLONE_ERR', c: 25, m: 1 }
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

// eslint-disable-next-line es/no-set -- safe
var SetPrototype = Set.prototype;

module.exports = {
  // eslint-disable-next-line es/no-set -- safe
  Set: Set,
  add: uncurryThis(SetPrototype.add),
  has: uncurryThis(SetPrototype.has),
  remove: uncurryThis(SetPrototype['delete']),
  proto: SetPrototype
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var fails = __webpack_require__(1);
var V8 = __webpack_require__(50);
var IS_BROWSER = __webpack_require__(214);
var IS_DENO = __webpack_require__(155);
var IS_NODE = __webpack_require__(55);

var structuredClone = global.structuredClone;

module.exports = !!structuredClone && !fails(function () {
  // prevent V8 ArrayBufferDetaching protector cell invalidation and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if ((IS_DENO && V8 > 92) || (IS_NODE && V8 > 94) || (IS_BROWSER && V8 > 97)) return false;
  var buffer = new ArrayBuffer(8);
  var clone = structuredClone(buffer, { transfer: [buffer] });
  return buffer.byteLength !== 0 || clone.byteLength !== 8;
});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(111);
var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var call = __webpack_require__(6);
var uncurryThis = __webpack_require__(2);
var DESCRIPTORS = __webpack_require__(4);
var USE_NATIVE_URL = __webpack_require__(165);
var defineBuiltIn = __webpack_require__(16);
var defineBuiltInAccessor = __webpack_require__(24);
var defineBuiltIns = __webpack_require__(93);
var setToStringTag = __webpack_require__(33);
var createIteratorConstructor = __webpack_require__(143);
var InternalStateModule = __webpack_require__(22);
var anInstance = __webpack_require__(47);
var isCallable = __webpack_require__(10);
var hasOwn = __webpack_require__(12);
var bind = __webpack_require__(41);
var classof = __webpack_require__(44);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(9);
var $toString = __webpack_require__(5);
var create = __webpack_require__(39);
var createPropertyDescriptor = __webpack_require__(37);
var getIterator = __webpack_require__(107);
var getIteratorMethod = __webpack_require__(90);
var createIterResultObject = __webpack_require__(92);
var validateArgumentsLength = __webpack_require__(42);
var wellKnownSymbol = __webpack_require__(11);
var arraySort = __webpack_require__(145);

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS) return global[name];
  var descriptor = getOwnPropertyDescriptor(global, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp = global.RegExp;
var TypeError = global.TypeError;
var decodeURIComponent = global.decodeURIComponent;
var encodeURIComponent = global.encodeURIComponent;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind: kind
  });
}, URL_SEARCH_PARAMS, function next() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  var entry = target[index];
  switch (state.kind) {
    case 'keys': return createIterResultObject(entry.key, false);
    case 'values': return createIterResultObject(entry.value, false);
  } return createIterResultObject([entry.key, entry.value], false);
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var entries = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw new TypeError('Expected sequence with length 2');
        push(entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var entries = this.entries;
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS) this.size = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 2);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    if (!DESCRIPTORS) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength(arguments.length, 1);
    var key = $toString(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    if (!DESCRIPTORS) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DropdownFilter_vue__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Gmaps_vue__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__database__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__databaseTaxonomy__ = __webpack_require__(572);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'WiV',
    components: { DropdownFilter: __WEBPACK_IMPORTED_MODULE_0__components_DropdownFilter_vue__["a" /* default */], Gmaps: __WEBPACK_IMPORTED_MODULE_1__components_Gmaps_vue__["a" /* default */] },
    props: [],
    data: function data() {
        return {
            wpData: wpData || {},

            selectedItems: [],

            searchTerm: '',

            taxonomy1: __WEBPACK_IMPORTED_MODULE_3__databaseTaxonomy__["d" /* jobType */],
            taxonomy2: __WEBPACK_IMPORTED_MODULE_3__databaseTaxonomy__["b" /* community */],
            taxonomy3: __WEBPACK_IMPORTED_MODULE_3__databaseTaxonomy__["e" /* practiceType */],
            taxonomy4: __WEBPACK_IMPORTED_MODULE_3__databaseTaxonomy__["c" /* fullPartTime */],
            taxonomy5: __WEBPACK_IMPORTED_MODULE_3__databaseTaxonomy__["a" /* clinicType */],

            databaseJobs: __WEBPACK_IMPORTED_MODULE_2__database__["a" /* default */],
            jobs: [],

            mapMarkers: [{ lat: 49.27975, lng: -123.118506 }, { lat: 49.28000, lng: -123.119000 }],

            isSmallScreen: false,

            currentView: 'list',
            showLeftSection: true
        };
    },

    methods: {
        handleResize: function handleResize() {
            this.isSmallScreen = window.innerWidth < 768;
        },
        handleItemsToggle: function handleItemsToggle(selected) {

            if (this.selectedItems.includes(selected.id)) {
                this.selectedItems = this.selectedItems.filter(function (id) {
                    return id !== selected.id;
                });
            } else {
                this.selectedItems.push(selected.id);
            }

            if (this.selectedItems.length < 1) {
                this.performUnifiedSearch();
                return;
            }

            this.performUnifiedSearch();
        },
        handleOutsideClick: function handleOutsideClick(event) {
            if (!event.target.closest('.dropdown-filter')) {
                this.closeAllDropdowns();
            }
        },
        closeAllDropdowns: function closeAllDropdowns() {
            this.$children.forEach(function (child) {
                if (child.$options.name === 'DropdownFilter') {
                    child.closeDropdown();
                }
            });
        },
        populateGoogleMaps: function populateGoogleMaps(jobs) {
            var _this = this;

            this.mapMarkers = [];
            jobs.forEach(function (item) {
                if (item.acf) {
                    var lat = parseFloat(item.acf["job_listing-clinic_lattitude"]);
                    var lng = parseFloat(item.acf["job_listing-clinic_longitude"]);
                    var info = item.title.rendered.replace(/&#8211;/g, '-');
                    var link = item.link;

                    if (!isNaN(lat) && !isNaN(lng)) {
                        _this.mapMarkers.push({ lat: lat, lng: lng, info: info, link: link });
                    }
                }
            });
        },
        performUnifiedSearch: function performUnifiedSearch() {
            var results = this.databaseJobs;

            if (this.searchTerm) {
                results = this.handleSearchBar(results);
            }

            if (this.selectedItems.length > 0) {
                results = this.filterPostsBySelectedOptions(results);
            }

            this.jobs = results;
            this.populateGoogleMaps(this.jobs);
        },
        handleSearchBar: function handleSearchBar(posts) {
            var term = this.searchTerm.toLowerCase();
            return posts.filter(function (job) {
                var title = job.title.rendered.toLowerCase();
                if (title.includes(term)) return true;

                for (var key in job.acf) {
                    var value = job.acf[key];
                    if (Array.isArray(value)) {
                        value = value.join(' ');
                    }

                    if (typeof value !== 'string') continue;
                    if (value.toLowerCase().includes(term)) return true;
                }
                return false;
            });
        },
        filterPostsBySelectedOptions: function filterPostsBySelectedOptions(posts) {
            var _this2 = this;

            var filteredItems = [];

            var joblisting_job_typeIds = [13, 15, 323, 17, 324]; //position types
            var joblisting_practice_typeIds = [100, 98, 99];
            var joblisting_clinic_typeIds = [19, 20, 21, 22, 322, 342, 23, 24]; //practice settings
            var joblisting_communityIds = [315, 319, 321, 92, 85, 87, 90, 81, 88, 317, 89, 86, 83, 316, 91, 318, 84, 82, 93, 320];
            var joblisting_ft_ptIds = [32, 31];

            var categoryIds = {
                joblisting_practice_type: joblisting_practice_typeIds,
                joblisting_job_type: joblisting_job_typeIds,
                joblisting_clinic_type: joblisting_clinic_typeIds,
                joblisting_community: joblisting_communityIds,
                joblisting_ft_pt: joblisting_ft_ptIds
            };

            function hasIntersection(arr1, arr2) {
                return arr1.some(function (item) {
                    return arr2.includes(item);
                });
            }

            function isSelectedInCategory(category, selectedItems) {
                return category.some(function (id) {
                    return selectedItems.includes(id);
                });
            }

            // Determine the categories of the selected items
            var selectedCategories = {};

            var _loop = function _loop(category) {
                if (isSelectedInCategory(categoryIds[category], _this2.selectedItems)) {
                    selectedCategories[category] = _this2.selectedItems.filter(function (id) {
                        return categoryIds[category].includes(id);
                    });
                }
            };

            for (var category in categoryIds) {
                _loop(category);
            }

            // Filter posts
            posts.forEach(function (post) {
                var matchesAllSelectedCategories = true;

                for (var category in selectedCategories) {
                    if (!hasIntersection(post[category], selectedCategories[category])) {
                        matchesAllSelectedCategories = false;
                        break;
                    }
                }

                if (matchesAllSelectedCategories) {
                    filteredItems.push(post);
                    // console.log(`Post ID ${post.id} matched in all selected categories.`);
                }
            });

            return filteredItems;
        },
        fetchJobsFromWP: function fetchJobsFromWP() {
            var _this3 = this;

            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var allJobs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            fetch(this.wpData.rest_url + 'wp/v2/job_listing?per_page=100&page=' + page).then(function (response) {
                var totalPages = parseInt(response.headers.get('X-WP-TotalPages'), 10);

                return response.json().then(function (data) {
                    var combinedData = [].concat(_toConsumableArray(allJobs), _toConsumableArray(data)); //database

                    if (page < totalPages) {
                        _this3.fetchJobsFromWP(page + 1, combinedData);
                    } else {
                        var lessMarkersOnLoad = combinedData.slice(0, 100);
                        // console.log(lessMarkersOnLoad)
                        _this3.populateGoogleMaps(lessMarkersOnLoad);
                        _this3.jobs = lessMarkersOnLoad;
                        _this3.databaseJobs = combinedData;
                    }
                });
            }).catch(function (error) {
                console.error(error);
            });
        }
    },

    mounted: function mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);

        this.fetchJobsFromWP();
        document.addEventListener('click', this.handleOutsideClick);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('click', this.handleOutsideClick);
    },


    computed: {
        jobTypeNames: function jobTypeNames() {
            return this.taxonomy1.map(function (item) {
                return { name: item.name, id: item.id };
            });
        },
        communityNames: function communityNames() {
            return this.taxonomy2.map(function (item) {
                return { name: item.name, id: item.id };
            });
        },
        practiceTypeNames: function practiceTypeNames() {
            return this.taxonomy3.map(function (item) {
                return { name: item.name, id: item.id };
            });
        },
        fullPartTimeNames: function fullPartTimeNames() {
            return this.taxonomy4.map(function (item) {
                return { name: item.name, id: item.id };
            });
        },
        clinicTypeNames: function clinicTypeNames() {
            return this.taxonomy5.map(function (item) {
                return { name: item.name, id: item.id };
            });
        }
    }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DropdownFilter',
    props: {
        title: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            isOpen: false,
            selectedItems: [],
            isReset: 0
        };
    },

    methods: {
        toggleDropdown: function toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        handleToggleBox: function handleToggleBox(item) {
            //    item.checked = !item.checked; // Toggle the checked state

            var itemIndex = this.selectedItems.findIndex(function (selectedItem) {
                return selectedItem.id === item.id;
            });
            if (itemIndex !== -1) {
                this.selectedItems.splice(itemIndex, 1);
            } else {
                this.selectedItems.push(item);
            }

            console.log(this.selectedItems);
            this.$emit('item-toggled', item);
        },
        closeDropdown: function closeDropdown() {
            this.isOpen = false;
        }
    },
    mounted: function mounted() {
        if (this.isReset == 0) {
            this.items.forEach(function (item) {
                return item.checked = false;
            });
        }
        this.isReset = 1;
    }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Gmaps',
    props: {
        markers: {
            type: Array,
            required: true,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {
            currentMarker: null,
            markerIcon: "https://victoriadivision.ca/wp-content/uploads/2024/07/map-pin-gm.png",
            mapStyle: {
                mapTypeControl: false,
                styles: [{ "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "color": "#444444" }] }, { "featureType": "landscape", "elementType": "all", "stylers": [{ "color": "#f2f2f2" }] }, { "featureType": "poi", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 45 }] }, { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#b5b5b5" }, { "visibility": "on" }, { "weight": "2.00" }] }, { "featureType": "road.highway", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "road.arterial", "elementType": "all", "stylers": [{ "visibility": "on" }, { "color": "#b5b5b5" }] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "color": "#cae9f2" }, { "visibility": "on" }] }]
            }

        };
    },

    computed: {
        mapCenter: function mapCenter() {
            if (this.markers.length) {
                //48.429455, -123.365445
                return {
                    lat: 48.429455,
                    lng: -123.365445
                };
            }
            return { lat: 48.429455, lng: -123.365445 };
        }
    },
    methods: {
        openInfoWindow: function openInfoWindow(marker) {
            this.currentMarker = marker;
        }
    }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__databaseResources__ = __webpack_require__(577);
var _methods;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            firstLoadDone: false,

            visibleResults: [],
            filteredResults: [],

            allPosts: [],
            imageUrls: {},
            defaultIconSrc: 'https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-25.png',
            imageReference: {
                "2509": "https://victoriadivision.ca/wp-content/uploads/2024/01/homepage-Support-for-you-2.png",
                "2528": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-15.png",
                "1571": "https://victoriadivision.ca/wp-content/uploads/2023/12/1-Campaign.png",
                "2537": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-24.png",
                "2538": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-25.png",
                "2534": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-21.png",
                "2532": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-19.png",
                "1576": "https://victoriadivision.ca/wp-content/uploads/2023/12/7-Tools.png",
                "1573": "https://victoriadivision.ca/wp-content/uploads/2023/12/3-Guide.png",
                "2515": "https://victoriadivision.ca/wp-content/uploads/2024/01/News-hub-story-to-tell.png",
                "1574": "https://victoriadivision.ca/wp-content/uploads/2023/12/4-Guide.png",

                "2536": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-23.png",
                "2526": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-13.png"

            },

            fullDatabase: [],

            selectedFiltersActive: [0, 0, 0, 0],

            currentPage: 1,
            itemsPerPage: 9,

            showLoadMoreButton: true,

            searchQuery: '',
            filtersOld: [{
                title: 'Career Stage',
                show: false,
                selectedFiltersActive: '',
                options: [{ "name": "Grow Your Practice", "ids": [162] }, { "name": "Practice Management", "ids": [70] }, { "name": "Retirement", "ids": [72] }]
            }, {
                title: 'Programs & Committees',
                show: false,
                selectedFiltersActive: '',
                options: [{ "name": "AGM", "ids": [166, 167, 179] }, { "name": "Clinic Grants", "ids": [187, 186, 185] }, { "name": "Interprofessional Teams", "ids": [205, 153, 152] }, { "name": "Mental Health", "ids": [198, 119, 117] }, { "name": "Community Practice", "ids": [196] }, { "name": "Continuity of Care", "ids": [199] }, { "name": "FP Service Contracts", "ids": [155, 154] }, { "name": "Long Term Care", "ids": [180] }, { "name": "MOA Program", "ids": [190] }, { "name": "NP Service Contracts", "ids": [149, 150] }]
            }, {
                title: 'Content Type',
                show: false,
                selectedFiltersActive: '',
                options: [{ "name": "Announcements", "ids": [126] }, { "name": "Business Tools", "ids": [163] }, { "name": "Contract Template", "ids": [151] }, { "name": "For Patients", "ids": [73] }, { "name": "Form Letters", "ids": [127] }, { "name": "Guidelines", "ids": [124] }, { "name": "How-To", "ids": [128] }, { "name": "Reports & Data", "ids": [125] }]
            }, {
                title: 'Tags',
                show: false,
                selectedFiltersActive: '',
                options: [{ "name": "JEDI", "ids": [173, 195] }, { "name": "Physician Wellness", "ids": [172, 129, 165] }, { "name": "Primary Care Crisis", "ids": [156, 170, 184] }, { "name": "CBT", "ids": [118, 79] }, { "name": "COVID-19", "ids": [74] }, { "name": "EASI Maternity Care", "ids": [148, 91] }, { "name": "Flu Vaccine", "ids": [169, 168] }, { "name": "Funding", "ids": [175] }, { "name": "Monkeypox", "ids": [174] }]
            }],

            filtersDEV: [{
                title: 'Career Stage',
                show: false,
                selectedFiltersActive: '',
                options: [{ "name": "New Doctors", "ids": [218] }, { "name": "Retiring Doctors", "ids": [220] }, { "name": "Running your Practice", "ids": [219] }]
            }, {
                title: 'Programs & Committees',
                show: false,
                selectedFiltersActive: '',
                options: [{ "name": "Clinic Business Solutions", "ids": [223] }, { "name": "Clinical Resources & Guidelines", "ids": [229] }, { "name": "Continuity of Care", "ids": [228] }, { "name": "Long Term Care", "ids": [225] }, { "name": "Maternity Care", "ids": [230] }, { "name": "Mental Health & Substance Use", "ids": [221] }, { "name": "Patient Care", "ids": [224] }, { "name": "Patient Resources", "ids": [227] }, { "name": "Recruitment & Retention", "ids": [222] }, { "name": "Vancouver Division Membership", "ids": [226] }]
            }, {
                title: 'Content Type',
                show: false,
                selectedFiltersActive: '',
                options: [{ "name": "Event", "ids": [236] }, { "name": "Guide", "ids": [233] }, { "name": "Initiative", "ids": [231] }, { "name": "News", "ids": [234] }, { "name": "Report", "ids": [235] }, { "name": "Tool", "ids": [232] }]
            }, {
                title: 'Tags',
                show: false,
                selectedFiltersActive: '',
                options: [{ "name": "AGM", "ids": [249] }, { "name": "CBT", "ids": [250] }, { "name": "Children & Youth", "ids": [251] }, { "name": "COVID-19", "ids": [252] }, { "name": "Fast Facts", "ids": [253] }, { "name": "Flu Vaccine", "ids": [254] }, { "name": "Funding & Grants", "ids": [255] }, { "name": "IPT", "ids": [256] }, { "name": "JEDI", "ids": [257] }, { "name": "Legal Support", "ids": [258] }, { "name": "Physician Wellness", "ids": [259] }, { "name": "Primary Care Crisis", "ids": [260] }]
            }],

            ImgIDsObj: {},

            filters: [{
                title: 'Career Stage',
                show: false,
                selectedFiltersActive: '',
                options: [{ name: "Late career/Retiring", ids: [41] }, { name: "New to Practice", ids: [42] }, { name: "Mid career/Practicing", ids: [38] }, { name: "Students & Residents", ids: [325] }]
            }, {
                title: 'Topic Areas',
                show: false,
                selectedFiltersActive: '',
                options: [{ name: "Care Transitions", ids: [115] }, //
                { name: "Clinic/Business Resources", ids: [44] }, //
                { name: "Membership", ids: [114] }, //
                { name: "Patient Resources", ids: [52] }, //
                { name: "Primary Care Network", ids: [113] }, //
                { name: "Recruitment & Retention", ids: [53] }, //
                { name: "Long-term Care Initiative", ids: [327] }, //
                { name: "Patient Medical Home Development", ids: [326] }]
            }, {
                title: 'Content Type',
                show: false,
                selectedFiltersActive: '',
                options: [{ name: "Events & Webinars", ids: [336] }, { name: "Guide", ids: [55] }, { name: "News", ids: [328] }, { name: "Initiative", ids: [56] }, { name: "Report", ids: [58] }, { name: "Tool", ids: [59] }]
            }, {
                title: 'Tags',
                show: false,
                selectedFiltersActive: '',
                options: [{ name: "Care of the Elderly", ids: [117] }, //
                { name: "Collaborative Services Committee", ids: [124] }, //
                { name: "Cultural Safety & Indigenous Health", ids: [119] }, //
                { name: "Long Term Care", ids: [120] }, //
                { name: "Member Updates", ids: [123] }, //
                { name: "Member Wellness", ids: [121] }, //
                { name: "Membership Information", ids: [122] }, //
                { name: "Mental Health & Substance Use", ids: [118] }, //
                { name: "Tools for Physicians & Clinics", ids: [125] }, //
                { name: "Urban Locum Program", ids: [116] }, //
                { name: "Events", ids: [330] }, //
                { name: "MOAs", ids: [329] }]
            }]
        };
    },

    //https://van-division.yarko.dev/resources/
    //https://van-division.yarko.dev/wp-admin/edit-tags.php?taxonomy=career_stage&post_type=event
    //https://van-division.yarko.dev/wp-admin/edit-tags.php?taxonomy=programs_committees&post_type=event
    //https://van-division.yarko.dev/wp-admin/edit-tags.php?taxonomy=content_type&post_type=event
    //https://van-division.yarko.dev/wp-admin/edit-tags.php?taxonomy=tags&post_type=event
    methods: (_methods = {
        toggleDropdown: function toggleDropdown(index) {
            this.filters.forEach(function (filter, i) {
                if (i !== index) filter.show = false;
            });
            this.filters[index].show = !this.filters[index].show;
        },
        applySearch: function applySearch() {
            this.currentPage = 1;
            this.applyCompositeFilter();
        },
        goToPreviousPage: function goToPreviousPage() {
            if (this.currentPage > 1) {
                this.currentPage -= 1;
                this.logPageAndScroll();
            }
        },
        goToNextPage: function goToNextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage += 1;
                this.logPageAndScroll();
            }
        },
        logPageAndScroll: function logPageAndScroll() {
            var filtersContainer = this.$el.querySelector('.filter-container');
            if (filtersContainer) {
                filtersContainer.scrollIntoView({ behavior: 'smooth' });
            }
        },
        loadMoreResults: function loadMoreResults() {
            // console.log('laod more')
            //  console.log(this.filteredResults)
            var totalVisible = this.visibleResults.length;
            var nextItems = this.filteredResults.slice(totalVisible, totalVisible + this.itemsPerPage);
            this.visibleResults = [].concat(_toConsumableArray(this.visibleResults), _toConsumableArray(nextItems));
            //  console.log('visible', this.visibleResults.length)
            //  console.log("total", this.filteredPosts)
        },
        applyCompositeFilter: function applyCompositeFilter() {
            var _this = this;

            // console.log(this.filters)
            var selectedFilters = this.filters.map(function (filter) {
                return {
                    title: filter.title,
                    selected: filter.options.filter(function (option) {
                        return option.checked;
                    }).map(function (option) {
                        return { name: option.name, ids: option.ids };
                    })
                };
            });
            //  console.log(selectedFilters);

            var dropdownActiveFilters = [];

            var filteredPosts = [];

            selectedFilters.forEach(function (item, index) {
                //   console.log(item.selected.length);
                _this.selectedFiltersActive[index] = item.selected.length;
                if (item.selected.length > 0) {
                    dropdownActiveFilters.push(item.title);
                }
            });

            if (dropdownActiveFilters.length == 0 && !this.searchQuery) {
                console.log('blank_');return this.visibleResults = this.fullDatabase;
            }

            this.fullDatabase.forEach(function (post) {
                _this.filters.forEach(function (filter) {
                    if (dropdownActiveFilters.includes(filter.title)) {
                        //   console.log(filter.title);
                        filter.options.forEach(function (opt) {
                            if (opt.checked) {

                                var isContentType = false;
                                var isPograms = false;
                                var isCareersStage = false;
                                var isTags = false;

                                if (post && post.content_type) {
                                    isContentType = opt.ids.some(function (id) {
                                        return post.content_type.includes(id);
                                    });
                                }
                                if (post && post.programs_committees) {
                                    isPograms = opt.ids.some(function (id) {
                                        return post.programs_committees.includes(id);
                                    });
                                }
                                if (post && post.career_stage) {
                                    isCareersStage = opt.ids.some(function (id) {
                                        return post.career_stage.includes(id);
                                    });
                                }
                                if (post && post.tx_tags) {
                                    isTags = opt.ids.some(function (id) {
                                        return post.tx_tags.includes(id);
                                    });
                                }

                                //     isRelatedCampaign = opt.ids.some(id => post.acf.related_campaigns.includes(id));
                                //     isRelatedEvent = opt.ids.some(id => post.acf.related_events.includes(id));
                                //     isRelatedResource = opt.ids.some(id => post.acf.related_resources.includes(id));

                                if (isContentType || isPograms || isCareersStage || isTags) {

                                    if (!filteredPosts.some(function (filteredPost) {
                                        return filteredPost === post;
                                    })) {
                                        filteredPosts.push(post);
                                    }
                                }
                            }
                        });
                    }
                });
            });

            //////////////////////////////////////////////////////////////////////////////////////////////
            if (dropdownActiveFilters.length > 1) {

                var newFilteredPosts = [];

                //     console.log('multiple triggered', selectedFilters)

                var relevantFilters = selectedFilters.filter(function (item) {
                    return item.selected.length > 0;
                });

                //  console.log(filteredPosts)
                //            console.log(relevantFilters)


                var bar = relevantFilters.length;
                //    console.log('the bar is', bar)
                //    console.log('===============================')
                filteredPosts.forEach(function (post) {
                    post.relevantScore = 0;

                    //      console.log(post.title.rendered)

                    relevantFilters.forEach(function (filter) {

                        var hasCommonElement = false;

                        filter.selected.forEach(function (sel) {
                            if (filter.title == "Career Stage") {
                                if (post.content_type.length > 0) {
                                    hasCommonElement = post.career_stage.some(function (element) {
                                        return sel.ids.includes(element);
                                    });
                                    if (hasCommonElement) {
                                        post.relevantScore++;console.log('has match', 1);
                                    }
                                }
                            }
                            if (filter.title == "Programs & Committees") {
                                if (post.programs_committees.length > 0) {
                                    //    console.log(post)
                                    hasCommonElement = post.programs_committees.some(function (element) {
                                        return sel.ids.includes(element);
                                    });
                                    //  console.log(post.programs_committees)
                                    //   console.log(filter.selected[0].ids)
                                    if (hasCommonElement) {
                                        post.relevantScore++;console.log('has match', 2);
                                    }
                                }
                            }
                            if (filter.title == "Content Type") {
                                if (post.content_type.length > 0) {
                                    hasCommonElement = post.content_type.some(function (element) {
                                        return sel.ids.includes(element);
                                    });
                                    if (hasCommonElement) {
                                        post.relevantScore++;console.log('has match', 3);
                                    }
                                }
                            }
                            if (filter.title == "Tags") {
                                if (post.tx_tags.length > 0) {
                                    hasCommonElement = post.tx_tags.some(function (element) {
                                        return sel.ids.includes(element);
                                    });
                                    if (hasCommonElement) {
                                        post.relevantScore++;console.log('has match', 4);
                                    }
                                }
                            }
                        });

                        // let concat = [...post.content_type, ...post.programs_committees, ...post.career_stage, ...post.tx_tags]
                        //  const hasCommonElement = concat.some(element => filter.selected[0].ids.includes(element));
                        //  if (hasCommonElement) { post.relevantScore++ }
                    });

                    //  console.log('>', post.relevantScore)
                    if (post.relevantScore >= bar) {
                        newFilteredPosts.push(post);
                    }
                });

                return this.textBarSearch(newFilteredPosts);
            }
            return this.textBarSearch(filteredPosts);
        },
        textBarSearch: function textBarSearch(filteredPosts) {
            // console.log('before text', filteredPosts)

            if (filteredPosts.length < 1 && this.selectedFiltersActive.some(function (value) {
                return value !== 0;
            })) {
                return this.visibleResults = [];
            }

            if (filteredPosts.length < 1) {
                filteredPosts = this.fullDatabase;
            }

            if (this.searchQuery) {
                var searchTerms = this.searchQuery.toLowerCase().split(/\s+/);
                filteredPosts = filteredPosts.filter(function (post) {
                    var title = post.title.rendered ? post.title.rendered.toLowerCase() : '';
                    var excerpt = post.acf['post-excerpt'] ? post.acf['post-excerpt'].toLowerCase() : '';

                    // Check if either title or excerpt contains any of the search terms
                    return searchTerms.some(function (term) {
                        return title.includes(term) || excerpt.includes(term);
                    });
                }).map(function (post) {
                    var title = post.title.rendered ? post.title.rendered.toLowerCase() : '';
                    var excerpt = post.acf['post-excerpt'] ? post.acf['post-excerpt'].toLowerCase() : '';
                    var matchCount = searchTerms.reduce(function (count, term) {
                        if (title.includes(term)) count++;
                        if (excerpt.includes(term)) count++;
                        return count;
                    }, 0);

                    return _extends({}, post, { matchCount: matchCount });
                }).sort(function (a, b) {
                    return b.matchCount - a.matchCount;
                }); // 
            }

            //  console.log('number of results: ', filteredPosts.length)
            this.filteredResults = filteredPosts;
            //  console.log(filteredPosts)
            return this.visibleResults = filteredPosts.slice(0, this.itemsPerPage);
        },
        getTitleClass: function getTitleClass(index) {
            var positionInRow = index % 3;
            if (positionInRow === 0) return 'first-col';
            if (positionInRow === 1) return 'second-col';
            if (positionInRow === 2) return 'third-col';
        },
        getCardClass: function getCardClass(index) {
            var positionInRow = index % 3;
            if (positionInRow === 0) return 'first-colCard';
            if (positionInRow === 1) return 'second-colCard';
            if (positionInRow === 2) return 'third-colCard';
        },
        getIconClass: function getIconClass(index) {
            var positionInRow = index % 3;
            if (positionInRow === 0) return 'first-colIcon';
            if (positionInRow === 1) return 'second-colIcon';
            if (positionInRow === 2) return 'third-colIcon';
        },
        getHoverClass: function getHoverClass(index) {
            var positionInRow = index % 3;
            if (positionInRow === 0) return 'first-colHover';
            if (positionInRow === 1) return 'second-colHover';
            if (positionInRow === 2) return 'third-colHover';
        },
        getIconSrc: function getIconSrc(post) {
            //console.log('>>>',post.iconSrc)
            // console.log(post)
            if (post.formatType == "page") {
                //     console.log('page!')
                return 'https://vancouverdivision.com/wp-content/uploads/2022/08/Pages-Icon-01.png';
            }
            return post.iconSrc || this.defaultIconSrc;
        },
        getImageUrlById: function getImageUrlById(imageId) {

            if (!imageId || imageId == '') {
                return this.defaultIconSrc;
            }

            return this.imageReference[imageId] || this.defaultIconSrc;;

            /*             try {
                            const response = await fetch(`/wp-json/wp/v2/media/${imageId}`);
                            if (!response.ok) {
                                console.error(`Error fetching image: Received response status ${response.status}`);
                                throw new Error(`HTTP error! status: ${response.status}`);
                            }
                            const image = await response.json();
                            this.imageUrls[imageId] = image.source_url;
                            return image.source_url;
                        } catch (error) {
                            console.error('Error fetching image:', error.message);
                            this.imageUrls[imageId] = this.defaultIconSrc;
                            return this.defaultIconSrc;
                        } */
        },
        getAllPosts: function getAllPosts(postType, page) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, posts, totalPages;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return fetch('/wp-json/wp/v2/' + postType + '?page=' + page + '&per_page=100');

                            case 3:
                                response = _context.sent;

                                if (response.ok) {
                                    _context.next = 6;
                                    break;
                                }

                                throw new Error('HTTP error! status: ' + response.status);

                            case 6:
                                _context.next = 8;
                                return response.json();

                            case 8:
                                posts = _context.sent;
                                totalPages = parseInt(response.headers.get('X-WP-TotalPages'));


                                posts.forEach(function (post) {
                                    if (postType == 'posts') {
                                        post.content_type = [328];
                                    }
                                    post.iconSrc = _this2.defaultIconSrc;
                                    post.formatType = "post";
                                });

                                _this2.allPosts = _this2.allPosts.concat(posts);

                                console.log(_this2.allPosts);

                                if (!(page < totalPages)) {
                                    _context.next = 15;
                                    break;
                                }

                                return _context.abrupt('return', _this2.getAllPosts(postType, page + 1));

                            case 15:
                                _context.next = 20;
                                break;

                            case 17:
                                _context.prev = 17;
                                _context.t0 = _context['catch'](0);

                                console.error('Error fetching posts:', _context.t0);

                            case 20:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[0, 17]]);
            }))();
        },
        getAllPages: function getAllPages() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var allJobListings, perPage, fields, fetchJobListings;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                allJobListings = [];
                                perPage = 10;
                                fields = 'id,title,excerpt,link,acf';

                                fetchJobListings = function () {
                                    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                                        var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                                        var totalPages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                                        var response, contentType, data, relevantPages;
                                        return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                            while (1) {
                                                switch (_context2.prev = _context2.next) {
                                                    case 0:
                                                        _context2.prev = 0;
                                                        _context2.next = 3;
                                                        return fetch('/wp-json/wp/v2/pages?page=' + page + '&per_page=' + perPage + '&_fields=' + fields);

                                                    case 3:
                                                        response = _context2.sent;

                                                        if (response.ok) {
                                                            _context2.next = 6;
                                                            break;
                                                        }

                                                        throw new Error('Network response was not ok for page ' + page);

                                                    case 6:
                                                        contentType = response.headers.get('Content-Type');

                                                        if (!(!contentType || !contentType.includes('application/json'))) {
                                                            _context2.next = 10;
                                                            break;
                                                        }

                                                        console.warn('Expected JSON response for page ' + page + ', but received: ' + contentType);
                                                        throw new Error('Unexpected content type for page ' + page);

                                                    case 10:

                                                        if (page === 1) {
                                                            totalPages = parseInt(response.headers.get('X-WP-TotalPages'), 10);
                                                        }

                                                        _context2.next = 13;
                                                        return response.json();

                                                    case 13:
                                                        data = _context2.sent;

                                                        allJobListings = allJobListings.concat(data);

                                                        if (!(page < totalPages)) {
                                                            _context2.next = 20;
                                                            break;
                                                        }

                                                        _context2.next = 18;
                                                        return fetchJobListings(page + 1, totalPages);

                                                    case 18:
                                                        _context2.next = 23;
                                                        break;

                                                    case 20:
                                                        relevantPages = [];

                                                        allJobListings.forEach(function (item) {

                                                            if (item.excerpt.rendered == '') {
                                                                console.log('');
                                                            } else {
                                                                item.acf['post-excerpt'] = item.excerpt.rendered.slice(0, 155) + "...";
                                                                item.iconSrc = 'https://vancouverdivision.com/wp-content/uploads/2022/08/Pages-Icon-01.png'; //https://vancouverdivision.com/wp-content/uploads/2022/08/Pages-Icon-01.png

                                                                item.tx_tags = item.acf.tag;
                                                                item.content_type = item.acf.content_type;
                                                                item.career_stage = item.acf.career_stages;
                                                                item.programs_committees = item.acf.program_comites;

                                                                item.formatType = "page";
                                                                relevantPages.push(item);
                                                            }
                                                        });
                                                        //  console.log('pages:', relevantPages)
                                                        _this3.allPosts = _this3.allPosts.concat(relevantPages);

                                                    case 23:
                                                        _context2.next = 28;
                                                        break;

                                                    case 25:
                                                        _context2.prev = 25;
                                                        _context2.t0 = _context2['catch'](0);

                                                        console.error('Error fetching page:', page, _context2.t0);

                                                    case 28:
                                                    case 'end':
                                                        return _context2.stop();
                                                }
                                            }
                                        }, _callee2, _this3, [[0, 25]]);
                                    }));

                                    return function fetchJobListings() {
                                        return _ref.apply(this, arguments);
                                    };
                                }();

                                _context3.next = 6;
                                return fetchJobListings();

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        setCorrectIconsForPosts: function setCorrectIconsForPosts() {
            var _this4 = this;

            //set image for each post
            this.allPosts.forEach(function (post, index) {

                if (post.acf && post.acf['post-icon']) {
                    post.iconSrc = _this4.getImageUrlById(post.acf['post-icon']);
                }
                if (post.formatType == "page") {
                    post.iconSrc = 'https://vancouverdivision.com/wp-content/uploads/2022/08/Pages-Icon-01.png';
                }
            });
        },
        fetchAllPosts: function fetchAllPosts() {
            var _this5 = this;

            //  console.log('promising posts...')
            Promise.all([
            //     this.getAllPosts('event', 1), // no events on vic div for now
            this.getAllPosts('initiative', 1), this.getAllPosts('resource', 1), this.getAllPosts('posts', 1), this.getAllPages()]).then(function () {
                _this5.setCorrectIconsForPosts();

                _this5.firstLoadDone = true;
                _this5.fullDatabase = _this5.allPosts;
                _this5.filteredResults = _this5.allPosts;
                _this5.visibleResults = _this5.fullDatabase.slice(0, _this5.itemsPerPage);
                console.log(_this5.visibleResults);
            }).catch(function (error) {
                return console.error('Error fetching posts:', error);
            });
        },
        fetchDummyDatabaseDeleteThisLater: function fetchDummyDatabaseDeleteThisLater() {
            var _this6 = this;

            this.fullDatabase = __WEBPACK_IMPORTED_MODULE_0__databaseResources__["a" /* default */];

            this.allPosts = this.fullDatabase;
            this.fullDatabase.forEach(function (post, index) {
                if (post.acf && post.acf['post-icon']) {
                    _this6.allPosts[index].iconSrc = _this6.getImageUrlById(post.acf['post-icon']);
                }
                if (post.formatType == "page") {
                    _this6.allPosts[index].iconSrc = 'https://vancouverdivision.com/wp-content/uploads/2022/08/Pages-Icon-01.png';
                }
            });
            this.fullDatabase = this.allPosts;
            this.filteredResults = this.allPosts;
            this.visibleResults = this.fullDatabase.slice(0, this.itemsPerPage);
            this.firstLoadDone = true;
            //   console.log(this.fullDatabase)
        }
    }, _defineProperty(_methods, 'toggleDropdown', function toggleDropdown(index) {
        this.filters.forEach(function (filter, i) {
            if (i !== index) filter.show = false;
        });
        this.filters[index].show = !this.filters[index].show;
    }), _defineProperty(_methods, 'closeDropdowns', function closeDropdowns() {
        this.filters.forEach(function (filter) {
            filter.show = false;
        });
    }), _defineProperty(_methods, 'clearFilters', function clearFilters() {
        //  console.log('clear');

        this.filters.forEach(function (filter) {
            filter.options.forEach(function (option) {
                option.checked = false;
            });
        });

        this.applySearch();
    }), _methods),

    computed: {
        computedIconSrc: function computedIconSrc(post) {
            //    console.log(post)
            return post.iconSrc || 'https://vancouverdivision.com/wp-content/uploads/2022/05/6-Tools.png';
        },
        paginatedResults: function paginatedResults() {
            var start = (this.currentPage - 1) * this.itemsPerPage;
            var end = start + this.itemsPerPage;
            return this.visibleResults.slice(start, end);
        },
        totalPages: function totalPages() {
            return Math.ceil(this.visibleResults.length / this.itemsPerPage);
        }
    },

    mounted: function mounted() {

        //this.fetchDummyDatabaseDeleteThisLater()

        this.fetchAllPosts();
        console.log("console test");
    },

    directives: {
        clickOutside: {
            bind: function bind(el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                    if (!(el == event.target || el.contains(event.target))) {
                        vnode.context[binding.expression](event);
                    }
                };
                document.addEventListener('click', el.clickOutsideEvent);
            },
            unbind: function unbind(el) {
                document.removeEventListener('click', el.clickOutsideEvent);
            }
        }
    }

});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ical_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ical_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ical_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            activeDayForDropdown: null,
            activeTooltip: null,
            currentDate: new Date(),
            maxEventsToShow: 3,
            events: [
                /* { date: '27 november 2023', name: 'Healthy Minds, Healthy Distractions', tag: 'Board Meeting', time: '7:30 pm' },
                { date: '27 november 2023', name: 'Healthy Minds, Healthy Distractions', tag: 'Board Meeting', time: '2:30 pm' },
                { date: '27 november 2023', name: 'Healthy Minds, Healthy Distractions', tag: 'Board Meeting', time: '3:30 pm' },
                { date: '27 november 2023', name: 'Healthy Minds, Healthy Distractions', tag: 'Board Meeting', time: '4:30 pm' },
                { date: '27 november 2023', name: 'Healthy Minds, Healthy Distractions', tag: 'Board Meeting', time: '5:30 pm' },
                 { date: '28 november 2023', name: 'Therapeutics Initiative Annual Course', tag: 'Internal Event', time: '4:30 pm' },
                { date: '28 november 2023', name: 'Therapeutics Initiative Annual Course', tag: 'All-member meeting', time: '4:30 pm' },
                { date: '28 november 2023', name: 'Therapeutics Initiative Annual Course', tag: 'Board meeting', time: '4:30 pm' },
                { date: '28 november 2023', name: 'Therapeutics Initiative Annual Course', tag: 'Internal Event', time: '4:30 pm' },
                { date: '28 november 2023', name: 'Therapeutics Initiative Annual Course', tag: 'Internal Event', time: '4:30 pm' },
                 { date: '29 november 2023', name: 'Therapeutics Initiative Annual Course', tag: 'Internal Event', time: '4:30 pm' }, */

            ]

        };
    },

    computed: {
        currentMonthYear: function currentMonthYear() {
            var options = { month: 'long', year: 'numeric' };
            return this.currentDate.toLocaleDateString('en-US', options);
        },
        currentWeek: function currentWeek() {
            var startOfWeek = this.getStartOfWeek(this.currentDate);
            var endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 6);

            return 'Mon ' + startOfWeek.getDate() + ' - Sun ' + endOfWeek.getDate();
        },
        weekDays: function weekDays() {
            var days = [];
            var startOfWeek = this.getStartOfWeek(this.currentDate);

            for (var i = 0; i < 7; i++) {
                var day = new Date(startOfWeek);
                day.setDate(startOfWeek.getDate() + i);

                days.push({
                    date: day.getDate().toString().padStart(2, '0'),
                    name: day.toLocaleDateString('en-US', { weekday: 'long' }),
                    fullDate: day.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }).replace(/ /g, ' ') // Format: '01 November 2023'
                });
            }

            return days;
        }
    },
    methods: {
        getStartOfWeek: function getStartOfWeek(date) {
            var day = date.getDay();
            var diff = date.getDate() - day + (day === 0 ? -6 : 1);
            return new Date(date.setDate(diff));
        },
        changeMonth: function changeMonth(step) {
            var newDate = new Date(this.currentDate.setMonth(this.currentDate.getMonth() + step));
            this.currentDate = newDate;
            //    console.log(newDate)
            var test = !this.isLastDayOfMonthVisible();
            //   console.log(test)
            if (test) {
                this.changeWeek(1);
            };

            this.checkLastDayOfMonthVisible();
        },
        checkLastDayOfMonthVisible: function checkLastDayOfMonthVisible() {
            var _this = this;

            this.$nextTick(function () {
                if (!_this.isLastDayOfMonthVisible()) {
                    _this.changeWeek(-1);
                    _this.checkLastDayOfMonthVisible();
                }
            });
        },
        changeWeek: function changeWeek(step) {
            var newDate = new Date(this.currentDate.setDate(this.currentDate.getDate() + step * 7));
            this.currentDate = newDate;
        },
        eventsForDate: function eventsForDate(fullDate) {
            var _this2 = this;

            var dayEvents = this.events.filter(function (event) {
                return event.date.toLowerCase() === fullDate.toLowerCase();
            });

            dayEvents.sort(function (a, b) {
                return _this2.convertTo24Hour(a.time) - _this2.convertTo24Hour(b.time);
            });

            return dayEvents;
        },
        convertTo24Hour: function convertTo24Hour(timeStr) {
            var _timeStr$split = timeStr.split(' '),
                _timeStr$split2 = _slicedToArray(_timeStr$split, 2),
                time = _timeStr$split2[0],
                modifier = _timeStr$split2[1];

            var _time$split = time.split(':'),
                _time$split2 = _slicedToArray(_time$split, 2),
                hours = _time$split2[0],
                minutes = _time$split2[1];

            hours = parseInt(hours, 10);
            minutes = parseInt(minutes, 10);

            if (hours === 12) {
                hours = modifier === 'am' ? 0 : 12;
            } else {
                hours = modifier === 'pm' ? hours + 12 : hours;
            }
            return new Date(1970, 0, 1, hours, minutes);
        },
        getTagColor: function getTagColor(tag) {
            var tagColors = {
                'Internal event': '#006D8A',
                'External event': '#E48F5B',
                'All-member meeting': '#EEB844',
                'Board meeting': '#BBBF9A'
            };
            return tagColors[tag] || '#006D8A';
        },
        isLastDayOfMonth: function isLastDayOfMonth(fullDate) {
            var date = new Date(fullDate);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return date.getDate() === lastDay.getDate();
        },
        getMonthName: function getMonthName(fullDate) {
            var date = new Date(fullDate);
            var nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            return nextMonth.toLocaleDateString('default', { month: 'long' });
        },
        isLastDayOfMonthVisible: function isLastDayOfMonthVisible() {
            var _this3 = this;

            return this.weekDays.some(function (day) {
                return _this3.isLastDayOfMonth(day.fullDate);
            });
        },
        updateMaxEventsToShow: function updateMaxEventsToShow() {
            if (window.innerWidth < 750) {
                this.maxEventsToShow = 2;
            } else {
                this.maxEventsToShow = 3;
            }

            if (window.innerWidth < 550) {
                this.maxEventsToShow = 3;
            }
        },
        toggleDropdown: function toggleDropdown(dayIndex) {
            this.activeTooltip = null;
            if (this.activeDayForDropdown === dayIndex) {
                this.activeDayForDropdown = null;
            } else {
                this.activeDayForDropdown = dayIndex;
            }
        },
        showTooltip: function showTooltip(index) {
            this.activeDayForDropdown = null;
            if (this.activeTooltip === index) {
                this.activeTooltip = null;
            } else {
                this.activeTooltip = index;
            }
            this.activeTooltip = index;
        },
        toggleDropdownTooltip: function toggleDropdownTooltip(event) {
            var _this4 = this;

            // Ensure that only dropdown events toggle the tooltip
            if (this.activeTooltip === event) {
                this.activeTooltip = null;
            } else {
                this.activeTooltip = event;
            }

            // Ensure the tooltip doesn't overflow the calendar content
            this.$nextTick(function () {
                var tooltipEl = _this4.$refs['dropdownTooltip-' + event.name];
            });
        },
        closeTooltip: function closeTooltip() {
            this.activeTooltip = null;
        },
        parseDescription: function parseDescription(desc) {
            // Function to remove specific strings and all text following them
            function removeSpecificStrings(str) {
                var removalPhrases = ['Tori Escallier', 'Nicole Cooper', "I acknowledge with respect and appreciation that I am", "As a visitor on the traditional, ancestral, and un", "I am grateful to live, work and adventure on the traditional lands", "The Victoria Division of Family Practice acknowledges with great respect and app", "---", "- - -"];

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = removalPhrases[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var phrase = _step.value;

                        var index = str.indexOf(phrase);
                        if (index !== -1) {
                            return str.substring(0, index);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return str;
            }

            desc = removeSpecificStrings(desc);

            // Process URLs from 'safelinks.protection.outlook.com' with preceding word as link text
            desc = desc.replace(/(\b\w+)\s*<https:.*?safelinks\.protection\.outlook\.com.*?url=([^&]+).*?>/gi, function (_, precedingWord, encodedUrl) {
                var decodedUrl = decodeURIComponent(encodedUrl);
                return '<a href="' + decodedUrl + '" target="_blank">' + precedingWord + '</a>';
            });

            // Convert generic URLs into anchor tags
            desc = desc.replace(/(\w+)<(https?:\/\/\S+)>/g, '<a href="$2">$1</a>');

            // Handle mailto links with spaces separating them from the preceding word
            desc = desc.replace(/(?:\b(\S+)\s*)?<mailto:([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\?.*?)?>/gi, function (match, precedingWord, email, params) {
                var mailtoLink = 'mailto:' + email;
                if (params) {
                    mailtoLink += params; // Append any extra mailto parameters
                }
                // Use the preceding word if it exists; otherwise, fallback to "email"
                var linkText = precedingWord ? precedingWord.replace(/\.$/, "") : "email";
                return '<a href="' + mailtoLink + '" target="_blank">' + linkText + '</a>';
            });

            // Handle standalone emails that aren't part of a <mailto:...> link
            desc = desc.replace(/\b([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\b(?![^<]*>)/g, function (match, email) {
                console.log('Processing standalone email: ' + email);
                return '<a href="mailto:' + email + '" target="_blank">' + email + '</a>';
            });

            // Remove redundant new lines and convert remaining to HTML line breaks
            desc = desc.replace(/\n\s*\n/g, '\n'); // Reduce multiple new lines to single
            desc = desc.replace(/\n/g, '<br>'); // Convert remaining new lines to <br>

            return desc;
        },


        //https://calendar.google.com/calendar/ical/2por7b281u6448ptl46qb7sijsrfu75u%40import.calendar.google.com/public/basic.ics

        loadEvents: function loadEvents() {
            var _this5 = this;

            var corsProxyUrl = 'https://corsproxy.io/?';
            var outlookIcsUrl = 'https://outlook.office365.com/owa/calendar/b8f430694e0b4e52b5a31ca13debfa27@victoriadivision.ca/e8585853d9794d1e85fbf2abd0c1a42b14663871500057393623/calendar.ics';

            fetch('https://worker-twilight-smoke-9efd.development-c3d.workers.dev/').then(function (response) {
                return response.text();
            }).then(function (data) {
                var jcalData = __WEBPACK_IMPORTED_MODULE_0_ical_js__["parse"](data);
                var comp = new __WEBPACK_IMPORTED_MODULE_0_ical_js__["Component"](jcalData);
                var events = comp.getAllSubcomponents('vevent');

                var dataArray = [];

                events.forEach(function (event) {
                    var obj = {
                        summary: event.getFirstPropertyValue('summary'),
                        startDate: event.getFirstPropertyValue('dtstart').toJSDate(),
                        endDate: event.getFirstPropertyValue('dtend').toJSDate(),
                        description: event.getFirstPropertyValue('description'),
                        location: event.getFirstPropertyValue('location'),
                        categories: event.getFirstPropertyValue('categories')
                    };

                    var rule = event.getFirstPropertyValue('rrule');
                    var exceptions = [];
                    event.getAllProperties('exdate').forEach(function (exdate) {
                        exdate.getValues().forEach(function (date) {
                            exceptions.push(date.toJSDate());
                        });
                    });

                    // console.log(`Processing event: ${obj.summary}`);
                    // console.log(`Rule: ${JSON.stringify(rule)}`);
                    //  console.log(`Exceptions: ${exceptions}`);

                    if (rule) {
                        processRecurrence(rule, obj, dataArray, exceptions);
                    } else {
                        dataArray.push(obj);
                    }
                });

                function processRecurrence(rule, obj, dataArray, exceptions) {
                    var currentDate = new Date(obj.startDate.getTime());
                    var untilDate = rule.until ? new Date(rule.until._time.year, rule.until._time.month - 1, rule.until._time.day, rule.until._time.hour, rule.until._time.minute, rule.until._time.second) : new Date();

                    if (rule.freq === "WEEKLY") {
                        while (currentDate <= untilDate) {
                            if (!isException(currentDate, exceptions)) {
                                addEvent(obj, currentDate, dataArray);
                            }
                            currentDate.setDate(currentDate.getDate() + 7 * rule.interval);
                        }
                    } else if (rule.freq === "MONTHLY") {
                        if (rule.parts.BYDAY && rule.parts.BYDAY[0] === "-1FR") {
                            while (currentDate <= untilDate) {
                                var lastFriday = findLastFridayOfMonth(currentDate.getFullYear(), currentDate.getMonth());
                                if (lastFriday <= untilDate && !isException(lastFriday, exceptions)) {
                                    addEvent(obj, lastFriday, dataArray);
                                }
                                currentDate.setMonth(currentDate.getMonth() + rule.interval);
                            }
                        } else if (rule.parts.BYDAY && rule.parts.BYDAY[0] === "4FR") {
                            while (currentDate <= untilDate) {
                                var fourthFriday = findNthWeekdayOfMonth(currentDate.getFullYear(), currentDate.getMonth(), 5, 4);
                                if (fourthFriday <= untilDate && !isException(fourthFriday, exceptions)) {
                                    addEvent(obj, fourthFriday, dataArray);
                                }
                                currentDate.setMonth(currentDate.getMonth() + rule.interval);
                            }
                        } else if (rule.parts.BYDAY && rule.parts.BYDAY[0] === "2WE") {
                            while (currentDate <= untilDate) {
                                var secondWednesday = findNthWeekdayOfMonth(currentDate.getFullYear(), currentDate.getMonth(), 3, 2);
                                if (secondWednesday <= untilDate && !isException(secondWednesday, exceptions)) {
                                    addEvent(obj, secondWednesday, dataArray);
                                }
                                currentDate.setMonth(currentDate.getMonth() + rule.interval);
                            }
                        } else if (rule.parts.BYDAY && rule.parts.BYDAY[0] === "2TH") {
                            while (currentDate <= untilDate) {
                                var secondThursday = findNthWeekdayOfMonth(currentDate.getFullYear(), currentDate.getMonth(), 4, 2);
                                if (secondThursday <= untilDate && !isException(secondThursday, exceptions)) {
                                    addEvent(obj, secondThursday, dataArray);
                                }
                                currentDate.setMonth(currentDate.getMonth() + rule.interval);
                            }
                        } else if (rule.parts.BYDAY && rule.parts.BYDAY[0] === "3TH") {
                            while (currentDate <= untilDate) {
                                var thirdThursday = findNthWeekdayOfMonth(currentDate.getFullYear(), currentDate.getMonth(), 4, 3);
                                if (thirdThursday <= untilDate && !isException(thirdThursday, exceptions)) {
                                    addEvent(obj, thirdThursday, dataArray);
                                }
                                currentDate.setMonth(currentDate.getMonth() + rule.interval);
                            }
                        } else {
                            while (currentDate <= untilDate) {
                                if (!isException(currentDate, exceptions)) {
                                    addEvent(obj, currentDate, dataArray);
                                }
                                currentDate.setMonth(currentDate.getMonth() + rule.interval);
                            }
                        }
                    }
                }

                function isException(date, exceptions) {
                    return exceptions.some(function (ex) {
                        return ex.getFullYear() === date.getFullYear() && ex.getMonth() === date.getMonth() && ex.getDate() === date.getDate();
                    });
                }

                function addEvent(obj, date, dataArray) {
                    var newObj = _extends({}, obj, { startDate: new Date(date), endDate: new Date(date) });
                    newObj.endDate.setHours(newObj.endDate.getHours() + (obj.endDate.getHours() - obj.startDate.getHours()));
                    newObj.endDate.setMinutes(newObj.endDate.getMinutes() + (obj.endDate.getMinutes() - obj.startDate.getMinutes()));
                    dataArray.push(newObj);
                }

                function findLastFridayOfMonth(year, month) {
                    var lastDayOfMonth = new Date(year, month + 1, 0);
                    var lastFridayOffset = lastDayOfMonth.getDay() >= 5 ? lastDayOfMonth.getDay() - 5 : lastDayOfMonth.getDay() + 2;
                    return new Date(lastDayOfMonth.setDate(lastDayOfMonth.getDate() - lastFridayOffset));
                }

                function findNthWeekdayOfMonth(year, month, weekday, n) {
                    var firstDayOfMonth = new Date(year, month, 1);
                    var firstWeekdayOffset = (weekday - firstDayOfMonth.getDay() + 7) % 7;
                    var nthWeekdayDate = firstDayOfMonth.getDate() + firstWeekdayOffset + (n - 1) * 7;
                    return new Date(year, month, nthWeekdayDate);
                }

                function addEvent(obj, date, dataArray) {
                    var newEvent = _extends({}, obj);

                    var startHours = obj.startDate.getHours();
                    var startMinutes = obj.startDate.getMinutes();
                    var startSeconds = obj.startDate.getSeconds();

                    newEvent.startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), startHours, startMinutes, startSeconds);

                    var duration = obj.endDate - obj.startDate;

                    newEvent.endDate = new Date(newEvent.startDate.getTime() + duration);

                    dataArray.push(newEvent);
                }

                function convertArrayOfObjects(inputArray) {
                    return inputArray.map(function (obj) {
                        var startDate = new Date(obj.startDate);

                        var day = startDate.getDate().toString().padStart(2, '0');
                        var month = startDate.toLocaleString('en-US', { month: 'long' });
                        var year = startDate.getFullYear();
                        var formattedDate = day + ' ' + month + ' ' + year;

                        var hours = startDate.getHours();
                        var minutes = startDate.getMinutes().toString().padStart(2, '0');
                        var ampm = hours >= 12 ? 'pm' : 'am';
                        var formattedTime = (hours % 12 || 12) + ':' + minutes + ' ' + ampm;

                        //  console.log(obj)
                        if (obj.description == null) {
                            obj.description = '';
                        }
                        //  console.log(obj.summary, formattedDate, startDate)
                        //  console.log(obj.summary)

                        return {
                            date: formattedDate,
                            name: obj.summary,
                            description: obj.description,
                            tag: obj.description.trim(),
                            time: formattedTime.toLowerCase()
                        };
                    });
                }

                _this5.events = convertArrayOfObjects(dataArray);

                //loads second calendar
                _this5.loadEvents2();
            }).catch(function (error) {
                return console.error('Error fetching the ICS file:', error);
            });
        },
        loadEvents2: function loadEvents2() {
            var _this6 = this;

            var corsProxyUrl = 'https://corsproxy.io/?';
            var outlookIcsUrl = 'https://outlook.office365.com/owa/calendar/b8f430694e0b4e52b5a31ca13debfa27@victoriadivision.ca/e8585853d9794d1e85fbf2abd0c1a42b14663871500057393623/calendar.ics';
            //https://worker-twilight-dew-5689.development-c3d.workers.dev/

            fetch('https://worker-twilight-dew-5689.development-c3d.workers.dev/').then(function (response) {
                return response.text();
            }).then(function (data) {

                //console.log(data)
                var jcalData = __WEBPACK_IMPORTED_MODULE_0_ical_js__["parse"](data);
                var comp = new __WEBPACK_IMPORTED_MODULE_0_ical_js__["Component"](jcalData);
                var events = comp.getAllSubcomponents('vevent');

                var dataArray = [];

                //  imageTailoredCaseStud
                //

                events.forEach(function (event) {
                    var obj = {};

                    obj.summary = event.getFirstPropertyValue('summary');
                    obj.startDate = event.getFirstPropertyValue('dtstart').toJSDate();
                    obj.endDate = event.getFirstPropertyValue('dtend').toJSDate();
                    obj.description = event.getFirstPropertyValue('description');
                    obj.location = event.getFirstPropertyValue('location');
                    obj.categories = event.getFirstPropertyValue('categories');

                    if (event.getFirstPropertyValue('rrule')) {
                        var rule = event.getFirstPropertyValue('rrule');

                        var currentDate = new Date(obj.startDate.getTime());
                        var untilDate = new Date(rule.until._time.year, rule.until._time.month - 1, rule.until._time.day, rule.until._time.hour, rule.until._time.minute, rule.until._time.second);

                        if (rule.freq == "WEEKLY") {
                            while (currentDate <= untilDate) {
                                var newEvent = _extends({}, obj);
                                newEvent.startDate = new Date(currentDate.getTime());
                                newEvent.endDate = new Date(currentDate.getTime() + (obj.endDate - obj.startDate));

                                dataArray.push(newEvent);

                                currentDate.setDate(currentDate.getDate() + 7 * rule.interval);
                            }
                        } else if (rule.freq === "MONTHLY") {
                            //       console.log(obj); console.log(rule.parts.BYDAY[0])
                            if (rule.parts.BYDAY && rule.parts.BYDAY[0] === "-1FR") {
                                while (currentDate <= untilDate) {
                                    var lastFriday = findLastFridayOfMonth(currentDate.getFullYear(), currentDate.getMonth());
                                    if (lastFriday <= untilDate) {
                                        addEvent(obj, lastFriday, dataArray);
                                    }
                                    currentDate.setMonth(currentDate.getMonth() + rule.interval);
                                }
                            } else if (rule.parts.BYDAY && rule.parts.BYDAY[0] === "4FR") {
                                while (currentDate <= untilDate) {
                                    var fourthFriday = findNthWeekdayOfMonth(currentDate.getFullYear(), currentDate.getMonth(), 5, 4);
                                    if (fourthFriday <= untilDate) {
                                        addEvent(obj, fourthFriday, dataArray);
                                    }
                                    currentDate.setMonth(currentDate.getMonth() + rule.interval);
                                }
                            } else if (rule.parts.BYDAY && rule.parts.BYDAY[0] === "2WE") {
                                while (currentDate <= untilDate) {
                                    var secondWednesday = findNthWeekdayOfMonth(currentDate.getFullYear(), currentDate.getMonth(), 3, 2);
                                    if (secondWednesday <= untilDate) {
                                        addEvent(obj, secondWednesday, dataArray);
                                    }
                                    currentDate.setMonth(currentDate.getMonth() + rule.interval);
                                }
                            } else if (rule.parts.BYDAY && rule.parts.BYDAY[0] === "2TH") {
                                while (currentDate <= untilDate) {
                                    var secondThursday = findNthWeekdayOfMonth(currentDate.getFullYear(), currentDate.getMonth(), 4, 2);
                                    if (secondThursday <= untilDate) {
                                        addEvent(obj, secondThursday, dataArray);
                                    }
                                    currentDate.setMonth(currentDate.getMonth() + rule.interval);
                                }
                            } else if (rule.parts.BYDAY && rule.parts.BYDAY[0] === "3TH") {
                                while (currentDate <= untilDate) {
                                    var thirdThursday = findNthWeekdayOfMonth(currentDate.getFullYear(), currentDate.getMonth(), 4, 3);
                                    if (thirdThursday <= untilDate) {
                                        addEvent(obj, thirdThursday, dataArray);
                                    }
                                    currentDate.setMonth(currentDate.getMonth() + rule.interval);
                                }
                            } else {
                                while (currentDate <= untilDate) {
                                    addEvent(obj, currentDate, dataArray);
                                    currentDate.setMonth(currentDate.getMonth() + rule.interval);
                                }
                            }
                        }
                    } else {
                        //     console.log('this event doesn’t have a rule');
                        dataArray.push(obj);
                    }
                });
                function findLastFridayOfMonth(year, month) {
                    var lastDayOfMonth = new Date(year, month + 1, 0); // 0 here gets the last day of the month
                    var lastFridayOffset = lastDayOfMonth.getDay() >= 5 ? lastDayOfMonth.getDay() - 5 : lastDayOfMonth.getDay() + 2;
                    return new Date(lastDayOfMonth.setDate(lastDayOfMonth.getDate() - lastFridayOffset));
                }

                function findNthWeekdayOfMonth(year, month, weekday, n) {
                    var firstDayOfMonth = new Date(year, month, 1);
                    var firstWeekdayOffset = (weekday - firstDayOfMonth.getDay() + 7) % 7;
                    var nthWeekdayDate = firstDayOfMonth.getDate() + firstWeekdayOffset + (n - 1) * 7;
                    return new Date(year, month, nthWeekdayDate);
                }

                function addEvent(obj, date, dataArray) {
                    var newEvent = _extends({}, obj);

                    var startHours = obj.startDate.getHours();
                    var startMinutes = obj.startDate.getMinutes();
                    var startSeconds = obj.startDate.getSeconds();

                    newEvent.startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), startHours, startMinutes, startSeconds);

                    var duration = obj.endDate - obj.startDate;

                    newEvent.endDate = new Date(newEvent.startDate.getTime() + duration);

                    dataArray.push(newEvent);
                }

                function convertArrayOfObjects(inputArray) {
                    return inputArray.map(function (obj) {
                        var startDate = new Date(obj.startDate);

                        var day = startDate.getDate().toString().padStart(2, '0');
                        var month = startDate.toLocaleString('en-US', { month: 'long' });
                        var year = startDate.getFullYear();
                        var formattedDate = day + ' ' + month + ' ' + year;

                        var hours = startDate.getHours();
                        var minutes = startDate.getMinutes().toString().padStart(2, '0');
                        var ampm = hours >= 12 ? 'pm' : 'am';
                        var formattedTime = (hours % 12 || 12) + ':' + minutes + ' ' + ampm;

                        if (obj.description == null) {
                            obj.description = '';
                        }

                        return {
                            date: formattedDate,
                            name: obj.summary,
                            description: obj.description,
                            tag: 'External event',
                            time: formattedTime.toLowerCase()
                        };
                    });
                }

                var newArray = convertArrayOfObjects(dataArray);

                newArray.forEach(function (item) {
                    _this6.events.push(item);
                });

                //   console.log(events)


                // this.loadEvents3();

            }).catch(function (error) {
                return console.error('Error fetching the ICS file:', error);
            });
        },
        loadEvents3: function loadEvents3() {
            var _this7 = this;

            var corsProxyUrl = 'https://corsproxy.io/?';
            var outlookIcsUrl = 'https://calendar.google.com/calendar/ical/2por7b281u6448ptl46qb7sijsrfu75u%40import.calendar.google.com/public/basic.ics';

            fetch('' + corsProxyUrl + outlookIcsUrl).then(function (response) {
                return response.text();
            }).then(function (data) {
                // console.log(data)
                var jcalData = __WEBPACK_IMPORTED_MODULE_0_ical_js__["parse"](data);
                var comp = new __WEBPACK_IMPORTED_MODULE_0_ical_js__["Component"](jcalData);
                var events = comp.getAllSubcomponents('vevent');

                //   console.log(events)

                var dataArray = [];

                events.forEach(function (event) {
                    var obj = {};
                    //     console.log(event)
                    obj.summary = event.getFirstPropertyValue('summary');
                    obj.startDate = event.getFirstPropertyValue('dtstart').toJSDate();
                    obj.endDate = event.getFirstPropertyValue('dtend').toJSDate();
                    obj.description = event.getFirstPropertyValue('description');
                    obj.location = event.getFirstPropertyValue('location');
                    obj.categories = event.getFirstPropertyValue('categories');
                    //    console.log(obj)
                    dataArray.push(obj);
                });

                function convertArrayOfObjects(inputArray) {
                    return inputArray.map(function (obj, i) {
                        var startDate = new Date(obj.startDate);

                        var day = startDate.getDate().toString().padStart(2, '0');
                        var month = startDate.toLocaleString('en-US', { month: 'long' });
                        var year = startDate.getFullYear();
                        var formattedDate = day + ' ' + month + ' ' + year;

                        var hours = startDate.getHours();
                        var minutes = startDate.getMinutes().toString().padStart(2, '0');
                        var ampm = hours >= 12 ? 'pm' : 'am';
                        var formattedTime = (hours % 12 || 12) + ':' + minutes + ' ' + ampm;

                        //  console.log(formattedDate, i)
                        return {
                            date: formattedDate,
                            name: obj.summary,
                            description: obj.description,
                            tag: 'Internal event',
                            time: formattedTime.toLowerCase()
                        };
                    });
                }

                var newArray = convertArrayOfObjects(dataArray);

                //  console.log(newArray)
                _this7.events = newArray;
                // newArray.forEach(item => { this.events.push(item) }) 
                _this7.loadEvents2();
            }).catch(function (error) {
                return console.error('Error fetching the ICS file:', error);
            });
        }
    },
    created: function created() {
        window.addEventListener('resize', this.updateMaxEventsToShow);
        this.updateMaxEventsToShow();
    },
    destroyed: function destroyed() {
        window.removeEventListener('resize', this.updateMaxEventsToShow);
    },
    mounted: function mounted() {
        console.log('loading calendar...');
        this.loadEvents();
        console.log("calendar loaded");
        /*     this.events = [
                   {
                       "date": "28 November 2023",
                       "name": "Sample Event",
                       "tag": "Internal event",
                       "time": "8:00 am"
                   },
                   {
                       "date": "28 November 2023",
                       "name": "Sample Event",
                       "tag": "Board meeting",
                       "time": "9:00 am"
                   },
                   {
                       "date": "28 November 2023",
                       "name": "Sample Event",
                       "tag": "External event",
                       "time": "12:00 pm"
                   },
                   {
                       "date": "28 November 2023",
                       "name": "Sample Event",
                       "tag": "All-member meeting",
                       "time": "2:30 pm"
                   },
                   {
                       "date": "28 November 2023",
                       "name": "Sample Event",
                       "tag": "Internal Event",
                       "time": "6:30 pm"
                   },
                   {
                       "date": "29 November 2023",
                       "name": "Sample Event",
                       "tag": "Internal Event",
                       "time": "8:00 am"
                   },
                   {
                       "date": "29 November 2023",
                       "name": "Sample Event",
                       "tag": "External event",
                       "time": "10:00 am"
                   },
                   {
                       "date": "29 November 2023",
                       "name": "Sample Event",
                       "tag": "Board meeting",
                       "time": "5:00 pm"
                   },
                   {
                       "date": "02 December 2023",
                       "name": "Sample Event",
                       "tag": "External event",
                       "time": "3:30 pm"
                   }
               ]
                   */
    }
});

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2021 */

/* jshint ignore:start */
var ICAL;
(function() {
  /* istanbul ignore next */
  if (true) {
    // CommonJS, where exports may be different each time.
    ICAL = module.exports;
  } else if (typeof HTMLScriptElement !== 'undefined' && 'noModule' in HTMLScriptElement.prototype) {
    // Until we use ES6 exports, using <script type="module"> we define ICAL on the window global.
    window.ICAL = ICAL = {};
  } else if (typeof ICAL !== 'object') {
    ICAL = {};
  }
})();
/* jshint ignore:end */
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */

/**
 * The number of characters before iCalendar line folding should occur
 * @type {Number}
 * @default 75
 */
ICAL.foldLength = 75;


/**
 * The character(s) to be used for a newline. The default value is provided by
 * rfc5545.
 * @type {String}
 * @default "\r\n"
 */
ICAL.newLineChar = '\r\n';


/**
 * Helper functions used in various places within ical.js
 * @namespace
 */
ICAL.helpers = {
  /**
   * Compiles a list of all referenced TZIDs in all subcomponents and
   * removes any extra VTIMEZONE subcomponents. In addition, if any TZIDs
   * are referenced by a component, but a VTIMEZONE does not exist,
   * an attempt will be made to generate a VTIMEZONE using ICAL.TimezoneService.
   *
   * @param {ICAL.Component} vcal     The top-level VCALENDAR component.
   * @return {ICAL.Component}         The ICAL.Component that was passed in.
   */
  updateTimezones: function(vcal) {
    var allsubs, properties, vtimezones, reqTzid, i, tzid;

    if (!vcal || vcal.name !== "vcalendar") {
      //not a top-level vcalendar component
      return vcal;
    }

    //Store vtimezone subcomponents in an object reference by tzid.
    //Store properties from everything else in another array
    allsubs = vcal.getAllSubcomponents();
    properties = [];
    vtimezones = {};
    for (i = 0; i < allsubs.length; i++) {
      if (allsubs[i].name === "vtimezone") {
        tzid = allsubs[i].getFirstProperty("tzid").getFirstValue();
        vtimezones[tzid] = allsubs[i];
      } else {
        properties = properties.concat(allsubs[i].getAllProperties());
      }
    }

    //create an object with one entry for each required tz
    reqTzid = {};
    for (i = 0; i < properties.length; i++) {
      if ((tzid = properties[i].getParameter("tzid"))) {
        reqTzid[tzid] = true;
      }
    }

    //delete any vtimezones that are not on the reqTzid list.
    for (i in vtimezones) {
      if (vtimezones.hasOwnProperty(i) && !reqTzid[i]) {
        vcal.removeSubcomponent(vtimezones[i]);
      }
    }

    //create any missing, but registered timezones
    for (i in reqTzid) {
      if (
        reqTzid.hasOwnProperty(i) &&
        !vtimezones[i] &&
        ICAL.TimezoneService.has(i)
      ) {
        vcal.addSubcomponent(ICAL.TimezoneService.get(i).component);
      }
    }

    return vcal;
  },

  /**
   * Checks if the given type is of the number type and also NaN.
   *
   * @param {Number} number     The number to check
   * @return {Boolean}          True, if the number is strictly NaN
   */
  isStrictlyNaN: function(number) {
    return typeof(number) === 'number' && isNaN(number);
  },

  /**
   * Parses a string value that is expected to be an integer, when the valid is
   * not an integer throws a decoration error.
   *
   * @param {String} string     Raw string input
   * @return {Number}           Parsed integer
   */
  strictParseInt: function(string) {
    var result = parseInt(string, 10);

    if (ICAL.helpers.isStrictlyNaN(result)) {
      throw new Error(
        'Could not extract integer from "' + string + '"'
      );
    }

    return result;
  },

  /**
   * Creates or returns a class instance of a given type with the initialization
   * data if the data is not already an instance of the given type.
   *
   * @example
   * var time = new ICAL.Time(...);
   * var result = ICAL.helpers.formatClassType(time, ICAL.Time);
   *
   * (result instanceof ICAL.Time)
   * // => true
   *
   * result = ICAL.helpers.formatClassType({}, ICAL.Time);
   * (result isntanceof ICAL.Time)
   * // => true
   *
   *
   * @param {Object} data       object initialization data
   * @param {Object} type       object type (like ICAL.Time)
   * @return {?}                An instance of the found type.
   */
  formatClassType: function formatClassType(data, type) {
    if (typeof(data) === 'undefined') {
      return undefined;
    }

    if (data instanceof type) {
      return data;
    }
    return new type(data);
  },

  /**
   * Identical to indexOf but will only match values when they are not preceded
   * by a backslash character.
   *
   * @param {String} buffer         String to search
   * @param {String} search         Value to look for
   * @param {Number} pos            Start position
   * @return {Number}               The position, or -1 if not found
   */
  unescapedIndexOf: function(buffer, search, pos) {
    while ((pos = buffer.indexOf(search, pos)) !== -1) {
      if (pos > 0 && buffer[pos - 1] === '\\') {
        pos += 1;
      } else {
        return pos;
      }
    }
    return -1;
  },

  /**
   * Find the index for insertion using binary search.
   *
   * @param {Array} list            The list to search
   * @param {?} seekVal             The value to insert
   * @param {function(?,?)} cmpfunc The comparison func, that can
   *                                  compare two seekVals
   * @return {Number}               The insert position
   */
  binsearchInsert: function(list, seekVal, cmpfunc) {
    if (!list.length)
      return 0;

    var low = 0, high = list.length - 1,
        mid, cmpval;

    while (low <= high) {
      mid = low + Math.floor((high - low) / 2);
      cmpval = cmpfunc(seekVal, list[mid]);

      if (cmpval < 0)
        high = mid - 1;
      else if (cmpval > 0)
        low = mid + 1;
      else
        break;
    }

    if (cmpval < 0)
      return mid; // insertion is displacing, so use mid outright.
    else if (cmpval > 0)
      return mid + 1;
    else
      return mid;
  },

  /**
   * Convenience function for debug output
   * @private
   */
  dumpn: /* istanbul ignore next */ function() {
    if (!ICAL.debug) {
      return;
    }

    if (typeof (console) !== 'undefined' && 'log' in console) {
      ICAL.helpers.dumpn = function consoleDumpn(input) {
        console.log(input);
      };
    } else {
      ICAL.helpers.dumpn = function geckoDumpn(input) {
        dump(input + '\n');
      };
    }

    ICAL.helpers.dumpn(arguments[0]);
  },

  /**
   * Clone the passed object or primitive. By default a shallow clone will be
   * executed.
   *
   * @param {*} aSrc            The thing to clone
   * @param {Boolean=} aDeep    If true, a deep clone will be performed
   * @return {*}                The copy of the thing
   */
  clone: function(aSrc, aDeep) {
    if (!aSrc || typeof aSrc != "object") {
      return aSrc;
    } else if (aSrc instanceof Date) {
      return new Date(aSrc.getTime());
    } else if ("clone" in aSrc) {
      return aSrc.clone();
    } else if (Array.isArray(aSrc)) {
      var arr = [];
      for (var i = 0; i < aSrc.length; i++) {
        arr.push(aDeep ? ICAL.helpers.clone(aSrc[i], true) : aSrc[i]);
      }
      return arr;
    } else {
      var obj = {};
      for (var name in aSrc) {
        // uses prototype method to allow use of Object.create(null);
        /* istanbul ignore else */
        if (Object.prototype.hasOwnProperty.call(aSrc, name)) {
          if (aDeep) {
            obj[name] = ICAL.helpers.clone(aSrc[name], true);
          } else {
            obj[name] = aSrc[name];
          }
        }
      }
      return obj;
    }
  },

  /**
   * Performs iCalendar line folding. A line ending character is inserted and
   * the next line begins with a whitespace.
   *
   * @example
   * SUMMARY:This line will be fold
   *  ed right in the middle of a word.
   *
   * @param {String} aLine      The line to fold
   * @return {String}           The folded line
   */
  foldline: function foldline(aLine) {
    var result = "";
    var line = aLine || "", pos = 0, line_length = 0;
    //pos counts position in line for the UTF-16 presentation
    //line_length counts the bytes for the UTF-8 presentation
    while (line.length) {
      var cp = line.codePointAt(pos);
      if (cp < 128) ++line_length;
      else if (cp < 2048) line_length += 2;//needs 2 UTF-8 bytes
      else if (cp < 65536) line_length += 3;
      else line_length += 4; //cp is less than 1114112
      if (line_length < ICAL.foldLength + 1)
        pos += cp > 65535 ? 2 : 1;
      else {
        result += ICAL.newLineChar + " " + line.substring(0, pos);
        line = line.substring(pos);
        pos = line_length = 0;
      }
    }
    return result.substr(ICAL.newLineChar.length + 1);
  },

  /**
   * Pads the given string or number with zeros so it will have at least two
   * characters.
   *
   * @param {String|Number} data    The string or number to pad
   * @return {String}               The number padded as a string
   */
  pad2: function pad(data) {
    if (typeof(data) !== 'string') {
      // handle fractions.
      if (typeof(data) === 'number') {
        data = parseInt(data);
      }
      data = String(data);
    }

    var len = data.length;

    switch (len) {
      case 0:
        return '00';
      case 1:
        return '0' + data;
      default:
        return data;
    }
  },

  /**
   * Truncates the given number, correctly handling negative numbers.
   *
   * @param {Number} number     The number to truncate
   * @return {Number}           The truncated number
   */
  trunc: function trunc(number) {
    return (number < 0 ? Math.ceil(number) : Math.floor(number));
  },

  /**
   * Poor-man's cross-browser inheritance for JavaScript. Doesn't support all
   * the features, but enough for our usage.
   *
   * @param {Function} base     The base class constructor function.
   * @param {Function} child    The child class constructor function.
   * @param {Object} extra      Extends the prototype with extra properties
   *                              and methods
   */
  inherits: function(base, child, extra) {
    function F() {}
    F.prototype = base.prototype;
    child.prototype = new F();

    if (extra) {
      ICAL.helpers.extend(extra, child.prototype);
    }
  },

  /**
   * Poor-man's cross-browser object extension. Doesn't support all the
   * features, but enough for our usage. Note that the target's properties are
   * not overwritten with the source properties.
   *
   * @example
   * var child = ICAL.helpers.extend(parent, {
   *   "bar": 123
   * });
   *
   * @param {Object} source     The object to extend
   * @param {Object} target     The object to extend with
   * @return {Object}           Returns the target.
   */
  extend: function(source, target) {
    for (var key in source) {
      var descr = Object.getOwnPropertyDescriptor(source, key);
      if (descr && !Object.getOwnPropertyDescriptor(target, key)) {
        Object.defineProperty(target, key, descr);
      }
    }
    return target;
  }
};
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */

/** @namespace ICAL */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.design = (function() {
  'use strict';

  var FROM_ICAL_NEWLINE = /\\\\|\\;|\\,|\\[Nn]/g;
  var TO_ICAL_NEWLINE = /\\|;|,|\n/g;
  var FROM_VCARD_NEWLINE = /\\\\|\\,|\\[Nn]/g;
  var TO_VCARD_NEWLINE = /\\|,|\n/g;

  function createTextType(fromNewline, toNewline) {
    var result = {
      matches: /.*/,

      fromICAL: function(aValue, structuredEscape) {
        return replaceNewline(aValue, fromNewline, structuredEscape);
      },

      toICAL: function(aValue, structuredEscape) {
        var regEx = toNewline;
        if (structuredEscape)
          regEx = new RegExp(regEx.source + '|' + structuredEscape);
        return aValue.replace(regEx, function(str) {
          switch (str) {
          case "\\":
            return "\\\\";
          case ";":
            return "\\;";
          case ",":
            return "\\,";
          case "\n":
            return "\\n";
          /* istanbul ignore next */
          default:
            return str;
          }
        });
      }
    };
    return result;
  }

  // default types used multiple times
  var DEFAULT_TYPE_TEXT = { defaultType: "text" };
  var DEFAULT_TYPE_TEXT_MULTI = { defaultType: "text", multiValue: "," };
  var DEFAULT_TYPE_TEXT_STRUCTURED = { defaultType: "text", structuredValue: ";" };
  var DEFAULT_TYPE_INTEGER = { defaultType: "integer" };
  var DEFAULT_TYPE_DATETIME_DATE = { defaultType: "date-time", allowedTypes: ["date-time", "date"] };
  var DEFAULT_TYPE_DATETIME = { defaultType: "date-time" };
  var DEFAULT_TYPE_URI = { defaultType: "uri" };
  var DEFAULT_TYPE_UTCOFFSET = { defaultType: "utc-offset" };
  var DEFAULT_TYPE_RECUR = { defaultType: "recur" };
  var DEFAULT_TYPE_DATE_ANDOR_TIME = { defaultType: "date-and-or-time", allowedTypes: ["date-time", "date", "text"] };

  function replaceNewlineReplace(string) {
    switch (string) {
      case "\\\\":
        return "\\";
      case "\\;":
        return ";";
      case "\\,":
        return ",";
      case "\\n":
      case "\\N":
        return "\n";
      /* istanbul ignore next */
      default:
        return string;
    }
  }

  function replaceNewline(value, newline, structuredEscape) {
    // avoid regex when possible.
    if (value.indexOf('\\') === -1) {
      return value;
    }
    if (structuredEscape)
      newline = new RegExp(newline.source + '|\\\\' + structuredEscape);
    return value.replace(newline, replaceNewlineReplace);
  }

  var commonProperties = {
    "categories": DEFAULT_TYPE_TEXT_MULTI,
    "url": DEFAULT_TYPE_URI,
    "version": DEFAULT_TYPE_TEXT,
    "uid": DEFAULT_TYPE_TEXT
  };

  var commonValues = {
    "boolean": {
      values: ["TRUE", "FALSE"],

      fromICAL: function(aValue) {
        switch (aValue) {
          case 'TRUE':
            return true;
          case 'FALSE':
            return false;
          default:
            //TODO: parser warning
            return false;
        }
      },

      toICAL: function(aValue) {
        if (aValue) {
          return 'TRUE';
        }
        return 'FALSE';
      }

    },
    float: {
      matches: /^[+-]?\d+\.\d+$/,

      fromICAL: function(aValue) {
        var parsed = parseFloat(aValue);
        if (ICAL.helpers.isStrictlyNaN(parsed)) {
          // TODO: parser warning
          return 0.0;
        }
        return parsed;
      },

      toICAL: function(aValue) {
        return String(aValue);
      }
    },
    integer: {
      fromICAL: function(aValue) {
        var parsed = parseInt(aValue);
        if (ICAL.helpers.isStrictlyNaN(parsed)) {
          return 0;
        }
        return parsed;
      },

      toICAL: function(aValue) {
        return String(aValue);
      }
    },
    "utc-offset": {
      toICAL: function(aValue) {
        if (aValue.length < 7) {
          // no seconds
          // -0500
          return aValue.substr(0, 3) +
                 aValue.substr(4, 2);
        } else {
          // seconds
          // -050000
          return aValue.substr(0, 3) +
                 aValue.substr(4, 2) +
                 aValue.substr(7, 2);
        }
      },

      fromICAL: function(aValue) {
        if (aValue.length < 6) {
          // no seconds
          // -05:00
          return aValue.substr(0, 3) + ':' +
                 aValue.substr(3, 2);
        } else {
          // seconds
          // -05:00:00
          return aValue.substr(0, 3) + ':' +
                 aValue.substr(3, 2) + ':' +
                 aValue.substr(5, 2);
        }
      },

      decorate: function(aValue) {
        return ICAL.UtcOffset.fromString(aValue);
      },

      undecorate: function(aValue) {
        return aValue.toString();
      }
    }
  };

  var icalParams = {
    // Although the syntax is DQUOTE uri DQUOTE, I don't think we should
    // enfoce anything aside from it being a valid content line.
    //
    // At least some params require - if multi values are used - DQUOTEs
    // for each of its values - e.g. delegated-from="uri1","uri2"
    // To indicate this, I introduced the new k/v pair
    // multiValueSeparateDQuote: true
    //
    // "ALTREP": { ... },

    // CN just wants a param-value
    // "CN": { ... }

    "cutype": {
      values: ["INDIVIDUAL", "GROUP", "RESOURCE", "ROOM", "UNKNOWN"],
      allowXName: true,
      allowIanaToken: true
    },

    "delegated-from": {
      valueType: "cal-address",
      multiValue: ",",
      multiValueSeparateDQuote: true
    },
    "delegated-to": {
      valueType: "cal-address",
      multiValue: ",",
      multiValueSeparateDQuote: true
    },
    // "DIR": { ... }, // See ALTREP
    "encoding": {
      values: ["8BIT", "BASE64"]
    },
    // "FMTTYPE": { ... }, // See ALTREP
    "fbtype": {
      values: ["FREE", "BUSY", "BUSY-UNAVAILABLE", "BUSY-TENTATIVE"],
      allowXName: true,
      allowIanaToken: true
    },
    // "LANGUAGE": { ... }, // See ALTREP
    "member": {
      valueType: "cal-address",
      multiValue: ",",
      multiValueSeparateDQuote: true
    },
    "partstat": {
      // TODO These values are actually different per-component
      values: ["NEEDS-ACTION", "ACCEPTED", "DECLINED", "TENTATIVE",
               "DELEGATED", "COMPLETED", "IN-PROCESS"],
      allowXName: true,
      allowIanaToken: true
    },
    "range": {
      values: ["THISANDFUTURE"]
    },
    "related": {
      values: ["START", "END"]
    },
    "reltype": {
      values: ["PARENT", "CHILD", "SIBLING"],
      allowXName: true,
      allowIanaToken: true
    },
    "role": {
      values: ["REQ-PARTICIPANT", "CHAIR",
               "OPT-PARTICIPANT", "NON-PARTICIPANT"],
      allowXName: true,
      allowIanaToken: true
    },
    "rsvp": {
      values: ["TRUE", "FALSE"]
    },
    "sent-by": {
      valueType: "cal-address"
    },
    "tzid": {
      matches: /^\//
    },
    "value": {
      // since the value here is a 'type' lowercase is used.
      values: ["binary", "boolean", "cal-address", "date", "date-time",
               "duration", "float", "integer", "period", "recur", "text",
               "time", "uri", "utc-offset"],
      allowXName: true,
      allowIanaToken: true
    }
  };

  // When adding a value here, be sure to add it to the parameter types!
  var icalValues = ICAL.helpers.extend(commonValues, {
    text: createTextType(FROM_ICAL_NEWLINE, TO_ICAL_NEWLINE),

    uri: {
      // TODO
      /* ... */
    },

    "binary": {
      decorate: function(aString) {
        return ICAL.Binary.fromString(aString);
      },

      undecorate: function(aBinary) {
        return aBinary.toString();
      }
    },
    "cal-address": {
      // needs to be an uri
    },
    "date": {
      decorate: function(aValue, aProp) {
        if (design.strict) {
          return ICAL.Time.fromDateString(aValue, aProp);
        } else {
          return ICAL.Time.fromString(aValue, aProp);
        }
      },

      /**
       * undecorates a time object.
       */
      undecorate: function(aValue) {
        return aValue.toString();
      },

      fromICAL: function(aValue) {
        // from: 20120901
        // to: 2012-09-01
        if (!design.strict && aValue.length >= 15) {
          // This is probably a date-time, e.g. 20120901T130000Z
          return icalValues["date-time"].fromICAL(aValue);
        } else {
          return aValue.substr(0, 4) + '-' +
                 aValue.substr(4, 2) + '-' +
                 aValue.substr(6, 2);
        }
      },

      toICAL: function(aValue) {
        // from: 2012-09-01
        // to: 20120901
        var len = aValue.length;

        if (len == 10) {
          return aValue.substr(0, 4) +
                 aValue.substr(5, 2) +
                 aValue.substr(8, 2);
        } else if (len >= 19) {
          return icalValues["date-time"].toICAL(aValue);
        } else {
          //TODO: serialize warning?
          return aValue;
        }

      }
    },
    "date-time": {
      fromICAL: function(aValue) {
        // from: 20120901T130000
        // to: 2012-09-01T13:00:00
        if (!design.strict && aValue.length == 8) {
          // This is probably a date, e.g. 20120901
          return icalValues.date.fromICAL(aValue);
        } else {
          var result = aValue.substr(0, 4) + '-' +
                       aValue.substr(4, 2) + '-' +
                       aValue.substr(6, 2) + 'T' +
                       aValue.substr(9, 2) + ':' +
                       aValue.substr(11, 2) + ':' +
                       aValue.substr(13, 2);

          if (aValue[15] && aValue[15] === 'Z') {
            result += 'Z';
          }

          return result;
        }
      },

      toICAL: function(aValue) {
        // from: 2012-09-01T13:00:00
        // to: 20120901T130000
        var len = aValue.length;

        if (len == 10 && !design.strict) {
          return icalValues.date.toICAL(aValue);
        } else if (len >= 19) {
          var result = aValue.substr(0, 4) +
                       aValue.substr(5, 2) +
                       // grab the (DDTHH) segment
                       aValue.substr(8, 5) +
                       // MM
                       aValue.substr(14, 2) +
                       // SS
                       aValue.substr(17, 2);

          if (aValue[19] && aValue[19] === 'Z') {
            result += 'Z';
          }
          return result;
        } else {
          // TODO: error
          return aValue;
        }
      },

      decorate: function(aValue, aProp) {
        if (design.strict) {
          return ICAL.Time.fromDateTimeString(aValue, aProp);
        } else {
          return ICAL.Time.fromString(aValue, aProp);
        }
      },

      undecorate: function(aValue) {
        return aValue.toString();
      }
    },
    duration: {
      decorate: function(aValue) {
        return ICAL.Duration.fromString(aValue);
      },
      undecorate: function(aValue) {
        return aValue.toString();
      }
    },
    period: {

      fromICAL: function(string) {
        var parts = string.split('/');
        parts[0] = icalValues['date-time'].fromICAL(parts[0]);

        if (!ICAL.Duration.isValueString(parts[1])) {
          parts[1] = icalValues['date-time'].fromICAL(parts[1]);
        }

        return parts;
      },

      toICAL: function(parts) {
        if (!design.strict && parts[0].length == 10) {
          parts[0] = icalValues.date.toICAL(parts[0]);
        } else {
          parts[0] = icalValues['date-time'].toICAL(parts[0]);
        }

        if (!ICAL.Duration.isValueString(parts[1])) {
          if (!design.strict && parts[1].length == 10) {
            parts[1] = icalValues.date.toICAL(parts[1]);
          } else {
            parts[1] = icalValues['date-time'].toICAL(parts[1]);
          }
        }

        return parts.join("/");
      },

      decorate: function(aValue, aProp) {
        return ICAL.Period.fromJSON(aValue, aProp, !design.strict);
      },

      undecorate: function(aValue) {
        return aValue.toJSON();
      }
    },
    recur: {
      fromICAL: function(string) {
        return ICAL.Recur._stringToData(string, true);
      },

      toICAL: function(data) {
        var str = "";
        for (var k in data) {
          /* istanbul ignore if */
          if (!Object.prototype.hasOwnProperty.call(data, k)) {
            continue;
          }
          var val = data[k];
          if (k == "until") {
            if (val.length > 10) {
              val = icalValues['date-time'].toICAL(val);
            } else {
              val = icalValues.date.toICAL(val);
            }
          } else if (k == "wkst") {
            if (typeof val === 'number') {
              val = ICAL.Recur.numericDayToIcalDay(val);
            }
          } else if (Array.isArray(val)) {
            val = val.join(",");
          }
          str += k.toUpperCase() + "=" + val + ";";
        }
        return str.substr(0, str.length - 1);
      },

      decorate: function decorate(aValue) {
        return ICAL.Recur.fromData(aValue);
      },

      undecorate: function(aRecur) {
        return aRecur.toJSON();
      }
    },

    time: {
      fromICAL: function(aValue) {
        // from: MMHHSS(Z)?
        // to: HH:MM:SS(Z)?
        if (aValue.length < 6) {
          // TODO: parser exception?
          return aValue;
        }

        // HH::MM::SSZ?
        var result = aValue.substr(0, 2) + ':' +
                     aValue.substr(2, 2) + ':' +
                     aValue.substr(4, 2);

        if (aValue[6] === 'Z') {
          result += 'Z';
        }

        return result;
      },

      toICAL: function(aValue) {
        // from: HH:MM:SS(Z)?
        // to: MMHHSS(Z)?
        if (aValue.length < 8) {
          //TODO: error
          return aValue;
        }

        var result = aValue.substr(0, 2) +
                     aValue.substr(3, 2) +
                     aValue.substr(6, 2);

        if (aValue[8] === 'Z') {
          result += 'Z';
        }

        return result;
      }
    }
  });

  var icalProperties = ICAL.helpers.extend(commonProperties, {

    "action": DEFAULT_TYPE_TEXT,
    "attach": { defaultType: "uri" },
    "attendee": { defaultType: "cal-address" },
    "calscale": DEFAULT_TYPE_TEXT,
    "class": DEFAULT_TYPE_TEXT,
    "comment": DEFAULT_TYPE_TEXT,
    "completed": DEFAULT_TYPE_DATETIME,
    "contact": DEFAULT_TYPE_TEXT,
    "created": DEFAULT_TYPE_DATETIME,
    "description": DEFAULT_TYPE_TEXT,
    "dtend": DEFAULT_TYPE_DATETIME_DATE,
    "dtstamp": DEFAULT_TYPE_DATETIME,
    "dtstart": DEFAULT_TYPE_DATETIME_DATE,
    "due": DEFAULT_TYPE_DATETIME_DATE,
    "duration": { defaultType: "duration" },
    "exdate": {
      defaultType: "date-time",
      allowedTypes: ["date-time", "date"],
      multiValue: ','
    },
    "exrule": DEFAULT_TYPE_RECUR,
    "freebusy": { defaultType: "period", multiValue: "," },
    "geo": { defaultType: "float", structuredValue: ";" },
    "last-modified": DEFAULT_TYPE_DATETIME,
    "location": DEFAULT_TYPE_TEXT,
    "method": DEFAULT_TYPE_TEXT,
    "organizer": { defaultType: "cal-address" },
    "percent-complete": DEFAULT_TYPE_INTEGER,
    "priority": DEFAULT_TYPE_INTEGER,
    "prodid": DEFAULT_TYPE_TEXT,
    "related-to": DEFAULT_TYPE_TEXT,
    "repeat": DEFAULT_TYPE_INTEGER,
    "rdate": {
      defaultType: "date-time",
      allowedTypes: ["date-time", "date", "period"],
      multiValue: ',',
      detectType: function(string) {
        if (string.indexOf('/') !== -1) {
          return 'period';
        }
        return (string.indexOf('T') === -1) ? 'date' : 'date-time';
      }
    },
    "recurrence-id": DEFAULT_TYPE_DATETIME_DATE,
    "resources": DEFAULT_TYPE_TEXT_MULTI,
    "request-status": DEFAULT_TYPE_TEXT_STRUCTURED,
    "rrule": DEFAULT_TYPE_RECUR,
    "sequence": DEFAULT_TYPE_INTEGER,
    "status": DEFAULT_TYPE_TEXT,
    "summary": DEFAULT_TYPE_TEXT,
    "transp": DEFAULT_TYPE_TEXT,
    "trigger": { defaultType: "duration", allowedTypes: ["duration", "date-time"] },
    "tzoffsetfrom": DEFAULT_TYPE_UTCOFFSET,
    "tzoffsetto": DEFAULT_TYPE_UTCOFFSET,
    "tzurl": DEFAULT_TYPE_URI,
    "tzid": DEFAULT_TYPE_TEXT,
    "tzname": DEFAULT_TYPE_TEXT
  });

  // When adding a value here, be sure to add it to the parameter types!
  var vcardValues = ICAL.helpers.extend(commonValues, {
    text: createTextType(FROM_VCARD_NEWLINE, TO_VCARD_NEWLINE),
    uri: createTextType(FROM_VCARD_NEWLINE, TO_VCARD_NEWLINE),

    date: {
      decorate: function(aValue) {
        return ICAL.VCardTime.fromDateAndOrTimeString(aValue, "date");
      },
      undecorate: function(aValue) {
        return aValue.toString();
      },
      fromICAL: function(aValue) {
        if (aValue.length == 8) {
          return icalValues.date.fromICAL(aValue);
        } else if (aValue[0] == '-' && aValue.length == 6) {
          return aValue.substr(0, 4) + '-' + aValue.substr(4);
        } else {
          return aValue;
        }
      },
      toICAL: function(aValue) {
        if (aValue.length == 10) {
          return icalValues.date.toICAL(aValue);
        } else if (aValue[0] == '-' && aValue.length == 7) {
          return aValue.substr(0, 4) + aValue.substr(5);
        } else {
          return aValue;
        }
      }
    },

    time: {
      decorate: function(aValue) {
        return ICAL.VCardTime.fromDateAndOrTimeString("T" + aValue, "time");
      },
      undecorate: function(aValue) {
        return aValue.toString();
      },
      fromICAL: function(aValue) {
        var splitzone = vcardValues.time._splitZone(aValue, true);
        var zone = splitzone[0], value = splitzone[1];

        //console.log("SPLIT: ",splitzone);

        if (value.length == 6) {
          value = value.substr(0, 2) + ':' +
                  value.substr(2, 2) + ':' +
                  value.substr(4, 2);
        } else if (value.length == 4 && value[0] != '-') {
          value = value.substr(0, 2) + ':' + value.substr(2, 2);
        } else if (value.length == 5) {
          value = value.substr(0, 3) + ':' + value.substr(3, 2);
        }

        if (zone.length == 5 && (zone[0] == '-' || zone[0] == '+')) {
          zone = zone.substr(0, 3) + ':' + zone.substr(3);
        }

        return value + zone;
      },

      toICAL: function(aValue) {
        var splitzone = vcardValues.time._splitZone(aValue);
        var zone = splitzone[0], value = splitzone[1];

        if (value.length == 8) {
          value = value.substr(0, 2) +
                  value.substr(3, 2) +
                  value.substr(6, 2);
        } else if (value.length == 5 && value[0] != '-') {
          value = value.substr(0, 2) + value.substr(3, 2);
        } else if (value.length == 6) {
          value = value.substr(0, 3) + value.substr(4, 2);
        }

        if (zone.length == 6 && (zone[0] == '-' || zone[0] == '+')) {
          zone = zone.substr(0, 3) + zone.substr(4);
        }

        return value + zone;
      },

      _splitZone: function(aValue, isFromIcal) {
        var lastChar = aValue.length - 1;
        var signChar = aValue.length - (isFromIcal ? 5 : 6);
        var sign = aValue[signChar];
        var zone, value;

        if (aValue[lastChar] == 'Z') {
          zone = aValue[lastChar];
          value = aValue.substr(0, lastChar);
        } else if (aValue.length > 6 && (sign == '-' || sign == '+')) {
          zone = aValue.substr(signChar);
          value = aValue.substr(0, signChar);
        } else {
          zone = "";
          value = aValue;
        }

        return [zone, value];
      }
    },

    "date-time": {
      decorate: function(aValue) {
        return ICAL.VCardTime.fromDateAndOrTimeString(aValue, "date-time");
      },

      undecorate: function(aValue) {
        return aValue.toString();
      },

      fromICAL: function(aValue) {
        return vcardValues['date-and-or-time'].fromICAL(aValue);
      },

      toICAL: function(aValue) {
        return vcardValues['date-and-or-time'].toICAL(aValue);
      }
    },

    "date-and-or-time": {
      decorate: function(aValue) {
        return ICAL.VCardTime.fromDateAndOrTimeString(aValue, "date-and-or-time");
      },

      undecorate: function(aValue) {
        return aValue.toString();
      },

      fromICAL: function(aValue) {
        var parts = aValue.split('T');
        return (parts[0] ? vcardValues.date.fromICAL(parts[0]) : '') +
               (parts[1] ? 'T' + vcardValues.time.fromICAL(parts[1]) : '');
      },

      toICAL: function(aValue) {
        var parts = aValue.split('T');
        return vcardValues.date.toICAL(parts[0]) +
               (parts[1] ? 'T' + vcardValues.time.toICAL(parts[1]) : '');

      }
    },
    timestamp: icalValues['date-time'],
    "language-tag": {
      matches: /^[a-zA-Z0-9-]+$/ // Could go with a more strict regex here
    }
  });

  var vcardParams = {
    "type": {
      valueType: "text",
      multiValue: ","
    },
    "value": {
      // since the value here is a 'type' lowercase is used.
      values: ["text", "uri", "date", "time", "date-time", "date-and-or-time",
               "timestamp", "boolean", "integer", "float", "utc-offset",
               "language-tag"],
      allowXName: true,
      allowIanaToken: true
    }
  };

  var vcardProperties = ICAL.helpers.extend(commonProperties, {
    "adr": { defaultType: "text", structuredValue: ";", multiValue: "," },
    "anniversary": DEFAULT_TYPE_DATE_ANDOR_TIME,
    "bday": DEFAULT_TYPE_DATE_ANDOR_TIME,
    "caladruri": DEFAULT_TYPE_URI,
    "caluri": DEFAULT_TYPE_URI,
    "clientpidmap": DEFAULT_TYPE_TEXT_STRUCTURED,
    "email": DEFAULT_TYPE_TEXT,
    "fburl": DEFAULT_TYPE_URI,
    "fn": DEFAULT_TYPE_TEXT,
    "gender": DEFAULT_TYPE_TEXT_STRUCTURED,
    "geo": DEFAULT_TYPE_URI,
    "impp": DEFAULT_TYPE_URI,
    "key": DEFAULT_TYPE_URI,
    "kind": DEFAULT_TYPE_TEXT,
    "lang": { defaultType: "language-tag" },
    "logo": DEFAULT_TYPE_URI,
    "member": DEFAULT_TYPE_URI,
    "n": { defaultType: "text", structuredValue: ";", multiValue: "," },
    "nickname": DEFAULT_TYPE_TEXT_MULTI,
    "note": DEFAULT_TYPE_TEXT,
    "org": { defaultType: "text", structuredValue: ";" },
    "photo": DEFAULT_TYPE_URI,
    "related": DEFAULT_TYPE_URI,
    "rev": { defaultType: "timestamp" },
    "role": DEFAULT_TYPE_TEXT,
    "sound": DEFAULT_TYPE_URI,
    "source": DEFAULT_TYPE_URI,
    "tel": { defaultType: "uri", allowedTypes: ["uri", "text"] },
    "title": DEFAULT_TYPE_TEXT,
    "tz": { defaultType: "text", allowedTypes: ["text", "utc-offset", "uri"] },
    "xml": DEFAULT_TYPE_TEXT
  });

  var vcard3Values = ICAL.helpers.extend(commonValues, {
    binary: icalValues.binary,
    date: vcardValues.date,
    "date-time": vcardValues["date-time"],
    "phone-number": {
      // TODO
      /* ... */
    },
    uri: icalValues.uri,
    text: icalValues.text,
    time: icalValues.time,
    vcard: icalValues.text,
    "utc-offset": {
      toICAL: function(aValue) {
        return aValue.substr(0, 7);
      },

      fromICAL: function(aValue) {
        return aValue.substr(0, 7);
      },

      decorate: function(aValue) {
        return ICAL.UtcOffset.fromString(aValue);
      },

      undecorate: function(aValue) {
        return aValue.toString();
      }
    }
  });

  var vcard3Params = {
    "type": {
      valueType: "text",
      multiValue: ","
    },
    "value": {
      // since the value here is a 'type' lowercase is used.
      values: ["text", "uri", "date", "date-time", "phone-number", "time",
               "boolean", "integer", "float", "utc-offset", "vcard", "binary"],
      allowXName: true,
      allowIanaToken: true
    }
  };

  var vcard3Properties = ICAL.helpers.extend(commonProperties, {
    fn: DEFAULT_TYPE_TEXT,
    n: { defaultType: "text", structuredValue: ";", multiValue: "," },
    nickname: DEFAULT_TYPE_TEXT_MULTI,
    photo: { defaultType: "binary", allowedTypes: ["binary", "uri"] },
    bday: {
      defaultType: "date-time",
      allowedTypes: ["date-time", "date"],
      detectType: function(string) {
        return (string.indexOf('T') === -1) ? 'date' : 'date-time';
      }
    },

    adr: { defaultType: "text", structuredValue: ";", multiValue: "," },
    label: DEFAULT_TYPE_TEXT,

    tel: { defaultType: "phone-number" },
    email: DEFAULT_TYPE_TEXT,
    mailer: DEFAULT_TYPE_TEXT,

    tz: { defaultType: "utc-offset", allowedTypes: ["utc-offset", "text"] },
    geo: { defaultType: "float", structuredValue: ";" },

    title: DEFAULT_TYPE_TEXT,
    role: DEFAULT_TYPE_TEXT,
    logo: { defaultType: "binary", allowedTypes: ["binary", "uri"] },
    agent: { defaultType: "vcard", allowedTypes: ["vcard", "text", "uri"] },
    org: DEFAULT_TYPE_TEXT_STRUCTURED,

    note: DEFAULT_TYPE_TEXT_MULTI,
    prodid: DEFAULT_TYPE_TEXT,
    rev: {
      defaultType: "date-time",
      allowedTypes: ["date-time", "date"],
      detectType: function(string) {
        return (string.indexOf('T') === -1) ? 'date' : 'date-time';
      }
    },
    "sort-string": DEFAULT_TYPE_TEXT,
    sound: { defaultType: "binary", allowedTypes: ["binary", "uri"] },

    class: DEFAULT_TYPE_TEXT,
    key: { defaultType: "binary", allowedTypes: ["binary", "text"] }
  });

  /**
   * iCalendar design set
   * @type {ICAL.design.designSet}
   */
  var icalSet = {
    value: icalValues,
    param: icalParams,
    property: icalProperties
  };

  /**
   * vCard 4.0 design set
   * @type {ICAL.design.designSet}
   */
  var vcardSet = {
    value: vcardValues,
    param: vcardParams,
    property: vcardProperties
  };

  /**
   * vCard 3.0 design set
   * @type {ICAL.design.designSet}
   */
  var vcard3Set = {
    value: vcard3Values,
    param: vcard3Params,
    property: vcard3Properties
  };

  /**
   * The design data, used by the parser to determine types for properties and
   * other metadata needed to produce correct jCard/jCal data.
   *
   * @alias ICAL.design
   * @namespace
   */
  var design = {
    /**
     * A designSet describes value, parameter and property data. It is used by
     * ther parser and stringifier in components and properties to determine they
     * should be represented.
     *
     * @typedef {Object} designSet
     * @memberOf ICAL.design
     * @property {Object} value       Definitions for value types, keys are type names
     * @property {Object} param       Definitions for params, keys are param names
     * @property {Object} property    Defintions for properties, keys are property names
     */

    /**
     * Can be set to false to make the parser more lenient.
     */
    strict: true,

    /**
     * The default set for new properties and components if none is specified.
     * @type {ICAL.design.designSet}
     */
    defaultSet: icalSet,

    /**
     * The default type for unknown properties
     * @type {String}
     */
    defaultType: 'unknown',

    /**
     * Holds the design set for known top-level components
     *
     * @type {Object}
     * @property {ICAL.design.designSet} vcard       vCard VCARD
     * @property {ICAL.design.designSet} vevent      iCalendar VEVENT
     * @property {ICAL.design.designSet} vtodo       iCalendar VTODO
     * @property {ICAL.design.designSet} vjournal    iCalendar VJOURNAL
     * @property {ICAL.design.designSet} valarm      iCalendar VALARM
     * @property {ICAL.design.designSet} vtimezone   iCalendar VTIMEZONE
     * @property {ICAL.design.designSet} daylight    iCalendar DAYLIGHT
     * @property {ICAL.design.designSet} standard    iCalendar STANDARD
     *
     * @example
     * var propertyName = 'fn';
     * var componentDesign = ICAL.design.components.vcard;
     * var propertyDetails = componentDesign.property[propertyName];
     * if (propertyDetails.defaultType == 'text') {
     *   // Yep, sure is...
     * }
     */
    components: {
      vcard: vcardSet,
      vcard3: vcard3Set,
      vevent: icalSet,
      vtodo: icalSet,
      vjournal: icalSet,
      valarm: icalSet,
      vtimezone: icalSet,
      daylight: icalSet,
      standard: icalSet
    },


    /**
     * The design set for iCalendar (rfc5545/rfc7265) components.
     * @type {ICAL.design.designSet}
     */
    icalendar: icalSet,

    /**
     * The design set for vCard (rfc6350/rfc7095) components.
     * @type {ICAL.design.designSet}
     */
    vcard: vcardSet,

    /**
     * The design set for vCard (rfc2425/rfc2426/rfc7095) components.
     * @type {ICAL.design.designSet}
     */
    vcard3: vcard3Set,

    /**
     * Gets the design set for the given component name.
     *
     * @param {String} componentName        The name of the component
     * @return {ICAL.design.designSet}      The design set for the component
     */
    getDesignSet: function(componentName) {
      var isInDesign = componentName && componentName in design.components;
      return isInDesign ? design.components[componentName] : design.defaultSet;
    }
  };

  return design;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * Contains various functions to convert jCal and jCard data back into
 * iCalendar and vCard.
 * @namespace
 */
ICAL.stringify = (function() {
  'use strict';

  var LINE_ENDING = '\r\n';
  var DEFAULT_VALUE_TYPE = 'unknown';

  var design = ICAL.design;
  var helpers = ICAL.helpers;

  /**
   * Convert a full jCal/jCard array into a iCalendar/vCard string.
   *
   * @function ICAL.stringify
   * @variation function
   * @param {Array} jCal    The jCal/jCard document
   * @return {String}       The stringified iCalendar/vCard document
   */
  function stringify(jCal) {
    if (typeof jCal[0] == "string") {
      // This is a single component
      jCal = [jCal];
    }

    var i = 0;
    var len = jCal.length;
    var result = '';

    for (; i < len; i++) {
      result += stringify.component(jCal[i]) + LINE_ENDING;
    }

    return result;
  }

  /**
   * Converts an jCal component array into a ICAL string.
   * Recursive will resolve sub-components.
   *
   * Exact component/property order is not saved all
   * properties will come before subcomponents.
   *
   * @function ICAL.stringify.component
   * @param {Array} component
   *        jCal/jCard fragment of a component
   * @param {ICAL.design.designSet} designSet
   *        The design data to use for this component
   * @return {String}       The iCalendar/vCard string
   */
  stringify.component = function(component, designSet) {
    var name = component[0].toUpperCase();
    var result = 'BEGIN:' + name + LINE_ENDING;

    var props = component[1];
    var propIdx = 0;
    var propLen = props.length;

    var designSetName = component[0];
    // rfc6350 requires that in vCard 4.0 the first component is the VERSION
    // component with as value 4.0, note that 3.0 does not have this requirement.
    if (designSetName === 'vcard' && component[1].length > 0 &&
            !(component[1][0][0] === "version" && component[1][0][3] === "4.0")) {
      designSetName = "vcard3";
    }
    designSet = designSet || design.getDesignSet(designSetName);

    for (; propIdx < propLen; propIdx++) {
      result += stringify.property(props[propIdx], designSet) + LINE_ENDING;
    }

    // Ignore subcomponents if none exist, e.g. in vCard.
    var comps = component[2] || [];
    var compIdx = 0;
    var compLen = comps.length;

    for (; compIdx < compLen; compIdx++) {
      result += stringify.component(comps[compIdx], designSet) + LINE_ENDING;
    }

    result += 'END:' + name;
    return result;
  };

  /**
   * Converts a single jCal/jCard property to a iCalendar/vCard string.
   *
   * @function ICAL.stringify.property
   * @param {Array} property
   *        jCal/jCard property array
   * @param {ICAL.design.designSet} designSet
   *        The design data to use for this property
   * @param {Boolean} noFold
   *        If true, the line is not folded
   * @return {String}       The iCalendar/vCard string
   */
  stringify.property = function(property, designSet, noFold) {
    var name = property[0].toUpperCase();
    var jsName = property[0];
    var params = property[1];

    var line = name;

    var paramName;
    for (paramName in params) {
      var value = params[paramName];

      /* istanbul ignore else */
      if (params.hasOwnProperty(paramName)) {
        var multiValue = (paramName in designSet.param) && designSet.param[paramName].multiValue;
        if (multiValue && Array.isArray(value)) {
          if (designSet.param[paramName].multiValueSeparateDQuote) {
            multiValue = '"' + multiValue + '"';
          }
          value = value.map(stringify._rfc6868Unescape);
          value = stringify.multiValue(value, multiValue, "unknown", null, designSet);
        } else {
          value = stringify._rfc6868Unescape(value);
        }


        line += ';' + paramName.toUpperCase();
        line += '=' + stringify.propertyValue(value);
      }
    }

    if (property.length === 3) {
      // If there are no values, we must assume a blank value
      return line + ':';
    }

    var valueType = property[2];

    if (!designSet) {
      designSet = design.defaultSet;
    }

    var propDetails;
    var multiValue = false;
    var structuredValue = false;
    var isDefault = false;

    if (jsName in designSet.property) {
      propDetails = designSet.property[jsName];

      if ('multiValue' in propDetails) {
        multiValue = propDetails.multiValue;
      }

      if (('structuredValue' in propDetails) && Array.isArray(property[3])) {
        structuredValue = propDetails.structuredValue;
      }

      if ('defaultType' in propDetails) {
        if (valueType === propDetails.defaultType) {
          isDefault = true;
        }
      } else {
        if (valueType === DEFAULT_VALUE_TYPE) {
          isDefault = true;
        }
      }
    } else {
      if (valueType === DEFAULT_VALUE_TYPE) {
        isDefault = true;
      }
    }

    // push the VALUE property if type is not the default
    // for the current property.
    if (!isDefault) {
      // value will never contain ;/:/, so we don't escape it here.
      line += ';VALUE=' + valueType.toUpperCase();
    }

    line += ':';

    if (multiValue && structuredValue) {
      line += stringify.multiValue(
        property[3], structuredValue, valueType, multiValue, designSet, structuredValue
      );
    } else if (multiValue) {
      line += stringify.multiValue(
        property.slice(3), multiValue, valueType, null, designSet, false
      );
    } else if (structuredValue) {
      line += stringify.multiValue(
        property[3], structuredValue, valueType, null, designSet, structuredValue
      );
    } else {
      line += stringify.value(property[3], valueType, designSet, false);
    }

    return noFold ? line : ICAL.helpers.foldline(line);
  };

  /**
   * Handles escaping of property values that may contain:
   *
   *    COLON (:), SEMICOLON (;), or COMMA (,)
   *
   * If any of the above are present the result is wrapped
   * in double quotes.
   *
   * @function ICAL.stringify.propertyValue
   * @param {String} value      Raw property value
   * @return {String}           Given or escaped value when needed
   */
  stringify.propertyValue = function(value) {

    if ((helpers.unescapedIndexOf(value, ',') === -1) &&
        (helpers.unescapedIndexOf(value, ':') === -1) &&
        (helpers.unescapedIndexOf(value, ';') === -1)) {

      return value;
    }

    return '"' + value + '"';
  };

  /**
   * Converts an array of ical values into a single
   * string based on a type and a delimiter value (like ",").
   *
   * @function ICAL.stringify.multiValue
   * @param {Array} values      List of values to convert
   * @param {String} delim      Used to join the values (",", ";", ":")
   * @param {String} type       Lowecase ical value type
   *        (like boolean, date-time, etc..)
   * @param {?String} innerMulti If set, each value will again be processed
   *        Used for structured values
   * @param {ICAL.design.designSet} designSet
   *        The design data to use for this property
   *
   * @return {String}           iCalendar/vCard string for value
   */
  stringify.multiValue = function(values, delim, type, innerMulti, designSet, structuredValue) {
    var result = '';
    var len = values.length;
    var i = 0;

    for (; i < len; i++) {
      if (innerMulti && Array.isArray(values[i])) {
        result += stringify.multiValue(values[i], innerMulti, type, null, designSet, structuredValue);
      } else {
        result += stringify.value(values[i], type, designSet, structuredValue);
      }

      if (i !== (len - 1)) {
        result += delim;
      }
    }

    return result;
  };

  /**
   * Processes a single ical value runs the associated "toICAL" method from the
   * design value type if available to convert the value.
   *
   * @function ICAL.stringify.value
   * @param {String|Number} value       A formatted value
   * @param {String} type               Lowercase iCalendar/vCard value type
   *  (like boolean, date-time, etc..)
   * @return {String}                   iCalendar/vCard value for single value
   */
  stringify.value = function(value, type, designSet, structuredValue) {
    if (type in designSet.value && 'toICAL' in designSet.value[type]) {
      return designSet.value[type].toICAL(value, structuredValue);
    }
    return value;
  };

  /**
   * Internal helper for rfc6868. Exposing this on ICAL.stringify so that
   * hackers can disable the rfc6868 parsing if the really need to.
   *
   * @param {String} val        The value to unescape
   * @return {String}           The escaped value
   */
  stringify._rfc6868Unescape = function(val) {
    return val.replace(/[\n^"]/g, function(x) {
      return RFC6868_REPLACE_MAP[x];
    });
  };
  var RFC6868_REPLACE_MAP = { '"': "^'", "\n": "^n", "^": "^^" };

  return stringify;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * Contains various functions to parse iCalendar and vCard data.
 * @namespace
 */
ICAL.parse = (function() {
  'use strict';

  var CHAR = /[^ \t]/;
  var MULTIVALUE_DELIMITER = ',';
  var VALUE_DELIMITER = ':';
  var PARAM_DELIMITER = ';';
  var PARAM_NAME_DELIMITER = '=';
  var DEFAULT_VALUE_TYPE = 'unknown';
  var DEFAULT_PARAM_TYPE = 'text';

  var design = ICAL.design;
  var helpers = ICAL.helpers;

  /**
   * An error that occurred during parsing.
   *
   * @param {String} message        The error message
   * @memberof ICAL.parse
   * @extends {Error}
   * @class
   */
  function ParserError(message) {
    this.message = message;
    this.name = 'ParserError';

    try {
      throw new Error();
    } catch (e) {
      if (e.stack) {
        var split = e.stack.split('\n');
        split.shift();
        this.stack = split.join('\n');
      }
    }
  }

  ParserError.prototype = Error.prototype;

  /**
   * Parses iCalendar or vCard data into a raw jCal object. Consult
   * documentation on the {@tutorial layers|layers of parsing} for more
   * details.
   *
   * @function ICAL.parse
   * @variation function
   * @todo Fix the API to be more clear on the return type
   * @param {String} input      The string data to parse
   * @return {Object|Object[]}  A single jCal object, or an array thereof
   */
  function parser(input) {
    var state = {};
    var root = state.component = [];

    state.stack = [root];

    parser._eachLine(input, function(err, line) {
      parser._handleContentLine(line, state);
    });


    // when there are still items on the stack
    // throw a fatal error, a component was not closed
    // correctly in that case.
    if (state.stack.length > 1) {
      throw new ParserError(
        'invalid ical body. component began but did not end'
      );
    }

    state = null;

    return (root.length == 1 ? root[0] : root);
  }

  /**
   * Parse an iCalendar property value into the jCal for a single property
   *
   * @function ICAL.parse.property
   * @param {String} str
   *   The iCalendar property string to parse
   * @param {ICAL.design.designSet=} designSet
   *   The design data to use for this property
   * @return {Object}
   *   The jCal Object containing the property
   */
  parser.property = function(str, designSet) {
    var state = {
      component: [[], []],
      designSet: designSet || design.defaultSet
    };
    parser._handleContentLine(str, state);
    return state.component[1][0];
  };

  /**
   * Convenience method to parse a component. You can use ICAL.parse() directly
   * instead.
   *
   * @function ICAL.parse.component
   * @see ICAL.parse(function)
   * @param {String} str    The iCalendar component string to parse
   * @return {Object}       The jCal Object containing the component
   */
  parser.component = function(str) {
    return parser(str);
  };

  // classes & constants
  parser.ParserError = ParserError;

  /**
   * The state for parsing content lines from an iCalendar/vCard string.
   *
   * @private
   * @memberof ICAL.parse
   * @typedef {Object} parserState
   * @property {ICAL.design.designSet} designSet    The design set to use for parsing
   * @property {ICAL.Component[]} stack             The stack of components being processed
   * @property {ICAL.Component} component           The currently active component
   */


  /**
   * Handles a single line of iCalendar/vCard, updating the state.
   *
   * @private
   * @function ICAL.parse._handleContentLine
   * @param {String} line               The content line to process
   * @param {ICAL.parse.parserState}    The current state of the line parsing
   */
  parser._handleContentLine = function(line, state) {
    // break up the parts of the line
    var valuePos = line.indexOf(VALUE_DELIMITER);
    var paramPos = line.indexOf(PARAM_DELIMITER);

    var lastParamIndex;
    var lastValuePos;

    // name of property or begin/end
    var name;
    var value;
    // params is only overridden if paramPos !== -1.
    // we can't do params = params || {} later on
    // because it sacrifices ops.
    var params = {};

    /**
     * Different property cases
     *
     *
     * 1. RRULE:FREQ=foo
     *    // FREQ= is not a param but the value
     *
     * 2. ATTENDEE;ROLE=REQ-PARTICIPANT;
     *    // ROLE= is a param because : has not happened yet
     */
      // when the parameter delimiter is after the
      // value delimiter then it is not a parameter.

    if ((paramPos !== -1 && valuePos !== -1)) {
      // when the parameter delimiter is after the
      // value delimiter then it is not a parameter.
      if (paramPos > valuePos) {
        paramPos = -1;
      }
    }

    var parsedParams;
    if (paramPos !== -1) {
      name = line.substring(0, paramPos).toLowerCase();
      parsedParams = parser._parseParameters(line.substring(paramPos), 0, state.designSet);
      if (parsedParams[2] == -1) {
        throw new ParserError("Invalid parameters in '" + line + "'");
      }
      params = parsedParams[0];
      lastParamIndex = parsedParams[1].length + parsedParams[2] + paramPos;
      if ((lastValuePos =
        line.substring(lastParamIndex).indexOf(VALUE_DELIMITER)) !== -1) {
        value = line.substring(lastParamIndex + lastValuePos + 1);
      } else {
        throw new ParserError("Missing parameter value in '" + line + "'");
      }
    } else if (valuePos !== -1) {
      // without parmeters (BEGIN:VCAENDAR, CLASS:PUBLIC)
      name = line.substring(0, valuePos).toLowerCase();
      value = line.substring(valuePos + 1);

      if (name === 'begin') {
        var newComponent = [value.toLowerCase(), [], []];
        if (state.stack.length === 1) {
          state.component.push(newComponent);
        } else {
          state.component[2].push(newComponent);
        }
        state.stack.push(state.component);
        state.component = newComponent;
        if (!state.designSet) {
          state.designSet = design.getDesignSet(state.component[0]);
        }
        return;
      } else if (name === 'end') {
        state.component = state.stack.pop();
        return;
      }
      // If it is not begin/end, then this is a property with an empty value,
      // which should be considered valid.
    } else {
      /**
       * Invalid line.
       * The rational to throw an error is we will
       * never be certain that the rest of the file
       * is sane and it is unlikely that we can serialize
       * the result correctly either.
       */
      throw new ParserError(
        'invalid line (no token ";" or ":") "' + line + '"'
      );
    }

    var valueType;
    var multiValue = false;
    var structuredValue = false;
    var propertyDetails;

    if (name in state.designSet.property) {
      propertyDetails = state.designSet.property[name];

      if ('multiValue' in propertyDetails) {
        multiValue = propertyDetails.multiValue;
      }

      if ('structuredValue' in propertyDetails) {
        structuredValue = propertyDetails.structuredValue;
      }

      if (value && 'detectType' in propertyDetails) {
        valueType = propertyDetails.detectType(value);
      }
    }

    // attempt to determine value
    if (!valueType) {
      if (!('value' in params)) {
        if (propertyDetails) {
          valueType = propertyDetails.defaultType;
        } else {
          valueType = DEFAULT_VALUE_TYPE;
        }
      } else {
        // possible to avoid this?
        valueType = params.value.toLowerCase();
      }
    }

    delete params.value;

    /**
     * Note on `var result` juggling:
     *
     * I observed that building the array in pieces has adverse
     * effects on performance, so where possible we inline the creation.
     * It is a little ugly but resulted in ~2000 additional ops/sec.
     */

    var result;
    if (multiValue && structuredValue) {
      value = parser._parseMultiValue(value, structuredValue, valueType, [], multiValue, state.designSet, structuredValue);
      result = [name, params, valueType, value];
    } else if (multiValue) {
      result = [name, params, valueType];
      parser._parseMultiValue(value, multiValue, valueType, result, null, state.designSet, false);
    } else if (structuredValue) {
      value = parser._parseMultiValue(value, structuredValue, valueType, [], null, state.designSet, structuredValue);
      result = [name, params, valueType, value];
    } else {
      value = parser._parseValue(value, valueType, state.designSet, false);
      result = [name, params, valueType, value];
    }
    // rfc6350 requires that in vCard 4.0 the first component is the VERSION
    // component with as value 4.0, note that 3.0 does not have this requirement.
    if (state.component[0] === 'vcard' && state.component[1].length === 0 &&
            !(name === 'version' && value === '4.0')) {
      state.designSet = design.getDesignSet("vcard3");
    }
    state.component[1].push(result);
  };

  /**
   * Parse a value from the raw value into the jCard/jCal value.
   *
   * @private
   * @function ICAL.parse._parseValue
   * @param {String} value          Original value
   * @param {String} type           Type of value
   * @param {Object} designSet      The design data to use for this value
   * @return {Object} varies on type
   */
  parser._parseValue = function(value, type, designSet, structuredValue) {
    if (type in designSet.value && 'fromICAL' in designSet.value[type]) {
      return designSet.value[type].fromICAL(value, structuredValue);
    }
    return value;
  };

  /**
   * Parse parameters from a string to object.
   *
   * @function ICAL.parse._parseParameters
   * @private
   * @param {String} line           A single unfolded line
   * @param {Numeric} start         Position to start looking for properties
   * @param {Object} designSet      The design data to use for this property
   * @return {Object} key/value pairs
   */
  parser._parseParameters = function(line, start, designSet) {
    var lastParam = start;
    var pos = 0;
    var delim = PARAM_NAME_DELIMITER;
    var result = {};
    var name, lcname;
    var value, valuePos = -1;
    var type, multiValue, mvdelim;

    // find the next '=' sign
    // use lastParam and pos to find name
    // check if " is used if so get value from "->"
    // then increment pos to find next ;

    while ((pos !== false) &&
           (pos = helpers.unescapedIndexOf(line, delim, pos + 1)) !== -1) {

      name = line.substr(lastParam + 1, pos - lastParam - 1);
      if (name.length == 0) {
        throw new ParserError("Empty parameter name in '" + line + "'");
      }
      lcname = name.toLowerCase();
      mvdelim = false;
      multiValue = false;

      if (lcname in designSet.param && designSet.param[lcname].valueType) {
        type = designSet.param[lcname].valueType;
      } else {
        type = DEFAULT_PARAM_TYPE;
      }

      if (lcname in designSet.param) {
        multiValue = designSet.param[lcname].multiValue;
        if (designSet.param[lcname].multiValueSeparateDQuote) {
          mvdelim = parser._rfc6868Escape('"' + multiValue + '"');
        }
      }

      var nextChar = line[pos + 1];
      if (nextChar === '"') {
        valuePos = pos + 2;
        pos = helpers.unescapedIndexOf(line, '"', valuePos);
        if (multiValue && pos != -1) {
            var extendedValue = true;
            while (extendedValue) {
              if (line[pos + 1] == multiValue && line[pos + 2] == '"') {
                pos = helpers.unescapedIndexOf(line, '"', pos + 3);
              } else {
                extendedValue = false;
              }
            }
          }
        if (pos === -1) {
          throw new ParserError(
            'invalid line (no matching double quote) "' + line + '"'
          );
        }
        value = line.substr(valuePos, pos - valuePos);
        lastParam = helpers.unescapedIndexOf(line, PARAM_DELIMITER, pos);
        if (lastParam === -1) {
          pos = false;
        }
      } else {
        valuePos = pos + 1;

        // move to next ";"
        var nextPos = helpers.unescapedIndexOf(line, PARAM_DELIMITER, valuePos);
        var propValuePos = helpers.unescapedIndexOf(line, VALUE_DELIMITER, valuePos);
        if (propValuePos !== -1 && nextPos > propValuePos) {
          // this is a delimiter in the property value, let's stop here
          nextPos = propValuePos;
          pos = false;
        } else if (nextPos === -1) {
          // no ";"
          if (propValuePos === -1) {
            nextPos = line.length;
          } else {
            nextPos = propValuePos;
          }
          pos = false;
        } else {
          lastParam = nextPos;
          pos = nextPos;
        }

        value = line.substr(valuePos, nextPos - valuePos);
      }

      value = parser._rfc6868Escape(value);
      if (multiValue) {
        var delimiter = mvdelim || multiValue;
        value = parser._parseMultiValue(value, delimiter, type, [], null, designSet);
      } else {
        value = parser._parseValue(value, type, designSet);
      }

      if (multiValue && (lcname in result)) {
        if (Array.isArray(result[lcname])) {
          result[lcname].push(value);
        } else {
          result[lcname] = [
            result[lcname],
            value
          ];
        }
      } else {
        result[lcname] = value;
      }
    }
    return [result, value, valuePos];
  };

  /**
   * Internal helper for rfc6868. Exposing this on ICAL.parse so that
   * hackers can disable the rfc6868 parsing if the really need to.
   *
   * @function ICAL.parse._rfc6868Escape
   * @param {String} val        The value to escape
   * @return {String}           The escaped value
   */
  parser._rfc6868Escape = function(val) {
    return val.replace(/\^['n^]/g, function(x) {
      return RFC6868_REPLACE_MAP[x];
    });
  };
  var RFC6868_REPLACE_MAP = { "^'": '"', "^n": "\n", "^^": "^" };

  /**
   * Parse a multi value string. This function is used either for parsing
   * actual multi-value property's values, or for handling parameter values. It
   * can be used for both multi-value properties and structured value properties.
   *
   * @private
   * @function ICAL.parse._parseMultiValue
   * @param {String} buffer     The buffer containing the full value
   * @param {String} delim      The multi-value delimiter
   * @param {String} type       The value type to be parsed
   * @param {Array.<?>} result        The array to append results to, varies on value type
   * @param {String} innerMulti The inner delimiter to split each value with
   * @param {ICAL.design.designSet} designSet   The design data for this value
   * @return {?|Array.<?>}            Either an array of results, or the first result
   */
  parser._parseMultiValue = function(buffer, delim, type, result, innerMulti, designSet, structuredValue) {
    var pos = 0;
    var lastPos = 0;
    var value;
    if (delim.length === 0) {
      return buffer;
    }

    // split each piece
    while ((pos = helpers.unescapedIndexOf(buffer, delim, lastPos)) !== -1) {
      value = buffer.substr(lastPos, pos - lastPos);
      if (innerMulti) {
        value = parser._parseMultiValue(value, innerMulti, type, [], null, designSet, structuredValue);
      } else {
        value = parser._parseValue(value, type, designSet, structuredValue);
      }
      result.push(value);
      lastPos = pos + delim.length;
    }

    // on the last piece take the rest of string
    value = buffer.substr(lastPos);
    if (innerMulti) {
      value = parser._parseMultiValue(value, innerMulti, type, [], null, designSet, structuredValue);
    } else {
      value = parser._parseValue(value, type, designSet, structuredValue);
    }
    result.push(value);

    return result.length == 1 ? result[0] : result;
  };

  /**
   * Process a complete buffer of iCalendar/vCard data line by line, correctly
   * unfolding content. Each line will be processed with the given callback
   *
   * @private
   * @function ICAL.parse._eachLine
   * @param {String} buffer                         The buffer to process
   * @param {function(?String, String)} callback    The callback for each line
   */
  parser._eachLine = function(buffer, callback) {
    var len = buffer.length;
    var lastPos = buffer.search(CHAR);
    var pos = lastPos;
    var line;
    var firstChar;

    var newlineOffset;

    do {
      pos = buffer.indexOf('\n', lastPos) + 1;

      if (pos > 1 && buffer[pos - 2] === '\r') {
        newlineOffset = 2;
      } else {
        newlineOffset = 1;
      }

      if (pos === 0) {
        pos = len;
        newlineOffset = 0;
      }

      firstChar = buffer[lastPos];

      if (firstChar === ' ' || firstChar === '\t') {
        // add to line
        line += buffer.substr(
          lastPos + 1,
          pos - lastPos - (newlineOffset + 1)
        );
      } else {
        if (line)
          callback(null, line);
        // push line
        line = buffer.substr(
          lastPos,
          pos - lastPos - newlineOffset
        );
      }

      lastPos = pos;
    } while (pos !== len);

    // extra ending line
    line = line.trim();

    if (line.length)
      callback(null, line);
  };

  return parser;

}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.Component = (function() {
  'use strict';

  var PROPERTY_INDEX = 1;
  var COMPONENT_INDEX = 2;
  var NAME_INDEX = 0;

  /**
   * @classdesc
   * Wraps a jCal component, adding convenience methods to add, remove and
   * update subcomponents and properties.
   *
   * @class
   * @alias ICAL.Component
   * @param {Array|String} jCal         Raw jCal component data OR name of new
   *                                      component
   * @param {ICAL.Component} parent     Parent component to associate
   */
  function Component(jCal, parent) {
    if (typeof(jCal) === 'string') {
      // jCal spec (name, properties, components)
      jCal = [jCal, [], []];
    }

    // mostly for legacy reasons.
    this.jCal = jCal;

    this.parent = parent || null;
  }

  Component.prototype = {
    /**
     * Hydrated properties are inserted into the _properties array at the same
     * position as in the jCal array, so it is possible that the array contains
     * undefined values for unhydrdated properties. To avoid iterating the
     * array when checking if all properties have been hydrated, we save the
     * count here.
     *
     * @type {Number}
     * @private
     */
    _hydratedPropertyCount: 0,

    /**
     * The same count as for _hydratedPropertyCount, but for subcomponents
     *
     * @type {Number}
     * @private
     */
    _hydratedComponentCount: 0,

    /**
     * The name of this component
     * @readonly
     */
    get name() {
      return this.jCal[NAME_INDEX];
    },

    /**
     * The design set for this component, e.g. icalendar vs vcard
     *
     * @type {ICAL.design.designSet}
     * @private
     */
    get _designSet() {
      var parentDesign = this.parent && this.parent._designSet;
      return parentDesign || ICAL.design.getDesignSet(this.name);
    },

    _hydrateComponent: function(index) {
      if (!this._components) {
        this._components = [];
        this._hydratedComponentCount = 0;
      }

      if (this._components[index]) {
        return this._components[index];
      }

      var comp = new Component(
        this.jCal[COMPONENT_INDEX][index],
        this
      );

      this._hydratedComponentCount++;
      return (this._components[index] = comp);
    },

    _hydrateProperty: function(index) {
      if (!this._properties) {
        this._properties = [];
        this._hydratedPropertyCount = 0;
      }

      if (this._properties[index]) {
        return this._properties[index];
      }

      var prop = new ICAL.Property(
        this.jCal[PROPERTY_INDEX][index],
        this
      );

      this._hydratedPropertyCount++;
      return (this._properties[index] = prop);
    },

    /**
     * Finds first sub component, optionally filtered by name.
     *
     * @param {String=} name        Optional name to filter by
     * @return {?ICAL.Component}     The found subcomponent
     */
    getFirstSubcomponent: function(name) {
      if (name) {
        var i = 0;
        var comps = this.jCal[COMPONENT_INDEX];
        var len = comps.length;

        for (; i < len; i++) {
          if (comps[i][NAME_INDEX] === name) {
            var result = this._hydrateComponent(i);
            return result;
          }
        }
      } else {
        if (this.jCal[COMPONENT_INDEX].length) {
          return this._hydrateComponent(0);
        }
      }

      // ensure we return a value (strict mode)
      return null;
    },

    /**
     * Finds all sub components, optionally filtering by name.
     *
     * @param {String=} name            Optional name to filter by
     * @return {ICAL.Component[]}       The found sub components
     */
    getAllSubcomponents: function(name) {
      var jCalLen = this.jCal[COMPONENT_INDEX].length;
      var i = 0;

      if (name) {
        var comps = this.jCal[COMPONENT_INDEX];
        var result = [];

        for (; i < jCalLen; i++) {
          if (name === comps[i][NAME_INDEX]) {
            result.push(
              this._hydrateComponent(i)
            );
          }
        }
        return result;
      } else {
        if (!this._components ||
            (this._hydratedComponentCount !== jCalLen)) {
          for (; i < jCalLen; i++) {
            this._hydrateComponent(i);
          }
        }

        return this._components || [];
      }
    },

    /**
     * Returns true when a named property exists.
     *
     * @param {String} name     The property name
     * @return {Boolean}        True, when property is found
     */
    hasProperty: function(name) {
      var props = this.jCal[PROPERTY_INDEX];
      var len = props.length;

      var i = 0;
      for (; i < len; i++) {
        // 0 is property name
        if (props[i][NAME_INDEX] === name) {
          return true;
        }
      }

      return false;
    },

    /**
     * Finds the first property, optionally with the given name.
     *
     * @param {String=} name        Lowercase property name
     * @return {?ICAL.Property}     The found property
     */
    getFirstProperty: function(name) {
      if (name) {
        var i = 0;
        var props = this.jCal[PROPERTY_INDEX];
        var len = props.length;

        for (; i < len; i++) {
          if (props[i][NAME_INDEX] === name) {
            var result = this._hydrateProperty(i);
            return result;
          }
        }
      } else {
        if (this.jCal[PROPERTY_INDEX].length) {
          return this._hydrateProperty(0);
        }
      }

      return null;
    },

    /**
     * Returns first property's value, if available.
     *
     * @param {String=} name    Lowercase property name
     * @return {?String}        The found property value.
     */
    getFirstPropertyValue: function(name) {
      var prop = this.getFirstProperty(name);
      if (prop) {
        return prop.getFirstValue();
      }

      return null;
    },

    /**
     * Get all properties in the component, optionally filtered by name.
     *
     * @param {String=} name        Lowercase property name
     * @return {ICAL.Property[]}    List of properties
     */
    getAllProperties: function(name) {
      var jCalLen = this.jCal[PROPERTY_INDEX].length;
      var i = 0;

      if (name) {
        var props = this.jCal[PROPERTY_INDEX];
        var result = [];

        for (; i < jCalLen; i++) {
          if (name === props[i][NAME_INDEX]) {
            result.push(
              this._hydrateProperty(i)
            );
          }
        }
        return result;
      } else {
        if (!this._properties ||
            (this._hydratedPropertyCount !== jCalLen)) {
          for (; i < jCalLen; i++) {
            this._hydrateProperty(i);
          }
        }

        return this._properties || [];
      }
    },

    _removeObjectByIndex: function(jCalIndex, cache, index) {
      cache = cache || [];
      // remove cached version
      if (cache[index]) {
        var obj = cache[index];
        if ("parent" in obj) {
            obj.parent = null;
        }
      }

      cache.splice(index, 1);

      // remove it from the jCal
      this.jCal[jCalIndex].splice(index, 1);
    },

    _removeObject: function(jCalIndex, cache, nameOrObject) {
      var i = 0;
      var objects = this.jCal[jCalIndex];
      var len = objects.length;
      var cached = this[cache];

      if (typeof(nameOrObject) === 'string') {
        for (; i < len; i++) {
          if (objects[i][NAME_INDEX] === nameOrObject) {
            this._removeObjectByIndex(jCalIndex, cached, i);
            return true;
          }
        }
      } else if (cached) {
        for (; i < len; i++) {
          if (cached[i] && cached[i] === nameOrObject) {
            this._removeObjectByIndex(jCalIndex, cached, i);
            return true;
          }
        }
      }

      return false;
    },

    _removeAllObjects: function(jCalIndex, cache, name) {
      var cached = this[cache];

      // Unfortunately we have to run through all children to reset their
      // parent property.
      var objects = this.jCal[jCalIndex];
      var i = objects.length - 1;

      // descending search required because splice
      // is used and will effect the indices.
      for (; i >= 0; i--) {
        if (!name || objects[i][NAME_INDEX] === name) {
          this._removeObjectByIndex(jCalIndex, cached, i);
        }
      }
    },

    /**
     * Adds a single sub component.
     *
     * @param {ICAL.Component} component        The component to add
     * @return {ICAL.Component}                 The passed in component
     */
    addSubcomponent: function(component) {
      if (!this._components) {
        this._components = [];
        this._hydratedComponentCount = 0;
      }

      if (component.parent) {
        component.parent.removeSubcomponent(component);
      }

      var idx = this.jCal[COMPONENT_INDEX].push(component.jCal);
      this._components[idx - 1] = component;
      this._hydratedComponentCount++;
      component.parent = this;
      return component;
    },

    /**
     * Removes a single component by name or the instance of a specific
     * component.
     *
     * @param {ICAL.Component|String} nameOrComp    Name of component, or component
     * @return {Boolean}                            True when comp is removed
     */
    removeSubcomponent: function(nameOrComp) {
      var removed = this._removeObject(COMPONENT_INDEX, '_components', nameOrComp);
      if (removed) {
        this._hydratedComponentCount--;
      }
      return removed;
    },

    /**
     * Removes all components or (if given) all components by a particular
     * name.
     *
     * @param {String=} name            Lowercase component name
     */
    removeAllSubcomponents: function(name) {
      var removed = this._removeAllObjects(COMPONENT_INDEX, '_components', name);
      this._hydratedComponentCount = 0;
      return removed;
    },

    /**
     * Adds an {@link ICAL.Property} to the component.
     *
     * @param {ICAL.Property} property      The property to add
     * @return {ICAL.Property}              The passed in property
     */
    addProperty: function(property) {
      if (!(property instanceof ICAL.Property)) {
        throw new TypeError('must instance of ICAL.Property');
      }

      if (!this._properties) {
        this._properties = [];
        this._hydratedPropertyCount = 0;
      }

      if (property.parent) {
        property.parent.removeProperty(property);
      }

      var idx = this.jCal[PROPERTY_INDEX].push(property.jCal);
      this._properties[idx - 1] = property;
      this._hydratedPropertyCount++;
      property.parent = this;
      return property;
    },

    /**
     * Helper method to add a property with a value to the component.
     *
     * @param {String}               name         Property name to add
     * @param {String|Number|Object} value        Property value
     * @return {ICAL.Property}                    The created property
     */
    addPropertyWithValue: function(name, value) {
      var prop = new ICAL.Property(name);
      prop.setValue(value);

      this.addProperty(prop);

      return prop;
    },

    /**
     * Helper method that will update or create a property of the given name
     * and sets its value. If multiple properties with the given name exist,
     * only the first is updated.
     *
     * @param {String}               name         Property name to update
     * @param {String|Number|Object} value        Property value
     * @return {ICAL.Property}                    The created property
     */
    updatePropertyWithValue: function(name, value) {
      var prop = this.getFirstProperty(name);

      if (prop) {
        prop.setValue(value);
      } else {
        prop = this.addPropertyWithValue(name, value);
      }

      return prop;
    },

    /**
     * Removes a single property by name or the instance of the specific
     * property.
     *
     * @param {String|ICAL.Property} nameOrProp     Property name or instance to remove
     * @return {Boolean}                            True, when deleted
     */
    removeProperty: function(nameOrProp) {
      var removed = this._removeObject(PROPERTY_INDEX, '_properties', nameOrProp);
      if (removed) {
        this._hydratedPropertyCount--;
      }
      return removed;
    },

    /**
     * Removes all properties associated with this component, optionally
     * filtered by name.
     *
     * @param {String=} name        Lowercase property name
     * @return {Boolean}            True, when deleted
     */
    removeAllProperties: function(name) {
      var removed = this._removeAllObjects(PROPERTY_INDEX, '_properties', name);
      this._hydratedPropertyCount = 0;
      return removed;
    },

    /**
     * Returns the Object representation of this component. The returned object
     * is a live jCal object and should be cloned if modified.
     * @return {Object}
     */
    toJSON: function() {
      return this.jCal;
    },

    /**
     * The string representation of this component.
     * @return {String}
     */
    toString: function() {
      return ICAL.stringify.component(
        this.jCal, this._designSet
      );
    }
  };

  /**
   * Create an {@link ICAL.Component} by parsing the passed iCalendar string.
   *
   * @param {String} str        The iCalendar string to parse
   */
  Component.fromString = function(str) {
    return new Component(ICAL.parse.component(str));
  };

  return Component;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.Property = (function() {
  'use strict';

  var NAME_INDEX = 0;
  var PROP_INDEX = 1;
  var TYPE_INDEX = 2;
  var VALUE_INDEX = 3;

  var design = ICAL.design;

  /**
   * @classdesc
   * Provides a layer on top of the raw jCal object for manipulating a single
   * property, with its parameters and value.
   *
   * @description
   * It is important to note that mutations done in the wrapper
   * directly mutate the jCal object used to initialize.
   *
   * Can also be used to create new properties by passing
   * the name of the property (as a String).
   *
   * @class
   * @alias ICAL.Property
   * @param {Array|String} jCal         Raw jCal representation OR
   *  the new name of the property
   *
   * @param {ICAL.Component=} parent    Parent component
   */
  function Property(jCal, parent) {
    this._parent = parent || null;

    if (typeof(jCal) === 'string') {
      // We are creating the property by name and need to detect the type
      this.jCal = [jCal, {}, design.defaultType];
      this.jCal[TYPE_INDEX] = this.getDefaultType();
    } else {
      this.jCal = jCal;
    }
    this._updateType();
  }

  Property.prototype = {

    /**
     * The value type for this property
     * @readonly
     * @type {String}
     */
    get type() {
      return this.jCal[TYPE_INDEX];
    },

    /**
     * The name of this property, in lowercase.
     * @readonly
     * @type {String}
     */
    get name() {
      return this.jCal[NAME_INDEX];
    },

    /**
     * The parent component for this property.
     * @type {ICAL.Component}
     */
    get parent() {
      return this._parent;
    },

    set parent(p) {
      // Before setting the parent, check if the design set has changed. If it
      // has, we later need to update the type if it was unknown before.
      var designSetChanged = !this._parent || (p && p._designSet != this._parent._designSet);

      this._parent = p;

      if (this.type == design.defaultType && designSetChanged) {
        this.jCal[TYPE_INDEX] = this.getDefaultType();
        this._updateType();
      }

      return p;
    },

    /**
     * The design set for this property, e.g. icalendar vs vcard
     *
     * @type {ICAL.design.designSet}
     * @private
     */
    get _designSet() {
      return this.parent ? this.parent._designSet : design.defaultSet;
    },

    /**
     * Updates the type metadata from the current jCal type and design set.
     *
     * @private
     */
    _updateType: function() {
      var designSet = this._designSet;

      if (this.type in designSet.value) {
        var designType = designSet.value[this.type];

        if ('decorate' in designSet.value[this.type]) {
          this.isDecorated = true;
        } else {
          this.isDecorated = false;
        }

        if (this.name in designSet.property) {
          this.isMultiValue = ('multiValue' in designSet.property[this.name]);
          this.isStructuredValue = ('structuredValue' in designSet.property[this.name]);
        }
      }
    },

    /**
     * Hydrate a single value. The act of hydrating means turning the raw jCal
     * value into a potentially wrapped object, for example {@link ICAL.Time}.
     *
     * @private
     * @param {Number} index        The index of the value to hydrate
     * @return {Object}             The decorated value.
     */
    _hydrateValue: function(index) {
      if (this._values && this._values[index]) {
        return this._values[index];
      }

      // for the case where there is no value.
      if (this.jCal.length <= (VALUE_INDEX + index)) {
        return null;
      }

      if (this.isDecorated) {
        if (!this._values) {
          this._values = [];
        }
        return (this._values[index] = this._decorate(
          this.jCal[VALUE_INDEX + index]
        ));
      } else {
        return this.jCal[VALUE_INDEX + index];
      }
    },

    /**
     * Decorate a single value, returning its wrapped object. This is used by
     * the hydrate function to actually wrap the value.
     *
     * @private
     * @param {?} value         The value to decorate
     * @return {Object}         The decorated value
     */
    _decorate: function(value) {
      return this._designSet.value[this.type].decorate(value, this);
    },

    /**
     * Undecorate a single value, returning its raw jCal data.
     *
     * @private
     * @param {Object} value         The value to undecorate
     * @return {?}                   The undecorated value
     */
    _undecorate: function(value) {
      return this._designSet.value[this.type].undecorate(value, this);
    },

    /**
     * Sets the value at the given index while also hydrating it. The passed
     * value can either be a decorated or undecorated value.
     *
     * @private
     * @param {?} value             The value to set
     * @param {Number} index        The index to set it at
     */
    _setDecoratedValue: function(value, index) {
      if (!this._values) {
        this._values = [];
      }

      if (typeof(value) === 'object' && 'icaltype' in value) {
        // decorated value
        this.jCal[VALUE_INDEX + index] = this._undecorate(value);
        this._values[index] = value;
      } else {
        // undecorated value
        this.jCal[VALUE_INDEX + index] = value;
        this._values[index] = this._decorate(value);
      }
    },

    /**
     * Gets a parameter on the property.
     *
     * @param {String}        name   Parameter name (lowercase)
     * @return {Array|String}        Parameter value
     */
    getParameter: function(name) {
      if (name in this.jCal[PROP_INDEX]) {
        return this.jCal[PROP_INDEX][name];
      } else {
        return undefined;
      }
    },

    /**
     * Gets first parameter on the property.
     *
     * @param {String}        name   Parameter name (lowercase)
     * @return {String}        Parameter value
     */
    getFirstParameter: function(name) {
      var parameters = this.getParameter(name);

      if (Array.isArray(parameters)) {
        return parameters[0];
      }

      return parameters;
    },

    /**
     * Sets a parameter on the property.
     *
     * @param {String}       name     The parameter name
     * @param {Array|String} value    The parameter value
     */
    setParameter: function(name, value) {
      var lcname = name.toLowerCase();
      if (typeof value === "string" &&
          lcname in this._designSet.param &&
          'multiValue' in this._designSet.param[lcname]) {
          value = [value];
      }
      this.jCal[PROP_INDEX][name] = value;
    },

    /**
     * Removes a parameter
     *
     * @param {String} name     The parameter name
     */
    removeParameter: function(name) {
      delete this.jCal[PROP_INDEX][name];
    },

    /**
     * Get the default type based on this property's name.
     *
     * @return {String}     The default type for this property
     */
    getDefaultType: function() {
      var name = this.jCal[NAME_INDEX];
      var designSet = this._designSet;

      if (name in designSet.property) {
        var details = designSet.property[name];
        if ('defaultType' in details) {
          return details.defaultType;
        }
      }
      return design.defaultType;
    },

    /**
     * Sets type of property and clears out any existing values of the current
     * type.
     *
     * @param {String} type     New iCAL type (see design.*.values)
     */
    resetType: function(type) {
      this.removeAllValues();
      this.jCal[TYPE_INDEX] = type;
      this._updateType();
    },

    /**
     * Finds the first property value.
     *
     * @return {String}         First property value
     */
    getFirstValue: function() {
      return this._hydrateValue(0);
    },

    /**
     * Gets all values on the property.
     *
     * NOTE: this creates an array during each call.
     *
     * @return {Array}          List of values
     */
    getValues: function() {
      var len = this.jCal.length - VALUE_INDEX;

      if (len < 1) {
        // it is possible for a property to have no value.
        return [];
      }

      var i = 0;
      var result = [];

      for (; i < len; i++) {
        result[i] = this._hydrateValue(i);
      }

      return result;
    },

    /**
     * Removes all values from this property
     */
    removeAllValues: function() {
      if (this._values) {
        this._values.length = 0;
      }
      this.jCal.length = 3;
    },

    /**
     * Sets the values of the property.  Will overwrite the existing values.
     * This can only be used for multi-value properties.
     *
     * @param {Array} values    An array of values
     */
    setValues: function(values) {
      if (!this.isMultiValue) {
        throw new Error(
          this.name + ': does not not support mulitValue.\n' +
          'override isMultiValue'
        );
      }

      var len = values.length;
      var i = 0;
      this.removeAllValues();

      if (len > 0 &&
          typeof(values[0]) === 'object' &&
          'icaltype' in values[0]) {
        this.resetType(values[0].icaltype);
      }

      if (this.isDecorated) {
        for (; i < len; i++) {
          this._setDecoratedValue(values[i], i);
        }
      } else {
        for (; i < len; i++) {
          this.jCal[VALUE_INDEX + i] = values[i];
        }
      }
    },

    /**
     * Sets the current value of the property. If this is a multi-value
     * property, all other values will be removed.
     *
     * @param {String|Object} value     New property value.
     */
    setValue: function(value) {
      this.removeAllValues();
      if (typeof(value) === 'object' && 'icaltype' in value) {
        this.resetType(value.icaltype);
      }

      if (this.isDecorated) {
        this._setDecoratedValue(value, 0);
      } else {
        this.jCal[VALUE_INDEX] = value;
      }
    },

    /**
     * Returns the Object representation of this component. The returned object
     * is a live jCal object and should be cloned if modified.
     * @return {Object}
     */
    toJSON: function() {
      return this.jCal;
    },

    /**
     * The string representation of this component.
     * @return {String}
     */
    toICALString: function() {
      return ICAL.stringify.property(
        this.jCal, this._designSet, true
      );
    }
  };

  /**
   * Create an {@link ICAL.Property} by parsing the passed iCalendar string.
   *
   * @param {String} str                        The iCalendar string to parse
   * @param {ICAL.design.designSet=} designSet  The design data to use for this property
   * @return {ICAL.Property}                    The created iCalendar property
   */
  Property.fromString = function(str, designSet) {
    return new Property(ICAL.parse.property(str, designSet));
  };

  return Property;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.UtcOffset = (function() {

  /**
   * @classdesc
   * This class represents the "duration" value type, with various calculation
   * and manipulation methods.
   *
   * @class
   * @alias ICAL.UtcOffset
   * @param {Object} aData          An object with members of the utc offset
   * @param {Number=} aData.hours   The hours for the utc offset
   * @param {Number=} aData.minutes The minutes in the utc offset
   * @param {Number=} aData.factor  The factor for the utc-offset, either -1 or 1
   */
  function UtcOffset(aData) {
    this.fromData(aData);
  }

  UtcOffset.prototype = {

    /**
     * The hours in the utc-offset
     * @type {Number}
     */
    hours: 0,

    /**
     * The minutes in the utc-offset
     * @type {Number}
     */
    minutes: 0,

    /**
     * The sign of the utc offset, 1 for positive offset, -1 for negative
     * offsets.
     * @type {Number}
     */
    factor: 1,

    /**
     * The type name, to be used in the jCal object.
     * @constant
     * @type {String}
     * @default "utc-offset"
     */
    icaltype: "utc-offset",

    /**
     * Returns a clone of the utc offset object.
     *
     * @return {ICAL.UtcOffset}     The cloned object
     */
    clone: function() {
      return ICAL.UtcOffset.fromSeconds(this.toSeconds());
    },

    /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {Object} aData          An object with members of the utc offset
     * @param {Number=} aData.hours   The hours for the utc offset
     * @param {Number=} aData.minutes The minutes in the utc offset
     * @param {Number=} aData.factor  The factor for the utc-offset, either -1 or 1
     */
    fromData: function(aData) {
      if (aData) {
        for (var key in aData) {
          /* istanbul ignore else */
          if (aData.hasOwnProperty(key)) {
            this[key] = aData[key];
          }
        }
      }
      this._normalize();
    },

    /**
     * Sets up the current instance from the given seconds value. The seconds
     * value is truncated to the minute. Offsets are wrapped when the world
     * ends, the hour after UTC+14:00 is UTC-12:00.
     *
     * @param {Number} aSeconds         The seconds to convert into an offset
     */
    fromSeconds: function(aSeconds) {
      var secs = Math.abs(aSeconds);

      this.factor = aSeconds < 0 ? -1 : 1;
      this.hours = ICAL.helpers.trunc(secs / 3600);

      secs -= (this.hours * 3600);
      this.minutes = ICAL.helpers.trunc(secs / 60);
      return this;
    },

    /**
     * Convert the current offset to a value in seconds
     *
     * @return {Number}                 The offset in seconds
     */
    toSeconds: function() {
      return this.factor * (60 * this.minutes + 3600 * this.hours);
    },

    /**
     * Compare this utc offset with another one.
     *
     * @param {ICAL.UtcOffset} other        The other offset to compare with
     * @return {Number}                     -1, 0 or 1 for less/equal/greater
     */
    compare: function icaltime_compare(other) {
      var a = this.toSeconds();
      var b = other.toSeconds();
      return (a > b) - (b > a);
    },

    _normalize: function() {
      // Range: 97200 seconds (with 1 hour inbetween)
      var secs = this.toSeconds();
      var factor = this.factor;
      while (secs < -43200) { // = UTC-12:00
        secs += 97200;
      }
      while (secs > 50400) { // = UTC+14:00
        secs -= 97200;
      }

      this.fromSeconds(secs);

      // Avoid changing the factor when on zero seconds
      if (secs == 0) {
        this.factor = factor;
      }
    },

    /**
     * The iCalendar string representation of this utc-offset.
     * @return {String}
     */
    toICALString: function() {
      return ICAL.design.icalendar.value['utc-offset'].toICAL(this.toString());
    },

    /**
     * The string representation of this utc-offset.
     * @return {String}
     */
    toString: function toString() {
      return (this.factor == 1 ? "+" : "-") +
              ICAL.helpers.pad2(this.hours) + ':' +
              ICAL.helpers.pad2(this.minutes);
    }
  };

  /**
   * Creates a new {@link ICAL.UtcOffset} instance from the passed string.
   *
   * @param {String} aString    The string to parse
   * @return {ICAL.Duration}    The created utc-offset instance
   */
  UtcOffset.fromString = function(aString) {
    // -05:00
    var options = {};
    //TODO: support seconds per rfc5545 ?
    options.factor = (aString[0] === '+') ? 1 : -1;
    options.hours = ICAL.helpers.strictParseInt(aString.substr(1, 2));
    options.minutes = ICAL.helpers.strictParseInt(aString.substr(4, 2));

    return new ICAL.UtcOffset(options);
  };

  /**
   * Creates a new {@link ICAL.UtcOffset} instance from the passed seconds
   * value.
   *
   * @param {Number} aSeconds       The number of seconds to convert
   */
  UtcOffset.fromSeconds = function(aSeconds) {
    var instance = new UtcOffset();
    instance.fromSeconds(aSeconds);
    return instance;
  };

  return UtcOffset;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.Binary = (function() {

  /**
   * @classdesc
   * Represents the BINARY value type, which contains extra methods for
   * encoding and decoding.
   *
   * @class
   * @alias ICAL.Binary
   * @param {String} aValue     The binary data for this value
   */
  function Binary(aValue) {
    this.value = aValue;
  }

  Binary.prototype = {
    /**
     * The type name, to be used in the jCal object.
     * @default "binary"
     * @constant
     */
    icaltype: "binary",

    /**
     * Base64 decode the current value
     *
     * @return {String}         The base64-decoded value
     */
    decodeValue: function decodeValue() {
      return this._b64_decode(this.value);
    },

    /**
     * Encodes the passed parameter with base64 and sets the internal
     * value to the result.
     *
     * @param {String} aValue      The raw binary value to encode
     */
    setEncodedValue: function setEncodedValue(aValue) {
      this.value = this._b64_encode(aValue);
    },

    _b64_encode: function base64_encode(data) {
      // http://kevin.vanzonneveld.net
      // +   original by: Tyler Akins (http://rumkin.com)
      // +   improved by: Bayron Guevara
      // +   improved by: Thunder.m
      // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // +   bugfixed by: Pellentesque Malesuada
      // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // +   improved by: Rafał Kukawski (http://kukawski.pl)
      // *     example 1: base64_encode('Kevin van Zonneveld');
      // *     returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
      // mozilla has this native
      // - but breaks in 2.0.0.12!
      //if (typeof this.window['atob'] == 'function') {
      //    return atob(data);
      //}
      var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ" +
                "abcdefghijklmnopqrstuvwxyz0123456789+/=";
      var o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
        ac = 0,
        enc = "",
        tmp_arr = [];

      if (!data) {
        return data;
      }

      do { // pack three octets into four hexets
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);

        bits = o1 << 16 | o2 << 8 | o3;

        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;

        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
      } while (i < data.length);

      enc = tmp_arr.join('');

      var r = data.length % 3;

      return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);

    },

    _b64_decode: function base64_decode(data) {
      // http://kevin.vanzonneveld.net
      // +   original by: Tyler Akins (http://rumkin.com)
      // +   improved by: Thunder.m
      // +      input by: Aman Gupta
      // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // +   bugfixed by: Onno Marsman
      // +   bugfixed by: Pellentesque Malesuada
      // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // +      input by: Brett Zamir (http://brett-zamir.me)
      // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // *     example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==');
      // *     returns 1: 'Kevin van Zonneveld'
      // mozilla has this native
      // - but breaks in 2.0.0.12!
      //if (typeof this.window['btoa'] == 'function') {
      //    return btoa(data);
      //}
      var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ" +
                "abcdefghijklmnopqrstuvwxyz0123456789+/=";
      var o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
        ac = 0,
        dec = "",
        tmp_arr = [];

      if (!data) {
        return data;
      }

      data += '';

      do { // unpack four hexets into three octets using index points in b64
        h1 = b64.indexOf(data.charAt(i++));
        h2 = b64.indexOf(data.charAt(i++));
        h3 = b64.indexOf(data.charAt(i++));
        h4 = b64.indexOf(data.charAt(i++));

        bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;

        o1 = bits >> 16 & 0xff;
        o2 = bits >> 8 & 0xff;
        o3 = bits & 0xff;

        if (h3 == 64) {
          tmp_arr[ac++] = String.fromCharCode(o1);
        } else if (h4 == 64) {
          tmp_arr[ac++] = String.fromCharCode(o1, o2);
        } else {
          tmp_arr[ac++] = String.fromCharCode(o1, o2, o3);
        }
      } while (i < data.length);

      dec = tmp_arr.join('');

      return dec;
    },

    /**
     * The string representation of this value
     * @return {String}
     */
    toString: function() {
      return this.value;
    }
  };

  /**
   * Creates a binary value from the given string.
   *
   * @param {String} aString        The binary value string
   * @return {ICAL.Binary}          The binary value instance
   */
  Binary.fromString = function(aString) {
    return new Binary(aString);
  };

  return Binary;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */



(function() {
  /**
   * @classdesc
   * This class represents the "period" value type, with various calculation
   * and manipulation methods.
   *
   * @description
   * The passed data object cannot contain both and end date and a duration.
   *
   * @class
   * @param {Object} aData                  An object with members of the period
   * @param {ICAL.Time=} aData.start        The start of the period
   * @param {ICAL.Time=} aData.end          The end of the period
   * @param {ICAL.Duration=} aData.duration The duration of the period
   */
  ICAL.Period = function icalperiod(aData) {
    this.wrappedJSObject = this;

    if (aData && 'start' in aData) {
      if (aData.start && !(aData.start instanceof ICAL.Time)) {
        throw new TypeError('.start must be an instance of ICAL.Time');
      }
      this.start = aData.start;
    }

    if (aData && aData.end && aData.duration) {
      throw new Error('cannot accept both end and duration');
    }

    if (aData && 'end' in aData) {
      if (aData.end && !(aData.end instanceof ICAL.Time)) {
        throw new TypeError('.end must be an instance of ICAL.Time');
      }
      this.end = aData.end;
    }

    if (aData && 'duration' in aData) {
      if (aData.duration && !(aData.duration instanceof ICAL.Duration)) {
        throw new TypeError('.duration must be an instance of ICAL.Duration');
      }
      this.duration = aData.duration;
    }
  };

  ICAL.Period.prototype = {

    /**
     * The start of the period
     * @type {ICAL.Time}
     */
    start: null,

    /**
     * The end of the period
     * @type {ICAL.Time}
     */
    end: null,

    /**
     * The duration of the period
     * @type {ICAL.Duration}
     */
    duration: null,

    /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icalperiod"
     */
    icalclass: "icalperiod",

    /**
     * The type name, to be used in the jCal object.
     * @constant
     * @type {String}
     * @default "period"
     */
    icaltype: "period",

    /**
     * Returns a clone of the duration object.
     *
     * @return {ICAL.Period}      The cloned object
     */
    clone: function() {
      return ICAL.Period.fromData({
        start: this.start ? this.start.clone() : null,
        end: this.end ? this.end.clone() : null,
        duration: this.duration ? this.duration.clone() : null
      });
    },

    /**
     * Calculates the duration of the period, either directly or by subtracting
     * start from end date.
     *
     * @return {ICAL.Duration}      The calculated duration
     */
    getDuration: function duration() {
      if (this.duration) {
        return this.duration;
      } else {
        return this.end.subtractDate(this.start);
      }
    },

    /**
     * Calculates the end date of the period, either directly or by adding
     * duration to start date.
     *
     * @return {ICAL.Time}          The calculated end date
     */
    getEnd: function() {
      if (this.end) {
        return this.end;
      } else {
        var end = this.start.clone();
        end.addDuration(this.duration);
        return end;
      }
    },

    /**
     * The string representation of this period.
     * @return {String}
     */
    toString: function toString() {
      return this.start + "/" + (this.end || this.duration);
    },

    /**
     * The jCal representation of this period type.
     * @return {Object}
     */
    toJSON: function() {
      return [this.start.toString(), (this.end || this.duration).toString()];
    },

    /**
     * The iCalendar string representation of this period.
     * @return {String}
     */
    toICALString: function() {
      return this.start.toICALString() + "/" +
             (this.end || this.duration).toICALString();
    }
  };

  /**
   * Creates a new {@link ICAL.Period} instance from the passed string.
   *
   * @param {String} str            The string to parse
   * @param {ICAL.Property} prop    The property this period will be on
   * @return {ICAL.Period}          The created period instance
   */
  ICAL.Period.fromString = function fromString(str, prop) {
    var parts = str.split('/');

    if (parts.length !== 2) {
      throw new Error(
        'Invalid string value: "' + str + '" must contain a "/" char.'
      );
    }

    var options = {
      start: ICAL.Time.fromDateTimeString(parts[0], prop)
    };

    var end = parts[1];

    if (ICAL.Duration.isValueString(end)) {
      options.duration = ICAL.Duration.fromString(end);
    } else {
      options.end = ICAL.Time.fromDateTimeString(end, prop);
    }

    return new ICAL.Period(options);
  };

  /**
   * Creates a new {@link ICAL.Period} instance from the given data object.
   * The passed data object cannot contain both and end date and a duration.
   *
   * @param {Object} aData                  An object with members of the period
   * @param {ICAL.Time=} aData.start        The start of the period
   * @param {ICAL.Time=} aData.end          The end of the period
   * @param {ICAL.Duration=} aData.duration The duration of the period
   * @return {ICAL.Period}                  The period instance
   */
  ICAL.Period.fromData = function fromData(aData) {
    return new ICAL.Period(aData);
  };

  /**
   * Returns a new period instance from the given jCal data array. The first
   * member is always the start date string, the second member is either a
   * duration or end date string.
   *
   * @param {Array<String,String>} aData    The jCal data array
   * @param {ICAL.Property} aProp           The property this jCal data is on
   * @param {Boolean} aLenient              If true, data value can be both date and date-time
   * @return {ICAL.Period}                  The period instance
   */
  ICAL.Period.fromJSON = function(aData, aProp, aLenient) {
    function fromDateOrDateTimeString(aValue, aProp) {
      if (aLenient) {
        return ICAL.Time.fromString(aValue, aProp);
      } else {
        return ICAL.Time.fromDateTimeString(aValue, aProp);
      }
    }

    if (ICAL.Duration.isValueString(aData[1])) {
      return ICAL.Period.fromData({
        start: fromDateOrDateTimeString(aData[0], aProp),
        duration: ICAL.Duration.fromString(aData[1])
      });
    } else {
      return ICAL.Period.fromData({
        start: fromDateOrDateTimeString(aData[0], aProp),
        end: fromDateOrDateTimeString(aData[1], aProp)
      });
    }
  };
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */



(function() {
  var DURATION_LETTERS = /([PDWHMTS]{1,1})/;

  /**
   * @classdesc
   * This class represents the "duration" value type, with various calculation
   * and manipulation methods.
   *
   * @class
   * @alias ICAL.Duration
   * @param {Object} data               An object with members of the duration
   * @param {Number} data.weeks         Duration in weeks
   * @param {Number} data.days          Duration in days
   * @param {Number} data.hours         Duration in hours
   * @param {Number} data.minutes       Duration in minutes
   * @param {Number} data.seconds       Duration in seconds
   * @param {Boolean} data.isNegative   If true, the duration is negative
   */
  ICAL.Duration = function icalduration(data) {
    this.wrappedJSObject = this;
    this.fromData(data);
  };

  ICAL.Duration.prototype = {
    /**
     * The weeks in this duration
     * @type {Number}
     * @default 0
     */
    weeks: 0,

    /**
     * The days in this duration
     * @type {Number}
     * @default 0
     */
    days: 0,

    /**
     * The days in this duration
     * @type {Number}
     * @default 0
     */
    hours: 0,

    /**
     * The minutes in this duration
     * @type {Number}
     * @default 0
     */
    minutes: 0,

    /**
     * The seconds in this duration
     * @type {Number}
     * @default 0
     */
    seconds: 0,

    /**
     * The seconds in this duration
     * @type {Boolean}
     * @default false
     */
    isNegative: false,

    /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icalduration"
     */
    icalclass: "icalduration",

    /**
     * The type name, to be used in the jCal object.
     * @constant
     * @type {String}
     * @default "duration"
     */
    icaltype: "duration",

    /**
     * Returns a clone of the duration object.
     *
     * @return {ICAL.Duration}      The cloned object
     */
    clone: function clone() {
      return ICAL.Duration.fromData(this);
    },

    /**
     * The duration value expressed as a number of seconds.
     *
     * @return {Number}             The duration value in seconds
     */
    toSeconds: function toSeconds() {
      var seconds = this.seconds + 60 * this.minutes + 3600 * this.hours +
                    86400 * this.days + 7 * 86400 * this.weeks;
      return (this.isNegative ? -seconds : seconds);
    },

    /**
     * Reads the passed seconds value into this duration object. Afterwards,
     * members like {@link ICAL.Duration#days days} and {@link ICAL.Duration#weeks weeks} will be set up
     * accordingly.
     *
     * @param {Number} aSeconds     The duration value in seconds
     * @return {ICAL.Duration}      Returns this instance
     */
    fromSeconds: function fromSeconds(aSeconds) {
      var secs = Math.abs(aSeconds);

      this.isNegative = (aSeconds < 0);
      this.days = ICAL.helpers.trunc(secs / 86400);

      // If we have a flat number of weeks, use them.
      if (this.days % 7 == 0) {
        this.weeks = this.days / 7;
        this.days = 0;
      } else {
        this.weeks = 0;
      }

      secs -= (this.days + 7 * this.weeks) * 86400;

      this.hours = ICAL.helpers.trunc(secs / 3600);
      secs -= this.hours * 3600;

      this.minutes = ICAL.helpers.trunc(secs / 60);
      secs -= this.minutes * 60;

      this.seconds = secs;
      return this;
    },

    /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {Object} aData               An object with members of the duration
     * @param {Number} aData.weeks         Duration in weeks
     * @param {Number} aData.days          Duration in days
     * @param {Number} aData.hours         Duration in hours
     * @param {Number} aData.minutes       Duration in minutes
     * @param {Number} aData.seconds       Duration in seconds
     * @param {Boolean} aData.isNegative   If true, the duration is negative
     */
    fromData: function fromData(aData) {
      var propsToCopy = ["weeks", "days", "hours",
                         "minutes", "seconds", "isNegative"];
      for (var key in propsToCopy) {
        /* istanbul ignore if */
        if (!propsToCopy.hasOwnProperty(key)) {
          continue;
        }
        var prop = propsToCopy[key];
        if (aData && prop in aData) {
          this[prop] = aData[prop];
        } else {
          this[prop] = 0;
        }
      }
    },

    /**
     * Resets the duration instance to the default values, i.e. PT0S
     */
    reset: function reset() {
      this.isNegative = false;
      this.weeks = 0;
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
    },

    /**
     * Compares the duration instance with another one.
     *
     * @param {ICAL.Duration} aOther        The instance to compare with
     * @return {Number}                     -1, 0 or 1 for less/equal/greater
     */
    compare: function compare(aOther) {
      var thisSeconds = this.toSeconds();
      var otherSeconds = aOther.toSeconds();
      return (thisSeconds > otherSeconds) - (thisSeconds < otherSeconds);
    },

    /**
     * Normalizes the duration instance. For example, a duration with a value
     * of 61 seconds will be normalized to 1 minute and 1 second.
     */
    normalize: function normalize() {
      this.fromSeconds(this.toSeconds());
    },

    /**
     * The string representation of this duration.
     * @return {String}
     */
    toString: function toString() {
      if (this.toSeconds() == 0) {
        return "PT0S";
      } else {
        var str = "";
        if (this.isNegative) str += "-";
        str += "P";
        if (this.weeks) str += this.weeks + "W";
        if (this.days) str += this.days + "D";

        if (this.hours || this.minutes || this.seconds) {
          str += "T";
          if (this.hours) str += this.hours + "H";
          if (this.minutes) str += this.minutes + "M";
          if (this.seconds) str += this.seconds + "S";
        }
        return str;
      }
    },

    /**
     * The iCalendar string representation of this duration.
     * @return {String}
     */
    toICALString: function() {
      return this.toString();
    }
  };

  /**
   * Returns a new ICAL.Duration instance from the passed seconds value.
   *
   * @param {Number} aSeconds       The seconds to create the instance from
   * @return {ICAL.Duration}        The newly created duration instance
   */
  ICAL.Duration.fromSeconds = function icalduration_from_seconds(aSeconds) {
    return (new ICAL.Duration()).fromSeconds(aSeconds);
  };

  /**
   * Internal helper function to handle a chunk of a duration.
   *
   * @param {String} letter type of duration chunk
   * @param {String} number numeric value or -/+
   * @param {Object} dict target to assign values to
   */
  function parseDurationChunk(letter, number, object) {
    var type;
    switch (letter) {
      case 'P':
        if (number && number === '-') {
          object.isNegative = true;
        } else {
          object.isNegative = false;
        }
        // period
        break;
      case 'D':
        type = 'days';
        break;
      case 'W':
        type = 'weeks';
        break;
      case 'H':
        type = 'hours';
        break;
      case 'M':
        type = 'minutes';
        break;
      case 'S':
        type = 'seconds';
        break;
      default:
        // Not a valid chunk
        return 0;
    }

    if (type) {
      if (!number && number !== 0) {
        throw new Error(
          'invalid duration value: Missing number before "' + letter + '"'
        );
      }
      var num = parseInt(number, 10);
      if (ICAL.helpers.isStrictlyNaN(num)) {
        throw new Error(
          'invalid duration value: Invalid number "' + number + '" before "' + letter + '"'
        );
      }
      object[type] = num;
    }

    return 1;
  }

  /**
   * Checks if the given string is an iCalendar duration value.
   *
   * @param {String} value      The raw ical value
   * @return {Boolean}          True, if the given value is of the
   *                              duration ical type
   */
  ICAL.Duration.isValueString = function(string) {
    return (string[0] === 'P' || string[1] === 'P');
  };

  /**
   * Creates a new {@link ICAL.Duration} instance from the passed string.
   *
   * @param {String} aStr       The string to parse
   * @return {ICAL.Duration}    The created duration instance
   */
  ICAL.Duration.fromString = function icalduration_from_string(aStr) {
    var pos = 0;
    var dict = Object.create(null);
    var chunks = 0;

    while ((pos = aStr.search(DURATION_LETTERS)) !== -1) {
      var type = aStr[pos];
      var numeric = aStr.substr(0, pos);
      aStr = aStr.substr(pos + 1);

      chunks += parseDurationChunk(type, numeric, dict);
    }

    if (chunks < 2) {
      // There must be at least a chunk with "P" and some unit chunk
      throw new Error(
        'invalid duration value: Not enough duration components in "' + aStr + '"'
      );
    }

    return new ICAL.Duration(dict);
  };

  /**
   * Creates a new ICAL.Duration instance from the given data object.
   *
   * @param {Object} aData               An object with members of the duration
   * @param {Number} aData.weeks         Duration in weeks
   * @param {Number} aData.days          Duration in days
   * @param {Number} aData.hours         Duration in hours
   * @param {Number} aData.minutes       Duration in minutes
   * @param {Number} aData.seconds       Duration in seconds
   * @param {Boolean} aData.isNegative   If true, the duration is negative
   * @return {ICAL.Duration}             The createad duration instance
   */
  ICAL.Duration.fromData = function icalduration_from_data(aData) {
    return new ICAL.Duration(aData);
  };
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2012 */



(function() {
  var OPTIONS = ["tzid", "location", "tznames",
                 "latitude", "longitude"];

  /**
   * @classdesc
   * Timezone representation, created by passing in a tzid and component.
   *
   * @example
   * var vcalendar;
   * var timezoneComp = vcalendar.getFirstSubcomponent('vtimezone');
   * var tzid = timezoneComp.getFirstPropertyValue('tzid');
   *
   * var timezone = new ICAL.Timezone({
   *   component: timezoneComp,
   *   tzid
   * });
   *
   * @class
   * @param {ICAL.Component|Object} data options for class
   * @param {String|ICAL.Component} data.component
   *        If data is a simple object, then this member can be set to either a
   *        string containing the component data, or an already parsed
   *        ICAL.Component
   * @param {String} data.tzid      The timezone identifier
   * @param {String} data.location  The timezone locationw
   * @param {String} data.tznames   An alternative string representation of the
   *                                  timezone
   * @param {Number} data.latitude  The latitude of the timezone
   * @param {Number} data.longitude The longitude of the timezone
   */
  ICAL.Timezone = function icaltimezone(data) {
    this.wrappedJSObject = this;
    this.fromData(data);
  };

  ICAL.Timezone.prototype = {

    /**
     * Timezone identifier
     * @type {String}
     */
    tzid: "",

    /**
     * Timezone location
     * @type {String}
     */
    location: "",

    /**
     * Alternative timezone name, for the string representation
     * @type {String}
     */
    tznames: "",

    /**
     * The primary latitude for the timezone.
     * @type {Number}
     */
    latitude: 0.0,

    /**
     * The primary longitude for the timezone.
     * @type {Number}
     */
    longitude: 0.0,

    /**
     * The vtimezone component for this timezone.
     * @type {ICAL.Component}
     */
    component: null,

    /**
     * The year this timezone has been expanded to. All timezone transition
     * dates until this year are known and can be used for calculation
     *
     * @private
     * @type {Number}
     */
    expandedUntilYear: 0,

    /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icaltimezone"
     */
    icalclass: "icaltimezone",

    /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {ICAL.Component|Object} aData options for class
     * @param {String|ICAL.Component} aData.component
     *        If aData is a simple object, then this member can be set to either a
     *        string containing the component data, or an already parsed
     *        ICAL.Component
     * @param {String} aData.tzid      The timezone identifier
     * @param {String} aData.location  The timezone locationw
     * @param {String} aData.tznames   An alternative string representation of the
     *                                  timezone
     * @param {Number} aData.latitude  The latitude of the timezone
     * @param {Number} aData.longitude The longitude of the timezone
     */
    fromData: function fromData(aData) {
      this.expandedUntilYear = 0;
      this.changes = [];

      if (aData instanceof ICAL.Component) {
        // Either a component is passed directly
        this.component = aData;
      } else {
        // Otherwise the component may be in the data object
        if (aData && "component" in aData) {
          if (typeof aData.component == "string") {
            // If a string was passed, parse it as a component
            var jCal = ICAL.parse(aData.component);
            this.component = new ICAL.Component(jCal);
          } else if (aData.component instanceof ICAL.Component) {
            // If it was a component already, then just set it
            this.component = aData.component;
          } else {
            // Otherwise just null out the component
            this.component = null;
          }
        }

        // Copy remaining passed properties
        for (var key in OPTIONS) {
          /* istanbul ignore else */
          if (OPTIONS.hasOwnProperty(key)) {
            var prop = OPTIONS[key];
            if (aData && prop in aData) {
              this[prop] = aData[prop];
            }
          }
        }
      }

      // If we have a component but no TZID, attempt to get it from the
      // component's properties.
      if (this.component instanceof ICAL.Component && !this.tzid) {
        this.tzid = this.component.getFirstPropertyValue('tzid');
      }

      return this;
    },

    /**
     * Finds the utcOffset the given time would occur in this timezone.
     *
     * @param {ICAL.Time} tt        The time to check for
     * @return {Number} utc offset in seconds
     */
    utcOffset: function utcOffset(tt) {
      if (this == ICAL.Timezone.utcTimezone || this == ICAL.Timezone.localTimezone) {
        return 0;
      }

      this._ensureCoverage(tt.year);

      if (!this.changes.length) {
        return 0;
      }

      var tt_change = {
        year: tt.year,
        month: tt.month,
        day: tt.day,
        hour: tt.hour,
        minute: tt.minute,
        second: tt.second
      };

      var change_num = this._findNearbyChange(tt_change);
      var change_num_to_use = -1;
      var step = 1;

      // TODO: replace with bin search?
      for (;;) {
        var change = ICAL.helpers.clone(this.changes[change_num], true);
        if (change.utcOffset < change.prevUtcOffset) {
          ICAL.Timezone.adjust_change(change, 0, 0, 0, change.utcOffset);
        } else {
          ICAL.Timezone.adjust_change(change, 0, 0, 0,
                                          change.prevUtcOffset);
        }

        var cmp = ICAL.Timezone._compare_change_fn(tt_change, change);

        if (cmp >= 0) {
          change_num_to_use = change_num;
        } else {
          step = -1;
        }

        if (step == -1 && change_num_to_use != -1) {
          break;
        }

        change_num += step;

        if (change_num < 0) {
          return 0;
        }

        if (change_num >= this.changes.length) {
          break;
        }
      }

      var zone_change = this.changes[change_num_to_use];
      var utcOffset_change = zone_change.utcOffset - zone_change.prevUtcOffset;

      if (utcOffset_change < 0 && change_num_to_use > 0) {
        var tmp_change = ICAL.helpers.clone(zone_change, true);
        ICAL.Timezone.adjust_change(tmp_change, 0, 0, 0,
                                        tmp_change.prevUtcOffset);

        if (ICAL.Timezone._compare_change_fn(tt_change, tmp_change) < 0) {
          var prev_zone_change = this.changes[change_num_to_use - 1];

          var want_daylight = false; // TODO

          if (zone_change.is_daylight != want_daylight &&
              prev_zone_change.is_daylight == want_daylight) {
            zone_change = prev_zone_change;
          }
        }
      }

      // TODO return is_daylight?
      return zone_change.utcOffset;
    },

    _findNearbyChange: function icaltimezone_find_nearby_change(change) {
      // find the closest match
      var idx = ICAL.helpers.binsearchInsert(
        this.changes,
        change,
        ICAL.Timezone._compare_change_fn
      );

      if (idx >= this.changes.length) {
        return this.changes.length - 1;
      }

      return idx;
    },

    _ensureCoverage: function(aYear) {
      if (ICAL.Timezone._minimumExpansionYear == -1) {
        var today = ICAL.Time.now();
        ICAL.Timezone._minimumExpansionYear = today.year;
      }

      var changesEndYear = aYear;
      if (changesEndYear < ICAL.Timezone._minimumExpansionYear) {
        changesEndYear = ICAL.Timezone._minimumExpansionYear;
      }

      changesEndYear += ICAL.Timezone.EXTRA_COVERAGE;

      if (changesEndYear > ICAL.Timezone.MAX_YEAR) {
        changesEndYear = ICAL.Timezone.MAX_YEAR;
      }

      if (!this.changes.length || this.expandedUntilYear < aYear) {
        var subcomps = this.component.getAllSubcomponents();
        var compLen = subcomps.length;
        var compIdx = 0;

        for (; compIdx < compLen; compIdx++) {
          this._expandComponent(
            subcomps[compIdx], changesEndYear, this.changes
          );
        }

        this.changes.sort(ICAL.Timezone._compare_change_fn);
        this.expandedUntilYear = changesEndYear;
      }
    },

    _expandComponent: function(aComponent, aYear, changes) {
      if (!aComponent.hasProperty("dtstart") ||
          !aComponent.hasProperty("tzoffsetto") ||
          !aComponent.hasProperty("tzoffsetfrom")) {
        return null;
      }

      var dtstart = aComponent.getFirstProperty("dtstart").getFirstValue();
      var change;

      function convert_tzoffset(offset) {
        return offset.factor * (offset.hours * 3600 + offset.minutes * 60);
      }

      function init_changes() {
        var changebase = {};
        changebase.is_daylight = (aComponent.name == "daylight");
        changebase.utcOffset = convert_tzoffset(
          aComponent.getFirstProperty("tzoffsetto").getFirstValue()
        );

        changebase.prevUtcOffset = convert_tzoffset(
          aComponent.getFirstProperty("tzoffsetfrom").getFirstValue()
        );

        return changebase;
      }

      if (!aComponent.hasProperty("rrule") && !aComponent.hasProperty("rdate")) {
        change = init_changes();
        change.year = dtstart.year;
        change.month = dtstart.month;
        change.day = dtstart.day;
        change.hour = dtstart.hour;
        change.minute = dtstart.minute;
        change.second = dtstart.second;

        ICAL.Timezone.adjust_change(change, 0, 0, 0,
                                        -change.prevUtcOffset);
        changes.push(change);
      } else {
        var props = aComponent.getAllProperties("rdate");
        for (var rdatekey in props) {
          /* istanbul ignore if */
          if (!props.hasOwnProperty(rdatekey)) {
            continue;
          }
          var rdate = props[rdatekey];
          var time = rdate.getFirstValue();
          change = init_changes();

          change.year = time.year;
          change.month = time.month;
          change.day = time.day;

          if (time.isDate) {
            change.hour = dtstart.hour;
            change.minute = dtstart.minute;
            change.second = dtstart.second;

            if (dtstart.zone != ICAL.Timezone.utcTimezone) {
              ICAL.Timezone.adjust_change(change, 0, 0, 0,
                                              -change.prevUtcOffset);
            }
          } else {
            change.hour = time.hour;
            change.minute = time.minute;
            change.second = time.second;

            if (time.zone != ICAL.Timezone.utcTimezone) {
              ICAL.Timezone.adjust_change(change, 0, 0, 0,
                                              -change.prevUtcOffset);
            }
          }

          changes.push(change);
        }

        var rrule = aComponent.getFirstProperty("rrule");

        if (rrule) {
          rrule = rrule.getFirstValue();
          change = init_changes();

          if (rrule.until && rrule.until.zone == ICAL.Timezone.utcTimezone) {
            rrule.until.adjust(0, 0, 0, change.prevUtcOffset);
            rrule.until.zone = ICAL.Timezone.localTimezone;
          }

          var iterator = rrule.iterator(dtstart);

          var occ;
          while ((occ = iterator.next())) {
            change = init_changes();
            if (occ.year > aYear || !occ) {
              break;
            }

            change.year = occ.year;
            change.month = occ.month;
            change.day = occ.day;
            change.hour = occ.hour;
            change.minute = occ.minute;
            change.second = occ.second;
            change.isDate = occ.isDate;

            ICAL.Timezone.adjust_change(change, 0, 0, 0,
                                            -change.prevUtcOffset);
            changes.push(change);
          }
        }
      }

      return changes;
    },

    /**
     * The string representation of this timezone.
     * @return {String}
     */
    toString: function toString() {
      return (this.tznames ? this.tznames : this.tzid);
    }
  };

  ICAL.Timezone._compare_change_fn = function icaltimezone_compare_change_fn(a, b) {
    if (a.year < b.year) return -1;
    else if (a.year > b.year) return 1;

    if (a.month < b.month) return -1;
    else if (a.month > b.month) return 1;

    if (a.day < b.day) return -1;
    else if (a.day > b.day) return 1;

    if (a.hour < b.hour) return -1;
    else if (a.hour > b.hour) return 1;

    if (a.minute < b.minute) return -1;
    else if (a.minute > b.minute) return 1;

    if (a.second < b.second) return -1;
    else if (a.second > b.second) return 1;

    return 0;
  };

  /**
   * Convert the date/time from one zone to the next.
   *
   * @param {ICAL.Time} tt                  The time to convert
   * @param {ICAL.Timezone} from_zone       The source zone to convert from
   * @param {ICAL.Timezone} to_zone         The target zone to convert to
   * @return {ICAL.Time}                    The converted date/time object
   */
  ICAL.Timezone.convert_time = function icaltimezone_convert_time(tt, from_zone, to_zone) {
    if (tt.isDate ||
        from_zone.tzid == to_zone.tzid ||
        from_zone == ICAL.Timezone.localTimezone ||
        to_zone == ICAL.Timezone.localTimezone) {
      tt.zone = to_zone;
      return tt;
    }

    var utcOffset = from_zone.utcOffset(tt);
    tt.adjust(0, 0, 0, - utcOffset);

    utcOffset = to_zone.utcOffset(tt);
    tt.adjust(0, 0, 0, utcOffset);

    return null;
  };

  /**
   * Creates a new ICAL.Timezone instance from the passed data object.
   *
   * @param {ICAL.Component|Object} aData options for class
   * @param {String|ICAL.Component} aData.component
   *        If aData is a simple object, then this member can be set to either a
   *        string containing the component data, or an already parsed
   *        ICAL.Component
   * @param {String} aData.tzid      The timezone identifier
   * @param {String} aData.location  The timezone locationw
   * @param {String} aData.tznames   An alternative string representation of the
   *                                  timezone
   * @param {Number} aData.latitude  The latitude of the timezone
   * @param {Number} aData.longitude The longitude of the timezone
   */
  ICAL.Timezone.fromData = function icaltimezone_fromData(aData) {
    var tt = new ICAL.Timezone();
    return tt.fromData(aData);
  };

  /**
   * The instance describing the UTC timezone
   * @type {ICAL.Timezone}
   * @constant
   * @instance
   */
  ICAL.Timezone.utcTimezone = ICAL.Timezone.fromData({
    tzid: "UTC"
  });

  /**
   * The instance describing the local timezone
   * @type {ICAL.Timezone}
   * @constant
   * @instance
   */
  ICAL.Timezone.localTimezone = ICAL.Timezone.fromData({
    tzid: "floating"
  });

  /**
   * Adjust a timezone change object.
   * @private
   * @param {Object} change     The timezone change object
   * @param {Number} days       The extra amount of days
   * @param {Number} hours      The extra amount of hours
   * @param {Number} minutes    The extra amount of minutes
   * @param {Number} seconds    The extra amount of seconds
   */
  ICAL.Timezone.adjust_change = function icaltimezone_adjust_change(change, days, hours, minutes, seconds) {
    return ICAL.Time.prototype.adjust.call(
      change,
      days,
      hours,
      minutes,
      seconds,
      change
    );
  };

  ICAL.Timezone._minimumExpansionYear = -1;
  ICAL.Timezone.MAX_YEAR = 2035; // TODO this is because of time_t, which we don't need. Still usefull?
  ICAL.Timezone.EXTRA_COVERAGE = 5;
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.TimezoneService = (function() {
  var zones;

  /**
   * @classdesc
   * Singleton class to contain timezones.  Right now it is all manual registry in
   * the future we may use this class to download timezone information or handle
   * loading pre-expanded timezones.
   *
   * @namespace
   * @alias ICAL.TimezoneService
   */
  var TimezoneService = {
    get count() {
      return Object.keys(zones).length;
    },

    reset: function() {
      zones = Object.create(null);
      var utc = ICAL.Timezone.utcTimezone;

      zones.Z = utc;
      zones.UTC = utc;
      zones.GMT = utc;
    },

    /**
     * Checks if timezone id has been registered.
     *
     * @param {String} tzid     Timezone identifier (e.g. America/Los_Angeles)
     * @return {Boolean}        False, when not present
     */
    has: function(tzid) {
      return !!zones[tzid];
    },

    /**
     * Returns a timezone by its tzid if present.
     *
     * @param {String} tzid     Timezone identifier (e.g. America/Los_Angeles)
     * @return {?ICAL.Timezone} The timezone, or null if not found
     */
    get: function(tzid) {
      return zones[tzid];
    },

    /**
     * Registers a timezone object or component.
     *
     * @param {String=} name
     *        The name of the timezone. Defaults to the component's TZID if not
     *        passed.
     * @param {ICAL.Component|ICAL.Timezone} zone
     *        The initialized zone or vtimezone.
     */
    register: function(name, timezone) {
      if (name instanceof ICAL.Component) {
        if (name.name === 'vtimezone') {
          timezone = new ICAL.Timezone(name);
          name = timezone.tzid;
        }
      }

      if (timezone instanceof ICAL.Timezone) {
        zones[name] = timezone;
      } else {
        throw new TypeError('timezone must be ICAL.Timezone or ICAL.Component');
      }
    },

    /**
     * Removes a timezone by its tzid from the list.
     *
     * @param {String} tzid     Timezone identifier (e.g. America/Los_Angeles)
     * @return {?ICAL.Timezone} The removed timezone, or null if not registered
     */
    remove: function(tzid) {
      return (delete zones[tzid]);
    }
  };

  // initialize defaults
  TimezoneService.reset();

  return TimezoneService;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */



(function() {

  /**
   * @classdesc
   * iCalendar Time representation (similar to JS Date object).  Fully
   * independent of system (OS) timezone / time.  Unlike JS Date, the month
   * January is 1, not zero.
   *
   * @example
   * var time = new ICAL.Time({
   *   year: 2012,
   *   month: 10,
   *   day: 11
   *   minute: 0,
   *   second: 0,
   *   isDate: false
   * });
   *
   *
   * @alias ICAL.Time
   * @class
   * @param {Object} data           Time initialization
   * @param {Number=} data.year     The year for this date
   * @param {Number=} data.month    The month for this date
   * @param {Number=} data.day      The day for this date
   * @param {Number=} data.hour     The hour for this date
   * @param {Number=} data.minute   The minute for this date
   * @param {Number=} data.second   The second for this date
   * @param {Boolean=} data.isDate  If true, the instance represents a date (as
   *                                  opposed to a date-time)
   * @param {ICAL.Timezone} zone timezone this position occurs in
   */
  ICAL.Time = function icaltime(data, zone) {
    this.wrappedJSObject = this;
    var time = this._time = Object.create(null);

    /* time defaults */
    time.year = 0;
    time.month = 1;
    time.day = 1;
    time.hour = 0;
    time.minute = 0;
    time.second = 0;
    time.isDate = false;

    this.fromData(data, zone);
  };

  ICAL.Time._dowCache = {};
  ICAL.Time._wnCache = {};

  ICAL.Time.prototype = {

    /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icaltime"
     */
    icalclass: "icaltime",
    _cachedUnixTime: null,

    /**
     * The type name, to be used in the jCal object. This value may change and
     * is strictly defined by the {@link ICAL.Time#isDate isDate} member.
     * @readonly
     * @type {String}
     * @default "date-time"
     */
    get icaltype() {
      return this.isDate ? 'date' : 'date-time';
    },

    /**
     * The timezone for this time.
     * @type {ICAL.Timezone}
     */
    zone: null,

    /**
     * Internal uses to indicate that a change has been made and the next read
     * operation must attempt to normalize the value (for example changing the
     * day to 33).
     *
     * @type {Boolean}
     * @private
     */
    _pendingNormalization: false,

    /**
     * Returns a clone of the time object.
     *
     * @return {ICAL.Time}              The cloned object
     */
    clone: function() {
      return new ICAL.Time(this._time, this.zone);
    },

    /**
     * Reset the time instance to epoch time
     */
    reset: function icaltime_reset() {
      this.fromData(ICAL.Time.epochTime);
      this.zone = ICAL.Timezone.utcTimezone;
    },

    /**
     * Reset the time instance to the given date/time values.
     *
     * @param {Number} year             The year to set
     * @param {Number} month            The month to set
     * @param {Number} day              The day to set
     * @param {Number} hour             The hour to set
     * @param {Number} minute           The minute to set
     * @param {Number} second           The second to set
     * @param {ICAL.Timezone} timezone  The timezone to set
     */
    resetTo: function icaltime_resetTo(year, month, day,
                                       hour, minute, second, timezone) {
      this.fromData({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        zone: timezone
      });
    },

    /**
     * Set up the current instance from the Javascript date value.
     *
     * @param {?Date} aDate     The Javascript Date to read, or null to reset
     * @param {Boolean} useUTC  If true, the UTC values of the date will be used
     */
    fromJSDate: function icaltime_fromJSDate(aDate, useUTC) {
      if (!aDate) {
        this.reset();
      } else {
        if (useUTC) {
          this.zone = ICAL.Timezone.utcTimezone;
          this.year = aDate.getUTCFullYear();
          this.month = aDate.getUTCMonth() + 1;
          this.day = aDate.getUTCDate();
          this.hour = aDate.getUTCHours();
          this.minute = aDate.getUTCMinutes();
          this.second = aDate.getUTCSeconds();
        } else {
          this.zone = ICAL.Timezone.localTimezone;
          this.year = aDate.getFullYear();
          this.month = aDate.getMonth() + 1;
          this.day = aDate.getDate();
          this.hour = aDate.getHours();
          this.minute = aDate.getMinutes();
          this.second = aDate.getSeconds();
        }
      }
      this._cachedUnixTime = null;
      return this;
    },

    /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {Object} aData            Time initialization
     * @param {Number=} aData.year      The year for this date
     * @param {Number=} aData.month     The month for this date
     * @param {Number=} aData.day       The day for this date
     * @param {Number=} aData.hour      The hour for this date
     * @param {Number=} aData.minute    The minute for this date
     * @param {Number=} aData.second    The second for this date
     * @param {Boolean=} aData.isDate   If true, the instance represents a date
     *                                    (as opposed to a date-time)
     * @param {ICAL.Timezone=} aZone    Timezone this position occurs in
     */
    fromData: function fromData(aData, aZone) {
      if (aData) {
        for (var key in aData) {
          /* istanbul ignore else */
          if (Object.prototype.hasOwnProperty.call(aData, key)) {
            // ical type cannot be set
            if (key === 'icaltype') continue;
            this[key] = aData[key];
          }
        }
      }

      if (aZone) {
        this.zone = aZone;
      }

      if (aData && !("isDate" in aData)) {
        this.isDate = !("hour" in aData);
      } else if (aData && ("isDate" in aData)) {
        this.isDate = aData.isDate;
      }

      if (aData && "timezone" in aData) {
        var zone = ICAL.TimezoneService.get(
          aData.timezone
        );

        this.zone = zone || ICAL.Timezone.localTimezone;
      }

      if (aData && "zone" in aData) {
        this.zone = aData.zone;
      }

      if (!this.zone) {
        this.zone = ICAL.Timezone.localTimezone;
      }

      this._cachedUnixTime = null;
      return this;
    },

    /**
     * Calculate the day of week.
     * @param {ICAL.Time.weekDay=} aWeekStart
     *        The week start weekday, defaults to SUNDAY
     * @return {ICAL.Time.weekDay}
     */
    dayOfWeek: function icaltime_dayOfWeek(aWeekStart) {
      var firstDow = aWeekStart || ICAL.Time.SUNDAY;
      var dowCacheKey = (this.year << 12) + (this.month << 8) + (this.day << 3) + firstDow;
      if (dowCacheKey in ICAL.Time._dowCache) {
        return ICAL.Time._dowCache[dowCacheKey];
      }

      // Using Zeller's algorithm
      var q = this.day;
      var m = this.month + (this.month < 3 ? 12 : 0);
      var Y = this.year - (this.month < 3 ? 1 : 0);

      var h = (q + Y + ICAL.helpers.trunc(((m + 1) * 26) / 10) + ICAL.helpers.trunc(Y / 4));
      /* istanbul ignore else */
      if (true /* gregorian */) {
        h += ICAL.helpers.trunc(Y / 100) * 6 + ICAL.helpers.trunc(Y / 400);
      } else {
        h += 5;
      }

      // Normalize to 1 = wkst
      h = ((h + 7 - firstDow) % 7) + 1;
      ICAL.Time._dowCache[dowCacheKey] = h;
      return h;
    },

    /**
     * Calculate the day of year.
     * @return {Number}
     */
    dayOfYear: function dayOfYear() {
      var is_leap = (ICAL.Time.isLeapYear(this.year) ? 1 : 0);
      var diypm = ICAL.Time.daysInYearPassedMonth;
      return diypm[is_leap][this.month - 1] + this.day;
    },

    /**
     * Returns a copy of the current date/time, rewound to the start of the
     * week. The resulting ICAL.Time instance is of icaltype date, even if this
     * is a date-time.
     *
     * @param {ICAL.Time.weekDay=} aWeekStart
     *        The week start weekday, defaults to SUNDAY
     * @return {ICAL.Time}      The start of the week (cloned)
     */
    startOfWeek: function startOfWeek(aWeekStart) {
      var firstDow = aWeekStart || ICAL.Time.SUNDAY;
      var result = this.clone();
      result.day -= ((this.dayOfWeek() + 7 - firstDow) % 7);
      result.isDate = true;
      result.hour = 0;
      result.minute = 0;
      result.second = 0;
      return result;
    },

    /**
     * Returns a copy of the current date/time, shifted to the end of the week.
     * The resulting ICAL.Time instance is of icaltype date, even if this is a
     * date-time.
     *
     * @param {ICAL.Time.weekDay=} aWeekStart
     *        The week start weekday, defaults to SUNDAY
     * @return {ICAL.Time}      The end of the week (cloned)
     */
    endOfWeek: function endOfWeek(aWeekStart) {
      var firstDow = aWeekStart || ICAL.Time.SUNDAY;
      var result = this.clone();
      result.day += (7 - this.dayOfWeek() + firstDow - ICAL.Time.SUNDAY) % 7;
      result.isDate = true;
      result.hour = 0;
      result.minute = 0;
      result.second = 0;
      return result;
    },

    /**
     * Returns a copy of the current date/time, rewound to the start of the
     * month. The resulting ICAL.Time instance is of icaltype date, even if
     * this is a date-time.
     *
     * @return {ICAL.Time}      The start of the month (cloned)
     */
    startOfMonth: function startOfMonth() {
      var result = this.clone();
      result.day = 1;
      result.isDate = true;
      result.hour = 0;
      result.minute = 0;
      result.second = 0;
      return result;
    },

    /**
     * Returns a copy of the current date/time, shifted to the end of the
     * month.  The resulting ICAL.Time instance is of icaltype date, even if
     * this is a date-time.
     *
     * @return {ICAL.Time}      The end of the month (cloned)
     */
    endOfMonth: function endOfMonth() {
      var result = this.clone();
      result.day = ICAL.Time.daysInMonth(result.month, result.year);
      result.isDate = true;
      result.hour = 0;
      result.minute = 0;
      result.second = 0;
      return result;
    },

    /**
     * Returns a copy of the current date/time, rewound to the start of the
     * year. The resulting ICAL.Time instance is of icaltype date, even if
     * this is a date-time.
     *
     * @return {ICAL.Time}      The start of the year (cloned)
     */
    startOfYear: function startOfYear() {
      var result = this.clone();
      result.day = 1;
      result.month = 1;
      result.isDate = true;
      result.hour = 0;
      result.minute = 0;
      result.second = 0;
      return result;
    },

    /**
     * Returns a copy of the current date/time, shifted to the end of the
     * year.  The resulting ICAL.Time instance is of icaltype date, even if
     * this is a date-time.
     *
     * @return {ICAL.Time}      The end of the year (cloned)
     */
    endOfYear: function endOfYear() {
      var result = this.clone();
      result.day = 31;
      result.month = 12;
      result.isDate = true;
      result.hour = 0;
      result.minute = 0;
      result.second = 0;
      return result;
    },

    /**
     * First calculates the start of the week, then returns the day of year for
     * this date. If the day falls into the previous year, the day is zero or negative.
     *
     * @param {ICAL.Time.weekDay=} aFirstDayOfWeek
     *        The week start weekday, defaults to SUNDAY
     * @return {Number}     The calculated day of year
     */
    startDoyWeek: function startDoyWeek(aFirstDayOfWeek) {
      var firstDow = aFirstDayOfWeek || ICAL.Time.SUNDAY;
      var delta = this.dayOfWeek() - firstDow;
      if (delta < 0) delta += 7;
      return this.dayOfYear() - delta;
    },

    /**
     * Get the dominical letter for the current year. Letters range from A - G
     * for common years, and AG to GF for leap years.
     *
     * @param {Number} yr           The year to retrieve the letter for
     * @return {String}             The dominical letter.
     */
    getDominicalLetter: function() {
      return ICAL.Time.getDominicalLetter(this.year);
    },

    /**
     * Finds the nthWeekDay relative to the current month (not day).  The
     * returned value is a day relative the month that this month belongs to so
     * 1 would indicate the first of the month and 40 would indicate a day in
     * the following month.
     *
     * @param {Number} aDayOfWeek   Day of the week see the day name constants
     * @param {Number} aPos         Nth occurrence of a given week day values
     *        of 1 and 0 both indicate the first weekday of that type. aPos may
     *        be either positive or negative
     *
     * @return {Number} numeric value indicating a day relative
     *                   to the current month of this time object
     */
    nthWeekDay: function icaltime_nthWeekDay(aDayOfWeek, aPos) {
      var daysInMonth = ICAL.Time.daysInMonth(this.month, this.year);
      var weekday;
      var pos = aPos;

      var start = 0;

      var otherDay = this.clone();

      if (pos >= 0) {
        otherDay.day = 1;

        // because 0 means no position has been given
        // 1 and 0 indicate the same day.
        if (pos != 0) {
          // remove the extra numeric value
          pos--;
        }

        // set current start offset to current day.
        start = otherDay.day;

        // find the current day of week
        var startDow = otherDay.dayOfWeek();

        // calculate the difference between current
        // day of the week and desired day of the week
        var offset = aDayOfWeek - startDow;


        // if the offset goes into the past
        // week we add 7 so it goes into the next
        // week. We only want to go forward in time here.
        if (offset < 0)
          // this is really important otherwise we would
          // end up with dates from in the past.
          offset += 7;

        // add offset to start so start is the same
        // day of the week as the desired day of week.
        start += offset;

        // because we are going to add (and multiply)
        // the numeric value of the day we subtract it
        // from the start position so not to add it twice.
        start -= aDayOfWeek;

        // set week day
        weekday = aDayOfWeek;
      } else {

        // then we set it to the last day in the current month
        otherDay.day = daysInMonth;

        // find the ends weekday
        var endDow = otherDay.dayOfWeek();

        pos++;

        weekday = (endDow - aDayOfWeek);

        if (weekday < 0) {
          weekday += 7;
        }

        weekday = daysInMonth - weekday;
      }

      weekday += pos * 7;

      return start + weekday;
    },

    /**
     * Checks if current time is the nth weekday, relative to the current
     * month.  Will always return false when rule resolves outside of current
     * month.
     *
     * @param {ICAL.Time.weekDay} aDayOfWeek       Day of week to check
     * @param {Number} aPos                        Relative position
     * @return {Boolean}                           True, if it is the nth weekday
     */
    isNthWeekDay: function(aDayOfWeek, aPos) {
      var dow = this.dayOfWeek();

      if (aPos === 0 && dow === aDayOfWeek) {
        return true;
      }

      // get pos
      var day = this.nthWeekDay(aDayOfWeek, aPos);

      if (day === this.day) {
        return true;
      }

      return false;
    },

    /**
     * Calculates the ISO 8601 week number. The first week of a year is the
     * week that contains the first Thursday. The year can have 53 weeks, if
     * January 1st is a Friday.
     *
     * Note there are regions where the first week of the year is the one that
     * starts on January 1st, which may offset the week number. Also, if a
     * different week start is specified, this will also affect the week
     * number.
     *
     * @see ICAL.Time.weekOneStarts
     * @param {ICAL.Time.weekDay} aWeekStart        The weekday the week starts with
     * @return {Number}                             The ISO week number
     */
    weekNumber: function weekNumber(aWeekStart) {
      var wnCacheKey = (this.year << 12) + (this.month << 8) + (this.day << 3) + aWeekStart;
      if (wnCacheKey in ICAL.Time._wnCache) {
        return ICAL.Time._wnCache[wnCacheKey];
      }
      // This function courtesty of Julian Bucknall, published under the MIT license
      // http://www.boyet.com/articles/publishedarticles/calculatingtheisoweeknumb.html
      // plus some fixes to be able to use different week starts.
      var week1;

      var dt = this.clone();
      dt.isDate = true;
      var isoyear = this.year;

      if (dt.month == 12 && dt.day > 25) {
        week1 = ICAL.Time.weekOneStarts(isoyear + 1, aWeekStart);
        if (dt.compare(week1) < 0) {
          week1 = ICAL.Time.weekOneStarts(isoyear, aWeekStart);
        } else {
          isoyear++;
        }
      } else {
        week1 = ICAL.Time.weekOneStarts(isoyear, aWeekStart);
        if (dt.compare(week1) < 0) {
          week1 = ICAL.Time.weekOneStarts(--isoyear, aWeekStart);
        }
      }

      var daysBetween = (dt.subtractDate(week1).toSeconds() / 86400);
      var answer = ICAL.helpers.trunc(daysBetween / 7) + 1;
      ICAL.Time._wnCache[wnCacheKey] = answer;
      return answer;
    },

    /**
     * Adds the duration to the current time. The instance is modified in
     * place.
     *
     * @param {ICAL.Duration} aDuration         The duration to add
     */
    addDuration: function icaltime_add(aDuration) {
      var mult = (aDuration.isNegative ? -1 : 1);

      // because of the duration optimizations it is much
      // more efficient to grab all the values up front
      // then set them directly (which will avoid a normalization call).
      // So we don't actually normalize until we need it.
      var second = this.second;
      var minute = this.minute;
      var hour = this.hour;
      var day = this.day;

      second += mult * aDuration.seconds;
      minute += mult * aDuration.minutes;
      hour += mult * aDuration.hours;
      day += mult * aDuration.days;
      day += mult * 7 * aDuration.weeks;

      this.second = second;
      this.minute = minute;
      this.hour = hour;
      this.day = day;

      this._cachedUnixTime = null;
    },

    /**
     * Subtract the date details (_excluding_ timezone).  Useful for finding
     * the relative difference between two time objects excluding their
     * timezone differences.
     *
     * @param {ICAL.Time} aDate     The date to substract
     * @return {ICAL.Duration}      The difference as a duration
     */
    subtractDate: function icaltime_subtract(aDate) {
      var unixTime = this.toUnixTime() + this.utcOffset();
      var other = aDate.toUnixTime() + aDate.utcOffset();
      return ICAL.Duration.fromSeconds(unixTime - other);
    },

    /**
     * Subtract the date details, taking timezones into account.
     *
     * @param {ICAL.Time} aDate  The date to subtract
     * @return {ICAL.Duration}  The difference in duration
     */
    subtractDateTz: function icaltime_subtract_abs(aDate) {
      var unixTime = this.toUnixTime();
      var other = aDate.toUnixTime();
      return ICAL.Duration.fromSeconds(unixTime - other);
    },

    /**
     * Compares the ICAL.Time instance with another one.
     *
     * @param {ICAL.Duration} aOther        The instance to compare with
     * @return {Number}                     -1, 0 or 1 for less/equal/greater
     */
    compare: function icaltime_compare(other) {
      var a = this.toUnixTime();
      var b = other.toUnixTime();

      if (a > b) return 1;
      if (b > a) return -1;
      return 0;
    },

    /**
     * Compares only the date part of this instance with another one.
     *
     * @param {ICAL.Duration} other         The instance to compare with
     * @param {ICAL.Timezone} tz            The timezone to compare in
     * @return {Number}                     -1, 0 or 1 for less/equal/greater
     */
    compareDateOnlyTz: function icaltime_compareDateOnlyTz(other, tz) {
      function cmp(attr) {
        return ICAL.Time._cmp_attr(a, b, attr);
      }
      var a = this.convertToZone(tz);
      var b = other.convertToZone(tz);
      var rc = 0;

      if ((rc = cmp("year")) != 0) return rc;
      if ((rc = cmp("month")) != 0) return rc;
      if ((rc = cmp("day")) != 0) return rc;

      return rc;
    },

    /**
     * Convert the instance into another timezone. The returned ICAL.Time
     * instance is always a copy.
     *
     * @param {ICAL.Timezone} zone      The zone to convert to
     * @return {ICAL.Time}              The copy, converted to the zone
     */
    convertToZone: function convertToZone(zone) {
      var copy = this.clone();
      var zone_equals = (this.zone.tzid == zone.tzid);

      if (!this.isDate && !zone_equals) {
        ICAL.Timezone.convert_time(copy, this.zone, zone);
      }

      copy.zone = zone;
      return copy;
    },

    /**
     * Calculates the UTC offset of the current date/time in the timezone it is
     * in.
     *
     * @return {Number}     UTC offset in seconds
     */
    utcOffset: function utc_offset() {
      if (this.zone == ICAL.Timezone.localTimezone ||
          this.zone == ICAL.Timezone.utcTimezone) {
        return 0;
      } else {
        return this.zone.utcOffset(this);
      }
    },

    /**
     * Returns an RFC 5545 compliant ical representation of this object.
     *
     * @return {String} ical date/date-time
     */
    toICALString: function() {
      var string = this.toString();

      if (string.length > 10) {
        return ICAL.design.icalendar.value['date-time'].toICAL(string);
      } else {
        return ICAL.design.icalendar.value.date.toICAL(string);
      }
    },

    /**
     * The string representation of this date/time, in jCal form
     * (including : and - separators).
     * @return {String}
     */
    toString: function toString() {
      var result = this.year + '-' +
                   ICAL.helpers.pad2(this.month) + '-' +
                   ICAL.helpers.pad2(this.day);

      if (!this.isDate) {
          result += 'T' + ICAL.helpers.pad2(this.hour) + ':' +
                    ICAL.helpers.pad2(this.minute) + ':' +
                    ICAL.helpers.pad2(this.second);

        if (this.zone === ICAL.Timezone.utcTimezone) {
          result += 'Z';
        }
      }

      return result;
    },

    /**
     * Converts the current instance to a Javascript date
     * @return {Date}
     */
    toJSDate: function toJSDate() {
      if (this.zone == ICAL.Timezone.localTimezone) {
        if (this.isDate) {
          return new Date(this.year, this.month - 1, this.day);
        } else {
          return new Date(this.year, this.month - 1, this.day,
                          this.hour, this.minute, this.second, 0);
        }
      } else {
        return new Date(this.toUnixTime() * 1000);
      }
    },

    _normalize: function icaltime_normalize() {
      var isDate = this._time.isDate;
      if (this._time.isDate) {
        this._time.hour = 0;
        this._time.minute = 0;
        this._time.second = 0;
      }
      this.adjust(0, 0, 0, 0);

      return this;
    },

    /**
     * Adjust the date/time by the given offset
     *
     * @param {Number} aExtraDays       The extra amount of days
     * @param {Number} aExtraHours      The extra amount of hours
     * @param {Number} aExtraMinutes    The extra amount of minutes
     * @param {Number} aExtraSeconds    The extra amount of seconds
     * @param {Number=} aTime           The time to adjust, defaults to the
     *                                    current instance.
     */
    adjust: function icaltime_adjust(aExtraDays, aExtraHours,
                                     aExtraMinutes, aExtraSeconds, aTime) {

      var minutesOverflow, hoursOverflow,
          daysOverflow = 0, yearsOverflow = 0;

      var second, minute, hour, day;
      var daysInMonth;

      var time = aTime || this._time;

      if (!time.isDate) {
        second = time.second + aExtraSeconds;
        time.second = second % 60;
        minutesOverflow = ICAL.helpers.trunc(second / 60);
        if (time.second < 0) {
          time.second += 60;
          minutesOverflow--;
        }

        minute = time.minute + aExtraMinutes + minutesOverflow;
        time.minute = minute % 60;
        hoursOverflow = ICAL.helpers.trunc(minute / 60);
        if (time.minute < 0) {
          time.minute += 60;
          hoursOverflow--;
        }

        hour = time.hour + aExtraHours + hoursOverflow;

        time.hour = hour % 24;
        daysOverflow = ICAL.helpers.trunc(hour / 24);
        if (time.hour < 0) {
          time.hour += 24;
          daysOverflow--;
        }
      }


      // Adjust month and year first, because we need to know what month the day
      // is in before adjusting it.
      if (time.month > 12) {
        yearsOverflow = ICAL.helpers.trunc((time.month - 1) / 12);
      } else if (time.month < 1) {
        yearsOverflow = ICAL.helpers.trunc(time.month / 12) - 1;
      }

      time.year += yearsOverflow;
      time.month -= 12 * yearsOverflow;

      // Now take care of the days (and adjust month if needed)
      day = time.day + aExtraDays + daysOverflow;

      if (day > 0) {
        for (;;) {
          daysInMonth = ICAL.Time.daysInMonth(time.month, time.year);
          if (day <= daysInMonth) {
            break;
          }

          time.month++;
          if (time.month > 12) {
            time.year++;
            time.month = 1;
          }

          day -= daysInMonth;
        }
      } else {
        while (day <= 0) {
          if (time.month == 1) {
            time.year--;
            time.month = 12;
          } else {
            time.month--;
          }

          day += ICAL.Time.daysInMonth(time.month, time.year);
        }
      }

      time.day = day;

      this._cachedUnixTime = null;
      return this;
    },

    /**
     * Sets up the current instance from unix time, the number of seconds since
     * January 1st, 1970.
     *
     * @param {Number} seconds      The seconds to set up with
     */
    fromUnixTime: function fromUnixTime(seconds) {
      this.zone = ICAL.Timezone.utcTimezone;
      var epoch = ICAL.Time.epochTime.clone();
      epoch.adjust(0, 0, 0, seconds);

      this.year = epoch.year;
      this.month = epoch.month;
      this.day = epoch.day;
      this.hour = epoch.hour;
      this.minute = epoch.minute;
      this.second = Math.floor(epoch.second);

      this._cachedUnixTime = null;
    },

    /**
     * Converts the current instance to seconds since January 1st 1970.
     *
     * @return {Number}         Seconds since 1970
     */
    toUnixTime: function toUnixTime() {
      if (this._cachedUnixTime !== null) {
        return this._cachedUnixTime;
      }
      var offset = this.utcOffset();

      // we use the offset trick to ensure
      // that we are getting the actual UTC time
      var ms = Date.UTC(
        this.year,
        this.month - 1,
        this.day,
        this.hour,
        this.minute,
        this.second - offset
      );

      // seconds
      this._cachedUnixTime = ms / 1000;
      return this._cachedUnixTime;
    },

    /**
     * Converts time to into Object which can be serialized then re-created
     * using the constructor.
     *
     * @example
     * // toJSON will automatically be called
     * var json = JSON.stringify(mytime);
     *
     * var deserialized = JSON.parse(json);
     *
     * var time = new ICAL.Time(deserialized);
     *
     * @return {Object}
     */
    toJSON: function() {
      var copy = [
        'year',
        'month',
        'day',
        'hour',
        'minute',
        'second',
        'isDate'
      ];

      var result = Object.create(null);

      var i = 0;
      var len = copy.length;
      var prop;

      for (; i < len; i++) {
        prop = copy[i];
        result[prop] = this[prop];
      }

      if (this.zone) {
        result.timezone = this.zone.tzid;
      }

      return result;
    }

  };

  (function setupNormalizeAttributes() {
    // This needs to run before any instances are created!
    function defineAttr(attr) {
      Object.defineProperty(ICAL.Time.prototype, attr, {
        get: function getTimeAttr() {
          if (this._pendingNormalization) {
            this._normalize();
            this._pendingNormalization = false;
          }

          return this._time[attr];
        },
        set: function setTimeAttr(val) {
          // Check if isDate will be set and if was not set to normalize date.
          // This avoids losing days when seconds, minutes and hours are zeroed
          // what normalize will do when time is a date.
          if (attr === "isDate" && val && !this._time.isDate) {
            this.adjust(0, 0, 0, 0);
          }
          this._cachedUnixTime = null;
          this._pendingNormalization = true;
          this._time[attr] = val;

          return val;
        }
      });

    }

    /* istanbul ignore else */
    if ("defineProperty" in Object) {
      defineAttr("year");
      defineAttr("month");
      defineAttr("day");
      defineAttr("hour");
      defineAttr("minute");
      defineAttr("second");
      defineAttr("isDate");
    }
  })();

  /**
   * Returns the days in the given month
   *
   * @param {Number} month      The month to check
   * @param {Number} year       The year to check
   * @return {Number}           The number of days in the month
   */
  ICAL.Time.daysInMonth = function icaltime_daysInMonth(month, year) {
    var _daysInMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    var days = 30;

    if (month < 1 || month > 12) return days;

    days = _daysInMonth[month];

    if (month == 2) {
      days += ICAL.Time.isLeapYear(year);
    }

    return days;
  };

  /**
   * Checks if the year is a leap year
   *
   * @param {Number} year       The year to check
   * @return {Boolean}          True, if the year is a leap year
   */
  ICAL.Time.isLeapYear = function isLeapYear(year) {
    if (year <= 1752) {
      return ((year % 4) == 0);
    } else {
      return (((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0));
    }
  };

  /**
   * Create a new ICAL.Time from the day of year and year. The date is returned
   * in floating timezone.
   *
   * @param {Number} aDayOfYear     The day of year
   * @param {Number} aYear          The year to create the instance in
   * @return {ICAL.Time}            The created instance with the calculated date
   */
  ICAL.Time.fromDayOfYear = function icaltime_fromDayOfYear(aDayOfYear, aYear) {
    var year = aYear;
    var doy = aDayOfYear;
    var tt = new ICAL.Time();
    tt.auto_normalize = false;
    var is_leap = (ICAL.Time.isLeapYear(year) ? 1 : 0);

    if (doy < 1) {
      year--;
      is_leap = (ICAL.Time.isLeapYear(year) ? 1 : 0);
      doy += ICAL.Time.daysInYearPassedMonth[is_leap][12];
      return ICAL.Time.fromDayOfYear(doy, year);
    } else if (doy > ICAL.Time.daysInYearPassedMonth[is_leap][12]) {
      is_leap = (ICAL.Time.isLeapYear(year) ? 1 : 0);
      doy -= ICAL.Time.daysInYearPassedMonth[is_leap][12];
      year++;
      return ICAL.Time.fromDayOfYear(doy, year);
    }

    tt.year = year;
    tt.isDate = true;

    for (var month = 11; month >= 0; month--) {
      if (doy > ICAL.Time.daysInYearPassedMonth[is_leap][month]) {
        tt.month = month + 1;
        tt.day = doy - ICAL.Time.daysInYearPassedMonth[is_leap][month];
        break;
      }
    }

    tt.auto_normalize = true;
    return tt;
  };

  /**
   * Returns a new ICAL.Time instance from a date string, e.g 2015-01-02.
   *
   * @deprecated                Use {@link ICAL.Time.fromDateString} instead
   * @param {String} str        The string to create from
   * @return {ICAL.Time}        The date/time instance
   */
  ICAL.Time.fromStringv2 = function fromString(str) {
    return new ICAL.Time({
      year: parseInt(str.substr(0, 4), 10),
      month: parseInt(str.substr(5, 2), 10),
      day: parseInt(str.substr(8, 2), 10),
      isDate: true
    });
  };

  /**
   * Returns a new ICAL.Time instance from a date string, e.g 2015-01-02.
   *
   * @param {String} aValue     The string to create from
   * @return {ICAL.Time}        The date/time instance
   */
  ICAL.Time.fromDateString = function(aValue) {
    // Dates should have no timezone.
    // Google likes to sometimes specify Z on dates
    // we specifically ignore that to avoid issues.

    // YYYY-MM-DD
    // 2012-10-10
    return new ICAL.Time({
      year: ICAL.helpers.strictParseInt(aValue.substr(0, 4)),
      month: ICAL.helpers.strictParseInt(aValue.substr(5, 2)),
      day: ICAL.helpers.strictParseInt(aValue.substr(8, 2)),
      isDate: true
    });
  };

  /**
   * Returns a new ICAL.Time instance from a date-time string, e.g
   * 2015-01-02T03:04:05. If a property is specified, the timezone is set up
   * from the property's TZID parameter.
   *
   * @param {String} aValue         The string to create from
   * @param {ICAL.Property=} prop   The property the date belongs to
   * @return {ICAL.Time}            The date/time instance
   */
  ICAL.Time.fromDateTimeString = function(aValue, prop) {
    if (aValue.length < 19) {
      throw new Error(
        'invalid date-time value: "' + aValue + '"'
      );
    }

    var zone;

    if (aValue[19] && aValue[19] === 'Z') {
      zone = 'Z';
    } else if (prop) {
      zone = prop.getParameter('tzid');
    }

    // 2012-10-10T10:10:10(Z)?
    var time = new ICAL.Time({
      year: ICAL.helpers.strictParseInt(aValue.substr(0, 4)),
      month: ICAL.helpers.strictParseInt(aValue.substr(5, 2)),
      day: ICAL.helpers.strictParseInt(aValue.substr(8, 2)),
      hour: ICAL.helpers.strictParseInt(aValue.substr(11, 2)),
      minute: ICAL.helpers.strictParseInt(aValue.substr(14, 2)),
      second: ICAL.helpers.strictParseInt(aValue.substr(17, 2)),
      timezone: zone
    });

    return time;
  };

  /**
   * Returns a new ICAL.Time instance from a date or date-time string,
   *
   * @param {String} aValue         The string to create from
   * @param {ICAL.Property=} prop   The property the date belongs to
   * @return {ICAL.Time}            The date/time instance
   */
  ICAL.Time.fromString = function fromString(aValue, aProperty) {
    if (aValue.length > 10) {
      return ICAL.Time.fromDateTimeString(aValue, aProperty);
    } else {
      return ICAL.Time.fromDateString(aValue);
    }
  };

  /**
   * Creates a new ICAL.Time instance from the given Javascript Date.
   *
   * @param {?Date} aDate     The Javascript Date to read, or null to reset
   * @param {Boolean} useUTC  If true, the UTC values of the date will be used
   */
  ICAL.Time.fromJSDate = function fromJSDate(aDate, useUTC) {
    var tt = new ICAL.Time();
    return tt.fromJSDate(aDate, useUTC);
  };

  /**
   * Creates a new ICAL.Time instance from the the passed data object.
   *
   * @param {Object} aData            Time initialization
   * @param {Number=} aData.year      The year for this date
   * @param {Number=} aData.month     The month for this date
   * @param {Number=} aData.day       The day for this date
   * @param {Number=} aData.hour      The hour for this date
   * @param {Number=} aData.minute    The minute for this date
   * @param {Number=} aData.second    The second for this date
   * @param {Boolean=} aData.isDate   If true, the instance represents a date
   *                                    (as opposed to a date-time)
   * @param {ICAL.Timezone=} aZone    Timezone this position occurs in
   */
  ICAL.Time.fromData = function fromData(aData, aZone) {
    var t = new ICAL.Time();
    return t.fromData(aData, aZone);
  };

  /**
   * Creates a new ICAL.Time instance from the current moment.
   * The instance is “floating” - has no timezone relation.
   * To create an instance considering the time zone, call
   * ICAL.Time.fromJSDate(new Date(), true)
   * @return {ICAL.Time}
   */
  ICAL.Time.now = function icaltime_now() {
    return ICAL.Time.fromJSDate(new Date(), false);
  };

  /**
   * Returns the date on which ISO week number 1 starts.
   *
   * @see ICAL.Time#weekNumber
   * @param {Number} aYear                  The year to search in
   * @param {ICAL.Time.weekDay=} aWeekStart The week start weekday, used for calculation.
   * @return {ICAL.Time}                    The date on which week number 1 starts
   */
  ICAL.Time.weekOneStarts = function weekOneStarts(aYear, aWeekStart) {
    var t = ICAL.Time.fromData({
      year: aYear,
      month: 1,
      day: 1,
      isDate: true
    });

    var dow = t.dayOfWeek();
    var wkst = aWeekStart || ICAL.Time.DEFAULT_WEEK_START;
    if (dow > ICAL.Time.THURSDAY) {
      t.day += 7;
    }
    if (wkst > ICAL.Time.THURSDAY) {
      t.day -= 7;
    }

    t.day -= dow - wkst;

    return t;
  };

  /**
   * Get the dominical letter for the given year. Letters range from A - G for
   * common years, and AG to GF for leap years.
   *
   * @param {Number} yr           The year to retrieve the letter for
   * @return {String}             The dominical letter.
   */
  ICAL.Time.getDominicalLetter = function(yr) {
    var LTRS = "GFEDCBA";
    var dom = (yr + (yr / 4 | 0) + (yr / 400 | 0) - (yr / 100 | 0) - 1) % 7;
    var isLeap = ICAL.Time.isLeapYear(yr);
    if (isLeap) {
      return LTRS[(dom + 6) % 7] + LTRS[dom];
    } else {
      return LTRS[dom];
    }
  };

  /**
   * January 1st, 1970 as an ICAL.Time.
   * @type {ICAL.Time}
   * @constant
   * @instance
   */
  ICAL.Time.epochTime = ICAL.Time.fromData({
    year: 1970,
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    isDate: false,
    timezone: "Z"
  });

  ICAL.Time._cmp_attr = function _cmp_attr(a, b, attr) {
    if (a[attr] > b[attr]) return 1;
    if (a[attr] < b[attr]) return -1;
    return 0;
  };

  /**
   * The days that have passed in the year after a given month. The array has
   * two members, one being an array of passed days for non-leap years, the
   * other analog for leap years.
   * @example
   * var isLeapYear = ICAL.Time.isLeapYear(year);
   * var passedDays = ICAL.Time.daysInYearPassedMonth[isLeapYear][month];
   * @type {Array.<Array.<Number>>}
   */
  ICAL.Time.daysInYearPassedMonth = [
    [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365],
    [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366]
  ];

  /**
   * The weekday, 1 = SUNDAY, 7 = SATURDAY. Access via
   * ICAL.Time.MONDAY, ICAL.Time.TUESDAY, ...
   *
   * @typedef {Number} weekDay
   * @memberof ICAL.Time
   */

  ICAL.Time.SUNDAY = 1;
  ICAL.Time.MONDAY = 2;
  ICAL.Time.TUESDAY = 3;
  ICAL.Time.WEDNESDAY = 4;
  ICAL.Time.THURSDAY = 5;
  ICAL.Time.FRIDAY = 6;
  ICAL.Time.SATURDAY = 7;

  /**
   * The default weekday for the WKST part.
   * @constant
   * @default ICAL.Time.MONDAY
   */
  ICAL.Time.DEFAULT_WEEK_START = ICAL.Time.MONDAY;
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2015 */



(function() {

  /**
   * Describes a vCard time, which has slight differences to the ICAL.Time.
   * Properties can be null if not specified, for example for dates with
   * reduced accuracy or truncation.
   *
   * Note that currently not all methods are correctly re-implemented for
   * VCardTime. For example, comparison will have undefined results when some
   * members are null.
   *
   * Also, normalization is not yet implemented for this class!
   *
   * @alias ICAL.VCardTime
   * @class
   * @extends {ICAL.Time}
   * @param {Object} data                           The data for the time instance
   * @param {Number=} data.year                     The year for this date
   * @param {Number=} data.month                    The month for this date
   * @param {Number=} data.day                      The day for this date
   * @param {Number=} data.hour                     The hour for this date
   * @param {Number=} data.minute                   The minute for this date
   * @param {Number=} data.second                   The second for this date
   * @param {ICAL.Timezone|ICAL.UtcOffset} zone     The timezone to use
   * @param {String} icaltype                       The type for this date/time object
   */
  ICAL.VCardTime = function(data, zone, icaltype) {
    this.wrappedJSObject = this;
    var time = this._time = Object.create(null);

    time.year = null;
    time.month = null;
    time.day = null;
    time.hour = null;
    time.minute = null;
    time.second = null;

    this.icaltype = icaltype || "date-and-or-time";

    this.fromData(data, zone);
  };
  ICAL.helpers.inherits(ICAL.Time, ICAL.VCardTime, /** @lends ICAL.VCardTime */ {

    /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "vcardtime"
     */
    icalclass: "vcardtime",

    /**
     * The type name, to be used in the jCal object.
     * @type {String}
     * @default "date-and-or-time"
     */
    icaltype: "date-and-or-time",

    /**
     * The timezone. This can either be floating, UTC, or an instance of
     * ICAL.UtcOffset.
     * @type {ICAL.Timezone|ICAL.UtcOFfset}
     */
    zone: null,

    /**
     * Returns a clone of the vcard date/time object.
     *
     * @return {ICAL.VCardTime}     The cloned object
     */
    clone: function() {
      return new ICAL.VCardTime(this._time, this.zone, this.icaltype);
    },

    _normalize: function() {
      return this;
    },

    /**
     * @inheritdoc
     */
    utcOffset: function() {
      if (this.zone instanceof ICAL.UtcOffset) {
        return this.zone.toSeconds();
      } else {
        return ICAL.Time.prototype.utcOffset.apply(this, arguments);
      }
    },

    /**
     * Returns an RFC 6350 compliant representation of this object.
     *
     * @return {String}         vcard date/time string
     */
    toICALString: function() {
      return ICAL.design.vcard.value[this.icaltype].toICAL(this.toString());
    },

    /**
     * The string representation of this date/time, in jCard form
     * (including : and - separators).
     * @return {String}
     */
    toString: function toString() {
      var p2 = ICAL.helpers.pad2;
      var y = this.year, m = this.month, d = this.day;
      var h = this.hour, mm = this.minute, s = this.second;

      var hasYear = y !== null, hasMonth = m !== null, hasDay = d !== null;
      var hasHour = h !== null, hasMinute = mm !== null, hasSecond = s !== null;

      var datepart = (hasYear ? p2(y) + (hasMonth || hasDay ? '-' : '') : (hasMonth || hasDay ? '--' : '')) +
                     (hasMonth ? p2(m) : '') +
                     (hasDay ? '-' + p2(d) : '');
      var timepart = (hasHour ? p2(h) : '-') + (hasHour && hasMinute ? ':' : '') +
                     (hasMinute ? p2(mm) : '') + (!hasHour && !hasMinute ? '-' : '') +
                     (hasMinute && hasSecond ? ':' : '') +
                     (hasSecond ? p2(s) : '');

      var zone;
      if (this.zone === ICAL.Timezone.utcTimezone) {
        zone = 'Z';
      } else if (this.zone instanceof ICAL.UtcOffset) {
        zone = this.zone.toString();
      } else if (this.zone === ICAL.Timezone.localTimezone) {
        zone = '';
      } else if (this.zone instanceof ICAL.Timezone) {
        var offset = ICAL.UtcOffset.fromSeconds(this.zone.utcOffset(this));
        zone = offset.toString();
      } else {
        zone = '';
      }

      switch (this.icaltype) {
        case "time":
          return timepart + zone;
        case "date-and-or-time":
        case "date-time":
          return datepart + (timepart == '--' ? '' : 'T' + timepart + zone);
        case "date":
          return datepart;
      }
      return null;
    }
  });

  /**
   * Returns a new ICAL.VCardTime instance from a date and/or time string.
   *
   * @param {String} aValue     The string to create from
   * @param {String} aIcalType  The type for this instance, e.g. date-and-or-time
   * @return {ICAL.VCardTime}   The date/time instance
   */
  ICAL.VCardTime.fromDateAndOrTimeString = function(aValue, aIcalType) {
    function part(v, s, e) {
      return v ? ICAL.helpers.strictParseInt(v.substr(s, e)) : null;
    }
    var parts = aValue.split('T');
    var dt = parts[0], tmz = parts[1];
    var splitzone = tmz ? ICAL.design.vcard.value.time._splitZone(tmz) : [];
    var zone = splitzone[0], tm = splitzone[1];

    var stoi = ICAL.helpers.strictParseInt;
    var dtlen = dt ? dt.length : 0;
    var tmlen = tm ? tm.length : 0;

    var hasDashDate = dt && dt[0] == '-' && dt[1] == '-';
    var hasDashTime = tm && tm[0] == '-';

    var o = {
      year: hasDashDate ? null : part(dt, 0, 4),
      month: hasDashDate && (dtlen == 4 || dtlen == 7) ? part(dt, 2, 2) : dtlen == 7 ? part(dt, 5, 2) : dtlen == 10 ? part(dt, 5, 2) : null,
      day: dtlen == 5 ? part(dt, 3, 2) : dtlen == 7 && hasDashDate ? part(dt, 5, 2) : dtlen == 10 ? part(dt, 8, 2) : null,

      hour: hasDashTime ? null : part(tm, 0, 2),
      minute: hasDashTime && tmlen == 3 ? part(tm, 1, 2) : tmlen > 4 ? hasDashTime ? part(tm, 1, 2) : part(tm, 3, 2) : null,
      second: tmlen == 4 ? part(tm, 2, 2) : tmlen == 6 ? part(tm, 4, 2) : tmlen == 8 ? part(tm, 6, 2) : null
    };

    if (zone == 'Z') {
      zone = ICAL.Timezone.utcTimezone;
    } else if (zone && zone[3] == ':') {
      zone = ICAL.UtcOffset.fromString(zone);
    } else {
      zone = null;
    }

    return new ICAL.VCardTime(o, zone, aIcalType);
  };
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */



(function() {
  var DOW_MAP = {
    SU: ICAL.Time.SUNDAY,
    MO: ICAL.Time.MONDAY,
    TU: ICAL.Time.TUESDAY,
    WE: ICAL.Time.WEDNESDAY,
    TH: ICAL.Time.THURSDAY,
    FR: ICAL.Time.FRIDAY,
    SA: ICAL.Time.SATURDAY
  };

  var REVERSE_DOW_MAP = {};
  for (var key in DOW_MAP) {
    /* istanbul ignore else */
    if (DOW_MAP.hasOwnProperty(key)) {
      REVERSE_DOW_MAP[DOW_MAP[key]] = key;
    }
  }

  var COPY_PARTS = ["BYSECOND", "BYMINUTE", "BYHOUR", "BYDAY",
                    "BYMONTHDAY", "BYYEARDAY", "BYWEEKNO",
                    "BYMONTH", "BYSETPOS"];

  /**
   * @classdesc
   * This class represents the "recur" value type, with various calculation
   * and manipulation methods.
   *
   * @class
   * @alias ICAL.Recur
   * @param {Object} data                               An object with members of the recurrence
   * @param {ICAL.Recur.frequencyValues=} data.freq     The frequency value
   * @param {Number=} data.interval                     The INTERVAL value
   * @param {ICAL.Time.weekDay=} data.wkst              The week start value
   * @param {ICAL.Time=} data.until                     The end of the recurrence set
   * @param {Number=} data.count                        The number of occurrences
   * @param {Array.<Number>=} data.bysecond             The seconds for the BYSECOND part
   * @param {Array.<Number>=} data.byminute             The minutes for the BYMINUTE part
   * @param {Array.<Number>=} data.byhour               The hours for the BYHOUR part
   * @param {Array.<String>=} data.byday                The BYDAY values
   * @param {Array.<Number>=} data.bymonthday           The days for the BYMONTHDAY part
   * @param {Array.<Number>=} data.byyearday            The days for the BYYEARDAY part
   * @param {Array.<Number>=} data.byweekno             The weeks for the BYWEEKNO part
   * @param {Array.<Number>=} data.bymonth              The month for the BYMONTH part
   * @param {Array.<Number>=} data.bysetpos             The positionals for the BYSETPOS part
   */
  ICAL.Recur = function icalrecur(data) {
    this.wrappedJSObject = this;
    this.parts = {};

    if (data && typeof(data) === 'object') {
      this.fromData(data);
    }
  };

  ICAL.Recur.prototype = {
    /**
     * An object holding the BY-parts of the recurrence rule
     * @type {Object}
     */
    parts: null,

    /**
     * The interval value for the recurrence rule.
     * @type {Number}
     */
    interval: 1,

    /**
     * The week start day
     *
     * @type {ICAL.Time.weekDay}
     * @default ICAL.Time.MONDAY
     */
    wkst: ICAL.Time.MONDAY,

    /**
     * The end of the recurrence
     * @type {?ICAL.Time}
     */
    until: null,

    /**
     * The maximum number of occurrences
     * @type {?Number}
     */
    count: null,

    /**
     * The frequency value.
     * @type {ICAL.Recur.frequencyValues}
     */
    freq: null,

    /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icalrecur"
     */
    icalclass: "icalrecur",

    /**
     * The type name, to be used in the jCal object.
     * @constant
     * @type {String}
     * @default "recur"
     */
    icaltype: "recur",

    /**
     * Create a new iterator for this recurrence rule. The passed start date
     * must be the start date of the event, not the start of the range to
     * search in.
     *
     * @example
     * var recur = comp.getFirstPropertyValue('rrule');
     * var dtstart = comp.getFirstPropertyValue('dtstart');
     * var iter = recur.iterator(dtstart);
     * for (var next = iter.next(); next; next = iter.next()) {
     *   if (next.compare(rangeStart) < 0) {
     *     continue;
     *   }
     *   console.log(next.toString());
     * }
     *
     * @param {ICAL.Time} aStart        The item's start date
     * @return {ICAL.RecurIterator}     The recurrence iterator
     */
    iterator: function(aStart) {
      return new ICAL.RecurIterator({
        rule: this,
        dtstart: aStart
      });
    },

    /**
     * Returns a clone of the recurrence object.
     *
     * @return {ICAL.Recur}      The cloned object
     */
    clone: function clone() {
      return new ICAL.Recur(this.toJSON());
    },

    /**
     * Checks if the current rule is finite, i.e. has a count or until part.
     *
     * @return {Boolean}        True, if the rule is finite
     */
    isFinite: function isfinite() {
      return !!(this.count || this.until);
    },

    /**
     * Checks if the current rule has a count part, and not limited by an until
     * part.
     *
     * @return {Boolean}        True, if the rule is by count
     */
    isByCount: function isbycount() {
      return !!(this.count && !this.until);
    },

    /**
     * Adds a component (part) to the recurrence rule. This is not a component
     * in the sense of {@link ICAL.Component}, but a part of the recurrence
     * rule, i.e. BYMONTH.
     *
     * @param {String} aType            The name of the component part
     * @param {Array|String} aValue     The component value
     */
    addComponent: function addPart(aType, aValue) {
      var ucname = aType.toUpperCase();
      if (ucname in this.parts) {
        this.parts[ucname].push(aValue);
      } else {
        this.parts[ucname] = [aValue];
      }
    },

    /**
     * Sets the component value for the given by-part.
     *
     * @param {String} aType        The component part name
     * @param {Array} aValues       The component values
     */
    setComponent: function setComponent(aType, aValues) {
      this.parts[aType.toUpperCase()] = aValues.slice();
    },

    /**
     * Gets (a copy) of the requested component value.
     *
     * @param {String} aType        The component part name
     * @return {Array}              The component part value
     */
    getComponent: function getComponent(aType) {
      var ucname = aType.toUpperCase();
      return (ucname in this.parts ? this.parts[ucname].slice() : []);
    },

    /**
     * Retrieves the next occurrence after the given recurrence id. See the
     * guide on {@tutorial terminology} for more details.
     *
     * NOTE: Currently, this method iterates all occurrences from the start
     * date. It should not be called in a loop for performance reasons. If you
     * would like to get more than one occurrence, you can iterate the
     * occurrences manually, see the example on the
     * {@link ICAL.Recur#iterator iterator} method.
     *
     * @param {ICAL.Time} aStartTime        The start of the event series
     * @param {ICAL.Time} aRecurrenceId     The date of the last occurrence
     * @return {ICAL.Time}                  The next occurrence after
     */
    getNextOccurrence: function getNextOccurrence(aStartTime, aRecurrenceId) {
      var iter = this.iterator(aStartTime);
      var next, cdt;

      do {
        next = iter.next();
      } while (next && next.compare(aRecurrenceId) <= 0);

      if (next && aRecurrenceId.zone) {
        next.zone = aRecurrenceId.zone;
      }

      return next;
    },

    /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {Object} data                               An object with members of the recurrence
     * @param {ICAL.Recur.frequencyValues=} data.freq     The frequency value
     * @param {Number=} data.interval                     The INTERVAL value
     * @param {ICAL.Time.weekDay=} data.wkst              The week start value
     * @param {ICAL.Time=} data.until                     The end of the recurrence set
     * @param {Number=} data.count                        The number of occurrences
     * @param {Array.<Number>=} data.bysecond             The seconds for the BYSECOND part
     * @param {Array.<Number>=} data.byminute             The minutes for the BYMINUTE part
     * @param {Array.<Number>=} data.byhour               The hours for the BYHOUR part
     * @param {Array.<String>=} data.byday                The BYDAY values
     * @param {Array.<Number>=} data.bymonthday           The days for the BYMONTHDAY part
     * @param {Array.<Number>=} data.byyearday            The days for the BYYEARDAY part
     * @param {Array.<Number>=} data.byweekno             The weeks for the BYWEEKNO part
     * @param {Array.<Number>=} data.bymonth              The month for the BYMONTH part
     * @param {Array.<Number>=} data.bysetpos             The positionals for the BYSETPOS part
     */
    fromData: function(data) {
      for (var key in data) {
        var uckey = key.toUpperCase();

        if (uckey in partDesign) {
          if (Array.isArray(data[key])) {
            this.parts[uckey] = data[key];
          } else {
            this.parts[uckey] = [data[key]];
          }
        } else {
          this[key] = data[key];
        }
      }

      if (this.interval && typeof this.interval != "number") {
        optionDesign.INTERVAL(this.interval, this);
      }

      if (this.wkst && typeof this.wkst != "number") {
        this.wkst = ICAL.Recur.icalDayToNumericDay(this.wkst);
      }

      if (this.until && !(this.until instanceof ICAL.Time)) {
        this.until = ICAL.Time.fromString(this.until);
      }
    },

    /**
     * The jCal representation of this recurrence type.
     * @return {Object}
     */
    toJSON: function() {
      var res = Object.create(null);
      res.freq = this.freq;

      if (this.count) {
        res.count = this.count;
      }

      if (this.interval > 1) {
        res.interval = this.interval;
      }

      for (var k in this.parts) {
        /* istanbul ignore if */
        if (!this.parts.hasOwnProperty(k)) {
          continue;
        }
        var kparts = this.parts[k];
        if (Array.isArray(kparts) && kparts.length == 1) {
          res[k.toLowerCase()] = kparts[0];
        } else {
          res[k.toLowerCase()] = ICAL.helpers.clone(this.parts[k]);
        }
      }

      if (this.until) {
        res.until = this.until.toString();
      }
      if ('wkst' in this && this.wkst !== ICAL.Time.DEFAULT_WEEK_START) {
        res.wkst = ICAL.Recur.numericDayToIcalDay(this.wkst);
      }
      return res;
    },

    /**
     * The string representation of this recurrence rule.
     * @return {String}
     */
    toString: function icalrecur_toString() {
      // TODO retain order
      var str = "FREQ=" + this.freq;
      if (this.count) {
        str += ";COUNT=" + this.count;
      }
      if (this.interval > 1) {
        str += ";INTERVAL=" + this.interval;
      }
      for (var k in this.parts) {
        /* istanbul ignore else */
        if (this.parts.hasOwnProperty(k)) {
          str += ";" + k + "=" + this.parts[k];
        }
      }
      if (this.until) {
        str += ';UNTIL=' + this.until.toICALString();
      }
      if ('wkst' in this && this.wkst !== ICAL.Time.DEFAULT_WEEK_START) {
        str += ';WKST=' + ICAL.Recur.numericDayToIcalDay(this.wkst);
      }
      return str;
    }
  };

  function parseNumericValue(type, min, max, value) {
    var result = value;

    if (value[0] === '+') {
      result = value.substr(1);
    }

    result = ICAL.helpers.strictParseInt(result);

    if (min !== undefined && value < min) {
      throw new Error(
        type + ': invalid value "' + value + '" must be > ' + min
      );
    }

    if (max !== undefined && value > max) {
      throw new Error(
        type + ': invalid value "' + value + '" must be < ' + min
      );
    }

    return result;
  }

  /**
   * Convert an ical representation of a day (SU, MO, etc..)
   * into a numeric value of that day.
   *
   * @param {String} string     The iCalendar day name
   * @param {ICAL.Time.weekDay=} aWeekStart
   *        The week start weekday, defaults to SUNDAY
   * @return {Number}           Numeric value of given day
   */
  ICAL.Recur.icalDayToNumericDay = function toNumericDay(string, aWeekStart) {
    //XXX: this is here so we can deal
    //     with possibly invalid string values.
    var firstDow = aWeekStart || ICAL.Time.SUNDAY;
    return ((DOW_MAP[string] - firstDow + 7) % 7) + 1;
  };

  /**
   * Convert a numeric day value into its ical representation (SU, MO, etc..)
   *
   * @param {Number} num        Numeric value of given day
   * @param {ICAL.Time.weekDay=} aWeekStart
   *        The week start weekday, defaults to SUNDAY
   * @return {String}           The ICAL day value, e.g SU,MO,...
   */
  ICAL.Recur.numericDayToIcalDay = function toIcalDay(num, aWeekStart) {
    //XXX: this is here so we can deal with possibly invalid number values.
    //     Also, this allows consistent mapping between day numbers and day
    //     names for external users.
    var firstDow = aWeekStart || ICAL.Time.SUNDAY;
    var dow = (num + firstDow - ICAL.Time.SUNDAY);
    if (dow > 7) {
      dow -= 7;
    }
    return REVERSE_DOW_MAP[dow];
  };

  var VALID_DAY_NAMES = /^(SU|MO|TU|WE|TH|FR|SA)$/;
  var VALID_BYDAY_PART = /^([+-])?(5[0-3]|[1-4][0-9]|[1-9])?(SU|MO|TU|WE|TH|FR|SA)$/;

  /**
   * Possible frequency values for the FREQ part
   * (YEARLY, MONTHLY, WEEKLY, DAILY, HOURLY, MINUTELY, SECONDLY)
   *
   * @typedef {String} frequencyValues
   * @memberof ICAL.Recur
   */

  var ALLOWED_FREQ = ['SECONDLY', 'MINUTELY', 'HOURLY',
                      'DAILY', 'WEEKLY', 'MONTHLY', 'YEARLY'];

  var optionDesign = {
    FREQ: function(value, dict, fmtIcal) {
      // yes this is actually equal or faster then regex.
      // upside here is we can enumerate the valid values.
      if (ALLOWED_FREQ.indexOf(value) !== -1) {
        dict.freq = value;
      } else {
        throw new Error(
          'invalid frequency "' + value + '" expected: "' +
          ALLOWED_FREQ.join(', ') + '"'
        );
      }
    },

    COUNT: function(value, dict, fmtIcal) {
      dict.count = ICAL.helpers.strictParseInt(value);
    },

    INTERVAL: function(value, dict, fmtIcal) {
      dict.interval = ICAL.helpers.strictParseInt(value);
      if (dict.interval < 1) {
        // 0 or negative values are not allowed, some engines seem to generate
        // it though. Assume 1 instead.
        dict.interval = 1;
      }
    },

    UNTIL: function(value, dict, fmtIcal) {
      if (value.length > 10) {
        dict.until = ICAL.design.icalendar.value['date-time'].fromICAL(value);
      } else {
        dict.until = ICAL.design.icalendar.value.date.fromICAL(value);
      }
      if (!fmtIcal) {
        dict.until = ICAL.Time.fromString(dict.until);
      }
    },

    WKST: function(value, dict, fmtIcal) {
      if (VALID_DAY_NAMES.test(value)) {
        dict.wkst = ICAL.Recur.icalDayToNumericDay(value);
      } else {
        throw new Error('invalid WKST value "' + value + '"');
      }
    }
  };

  var partDesign = {
    BYSECOND: parseNumericValue.bind(this, 'BYSECOND', 0, 60),
    BYMINUTE: parseNumericValue.bind(this, 'BYMINUTE', 0, 59),
    BYHOUR: parseNumericValue.bind(this, 'BYHOUR', 0, 23),
    BYDAY: function(value) {
      if (VALID_BYDAY_PART.test(value)) {
        return value;
      } else {
        throw new Error('invalid BYDAY value "' + value + '"');
      }
    },
    BYMONTHDAY: parseNumericValue.bind(this, 'BYMONTHDAY', -31, 31),
    BYYEARDAY: parseNumericValue.bind(this, 'BYYEARDAY', -366, 366),
    BYWEEKNO: parseNumericValue.bind(this, 'BYWEEKNO', -53, 53),
    BYMONTH: parseNumericValue.bind(this, 'BYMONTH', 1, 12),
    BYSETPOS: parseNumericValue.bind(this, 'BYSETPOS', -366, 366)
  };


  /**
   * Creates a new {@link ICAL.Recur} instance from the passed string.
   *
   * @param {String} string         The string to parse
   * @return {ICAL.Recur}           The created recurrence instance
   */
  ICAL.Recur.fromString = function(string) {
    var data = ICAL.Recur._stringToData(string, false);
    return new ICAL.Recur(data);
  };

  /**
   * Creates a new {@link ICAL.Recur} instance using members from the passed
   * data object.
   *
   * @param {Object} aData                              An object with members of the recurrence
   * @param {ICAL.Recur.frequencyValues=} aData.freq    The frequency value
   * @param {Number=} aData.interval                    The INTERVAL value
   * @param {ICAL.Time.weekDay=} aData.wkst             The week start value
   * @param {ICAL.Time=} aData.until                    The end of the recurrence set
   * @param {Number=} aData.count                       The number of occurrences
   * @param {Array.<Number>=} aData.bysecond            The seconds for the BYSECOND part
   * @param {Array.<Number>=} aData.byminute            The minutes for the BYMINUTE part
   * @param {Array.<Number>=} aData.byhour              The hours for the BYHOUR part
   * @param {Array.<String>=} aData.byday               The BYDAY values
   * @param {Array.<Number>=} aData.bymonthday          The days for the BYMONTHDAY part
   * @param {Array.<Number>=} aData.byyearday           The days for the BYYEARDAY part
   * @param {Array.<Number>=} aData.byweekno            The weeks for the BYWEEKNO part
   * @param {Array.<Number>=} aData.bymonth             The month for the BYMONTH part
   * @param {Array.<Number>=} aData.bysetpos            The positionals for the BYSETPOS part
   */
  ICAL.Recur.fromData = function(aData) {
    return new ICAL.Recur(aData);
  };

  /**
   * Converts a recurrence string to a data object, suitable for the fromData
   * method.
   *
   * @param {String} string     The string to parse
   * @param {Boolean} fmtIcal   If true, the string is considered to be an
   *                              iCalendar string
   * @return {ICAL.Recur}       The recurrence instance
   */
  ICAL.Recur._stringToData = function(string, fmtIcal) {
    var dict = Object.create(null);

    // split is slower in FF but fast enough.
    // v8 however this is faster then manual split?
    var values = string.split(';');
    var len = values.length;

    for (var i = 0; i < len; i++) {
      var parts = values[i].split('=');
      var ucname = parts[0].toUpperCase();
      var lcname = parts[0].toLowerCase();
      var name = (fmtIcal ? lcname : ucname);
      var value = parts[1];

      if (ucname in partDesign) {
        var partArr = value.split(',');
        var partArrIdx = 0;
        var partArrLen = partArr.length;

        for (; partArrIdx < partArrLen; partArrIdx++) {
          partArr[partArrIdx] = partDesign[ucname](partArr[partArrIdx]);
        }
        dict[name] = (partArr.length == 1 ? partArr[0] : partArr);
      } else if (ucname in optionDesign) {
        optionDesign[ucname](value, dict, fmtIcal);
      } else {
        // Don't swallow unknown values. Just set them as they are.
        dict[lcname] = value;
      }
    }

    return dict;
  };
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.RecurIterator = (function() {

  /**
   * @classdesc
   * An iterator for a single recurrence rule. This class usually doesn't have
   * to be instanciated directly, the convenience method
   * {@link ICAL.Recur#iterator} can be used.
   *
   * @description
   * The options object may contain additional members when resuming iteration from a previous run
   *
   * @description
   * The options object may contain additional members when resuming iteration
   * from a previous run.
   *
   * @class
   * @alias ICAL.RecurIterator
   * @param {Object} options                The iterator options
   * @param {ICAL.Recur} options.rule       The rule to iterate.
   * @param {ICAL.Time} options.dtstart     The start date of the event.
   * @param {Boolean=} options.initialized  When true, assume that options are
   *        from a previously constructed iterator. Initialization will not be
   *        repeated.
   */
  function icalrecur_iterator(options) {
    this.fromData(options);
  }

  icalrecur_iterator.prototype = {

    /**
     * True when iteration is finished.
     * @type {Boolean}
     */
    completed: false,

    /**
     * The rule that is being iterated
     * @type {ICAL.Recur}
     */
    rule: null,

    /**
     * The start date of the event being iterated.
     * @type {ICAL.Time}
     */
    dtstart: null,

    /**
     * The last occurrence that was returned from the
     * {@link ICAL.RecurIterator#next} method.
     * @type {ICAL.Time}
     */
    last: null,

    /**
     * The sequence number from the occurrence
     * @type {Number}
     */
    occurrence_number: 0,

    /**
     * The indices used for the {@link ICAL.RecurIterator#by_data} object.
     * @type {Object}
     * @private
     */
    by_indices: null,

    /**
     * If true, the iterator has already been initialized
     * @type {Boolean}
     * @private
     */
    initialized: false,

    /**
     * The initializd by-data.
     * @type {Object}
     * @private
     */
    by_data: null,

    /**
     * The expanded yeardays
     * @type {Array}
     * @private
     */
    days: null,

    /**
     * The index in the {@link ICAL.RecurIterator#days} array.
     * @type {Number}
     * @private
     */
    days_index: 0,

    /**
     * Initialize the recurrence iterator from the passed data object. This
     * method is usually not called directly, you can initialize the iterator
     * through the constructor.
     *
     * @param {Object} options                The iterator options
     * @param {ICAL.Recur} options.rule       The rule to iterate.
     * @param {ICAL.Time} options.dtstart     The start date of the event.
     * @param {Boolean=} options.initialized  When true, assume that options are
     *        from a previously constructed iterator. Initialization will not be
     *        repeated.
     */
    fromData: function(options) {
      this.rule = ICAL.helpers.formatClassType(options.rule, ICAL.Recur);

      if (!this.rule) {
        throw new Error('iterator requires a (ICAL.Recur) rule');
      }

      this.dtstart = ICAL.helpers.formatClassType(options.dtstart, ICAL.Time);

      if (!this.dtstart) {
        throw new Error('iterator requires a (ICAL.Time) dtstart');
      }

      if (options.by_data) {
        this.by_data = options.by_data;
      } else {
        this.by_data = ICAL.helpers.clone(this.rule.parts, true);
      }

      if (options.occurrence_number)
        this.occurrence_number = options.occurrence_number;

      this.days = options.days || [];
      if (options.last) {
        this.last = ICAL.helpers.formatClassType(options.last, ICAL.Time);
      }

      this.by_indices = options.by_indices;

      if (!this.by_indices) {
        this.by_indices = {
          "BYSECOND": 0,
          "BYMINUTE": 0,
          "BYHOUR": 0,
          "BYDAY": 0,
          "BYMONTH": 0,
          "BYWEEKNO": 0,
          "BYMONTHDAY": 0
        };
      }

      this.initialized = options.initialized || false;

      if (!this.initialized) {
        this.init();
      }
    },

    /**
     * Intialize the iterator
     * @private
     */
    init: function icalrecur_iterator_init() {
      this.initialized = true;
      this.last = this.dtstart.clone();
      var parts = this.by_data;

      if ("BYDAY" in parts) {
        // libical does this earlier when the rule is loaded, but we postpone to
        // now so we can preserve the original order.
        this.sort_byday_rules(parts.BYDAY);
      }

      // If the BYYEARDAY appares, no other date rule part may appear
      if ("BYYEARDAY" in parts) {
        if ("BYMONTH" in parts || "BYWEEKNO" in parts ||
            "BYMONTHDAY" in parts || "BYDAY" in parts) {
          throw new Error("Invalid BYYEARDAY rule");
        }
      }

      // BYWEEKNO and BYMONTHDAY rule parts may not both appear
      if ("BYWEEKNO" in parts && "BYMONTHDAY" in parts) {
        throw new Error("BYWEEKNO does not fit to BYMONTHDAY");
      }

      // For MONTHLY recurrences (FREQ=MONTHLY) neither BYYEARDAY nor
      // BYWEEKNO may appear.
      if (this.rule.freq == "MONTHLY" &&
          ("BYYEARDAY" in parts || "BYWEEKNO" in parts)) {
        throw new Error("For MONTHLY recurrences neither BYYEARDAY nor BYWEEKNO may appear");
      }

      // For WEEKLY recurrences (FREQ=WEEKLY) neither BYMONTHDAY nor
      // BYYEARDAY may appear.
      if (this.rule.freq == "WEEKLY" &&
          ("BYYEARDAY" in parts || "BYMONTHDAY" in parts)) {
        throw new Error("For WEEKLY recurrences neither BYMONTHDAY nor BYYEARDAY may appear");
      }

      // BYYEARDAY may only appear in YEARLY rules
      if (this.rule.freq != "YEARLY" && "BYYEARDAY" in parts) {
        throw new Error("BYYEARDAY may only appear in YEARLY rules");
      }

      this.last.second = this.setup_defaults("BYSECOND", "SECONDLY", this.dtstart.second);
      this.last.minute = this.setup_defaults("BYMINUTE", "MINUTELY", this.dtstart.minute);
      this.last.hour = this.setup_defaults("BYHOUR", "HOURLY", this.dtstart.hour);
      this.last.day = this.setup_defaults("BYMONTHDAY", "DAILY", this.dtstart.day);
      this.last.month = this.setup_defaults("BYMONTH", "MONTHLY", this.dtstart.month);

      if (this.rule.freq == "WEEKLY") {
        if ("BYDAY" in parts) {
          var bydayParts = this.ruleDayOfWeek(parts.BYDAY[0], this.rule.wkst);
          var pos = bydayParts[0];
          var dow = bydayParts[1];
          var wkdy = dow - this.last.dayOfWeek(this.rule.wkst);
          if ((this.last.dayOfWeek(this.rule.wkst) < dow && wkdy >= 0) || wkdy < 0) {
            // Initial time is after first day of BYDAY data
            this.last.day += wkdy;
          }
        } else {
          var dayName = ICAL.Recur.numericDayToIcalDay(this.dtstart.dayOfWeek());
          parts.BYDAY = [dayName];
        }
      }

      if (this.rule.freq == "YEARLY") {
        for (;;) {
          this.expand_year_days(this.last.year);
          if (this.days.length > 0) {
            break;
          }
          this.increment_year(this.rule.interval);
        }

        this._nextByYearDay();
      }

      if (this.rule.freq == "MONTHLY" && this.has_by_data("BYDAY")) {
        var tempLast = null;
        var initLast = this.last.clone();
        var daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);

        // Check every weekday in BYDAY with relative dow and pos.
        for (var i in this.by_data.BYDAY) {
          /* istanbul ignore if */
          if (!this.by_data.BYDAY.hasOwnProperty(i)) {
            continue;
          }
          this.last = initLast.clone();
          var bydayParts = this.ruleDayOfWeek(this.by_data.BYDAY[i]);
          var pos = bydayParts[0];
          var dow = bydayParts[1];
          var dayOfMonth = this.last.nthWeekDay(dow, pos);

          // If |pos| >= 6, the byday is invalid for a monthly rule.
          if (pos >= 6 || pos <= -6) {
            throw new Error("Malformed values in BYDAY part");
          }

          // If a Byday with pos=+/-5 is not in the current month it
          // must be searched in the next months.
          if (dayOfMonth > daysInMonth || dayOfMonth <= 0) {
            // Skip if we have already found a "last" in this month.
            if (tempLast && tempLast.month == initLast.month) {
              continue;
            }
            while (dayOfMonth > daysInMonth || dayOfMonth <= 0) {
              this.increment_month();
              daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);
              dayOfMonth = this.last.nthWeekDay(dow, pos);
            }
          }

          this.last.day = dayOfMonth;
          if (!tempLast || this.last.compare(tempLast) < 0) {
            tempLast = this.last.clone();
          }
        }
        this.last = tempLast.clone();

        //XXX: This feels like a hack, but we need to initialize
        //     the BYMONTHDAY case correctly and byDayAndMonthDay handles
        //     this case. It accepts a special flag which will avoid incrementing
        //     the initial value without the flag days that match the start time
        //     would be missed.
        if (this.has_by_data('BYMONTHDAY')) {
          this._byDayAndMonthDay(true);
        }

        if (this.last.day > daysInMonth || this.last.day == 0) {
          throw new Error("Malformed values in BYDAY part");
        }

      } else if (this.has_by_data("BYMONTHDAY")) {
        if (this.last.day < 0) {
          var daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);
          this.last.day = daysInMonth + this.last.day + 1;
        }
      }

    },

    /**
     * Retrieve the next occurrence from the iterator.
     * @return {ICAL.Time}
     */
    next: function icalrecur_iterator_next() {
      var before = (this.last ? this.last.clone() : null);

      if ((this.rule.count && this.occurrence_number >= this.rule.count) ||
          (this.rule.until && this.last.compare(this.rule.until) > 0)) {

        //XXX: right now this is just a flag and has no impact
        //     we can simplify the above case to check for completed later.
        this.completed = true;

        return null;
      }

      if (this.occurrence_number == 0 && this.last.compare(this.dtstart) >= 0) {
        // First of all, give the instance that was initialized
        this.occurrence_number++;
        return this.last;
      }


      var valid;
      do {
        valid = 1;

        switch (this.rule.freq) {
        case "SECONDLY":
          this.next_second();
          break;
        case "MINUTELY":
          this.next_minute();
          break;
        case "HOURLY":
          this.next_hour();
          break;
        case "DAILY":
          this.next_day();
          break;
        case "WEEKLY":
          this.next_week();
          break;
        case "MONTHLY":
          valid = this.next_month();
          break;
        case "YEARLY":
          this.next_year();
          break;

        default:
          return null;
        }
      } while (!this.check_contracting_rules() ||
               this.last.compare(this.dtstart) < 0 ||
               !valid);

      // TODO is this valid?
      if (this.last.compare(before) == 0) {
        throw new Error("Same occurrence found twice, protecting " +
                        "you from death by recursion");
      }

      if (this.rule.until && this.last.compare(this.rule.until) > 0) {
        this.completed = true;
        return null;
      } else {
        this.occurrence_number++;
        return this.last;
      }
    },

    next_second: function next_second() {
      return this.next_generic("BYSECOND", "SECONDLY", "second", "minute");
    },

    increment_second: function increment_second(inc) {
      return this.increment_generic(inc, "second", 60, "minute");
    },

    next_minute: function next_minute() {
      return this.next_generic("BYMINUTE", "MINUTELY",
                               "minute", "hour", "next_second");
    },

    increment_minute: function increment_minute(inc) {
      return this.increment_generic(inc, "minute", 60, "hour");
    },

    next_hour: function next_hour() {
      return this.next_generic("BYHOUR", "HOURLY", "hour",
                               "monthday", "next_minute");
    },

    increment_hour: function increment_hour(inc) {
      this.increment_generic(inc, "hour", 24, "monthday");
    },

    next_day: function next_day() {
      var has_by_day = ("BYDAY" in this.by_data);
      var this_freq = (this.rule.freq == "DAILY");

      if (this.next_hour() == 0) {
        return 0;
      }

      if (this_freq) {
        this.increment_monthday(this.rule.interval);
      } else {
        this.increment_monthday(1);
      }

      return 0;
    },

    next_week: function next_week() {
      var end_of_data = 0;

      if (this.next_weekday_by_week() == 0) {
        return end_of_data;
      }

      if (this.has_by_data("BYWEEKNO")) {
        var idx = ++this.by_indices.BYWEEKNO;

        if (this.by_indices.BYWEEKNO == this.by_data.BYWEEKNO.length) {
          this.by_indices.BYWEEKNO = 0;
          end_of_data = 1;
        }

        // HACK should be first month of the year
        this.last.month = 1;
        this.last.day = 1;

        var week_no = this.by_data.BYWEEKNO[this.by_indices.BYWEEKNO];

        this.last.day += 7 * week_no;

        if (end_of_data) {
          this.increment_year(1);
        }
      } else {
        // Jump to the next week
        this.increment_monthday(7 * this.rule.interval);
      }

      return end_of_data;
    },

    /**
     * Normalize each by day rule for a given year/month.
     * Takes into account ordering and negative rules
     *
     * @private
     * @param {Number} year         Current year.
     * @param {Number} month        Current month.
     * @param {Array}  rules        Array of rules.
     *
     * @return {Array} sorted and normalized rules.
     *                 Negative rules will be expanded to their
     *                 correct positive values for easier processing.
     */
    normalizeByMonthDayRules: function(year, month, rules) {
      var daysInMonth = ICAL.Time.daysInMonth(month, year);

      // XXX: This is probably bad for performance to allocate
      //      a new array for each month we scan, if possible
      //      we should try to optimize this...
      var newRules = [];

      var ruleIdx = 0;
      var len = rules.length;
      var rule;

      for (; ruleIdx < len; ruleIdx++) {
        rule = rules[ruleIdx];

        // if this rule falls outside of given
        // month discard it.
        if (Math.abs(rule) > daysInMonth) {
          continue;
        }

        // negative case
        if (rule < 0) {
          // we add (not subtract it is a negative number)
          // one from the rule because 1 === last day of month
          rule = daysInMonth + (rule + 1);
        } else if (rule === 0) {
          // skip zero: it is invalid.
          continue;
        }

        // only add unique items...
        if (newRules.indexOf(rule) === -1) {
          newRules.push(rule);
        }

      }

      // unique and sort
      return newRules.sort(function(a, b) { return a - b; });
    },

    /**
     * NOTES:
     * We are given a list of dates in the month (BYMONTHDAY) (23, etc..)
     * Also we are given a list of days (BYDAY) (MO, 2SU, etc..) when
     * both conditions match a given date (this.last.day) iteration stops.
     *
     * @private
     * @param {Boolean=} isInit     When given true will not increment the
     *                                current day (this.last).
     */
    _byDayAndMonthDay: function(isInit) {
      var byMonthDay; // setup in initMonth
      var byDay = this.by_data.BYDAY;

      var date;
      var dateIdx = 0;
      var dateLen; // setup in initMonth
      var dayLen = byDay.length;

      // we are not valid by default
      var dataIsValid = 0;

      var daysInMonth;
      var self = this;
      // we need a copy of this, because a DateTime gets normalized
      // automatically if the day is out of range. At some points we
      // set the last day to 0 to start counting.
      var lastDay = this.last.day;

      function initMonth() {
        daysInMonth = ICAL.Time.daysInMonth(
          self.last.month, self.last.year
        );

        byMonthDay = self.normalizeByMonthDayRules(
          self.last.year,
          self.last.month,
          self.by_data.BYMONTHDAY
        );

        dateLen = byMonthDay.length;

        // For the case of more than one occurrence in one month
        // we have to be sure to start searching after the last
        // found date or at the last BYMONTHDAY, unless we are
        // initializing the iterator because in this case we have
        // to consider the last found date too.
        while (byMonthDay[dateIdx] <= lastDay &&
               !(isInit && byMonthDay[dateIdx] == lastDay) &&
               dateIdx < dateLen - 1) {
          dateIdx++;
        }
      }

      function nextMonth() {
        // since the day is incremented at the start
        // of the loop below, we need to start at 0
        lastDay = 0;
        self.increment_month();
        dateIdx = 0;
        initMonth();
      }

      initMonth();

      // should come after initMonth
      if (isInit) {
        lastDay -= 1;
      }

      // Use a counter to avoid an infinite loop with malformed rules.
      // Stop checking after 4 years so we consider also a leap year.
      var monthsCounter = 48;

      while (!dataIsValid && monthsCounter) {
        monthsCounter--;
        // increment the current date. This is really
        // important otherwise we may fall into the infinite
        // loop trap. The initial date takes care of the case
        // where the current date is the date we are looking
        // for.
        date = lastDay + 1;

        if (date > daysInMonth) {
          nextMonth();
          continue;
        }

        // find next date
        var next = byMonthDay[dateIdx++];

        // this logic is dependant on the BYMONTHDAYS
        // being in order (which is done by #normalizeByMonthDayRules)
        if (next >= date) {
          // if the next month day is in the future jump to it.
          lastDay = next;
        } else {
          // in this case the 'next' monthday has past
          // we must move to the month.
          nextMonth();
          continue;
        }

        // Now we can loop through the day rules to see
        // if one matches the current month date.
        for (var dayIdx = 0; dayIdx < dayLen; dayIdx++) {
          var parts = this.ruleDayOfWeek(byDay[dayIdx]);
          var pos = parts[0];
          var dow = parts[1];

          this.last.day = lastDay;
          if (this.last.isNthWeekDay(dow, pos)) {
            // when we find the valid one we can mark
            // the conditions as met and break the loop.
            // (Because we have this condition above
            //  it will also break the parent loop).
            dataIsValid = 1;
            break;
          }
        }

        // It is completely possible that the combination
        // cannot be matched in the current month.
        // When we reach the end of possible combinations
        // in the current month we iterate to the next one.
        // since dateIdx is incremented right after getting
        // "next", we don't need dateLen -1 here.
        if (!dataIsValid && dateIdx === dateLen) {
          nextMonth();
          continue;
        }
      }

      if (monthsCounter <= 0) {
        // Checked 4 years without finding a Byday that matches
        // a Bymonthday. Maybe the rule is not correct.
        throw new Error("Malformed values in BYDAY combined with BYMONTHDAY parts");
      }


      return dataIsValid;
    },

    next_month: function next_month() {
      var this_freq = (this.rule.freq == "MONTHLY");
      var data_valid = 1;

      if (this.next_hour() == 0) {
        return data_valid;
      }

      if (this.has_by_data("BYDAY") && this.has_by_data("BYMONTHDAY")) {
        data_valid = this._byDayAndMonthDay();
      } else if (this.has_by_data("BYDAY")) {
        var daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);
        var setpos = 0;
        var setpos_total = 0;

        if (this.has_by_data("BYSETPOS")) {
          var last_day = this.last.day;
          for (var day = 1; day <= daysInMonth; day++) {
            this.last.day = day;
            if (this.is_day_in_byday(this.last)) {
              setpos_total++;
              if (day <= last_day) {
                setpos++;
              }
            }
          }
          this.last.day = last_day;
        }

        data_valid = 0;
        for (var day = this.last.day + 1; day <= daysInMonth; day++) {
          this.last.day = day;

          if (this.is_day_in_byday(this.last)) {
            if (!this.has_by_data("BYSETPOS") ||
                this.check_set_position(++setpos) ||
                this.check_set_position(setpos - setpos_total - 1)) {

              data_valid = 1;
              break;
            }
          }
        }

        if (day > daysInMonth) {
          this.last.day = 1;
          this.increment_month();

          if (this.is_day_in_byday(this.last)) {
            if (!this.has_by_data("BYSETPOS") || this.check_set_position(1)) {
              data_valid = 1;
            }
          } else {
            data_valid = 0;
          }
        }
      } else if (this.has_by_data("BYMONTHDAY")) {
        this.by_indices.BYMONTHDAY++;

        if (this.by_indices.BYMONTHDAY >= this.by_data.BYMONTHDAY.length) {
          this.by_indices.BYMONTHDAY = 0;
          this.increment_month();
        }

        var daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);
        var day = this.by_data.BYMONTHDAY[this.by_indices.BYMONTHDAY];

        if (day < 0) {
          day = daysInMonth + day + 1;
        }

        if (day > daysInMonth) {
          this.last.day = 1;
          data_valid = this.is_day_in_byday(this.last);
        } else {
          this.last.day = day;
        }

      } else {
        this.increment_month();
        var daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);
        if (this.by_data.BYMONTHDAY[0] > daysInMonth) {
          data_valid = 0;
        } else {
          this.last.day = this.by_data.BYMONTHDAY[0];
        }
      }

      return data_valid;
    },

    next_weekday_by_week: function next_weekday_by_week() {
      var end_of_data = 0;

      if (this.next_hour() == 0) {
        return end_of_data;
      }

      if (!this.has_by_data("BYDAY")) {
        return 1;
      }

      for (;;) {
        var tt = new ICAL.Time();
        this.by_indices.BYDAY++;

        if (this.by_indices.BYDAY == Object.keys(this.by_data.BYDAY).length) {
          this.by_indices.BYDAY = 0;
          end_of_data = 1;
        }

        var coded_day = this.by_data.BYDAY[this.by_indices.BYDAY];
        var parts = this.ruleDayOfWeek(coded_day);
        var dow = parts[1];

        dow -= this.rule.wkst;

        if (dow < 0) {
          dow += 7;
        }

        tt.year = this.last.year;
        tt.month = this.last.month;
        tt.day = this.last.day;

        var startOfWeek = tt.startDoyWeek(this.rule.wkst);

        if (dow + startOfWeek < 1) {
          // The selected date is in the previous year
          if (!end_of_data) {
            continue;
          }
        }

        var next = ICAL.Time.fromDayOfYear(startOfWeek + dow,
                                                  this.last.year);

        /**
         * The normalization horrors below are due to
         * the fact that when the year/month/day changes
         * it can effect the other operations that come after.
         */
        this.last.year = next.year;
        this.last.month = next.month;
        this.last.day = next.day;

        return end_of_data;
      }
    },

    next_year: function next_year() {

      if (this.next_hour() == 0) {
        return 0;
      }

      if (++this.days_index == this.days.length) {
        this.days_index = 0;
        do {
          this.increment_year(this.rule.interval);
          this.expand_year_days(this.last.year);
        } while (this.days.length == 0);
      }

      this._nextByYearDay();

      return 1;
    },

    _nextByYearDay: function _nextByYearDay() {
        var doy = this.days[this.days_index];
        var year = this.last.year;
        if (doy < 1) {
            // Time.fromDayOfYear(doy, year) indexes relative to the
            // start of the given year. That is different from the
            // semantics of BYYEARDAY where negative indexes are an
            // offset from the end of the given year.
            doy += 1;
            year += 1;
        }
        var next = ICAL.Time.fromDayOfYear(doy, year);
        this.last.day = next.day;
        this.last.month = next.month;
    },

    /**
     * @param dow (eg: '1TU', '-1MO')
     * @param {ICAL.Time.weekDay=} aWeekStart The week start weekday
     * @return [pos, numericDow] (eg: [1, 3]) numericDow is relative to aWeekStart
     */
    ruleDayOfWeek: function ruleDayOfWeek(dow, aWeekStart) {
      var matches = dow.match(/([+-]?[0-9])?(MO|TU|WE|TH|FR|SA|SU)/);
      if (matches) {
        var pos = parseInt(matches[1] || 0, 10);
        dow = ICAL.Recur.icalDayToNumericDay(matches[2], aWeekStart);
        return [pos, dow];
      } else {
        return [0, 0];
      }
    },

    next_generic: function next_generic(aRuleType, aInterval, aDateAttr,
                                        aFollowingAttr, aPreviousIncr) {
      var has_by_rule = (aRuleType in this.by_data);
      var this_freq = (this.rule.freq == aInterval);
      var end_of_data = 0;

      if (aPreviousIncr && this[aPreviousIncr]() == 0) {
        return end_of_data;
      }

      if (has_by_rule) {
        this.by_indices[aRuleType]++;
        var idx = this.by_indices[aRuleType];
        var dta = this.by_data[aRuleType];

        if (this.by_indices[aRuleType] == dta.length) {
          this.by_indices[aRuleType] = 0;
          end_of_data = 1;
        }
        this.last[aDateAttr] = dta[this.by_indices[aRuleType]];
      } else if (this_freq) {
        this["increment_" + aDateAttr](this.rule.interval);
      }

      if (has_by_rule && end_of_data && this_freq) {
        this["increment_" + aFollowingAttr](1);
      }

      return end_of_data;
    },

    increment_monthday: function increment_monthday(inc) {
      for (var i = 0; i < inc; i++) {
        var daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);
        this.last.day++;

        if (this.last.day > daysInMonth) {
          this.last.day -= daysInMonth;
          this.increment_month();
        }
      }
    },

    increment_month: function increment_month() {
      this.last.day = 1;
      if (this.has_by_data("BYMONTH")) {
        this.by_indices.BYMONTH++;

        if (this.by_indices.BYMONTH == this.by_data.BYMONTH.length) {
          this.by_indices.BYMONTH = 0;
          this.increment_year(1);
        }

        this.last.month = this.by_data.BYMONTH[this.by_indices.BYMONTH];
      } else {
        if (this.rule.freq == "MONTHLY") {
          this.last.month += this.rule.interval;
        } else {
          this.last.month++;
        }

        this.last.month--;
        var years = ICAL.helpers.trunc(this.last.month / 12);
        this.last.month %= 12;
        this.last.month++;

        if (years != 0) {
          this.increment_year(years);
        }
      }
    },

    increment_year: function increment_year(inc) {
      this.last.year += inc;
    },

    increment_generic: function increment_generic(inc, aDateAttr,
                                                  aFactor, aNextIncrement) {
      this.last[aDateAttr] += inc;
      var nextunit = ICAL.helpers.trunc(this.last[aDateAttr] / aFactor);
      this.last[aDateAttr] %= aFactor;
      if (nextunit != 0) {
        this["increment_" + aNextIncrement](nextunit);
      }
    },

    has_by_data: function has_by_data(aRuleType) {
      return (aRuleType in this.rule.parts);
    },

    expand_year_days: function expand_year_days(aYear) {
      var t = new ICAL.Time();
      this.days = [];

      // We need our own copy with a few keys set
      var parts = {};
      var rules = ["BYDAY", "BYWEEKNO", "BYMONTHDAY", "BYMONTH", "BYYEARDAY"];
      for (var p in rules) {
        /* istanbul ignore else */
        if (rules.hasOwnProperty(p)) {
          var part = rules[p];
          if (part in this.rule.parts) {
            parts[part] = this.rule.parts[part];
          }
        }
      }

      if ("BYMONTH" in parts && "BYWEEKNO" in parts) {
        var valid = 1;
        var validWeeks = {};
        t.year = aYear;
        t.isDate = true;

        for (var monthIdx = 0; monthIdx < this.by_data.BYMONTH.length; monthIdx++) {
          var month = this.by_data.BYMONTH[monthIdx];
          t.month = month;
          t.day = 1;
          var first_week = t.weekNumber(this.rule.wkst);
          t.day = ICAL.Time.daysInMonth(month, aYear);
          var last_week = t.weekNumber(this.rule.wkst);
          for (monthIdx = first_week; monthIdx < last_week; monthIdx++) {
            validWeeks[monthIdx] = 1;
          }
        }

        for (var weekIdx = 0; weekIdx < this.by_data.BYWEEKNO.length && valid; weekIdx++) {
          var weekno = this.by_data.BYWEEKNO[weekIdx];
          if (weekno < 52) {
            valid &= validWeeks[weekIdx];
          } else {
            valid = 0;
          }
        }

        if (valid) {
          delete parts.BYMONTH;
        } else {
          delete parts.BYWEEKNO;
        }
      }

      var partCount = Object.keys(parts).length;

      if (partCount == 0) {
        var t1 = this.dtstart.clone();
        t1.year = this.last.year;
        this.days.push(t1.dayOfYear());
      } else if (partCount == 1 && "BYMONTH" in parts) {
        for (var monthkey in this.by_data.BYMONTH) {
          /* istanbul ignore if */
          if (!this.by_data.BYMONTH.hasOwnProperty(monthkey)) {
            continue;
          }
          var t2 = this.dtstart.clone();
          t2.year = aYear;
          t2.month = this.by_data.BYMONTH[monthkey];
          t2.isDate = true;
          this.days.push(t2.dayOfYear());
        }
      } else if (partCount == 1 && "BYMONTHDAY" in parts) {
        for (var monthdaykey in this.by_data.BYMONTHDAY) {
          /* istanbul ignore if */
          if (!this.by_data.BYMONTHDAY.hasOwnProperty(monthdaykey)) {
            continue;
          }
          var t3 = this.dtstart.clone();
          var day_ = this.by_data.BYMONTHDAY[monthdaykey];
          if (day_ < 0) {
            var daysInMonth = ICAL.Time.daysInMonth(t3.month, aYear);
            day_ = day_ + daysInMonth + 1;
          }
          t3.day = day_;
          t3.year = aYear;
          t3.isDate = true;
          this.days.push(t3.dayOfYear());
        }
      } else if (partCount == 2 &&
                 "BYMONTHDAY" in parts &&
                 "BYMONTH" in parts) {
        for (var monthkey in this.by_data.BYMONTH) {
          /* istanbul ignore if */
          if (!this.by_data.BYMONTH.hasOwnProperty(monthkey)) {
            continue;
          }
          var month_ = this.by_data.BYMONTH[monthkey];
          var daysInMonth = ICAL.Time.daysInMonth(month_, aYear);
          for (var monthdaykey in this.by_data.BYMONTHDAY) {
            /* istanbul ignore if */
            if (!this.by_data.BYMONTHDAY.hasOwnProperty(monthdaykey)) {
              continue;
            }
            var day_ = this.by_data.BYMONTHDAY[monthdaykey];
            if (day_ < 0) {
              day_ = day_ + daysInMonth + 1;
            }
            t.day = day_;
            t.month = month_;
            t.year = aYear;
            t.isDate = true;

            this.days.push(t.dayOfYear());
          }
        }
      } else if (partCount == 1 && "BYWEEKNO" in parts) {
        // TODO unimplemented in libical
      } else if (partCount == 2 &&
                 "BYWEEKNO" in parts &&
                 "BYMONTHDAY" in parts) {
        // TODO unimplemented in libical
      } else if (partCount == 1 && "BYDAY" in parts) {
        this.days = this.days.concat(this.expand_by_day(aYear));
      } else if (partCount == 2 && "BYDAY" in parts && "BYMONTH" in parts) {
        for (var monthkey in this.by_data.BYMONTH) {
          /* istanbul ignore if */
          if (!this.by_data.BYMONTH.hasOwnProperty(monthkey)) {
            continue;
          }
          var month = this.by_data.BYMONTH[monthkey];
          var daysInMonth = ICAL.Time.daysInMonth(month, aYear);

          t.year = aYear;
          t.month = this.by_data.BYMONTH[monthkey];
          t.day = 1;
          t.isDate = true;

          var first_dow = t.dayOfWeek();
          var doy_offset = t.dayOfYear() - 1;

          t.day = daysInMonth;
          var last_dow = t.dayOfWeek();

          if (this.has_by_data("BYSETPOS")) {
            var set_pos_counter = 0;
            var by_month_day = [];
            for (var day = 1; day <= daysInMonth; day++) {
              t.day = day;
              if (this.is_day_in_byday(t)) {
                by_month_day.push(day);
              }
            }

            for (var spIndex = 0; spIndex < by_month_day.length; spIndex++) {
              if (this.check_set_position(spIndex + 1) ||
                  this.check_set_position(spIndex - by_month_day.length)) {
                this.days.push(doy_offset + by_month_day[spIndex]);
              }
            }
          } else {
            for (var daycodedkey in this.by_data.BYDAY) {
              /* istanbul ignore if */
              if (!this.by_data.BYDAY.hasOwnProperty(daycodedkey)) {
                continue;
              }
              var coded_day = this.by_data.BYDAY[daycodedkey];
              var bydayParts = this.ruleDayOfWeek(coded_day);
              var pos = bydayParts[0];
              var dow = bydayParts[1];
              var month_day;

              var first_matching_day = ((dow + 7 - first_dow) % 7) + 1;
              var last_matching_day = daysInMonth - ((last_dow + 7 - dow) % 7);

              if (pos == 0) {
                for (var day = first_matching_day; day <= daysInMonth; day += 7) {
                  this.days.push(doy_offset + day);
                }
              } else if (pos > 0) {
                month_day = first_matching_day + (pos - 1) * 7;

                if (month_day <= daysInMonth) {
                  this.days.push(doy_offset + month_day);
                }
              } else {
                month_day = last_matching_day + (pos + 1) * 7;

                if (month_day > 0) {
                  this.days.push(doy_offset + month_day);
                }
              }
            }
          }
        }
        // Return dates in order of occurrence (1,2,3,...) instead
        // of by groups of weekdays (1,8,15,...,2,9,16,...).
        this.days.sort(function(a, b) { return a - b; }); // Comparator function allows to sort numbers.
      } else if (partCount == 2 && "BYDAY" in parts && "BYMONTHDAY" in parts) {
        var expandedDays = this.expand_by_day(aYear);

        for (var daykey in expandedDays) {
          /* istanbul ignore if */
          if (!expandedDays.hasOwnProperty(daykey)) {
            continue;
          }
          var day = expandedDays[daykey];
          var tt = ICAL.Time.fromDayOfYear(day, aYear);
          if (this.by_data.BYMONTHDAY.indexOf(tt.day) >= 0) {
            this.days.push(day);
          }
        }
      } else if (partCount == 3 &&
                 "BYDAY" in parts &&
                 "BYMONTHDAY" in parts &&
                 "BYMONTH" in parts) {
        var expandedDays = this.expand_by_day(aYear);

        for (var daykey in expandedDays) {
          /* istanbul ignore if */
          if (!expandedDays.hasOwnProperty(daykey)) {
            continue;
          }
          var day = expandedDays[daykey];
          var tt = ICAL.Time.fromDayOfYear(day, aYear);

          if (this.by_data.BYMONTH.indexOf(tt.month) >= 0 &&
              this.by_data.BYMONTHDAY.indexOf(tt.day) >= 0) {
            this.days.push(day);
          }
        }
      } else if (partCount == 2 && "BYDAY" in parts && "BYWEEKNO" in parts) {
        var expandedDays = this.expand_by_day(aYear);

        for (var daykey in expandedDays) {
          /* istanbul ignore if */
          if (!expandedDays.hasOwnProperty(daykey)) {
            continue;
          }
          var day = expandedDays[daykey];
          var tt = ICAL.Time.fromDayOfYear(day, aYear);
          var weekno = tt.weekNumber(this.rule.wkst);

          if (this.by_data.BYWEEKNO.indexOf(weekno)) {
            this.days.push(day);
          }
        }
      } else if (partCount == 3 &&
                 "BYDAY" in parts &&
                 "BYWEEKNO" in parts &&
                 "BYMONTHDAY" in parts) {
        // TODO unimplemted in libical
      } else if (partCount == 1 && "BYYEARDAY" in parts) {
        this.days = this.days.concat(this.by_data.BYYEARDAY);
      } else {
        this.days = [];
      }
      return 0;
    },

    expand_by_day: function expand_by_day(aYear) {

      var days_list = [];
      var tmp = this.last.clone();

      tmp.year = aYear;
      tmp.month = 1;
      tmp.day = 1;
      tmp.isDate = true;

      var start_dow = tmp.dayOfWeek();

      tmp.month = 12;
      tmp.day = 31;
      tmp.isDate = true;

      var end_dow = tmp.dayOfWeek();
      var end_year_day = tmp.dayOfYear();

      for (var daykey in this.by_data.BYDAY) {
        /* istanbul ignore if */
        if (!this.by_data.BYDAY.hasOwnProperty(daykey)) {
          continue;
        }
        var day = this.by_data.BYDAY[daykey];
        var parts = this.ruleDayOfWeek(day);
        var pos = parts[0];
        var dow = parts[1];

        if (pos == 0) {
          var tmp_start_doy = ((dow + 7 - start_dow) % 7) + 1;

          for (var doy = tmp_start_doy; doy <= end_year_day; doy += 7) {
            days_list.push(doy);
          }

        } else if (pos > 0) {
          var first;
          if (dow >= start_dow) {
            first = dow - start_dow + 1;
          } else {
            first = dow - start_dow + 8;
          }

          days_list.push(first + (pos - 1) * 7);
        } else {
          var last;
          pos = -pos;

          if (dow <= end_dow) {
            last = end_year_day - end_dow + dow;
          } else {
            last = end_year_day - end_dow + dow - 7;
          }

          days_list.push(last - (pos - 1) * 7);
        }
      }
      return days_list;
    },

    is_day_in_byday: function is_day_in_byday(tt) {
      for (var daykey in this.by_data.BYDAY) {
        /* istanbul ignore if */
        if (!this.by_data.BYDAY.hasOwnProperty(daykey)) {
          continue;
        }
        var day = this.by_data.BYDAY[daykey];
        var parts = this.ruleDayOfWeek(day);
        var pos = parts[0];
        var dow = parts[1];
        var this_dow = tt.dayOfWeek();

        if ((pos == 0 && dow == this_dow) ||
            (tt.nthWeekDay(dow, pos) == tt.day)) {
          return 1;
        }
      }

      return 0;
    },

    /**
     * Checks if given value is in BYSETPOS.
     *
     * @private
     * @param {Numeric} aPos position to check for.
     * @return {Boolean} false unless BYSETPOS rules exist
     *                   and the given value is present in rules.
     */
    check_set_position: function check_set_position(aPos) {
      if (this.has_by_data('BYSETPOS')) {
        var idx = this.by_data.BYSETPOS.indexOf(aPos);
        // negative numbers are not false-y
        return idx !== -1;
      }
      return false;
    },

    sort_byday_rules: function icalrecur_sort_byday_rules(aRules) {
      for (var i = 0; i < aRules.length; i++) {
        for (var j = 0; j < i; j++) {
          var one = this.ruleDayOfWeek(aRules[j], this.rule.wkst)[1];
          var two = this.ruleDayOfWeek(aRules[i], this.rule.wkst)[1];

          if (one > two) {
            var tmp = aRules[i];
            aRules[i] = aRules[j];
            aRules[j] = tmp;
          }
        }
      }
    },

    check_contract_restriction: function check_contract_restriction(aRuleType, v) {
      var indexMapValue = icalrecur_iterator._indexMap[aRuleType];
      var ruleMapValue = icalrecur_iterator._expandMap[this.rule.freq][indexMapValue];
      var pass = false;

      if (aRuleType in this.by_data &&
          ruleMapValue == icalrecur_iterator.CONTRACT) {

        var ruleType = this.by_data[aRuleType];

        for (var bydatakey in ruleType) {
          /* istanbul ignore else */
          if (ruleType.hasOwnProperty(bydatakey)) {
            if (ruleType[bydatakey] == v) {
              pass = true;
              break;
            }
          }
        }
      } else {
        // Not a contracting byrule or has no data, test passes
        pass = true;
      }
      return pass;
    },

    check_contracting_rules: function check_contracting_rules() {
      var dow = this.last.dayOfWeek();
      var weekNo = this.last.weekNumber(this.rule.wkst);
      var doy = this.last.dayOfYear();

      return (this.check_contract_restriction("BYSECOND", this.last.second) &&
              this.check_contract_restriction("BYMINUTE", this.last.minute) &&
              this.check_contract_restriction("BYHOUR", this.last.hour) &&
              this.check_contract_restriction("BYDAY", ICAL.Recur.numericDayToIcalDay(dow)) &&
              this.check_contract_restriction("BYWEEKNO", weekNo) &&
              this.check_contract_restriction("BYMONTHDAY", this.last.day) &&
              this.check_contract_restriction("BYMONTH", this.last.month) &&
              this.check_contract_restriction("BYYEARDAY", doy));
    },

    setup_defaults: function setup_defaults(aRuleType, req, deftime) {
      var indexMapValue = icalrecur_iterator._indexMap[aRuleType];
      var ruleMapValue = icalrecur_iterator._expandMap[this.rule.freq][indexMapValue];

      if (ruleMapValue != icalrecur_iterator.CONTRACT) {
        if (!(aRuleType in this.by_data)) {
          this.by_data[aRuleType] = [deftime];
        }
        if (this.rule.freq != req) {
          return this.by_data[aRuleType][0];
        }
      }
      return deftime;
    },

    /**
     * Convert iterator into a serialize-able object.  Will preserve current
     * iteration sequence to ensure the seamless continuation of the recurrence
     * rule.
     * @return {Object}
     */
    toJSON: function() {
      var result = Object.create(null);

      result.initialized = this.initialized;
      result.rule = this.rule.toJSON();
      result.dtstart = this.dtstart.toJSON();
      result.by_data = this.by_data;
      result.days = this.days;
      result.last = this.last.toJSON();
      result.by_indices = this.by_indices;
      result.occurrence_number = this.occurrence_number;

      return result;
    }
  };

  icalrecur_iterator._indexMap = {
    "BYSECOND": 0,
    "BYMINUTE": 1,
    "BYHOUR": 2,
    "BYDAY": 3,
    "BYMONTHDAY": 4,
    "BYYEARDAY": 5,
    "BYWEEKNO": 6,
    "BYMONTH": 7,
    "BYSETPOS": 8
  };

  icalrecur_iterator._expandMap = {
    "SECONDLY": [1, 1, 1, 1, 1, 1, 1, 1],
    "MINUTELY": [2, 1, 1, 1, 1, 1, 1, 1],
    "HOURLY": [2, 2, 1, 1, 1, 1, 1, 1],
    "DAILY": [2, 2, 2, 1, 1, 1, 1, 1],
    "WEEKLY": [2, 2, 2, 2, 3, 3, 1, 1],
    "MONTHLY": [2, 2, 2, 2, 2, 3, 3, 1],
    "YEARLY": [2, 2, 2, 2, 2, 2, 2, 2]
  };
  icalrecur_iterator.UNKNOWN = 0;
  icalrecur_iterator.CONTRACT = 1;
  icalrecur_iterator.EXPAND = 2;
  icalrecur_iterator.ILLEGAL = 3;

  return icalrecur_iterator;

}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.RecurExpansion = (function() {
  function formatTime(item) {
    return ICAL.helpers.formatClassType(item, ICAL.Time);
  }

  function compareTime(a, b) {
    return a.compare(b);
  }

  function isRecurringComponent(comp) {
    return comp.hasProperty('rdate') ||
           comp.hasProperty('rrule') ||
           comp.hasProperty('recurrence-id');
  }

  /**
   * @classdesc
   * Primary class for expanding recurring rules.  Can take multiple rrules,
   * rdates, exdate(s) and iterate (in order) over each next occurrence.
   *
   * Once initialized this class can also be serialized saved and continue
   * iteration from the last point.
   *
   * NOTE: it is intended that this class is to be used
   *       with ICAL.Event which handles recurrence exceptions.
   *
   * @example
   * // assuming event is a parsed ical component
   * var event;
   *
   * var expand = new ICAL.RecurExpansion({
   *   component: event,
   *   dtstart: event.getFirstPropertyValue('dtstart')
   * });
   *
   * // remember there are infinite rules
   * // so it is a good idea to limit the scope
   * // of the iterations then resume later on.
   *
   * // next is always an ICAL.Time or null
   * var next;
   *
   * while (someCondition && (next = expand.next())) {
   *   // do something with next
   * }
   *
   * // save instance for later
   * var json = JSON.stringify(expand);
   *
   * //...
   *
   * // NOTE: if the component's properties have
   * //       changed you will need to rebuild the
   * //       class and start over. This only works
   * //       when the component's recurrence info is the same.
   * var expand = new ICAL.RecurExpansion(JSON.parse(json));
   *
   * @description
   * The options object can be filled with the specified initial values. It can
   * also contain additional members, as a result of serializing a previous
   * expansion state, as shown in the example.
   *
   * @class
   * @alias ICAL.RecurExpansion
   * @param {Object} options
   *        Recurrence expansion options
   * @param {ICAL.Time} options.dtstart
   *        Start time of the event
   * @param {ICAL.Component=} options.component
   *        Component for expansion, required if not resuming.
   */
  function RecurExpansion(options) {
    this.ruleDates = [];
    this.exDates = [];
    this.fromData(options);
  }

  RecurExpansion.prototype = {
    /**
     * True when iteration is fully completed.
     * @type {Boolean}
     */
    complete: false,

    /**
     * Array of rrule iterators.
     *
     * @type {ICAL.RecurIterator[]}
     * @private
     */
    ruleIterators: null,

    /**
     * Array of rdate instances.
     *
     * @type {ICAL.Time[]}
     * @private
     */
    ruleDates: null,

    /**
     * Array of exdate instances.
     *
     * @type {ICAL.Time[]}
     * @private
     */
    exDates: null,

    /**
     * Current position in ruleDates array.
     * @type {Number}
     * @private
     */
    ruleDateInc: 0,

    /**
     * Current position in exDates array
     * @type {Number}
     * @private
     */
    exDateInc: 0,

    /**
     * Current negative date.
     *
     * @type {ICAL.Time}
     * @private
     */
    exDate: null,

    /**
     * Current additional date.
     *
     * @type {ICAL.Time}
     * @private
     */
    ruleDate: null,

    /**
     * Start date of recurring rules.
     *
     * @type {ICAL.Time}
     */
    dtstart: null,

    /**
     * Last expanded time
     *
     * @type {ICAL.Time}
     */
    last: null,

    /**
     * Initialize the recurrence expansion from the data object. The options
     * object may also contain additional members, see the
     * {@link ICAL.RecurExpansion constructor} for more details.
     *
     * @param {Object} options
     *        Recurrence expansion options
     * @param {ICAL.Time} options.dtstart
     *        Start time of the event
     * @param {ICAL.Component=} options.component
     *        Component for expansion, required if not resuming.
     */
    fromData: function(options) {
      var start = ICAL.helpers.formatClassType(options.dtstart, ICAL.Time);

      if (!start) {
        throw new Error('.dtstart (ICAL.Time) must be given');
      } else {
        this.dtstart = start;
      }

      if (options.component) {
        this._init(options.component);
      } else {
        this.last = formatTime(options.last) || start.clone();

        if (!options.ruleIterators) {
          throw new Error('.ruleIterators or .component must be given');
        }

        this.ruleIterators = options.ruleIterators.map(function(item) {
          return ICAL.helpers.formatClassType(item, ICAL.RecurIterator);
        });

        this.ruleDateInc = options.ruleDateInc;
        this.exDateInc = options.exDateInc;

        if (options.ruleDates) {
          this.ruleDates = options.ruleDates.map(formatTime);
          this.ruleDate = this.ruleDates[this.ruleDateInc];
        }

        if (options.exDates) {
          this.exDates = options.exDates.map(formatTime);
          this.exDate = this.exDates[this.exDateInc];
        }

        if (typeof(options.complete) !== 'undefined') {
          this.complete = options.complete;
        }
      }
    },

    /**
     * Retrieve the next occurrence in the series.
     * @return {ICAL.Time}
     */
    next: function() {
      var iter;
      var ruleOfDay;
      var next;
      var compare;

      var maxTries = 500;
      var currentTry = 0;

      while (true) {
        if (currentTry++ > maxTries) {
          throw new Error(
            'max tries have occured, rule may be impossible to forfill.'
          );
        }

        next = this.ruleDate;
        iter = this._nextRecurrenceIter(this.last);

        // no more matches
        // because we increment the rule day or rule
        // _after_ we choose a value this should be
        // the only spot where we need to worry about the
        // end of events.
        if (!next && !iter) {
          // there are no more iterators or rdates
          this.complete = true;
          break;
        }

        // no next rule day or recurrence rule is first.
        if (!next || (iter && next.compare(iter.last) > 0)) {
          // must be cloned, recur will reuse the time element.
          next = iter.last.clone();
          // move to next so we can continue
          iter.next();
        }

        // if the ruleDate is still next increment it.
        if (this.ruleDate === next) {
          this._nextRuleDay();
        }

        this.last = next;

        // check the negative rules
        if (this.exDate) {
          compare = this.exDate.compare(this.last);

          if (compare < 0) {
            this._nextExDay();
          }

          // if the current rule is excluded skip it.
          if (compare === 0) {
            this._nextExDay();
            continue;
          }
        }

        //XXX: The spec states that after we resolve the final
        //     list of dates we execute exdate this seems somewhat counter
        //     intuitive to what I have seen most servers do so for now
        //     I exclude based on the original date not the one that may
        //     have been modified by the exception.
        return this.last;
      }
    },

    /**
     * Converts object into a serialize-able format. This format can be passed
     * back into the expansion to resume iteration.
     * @return {Object}
     */
    toJSON: function() {
      function toJSON(item) {
        return item.toJSON();
      }

      var result = Object.create(null);
      result.ruleIterators = this.ruleIterators.map(toJSON);

      if (this.ruleDates) {
        result.ruleDates = this.ruleDates.map(toJSON);
      }

      if (this.exDates) {
        result.exDates = this.exDates.map(toJSON);
      }

      result.ruleDateInc = this.ruleDateInc;
      result.exDateInc = this.exDateInc;
      result.last = this.last.toJSON();
      result.dtstart = this.dtstart.toJSON();
      result.complete = this.complete;

      return result;
    },

    /**
     * Extract all dates from the properties in the given component. The
     * properties will be filtered by the property name.
     *
     * @private
     * @param {ICAL.Component} component        The component to search in
     * @param {String} propertyName             The property name to search for
     * @return {ICAL.Time[]}                    The extracted dates.
     */
    _extractDates: function(component, propertyName) {
      function handleProp(prop) {
        idx = ICAL.helpers.binsearchInsert(
          result,
          prop,
          compareTime
        );

        // ordered insert
        result.splice(idx, 0, prop);
      }

      var result = [];
      var props = component.getAllProperties(propertyName);
      var len = props.length;
      var i = 0;
      var prop;

      var idx;

      for (; i < len; i++) {
        props[i].getValues().forEach(handleProp);
      }

      return result;
    },

    /**
     * Initialize the recurrence expansion.
     *
     * @private
     * @param {ICAL.Component} component    The component to initialize from.
     */
    _init: function(component) {
      this.ruleIterators = [];

      this.last = this.dtstart.clone();

      // to provide api consistency non-recurring
      // events can also use the iterator though it will
      // only return a single time.
      if (!isRecurringComponent(component)) {
        this.ruleDate = this.last.clone();
        this.complete = true;
        return;
      }

      if (component.hasProperty('rdate')) {
        this.ruleDates = this._extractDates(component, 'rdate');

        // special hack for cases where first rdate is prior
        // to the start date. We only check for the first rdate.
        // This is mostly for google's crazy recurring date logic
        // (contacts birthdays).
        if ((this.ruleDates[0]) &&
            (this.ruleDates[0].compare(this.dtstart) < 0)) {

          this.ruleDateInc = 0;
          this.last = this.ruleDates[0].clone();
        } else {
          this.ruleDateInc = ICAL.helpers.binsearchInsert(
            this.ruleDates,
            this.last,
            compareTime
          );
        }

        this.ruleDate = this.ruleDates[this.ruleDateInc];
      }

      if (component.hasProperty('rrule')) {
        var rules = component.getAllProperties('rrule');
        var i = 0;
        var len = rules.length;

        var rule;
        var iter;

        for (; i < len; i++) {
          rule = rules[i].getFirstValue();
          iter = rule.iterator(this.dtstart);
          this.ruleIterators.push(iter);

          // increment to the next occurrence so future
          // calls to next return times beyond the initial iteration.
          // XXX: I find this suspicious might be a bug?
          iter.next();
        }
      }

      if (component.hasProperty('exdate')) {
        this.exDates = this._extractDates(component, 'exdate');
        // if we have a .last day we increment the index to beyond it.
        this.exDateInc = ICAL.helpers.binsearchInsert(
          this.exDates,
          this.last,
          compareTime
        );

        this.exDate = this.exDates[this.exDateInc];
      }
    },

    /**
     * Advance to the next exdate
     * @private
     */
    _nextExDay: function() {
      this.exDate = this.exDates[++this.exDateInc];
    },

    /**
     * Advance to the next rule date
     * @private
     */
    _nextRuleDay: function() {
      this.ruleDate = this.ruleDates[++this.ruleDateInc];
    },

    /**
     * Find and return the recurrence rule with the most recent event and
     * return it.
     *
     * @private
     * @return {?ICAL.RecurIterator}    Found iterator.
     */
    _nextRecurrenceIter: function() {
      var iters = this.ruleIterators;

      if (iters.length === 0) {
        return null;
      }

      var len = iters.length;
      var iter;
      var iterTime;
      var iterIdx = 0;
      var chosenIter;

      // loop through each iterator
      for (; iterIdx < len; iterIdx++) {
        iter = iters[iterIdx];
        iterTime = iter.last;

        // if iteration is complete
        // then we must exclude it from
        // the search and remove it.
        if (iter.completed) {
          len--;
          if (iterIdx !== 0) {
            iterIdx--;
          }
          iters.splice(iterIdx, 1);
          continue;
        }

        // find the most recent possible choice
        if (!chosenIter || chosenIter.last.compare(iterTime) > 0) {
          // that iterator is saved
          chosenIter = iter;
        }
      }

      // the chosen iterator is returned but not mutated
      // this iterator contains the most recent event.
      return chosenIter;
    }
  };

  return RecurExpansion;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.Event = (function() {

  /**
   * @classdesc
   * ICAL.js is organized into multiple layers. The bottom layer is a raw jCal
   * object, followed by the component/property layer. The highest level is the
   * event representation, which this class is part of. See the
   * {@tutorial layers} guide for more details.
   *
   * @class
   * @alias ICAL.Event
   * @param {ICAL.Component=} component         The ICAL.Component to base this event on
   * @param {Object} options                    Options for this event
   * @param {Boolean} options.strictExceptions
   *          When true, will verify exceptions are related by their UUID
   * @param {Array<ICAL.Component|ICAL.Event>} options.exceptions
   *          Exceptions to this event, either as components or events. If not
   *            specified exceptions will automatically be set in relation of
   *            component's parent
   */
  function Event(component, options) {
    if (!(component instanceof ICAL.Component)) {
      options = component;
      component = null;
    }

    if (component) {
      this.component = component;
    } else {
      this.component = new ICAL.Component('vevent');
    }

    this._rangeExceptionCache = Object.create(null);
    this.exceptions = Object.create(null);
    this.rangeExceptions = [];

    if (options && options.strictExceptions) {
      this.strictExceptions = options.strictExceptions;
    }

    if (options && options.exceptions) {
      options.exceptions.forEach(this.relateException, this);
    } else if (this.component.parent && !this.isRecurrenceException()) {
      this.component.parent.getAllSubcomponents('vevent').forEach(function(event) {
        if (event.hasProperty('recurrence-id')) {
          this.relateException(event);
        }
      }, this);
    }
  }

  Event.prototype = {

    THISANDFUTURE: 'THISANDFUTURE',

    /**
     * List of related event exceptions.
     *
     * @type {ICAL.Event[]}
     */
    exceptions: null,

    /**
     * When true, will verify exceptions are related by their UUID.
     *
     * @type {Boolean}
     */
    strictExceptions: false,

    /**
     * Relates a given event exception to this object.  If the given component
     * does not share the UID of this event it cannot be related and will throw
     * an exception.
     *
     * If this component is an exception it cannot have other exceptions
     * related to it.
     *
     * @param {ICAL.Component|ICAL.Event} obj       Component or event
     */
    relateException: function(obj) {
      if (this.isRecurrenceException()) {
        throw new Error('cannot relate exception to exceptions');
      }

      if (obj instanceof ICAL.Component) {
        obj = new ICAL.Event(obj);
      }

      if (this.strictExceptions && obj.uid !== this.uid) {
        throw new Error('attempted to relate unrelated exception');
      }

      var id = obj.recurrenceId.toString();

      // we don't sort or manage exceptions directly
      // here the recurrence expander handles that.
      this.exceptions[id] = obj;

      // index RANGE=THISANDFUTURE exceptions so we can
      // look them up later in getOccurrenceDetails.
      if (obj.modifiesFuture()) {
        var item = [
          obj.recurrenceId.toUnixTime(), id
        ];

        // we keep them sorted so we can find the nearest
        // value later on...
        var idx = ICAL.helpers.binsearchInsert(
          this.rangeExceptions,
          item,
          compareRangeException
        );

        this.rangeExceptions.splice(idx, 0, item);
      }
    },

    /**
     * Checks if this record is an exception and has the RANGE=THISANDFUTURE
     * value.
     *
     * @return {Boolean}        True, when exception is within range
     */
    modifiesFuture: function() {
      if (!this.component.hasProperty('recurrence-id')) {
        return false;
      }

      var range = this.component.getFirstProperty('recurrence-id').getParameter('range');
      return range === this.THISANDFUTURE;
    },

    /**
     * Finds the range exception nearest to the given date.
     *
     * @param {ICAL.Time} time usually an occurrence time of an event
     * @return {?ICAL.Event} the related event/exception or null
     */
    findRangeException: function(time) {
      if (!this.rangeExceptions.length) {
        return null;
      }

      var utc = time.toUnixTime();
      var idx = ICAL.helpers.binsearchInsert(
        this.rangeExceptions,
        [utc],
        compareRangeException
      );

      idx -= 1;

      // occurs before
      if (idx < 0) {
        return null;
      }

      var rangeItem = this.rangeExceptions[idx];

      /* istanbul ignore next: sanity check only */
      if (utc < rangeItem[0]) {
        return null;
      }

      return rangeItem[1];
    },

    /**
     * This object is returned by {@link ICAL.Event#getOccurrenceDetails getOccurrenceDetails}
     *
     * @typedef {Object} occurrenceDetails
     * @memberof ICAL.Event
     * @property {ICAL.Time} recurrenceId       The passed in recurrence id
     * @property {ICAL.Event} item              The occurrence
     * @property {ICAL.Time} startDate          The start of the occurrence
     * @property {ICAL.Time} endDate            The end of the occurrence
     */

    /**
     * Returns the occurrence details based on its start time.  If the
     * occurrence has an exception will return the details for that exception.
     *
     * NOTE: this method is intend to be used in conjunction
     *       with the {@link ICAL.Event#iterator iterator} method.
     *
     * @param {ICAL.Time} occurrence time occurrence
     * @return {ICAL.Event.occurrenceDetails} Information about the occurrence
     */
    getOccurrenceDetails: function(occurrence) {
      var id = occurrence.toString();
      var utcId = occurrence.convertToZone(ICAL.Timezone.utcTimezone).toString();
      var item;
      var result = {
        //XXX: Clone?
        recurrenceId: occurrence
      };

      if (id in this.exceptions) {
        item = result.item = this.exceptions[id];
        result.startDate = item.startDate;
        result.endDate = item.endDate;
        result.item = item;
      } else if (utcId in this.exceptions) {
        item = this.exceptions[utcId];
        result.startDate = item.startDate;
        result.endDate = item.endDate;
        result.item = item;
      } else {
        // range exceptions (RANGE=THISANDFUTURE) have a
        // lower priority then direct exceptions but
        // must be accounted for first. Their item is
        // always the first exception with the range prop.
        var rangeExceptionId = this.findRangeException(
          occurrence
        );
        var end;

        if (rangeExceptionId) {
          var exception = this.exceptions[rangeExceptionId];

          // range exception must modify standard time
          // by the difference (if any) in start/end times.
          result.item = exception;

          var startDiff = this._rangeExceptionCache[rangeExceptionId];

          if (!startDiff) {
            var original = exception.recurrenceId.clone();
            var newStart = exception.startDate.clone();

            // zones must be same otherwise subtract may be incorrect.
            original.zone = newStart.zone;
            startDiff = newStart.subtractDate(original);

            this._rangeExceptionCache[rangeExceptionId] = startDiff;
          }

          var start = occurrence.clone();
          start.zone = exception.startDate.zone;
          start.addDuration(startDiff);

          end = start.clone();
          end.addDuration(exception.duration);

          result.startDate = start;
          result.endDate = end;
        } else {
          // no range exception standard expansion
          end = occurrence.clone();
          end.addDuration(this.duration);

          result.endDate = end;
          result.startDate = occurrence;
          result.item = this;
        }
      }

      return result;
    },

    /**
     * Builds a recur expansion instance for a specific point in time (defaults
     * to startDate).
     *
     * @param {ICAL.Time} startTime     Starting point for expansion
     * @return {ICAL.RecurExpansion}    Expansion object
     */
    iterator: function(startTime) {
      return new ICAL.RecurExpansion({
        component: this.component,
        dtstart: startTime || this.startDate
      });
    },

    /**
     * Checks if the event is recurring
     *
     * @return {Boolean}        True, if event is recurring
     */
    isRecurring: function() {
      var comp = this.component;
      return comp.hasProperty('rrule') || comp.hasProperty('rdate');
    },

    /**
     * Checks if the event describes a recurrence exception. See
     * {@tutorial terminology} for details.
     *
     * @return {Boolean}    True, if the event describes a recurrence exception
     */
    isRecurrenceException: function() {
      return this.component.hasProperty('recurrence-id');
    },

    /**
     * Returns the types of recurrences this event may have.
     *
     * Returned as an object with the following possible keys:
     *
     *    - YEARLY
     *    - MONTHLY
     *    - WEEKLY
     *    - DAILY
     *    - MINUTELY
     *    - SECONDLY
     *
     * @return {Object.<ICAL.Recur.frequencyValues, Boolean>}
     *          Object of recurrence flags
     */
    getRecurrenceTypes: function() {
      var rules = this.component.getAllProperties('rrule');
      var i = 0;
      var len = rules.length;
      var result = Object.create(null);

      for (; i < len; i++) {
        var value = rules[i].getFirstValue();
        result[value.freq] = true;
      }

      return result;
    },

    /**
     * The uid of this event
     * @type {String}
     */
    get uid() {
      return this._firstProp('uid');
    },

    set uid(value) {
      this._setProp('uid', value);
    },

    /**
     * The start date
     * @type {ICAL.Time}
     */
    get startDate() {
      return this._firstProp('dtstart');
    },

    set startDate(value) {
      this._setTime('dtstart', value);
    },

    /**
     * The end date. This can be the result directly from the property, or the
     * end date calculated from start date and duration. Setting the property
     * will remove any duration properties.
     * @type {ICAL.Time}
     */
    get endDate() {
      var endDate = this._firstProp('dtend');
      if (!endDate) {
          var duration = this._firstProp('duration');
          endDate = this.startDate.clone();
          if (duration) {
              endDate.addDuration(duration);
          } else if (endDate.isDate) {
              endDate.day += 1;
          }
      }
      return endDate;
    },

    set endDate(value) {
      if (this.component.hasProperty('duration')) {
        this.component.removeProperty('duration');
      }
      this._setTime('dtend', value);
    },

    /**
     * The duration. This can be the result directly from the property, or the
     * duration calculated from start date and end date. Setting the property
     * will remove any `dtend` properties.
     * @type {ICAL.Duration}
     */
    get duration() {
      var duration = this._firstProp('duration');
      if (!duration) {
        return this.endDate.subtractDateTz(this.startDate);
      }
      return duration;
    },

    set duration(value) {
      if (this.component.hasProperty('dtend')) {
        this.component.removeProperty('dtend');
      }

      this._setProp('duration', value);
    },

    /**
     * The location of the event.
     * @type {String}
     */
    get location() {
      return this._firstProp('location');
    },

    set location(value) {
      return this._setProp('location', value);
    },

    /**
     * The attendees in the event
     * @type {ICAL.Property[]}
     * @readonly
     */
    get attendees() {
      //XXX: This is way lame we should have a better
      //     data structure for this later.
      return this.component.getAllProperties('attendee');
    },


    /**
     * The event summary
     * @type {String}
     */
    get summary() {
      return this._firstProp('summary');
    },

    set summary(value) {
      this._setProp('summary', value);
    },

    /**
     * The event description.
     * @type {String}
     */
    get description() {
      return this._firstProp('description');
    },

    set description(value) {
      this._setProp('description', value);
    },

    /**
     * The event color from [rfc7986](https://datatracker.ietf.org/doc/html/rfc7986)
     * @type {String}
     */
    get color() {
      return this._firstProp('color');
    },

    set color(value) {
      this._setProp('color', value);
    },

    /**
     * The organizer value as an uri. In most cases this is a mailto: uri, but
     * it can also be something else, like urn:uuid:...
     * @type {String}
     */
    get organizer() {
      return this._firstProp('organizer');
    },

    set organizer(value) {
      this._setProp('organizer', value);
    },

    /**
     * The sequence value for this event. Used for scheduling
     * see {@tutorial terminology}.
     * @type {Number}
     */
    get sequence() {
      return this._firstProp('sequence');
    },

    set sequence(value) {
      this._setProp('sequence', value);
    },

    /**
     * The recurrence id for this event. See {@tutorial terminology} for details.
     * @type {ICAL.Time}
     */
    get recurrenceId() {
      return this._firstProp('recurrence-id');
    },

    set recurrenceId(value) {
      this._setTime('recurrence-id', value);
    },

    /**
     * Set/update a time property's value.
     * This will also update the TZID of the property.
     *
     * TODO: this method handles the case where we are switching
     * from a known timezone to an implied timezone (one without TZID).
     * This does _not_ handle the case of moving between a known
     *  (by TimezoneService) timezone to an unknown timezone...
     *
     * We will not add/remove/update the VTIMEZONE subcomponents
     *  leading to invalid ICAL data...
     * @private
     * @param {String} propName     The property name
     * @param {ICAL.Time} time      The time to set
     */
    _setTime: function(propName, time) {
      var prop = this.component.getFirstProperty(propName);

      if (!prop) {
        prop = new ICAL.Property(propName);
        this.component.addProperty(prop);
      }

      // utc and local don't get a tzid
      if (
        time.zone === ICAL.Timezone.localTimezone ||
        time.zone === ICAL.Timezone.utcTimezone
      ) {
        // remove the tzid
        prop.removeParameter('tzid');
      } else {
        prop.setParameter('tzid', time.zone.tzid);
      }

      prop.setValue(time);
    },

    _setProp: function(name, value) {
      this.component.updatePropertyWithValue(name, value);
    },

    _firstProp: function(name) {
      return this.component.getFirstPropertyValue(name);
    },

    /**
     * The string representation of this event.
     * @return {String}
     */
    toString: function() {
      return this.component.toString();
    }

  };

  function compareRangeException(a, b) {
    if (a[0] > b[0]) return 1;
    if (b[0] > a[0]) return -1;
    return 0;
  }

  return Event;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.ComponentParser = (function() {
  /**
   * @classdesc
   * The ComponentParser is used to process a String or jCal Object,
   * firing callbacks for various found components, as well as completion.
   *
   * @example
   * var options = {
   *   // when false no events will be emitted for type
   *   parseEvent: true,
   *   parseTimezone: true
   * };
   *
   * var parser = new ICAL.ComponentParser(options);
   *
   * parser.onevent(eventComponent) {
   *   //...
   * }
   *
   * // ontimezone, etc...
   *
   * parser.oncomplete = function() {
   *
   * };
   *
   * parser.process(stringOrComponent);
   *
   * @class
   * @alias ICAL.ComponentParser
   * @param {Object=} options        Component parser options
   * @param {Boolean} options.parseEvent        Whether events should be parsed
   * @param {Boolean} options.parseTimezeone    Whether timezones should be parsed
   */
  function ComponentParser(options) {
    if (typeof(options) === 'undefined') {
      options = {};
    }

    var key;
    for (key in options) {
      /* istanbul ignore else */
      if (options.hasOwnProperty(key)) {
        this[key] = options[key];
      }
    }
  }

  ComponentParser.prototype = {

    /**
     * When true, parse events
     *
     * @type {Boolean}
     */
    parseEvent: true,

    /**
     * When true, parse timezones
     *
     * @type {Boolean}
     */
    parseTimezone: true,


    /* SAX like events here for reference */

    /**
     * Fired when parsing is complete
     * @callback
     */
    oncomplete: /* istanbul ignore next */ function() {},

    /**
     * Fired if an error occurs during parsing.
     *
     * @callback
     * @param {Error} err details of error
     */
    onerror: /* istanbul ignore next */ function(err) {},

    /**
     * Fired when a top level component (VTIMEZONE) is found
     *
     * @callback
     * @param {ICAL.Timezone} component     Timezone object
     */
    ontimezone: /* istanbul ignore next */ function(component) {},

    /**
     * Fired when a top level component (VEVENT) is found.
     *
     * @callback
     * @param {ICAL.Event} component    Top level component
     */
    onevent: /* istanbul ignore next */ function(component) {},

    /**
     * Process a string or parse ical object.  This function itself will return
     * nothing but will start the parsing process.
     *
     * Events must be registered prior to calling this method.
     *
     * @param {ICAL.Component|String|Object} ical      The component to process,
     *        either in its final form, as a jCal Object, or string representation
     */
    process: function(ical) {
      //TODO: this is sync now in the future we will have a incremental parser.
      if (typeof(ical) === 'string') {
        ical = ICAL.parse(ical);
      }

      if (!(ical instanceof ICAL.Component)) {
        ical = new ICAL.Component(ical);
      }

      var components = ical.getAllSubcomponents();
      var i = 0;
      var len = components.length;
      var component;

      for (; i < len; i++) {
        component = components[i];

        switch (component.name) {
          case 'vtimezone':
            if (this.parseTimezone) {
              var tzid = component.getFirstPropertyValue('tzid');
              if (tzid) {
                this.ontimezone(new ICAL.Timezone({
                  tzid: tzid,
                  component: component
                }));
              }
            }
            break;
          case 'vevent':
            if (this.parseEvent) {
              this.onevent(new ICAL.Event(component));
            }
            break;
          default:
            continue;
        }
      }

      //XXX: ideally we should do a "nextTick" here
      //     so in all cases this is actually async.
      this.oncomplete();
    }
  };

  return ComponentParser;
}());


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @class MapElementMixin
 *
 * Extends components to include the following fields:
 *
 * @property $map        The Google map (valid only after the promise returns)
 *
 *
 * */
exports.default = {
  inject: {
    '$mapPromise': { default: 'abcdef' }
  },

  provide: function provide() {
    var _this = this;

    // Note: although this mixin is not "providing" anything,
    // components' expect the `$map` property to be present on the component.
    // In order for that to happen, this mixin must intercept the $mapPromise
    // .then(() =>) first before its component does so.
    //
    // Since a provide() on a mixin is executed before a provide() on the
    // component, putting this code in provide() ensures that the $map is
    // already set by the time the
    // component's provide() is called.
    this.$mapPromise.then(function (map) {
      _this.$map = map;
    });

    return {};
  }
};

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(592)));

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(597)));

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TwoWayBindingWrapper;
/**
 * When you have two-way bindings, but the actual bound value will not equal
 * the value you initially passed in, then to avoid an infinite loop you
 * need to increment a counter every time you pass in a value, decrement the
 * same counter every time the bound value changed, but only bubble up
 * the event when the counter is zero.
 *
Example:

Let's say DrawingRecognitionCanvas is a deep-learning backed canvas
that, when given the name of an object (e.g. 'dog'), draws a dog.
But whenever the drawing on it changes, it also sends back its interpretation
of the image by way of the @newObjectRecognized event.

<input
  type="text"
  placeholder="an object, e.g. Dog, Cat, Frog"
  v-model="identifiedObject" />
<DrawingRecognitionCanvas
  :object="identifiedObject"
  @newObjectRecognized="identifiedObject = $event"
  />

new TwoWayBindingWrapper((increment, decrement, shouldUpdate) => {
  this.$watch('identifiedObject', () => {
    // new object passed in
    increment()
  })
  this.$deepLearningBackend.on('drawingChanged', () => {
    recognizeObject(this.$deepLearningBackend)
      .then((object) => {
        decrement()
        if (shouldUpdate()) {
          this.$emit('newObjectRecognized', object.name)
        }
      })
  })
})
 */
function TwoWayBindingWrapper(fn) {
  var counter = 0;

  fn(function () {
    counter += 1;
  }, function () {
    counter = Math.max(0, counter - 1);
  }, function () {
    return counter === 0;
  });
}

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(602)));

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bindProps = __webpack_require__(99);

var _simulateArrowDown = __webpack_require__(247);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var props = {
  bounds: {
    type: Object
  },
  defaultPlace: {
    type: String,
    default: ''
  },
  componentRestrictions: {
    type: Object,
    default: null
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  placeholder: {
    required: false,
    type: String
  },
  className: {
    required: false,
    type: String
  },
  label: {
    required: false,
    type: String,
    default: null
  },
  selectFirstOnEnter: {
    require: false,
    type: Boolean,
    default: false
  }
};

exports.default = {
  mounted: function mounted() {
    var _this = this;

    var input = this.$refs.input;

    // Allow default place to be set
    input.value = this.defaultPlace;
    this.$watch('defaultPlace', function () {
      input.value = _this.defaultPlace;
    });

    this.$gmapApiPromiseLazy().then(function () {
      var options = (0, _bindProps.getPropsValues)(_this, props);
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      _this.autoCompleter = new google.maps.places.Autocomplete(_this.$refs.input, options);

      var placeholder = props.placeholder,
          place = props.place,
          defaultPlace = props.defaultPlace,
          className = props.className,
          label = props.label,
          selectFirstOnEnter = props.selectFirstOnEnter,
          rest = _objectWithoutProperties(props, ['placeholder', 'place', 'defaultPlace', 'className', 'label', 'selectFirstOnEnter']); // eslint-disable-line


      (0, _bindProps.bindProps)(_this, _this.autoCompleter, rest);

      _this.autoCompleter.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.autoCompleter.getPlace());
      });
    });
  },
  created: function created() {
    console.warn('The PlaceInput class is deprecated! Please consider using the Autocomplete input instead'); // eslint-disable-line no-console
  },

  props: props
};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// This piece of code was orignally written by amirnissim and can be seen here
// http://stackoverflow.com/a/11703018/2694653
// This has been ported to Vanilla.js by GuillaumeLeclerc
exports.default = function (input) {
  var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

  function addEventListenerWrapper(type, listener) {
    // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
    // and then trigger the original listener.
    if (type === 'keydown') {
      var origListener = listener;
      listener = function (event) {
        var suggestionSelected = document.getElementsByClassName('pac-item-selected').length > 0;
        if (event.which === 13 && !suggestionSelected) {
          var simulatedEvent = document.createEvent('Event');
          simulatedEvent.keyCode = 40;
          simulatedEvent.which = 40;
          origListener.apply(input, [simulatedEvent]);
        }
        origListener.apply(input, [event]);
      };
    }
    _addEventListener.apply(input, [type, listener]);
  }

  input.addEventListener = addEventListenerWrapper;
  input.attachEvent = addEventListenerWrapper;
};

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(607)));

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_stable__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_stable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_stable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_regenerator_runtime_runtime__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WiV_vue__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__allResources_vue__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__calendar_vue__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ical_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ical_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ical_js__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__, {
  load: {
    key: 'AIzaSyCh1QZGfEV848y0FOBzOnAUVPHKVXAZTvg',
    libraries: 'places,geocoding,geometry'
  },
  installComponents: true,
  autobindAllEvents: true,
  defaultZoom: 8,
  mapTypeControl: false,
  mapTypeControlOptions: { mapTypeIds: [] },

  defaultCenter: { lat: 48.429455, lng: -123.365445 }
});

// Check and initialize for #vue-element_Resources
if (document.querySelector('#vue-element_Resources')) {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#vue-element_Resources',
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_4__allResources_vue__["a" /* default */]);
    }
  });
}

// Check and initialize for #vue-element
if (document.querySelector('#vue-element')) {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#vue-element',
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_3__WiV_vue__["a" /* default */]);
    }
  });
}

// Check and initialize for #calendarVue
if (document.querySelector('#calendarVue')) {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#calendarVue',
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_5__calendar_vue__["a" /* default */]);
    }
  });
}

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/* unused harmony export EffectScope */
/* unused harmony export computed */
/* unused harmony export customRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Vue; });
/* unused harmony export defineAsyncComponent */
/* unused harmony export defineComponent */
/* unused harmony export del */
/* unused harmony export effectScope */
/* unused harmony export getCurrentInstance */
/* unused harmony export getCurrentScope */
/* unused harmony export h */
/* unused harmony export inject */
/* unused harmony export isProxy */
/* unused harmony export isReactive */
/* unused harmony export isReadonly */
/* unused harmony export isRef */
/* unused harmony export isShallow */
/* unused harmony export markRaw */
/* unused harmony export mergeDefaults */
/* unused harmony export nextTick */
/* unused harmony export onActivated */
/* unused harmony export onBeforeMount */
/* unused harmony export onBeforeUnmount */
/* unused harmony export onBeforeUpdate */
/* unused harmony export onDeactivated */
/* unused harmony export onErrorCaptured */
/* unused harmony export onMounted */
/* unused harmony export onRenderTracked */
/* unused harmony export onRenderTriggered */
/* unused harmony export onScopeDispose */
/* unused harmony export onServerPrefetch */
/* unused harmony export onUnmounted */
/* unused harmony export onUpdated */
/* unused harmony export provide */
/* unused harmony export proxyRefs */
/* unused harmony export reactive */
/* unused harmony export readonly */
/* unused harmony export ref */
/* unused harmony export set */
/* unused harmony export shallowReactive */
/* unused harmony export shallowReadonly */
/* unused harmony export shallowRef */
/* unused harmony export toRaw */
/* unused harmony export toRef */
/* unused harmony export toRefs */
/* unused harmony export triggerRef */
/* unused harmony export unref */
/* unused harmony export useAttrs */
/* unused harmony export useCssModule */
/* unused harmony export useCssVars */
/* unused harmony export useListeners */
/* unused harmony export useSlots */
/* unused harmony export version */
/* unused harmony export watch */
/* unused harmony export watchEffect */
/* unused harmony export watchPostEffect */
/* unused harmony export watchSyncEffect */
/*!
 * Vue.js v2.7.14
 * (c) 2014-2022 Evan You
 * Released under the MIT License.
 */
var emptyObject = Object.freeze({});
var isArray = Array.isArray;
// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef(v) {
    return v === undefined || v === null;
}
function isDef(v) {
    return v !== undefined && v !== null;
}
function isTrue(v) {
    return v === true;
}
function isFalse(v) {
    return v === false;
}
/**
 * Check if value is primitive.
 */
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isFunction(value) {
    return typeof value === 'function';
}
/**
 * Quick object check - this is primarily used to tell
 * objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;
function toRawType(value) {
    return _toString.call(value).slice(8, -1);
}
/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject(obj) {
    return _toString.call(obj) === '[object Object]';
}
function isRegExp(v) {
    return _toString.call(v) === '[object RegExp]';
}
/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
}
function isPromise(val) {
    return (isDef(val) &&
        typeof val.then === 'function' &&
        typeof val.catch === 'function');
}
/**
 * Convert a value to a string that is actually rendered.
 */
function toString(val) {
    return val == null
        ? ''
        : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
            ? JSON.stringify(val, null, 2)
            : String(val);
}
/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
}
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap(str, expectsLowerCase) {
    var map = Object.create(null);
    var list = str.split(',');
    for (var i = 0; i < list.length; i++) {
        map[list[i]] = true;
    }
    return expectsLowerCase ? function (val) { return map[val.toLowerCase()]; } : function (val) { return map[val]; };
}
/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);
/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
/**
 * Remove an item from an array.
 */
function remove$2(arr, item) {
    var len = arr.length;
    if (len) {
        // fast path for the only / last item
        if (item === arr[len - 1]) {
            arr.length = len - 1;
            return;
        }
        var index = arr.indexOf(item);
        if (index > -1) {
            return arr.splice(index, 1);
        }
    }
}
/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
}
/**
 * Create a cached version of a pure function.
 */
function cached(fn) {
    var cache = Object.create(null);
    return function cachedFn(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
    return str.replace(camelizeRE, function (_, c) { return (c ? c.toUpperCase() : ''); });
});
/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
    return str.replace(hyphenateRE, '-$1').toLowerCase();
});
/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */
/* istanbul ignore next */
function polyfillBind(fn, ctx) {
    function boundFn(a) {
        var l = arguments.length;
        return l
            ? l > 1
                ? fn.apply(ctx, arguments)
                : fn.call(ctx, a)
            : fn.call(ctx);
    }
    boundFn._length = fn.length;
    return boundFn;
}
function nativeBind(fn, ctx) {
    return fn.bind(ctx);
}
// @ts-expect-error bind cannot be `undefined`
var bind$1 = Function.prototype.bind ? nativeBind : polyfillBind;
/**
 * Convert an Array-like object to a real Array.
 */
function toArray(list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);
    while (i--) {
        ret[i] = list[i + start];
    }
    return ret;
}
/**
 * Mix properties into target object.
 */
function extend(to, _from) {
    for (var key in _from) {
        to[key] = _from[key];
    }
    return to;
}
/**
 * Merge an Array of Objects into a single Object.
 */
function toObject(arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
            extend(res, arr[i]);
        }
    }
    return res;
}
/* eslint-disable no-unused-vars */
/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop(a, b, c) { }
/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };
/* eslint-enable no-unused-vars */
/**
 * Return the same value.
 */
var identity = function (_) { return _; };
/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys$1(modules) {
    return modules
        .reduce(function (keys, m) {
        return keys.concat(m.staticKeys || []);
    }, [])
        .join(',');
}
/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual(a, b) {
    if (a === b)
        return true;
    var isObjectA = isObject(a);
    var isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
        try {
            var isArrayA = Array.isArray(a);
            var isArrayB = Array.isArray(b);
            if (isArrayA && isArrayB) {
                return (a.length === b.length &&
                    a.every(function (e, i) {
                        return looseEqual(e, b[i]);
                    }));
            }
            else if (a instanceof Date && b instanceof Date) {
                return a.getTime() === b.getTime();
            }
            else if (!isArrayA && !isArrayB) {
                var keysA = Object.keys(a);
                var keysB = Object.keys(b);
                return (keysA.length === keysB.length &&
                    keysA.every(function (key) {
                        return looseEqual(a[key], b[key]);
                    }));
            }
            else {
                /* istanbul ignore next */
                return false;
            }
        }
        catch (e) {
            /* istanbul ignore next */
            return false;
        }
    }
    else if (!isObjectA && !isObjectB) {
        return String(a) === String(b);
    }
    else {
        return false;
    }
}
/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf(arr, val) {
    for (var i = 0; i < arr.length; i++) {
        if (looseEqual(arr[i], val))
            return i;
    }
    return -1;
}
/**
 * Ensure a function is called only once.
 */
function once(fn) {
    var called = false;
    return function () {
        if (!called) {
            called = true;
            fn.apply(this, arguments);
        }
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
function hasChanged(x, y) {
    if (x === y) {
        return x === 0 && 1 / x !== 1 / y;
    }
    else {
        return x === x || y === y;
    }
}

var SSR_ATTR = 'data-server-rendered';
var ASSET_TYPES = ['component', 'directive', 'filter'];
var LIFECYCLE_HOOKS = [
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeUpdate',
    'updated',
    'beforeDestroy',
    'destroyed',
    'activated',
    'deactivated',
    'errorCaptured',
    'serverPrefetch',
    'renderTracked',
    'renderTriggered'
];

var config = {
    /**
     * Option merge strategies (used in core/util/options)
     */
    // $flow-disable-line
    optionMergeStrategies: Object.create(null),
    /**
     * Whether to suppress warnings.
     */
    silent: false,
    /**
     * Show production mode tip message on boot?
     */
    productionTip: "production" !== 'production',
    /**
     * Whether to enable devtools
     */
    devtools: "production" !== 'production',
    /**
     * Whether to record perf
     */
    performance: false,
    /**
     * Error handler for watcher errors
     */
    errorHandler: null,
    /**
     * Warn handler for watcher warns
     */
    warnHandler: null,
    /**
     * Ignore certain custom elements
     */
    ignoredElements: [],
    /**
     * Custom user key aliases for v-on
     */
    // $flow-disable-line
    keyCodes: Object.create(null),
    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */
    isReservedTag: no,
    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */
    isReservedAttr: no,
    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */
    isUnknownElement: no,
    /**
     * Get the namespace of an element
     */
    getTagNamespace: noop,
    /**
     * Parse the real tag name for the specific platform.
     */
    parsePlatformTagName: identity,
    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */
    mustUseProp: no,
    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */
    async: true,
    /**
     * Exposed for legacy reasons
     */
    _lifecycleHooks: LIFECYCLE_HOOKS
};

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
/**
 * Check if a string starts with $ or _
 */
function isReserved(str) {
    var c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5f;
}
/**
 * Define a property.
 */
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true
    });
}
/**
 * Parse simple path.
 */
var bailRE = new RegExp("[^".concat(unicodeRegExp.source, ".$_\\d]"));
function parsePath(path) {
    if (bailRE.test(path)) {
        return;
    }
    var segments = path.split('.');
    return function (obj) {
        for (var i = 0; i < segments.length; i++) {
            if (!obj)
                return;
            obj = obj[segments[i]];
        }
        return obj;
    };
}

// can we use __proto__?
var hasProto = '__proto__' in {};
// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
UA && /chrome\/\d+/.test(UA) && !isEdge;
UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);
// Firefox has a "watch" function on Object.prototype...
// @ts-expect-error firebox support
var nativeWatch = {}.watch;
var supportsPassive = false;
if (inBrowser) {
    try {
        var opts = {};
        Object.defineProperty(opts, 'passive', {
            get: function () {
                /* istanbul ignore next */
                supportsPassive = true;
            }
        }); // https://github.com/facebook/flow/issues/285
        window.addEventListener('test-passive', null, opts);
    }
    catch (e) { }
}
// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
    if (_isServer === undefined) {
        /* istanbul ignore if */
        if (!inBrowser && typeof global !== 'undefined') {
            // detect presence of vue-server-renderer and avoid
            // Webpack shimming the process
            _isServer =
                global['process'] && global['process'].env.VUE_ENV === 'server';
        }
        else {
            _isServer = false;
        }
    }
    return _isServer;
};
// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
/* istanbul ignore next */
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var _Set; // $flow-disable-line
/* istanbul ignore if */ if (typeof Set !== 'undefined' && isNative(Set)) {
    // use native Set when available.
    _Set = Set;
}
else {
    // a non-standard Set polyfill that only works with primitive keys.
    _Set = /** @class */ (function () {
        function Set() {
            this.set = Object.create(null);
        }
        Set.prototype.has = function (key) {
            return this.set[key] === true;
        };
        Set.prototype.add = function (key) {
            this.set[key] = true;
        };
        Set.prototype.clear = function () {
            this.set = Object.create(null);
        };
        return Set;
    }());
}

var currentInstance = null;
/**
 * This is exposed for compatibility with v3 (e.g. some functions in VueUse
 * relies on it). Do not use this internally, just use `currentInstance`.
 *
 * @internal this function needs manual type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function getCurrentInstance() {
    return currentInstance && { proxy: currentInstance };
}
/**
 * @internal
 */
function setCurrentInstance(vm) {
    if (vm === void 0) { vm = null; }
    if (!vm)
        currentInstance && currentInstance._scope.off();
    currentInstance = vm;
    vm && vm._scope.on();
}

/**
 * @internal
 */
var VNode = /** @class */ (function () {
    function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
        this.tag = tag;
        this.data = data;
        this.children = children;
        this.text = text;
        this.elm = elm;
        this.ns = undefined;
        this.context = context;
        this.fnContext = undefined;
        this.fnOptions = undefined;
        this.fnScopeId = undefined;
        this.key = data && data.key;
        this.componentOptions = componentOptions;
        this.componentInstance = undefined;
        this.parent = undefined;
        this.raw = false;
        this.isStatic = false;
        this.isRootInsert = true;
        this.isComment = false;
        this.isCloned = false;
        this.isOnce = false;
        this.asyncFactory = asyncFactory;
        this.asyncMeta = undefined;
        this.isAsyncPlaceholder = false;
    }
    Object.defineProperty(VNode.prototype, "child", {
        // DEPRECATED: alias for componentInstance for backwards compat.
        /* istanbul ignore next */
        get: function () {
            return this.componentInstance;
        },
        enumerable: false,
        configurable: true
    });
    return VNode;
}());
var createEmptyVNode = function (text) {
    if (text === void 0) { text = ''; }
    var node = new VNode();
    node.text = text;
    node.isComment = true;
    return node;
};
function createTextVNode(val) {
    return new VNode(undefined, undefined, undefined, String(val));
}
// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode(vnode) {
    var cloned = new VNode(vnode.tag, vnode.data, 
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
}

/* not type checking this file because flow doesn't play well with Proxy */
var initProxy;
if (false) {
    var allowedGlobals_1 = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' +
        'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
        'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
        'require' // for Webpack/Browserify
    );
    var warnNonPresent_1 = function (target, key) {
        warn$2("Property or method \"".concat(key, "\" is not defined on the instance but ") +
            'referenced during render. Make sure that this property is reactive, ' +
            'either in the data option, or for class-based components, by ' +
            'initializing the property. ' +
            'See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
    };
    var warnReservedPrefix_1 = function (target, key) {
        warn$2("Property \"".concat(key, "\" must be accessed with \"$data.").concat(key, "\" because ") +
            'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
            'prevent conflicts with Vue internals. ' +
            'See: https://v2.vuejs.org/v2/api/#data', target);
    };
    var hasProxy_1 = typeof Proxy !== 'undefined' && isNative(Proxy);
    if (hasProxy_1) {
        var isBuiltInModifier_1 = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
        config.keyCodes = new Proxy(config.keyCodes, {
            set: function (target, key, value) {
                if (isBuiltInModifier_1(key)) {
                    warn$2("Avoid overwriting built-in modifier in config.keyCodes: .".concat(key));
                    return false;
                }
                else {
                    target[key] = value;
                    return true;
                }
            }
        });
    }
    var hasHandler_1 = {
        has: function (target, key) {
            var has = key in target;
            var isAllowed = allowedGlobals_1(key) ||
                (typeof key === 'string' &&
                    key.charAt(0) === '_' &&
                    !(key in target.$data));
            if (!has && !isAllowed) {
                if (key in target.$data)
                    warnReservedPrefix_1(target, key);
                else
                    warnNonPresent_1(target, key);
            }
            return has || !isAllowed;
        }
    };
    var getHandler_1 = {
        get: function (target, key) {
            if (typeof key === 'string' && !(key in target)) {
                if (key in target.$data)
                    warnReservedPrefix_1(target, key);
                else
                    warnNonPresent_1(target, key);
            }
            return target[key];
        }
    };
    initProxy = function initProxy(vm) {
        if (hasProxy_1) {
            // determine which proxy handler to use
            var options = vm.$options;
            var handlers = options.render && options.render._withStripped ? getHandler_1 : hasHandler_1;
            vm._renderProxy = new Proxy(vm, handlers);
        }
        else {
            vm._renderProxy = vm;
        }
    };
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var uid$2 = 0;
var pendingCleanupDeps = [];
var cleanupDeps = function () {
    for (var i = 0; i < pendingCleanupDeps.length; i++) {
        var dep = pendingCleanupDeps[i];
        dep.subs = dep.subs.filter(function (s) { return s; });
        dep._pending = false;
    }
    pendingCleanupDeps.length = 0;
};
/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 * @internal
 */
var Dep = /** @class */ (function () {
    function Dep() {
        // pending subs cleanup
        this._pending = false;
        this.id = uid$2++;
        this.subs = [];
    }
    Dep.prototype.addSub = function (sub) {
        this.subs.push(sub);
    };
    Dep.prototype.removeSub = function (sub) {
        // #12696 deps with massive amount of subscribers are extremely slow to
        // clean up in Chromium
        // to workaround this, we unset the sub for now, and clear them on
        // next scheduler flush.
        this.subs[this.subs.indexOf(sub)] = null;
        if (!this._pending) {
            this._pending = true;
            pendingCleanupDeps.push(this);
        }
    };
    Dep.prototype.depend = function (info) {
        if (Dep.target) {
            Dep.target.addDep(this);
            if (false) {
                Dep.target.onTrack(__assign({ effect: Dep.target }, info));
            }
        }
    };
    Dep.prototype.notify = function (info) {
        // stabilize the subscriber list first
        var subs = this.subs.filter(function (s) { return s; });
        if (false) {
            // subs aren't sorted in scheduler if not running async
            // we need to sort them now to make sure they fire in correct
            // order
            subs.sort(function (a, b) { return a.id - b.id; });
        }
        for (var i = 0, l = subs.length; i < l; i++) {
            var sub = subs[i];
            if (false) {
                sub.onTrigger &&
                    sub.onTrigger(__assign({ effect: subs[i] }, info));
            }
            sub.update();
        }
    };
    return Dep;
}());
// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];
function pushTarget(target) {
    targetStack.push(target);
    Dep.target = target;
}
function popTarget() {
    targetStack.pop();
    Dep.target = targetStack[targetStack.length - 1];
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */
var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);
var methodsToPatch = [
    'push',
    'pop',
    'shift',
    'unshift',
    'splice',
    'sort',
    'reverse'
];
/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
    // cache original method
    var original = arrayProto[method];
    def(arrayMethods, method, function mutator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = original.apply(this, args);
        var ob = this.__ob__;
        var inserted;
        switch (method) {
            case 'push':
            case 'unshift':
                inserted = args;
                break;
            case 'splice':
                inserted = args.slice(2);
                break;
        }
        if (inserted)
            ob.observeArray(inserted);
        // notify change
        if (false) {
            ob.dep.notify({
                type: "array mutation" /* TriggerOpTypes.ARRAY_MUTATION */,
                target: this,
                key: method
            });
        }
        else {
            ob.dep.notify();
        }
        return result;
    });
});

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
var NO_INIITIAL_VALUE = {};
/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;
function toggleObserving(value) {
    shouldObserve = value;
}
// ssr mock dep
var mockDep = {
    notify: noop,
    depend: noop,
    addSub: noop,
    removeSub: noop
};
/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = /** @class */ (function () {
    function Observer(value, shallow, mock) {
        if (shallow === void 0) { shallow = false; }
        if (mock === void 0) { mock = false; }
        this.value = value;
        this.shallow = shallow;
        this.mock = mock;
        // this.value = value
        this.dep = mock ? mockDep : new Dep();
        this.vmCount = 0;
        def(value, '__ob__', this);
        if (isArray(value)) {
            if (!mock) {
                if (hasProto) {
                    value.__proto__ = arrayMethods;
                    /* eslint-enable no-proto */
                }
                else {
                    for (var i = 0, l = arrayKeys.length; i < l; i++) {
                        var key = arrayKeys[i];
                        def(value, key, arrayMethods[key]);
                    }
                }
            }
            if (!shallow) {
                this.observeArray(value);
            }
        }
        else {
            /**
             * Walk through all properties and convert them into
             * getter/setters. This method should only be called when
             * value type is Object.
             */
            var keys = Object.keys(value);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                defineReactive(value, key, NO_INIITIAL_VALUE, undefined, shallow, mock);
            }
        }
    }
    /**
     * Observe a list of Array items.
     */
    Observer.prototype.observeArray = function (value) {
        for (var i = 0, l = value.length; i < l; i++) {
            observe(value[i], false, this.mock);
        }
    };
    return Observer;
}());
// helpers
/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe(value, shallow, ssrMockReactivity) {
    if (value && hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
        return value.__ob__;
    }
    if (shouldObserve &&
        (ssrMockReactivity || !isServerRendering()) &&
        (isArray(value) || isPlainObject(value)) &&
        Object.isExtensible(value) &&
        !value.__v_skip /* ReactiveFlags.SKIP */ &&
        !isRef(value) &&
        !(value instanceof VNode)) {
        return new Observer(value, shallow, ssrMockReactivity);
    }
}
/**
 * Define a reactive property on an Object.
 */
function defineReactive(obj, key, val, customSetter, shallow, mock) {
    var dep = new Dep();
    var property = Object.getOwnPropertyDescriptor(obj, key);
    if (property && property.configurable === false) {
        return;
    }
    // cater for pre-defined getter/setters
    var getter = property && property.get;
    var setter = property && property.set;
    if ((!getter || setter) &&
        (val === NO_INIITIAL_VALUE || arguments.length === 2)) {
        val = obj[key];
    }
    var childOb = !shallow && observe(val, false, mock);
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        get: function reactiveGetter() {
            var value = getter ? getter.call(obj) : val;
            if (Dep.target) {
                if (false) {
                    dep.depend({
                        target: obj,
                        type: "get" /* TrackOpTypes.GET */,
                        key: key
                    });
                }
                else {
                    dep.depend();
                }
                if (childOb) {
                    childOb.dep.depend();
                    if (isArray(value)) {
                        dependArray(value);
                    }
                }
            }
            return isRef(value) && !shallow ? value.value : value;
        },
        set: function reactiveSetter(newVal) {
            var value = getter ? getter.call(obj) : val;
            if (!hasChanged(value, newVal)) {
                return;
            }
            if (false) {
                customSetter();
            }
            if (setter) {
                setter.call(obj, newVal);
            }
            else if (getter) {
                // #7981: for accessor properties without setter
                return;
            }
            else if (!shallow && isRef(value) && !isRef(newVal)) {
                value.value = newVal;
                return;
            }
            else {
                val = newVal;
            }
            childOb = !shallow && observe(newVal, false, mock);
            if (false) {
                dep.notify({
                    type: "set" /* TriggerOpTypes.SET */,
                    target: obj,
                    key: key,
                    newValue: newVal,
                    oldValue: value
                });
            }
            else {
                dep.notify();
            }
        }
    });
    return dep;
}
function set(target, key, val) {
    if (false) {
        warn$2("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isReadonly(target)) {
        "production" !== 'production' && warn$2("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    var ob = target.__ob__;
    if (isArray(target) && isValidArrayIndex(key)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        // when mocking for SSR, array methods are not hijacked
        if (ob && !ob.shallow && ob.mock) {
            observe(val, false, true);
        }
        return val;
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        "production" !== 'production' &&
            warn$2('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
    if (false) {
        ob.dep.notify({
            type: "add" /* TriggerOpTypes.ADD */,
            target: target,
            key: key,
            newValue: val,
            oldValue: undefined
        });
    }
    else {
        ob.dep.notify();
    }
    return val;
}
function del(target, key) {
    if (false) {
        warn$2("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        "production" !== 'production' &&
            warn$2('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (isReadonly(target)) {
        "production" !== 'production' &&
            warn$2("Delete operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    if (false) {
        ob.dep.notify({
            type: "delete" /* TriggerOpTypes.DELETE */,
            target: target,
            key: key
        });
    }
    else {
        ob.dep.notify();
    }
}
/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray(value) {
    for (var e = void 0, i = 0, l = value.length; i < l; i++) {
        e = value[i];
        if (e && e.__ob__) {
            e.__ob__.dep.depend();
        }
        if (isArray(e)) {
            dependArray(e);
        }
    }
}

function reactive(target) {
    makeReactive(target, false);
    return target;
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */
function shallowReactive(target) {
    makeReactive(target, true);
    def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    return target;
}
function makeReactive(target, shallow) {
    // if trying to observe a readonly proxy, return the readonly version.
    if (!isReadonly(target)) {
        if (false) {
            if (isArray(target)) {
                warn$2("Avoid using Array as root value for ".concat(shallow ? "shallowReactive()" : "reactive()", " as it cannot be tracked in watch() or watchEffect(). Use ").concat(shallow ? "shallowRef()" : "ref()", " instead. This is a Vue-2-only limitation."));
            }
            var existingOb = target && target.__ob__;
            if (existingOb && existingOb.shallow !== shallow) {
                warn$2("Target is already a ".concat(existingOb.shallow ? "" : "non-", "shallow reactive object, and cannot be converted to ").concat(shallow ? "" : "non-", "shallow."));
            }
        }
        var ob = observe(target, shallow, isServerRendering() /* ssr mock reactivity */);
        if (false) {
            if (target == null || isPrimitive(target)) {
                warn$2("value cannot be made reactive: ".concat(String(target)));
            }
            if (isCollectionType(target)) {
                warn$2("Vue 2 does not support reactive collection types such as Map or Set.");
            }
        }
    }
}
function isReactive(value) {
    if (isReadonly(value)) {
        return isReactive(value["__v_raw" /* ReactiveFlags.RAW */]);
    }
    return !!(value && value.__ob__);
}
function isShallow(value) {
    return !!(value && value.__v_isShallow);
}
function isReadonly(value) {
    return !!(value && value.__v_isReadonly);
}
function isProxy(value) {
    return isReactive(value) || isReadonly(value);
}
function toRaw(observed) {
    var raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    // non-extensible objects won't be observed anyway
    if (Object.isExtensible(value)) {
        def(value, "__v_skip" /* ReactiveFlags.SKIP */, true);
    }
    return value;
}
/**
 * @internal
 */
function isCollectionType(value) {
    var type = toRawType(value);
    return (type === 'Map' || type === 'WeakMap' || type === 'Set' || type === 'WeakSet');
}

/**
 * @internal
 */
var RefFlag = "__v_isRef";
function isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function ref$1(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) {
        return rawValue;
    }
    var ref = {};
    def(ref, RefFlag, true);
    def(ref, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, shallow);
    def(ref, 'dep', defineReactive(ref, 'value', rawValue, null, shallow, isServerRendering()));
    return ref;
}
function triggerRef(ref) {
    if (false) {
        warn$2("received object is not a triggerable ref.");
    }
    if (false) {
        ref.dep &&
            ref.dep.notify({
                type: "set" /* TriggerOpTypes.SET */,
                target: ref,
                key: 'value'
            });
    }
    else {
        ref.dep && ref.dep.notify();
    }
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function proxyRefs(objectWithRefs) {
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var proxy = {};
    var keys = Object.keys(objectWithRefs);
    for (var i = 0; i < keys.length; i++) {
        proxyWithRefUnwrap(proxy, objectWithRefs, keys[i]);
    }
    return proxy;
}
function proxyWithRefUnwrap(target, source, key) {
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            var val = source[key];
            if (isRef(val)) {
                return val.value;
            }
            else {
                var ob = val && val.__ob__;
                if (ob)
                    ob.dep.depend();
                return val;
            }
        },
        set: function (value) {
            var oldValue = source[key];
            if (isRef(oldValue) && !isRef(value)) {
                oldValue.value = value;
            }
            else {
                source[key] = value;
            }
        }
    });
}
function customRef(factory) {
    var dep = new Dep();
    var _a = factory(function () {
        if (false) {
            dep.depend({
                target: ref,
                type: "get" /* TrackOpTypes.GET */,
                key: 'value'
            });
        }
        else {
            dep.depend();
        }
    }, function () {
        if (false) {
            dep.notify({
                target: ref,
                type: "set" /* TriggerOpTypes.SET */,
                key: 'value'
            });
        }
        else {
            dep.notify();
        }
    }), get = _a.get, set = _a.set;
    var ref = {
        get value() {
            return get();
        },
        set value(newVal) {
            set(newVal);
        }
    };
    def(ref, RefFlag, true);
    return ref;
}
function toRefs(object) {
    if (false) {
        warn$2("toRefs() expects a reactive object but received a plain one.");
    }
    var ret = isArray(object) ? new Array(object.length) : {};
    for (var key in object) {
        ret[key] = toRef(object, key);
    }
    return ret;
}
function toRef(object, key, defaultValue) {
    var val = object[key];
    if (isRef(val)) {
        return val;
    }
    var ref = {
        get value() {
            var val = object[key];
            return val === undefined ? defaultValue : val;
        },
        set value(newVal) {
            object[key] = newVal;
        }
    };
    def(ref, RefFlag, true);
    return ref;
}

var rawToReadonlyFlag = "__v_rawToReadonly";
var rawToShallowReadonlyFlag = "__v_rawToShallowReadonly";
function readonly(target) {
    return createReadonly(target, false);
}
function createReadonly(target, shallow) {
    if (!isPlainObject(target)) {
        if (false) {
            if (isArray(target)) {
                warn$2("Vue 2 does not support readonly arrays.");
            }
            else if (isCollectionType(target)) {
                warn$2("Vue 2 does not support readonly collection types such as Map or Set.");
            }
            else {
                warn$2("value cannot be made readonly: ".concat(typeof target));
            }
        }
        return target;
    }
    if (false) {
        warn$2("Vue 2 does not support creating readonly proxy for non-extensible object.");
    }
    // already a readonly object
    if (isReadonly(target)) {
        return target;
    }
    // already has a readonly proxy
    var existingFlag = shallow ? rawToShallowReadonlyFlag : rawToReadonlyFlag;
    var existingProxy = target[existingFlag];
    if (existingProxy) {
        return existingProxy;
    }
    var proxy = Object.create(Object.getPrototypeOf(target));
    def(target, existingFlag, proxy);
    def(proxy, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, true);
    def(proxy, "__v_raw" /* ReactiveFlags.RAW */, target);
    if (isRef(target)) {
        def(proxy, RefFlag, true);
    }
    if (shallow || isShallow(target)) {
        def(proxy, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    }
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineReadonlyProperty(proxy, target, keys[i], shallow);
    }
    return proxy;
}
function defineReadonlyProperty(proxy, target, key, shallow) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            var val = target[key];
            return shallow || !isPlainObject(val) ? val : readonly(val);
        },
        set: function () {
            "production" !== 'production' &&
                warn$2("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        }
    });
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */
function shallowReadonly(target) {
    return createReadonly(target, true);
}

function computed(getterOrOptions, debugOptions) {
    var getter;
    var setter;
    var onlyGetter = isFunction(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter =  false
            ? function () {
                warn$2('Write operation failed: computed value is readonly');
            }
            : noop;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var watcher = isServerRendering()
        ? null
        : new Watcher(currentInstance, getter, noop, { lazy: true });
    if (false) {
        watcher.onTrack = debugOptions.onTrack;
        watcher.onTrigger = debugOptions.onTrigger;
    }
    var ref = {
        // some libs rely on the presence effect for checking computed refs
        // from normal refs, but the implementation doesn't matter
        effect: watcher,
        get value() {
            if (watcher) {
                if (watcher.dirty) {
                    watcher.evaluate();
                }
                if (Dep.target) {
                    if (false) {
                        Dep.target.onTrack({
                            effect: Dep.target,
                            target: ref,
                            type: "get" /* TrackOpTypes.GET */,
                            key: 'value'
                        });
                    }
                    watcher.depend();
                }
                return watcher.value;
            }
            else {
                return getter();
            }
        },
        set value(newVal) {
            setter(newVal);
        }
    };
    def(ref, RefFlag, true);
    def(ref, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, onlyGetter);
    return ref;
}

var mark;
var measure;
if (false) {
    var perf_1 = inBrowser && window.performance;
    /* istanbul ignore if */
    if (perf_1 &&
        // @ts-ignore
        perf_1.mark &&
        // @ts-ignore
        perf_1.measure &&
        // @ts-ignore
        perf_1.clearMarks &&
        // @ts-ignore
        perf_1.clearMeasures) {
        mark = function (tag) { return perf_1.mark(tag); };
        measure = function (name, startTag, endTag) {
            perf_1.measure(name, startTag, endTag);
            perf_1.clearMarks(startTag);
            perf_1.clearMarks(endTag);
            // perf.clearMeasures(name)
        };
    }
}

var normalizeEvent = cached(function (name) {
    var passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    var once = name.charAt(0) === '~'; // Prefixed last, checked first
    name = once ? name.slice(1) : name;
    var capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
        name: name,
        once: once,
        capture: capture,
        passive: passive
    };
});
function createFnInvoker(fns, vm) {
    function invoker() {
        var fns = invoker.fns;
        if (isArray(fns)) {
            var cloned = fns.slice();
            for (var i = 0; i < cloned.length; i++) {
                invokeWithErrorHandling(cloned[i], null, arguments, vm, "v-on handler");
            }
        }
        else {
            // return handler return value for single handlers
            return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
        }
    }
    invoker.fns = fns;
    return invoker;
}
function updateListeners(on, oldOn, add, remove, createOnceHandler, vm) {
    var name, cur, old, event;
    for (name in on) {
        cur = on[name];
        old = oldOn[name];
        event = normalizeEvent(name);
        if (isUndef(cur)) {
            "production" !== 'production' &&
                warn$2("Invalid handler for event \"".concat(event.name, "\": got ") + String(cur), vm);
        }
        else if (isUndef(old)) {
            if (isUndef(cur.fns)) {
                cur = on[name] = createFnInvoker(cur, vm);
            }
            if (isTrue(event.once)) {
                cur = on[name] = createOnceHandler(event.name, cur, event.capture);
            }
            add(event.name, cur, event.capture, event.passive, event.params);
        }
        else if (cur !== old) {
            old.fns = cur;
            on[name] = old;
        }
    }
    for (name in oldOn) {
        if (isUndef(on[name])) {
            event = normalizeEvent(name);
            remove(event.name, oldOn[name], event.capture);
        }
    }
}

function mergeVNodeHook(def, hookKey, hook) {
    if (def instanceof VNode) {
        def = def.data.hook || (def.data.hook = {});
    }
    var invoker;
    var oldHook = def[hookKey];
    function wrappedHook() {
        hook.apply(this, arguments);
        // important: remove merged hook to ensure it's called only once
        // and prevent memory leak
        remove$2(invoker.fns, wrappedHook);
    }
    if (isUndef(oldHook)) {
        // no existing hook
        invoker = createFnInvoker([wrappedHook]);
    }
    else {
        /* istanbul ignore if */
        if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
            // already a merged invoker
            invoker = oldHook;
            invoker.fns.push(wrappedHook);
        }
        else {
            // existing plain hook
            invoker = createFnInvoker([oldHook, wrappedHook]);
        }
    }
    invoker.merged = true;
    def[hookKey] = invoker;
}

function extractPropsFromVNodeData(data, Ctor, tag) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;
    if (isUndef(propOptions)) {
        return;
    }
    var res = {};
    var attrs = data.attrs, props = data.props;
    if (isDef(attrs) || isDef(props)) {
        for (var key in propOptions) {
            var altKey = hyphenate(key);
            if (false) {
                var keyInLowerCase = key.toLowerCase();
                if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
                    tip("Prop \"".concat(keyInLowerCase, "\" is passed to component ") +
                        "".concat(formatComponentName(
                        // @ts-expect-error tag is string
                        tag || Ctor), ", but the declared prop name is") +
                        " \"".concat(key, "\". ") +
                        "Note that HTML attributes are case-insensitive and camelCased " +
                        "props need to use their kebab-case equivalents when using in-DOM " +
                        "templates. You should probably use \"".concat(altKey, "\" instead of \"").concat(key, "\"."));
                }
            }
            checkProp(res, props, key, altKey, true) ||
                checkProp(res, attrs, key, altKey, false);
        }
    }
    return res;
}
function checkProp(res, hash, key, altKey, preserve) {
    if (isDef(hash)) {
        if (hasOwn(hash, key)) {
            res[key] = hash[key];
            if (!preserve) {
                delete hash[key];
            }
            return true;
        }
        else if (hasOwn(hash, altKey)) {
            res[key] = hash[altKey];
            if (!preserve) {
                delete hash[altKey];
            }
            return true;
        }
    }
    return false;
}

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:
// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren(children) {
    for (var i = 0; i < children.length; i++) {
        if (isArray(children[i])) {
            return Array.prototype.concat.apply([], children);
        }
    }
    return children;
}
// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren(children) {
    return isPrimitive(children)
        ? [createTextVNode(children)]
        : isArray(children)
            ? normalizeArrayChildren(children)
            : undefined;
}
function isTextNode(node) {
    return isDef(node) && isDef(node.text) && isFalse(node.isComment);
}
function normalizeArrayChildren(children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;
    for (i = 0; i < children.length; i++) {
        c = children[i];
        if (isUndef(c) || typeof c === 'boolean')
            continue;
        lastIndex = res.length - 1;
        last = res[lastIndex];
        //  nested
        if (isArray(c)) {
            if (c.length > 0) {
                c = normalizeArrayChildren(c, "".concat(nestedIndex || '', "_").concat(i));
                // merge adjacent text nodes
                if (isTextNode(c[0]) && isTextNode(last)) {
                    res[lastIndex] = createTextVNode(last.text + c[0].text);
                    c.shift();
                }
                res.push.apply(res, c);
            }
        }
        else if (isPrimitive(c)) {
            if (isTextNode(last)) {
                // merge adjacent text nodes
                // this is necessary for SSR hydration because text nodes are
                // essentially merged when rendered to HTML strings
                res[lastIndex] = createTextVNode(last.text + c);
            }
            else if (c !== '') {
                // convert primitive to vnode
                res.push(createTextVNode(c));
            }
        }
        else {
            if (isTextNode(c) && isTextNode(last)) {
                // merge adjacent text nodes
                res[lastIndex] = createTextVNode(last.text + c.text);
            }
            else {
                // default key for nested array children (likely generated by v-for)
                if (isTrue(children._isVList) &&
                    isDef(c.tag) &&
                    isUndef(c.key) &&
                    isDef(nestedIndex)) {
                    c.key = "__vlist".concat(nestedIndex, "_").concat(i, "__");
                }
                res.push(c);
            }
        }
    }
    return res;
}

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;
// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement$1(context, tag, data, children, normalizationType, alwaysNormalize) {
    if (isArray(data) || isPrimitive(data)) {
        normalizationType = children;
        children = data;
        data = undefined;
    }
    if (isTrue(alwaysNormalize)) {
        normalizationType = ALWAYS_NORMALIZE;
    }
    return _createElement(context, tag, data, children, normalizationType);
}
function _createElement(context, tag, data, children, normalizationType) {
    if (isDef(data) && isDef(data.__ob__)) {
        "production" !== 'production' &&
            warn$2("Avoid using observed data object as vnode data: ".concat(JSON.stringify(data), "\n") + 'Always create fresh vnode data objects in each render!', context);
        return createEmptyVNode();
    }
    // object syntax in v-bind
    if (isDef(data) && isDef(data.is)) {
        tag = data.is;
    }
    if (!tag) {
        // in case of component :is set to falsy value
        return createEmptyVNode();
    }
    // warn against non-primitive key
    if (false) {
        warn$2('Avoid using non-primitive value as key, ' +
            'use string/number value instead.', context);
    }
    // support single function children as default scoped slot
    if (isArray(children) && isFunction(children[0])) {
        data = data || {};
        data.scopedSlots = { default: children[0] };
        children.length = 0;
    }
    if (normalizationType === ALWAYS_NORMALIZE) {
        children = normalizeChildren(children);
    }
    else if (normalizationType === SIMPLE_NORMALIZE) {
        children = simpleNormalizeChildren(children);
    }
    var vnode, ns;
    if (typeof tag === 'string') {
        var Ctor = void 0;
        ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
        if (config.isReservedTag(tag)) {
            // platform built-in elements
            if (false) {
                warn$2("The .native modifier for v-on is only valid on components but it was used on <".concat(tag, ">."), context);
            }
            vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
        }
        else if ((!data || !data.pre) &&
            isDef((Ctor = resolveAsset(context.$options, 'components', tag)))) {
            // component
            vnode = createComponent(Ctor, data, context, children, tag);
        }
        else {
            // unknown or unlisted namespaced elements
            // check at runtime because it may get assigned a namespace when its
            // parent normalizes children
            vnode = new VNode(tag, data, children, undefined, undefined, context);
        }
    }
    else {
        // direct component options / constructor
        vnode = createComponent(tag, data, context, children);
    }
    if (isArray(vnode)) {
        return vnode;
    }
    else if (isDef(vnode)) {
        if (isDef(ns))
            applyNS(vnode, ns);
        if (isDef(data))
            registerDeepBindings(data);
        return vnode;
    }
    else {
        return createEmptyVNode();
    }
}
function applyNS(vnode, ns, force) {
    vnode.ns = ns;
    if (vnode.tag === 'foreignObject') {
        // use default namespace inside foreignObject
        ns = undefined;
        force = true;
    }
    if (isDef(vnode.children)) {
        for (var i = 0, l = vnode.children.length; i < l; i++) {
            var child = vnode.children[i];
            if (isDef(child.tag) &&
                (isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
                applyNS(child, ns, force);
            }
        }
    }
}
// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings(data) {
    if (isObject(data.style)) {
        traverse(data.style);
    }
    if (isObject(data.class)) {
        traverse(data.class);
    }
}

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList(val, render) {
    var ret = null, i, l, keys, key;
    if (isArray(val) || typeof val === 'string') {
        ret = new Array(val.length);
        for (i = 0, l = val.length; i < l; i++) {
            ret[i] = render(val[i], i);
        }
    }
    else if (typeof val === 'number') {
        ret = new Array(val);
        for (i = 0; i < val; i++) {
            ret[i] = render(i + 1, i);
        }
    }
    else if (isObject(val)) {
        if (hasSymbol && val[Symbol.iterator]) {
            ret = [];
            var iterator = val[Symbol.iterator]();
            var result = iterator.next();
            while (!result.done) {
                ret.push(render(result.value, ret.length));
                result = iterator.next();
            }
        }
        else {
            keys = Object.keys(val);
            ret = new Array(keys.length);
            for (i = 0, l = keys.length; i < l; i++) {
                key = keys[i];
                ret[i] = render(val[key], key, i);
            }
        }
    }
    if (!isDef(ret)) {
        ret = [];
    }
    ret._isVList = true;
    return ret;
}

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot(name, fallbackRender, props, bindObject) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;
    if (scopedSlotFn) {
        // scoped slot
        props = props || {};
        if (bindObject) {
            if (false) {
                warn$2('slot v-bind without argument expects an Object', this);
            }
            props = extend(extend({}, bindObject), props);
        }
        nodes =
            scopedSlotFn(props) ||
                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    else {
        nodes =
            this.$slots[name] ||
                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    var target = props && props.slot;
    if (target) {
        return this.$createElement('template', { slot: target }, nodes);
    }
    else {
        return nodes;
    }
}

/**
 * Runtime helper for resolving filters
 */
function resolveFilter(id) {
    return resolveAsset(this.$options, 'filters', id, true) || identity;
}

function isKeyNotMatch(expect, actual) {
    if (isArray(expect)) {
        return expect.indexOf(actual) === -1;
    }
    else {
        return expect !== actual;
    }
}
/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
    var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
    if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
        return isKeyNotMatch(builtInKeyName, eventKeyName);
    }
    else if (mappedKeyCode) {
        return isKeyNotMatch(mappedKeyCode, eventKeyCode);
    }
    else if (eventKeyName) {
        return hyphenate(eventKeyName) !== key;
    }
    return eventKeyCode === undefined;
}

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps(data, tag, value, asProp, isSync) {
    if (value) {
        if (!isObject(value)) {
            "production" !== 'production' &&
                warn$2('v-bind without argument expects an Object or Array value', this);
        }
        else {
            if (isArray(value)) {
                value = toObject(value);
            }
            var hash = void 0;
            var _loop_1 = function (key) {
                if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
                    hash = data;
                }
                else {
                    var type = data.attrs && data.attrs.type;
                    hash =
                        asProp || config.mustUseProp(tag, type, key)
                            ? data.domProps || (data.domProps = {})
                            : data.attrs || (data.attrs = {});
                }
                var camelizedKey = camelize(key);
                var hyphenatedKey = hyphenate(key);
                if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
                    hash[key] = value[key];
                    if (isSync) {
                        var on = data.on || (data.on = {});
                        on["update:".concat(key)] = function ($event) {
                            value[key] = $event;
                        };
                    }
                }
            };
            for (var key in value) {
                _loop_1(key);
            }
        }
    }
    return data;
}

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic(index, isInFor) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index];
    // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.
    if (tree && !isInFor) {
        return tree;
    }
    // otherwise, render a fresh tree.
    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, this._c, this // for render fns generated for functional component templates
    );
    markStatic$1(tree, "__static__".concat(index), false);
    return tree;
}
/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce(tree, index, key) {
    markStatic$1(tree, "__once__".concat(index).concat(key ? "_".concat(key) : ""), true);
    return tree;
}
function markStatic$1(tree, key, isOnce) {
    if (isArray(tree)) {
        for (var i = 0; i < tree.length; i++) {
            if (tree[i] && typeof tree[i] !== 'string') {
                markStaticNode(tree[i], "".concat(key, "_").concat(i), isOnce);
            }
        }
    }
    else {
        markStaticNode(tree, key, isOnce);
    }
}
function markStaticNode(node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
}

function bindObjectListeners(data, value) {
    if (value) {
        if (!isPlainObject(value)) {
            "production" !== 'production' && warn$2('v-on without argument expects an Object value', this);
        }
        else {
            var on = (data.on = data.on ? extend({}, data.on) : {});
            for (var key in value) {
                var existing = on[key];
                var ours = value[key];
                on[key] = existing ? [].concat(existing, ours) : ours;
            }
        }
    }
    return data;
}

function resolveScopedSlots(fns, res, 
// the following are added in 2.6
hasDynamicKeys, contentHashKey) {
    res = res || { $stable: !hasDynamicKeys };
    for (var i = 0; i < fns.length; i++) {
        var slot = fns[i];
        if (isArray(slot)) {
            resolveScopedSlots(slot, res, hasDynamicKeys);
        }
        else if (slot) {
            // marker for reverse proxying v-slot without scope on this.$slots
            // @ts-expect-error
            if (slot.proxy) {
                // @ts-expect-error
                slot.fn.proxy = true;
            }
            res[slot.key] = slot.fn;
        }
    }
    if (contentHashKey) {
        res.$key = contentHashKey;
    }
    return res;
}

// helper to process dynamic keys for dynamic arguments in v-bind and v-on.
function bindDynamicKeys(baseObj, values) {
    for (var i = 0; i < values.length; i += 2) {
        var key = values[i];
        if (typeof key === 'string' && key) {
            baseObj[values[i]] = values[i + 1];
        }
        else if (false) {
            // null is a special value for explicitly removing a binding
            warn$2("Invalid value for dynamic directive argument (expected string or null): ".concat(key), this);
        }
    }
    return baseObj;
}
// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier(value, symbol) {
    return typeof value === 'string' ? symbol + value : value;
}

function installRenderHelpers(target) {
    target._o = markOnce;
    target._n = toNumber;
    target._s = toString;
    target._l = renderList;
    target._t = renderSlot;
    target._q = looseEqual;
    target._i = looseIndexOf;
    target._m = renderStatic;
    target._f = resolveFilter;
    target._k = checkKeyCodes;
    target._b = bindObjectProps;
    target._v = createTextVNode;
    target._e = createEmptyVNode;
    target._u = resolveScopedSlots;
    target._g = bindObjectListeners;
    target._d = bindDynamicKeys;
    target._p = prependModifier;
}

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots(children, context) {
    if (!children || !children.length) {
        return {};
    }
    var slots = {};
    for (var i = 0, l = children.length; i < l; i++) {
        var child = children[i];
        var data = child.data;
        // remove slot attribute if the node is resolved as a Vue slot node
        if (data && data.attrs && data.attrs.slot) {
            delete data.attrs.slot;
        }
        // named slots should only be respected if the vnode was rendered in the
        // same context.
        if ((child.context === context || child.fnContext === context) &&
            data &&
            data.slot != null) {
            var name_1 = data.slot;
            var slot = slots[name_1] || (slots[name_1] = []);
            if (child.tag === 'template') {
                slot.push.apply(slot, child.children || []);
            }
            else {
                slot.push(child);
            }
        }
        else {
            (slots.default || (slots.default = [])).push(child);
        }
    }
    // ignore slots that contains only whitespace
    for (var name_2 in slots) {
        if (slots[name_2].every(isWhitespace)) {
            delete slots[name_2];
        }
    }
    return slots;
}
function isWhitespace(node) {
    return (node.isComment && !node.asyncFactory) || node.text === ' ';
}

function isAsyncPlaceholder(node) {
    // @ts-expect-error not really boolean type
    return node.isComment && node.asyncFactory;
}

function normalizeScopedSlots(ownerVm, scopedSlots, normalSlots, prevScopedSlots) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = scopedSlots ? !!scopedSlots.$stable : !hasNormalSlots;
    var key = scopedSlots && scopedSlots.$key;
    if (!scopedSlots) {
        res = {};
    }
    else if (scopedSlots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return scopedSlots._normalized;
    }
    else if (isStable &&
        prevScopedSlots &&
        prevScopedSlots !== emptyObject &&
        key === prevScopedSlots.$key &&
        !hasNormalSlots &&
        !prevScopedSlots.$hasNormal) {
        // fast path 2: stable scoped slots w/ no normal slots to proxy,
        // only need to normalize once
        return prevScopedSlots;
    }
    else {
        res = {};
        for (var key_1 in scopedSlots) {
            if (scopedSlots[key_1] && key_1[0] !== '$') {
                res[key_1] = normalizeScopedSlot(ownerVm, normalSlots, key_1, scopedSlots[key_1]);
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key_2 in normalSlots) {
        if (!(key_2 in res)) {
            res[key_2] = proxyNormalSlot(normalSlots, key_2);
        }
    }
    // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error
    if (scopedSlots && Object.isExtensible(scopedSlots)) {
        scopedSlots._normalized = res;
    }
    def(res, '$stable', isStable);
    def(res, '$key', key);
    def(res, '$hasNormal', hasNormalSlots);
    return res;
}
function normalizeScopedSlot(vm, normalSlots, key, fn) {
    var normalized = function () {
        var cur = currentInstance;
        setCurrentInstance(vm);
        var res = arguments.length ? fn.apply(null, arguments) : fn({});
        res =
            res && typeof res === 'object' && !isArray(res)
                ? [res] // single vnode
                : normalizeChildren(res);
        var vnode = res && res[0];
        setCurrentInstance(cur);
        return res &&
            (!vnode ||
                (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode))) // #9658, #10391
            ? undefined
            : res;
    };
    // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.
    if (fn.proxy) {
        Object.defineProperty(normalSlots, key, {
            get: normalized,
            enumerable: true,
            configurable: true
        });
    }
    return normalized;
}
function proxyNormalSlot(slots, key) {
    return function () { return slots[key]; };
}

function initSetup(vm) {
    var options = vm.$options;
    var setup = options.setup;
    if (setup) {
        var ctx = (vm._setupContext = createSetupContext(vm));
        setCurrentInstance(vm);
        pushTarget();
        var setupResult = invokeWithErrorHandling(setup, null, [vm._props || shallowReactive({}), ctx], vm, "setup");
        popTarget();
        setCurrentInstance();
        if (isFunction(setupResult)) {
            // render function
            // @ts-ignore
            options.render = setupResult;
        }
        else if (isObject(setupResult)) {
            // bindings
            if (false) {
                warn$2("setup() should not return VNodes directly - " +
                    "return a render function instead.");
            }
            vm._setupState = setupResult;
            // __sfc indicates compiled bindings from <script setup>
            if (!setupResult.__sfc) {
                for (var key in setupResult) {
                    if (!isReserved(key)) {
                        proxyWithRefUnwrap(vm, setupResult, key);
                    }
                    else if (false) {
                        warn$2("Avoid using variables that start with _ or $ in setup().");
                    }
                }
            }
            else {
                // exposed for compiled render fn
                var proxy = (vm._setupProxy = {});
                for (var key in setupResult) {
                    if (key !== '__sfc') {
                        proxyWithRefUnwrap(proxy, setupResult, key);
                    }
                }
            }
        }
        else if (false) {
            warn$2("setup() should return an object. Received: ".concat(setupResult === null ? 'null' : typeof setupResult));
        }
    }
}
function createSetupContext(vm) {
    var exposeCalled = false;
    return {
        get attrs() {
            if (!vm._attrsProxy) {
                var proxy = (vm._attrsProxy = {});
                def(proxy, '_v_attr_proxy', true);
                syncSetupProxy(proxy, vm.$attrs, emptyObject, vm, '$attrs');
            }
            return vm._attrsProxy;
        },
        get listeners() {
            if (!vm._listenersProxy) {
                var proxy = (vm._listenersProxy = {});
                syncSetupProxy(proxy, vm.$listeners, emptyObject, vm, '$listeners');
            }
            return vm._listenersProxy;
        },
        get slots() {
            return initSlotsProxy(vm);
        },
        emit: bind$1(vm.$emit, vm),
        expose: function (exposed) {
            if (false) {
                if (exposeCalled) {
                    warn$2("expose() should be called only once per setup().", vm);
                }
                exposeCalled = true;
            }
            if (exposed) {
                Object.keys(exposed).forEach(function (key) {
                    return proxyWithRefUnwrap(vm, exposed, key);
                });
            }
        }
    };
}
function syncSetupProxy(to, from, prev, instance, type) {
    var changed = false;
    for (var key in from) {
        if (!(key in to)) {
            changed = true;
            defineProxyAttr(to, key, instance, type);
        }
        else if (from[key] !== prev[key]) {
            changed = true;
        }
    }
    for (var key in to) {
        if (!(key in from)) {
            changed = true;
            delete to[key];
        }
    }
    return changed;
}
function defineProxyAttr(proxy, key, instance, type) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            return instance[type][key];
        }
    });
}
function initSlotsProxy(vm) {
    if (!vm._slotsProxy) {
        syncSetupSlots((vm._slotsProxy = {}), vm.$scopedSlots);
    }
    return vm._slotsProxy;
}
function syncSetupSlots(to, from) {
    for (var key in from) {
        to[key] = from[key];
    }
    for (var key in to) {
        if (!(key in from)) {
            delete to[key];
        }
    }
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useSlots() {
    return getContext().slots;
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useAttrs() {
    return getContext().attrs;
}
/**
 * Vue 2 only
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useListeners() {
    return getContext().listeners;
}
function getContext() {
    if (false) {
        warn$2("useContext() called without active instance.");
    }
    var vm = currentInstance;
    return vm._setupContext || (vm._setupContext = createSetupContext(vm));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */
function mergeDefaults(raw, defaults) {
    var props = isArray(raw)
        ? raw.reduce(function (normalized, p) { return ((normalized[p] = {}), normalized); }, {})
        : raw;
    for (var key in defaults) {
        var opt = props[key];
        if (opt) {
            if (isArray(opt) || isFunction(opt)) {
                props[key] = { type: opt, default: defaults[key] };
            }
            else {
                opt.default = defaults[key];
            }
        }
        else if (opt === null) {
            props[key] = { default: defaults[key] };
        }
        else if (false) {
            warn$2("props default key \"".concat(key, "\" has no corresponding declaration."));
        }
    }
    return props;
}

function initRender(vm) {
    vm._vnode = null; // the root of the child tree
    vm._staticTrees = null; // v-once cached trees
    var options = vm.$options;
    var parentVnode = (vm.$vnode = options._parentVnode); // the placeholder node in parent tree
    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = parentVnode
        ? normalizeScopedSlots(vm.$parent, parentVnode.data.scopedSlots, vm.$slots)
        : emptyObject;
    // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates
    // @ts-expect-error
    vm._c = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, false); };
    // normalization is always applied for the public version, used in
    // user-written render functions.
    // @ts-expect-error
    vm.$createElement = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, true); };
    // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated
    var parentData = parentVnode && parentVnode.data;
    /* istanbul ignore else */
    if (false) {
        defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, function () {
            !isUpdatingChildComponent && warn$2("$attrs is readonly.", vm);
        }, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
            !isUpdatingChildComponent && warn$2("$listeners is readonly.", vm);
        }, true);
    }
    else {
        defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, null, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
    }
}
var currentRenderingInstance = null;
function renderMixin(Vue) {
    // install runtime convenience helpers
    installRenderHelpers(Vue.prototype);
    Vue.prototype.$nextTick = function (fn) {
        return nextTick(fn, this);
    };
    Vue.prototype._render = function () {
        var vm = this;
        var _a = vm.$options, render = _a.render, _parentVnode = _a._parentVnode;
        if (_parentVnode && vm._isMounted) {
            vm.$scopedSlots = normalizeScopedSlots(vm.$parent, _parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
            if (vm._slotsProxy) {
                syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
            }
        }
        // set parent vnode. this allows render functions to have access
        // to the data on the placeholder node.
        vm.$vnode = _parentVnode;
        // render self
        var vnode;
        try {
            // There's no need to maintain a stack because all render fns are called
            // separately from one another. Nested component's render fns are called
            // when parent component is patched.
            setCurrentInstance(vm);
            currentRenderingInstance = vm;
            vnode = render.call(vm._renderProxy, vm.$createElement);
        }
        catch (e) {
            handleError(e, vm, "render");
            // return error render result,
            // or previous vnode to prevent render error causing blank component
            /* istanbul ignore else */
            if (false) {
                try {
                    vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
                }
                catch (e) {
                    handleError(e, vm, "renderError");
                    vnode = vm._vnode;
                }
            }
            else {
                vnode = vm._vnode;
            }
        }
        finally {
            currentRenderingInstance = null;
            setCurrentInstance();
        }
        // if the returned array contains only a single node, allow it
        if (isArray(vnode) && vnode.length === 1) {
            vnode = vnode[0];
        }
        // return empty vnode in case the render function errored out
        if (!(vnode instanceof VNode)) {
            if (false) {
                warn$2('Multiple root nodes returned from render function. Render function ' +
                    'should return a single root node.', vm);
            }
            vnode = createEmptyVNode();
        }
        // set parent
        vnode.parent = _parentVnode;
        return vnode;
    };
}

function ensureCtor(comp, base) {
    if (comp.__esModule || (hasSymbol && comp[Symbol.toStringTag] === 'Module')) {
        comp = comp.default;
    }
    return isObject(comp) ? base.extend(comp) : comp;
}
function createAsyncPlaceholder(factory, data, context, children, tag) {
    var node = createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = { data: data, context: context, children: children, tag: tag };
    return node;
}
function resolveAsyncComponent(factory, baseCtor) {
    if (isTrue(factory.error) && isDef(factory.errorComp)) {
        return factory.errorComp;
    }
    if (isDef(factory.resolved)) {
        return factory.resolved;
    }
    var owner = currentRenderingInstance;
    if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
        // already pending
        factory.owners.push(owner);
    }
    if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
        return factory.loadingComp;
    }
    if (owner && !isDef(factory.owners)) {
        var owners_1 = (factory.owners = [owner]);
        var sync_1 = true;
        var timerLoading_1 = null;
        var timerTimeout_1 = null;
        owner.$on('hook:destroyed', function () { return remove$2(owners_1, owner); });
        var forceRender_1 = function (renderCompleted) {
            for (var i = 0, l = owners_1.length; i < l; i++) {
                owners_1[i].$forceUpdate();
            }
            if (renderCompleted) {
                owners_1.length = 0;
                if (timerLoading_1 !== null) {
                    clearTimeout(timerLoading_1);
                    timerLoading_1 = null;
                }
                if (timerTimeout_1 !== null) {
                    clearTimeout(timerTimeout_1);
                    timerTimeout_1 = null;
                }
            }
        };
        var resolve = once(function (res) {
            // cache resolved
            factory.resolved = ensureCtor(res, baseCtor);
            // invoke callbacks only if this is not a synchronous resolve
            // (async resolves are shimmed as synchronous during SSR)
            if (!sync_1) {
                forceRender_1(true);
            }
            else {
                owners_1.length = 0;
            }
        });
        var reject_1 = once(function (reason) {
            "production" !== 'production' &&
                warn$2("Failed to resolve async component: ".concat(String(factory)) +
                    (reason ? "\nReason: ".concat(reason) : ''));
            if (isDef(factory.errorComp)) {
                factory.error = true;
                forceRender_1(true);
            }
        });
        var res_1 = factory(resolve, reject_1);
        if (isObject(res_1)) {
            if (isPromise(res_1)) {
                // () => Promise
                if (isUndef(factory.resolved)) {
                    res_1.then(resolve, reject_1);
                }
            }
            else if (isPromise(res_1.component)) {
                res_1.component.then(resolve, reject_1);
                if (isDef(res_1.error)) {
                    factory.errorComp = ensureCtor(res_1.error, baseCtor);
                }
                if (isDef(res_1.loading)) {
                    factory.loadingComp = ensureCtor(res_1.loading, baseCtor);
                    if (res_1.delay === 0) {
                        factory.loading = true;
                    }
                    else {
                        // @ts-expect-error NodeJS timeout type
                        timerLoading_1 = setTimeout(function () {
                            timerLoading_1 = null;
                            if (isUndef(factory.resolved) && isUndef(factory.error)) {
                                factory.loading = true;
                                forceRender_1(false);
                            }
                        }, res_1.delay || 200);
                    }
                }
                if (isDef(res_1.timeout)) {
                    // @ts-expect-error NodeJS timeout type
                    timerTimeout_1 = setTimeout(function () {
                        timerTimeout_1 = null;
                        if (isUndef(factory.resolved)) {
                            reject_1( false ? "timeout (".concat(res_1.timeout, "ms)") : null);
                        }
                    }, res_1.timeout);
                }
            }
        }
        sync_1 = false;
        // return in case resolved synchronously
        return factory.loading ? factory.loadingComp : factory.resolved;
    }
}

function getFirstComponentChild(children) {
    if (isArray(children)) {
        for (var i = 0; i < children.length; i++) {
            var c = children[i];
            if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
                return c;
            }
        }
    }
}

function initEvents(vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false;
    // init parent attached events
    var listeners = vm.$options._parentListeners;
    if (listeners) {
        updateComponentListeners(vm, listeners);
    }
}
var target$1;
function add$1(event, fn) {
    target$1.$on(event, fn);
}
function remove$1(event, fn) {
    target$1.$off(event, fn);
}
function createOnceHandler$1(event, fn) {
    var _target = target$1;
    return function onceHandler() {
        var res = fn.apply(null, arguments);
        if (res !== null) {
            _target.$off(event, onceHandler);
        }
    };
}
function updateComponentListeners(vm, listeners, oldListeners) {
    target$1 = vm;
    updateListeners(listeners, oldListeners || {}, add$1, remove$1, createOnceHandler$1, vm);
    target$1 = undefined;
}
function eventsMixin(Vue) {
    var hookRE = /^hook:/;
    Vue.prototype.$on = function (event, fn) {
        var vm = this;
        if (isArray(event)) {
            for (var i = 0, l = event.length; i < l; i++) {
                vm.$on(event[i], fn);
            }
        }
        else {
            (vm._events[event] || (vm._events[event] = [])).push(fn);
            // optimize hook:event cost by using a boolean flag marked at registration
            // instead of a hash lookup
            if (hookRE.test(event)) {
                vm._hasHookEvent = true;
            }
        }
        return vm;
    };
    Vue.prototype.$once = function (event, fn) {
        var vm = this;
        function on() {
            vm.$off(event, on);
            fn.apply(vm, arguments);
        }
        on.fn = fn;
        vm.$on(event, on);
        return vm;
    };
    Vue.prototype.$off = function (event, fn) {
        var vm = this;
        // all
        if (!arguments.length) {
            vm._events = Object.create(null);
            return vm;
        }
        // array of events
        if (isArray(event)) {
            for (var i_1 = 0, l = event.length; i_1 < l; i_1++) {
                vm.$off(event[i_1], fn);
            }
            return vm;
        }
        // specific event
        var cbs = vm._events[event];
        if (!cbs) {
            return vm;
        }
        if (!fn) {
            vm._events[event] = null;
            return vm;
        }
        // specific handler
        var cb;
        var i = cbs.length;
        while (i--) {
            cb = cbs[i];
            if (cb === fn || cb.fn === fn) {
                cbs.splice(i, 1);
                break;
            }
        }
        return vm;
    };
    Vue.prototype.$emit = function (event) {
        var vm = this;
        if (false) {
            var lowerCaseEvent = event.toLowerCase();
            if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
                tip("Event \"".concat(lowerCaseEvent, "\" is emitted in component ") +
                    "".concat(formatComponentName(vm), " but the handler is registered for \"").concat(event, "\". ") +
                    "Note that HTML attributes are case-insensitive and you cannot use " +
                    "v-on to listen to camelCase events when using in-DOM templates. " +
                    "You should probably use \"".concat(hyphenate(event), "\" instead of \"").concat(event, "\"."));
            }
        }
        var cbs = vm._events[event];
        if (cbs) {
            cbs = cbs.length > 1 ? toArray(cbs) : cbs;
            var args = toArray(arguments, 1);
            var info = "event handler for \"".concat(event, "\"");
            for (var i = 0, l = cbs.length; i < l; i++) {
                invokeWithErrorHandling(cbs[i], vm, args, vm, info);
            }
        }
        return vm;
    };
}

var activeInstance = null;
var isUpdatingChildComponent = false;
function setActiveInstance(vm) {
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    return function () {
        activeInstance = prevActiveInstance;
    };
}
function initLifecycle(vm) {
    var options = vm.$options;
    // locate first non-abstract parent
    var parent = options.parent;
    if (parent && !options.abstract) {
        while (parent.$options.abstract && parent.$parent) {
            parent = parent.$parent;
        }
        parent.$children.push(vm);
    }
    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;
    vm.$children = [];
    vm.$refs = {};
    vm._provided = parent ? parent._provided : Object.create(null);
    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
}
function lifecycleMixin(Vue) {
    Vue.prototype._update = function (vnode, hydrating) {
        var vm = this;
        var prevEl = vm.$el;
        var prevVnode = vm._vnode;
        var restoreActiveInstance = setActiveInstance(vm);
        vm._vnode = vnode;
        // Vue.prototype.__patch__ is injected in entry points
        // based on the rendering backend used.
        if (!prevVnode) {
            // initial render
            vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
        }
        else {
            // updates
            vm.$el = vm.__patch__(prevVnode, vnode);
        }
        restoreActiveInstance();
        // update __vue__ reference
        if (prevEl) {
            prevEl.__vue__ = null;
        }
        if (vm.$el) {
            vm.$el.__vue__ = vm;
        }
        // if parent is an HOC, update its $el as well
        var wrapper = vm;
        while (wrapper &&
            wrapper.$vnode &&
            wrapper.$parent &&
            wrapper.$vnode === wrapper.$parent._vnode) {
            wrapper.$parent.$el = wrapper.$el;
            wrapper = wrapper.$parent;
        }
        // updated hook is called by the scheduler to ensure that children are
        // updated in a parent's updated hook.
    };
    Vue.prototype.$forceUpdate = function () {
        var vm = this;
        if (vm._watcher) {
            vm._watcher.update();
        }
    };
    Vue.prototype.$destroy = function () {
        var vm = this;
        if (vm._isBeingDestroyed) {
            return;
        }
        callHook$1(vm, 'beforeDestroy');
        vm._isBeingDestroyed = true;
        // remove self from parent
        var parent = vm.$parent;
        if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
            remove$2(parent.$children, vm);
        }
        // teardown scope. this includes both the render watcher and other
        // watchers created
        vm._scope.stop();
        // remove reference from data ob
        // frozen object may not have observer.
        if (vm._data.__ob__) {
            vm._data.__ob__.vmCount--;
        }
        // call the last hook...
        vm._isDestroyed = true;
        // invoke destroy hooks on current rendered tree
        vm.__patch__(vm._vnode, null);
        // fire destroyed hook
        callHook$1(vm, 'destroyed');
        // turn off all instance listeners.
        vm.$off();
        // remove __vue__ reference
        if (vm.$el) {
            vm.$el.__vue__ = null;
        }
        // release circular reference (#6759)
        if (vm.$vnode) {
            vm.$vnode.parent = null;
        }
    };
}
function mountComponent(vm, el, hydrating) {
    vm.$el = el;
    if (!vm.$options.render) {
        // @ts-expect-error invalid type
        vm.$options.render = createEmptyVNode;
        if (false) {
            /* istanbul ignore if */
            if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
                vm.$options.el ||
                el) {
                warn$2('You are using the runtime-only build of Vue where the template ' +
                    'compiler is not available. Either pre-compile the templates into ' +
                    'render functions, or use the compiler-included build.', vm);
            }
            else {
                warn$2('Failed to mount component: template or render function not defined.', vm);
            }
        }
    }
    callHook$1(vm, 'beforeMount');
    var updateComponent;
    /* istanbul ignore if */
    if (false) {
        updateComponent = function () {
            var name = vm._name;
            var id = vm._uid;
            var startTag = "vue-perf-start:".concat(id);
            var endTag = "vue-perf-end:".concat(id);
            mark(startTag);
            var vnode = vm._render();
            mark(endTag);
            measure("vue ".concat(name, " render"), startTag, endTag);
            mark(startTag);
            vm._update(vnode, hydrating);
            mark(endTag);
            measure("vue ".concat(name, " patch"), startTag, endTag);
        };
    }
    else {
        updateComponent = function () {
            vm._update(vm._render(), hydrating);
        };
    }
    var watcherOptions = {
        before: function () {
            if (vm._isMounted && !vm._isDestroyed) {
                callHook$1(vm, 'beforeUpdate');
            }
        }
    };
    if (false) {
        watcherOptions.onTrack = function (e) { return callHook$1(vm, 'renderTracked', [e]); };
        watcherOptions.onTrigger = function (e) { return callHook$1(vm, 'renderTriggered', [e]); };
    }
    // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined
    new Watcher(vm, updateComponent, noop, watcherOptions, true /* isRenderWatcher */);
    hydrating = false;
    // flush buffer for flush: "pre" watchers queued in setup()
    var preWatchers = vm._preWatchers;
    if (preWatchers) {
        for (var i = 0; i < preWatchers.length; i++) {
            preWatchers[i].run();
        }
    }
    // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook
    if (vm.$vnode == null) {
        vm._isMounted = true;
        callHook$1(vm, 'mounted');
    }
    return vm;
}
function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
    if (false) {
        isUpdatingChildComponent = true;
    }
    // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.
    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.
    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!((newScopedSlots && !newScopedSlots.$stable) ||
        (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
        (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
        (!newScopedSlots && vm.$scopedSlots.$key));
    // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.
    var needsForceUpdate = !!(renderChildren || // has new static slots
        vm.$options._renderChildren || // has old static slots
        hasDynamicScopedSlot);
    var prevVNode = vm.$vnode;
    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
    if (vm._vnode) {
        // update child tree's parent
        vm._vnode.parent = parentVnode;
    }
    vm.$options._renderChildren = renderChildren;
    // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render
    var attrs = parentVnode.data.attrs || emptyObject;
    if (vm._attrsProxy) {
        // force update if attrs are accessed and has changed since it may be
        // passed to a child component.
        if (syncSetupProxy(vm._attrsProxy, attrs, (prevVNode.data && prevVNode.data.attrs) || emptyObject, vm, '$attrs')) {
            needsForceUpdate = true;
        }
    }
    vm.$attrs = attrs;
    // update listeners
    listeners = listeners || emptyObject;
    var prevListeners = vm.$options._parentListeners;
    if (vm._listenersProxy) {
        syncSetupProxy(vm._listenersProxy, listeners, prevListeners || emptyObject, vm, '$listeners');
    }
    vm.$listeners = vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, prevListeners);
    // update props
    if (propsData && vm.$options.props) {
        toggleObserving(false);
        var props = vm._props;
        var propKeys = vm.$options._propKeys || [];
        for (var i = 0; i < propKeys.length; i++) {
            var key = propKeys[i];
            var propOptions = vm.$options.props; // wtf flow?
            props[key] = validateProp(key, propOptions, propsData, vm);
        }
        toggleObserving(true);
        // keep a copy of raw propsData
        vm.$options.propsData = propsData;
    }
    // resolve slots + force update if has children
    if (needsForceUpdate) {
        vm.$slots = resolveSlots(renderChildren, parentVnode.context);
        vm.$forceUpdate();
    }
    if (false) {
        isUpdatingChildComponent = false;
    }
}
function isInInactiveTree(vm) {
    while (vm && (vm = vm.$parent)) {
        if (vm._inactive)
            return true;
    }
    return false;
}
function activateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = false;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    else if (vm._directInactive) {
        return;
    }
    if (vm._inactive || vm._inactive === null) {
        vm._inactive = false;
        for (var i = 0; i < vm.$children.length; i++) {
            activateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'activated');
    }
}
function deactivateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = true;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    if (!vm._inactive) {
        vm._inactive = true;
        for (var i = 0; i < vm.$children.length; i++) {
            deactivateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'deactivated');
    }
}
function callHook$1(vm, hook, args, setContext) {
    if (setContext === void 0) { setContext = true; }
    // #7573 disable dep collection when invoking lifecycle hooks
    pushTarget();
    var prev = currentInstance;
    setContext && setCurrentInstance(vm);
    var handlers = vm.$options[hook];
    var info = "".concat(hook, " hook");
    if (handlers) {
        for (var i = 0, j = handlers.length; i < j; i++) {
            invokeWithErrorHandling(handlers[i], vm, args || null, vm, info);
        }
    }
    if (vm._hasHookEvent) {
        vm.$emit('hook:' + hook);
    }
    setContext && setCurrentInstance(prev);
    popTarget();
}

var MAX_UPDATE_COUNT = 100;
var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index$1 = 0;
/**
 * Reset the scheduler's state.
 */
function resetSchedulerState() {
    index$1 = queue.length = activatedChildren.length = 0;
    has = {};
    if (false) {
        circular = {};
    }
    waiting = flushing = false;
}
// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;
// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;
// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
    var performance_1 = window.performance;
    if (performance_1 &&
        typeof performance_1.now === 'function' &&
        getNow() > document.createEvent('Event').timeStamp) {
        // if the event timestamp, although evaluated AFTER the Date.now(), is
        // smaller than it, it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listener timestamps as
        // well.
        getNow = function () { return performance_1.now(); };
    }
}
var sortCompareFn = function (a, b) {
    if (a.post) {
        if (!b.post)
            return 1;
    }
    else if (b.post) {
        return -1;
    }
    return a.id - b.id;
};
/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue() {
    currentFlushTimestamp = getNow();
    flushing = true;
    var watcher, id;
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.
    queue.sort(sortCompareFn);
    // do not cache length because more watchers might be pushed
    // as we run existing watchers
    for (index$1 = 0; index$1 < queue.length; index$1++) {
        watcher = queue[index$1];
        if (watcher.before) {
            watcher.before();
        }
        id = watcher.id;
        has[id] = null;
        watcher.run();
        // in dev build, check and stop circular updates.
        if (false) {
            circular[id] = (circular[id] || 0) + 1;
            if (circular[id] > MAX_UPDATE_COUNT) {
                warn$2('You may have an infinite update loop ' +
                    (watcher.user
                        ? "in watcher with expression \"".concat(watcher.expression, "\"")
                        : "in a component render function."), watcher.vm);
                break;
            }
        }
    }
    // keep copies of post queues before resetting state
    var activatedQueue = activatedChildren.slice();
    var updatedQueue = queue.slice();
    resetSchedulerState();
    // call component updated and activated hooks
    callActivatedHooks(activatedQueue);
    callUpdatedHooks(updatedQueue);
    cleanupDeps();
    // devtool hook
    /* istanbul ignore if */
    if (devtools && config.devtools) {
        devtools.emit('flush');
    }
}
function callUpdatedHooks(queue) {
    var i = queue.length;
    while (i--) {
        var watcher = queue[i];
        var vm = watcher.vm;
        if (vm && vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
            callHook$1(vm, 'updated');
        }
    }
}
/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent(vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    activatedChildren.push(vm);
}
function callActivatedHooks(queue) {
    for (var i = 0; i < queue.length; i++) {
        queue[i]._inactive = true;
        activateChildComponent(queue[i], true /* true */);
    }
}
/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher(watcher) {
    var id = watcher.id;
    if (has[id] != null) {
        return;
    }
    if (watcher === Dep.target && watcher.noRecurse) {
        return;
    }
    has[id] = true;
    if (!flushing) {
        queue.push(watcher);
    }
    else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = queue.length - 1;
        while (i > index$1 && queue[i].id > watcher.id) {
            i--;
        }
        queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
        waiting = true;
        if (false) {
            flushSchedulerQueue();
            return;
        }
        nextTick(flushSchedulerQueue);
    }
}

var WATCHER = "watcher";
var WATCHER_CB = "".concat(WATCHER, " callback");
var WATCHER_GETTER = "".concat(WATCHER, " getter");
var WATCHER_CLEANUP = "".concat(WATCHER, " cleanup");
// Simple effect.
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null, ( false
        ? __assign(__assign({}, options), { flush: 'post' }) : { flush: 'post' }));
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null, ( false
        ? __assign(__assign({}, options), { flush: 'sync' }) : { flush: 'sync' }));
}
// initial value for watchers to trigger on undefined initial values
var INITIAL_WATCHER_VALUE = {};
// implementation
function watch(source, cb, options) {
    if (false) {
        warn$2("`watch(fn, options?)` signature has been moved to a separate API. " +
            "Use `watchEffect(fn, options?)` instead. `watch` now only " +
            "supports `watch(source, cb, options?) signature.");
    }
    return doWatch(source, cb, options);
}
function doWatch(source, cb, _a) {
    var _b = _a === void 0 ? emptyObject : _a, immediate = _b.immediate, deep = _b.deep, _c = _b.flush, flush = _c === void 0 ? 'pre' : _c, onTrack = _b.onTrack, onTrigger = _b.onTrigger;
    if (false) {
        if (immediate !== undefined) {
            warn$2("watch() \"immediate\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
        if (deep !== undefined) {
            warn$2("watch() \"deep\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
    }
    var warnInvalidSource = function (s) {
        warn$2("Invalid watch source: ".concat(s, ". A watch source can only be a getter/effect ") +
            "function, a ref, a reactive object, or an array of these types.");
    };
    var instance = currentInstance;
    var call = function (fn, type, args) {
        if (args === void 0) { args = null; }
        return invokeWithErrorHandling(fn, null, args, instance, type);
    };
    var getter;
    var forceTrigger = false;
    var isMultiSource = false;
    if (isRef(source)) {
        getter = function () { return source.value; };
        forceTrigger = isShallow(source);
    }
    else if (isReactive(source)) {
        getter = function () {
            source.__ob__.dep.depend();
            return source;
        };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function (s) { return isReactive(s) || isShallow(s); });
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return call(s, WATCHER_GETTER);
                }
                else {
                    "production" !== 'production' && warnInvalidSource(s);
                }
            });
        };
    }
    else if (isFunction(source)) {
        if (cb) {
            // getter with cb
            getter = function () { return call(source, WATCHER_GETTER); };
        }
        else {
            // no cb -> simple effect
            getter = function () {
                if (instance && instance._isDestroyed) {
                    return;
                }
                if (cleanup) {
                    cleanup();
                }
                return call(source, WATCHER, [onCleanup]);
            };
        }
    }
    else {
        getter = noop;
        "production" !== 'production' && warnInvalidSource(source);
    }
    if (cb && deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var cleanup;
    var onCleanup = function (fn) {
        cleanup = watcher.onStop = function () {
            call(fn, WATCHER_CLEANUP);
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if (isServerRendering()) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = noop;
        if (!cb) {
            getter();
        }
        else if (immediate) {
            call(cb, WATCHER_CB, [
                getter(),
                isMultiSource ? [] : undefined,
                onCleanup
            ]);
        }
        return noop;
    }
    var watcher = new Watcher(currentInstance, getter, noop, {
        lazy: true
    });
    watcher.noRecurse = !cb;
    var oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
    // overwrite default run
    watcher.run = function () {
        if (!watcher.active) {
            return;
        }
        if (cb) {
            // watch(source, cb)
            var newValue = watcher.get();
            if (deep ||
                forceTrigger ||
                (isMultiSource
                    ? newValue.some(function (v, i) {
                        return hasChanged(v, oldValue[i]);
                    })
                    : hasChanged(newValue, oldValue))) {
                // cleanup before running cb again
                if (cleanup) {
                    cleanup();
                }
                call(cb, WATCHER_CB, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        }
        else {
            // watchEffect
            watcher.get();
        }
    };
    if (flush === 'sync') {
        watcher.update = watcher.run;
    }
    else if (flush === 'post') {
        watcher.post = true;
        watcher.update = function () { return queueWatcher(watcher); };
    }
    else {
        // pre
        watcher.update = function () {
            if (instance && instance === currentInstance && !instance._isMounted) {
                // pre-watcher triggered before
                var buffer = instance._preWatchers || (instance._preWatchers = []);
                if (buffer.indexOf(watcher) < 0)
                    buffer.push(watcher);
            }
            else {
                queueWatcher(watcher);
            }
        };
    }
    if (false) {
        watcher.onTrack = onTrack;
        watcher.onTrigger = onTrigger;
    }
    // initial run
    if (cb) {
        if (immediate) {
            watcher.run();
        }
        else {
            oldValue = watcher.get();
        }
    }
    else if (flush === 'post' && instance) {
        instance.$once('hook:mounted', function () { return watcher.get(); });
    }
    else {
        watcher.get();
    }
    return function () {
        watcher.teardown();
    };
}

var activeEffectScope;
var EffectScope = /** @class */ (function () {
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        this.detached = detached;
        /**
         * @internal
         */
        this.active = true;
        /**
         * @internal
         */
        this.effects = [];
        /**
         * @internal
         */
        this.cleanups = [];
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) {
            this.index =
                (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    EffectScope.prototype.run = function (fn) {
        if (this.active) {
            var currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            }
            finally {
                activeEffectScope = currentEffectScope;
            }
        }
        else if (false) {
            warn$2("cannot run an inactive effect scope.");
        }
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.on = function () {
        activeEffectScope = this;
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.off = function () {
        activeEffectScope = this.parent;
    };
    EffectScope.prototype.stop = function (fromParent) {
        if (this.active) {
            var i = void 0, l = void 0;
            for (i = 0, l = this.effects.length; i < l; i++) {
                this.effects[i].teardown();
            }
            for (i = 0, l = this.cleanups.length; i < l; i++) {
                this.cleanups[i]();
            }
            if (this.scopes) {
                for (i = 0, l = this.scopes.length; i < l; i++) {
                    this.scopes[i].stop(true);
                }
            }
            // nested scope, dereference from parent to avoid memory leaks
            if (!this.detached && this.parent && !fromParent) {
                // optimized O(1) removal
                var last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = undefined;
            this.active = false;
        }
    };
    return EffectScope;
}());
function effectScope(detached) {
    return new EffectScope(detached);
}
/**
 * @internal
 */
function recordEffectScope(effect, scope) {
    if (scope === void 0) { scope = activeEffectScope; }
    if (scope && scope.active) {
        scope.effects.push(effect);
    }
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if (false) {
        warn$2("onScopeDispose() is called when there is no active effect scope" +
            " to be associated with.");
    }
}

function provide(key, value) {
    if (!currentInstance) {
        if (false) {
            warn$2("provide() can only be used inside setup().");
        }
    }
    else {
        // TS doesn't allow symbol as index type
        resolveProvided(currentInstance)[key] = value;
    }
}
function resolveProvided(vm) {
    // by default an instance inherits its parent's provides object
    // but when it needs to provide values of its own, it creates its
    // own provides object using parent provides object as prototype.
    // this way in `inject` we can simply look up injections from direct
    // parent and let the prototype chain do the work.
    var existing = vm._provided;
    var parentProvides = vm.$parent && vm.$parent._provided;
    if (parentProvides === existing) {
        return (vm._provided = Object.create(parentProvides));
    }
    else {
        return existing;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    var instance = currentInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        var provides = instance.$parent && instance.$parent._provided;
        if (provides && key in provides) {
            // TS doesn't allow symbol as index type
            return provides[key];
        }
        else if (arguments.length > 1) {
            return treatDefaultAsFactory && isFunction(defaultValue)
                ? defaultValue.call(instance)
                : defaultValue;
        }
        else if (false) {
            warn$2("injection \"".concat(String(key), "\" not found."));
        }
    }
    else if (false) {
        warn$2("inject() can only be used inside setup() or functional components.");
    }
}

/**
 * @internal this function needs manual public type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function h(type, props, children) {
    if (!currentInstance) {
        "production" !== 'production' &&
            warn$2("globally imported h() can only be invoked when there is an active " +
                "component instance, e.g. synchronously in a component's render or setup function.");
    }
    return createElement$1(currentInstance, type, props, children, 2, true);
}

function handleError(err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    pushTarget();
    try {
        if (vm) {
            var cur = vm;
            while ((cur = cur.$parent)) {
                var hooks = cur.$options.errorCaptured;
                if (hooks) {
                    for (var i = 0; i < hooks.length; i++) {
                        try {
                            var capture = hooks[i].call(cur, err, vm, info) === false;
                            if (capture)
                                return;
                        }
                        catch (e) {
                            globalHandleError(e, cur, 'errorCaptured hook');
                        }
                    }
                }
            }
        }
        globalHandleError(err, vm, info);
    }
    finally {
        popTarget();
    }
}
function invokeWithErrorHandling(handler, context, args, vm, info) {
    var res;
    try {
        res = args ? handler.apply(context, args) : handler.call(context);
        if (res && !res._isVue && isPromise(res) && !res._handled) {
            res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
            res._handled = true;
        }
    }
    catch (e) {
        handleError(e, vm, info);
    }
    return res;
}
function globalHandleError(err, vm, info) {
    if (config.errorHandler) {
        try {
            return config.errorHandler.call(null, err, vm, info);
        }
        catch (e) {
            // if the user intentionally throws the original error in the handler,
            // do not log it twice
            if (e !== err) {
                logError(e, null, 'config.errorHandler');
            }
        }
    }
    logError(err, vm, info);
}
function logError(err, vm, info) {
    if (false) {
        warn$2("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    /* istanbul ignore else */
    if (inBrowser && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}

/* globals MutationObserver */
var isUsingMicroTask = false;
var callbacks = [];
var pending = false;
function flushCallbacks() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
        copies[i]();
    }
}
// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;
// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p_1 = Promise.resolve();
    timerFunc = function () {
        p_1.then(flushCallbacks);
        // In problematic UIWebViews, Promise.then doesn't completely break, but
        // it can get stuck in a weird state where callbacks are pushed into the
        // microtask queue but the queue isn't being flushed, until the browser
        // needs to do some other work, e.g. handle a timer. Therefore we can
        // "force" the microtask queue to be flushed by adding an empty timer.
        if (isIOS)
            setTimeout(noop);
    };
    isUsingMicroTask = true;
}
else if (!isIE &&
    typeof MutationObserver !== 'undefined' &&
    (isNative(MutationObserver) ||
        // PhantomJS and iOS 7.x
        MutationObserver.toString() === '[object MutationObserverConstructor]')) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var counter_1 = 1;
    var observer = new MutationObserver(flushCallbacks);
    var textNode_1 = document.createTextNode(String(counter_1));
    observer.observe(textNode_1, {
        characterData: true
    });
    timerFunc = function () {
        counter_1 = (counter_1 + 1) % 2;
        textNode_1.data = String(counter_1);
    };
    isUsingMicroTask = true;
}
else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
    // Fallback to setImmediate.
    // Technically it leverages the (macro) task queue,
    // but it is still a better choice than setTimeout.
    timerFunc = function () {
        setImmediate(flushCallbacks);
    };
}
else {
    // Fallback to setTimeout.
    timerFunc = function () {
        setTimeout(flushCallbacks, 0);
    };
}
/**
 * @internal
 */
function nextTick(cb, ctx) {
    var _resolve;
    callbacks.push(function () {
        if (cb) {
            try {
                cb.call(ctx);
            }
            catch (e) {
                handleError(e, ctx, 'nextTick');
            }
        }
        else if (_resolve) {
            _resolve(ctx);
        }
    });
    if (!pending) {
        pending = true;
        timerFunc();
    }
    // $flow-disable-line
    if (!cb && typeof Promise !== 'undefined') {
        return new Promise(function (resolve) {
            _resolve = resolve;
        });
    }
}

function useCssModule(name) {
    if (name === void 0) { name = '$style'; }
    /* istanbul ignore else */
    {
        if (!currentInstance) {
            "production" !== 'production' && warn$2("useCssModule must be called inside setup()");
            return emptyObject;
        }
        var mod = currentInstance[name];
        if (!mod) {
            "production" !== 'production' &&
                warn$2("Current instance does not have CSS module named \"".concat(name, "\"."));
            return emptyObject;
        }
        return mod;
    }
}

/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */
function useCssVars(getter) {
    if (!inBrowser && !false)
        return;
    var instance = currentInstance;
    if (!instance) {
        "production" !== 'production' &&
            warn$2("useCssVars is called without current active component instance.");
        return;
    }
    watchPostEffect(function () {
        var el = instance.$el;
        var vars = getter(instance, instance._setupProxy);
        if (el && el.nodeType === 1) {
            var style = el.style;
            for (var key in vars) {
                style.setProperty("--".concat(key), vars[key]);
            }
        }
    });
}

/**
 * v3-compatible async component API.
 * @internal the type is manually declared in <root>/types/v3-define-async-component.d.ts
 * because it relies on existing manual types
 */
function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn$2("The suspensiblbe option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {
                        warn$2("Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value.");
                    }
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {
                        throw new Error("Invalid async component load result: ".concat(comp));
                    }
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent
        };
    };
}

function createLifeCycle(hookName) {
    return function (fn, target) {
        if (target === void 0) { target = currentInstance; }
        if (!target) {
            "production" !== 'production' &&
                warn$2("".concat(formatName(hookName), " is called when there is no active component instance to be ") +
                    "associated with. " +
                    "Lifecycle injection APIs can only be used during execution of setup().");
            return;
        }
        return injectHook(target, hookName, fn);
    };
}
function formatName(name) {
    if (name === 'beforeDestroy') {
        name = 'beforeUnmount';
    }
    else if (name === 'destroyed') {
        name = 'unmounted';
    }
    return "on".concat(name[0].toUpperCase() + name.slice(1));
}
function injectHook(instance, hookName, fn) {
    var options = instance.$options;
    options[hookName] = mergeLifecycleHook(options[hookName], fn);
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');
var onRenderTracked = createLifeCycle('renderTracked');
var onRenderTriggered = createLifeCycle('renderTriggered');
var injectErrorCapturedHook = createLifeCycle('errorCaptured');
function onErrorCaptured(hook, target) {
    if (target === void 0) { target = currentInstance; }
    injectErrorCapturedHook(hook, target);
}

/**
 * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
 */
var version = '2.7.14';
/**
 * @internal type is manually declared in <root>/types/v3-define-component.d.ts
 */
function defineComponent(options) {
    return options;
}

var seenObjects = new _Set();
/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse(val) {
    _traverse(val, seenObjects);
    seenObjects.clear();
    return val;
}
function _traverse(val, seen) {
    var i, keys;
    var isA = isArray(val);
    if ((!isA && !isObject(val)) ||
        val.__v_skip /* ReactiveFlags.SKIP */ ||
        Object.isFrozen(val) ||
        val instanceof VNode) {
        return;
    }
    if (val.__ob__) {
        var depId = val.__ob__.dep.id;
        if (seen.has(depId)) {
            return;
        }
        seen.add(depId);
    }
    if (isA) {
        i = val.length;
        while (i--)
            _traverse(val[i], seen);
    }
    else if (isRef(val)) {
        _traverse(val.value, seen);
    }
    else {
        keys = Object.keys(val);
        i = keys.length;
        while (i--)
            _traverse(val[keys[i]], seen);
    }
}

var uid$1 = 0;
/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 * @internal
 */
var Watcher = /** @class */ (function () {
    function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
        recordEffectScope(this, 
        // if the active effect scope is manually created (not a component scope),
        // prioritize it
        activeEffectScope && !activeEffectScope._vm
            ? activeEffectScope
            : vm
                ? vm._scope
                : undefined);
        if ((this.vm = vm) && isRenderWatcher) {
            vm._watcher = this;
        }
        // options
        if (options) {
            this.deep = !!options.deep;
            this.user = !!options.user;
            this.lazy = !!options.lazy;
            this.sync = !!options.sync;
            this.before = options.before;
            if (false) {
                this.onTrack = options.onTrack;
                this.onTrigger = options.onTrigger;
            }
        }
        else {
            this.deep = this.user = this.lazy = this.sync = false;
        }
        this.cb = cb;
        this.id = ++uid$1; // uid for batching
        this.active = true;
        this.post = false;
        this.dirty = this.lazy; // for lazy watchers
        this.deps = [];
        this.newDeps = [];
        this.depIds = new _Set();
        this.newDepIds = new _Set();
        this.expression =  false ? expOrFn.toString() : '';
        // parse expression for getter
        if (isFunction(expOrFn)) {
            this.getter = expOrFn;
        }
        else {
            this.getter = parsePath(expOrFn);
            if (!this.getter) {
                this.getter = noop;
                "production" !== 'production' &&
                    warn$2("Failed watching path: \"".concat(expOrFn, "\" ") +
                        'Watcher only accepts simple dot-delimited paths. ' +
                        'For full control, use a function instead.', vm);
            }
        }
        this.value = this.lazy ? undefined : this.get();
    }
    /**
     * Evaluate the getter, and re-collect dependencies.
     */
    Watcher.prototype.get = function () {
        pushTarget(this);
        var value;
        var vm = this.vm;
        try {
            value = this.getter.call(vm, vm);
        }
        catch (e) {
            if (this.user) {
                handleError(e, vm, "getter for watcher \"".concat(this.expression, "\""));
            }
            else {
                throw e;
            }
        }
        finally {
            // "touch" every property so they are all tracked as
            // dependencies for deep watching
            if (this.deep) {
                traverse(value);
            }
            popTarget();
            this.cleanupDeps();
        }
        return value;
    };
    /**
     * Add a dependency to this directive.
     */
    Watcher.prototype.addDep = function (dep) {
        var id = dep.id;
        if (!this.newDepIds.has(id)) {
            this.newDepIds.add(id);
            this.newDeps.push(dep);
            if (!this.depIds.has(id)) {
                dep.addSub(this);
            }
        }
    };
    /**
     * Clean up for dependency collection.
     */
    Watcher.prototype.cleanupDeps = function () {
        var i = this.deps.length;
        while (i--) {
            var dep = this.deps[i];
            if (!this.newDepIds.has(dep.id)) {
                dep.removeSub(this);
            }
        }
        var tmp = this.depIds;
        this.depIds = this.newDepIds;
        this.newDepIds = tmp;
        this.newDepIds.clear();
        tmp = this.deps;
        this.deps = this.newDeps;
        this.newDeps = tmp;
        this.newDeps.length = 0;
    };
    /**
     * Subscriber interface.
     * Will be called when a dependency changes.
     */
    Watcher.prototype.update = function () {
        /* istanbul ignore else */
        if (this.lazy) {
            this.dirty = true;
        }
        else if (this.sync) {
            this.run();
        }
        else {
            queueWatcher(this);
        }
    };
    /**
     * Scheduler job interface.
     * Will be called by the scheduler.
     */
    Watcher.prototype.run = function () {
        if (this.active) {
            var value = this.get();
            if (value !== this.value ||
                // Deep watchers and watchers on Object/Arrays should fire even
                // when the value is the same, because the value may
                // have mutated.
                isObject(value) ||
                this.deep) {
                // set new value
                var oldValue = this.value;
                this.value = value;
                if (this.user) {
                    var info = "callback for watcher \"".concat(this.expression, "\"");
                    invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
                }
                else {
                    this.cb.call(this.vm, value, oldValue);
                }
            }
        }
    };
    /**
     * Evaluate the value of the watcher.
     * This only gets called for lazy watchers.
     */
    Watcher.prototype.evaluate = function () {
        this.value = this.get();
        this.dirty = false;
    };
    /**
     * Depend on all deps collected by this watcher.
     */
    Watcher.prototype.depend = function () {
        var i = this.deps.length;
        while (i--) {
            this.deps[i].depend();
        }
    };
    /**
     * Remove self from all dependencies' subscriber list.
     */
    Watcher.prototype.teardown = function () {
        if (this.vm && !this.vm._isBeingDestroyed) {
            remove$2(this.vm._scope.effects, this);
        }
        if (this.active) {
            var i = this.deps.length;
            while (i--) {
                this.deps[i].removeSub(this);
            }
            this.active = false;
            if (this.onStop) {
                this.onStop();
            }
        }
    };
    return Watcher;
}());

var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noop,
    set: noop
};
function proxy(target, sourceKey, key) {
    sharedPropertyDefinition.get = function proxyGetter() {
        return this[sourceKey][key];
    };
    sharedPropertyDefinition.set = function proxySetter(val) {
        this[sourceKey][key] = val;
    };
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function initState(vm) {
    var opts = vm.$options;
    if (opts.props)
        initProps$1(vm, opts.props);
    // Composition API
    initSetup(vm);
    if (opts.methods)
        initMethods(vm, opts.methods);
    if (opts.data) {
        initData(vm);
    }
    else {
        var ob = observe((vm._data = {}));
        ob && ob.vmCount++;
    }
    if (opts.computed)
        initComputed$1(vm, opts.computed);
    if (opts.watch && opts.watch !== nativeWatch) {
        initWatch(vm, opts.watch);
    }
}
function initProps$1(vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = (vm._props = shallowReactive({}));
    // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.
    var keys = (vm.$options._propKeys = []);
    var isRoot = !vm.$parent;
    // root instance props should be converted
    if (!isRoot) {
        toggleObserving(false);
    }
    var _loop_1 = function (key) {
        keys.push(key);
        var value = validateProp(key, propsOptions, propsData, vm);
        /* istanbul ignore else */
        if (false) {
            var hyphenatedKey = hyphenate(key);
            if (isReservedAttribute(hyphenatedKey) ||
                config.isReservedAttr(hyphenatedKey)) {
                warn$2("\"".concat(hyphenatedKey, "\" is a reserved attribute and cannot be used as component prop."), vm);
            }
            defineReactive(props, key, value, function () {
                if (!isRoot && !isUpdatingChildComponent) {
                    warn$2("Avoid mutating a prop directly since the value will be " +
                        "overwritten whenever the parent component re-renders. " +
                        "Instead, use a data or computed property based on the prop's " +
                        "value. Prop being mutated: \"".concat(key, "\""), vm);
                }
            });
        }
        else {
            defineReactive(props, key, value);
        }
        // static props are already proxied on the component's prototype
        // during Vue.extend(). We only need to proxy props defined at
        // instantiation here.
        if (!(key in vm)) {
            proxy(vm, "_props", key);
        }
    };
    for (var key in propsOptions) {
        _loop_1(key);
    }
    toggleObserving(true);
}
function initData(vm) {
    var data = vm.$options.data;
    data = vm._data = isFunction(data) ? getData(data, vm) : data || {};
    if (!isPlainObject(data)) {
        data = {};
        "production" !== 'production' &&
            warn$2('data functions should return an object:\n' +
                'https://v2.vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
    }
    // proxy data on instance
    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;
    while (i--) {
        var key = keys[i];
        if (false) {
            if (methods && hasOwn(methods, key)) {
                warn$2("Method \"".concat(key, "\" has already been defined as a data property."), vm);
            }
        }
        if (props && hasOwn(props, key)) {
            "production" !== 'production' &&
                warn$2("The data property \"".concat(key, "\" is already declared as a prop. ") +
                    "Use prop default value instead.", vm);
        }
        else if (!isReserved(key)) {
            proxy(vm, "_data", key);
        }
    }
    // observe data
    var ob = observe(data);
    ob && ob.vmCount++;
}
function getData(data, vm) {
    // #7573 disable dep collection when invoking data getters
    pushTarget();
    try {
        return data.call(vm, vm);
    }
    catch (e) {
        handleError(e, vm, "data()");
        return {};
    }
    finally {
        popTarget();
    }
}
var computedWatcherOptions = { lazy: true };
function initComputed$1(vm, computed) {
    // $flow-disable-line
    var watchers = (vm._computedWatchers = Object.create(null));
    // computed properties are just getters during SSR
    var isSSR = isServerRendering();
    for (var key in computed) {
        var userDef = computed[key];
        var getter = isFunction(userDef) ? userDef : userDef.get;
        if (false) {
            warn$2("Getter is missing for computed property \"".concat(key, "\"."), vm);
        }
        if (!isSSR) {
            // create internal watcher for the computed property.
            watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
        }
        // component-defined computed properties are already defined on the
        // component prototype. We only need to define computed properties defined
        // at instantiation here.
        if (!(key in vm)) {
            defineComputed(vm, key, userDef);
        }
        else if (false) {
            if (key in vm.$data) {
                warn$2("The computed property \"".concat(key, "\" is already defined in data."), vm);
            }
            else if (vm.$options.props && key in vm.$options.props) {
                warn$2("The computed property \"".concat(key, "\" is already defined as a prop."), vm);
            }
            else if (vm.$options.methods && key in vm.$options.methods) {
                warn$2("The computed property \"".concat(key, "\" is already defined as a method."), vm);
            }
        }
    }
}
function defineComputed(target, key, userDef) {
    var shouldCache = !isServerRendering();
    if (isFunction(userDef)) {
        sharedPropertyDefinition.get = shouldCache
            ? createComputedGetter(key)
            : createGetterInvoker(userDef);
        sharedPropertyDefinition.set = noop;
    }
    else {
        sharedPropertyDefinition.get = userDef.get
            ? shouldCache && userDef.cache !== false
                ? createComputedGetter(key)
                : createGetterInvoker(userDef.get)
            : noop;
        sharedPropertyDefinition.set = userDef.set || noop;
    }
    if (false) {
        sharedPropertyDefinition.set = function () {
            warn$2("Computed property \"".concat(key, "\" was assigned to but it has no setter."), this);
        };
    }
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function createComputedGetter(key) {
    return function computedGetter() {
        var watcher = this._computedWatchers && this._computedWatchers[key];
        if (watcher) {
            if (watcher.dirty) {
                watcher.evaluate();
            }
            if (Dep.target) {
                if (false) {
                    Dep.target.onTrack({
                        effect: Dep.target,
                        target: this,
                        type: "get" /* TrackOpTypes.GET */,
                        key: key
                    });
                }
                watcher.depend();
            }
            return watcher.value;
        }
    };
}
function createGetterInvoker(fn) {
    return function computedGetter() {
        return fn.call(this, this);
    };
}
function initMethods(vm, methods) {
    var props = vm.$options.props;
    for (var key in methods) {
        if (false) {
            if (typeof methods[key] !== 'function') {
                warn$2("Method \"".concat(key, "\" has type \"").concat(typeof methods[key], "\" in the component definition. ") +
                    "Did you reference the function correctly?", vm);
            }
            if (props && hasOwn(props, key)) {
                warn$2("Method \"".concat(key, "\" has already been defined as a prop."), vm);
            }
            if (key in vm && isReserved(key)) {
                warn$2("Method \"".concat(key, "\" conflicts with an existing Vue instance method. ") +
                    "Avoid defining component methods that start with _ or $.");
            }
        }
        vm[key] = typeof methods[key] !== 'function' ? noop : bind$1(methods[key], vm);
    }
}
function initWatch(vm, watch) {
    for (var key in watch) {
        var handler = watch[key];
        if (isArray(handler)) {
            for (var i = 0; i < handler.length; i++) {
                createWatcher(vm, key, handler[i]);
            }
        }
        else {
            createWatcher(vm, key, handler);
        }
    }
}
function createWatcher(vm, expOrFn, handler, options) {
    if (isPlainObject(handler)) {
        options = handler;
        handler = handler.handler;
    }
    if (typeof handler === 'string') {
        handler = vm[handler];
    }
    return vm.$watch(expOrFn, handler, options);
}
function stateMixin(Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};
    dataDef.get = function () {
        return this._data;
    };
    var propsDef = {};
    propsDef.get = function () {
        return this._props;
    };
    if (false) {
        dataDef.set = function () {
            warn$2('Avoid replacing instance root $data. ' +
                'Use nested data properties instead.', this);
        };
        propsDef.set = function () {
            warn$2("$props is readonly.", this);
        };
    }
    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);
    Vue.prototype.$set = set;
    Vue.prototype.$delete = del;
    Vue.prototype.$watch = function (expOrFn, cb, options) {
        var vm = this;
        if (isPlainObject(cb)) {
            return createWatcher(vm, expOrFn, cb, options);
        }
        options = options || {};
        options.user = true;
        var watcher = new Watcher(vm, expOrFn, cb, options);
        if (options.immediate) {
            var info = "callback for immediate watcher \"".concat(watcher.expression, "\"");
            pushTarget();
            invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
            popTarget();
        }
        return function unwatchFn() {
            watcher.teardown();
        };
    };
}

function initProvide(vm) {
    var provideOption = vm.$options.provide;
    if (provideOption) {
        var provided = isFunction(provideOption)
            ? provideOption.call(vm)
            : provideOption;
        if (!isObject(provided)) {
            return;
        }
        var source = resolveProvided(vm);
        // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
        // iterate the keys ourselves.
        var keys = hasSymbol ? Reflect.ownKeys(provided) : Object.keys(provided);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            Object.defineProperty(source, key, Object.getOwnPropertyDescriptor(provided, key));
        }
    }
}
function initInjections(vm) {
    var result = resolveInject(vm.$options.inject, vm);
    if (result) {
        toggleObserving(false);
        Object.keys(result).forEach(function (key) {
            /* istanbul ignore else */
            if (false) {
                defineReactive(vm, key, result[key], function () {
                    warn$2("Avoid mutating an injected value directly since the changes will be " +
                        "overwritten whenever the provided component re-renders. " +
                        "injection being mutated: \"".concat(key, "\""), vm);
                });
            }
            else {
                defineReactive(vm, key, result[key]);
            }
        });
        toggleObserving(true);
    }
}
function resolveInject(inject, vm) {
    if (inject) {
        // inject is :any because flow is not smart enough to figure out cached
        var result = Object.create(null);
        var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            // #6574 in case the inject object is observed...
            if (key === '__ob__')
                continue;
            var provideKey = inject[key].from;
            if (provideKey in vm._provided) {
                result[key] = vm._provided[provideKey];
            }
            else if ('default' in inject[key]) {
                var provideDefault = inject[key].default;
                result[key] = isFunction(provideDefault)
                    ? provideDefault.call(vm)
                    : provideDefault;
            }
            else if (false) {
                warn$2("Injection \"".concat(key, "\" not found"), vm);
            }
        }
        return result;
    }
}

var uid = 0;
function initMixin$1(Vue) {
    Vue.prototype._init = function (options) {
        var vm = this;
        // a uid
        vm._uid = uid++;
        var startTag, endTag;
        /* istanbul ignore if */
        if (false) {
            startTag = "vue-perf-start:".concat(vm._uid);
            endTag = "vue-perf-end:".concat(vm._uid);
            mark(startTag);
        }
        // a flag to mark this as a Vue instance without having to do instanceof
        // check
        vm._isVue = true;
        // avoid instances from being observed
        vm.__v_skip = true;
        // effect scope
        vm._scope = new EffectScope(true /* detached */);
        vm._scope._vm = true;
        // merge options
        if (options && options._isComponent) {
            // optimize internal component instantiation
            // since dynamic options merging is pretty slow, and none of the
            // internal component options needs special treatment.
            initInternalComponent(vm, options);
        }
        else {
            vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
        }
        /* istanbul ignore else */
        if (false) {
            initProxy(vm);
        }
        else {
            vm._renderProxy = vm;
        }
        // expose real self
        vm._self = vm;
        initLifecycle(vm);
        initEvents(vm);
        initRender(vm);
        callHook$1(vm, 'beforeCreate', undefined, false /* setContext */);
        initInjections(vm); // resolve injections before data/props
        initState(vm);
        initProvide(vm); // resolve provide after data/props
        callHook$1(vm, 'created');
        /* istanbul ignore if */
        if (false) {
            vm._name = formatComponentName(vm, false);
            mark(endTag);
            measure("vue ".concat(vm._name, " init"), startTag, endTag);
        }
        if (vm.$options.el) {
            vm.$mount(vm.$options.el);
        }
    };
}
function initInternalComponent(vm, options) {
    var opts = (vm.$options = Object.create(vm.constructor.options));
    // doing this because it's faster than dynamic enumeration.
    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;
    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;
    if (options.render) {
        opts.render = options.render;
        opts.staticRenderFns = options.staticRenderFns;
    }
}
function resolveConstructorOptions(Ctor) {
    var options = Ctor.options;
    if (Ctor.super) {
        var superOptions = resolveConstructorOptions(Ctor.super);
        var cachedSuperOptions = Ctor.superOptions;
        if (superOptions !== cachedSuperOptions) {
            // super option changed,
            // need to resolve new options.
            Ctor.superOptions = superOptions;
            // check if there are any late-modified/attached options (#4976)
            var modifiedOptions = resolveModifiedOptions(Ctor);
            // update base extend options
            if (modifiedOptions) {
                extend(Ctor.extendOptions, modifiedOptions);
            }
            options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
            if (options.name) {
                options.components[options.name] = Ctor;
            }
        }
    }
    return options;
}
function resolveModifiedOptions(Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;
    for (var key in latest) {
        if (latest[key] !== sealed[key]) {
            if (!modified)
                modified = {};
            modified[key] = latest[key];
        }
    }
    return modified;
}

function FunctionalRenderContext(data, props, children, parent, Ctor) {
    var _this = this;
    var options = Ctor.options;
    // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check
    var contextVm;
    if (hasOwn(parent, '_uid')) {
        contextVm = Object.create(parent);
        contextVm._original = parent;
    }
    else {
        // the context vm passed in is a functional context as well.
        // in this case we want to make sure we are able to get a hold to the
        // real context instance.
        contextVm = parent;
        // @ts-ignore
        parent = parent._original;
    }
    var isCompiled = isTrue(options._compiled);
    var needNormalization = !isCompiled;
    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || emptyObject;
    this.injections = resolveInject(options.inject, parent);
    this.slots = function () {
        if (!_this.$slots) {
            normalizeScopedSlots(parent, data.scopedSlots, (_this.$slots = resolveSlots(children, parent)));
        }
        return _this.$slots;
    };
    Object.defineProperty(this, 'scopedSlots', {
        enumerable: true,
        get: function () {
            return normalizeScopedSlots(parent, data.scopedSlots, this.slots());
        }
    });
    // support for compiled functional template
    if (isCompiled) {
        // exposing $options for renderStatic()
        this.$options = options;
        // pre-resolve slots for renderSlot()
        this.$slots = this.slots();
        this.$scopedSlots = normalizeScopedSlots(parent, data.scopedSlots, this.$slots);
    }
    if (options._scopeId) {
        this._c = function (a, b, c, d) {
            var vnode = createElement$1(contextVm, a, b, c, d, needNormalization);
            if (vnode && !isArray(vnode)) {
                vnode.fnScopeId = options._scopeId;
                vnode.fnContext = parent;
            }
            return vnode;
        };
    }
    else {
        this._c = function (a, b, c, d) {
            return createElement$1(contextVm, a, b, c, d, needNormalization);
        };
    }
}
installRenderHelpers(FunctionalRenderContext.prototype);
function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;
    if (isDef(propOptions)) {
        for (var key in propOptions) {
            props[key] = validateProp(key, propOptions, propsData || emptyObject);
        }
    }
    else {
        if (isDef(data.attrs))
            mergeProps(props, data.attrs);
        if (isDef(data.props))
            mergeProps(props, data.props);
    }
    var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
    var vnode = options.render.call(null, renderContext._c, renderContext);
    if (vnode instanceof VNode) {
        return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
    }
    else if (isArray(vnode)) {
        var vnodes = normalizeChildren(vnode) || [];
        var res = new Array(vnodes.length);
        for (var i = 0; i < vnodes.length; i++) {
            res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
        }
        return res;
    }
}
function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    if (false) {
        (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext =
            renderContext;
    }
    if (data.slot) {
        (clone.data || (clone.data = {})).slot = data.slot;
    }
    return clone;
}
function mergeProps(to, from) {
    for (var key in from) {
        to[camelize(key)] = from[key];
    }
}

function getComponentName(options) {
    return options.name || options.__name || options._componentTag;
}
// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
    init: function (vnode, hydrating) {
        if (vnode.componentInstance &&
            !vnode.componentInstance._isDestroyed &&
            vnode.data.keepAlive) {
            // kept-alive components, treat as a patch
            var mountedNode = vnode; // work around flow
            componentVNodeHooks.prepatch(mountedNode, mountedNode);
        }
        else {
            var child = (vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance));
            child.$mount(hydrating ? vnode.elm : undefined, hydrating);
        }
    },
    prepatch: function (oldVnode, vnode) {
        var options = vnode.componentOptions;
        var child = (vnode.componentInstance = oldVnode.componentInstance);
        updateChildComponent(child, options.propsData, // updated props
        options.listeners, // updated listeners
        vnode, // new parent vnode
        options.children // new children
        );
    },
    insert: function (vnode) {
        var context = vnode.context, componentInstance = vnode.componentInstance;
        if (!componentInstance._isMounted) {
            componentInstance._isMounted = true;
            callHook$1(componentInstance, 'mounted');
        }
        if (vnode.data.keepAlive) {
            if (context._isMounted) {
                // vue-router#1212
                // During updates, a kept-alive component's child components may
                // change, so directly walking the tree here may call activated hooks
                // on incorrect children. Instead we push them into a queue which will
                // be processed after the whole patch process ended.
                queueActivatedComponent(componentInstance);
            }
            else {
                activateChildComponent(componentInstance, true /* direct */);
            }
        }
    },
    destroy: function (vnode) {
        var componentInstance = vnode.componentInstance;
        if (!componentInstance._isDestroyed) {
            if (!vnode.data.keepAlive) {
                componentInstance.$destroy();
            }
            else {
                deactivateChildComponent(componentInstance, true /* direct */);
            }
        }
    }
};
var hooksToMerge = Object.keys(componentVNodeHooks);
function createComponent(Ctor, data, context, children, tag) {
    if (isUndef(Ctor)) {
        return;
    }
    var baseCtor = context.$options._base;
    // plain options object: turn it into a constructor
    if (isObject(Ctor)) {
        Ctor = baseCtor.extend(Ctor);
    }
    // if at this stage it's not a constructor or an async component factory,
    // reject.
    if (typeof Ctor !== 'function') {
        if (false) {
            warn$2("Invalid Component definition: ".concat(String(Ctor)), context);
        }
        return;
    }
    // async component
    var asyncFactory;
    // @ts-expect-error
    if (isUndef(Ctor.cid)) {
        asyncFactory = Ctor;
        Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
        if (Ctor === undefined) {
            // return a placeholder node for async component, which is rendered
            // as a comment node but preserves all the raw information for the node.
            // the information will be used for async server-rendering and hydration.
            return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
        }
    }
    data = data || {};
    // resolve constructor options in case global mixins are applied after
    // component constructor creation
    resolveConstructorOptions(Ctor);
    // transform component v-model data into props & events
    if (isDef(data.model)) {
        // @ts-expect-error
        transformModel(Ctor.options, data);
    }
    // extract props
    // @ts-expect-error
    var propsData = extractPropsFromVNodeData(data, Ctor, tag);
    // functional component
    // @ts-expect-error
    if (isTrue(Ctor.options.functional)) {
        return createFunctionalComponent(Ctor, propsData, data, context, children);
    }
    // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners
    var listeners = data.on;
    // replace with listeners with .native modifier
    // so it gets processed during parent component patch.
    data.on = data.nativeOn;
    // @ts-expect-error
    if (isTrue(Ctor.options.abstract)) {
        // abstract components do not keep anything
        // other than props & listeners & slot
        // work around flow
        var slot = data.slot;
        data = {};
        if (slot) {
            data.slot = slot;
        }
    }
    // install component management hooks onto the placeholder node
    installComponentHooks(data);
    // return a placeholder vnode
    // @ts-expect-error
    var name = getComponentName(Ctor.options) || tag;
    var vnode = new VNode(
    // @ts-expect-error
    "vue-component-".concat(Ctor.cid).concat(name ? "-".concat(name) : ''), data, undefined, undefined, undefined, context, 
    // @ts-expect-error
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }, asyncFactory);
    return vnode;
}
function createComponentInstanceForVnode(
// we know it's MountedComponentVNode but flow doesn't
vnode, 
// activeInstance in lifecycle state
parent) {
    var options = {
        _isComponent: true,
        _parentVnode: vnode,
        parent: parent
    };
    // check inline-template render functions
    var inlineTemplate = vnode.data.inlineTemplate;
    if (isDef(inlineTemplate)) {
        options.render = inlineTemplate.render;
        options.staticRenderFns = inlineTemplate.staticRenderFns;
    }
    return new vnode.componentOptions.Ctor(options);
}
function installComponentHooks(data) {
    var hooks = data.hook || (data.hook = {});
    for (var i = 0; i < hooksToMerge.length; i++) {
        var key = hooksToMerge[i];
        var existing = hooks[key];
        var toMerge = componentVNodeHooks[key];
        // @ts-expect-error
        if (existing !== toMerge && !(existing && existing._merged)) {
            hooks[key] = existing ? mergeHook(toMerge, existing) : toMerge;
        }
    }
}
function mergeHook(f1, f2) {
    var merged = function (a, b) {
        // flow complains about extra args which is why we use any
        f1(a, b);
        f2(a, b);
    };
    merged._merged = true;
    return merged;
}
// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel(options, data) {
    var prop = (options.model && options.model.prop) || 'value';
    var event = (options.model && options.model.event) || 'input';
    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;
    if (isDef(existing)) {
        if (isArray(existing)
            ? existing.indexOf(callback) === -1
            : existing !== callback) {
            on[event] = [callback].concat(existing);
        }
    }
    else {
        on[event] = callback;
    }
}

var warn$2 = noop;
var tip = noop;
var generateComponentTrace; // work around flow check
var formatComponentName;
if (false) {
    var hasConsole_1 = typeof console !== 'undefined';
    var classifyRE_1 = /(?:^|[-_])(\w)/g;
    var classify_1 = function (str) {
        return str.replace(classifyRE_1, function (c) { return c.toUpperCase(); }).replace(/[-_]/g, '');
    };
    warn$2 = function (msg, vm) {
        if (vm === void 0) { vm = currentInstance; }
        var trace = vm ? generateComponentTrace(vm) : '';
        if (config.warnHandler) {
            config.warnHandler.call(null, msg, vm, trace);
        }
        else if (hasConsole_1 && !config.silent) {
            console.error("[Vue warn]: ".concat(msg).concat(trace));
        }
    };
    tip = function (msg, vm) {
        if (hasConsole_1 && !config.silent) {
            console.warn("[Vue tip]: ".concat(msg) + (vm ? generateComponentTrace(vm) : ''));
        }
    };
    formatComponentName = function (vm, includeFile) {
        if (vm.$root === vm) {
            return '<Root>';
        }
        var options = isFunction(vm) && vm.cid != null
            ? vm.options
            : vm._isVue
                ? vm.$options || vm.constructor.options
                : vm;
        var name = getComponentName(options);
        var file = options.__file;
        if (!name && file) {
            var match = file.match(/([^/\\]+)\.vue$/);
            name = match && match[1];
        }
        return ((name ? "<".concat(classify_1(name), ">") : "<Anonymous>") +
            (file && includeFile !== false ? " at ".concat(file) : ''));
    };
    var repeat_1 = function (str, n) {
        var res = '';
        while (n) {
            if (n % 2 === 1)
                res += str;
            if (n > 1)
                str += str;
            n >>= 1;
        }
        return res;
    };
    generateComponentTrace = function (vm) {
        if (vm._isVue && vm.$parent) {
            var tree = [];
            var currentRecursiveSequence = 0;
            while (vm) {
                if (tree.length > 0) {
                    var last = tree[tree.length - 1];
                    if (last.constructor === vm.constructor) {
                        currentRecursiveSequence++;
                        vm = vm.$parent;
                        continue;
                    }
                    else if (currentRecursiveSequence > 0) {
                        tree[tree.length - 1] = [last, currentRecursiveSequence];
                        currentRecursiveSequence = 0;
                    }
                }
                tree.push(vm);
                vm = vm.$parent;
            }
            return ('\n\nfound in\n\n' +
                tree
                    .map(function (vm, i) {
                    return "".concat(i === 0 ? '---> ' : repeat_1(' ', 5 + i * 2)).concat(isArray(vm)
                        ? "".concat(formatComponentName(vm[0]), "... (").concat(vm[1], " recursive calls)")
                        : formatComponentName(vm));
                })
                    .join('\n'));
        }
        else {
            return "\n\n(found in ".concat(formatComponentName(vm), ")");
        }
    };
}

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;
/**
 * Options with restrictions
 */
if (false) {
    strats.el = strats.propsData = function (parent, child, vm, key) {
        if (!vm) {
            warn$2("option \"".concat(key, "\" can only be used during instance ") +
                'creation with the `new` keyword.');
        }
        return defaultStrat(parent, child);
    };
}
/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(to, from, recursive) {
    if (recursive === void 0) { recursive = true; }
    if (!from)
        return to;
    var key, toVal, fromVal;
    var keys = hasSymbol
        ? Reflect.ownKeys(from)
        : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!recursive || !hasOwn(to, key)) {
            set(to, key, fromVal);
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            isPlainObject(fromVal)) {
            mergeData(toVal, fromVal);
        }
    }
    return to;
}
/**
 * Data
 */
function mergeDataOrFn(parentVal, childVal, vm) {
    if (!vm) {
        // in a Vue.extend merge, both should be functions
        if (!childVal) {
            return parentVal;
        }
        if (!parentVal) {
            return childVal;
        }
        // when parentVal & childVal are both present,
        // we need to return a function that returns the
        // merged result of both functions... no need to
        // check if parentVal is a function here because
        // it has to be a function to pass previous merges.
        return function mergedDataFn() {
            return mergeData(isFunction(childVal) ? childVal.call(this, this) : childVal, isFunction(parentVal) ? parentVal.call(this, this) : parentVal);
        };
    }
    else {
        return function mergedInstanceDataFn() {
            // instance merge
            var instanceData = isFunction(childVal)
                ? childVal.call(vm, vm)
                : childVal;
            var defaultData = isFunction(parentVal)
                ? parentVal.call(vm, vm)
                : parentVal;
            if (instanceData) {
                return mergeData(instanceData, defaultData);
            }
            else {
                return defaultData;
            }
        };
    }
}
strats.data = function (parentVal, childVal, vm) {
    if (!vm) {
        if (childVal && typeof childVal !== 'function') {
            "production" !== 'production' &&
                warn$2('The "data" option should be a function ' +
                    'that returns a per-instance value in component ' +
                    'definitions.', vm);
            return parentVal;
        }
        return mergeDataOrFn(parentVal, childVal);
    }
    return mergeDataOrFn(parentVal, childVal, vm);
};
/**
 * Hooks and props are merged as arrays.
 */
function mergeLifecycleHook(parentVal, childVal) {
    var res = childVal
        ? parentVal
            ? parentVal.concat(childVal)
            : isArray(childVal)
                ? childVal
                : [childVal]
        : parentVal;
    return res ? dedupeHooks(res) : res;
}
function dedupeHooks(hooks) {
    var res = [];
    for (var i = 0; i < hooks.length; i++) {
        if (res.indexOf(hooks[i]) === -1) {
            res.push(hooks[i]);
        }
    }
    return res;
}
LIFECYCLE_HOOKS.forEach(function (hook) {
    strats[hook] = mergeLifecycleHook;
});
/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets(parentVal, childVal, vm, key) {
    var res = Object.create(parentVal || null);
    if (childVal) {
        "production" !== 'production' && assertObjectType(key, childVal, vm);
        return extend(res, childVal);
    }
    else {
        return res;
    }
}
ASSET_TYPES.forEach(function (type) {
    strats[type + 's'] = mergeAssets;
});
/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal, vm, key) {
    // work around Firefox's Object.prototype.watch...
    //@ts-expect-error work around
    if (parentVal === nativeWatch)
        parentVal = undefined;
    //@ts-expect-error work around
    if (childVal === nativeWatch)
        childVal = undefined;
    /* istanbul ignore if */
    if (!childVal)
        return Object.create(parentVal || null);
    if (false) {
        assertObjectType(key, childVal, vm);
    }
    if (!parentVal)
        return childVal;
    var ret = {};
    extend(ret, parentVal);
    for (var key_1 in childVal) {
        var parent_1 = ret[key_1];
        var child = childVal[key_1];
        if (parent_1 && !isArray(parent_1)) {
            parent_1 = [parent_1];
        }
        ret[key_1] = parent_1 ? parent_1.concat(child) : isArray(child) ? child : [child];
    }
    return ret;
};
/**
 * Other object hashes.
 */
strats.props =
    strats.methods =
        strats.inject =
            strats.computed =
                function (parentVal, childVal, vm, key) {
                    if (childVal && "production" !== 'production') {
                        assertObjectType(key, childVal, vm);
                    }
                    if (!parentVal)
                        return childVal;
                    var ret = Object.create(null);
                    extend(ret, parentVal);
                    if (childVal)
                        extend(ret, childVal);
                    return ret;
                };
strats.provide = function (parentVal, childVal) {
    if (!parentVal)
        return childVal;
    return function () {
        var ret = Object.create(null);
        mergeData(ret, isFunction(parentVal) ? parentVal.call(this) : parentVal);
        if (childVal) {
            mergeData(ret, isFunction(childVal) ? childVal.call(this) : childVal, false // non-recursive
            );
        }
        return ret;
    };
};
/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
};
/**
 * Validate component names
 */
function checkComponents(options) {
    for (var key in options.components) {
        validateComponentName(key);
    }
}
function validateComponentName(name) {
    if (!new RegExp("^[a-zA-Z][\\-\\.0-9_".concat(unicodeRegExp.source, "]*$")).test(name)) {
        warn$2('Invalid component name: "' +
            name +
            '". Component names ' +
            'should conform to valid custom element name in html5 specification.');
    }
    if (isBuiltInTag(name) || config.isReservedTag(name)) {
        warn$2('Do not use built-in or reserved HTML elements as component ' +
            'id: ' +
            name);
    }
}
/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps(options, vm) {
    var props = options.props;
    if (!props)
        return;
    var res = {};
    var i, val, name;
    if (isArray(props)) {
        i = props.length;
        while (i--) {
            val = props[i];
            if (typeof val === 'string') {
                name = camelize(val);
                res[name] = { type: null };
            }
            else if (false) {
                warn$2('props must be strings when using array syntax.');
            }
        }
    }
    else if (isPlainObject(props)) {
        for (var key in props) {
            val = props[key];
            name = camelize(key);
            res[name] = isPlainObject(val) ? val : { type: val };
        }
    }
    else if (false) {
        warn$2("Invalid value for option \"props\": expected an Array or an Object, " +
            "but got ".concat(toRawType(props), "."), vm);
    }
    options.props = res;
}
/**
 * Normalize all injections into Object-based format
 */
function normalizeInject(options, vm) {
    var inject = options.inject;
    if (!inject)
        return;
    var normalized = (options.inject = {});
    if (isArray(inject)) {
        for (var i = 0; i < inject.length; i++) {
            normalized[inject[i]] = { from: inject[i] };
        }
    }
    else if (isPlainObject(inject)) {
        for (var key in inject) {
            var val = inject[key];
            normalized[key] = isPlainObject(val)
                ? extend({ from: key }, val)
                : { from: val };
        }
    }
    else if (false) {
        warn$2("Invalid value for option \"inject\": expected an Array or an Object, " +
            "but got ".concat(toRawType(inject), "."), vm);
    }
}
/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives$1(options) {
    var dirs = options.directives;
    if (dirs) {
        for (var key in dirs) {
            var def = dirs[key];
            if (isFunction(def)) {
                dirs[key] = { bind: def, update: def };
            }
        }
    }
}
function assertObjectType(name, value, vm) {
    if (!isPlainObject(value)) {
        warn$2("Invalid value for option \"".concat(name, "\": expected an Object, ") +
            "but got ".concat(toRawType(value), "."), vm);
    }
}
/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions(parent, child, vm) {
    if (false) {
        checkComponents(child);
    }
    if (isFunction(child)) {
        // @ts-expect-error
        child = child.options;
    }
    normalizeProps(child, vm);
    normalizeInject(child, vm);
    normalizeDirectives$1(child);
    // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.
    if (!child._base) {
        if (child.extends) {
            parent = mergeOptions(parent, child.extends, vm);
        }
        if (child.mixins) {
            for (var i = 0, l = child.mixins.length; i < l; i++) {
                parent = mergeOptions(parent, child.mixins[i], vm);
            }
        }
    }
    var options = {};
    var key;
    for (key in parent) {
        mergeField(key);
    }
    for (key in child) {
        if (!hasOwn(parent, key)) {
            mergeField(key);
        }
    }
    function mergeField(key) {
        var strat = strats[key] || defaultStrat;
        options[key] = strat(parent[key], child[key], vm, key);
    }
    return options;
}
/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset(options, type, id, warnMissing) {
    /* istanbul ignore if */
    if (typeof id !== 'string') {
        return;
    }
    var assets = options[type];
    // check local registration variations first
    if (hasOwn(assets, id))
        return assets[id];
    var camelizedId = camelize(id);
    if (hasOwn(assets, camelizedId))
        return assets[camelizedId];
    var PascalCaseId = capitalize(camelizedId);
    if (hasOwn(assets, PascalCaseId))
        return assets[PascalCaseId];
    // fallback to prototype chain
    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
    if (false) {
        warn$2('Failed to resolve ' + type.slice(0, -1) + ': ' + id);
    }
    return res;
}

function validateProp(key, propOptions, propsData, vm) {
    var prop = propOptions[key];
    var absent = !hasOwn(propsData, key);
    var value = propsData[key];
    // boolean casting
    var booleanIndex = getTypeIndex(Boolean, prop.type);
    if (booleanIndex > -1) {
        if (absent && !hasOwn(prop, 'default')) {
            value = false;
        }
        else if (value === '' || value === hyphenate(key)) {
            // only cast empty string / same name to boolean if
            // boolean has higher priority
            var stringIndex = getTypeIndex(String, prop.type);
            if (stringIndex < 0 || booleanIndex < stringIndex) {
                value = true;
            }
        }
    }
    // check default value
    if (value === undefined) {
        value = getPropDefaultValue(vm, prop, key);
        // since the default value is a fresh copy,
        // make sure to observe it.
        var prevShouldObserve = shouldObserve;
        toggleObserving(true);
        observe(value);
        toggleObserving(prevShouldObserve);
    }
    if (false) {
        assertProp(prop, key, value, vm, absent);
    }
    return value;
}
/**
 * Get the default value of a prop.
 */
function getPropDefaultValue(vm, prop, key) {
    // no default, return undefined
    if (!hasOwn(prop, 'default')) {
        return undefined;
    }
    var def = prop.default;
    // warn against non-factory defaults for Object & Array
    if (false) {
        warn$2('Invalid default value for prop "' +
            key +
            '": ' +
            'Props with type Object/Array must use a factory function ' +
            'to return the default value.', vm);
    }
    // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger
    if (vm &&
        vm.$options.propsData &&
        vm.$options.propsData[key] === undefined &&
        vm._props[key] !== undefined) {
        return vm._props[key];
    }
    // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context
    return isFunction(def) && getType(prop.type) !== 'Function'
        ? def.call(vm)
        : def;
}
/**
 * Assert whether a prop is valid.
 */
function assertProp(prop, name, value, vm, absent) {
    if (prop.required && absent) {
        warn$2('Missing required prop: "' + name + '"', vm);
        return;
    }
    if (value == null && !prop.required) {
        return;
    }
    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];
    if (type) {
        if (!isArray(type)) {
            type = [type];
        }
        for (var i = 0; i < type.length && !valid; i++) {
            var assertedType = assertType(value, type[i], vm);
            expectedTypes.push(assertedType.expectedType || '');
            valid = assertedType.valid;
        }
    }
    var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
    if (!valid && haveExpectedTypes) {
        warn$2(getInvalidTypeMessage(name, value, expectedTypes), vm);
        return;
    }
    var validator = prop.validator;
    if (validator) {
        if (!validator(value)) {
            warn$2('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
        }
    }
}
var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
function assertType(value, type, vm) {
    var valid;
    var expectedType = getType(type);
    if (simpleCheckRE.test(expectedType)) {
        var t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === 'object') {
            valid = value instanceof type;
        }
    }
    else if (expectedType === 'Object') {
        valid = isPlainObject(value);
    }
    else if (expectedType === 'Array') {
        valid = isArray(value);
    }
    else {
        try {
            valid = value instanceof type;
        }
        catch (e) {
            warn$2('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
            valid = false;
        }
    }
    return {
        valid: valid,
        expectedType: expectedType
    };
}
var functionTypeCheckRE = /^\s*function (\w+)/;
/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType(fn) {
    var match = fn && fn.toString().match(functionTypeCheckRE);
    return match ? match[1] : '';
}
function isSameType(a, b) {
    return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
    if (!isArray(expectedTypes)) {
        return isSameType(expectedTypes, type) ? 0 : -1;
    }
    for (var i = 0, len = expectedTypes.length; i < len; i++) {
        if (isSameType(expectedTypes[i], type)) {
            return i;
        }
    }
    return -1;
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    var message = "Invalid prop: type check failed for prop \"".concat(name, "\".") +
        " Expected ".concat(expectedTypes.map(capitalize).join(', '));
    var expectedType = expectedTypes[0];
    var receivedType = toRawType(value);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 &&
        isExplicable(expectedType) &&
        isExplicable(typeof value) &&
        !isBoolean(expectedType, receivedType)) {
        message += " with value ".concat(styleValue(value, expectedType));
    }
    message += ", got ".concat(receivedType, " ");
    // check if we need to specify received value
    if (isExplicable(receivedType)) {
        message += "with value ".concat(styleValue(value, receivedType), ".");
    }
    return message;
}
function styleValue(value, type) {
    if (type === 'String') {
        return "\"".concat(value, "\"");
    }
    else if (type === 'Number') {
        return "".concat(Number(value));
    }
    else {
        return "".concat(value);
    }
}
var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable(value) {
    return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; });
}
function isBoolean() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; });
}

function Vue(options) {
    if (false) {
        warn$2('Vue is a constructor and should be called with the `new` keyword');
    }
    this._init(options);
}
//@ts-expect-error Vue has function type
initMixin$1(Vue);
//@ts-expect-error Vue has function type
stateMixin(Vue);
//@ts-expect-error Vue has function type
eventsMixin(Vue);
//@ts-expect-error Vue has function type
lifecycleMixin(Vue);
//@ts-expect-error Vue has function type
renderMixin(Vue);

function initUse(Vue) {
    Vue.use = function (plugin) {
        var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
        if (installedPlugins.indexOf(plugin) > -1) {
            return this;
        }
        // additional parameters
        var args = toArray(arguments, 1);
        args.unshift(this);
        if (isFunction(plugin.install)) {
            plugin.install.apply(plugin, args);
        }
        else if (isFunction(plugin)) {
            plugin.apply(null, args);
        }
        installedPlugins.push(plugin);
        return this;
    };
}

function initMixin(Vue) {
    Vue.mixin = function (mixin) {
        this.options = mergeOptions(this.options, mixin);
        return this;
    };
}

function initExtend(Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */
    Vue.cid = 0;
    var cid = 1;
    /**
     * Class inheritance
     */
    Vue.extend = function (extendOptions) {
        extendOptions = extendOptions || {};
        var Super = this;
        var SuperId = Super.cid;
        var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
        if (cachedCtors[SuperId]) {
            return cachedCtors[SuperId];
        }
        var name = getComponentName(extendOptions) || getComponentName(Super.options);
        if (false) {
            validateComponentName(name);
        }
        var Sub = function VueComponent(options) {
            this._init(options);
        };
        Sub.prototype = Object.create(Super.prototype);
        Sub.prototype.constructor = Sub;
        Sub.cid = cid++;
        Sub.options = mergeOptions(Super.options, extendOptions);
        Sub['super'] = Super;
        // For props and computed properties, we define the proxy getters on
        // the Vue instances at extension time, on the extended prototype. This
        // avoids Object.defineProperty calls for each instance created.
        if (Sub.options.props) {
            initProps(Sub);
        }
        if (Sub.options.computed) {
            initComputed(Sub);
        }
        // allow further extension/mixin/plugin usage
        Sub.extend = Super.extend;
        Sub.mixin = Super.mixin;
        Sub.use = Super.use;
        // create asset registers, so extended classes
        // can have their private assets too.
        ASSET_TYPES.forEach(function (type) {
            Sub[type] = Super[type];
        });
        // enable recursive self-lookup
        if (name) {
            Sub.options.components[name] = Sub;
        }
        // keep a reference to the super options at extension time.
        // later at instantiation we can check if Super's options have
        // been updated.
        Sub.superOptions = Super.options;
        Sub.extendOptions = extendOptions;
        Sub.sealedOptions = extend({}, Sub.options);
        // cache constructor
        cachedCtors[SuperId] = Sub;
        return Sub;
    };
}
function initProps(Comp) {
    var props = Comp.options.props;
    for (var key in props) {
        proxy(Comp.prototype, "_props", key);
    }
}
function initComputed(Comp) {
    var computed = Comp.options.computed;
    for (var key in computed) {
        defineComputed(Comp.prototype, key, computed[key]);
    }
}

function initAssetRegisters(Vue) {
    /**
     * Create asset registration methods.
     */
    ASSET_TYPES.forEach(function (type) {
        // @ts-expect-error function is not exact same type
        Vue[type] = function (id, definition) {
            if (!definition) {
                return this.options[type + 's'][id];
            }
            else {
                /* istanbul ignore if */
                if (false) {
                    validateComponentName(id);
                }
                if (type === 'component' && isPlainObject(definition)) {
                    // @ts-expect-error
                    definition.name = definition.name || id;
                    definition = this.options._base.extend(definition);
                }
                if (type === 'directive' && isFunction(definition)) {
                    definition = { bind: definition, update: definition };
                }
                this.options[type + 's'][id] = definition;
                return definition;
            }
        };
    });
}

function _getComponentName(opts) {
    return opts && (getComponentName(opts.Ctor.options) || opts.tag);
}
function matches(pattern, name) {
    if (isArray(pattern)) {
        return pattern.indexOf(name) > -1;
    }
    else if (typeof pattern === 'string') {
        return pattern.split(',').indexOf(name) > -1;
    }
    else if (isRegExp(pattern)) {
        return pattern.test(name);
    }
    /* istanbul ignore next */
    return false;
}
function pruneCache(keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache, keys = keepAliveInstance.keys, _vnode = keepAliveInstance._vnode;
    for (var key in cache) {
        var entry = cache[key];
        if (entry) {
            var name_1 = entry.name;
            if (name_1 && !filter(name_1)) {
                pruneCacheEntry(cache, key, keys, _vnode);
            }
        }
    }
}
function pruneCacheEntry(cache, key, keys, current) {
    var entry = cache[key];
    if (entry && (!current || entry.tag !== current.tag)) {
        // @ts-expect-error can be undefined
        entry.componentInstance.$destroy();
    }
    cache[key] = null;
    remove$2(keys, key);
}
var patternTypes = [String, RegExp, Array];
// TODO defineComponent
var KeepAlive = {
    name: 'keep-alive',
    abstract: true,
    props: {
        include: patternTypes,
        exclude: patternTypes,
        max: [String, Number]
    },
    methods: {
        cacheVNode: function () {
            var _a = this, cache = _a.cache, keys = _a.keys, vnodeToCache = _a.vnodeToCache, keyToCache = _a.keyToCache;
            if (vnodeToCache) {
                var tag = vnodeToCache.tag, componentInstance = vnodeToCache.componentInstance, componentOptions = vnodeToCache.componentOptions;
                cache[keyToCache] = {
                    name: _getComponentName(componentOptions),
                    tag: tag,
                    componentInstance: componentInstance
                };
                keys.push(keyToCache);
                // prune oldest entry
                if (this.max && keys.length > parseInt(this.max)) {
                    pruneCacheEntry(cache, keys[0], keys, this._vnode);
                }
                this.vnodeToCache = null;
            }
        }
    },
    created: function () {
        this.cache = Object.create(null);
        this.keys = [];
    },
    destroyed: function () {
        for (var key in this.cache) {
            pruneCacheEntry(this.cache, key, this.keys);
        }
    },
    mounted: function () {
        var _this = this;
        this.cacheVNode();
        this.$watch('include', function (val) {
            pruneCache(_this, function (name) { return matches(val, name); });
        });
        this.$watch('exclude', function (val) {
            pruneCache(_this, function (name) { return !matches(val, name); });
        });
    },
    updated: function () {
        this.cacheVNode();
    },
    render: function () {
        var slot = this.$slots.default;
        var vnode = getFirstComponentChild(slot);
        var componentOptions = vnode && vnode.componentOptions;
        if (componentOptions) {
            // check pattern
            var name_2 = _getComponentName(componentOptions);
            var _a = this, include = _a.include, exclude = _a.exclude;
            if (
            // not included
            (include && (!name_2 || !matches(include, name_2))) ||
                // excluded
                (exclude && name_2 && matches(exclude, name_2))) {
                return vnode;
            }
            var _b = this, cache = _b.cache, keys = _b.keys;
            var key = vnode.key == null
                ? // same constructor may get registered as different local components
                    // so cid alone is not enough (#3269)
                    componentOptions.Ctor.cid +
                        (componentOptions.tag ? "::".concat(componentOptions.tag) : '')
                : vnode.key;
            if (cache[key]) {
                vnode.componentInstance = cache[key].componentInstance;
                // make current key freshest
                remove$2(keys, key);
                keys.push(key);
            }
            else {
                // delay setting the cache until update
                this.vnodeToCache = vnode;
                this.keyToCache = key;
            }
            // @ts-expect-error can vnode.data can be undefined
            vnode.data.keepAlive = true;
        }
        return vnode || (slot && slot[0]);
    }
};

var builtInComponents = {
    KeepAlive: KeepAlive
};

function initGlobalAPI(Vue) {
    // config
    var configDef = {};
    configDef.get = function () { return config; };
    if (false) {
        configDef.set = function () {
            warn$2('Do not replace the Vue.config object, set individual fields instead.');
        };
    }
    Object.defineProperty(Vue, 'config', configDef);
    // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.
    Vue.util = {
        warn: warn$2,
        extend: extend,
        mergeOptions: mergeOptions,
        defineReactive: defineReactive
    };
    Vue.set = set;
    Vue.delete = del;
    Vue.nextTick = nextTick;
    // 2.6 explicit observable API
    Vue.observable = function (obj) {
        observe(obj);
        return obj;
    };
    Vue.options = Object.create(null);
    ASSET_TYPES.forEach(function (type) {
        Vue.options[type + 's'] = Object.create(null);
    });
    // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.
    Vue.options._base = Vue;
    extend(Vue.options.components, builtInComponents);
    initUse(Vue);
    initMixin(Vue);
    initExtend(Vue);
    initAssetRegisters(Vue);
}

initGlobalAPI(Vue);
Object.defineProperty(Vue.prototype, '$isServer', {
    get: isServerRendering
});
Object.defineProperty(Vue.prototype, '$ssrContext', {
    get: function () {
        /* istanbul ignore next */
        return this.$vnode && this.$vnode.ssrContext;
    }
});
// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
    value: FunctionalRenderContext
});
Vue.version = version;

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');
// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
    return ((attr === 'value' && acceptValue(tag) && type !== 'button') ||
        (attr === 'selected' && tag === 'option') ||
        (attr === 'checked' && tag === 'input') ||
        (attr === 'muted' && tag === 'video'));
};
var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');
var convertEnumeratedValue = function (key, value) {
    return isFalsyAttrValue(value) || value === 'false'
        ? 'false'
        : // allow arbitrary string value for contenteditable
            key === 'contenteditable' && isValidContentEditableValue(value)
                ? value
                : 'true';
};
var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
    'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
    'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
    'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
    'required,reversed,scoped,seamless,selected,sortable,' +
    'truespeed,typemustmatch,visible');
var xlinkNS = 'http://www.w3.org/1999/xlink';
var isXlink = function (name) {
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
};
var getXlinkProp = function (name) {
    return isXlink(name) ? name.slice(6, name.length) : '';
};
var isFalsyAttrValue = function (val) {
    return val == null || val === false;
};

function genClassForVnode(vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;
    while (isDef(childNode.componentInstance)) {
        childNode = childNode.componentInstance._vnode;
        if (childNode && childNode.data) {
            data = mergeClassData(childNode.data, data);
        }
    }
    // @ts-expect-error parentNode.parent not VNodeWithData
    while (isDef((parentNode = parentNode.parent))) {
        if (parentNode && parentNode.data) {
            data = mergeClassData(data, parentNode.data);
        }
    }
    return renderClass(data.staticClass, data.class);
}
function mergeClassData(child, parent) {
    return {
        staticClass: concat(child.staticClass, parent.staticClass),
        class: isDef(child.class) ? [child.class, parent.class] : parent.class
    };
}
function renderClass(staticClass, dynamicClass) {
    if (isDef(staticClass) || isDef(dynamicClass)) {
        return concat(staticClass, stringifyClass(dynamicClass));
    }
    /* istanbul ignore next */
    return '';
}
function concat(a, b) {
    return a ? (b ? a + ' ' + b : a) : b || '';
}
function stringifyClass(value) {
    if (Array.isArray(value)) {
        return stringifyArray(value);
    }
    if (isObject(value)) {
        return stringifyObject(value);
    }
    if (typeof value === 'string') {
        return value;
    }
    /* istanbul ignore next */
    return '';
}
function stringifyArray(value) {
    var res = '';
    var stringified;
    for (var i = 0, l = value.length; i < l; i++) {
        if (isDef((stringified = stringifyClass(value[i]))) && stringified !== '') {
            if (res)
                res += ' ';
            res += stringified;
        }
    }
    return res;
}
function stringifyObject(value) {
    var res = '';
    for (var key in value) {
        if (value[key]) {
            if (res)
                res += ' ';
            res += key;
        }
    }
    return res;
}

var namespaceMap = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' +
    'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
    'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
    'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
    's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
    'embed,object,param,source,canvas,script,noscript,del,ins,' +
    'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
    'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
    'output,progress,select,textarea,' +
    'details,dialog,menu,menuitem,summary,' +
    'content,element,shadow,template,blockquote,iframe,tfoot');
// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
    'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
    'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);
var isPreTag = function (tag) { return tag === 'pre'; };
var isReservedTag = function (tag) {
    return isHTMLTag(tag) || isSVG(tag);
};
function getTagNamespace(tag) {
    if (isSVG(tag)) {
        return 'svg';
    }
    // basic support for MathML
    // note it doesn't support other MathML elements being component roots
    if (tag === 'math') {
        return 'math';
    }
}
var unknownElementCache = Object.create(null);
function isUnknownElement(tag) {
    /* istanbul ignore if */
    if (!inBrowser) {
        return true;
    }
    if (isReservedTag(tag)) {
        return false;
    }
    tag = tag.toLowerCase();
    /* istanbul ignore if */
    if (unknownElementCache[tag] != null) {
        return unknownElementCache[tag];
    }
    var el = document.createElement(tag);
    if (tag.indexOf('-') > -1) {
        // http://stackoverflow.com/a/28210364/1070244
        return (unknownElementCache[tag] =
            el.constructor === window.HTMLUnknownElement ||
                el.constructor === window.HTMLElement);
    }
    else {
        return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()));
    }
}
var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/**
 * Query an element selector if it's not an element already.
 */
function query(el) {
    if (typeof el === 'string') {
        var selected = document.querySelector(el);
        if (!selected) {
            "production" !== 'production' && warn$2('Cannot find element: ' + el);
            return document.createElement('div');
        }
        return selected;
    }
    else {
        return el;
    }
}

function createElement(tagName, vnode) {
    var elm = document.createElement(tagName);
    if (tagName !== 'select') {
        return elm;
    }
    // false or null will remove the attribute but undefined will not
    if (vnode.data &&
        vnode.data.attrs &&
        vnode.data.attrs.multiple !== undefined) {
        elm.setAttribute('multiple', 'multiple');
    }
    return elm;
}
function createElementNS(namespace, tagName) {
    return document.createElementNS(namespaceMap[namespace], tagName);
}
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(node) {
    return node.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function setStyleScope(node, scopeId) {
    node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createElement: createElement,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

var ref = {
    create: function (_, vnode) {
        registerRef(vnode);
    },
    update: function (oldVnode, vnode) {
        if (oldVnode.data.ref !== vnode.data.ref) {
            registerRef(oldVnode, true);
            registerRef(vnode);
        }
    },
    destroy: function (vnode) {
        registerRef(vnode, true);
    }
};
function registerRef(vnode, isRemoval) {
    var ref = vnode.data.ref;
    if (!isDef(ref))
        return;
    var vm = vnode.context;
    var refValue = vnode.componentInstance || vnode.elm;
    var value = isRemoval ? null : refValue;
    var $refsValue = isRemoval ? undefined : refValue;
    if (isFunction(ref)) {
        invokeWithErrorHandling(ref, vm, [value], vm, "template ref function");
        return;
    }
    var isFor = vnode.data.refInFor;
    var _isString = typeof ref === 'string' || typeof ref === 'number';
    var _isRef = isRef(ref);
    var refs = vm.$refs;
    if (_isString || _isRef) {
        if (isFor) {
            var existing = _isString ? refs[ref] : ref.value;
            if (isRemoval) {
                isArray(existing) && remove$2(existing, refValue);
            }
            else {
                if (!isArray(existing)) {
                    if (_isString) {
                        refs[ref] = [refValue];
                        setSetupRef(vm, ref, refs[ref]);
                    }
                    else {
                        ref.value = [refValue];
                    }
                }
                else if (!existing.includes(refValue)) {
                    existing.push(refValue);
                }
            }
        }
        else if (_isString) {
            if (isRemoval && refs[ref] !== refValue) {
                return;
            }
            refs[ref] = $refsValue;
            setSetupRef(vm, ref, value);
        }
        else if (_isRef) {
            if (isRemoval && ref.value !== refValue) {
                return;
            }
            ref.value = value;
        }
        else if (false) {
            warn$2("Invalid template ref type: ".concat(typeof ref));
        }
    }
}
function setSetupRef(_a, key, val) {
    var _setupState = _a._setupState;
    if (_setupState && hasOwn(_setupState, key)) {
        if (isRef(_setupState[key])) {
            _setupState[key].value = val;
        }
        else {
            _setupState[key] = val;
        }
    }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */
var emptyNode = new VNode('', {}, []);
var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
function sameVnode(a, b) {
    return (a.key === b.key &&
        a.asyncFactory === b.asyncFactory &&
        ((a.tag === b.tag &&
            a.isComment === b.isComment &&
            isDef(a.data) === isDef(b.data) &&
            sameInputType(a, b)) ||
            (isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error))));
}
function sameInputType(a, b) {
    if (a.tag !== 'input')
        return true;
    var i;
    var typeA = isDef((i = a.data)) && isDef((i = i.attrs)) && i.type;
    var typeB = isDef((i = b.data)) && isDef((i = i.attrs)) && i.type;
    return typeA === typeB || (isTextInputType(typeA) && isTextInputType(typeB));
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, key;
    var map = {};
    for (i = beginIdx; i <= endIdx; ++i) {
        key = children[i].key;
        if (isDef(key))
            map[key] = i;
    }
    return map;
}
function createPatchFunction(backend) {
    var i, j;
    var cbs = {};
    var modules = backend.modules, nodeOps = backend.nodeOps;
    for (i = 0; i < hooks.length; ++i) {
        cbs[hooks[i]] = [];
        for (j = 0; j < modules.length; ++j) {
            if (isDef(modules[j][hooks[i]])) {
                cbs[hooks[i]].push(modules[j][hooks[i]]);
            }
        }
    }
    function emptyNodeAt(elm) {
        return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        function remove() {
            if (--remove.listeners === 0) {
                removeNode(childElm);
            }
        }
        remove.listeners = listeners;
        return remove;
    }
    function removeNode(el) {
        var parent = nodeOps.parentNode(el);
        // element may have already been removed due to v-html / v-text
        if (isDef(parent)) {
            nodeOps.removeChild(parent, el);
        }
    }
    function isUnknownElement(vnode, inVPre) {
        return (!inVPre &&
            !vnode.ns &&
            !(config.ignoredElements.length &&
                config.ignoredElements.some(function (ignore) {
                    return isRegExp(ignore)
                        ? ignore.test(vnode.tag)
                        : ignore === vnode.tag;
                })) &&
            config.isUnknownElement(vnode.tag));
    }
    var creatingElmInVPre = 0;
    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // This vnode was used in a previous render!
            // now it's used as a new node, overwriting its elm would cause
            // potential patch errors down the road when it's used as an insertion
            // reference node. Instead, we clone the node on-demand before creating
            // associated DOM element for it.
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        vnode.isRootInsert = !nested; // for transition enter check
        if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
            return;
        }
        var data = vnode.data;
        var children = vnode.children;
        var tag = vnode.tag;
        if (isDef(tag)) {
            if (false) {
                if (data && data.pre) {
                    creatingElmInVPre++;
                }
                if (isUnknownElement(vnode, creatingElmInVPre)) {
                    warn$2('Unknown custom element: <' +
                        tag +
                        '> - did you ' +
                        'register the component correctly? For recursive components, ' +
                        'make sure to provide the "name" option.', vnode.context);
                }
            }
            vnode.elm = vnode.ns
                ? nodeOps.createElementNS(vnode.ns, tag)
                : nodeOps.createElement(tag, vnode);
            setScope(vnode);
            createChildren(vnode, children, insertedVnodeQueue);
            if (isDef(data)) {
                invokeCreateHooks(vnode, insertedVnodeQueue);
            }
            insert(parentElm, vnode.elm, refElm);
            if (false) {
                creatingElmInVPre--;
            }
        }
        else if (isTrue(vnode.isComment)) {
            vnode.elm = nodeOps.createComment(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
        else {
            vnode.elm = nodeOps.createTextNode(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
    }
    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i = vnode.data;
        if (isDef(i)) {
            var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
            if (isDef((i = i.hook)) && isDef((i = i.init))) {
                i(vnode, false /* hydrating */);
            }
            // after calling the init hook, if the vnode is a child component
            // it should've created a child instance and mounted it. the child
            // component also has set the placeholder vnode's elm.
            // in that case we can just return the element and be done.
            if (isDef(vnode.componentInstance)) {
                initComponent(vnode, insertedVnodeQueue);
                insert(parentElm, vnode.elm, refElm);
                if (isTrue(isReactivated)) {
                    reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
                }
                return true;
            }
        }
    }
    function initComponent(vnode, insertedVnodeQueue) {
        if (isDef(vnode.data.pendingInsert)) {
            insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
            vnode.data.pendingInsert = null;
        }
        vnode.elm = vnode.componentInstance.$el;
        if (isPatchable(vnode)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            setScope(vnode);
        }
        else {
            // empty component root.
            // skip all element-related modules except for ref (#3455)
            registerRef(vnode);
            // make sure to invoke the insert hook
            insertedVnodeQueue.push(vnode);
        }
    }
    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i;
        // hack for #4339: a reactivated component with inner transition
        // does not trigger because the inner node's created hooks are not called
        // again. It's not ideal to involve module-specific logic in here but
        // there doesn't seem to be a better way to do it.
        var innerNode = vnode;
        while (innerNode.componentInstance) {
            innerNode = innerNode.componentInstance._vnode;
            if (isDef((i = innerNode.data)) && isDef((i = i.transition))) {
                for (i = 0; i < cbs.activate.length; ++i) {
                    cbs.activate[i](emptyNode, innerNode);
                }
                insertedVnodeQueue.push(innerNode);
                break;
            }
        }
        // unlike a newly created component,
        // a reactivated keep-alive component doesn't insert itself
        insert(parentElm, vnode.elm, refElm);
    }
    function insert(parent, elm, ref) {
        if (isDef(parent)) {
            if (isDef(ref)) {
                if (nodeOps.parentNode(ref) === parent) {
                    nodeOps.insertBefore(parent, elm, ref);
                }
            }
            else {
                nodeOps.appendChild(parent, elm);
            }
        }
    }
    function createChildren(vnode, children, insertedVnodeQueue) {
        if (isArray(children)) {
            if (false) {
                checkDuplicateKeys(children);
            }
            for (var i_1 = 0; i_1 < children.length; ++i_1) {
                createElm(children[i_1], insertedVnodeQueue, vnode.elm, null, true, children, i_1);
            }
        }
        else if (isPrimitive(vnode.text)) {
            nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
        }
    }
    function isPatchable(vnode) {
        while (vnode.componentInstance) {
            vnode = vnode.componentInstance._vnode;
        }
        return isDef(vnode.tag);
    }
    function invokeCreateHooks(vnode, insertedVnodeQueue) {
        for (var i_2 = 0; i_2 < cbs.create.length; ++i_2) {
            cbs.create[i_2](emptyNode, vnode);
        }
        i = vnode.data.hook; // Reuse variable
        if (isDef(i)) {
            if (isDef(i.create))
                i.create(emptyNode, vnode);
            if (isDef(i.insert))
                insertedVnodeQueue.push(vnode);
        }
    }
    // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.
    function setScope(vnode) {
        var i;
        if (isDef((i = vnode.fnScopeId))) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
        else {
            var ancestor = vnode;
            while (ancestor) {
                if (isDef((i = ancestor.context)) && isDef((i = i.$options._scopeId))) {
                    nodeOps.setStyleScope(vnode.elm, i);
                }
                ancestor = ancestor.parent;
            }
        }
        // for slot content they should also get the scopeId from the host instance.
        if (isDef((i = activeInstance)) &&
            i !== vnode.context &&
            i !== vnode.fnContext &&
            isDef((i = i.$options._scopeId))) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
    }
    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for (; startIdx <= endIdx; ++startIdx) {
            createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
        }
    }
    function invokeDestroyHook(vnode) {
        var i, j;
        var data = vnode.data;
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.destroy)))
                i(vnode);
            for (i = 0; i < cbs.destroy.length; ++i)
                cbs.destroy[i](vnode);
        }
        if (isDef((i = vnode.children))) {
            for (j = 0; j < vnode.children.length; ++j) {
                invokeDestroyHook(vnode.children[j]);
            }
        }
    }
    function removeVnodes(vnodes, startIdx, endIdx) {
        for (; startIdx <= endIdx; ++startIdx) {
            var ch = vnodes[startIdx];
            if (isDef(ch)) {
                if (isDef(ch.tag)) {
                    removeAndInvokeRemoveHook(ch);
                    invokeDestroyHook(ch);
                }
                else {
                    // Text node
                    removeNode(ch.elm);
                }
            }
        }
    }
    function removeAndInvokeRemoveHook(vnode, rm) {
        if (isDef(rm) || isDef(vnode.data)) {
            var i_3;
            var listeners = cbs.remove.length + 1;
            if (isDef(rm)) {
                // we have a recursively passed down rm callback
                // increase the listeners count
                rm.listeners += listeners;
            }
            else {
                // directly removing
                rm = createRmCb(vnode.elm, listeners);
            }
            // recursively invoke hooks on child component root node
            if (isDef((i_3 = vnode.componentInstance)) &&
                isDef((i_3 = i_3._vnode)) &&
                isDef(i_3.data)) {
                removeAndInvokeRemoveHook(i_3, rm);
            }
            for (i_3 = 0; i_3 < cbs.remove.length; ++i_3) {
                cbs.remove[i_3](vnode, rm);
            }
            if (isDef((i_3 = vnode.data.hook)) && isDef((i_3 = i_3.remove))) {
                i_3(vnode, rm);
            }
            else {
                rm();
            }
        }
        else {
            removeNode(vnode.elm);
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
        var oldStartIdx = 0;
        var newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
        // removeOnly is a special flag used only by <transition-group>
        // to ensure removed elements stay in correct relative positions
        // during leaving transitions
        var canMove = !removeOnly;
        if (false) {
            checkDuplicateKeys(newCh);
        }
        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
            if (isUndef(oldStartVnode)) {
                oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
            }
            else if (isUndef(oldEndVnode)) {
                oldEndVnode = oldCh[--oldEndIdx];
            }
            else if (sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else if (sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                canMove &&
                    nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                canMove &&
                    nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else {
                if (isUndef(oldKeyToIdx))
                    oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = isDef(newStartVnode.key)
                    ? oldKeyToIdx[newStartVnode.key]
                    : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
                if (isUndef(idxInOld)) {
                    // New element
                    createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                }
                else {
                    vnodeToMove = oldCh[idxInOld];
                    if (sameVnode(vnodeToMove, newStartVnode)) {
                        patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                        oldCh[idxInOld] = undefined;
                        canMove &&
                            nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                    }
                    else {
                        // same key but different element. treat as new element
                        createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                    }
                }
                newStartVnode = newCh[++newStartIdx];
            }
        }
        if (oldStartIdx > oldEndIdx) {
            refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        }
        else if (newStartIdx > newEndIdx) {
            removeVnodes(oldCh, oldStartIdx, oldEndIdx);
        }
    }
    function checkDuplicateKeys(children) {
        var seenKeys = {};
        for (var i_4 = 0; i_4 < children.length; i_4++) {
            var vnode = children[i_4];
            var key = vnode.key;
            if (isDef(key)) {
                if (seenKeys[key]) {
                    warn$2("Duplicate keys detected: '".concat(key, "'. This may cause an update error."), vnode.context);
                }
                else {
                    seenKeys[key] = true;
                }
            }
        }
    }
    function findIdxInOld(node, oldCh, start, end) {
        for (var i_5 = start; i_5 < end; i_5++) {
            var c = oldCh[i_5];
            if (isDef(c) && sameVnode(node, c))
                return i_5;
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
        if (oldVnode === vnode) {
            return;
        }
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // clone reused vnode
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        var elm = (vnode.elm = oldVnode.elm);
        if (isTrue(oldVnode.isAsyncPlaceholder)) {
            if (isDef(vnode.asyncFactory.resolved)) {
                hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
            }
            else {
                vnode.isAsyncPlaceholder = true;
            }
            return;
        }
        // reuse element for static trees.
        // note we only do this if the vnode is cloned -
        // if the new node is not cloned it means the render functions have been
        // reset by the hot-reload-api and we need to do a proper re-render.
        if (isTrue(vnode.isStatic) &&
            isTrue(oldVnode.isStatic) &&
            vnode.key === oldVnode.key &&
            (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
            vnode.componentInstance = oldVnode.componentInstance;
            return;
        }
        var i;
        var data = vnode.data;
        if (isDef(data) && isDef((i = data.hook)) && isDef((i = i.prepatch))) {
            i(oldVnode, vnode);
        }
        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if (isDef(data) && isPatchable(vnode)) {
            for (i = 0; i < cbs.update.length; ++i)
                cbs.update[i](oldVnode, vnode);
            if (isDef((i = data.hook)) && isDef((i = i.update)))
                i(oldVnode, vnode);
        }
        if (isUndef(vnode.text)) {
            if (isDef(oldCh) && isDef(ch)) {
                if (oldCh !== ch)
                    updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
            }
            else if (isDef(ch)) {
                if (false) {
                    checkDuplicateKeys(ch);
                }
                if (isDef(oldVnode.text))
                    nodeOps.setTextContent(elm, '');
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            }
            else if (isDef(oldCh)) {
                removeVnodes(oldCh, 0, oldCh.length - 1);
            }
            else if (isDef(oldVnode.text)) {
                nodeOps.setTextContent(elm, '');
            }
        }
        else if (oldVnode.text !== vnode.text) {
            nodeOps.setTextContent(elm, vnode.text);
        }
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.postpatch)))
                i(oldVnode, vnode);
        }
    }
    function invokeInsertHook(vnode, queue, initial) {
        // delay insert hooks for component root nodes, invoke them after the
        // element is really inserted
        if (isTrue(initial) && isDef(vnode.parent)) {
            vnode.parent.data.pendingInsert = queue;
        }
        else {
            for (var i_6 = 0; i_6 < queue.length; ++i_6) {
                queue[i_6].data.hook.insert(queue[i_6]);
            }
        }
    }
    var hydrationBailed = false;
    // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).
    var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
    // Note: this is a browser-only function so we can assume elms are DOM nodes.
    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
        var i;
        var tag = vnode.tag, data = vnode.data, children = vnode.children;
        inVPre = inVPre || (data && data.pre);
        vnode.elm = elm;
        if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
            vnode.isAsyncPlaceholder = true;
            return true;
        }
        // assert node match
        if (false) {
            if (!assertNodeMatch(elm, vnode, inVPre)) {
                return false;
            }
        }
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.init)))
                i(vnode, true /* hydrating */);
            if (isDef((i = vnode.componentInstance))) {
                // child component. it should have hydrated its own tree.
                initComponent(vnode, insertedVnodeQueue);
                return true;
            }
        }
        if (isDef(tag)) {
            if (isDef(children)) {
                // empty element, allow client to pick up and populate children
                if (!elm.hasChildNodes()) {
                    createChildren(vnode, children, insertedVnodeQueue);
                }
                else {
                    // v-html and domProps: innerHTML
                    if (isDef((i = data)) &&
                        isDef((i = i.domProps)) &&
                        isDef((i = i.innerHTML))) {
                        if (i !== elm.innerHTML) {
                            /* istanbul ignore if */
                            if (false) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('server innerHTML: ', i);
                                console.warn('client innerHTML: ', elm.innerHTML);
                            }
                            return false;
                        }
                    }
                    else {
                        // iterate and compare children lists
                        var childrenMatch = true;
                        var childNode = elm.firstChild;
                        for (var i_7 = 0; i_7 < children.length; i_7++) {
                            if (!childNode ||
                                !hydrate(childNode, children[i_7], insertedVnodeQueue, inVPre)) {
                                childrenMatch = false;
                                break;
                            }
                            childNode = childNode.nextSibling;
                        }
                        // if childNode is not null, it means the actual childNodes list is
                        // longer than the virtual children list.
                        if (!childrenMatch || childNode) {
                            /* istanbul ignore if */
                            if (false) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                            }
                            return false;
                        }
                    }
                }
            }
            if (isDef(data)) {
                var fullInvoke = false;
                for (var key in data) {
                    if (!isRenderedModule(key)) {
                        fullInvoke = true;
                        invokeCreateHooks(vnode, insertedVnodeQueue);
                        break;
                    }
                }
                if (!fullInvoke && data['class']) {
                    // ensure collecting deps for deep class bindings for future updates
                    traverse(data['class']);
                }
            }
        }
        else if (elm.data !== vnode.text) {
            elm.data = vnode.text;
        }
        return true;
    }
    function assertNodeMatch(node, vnode, inVPre) {
        if (isDef(vnode.tag)) {
            return (vnode.tag.indexOf('vue-component') === 0 ||
                (!isUnknownElement(vnode, inVPre) &&
                    vnode.tag.toLowerCase() ===
                        (node.tagName && node.tagName.toLowerCase())));
        }
        else {
            return node.nodeType === (vnode.isComment ? 8 : 3);
        }
    }
    return function patch(oldVnode, vnode, hydrating, removeOnly) {
        if (isUndef(vnode)) {
            if (isDef(oldVnode))
                invokeDestroyHook(oldVnode);
            return;
        }
        var isInitialPatch = false;
        var insertedVnodeQueue = [];
        if (isUndef(oldVnode)) {
            // empty mount (likely as component), create new root element
            isInitialPatch = true;
            createElm(vnode, insertedVnodeQueue);
        }
        else {
            var isRealElement = isDef(oldVnode.nodeType);
            if (!isRealElement && sameVnode(oldVnode, vnode)) {
                // patch existing root node
                patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
            }
            else {
                if (isRealElement) {
                    // mounting to a real element
                    // check if this is server-rendered content and if we can perform
                    // a successful hydration.
                    if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
                        oldVnode.removeAttribute(SSR_ATTR);
                        hydrating = true;
                    }
                    if (isTrue(hydrating)) {
                        if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                            invokeInsertHook(vnode, insertedVnodeQueue, true);
                            return oldVnode;
                        }
                        else if (false) {
                            warn$2('The client-side rendered virtual DOM tree is not matching ' +
                                'server-rendered content. This is likely caused by incorrect ' +
                                'HTML markup, for example nesting block-level elements inside ' +
                                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                                'full client-side render.');
                        }
                    }
                    // either not server-rendered, or hydration failed.
                    // create an empty node and replace it
                    oldVnode = emptyNodeAt(oldVnode);
                }
                // replacing existing element
                var oldElm = oldVnode.elm;
                var parentElm = nodeOps.parentNode(oldElm);
                // create new node
                createElm(vnode, insertedVnodeQueue, 
                // extremely rare edge case: do not insert if old element is in a
                // leaving transition. Only happens when combining transition +
                // keep-alive + HOCs. (#4590)
                oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));
                // update parent placeholder node element, recursively
                if (isDef(vnode.parent)) {
                    var ancestor = vnode.parent;
                    var patchable = isPatchable(vnode);
                    while (ancestor) {
                        for (var i_8 = 0; i_8 < cbs.destroy.length; ++i_8) {
                            cbs.destroy[i_8](ancestor);
                        }
                        ancestor.elm = vnode.elm;
                        if (patchable) {
                            for (var i_9 = 0; i_9 < cbs.create.length; ++i_9) {
                                cbs.create[i_9](emptyNode, ancestor);
                            }
                            // #6513
                            // invoke insert hooks that may have been merged by create hooks.
                            // e.g. for directives that uses the "inserted" hook.
                            var insert_1 = ancestor.data.hook.insert;
                            if (insert_1.merged) {
                                // start at index 1 to avoid re-invoking component mounted hook
                                for (var i_10 = 1; i_10 < insert_1.fns.length; i_10++) {
                                    insert_1.fns[i_10]();
                                }
                            }
                        }
                        else {
                            registerRef(ancestor);
                        }
                        ancestor = ancestor.parent;
                    }
                }
                // destroy old node
                if (isDef(parentElm)) {
                    removeVnodes([oldVnode], 0, 0);
                }
                else if (isDef(oldVnode.tag)) {
                    invokeDestroyHook(oldVnode);
                }
            }
        }
        invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
        return vnode.elm;
    };
}

var directives$1 = {
    create: updateDirectives,
    update: updateDirectives,
    destroy: function unbindDirectives(vnode) {
        // @ts-expect-error emptyNode is not VNodeWithData
        updateDirectives(vnode, emptyNode);
    }
};
function updateDirectives(oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) {
        _update(oldVnode, vnode);
    }
}
function _update(oldVnode, vnode) {
    var isCreate = oldVnode === emptyNode;
    var isDestroy = vnode === emptyNode;
    var oldDirs = normalizeDirectives(oldVnode.data.directives, oldVnode.context);
    var newDirs = normalizeDirectives(vnode.data.directives, vnode.context);
    var dirsWithInsert = [];
    var dirsWithPostpatch = [];
    var key, oldDir, dir;
    for (key in newDirs) {
        oldDir = oldDirs[key];
        dir = newDirs[key];
        if (!oldDir) {
            // new directive, bind
            callHook(dir, 'bind', vnode, oldVnode);
            if (dir.def && dir.def.inserted) {
                dirsWithInsert.push(dir);
            }
        }
        else {
            // existing directive, update
            dir.oldValue = oldDir.value;
            dir.oldArg = oldDir.arg;
            callHook(dir, 'update', vnode, oldVnode);
            if (dir.def && dir.def.componentUpdated) {
                dirsWithPostpatch.push(dir);
            }
        }
    }
    if (dirsWithInsert.length) {
        var callInsert = function () {
            for (var i = 0; i < dirsWithInsert.length; i++) {
                callHook(dirsWithInsert[i], 'inserted', vnode, oldVnode);
            }
        };
        if (isCreate) {
            mergeVNodeHook(vnode, 'insert', callInsert);
        }
        else {
            callInsert();
        }
    }
    if (dirsWithPostpatch.length) {
        mergeVNodeHook(vnode, 'postpatch', function () {
            for (var i = 0; i < dirsWithPostpatch.length; i++) {
                callHook(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
            }
        });
    }
    if (!isCreate) {
        for (key in oldDirs) {
            if (!newDirs[key]) {
                // no longer present, unbind
                callHook(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
            }
        }
    }
}
var emptyModifiers = Object.create(null);
function normalizeDirectives(dirs, vm) {
    var res = Object.create(null);
    if (!dirs) {
        // $flow-disable-line
        return res;
    }
    var i, dir;
    for (i = 0; i < dirs.length; i++) {
        dir = dirs[i];
        if (!dir.modifiers) {
            // $flow-disable-line
            dir.modifiers = emptyModifiers;
        }
        res[getRawDirName(dir)] = dir;
        if (vm._setupState && vm._setupState.__sfc) {
            var setupDef = dir.def || resolveAsset(vm, '_setupState', 'v-' + dir.name);
            if (typeof setupDef === 'function') {
                dir.def = {
                    bind: setupDef,
                    update: setupDef,
                };
            }
            else {
                dir.def = setupDef;
            }
        }
        dir.def = dir.def || resolveAsset(vm.$options, 'directives', dir.name, true);
    }
    // $flow-disable-line
    return res;
}
function getRawDirName(dir) {
    return (dir.rawName || "".concat(dir.name, ".").concat(Object.keys(dir.modifiers || {}).join('.')));
}
function callHook(dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];
    if (fn) {
        try {
            fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
        }
        catch (e) {
            handleError(e, vnode.context, "directive ".concat(dir.name, " ").concat(hook, " hook"));
        }
    }
}

var baseModules = [ref, directives$1];

function updateAttrs(oldVnode, vnode) {
    var opts = vnode.componentOptions;
    if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
        return;
    }
    if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
        return;
    }
    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(attrs.__ob__) || isTrue(attrs._v_attr_proxy)) {
        attrs = vnode.data.attrs = extend({}, attrs);
    }
    for (key in attrs) {
        cur = attrs[key];
        old = oldAttrs[key];
        if (old !== cur) {
            setAttr(elm, key, cur, vnode.data.pre);
        }
    }
    // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max
    /* istanbul ignore if */
    if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
        setAttr(elm, 'value', attrs.value);
    }
    for (key in oldAttrs) {
        if (isUndef(attrs[key])) {
            if (isXlink(key)) {
                elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
            }
            else if (!isEnumeratedAttr(key)) {
                elm.removeAttribute(key);
            }
        }
    }
}
function setAttr(el, key, value, isInPre) {
    if (isInPre || el.tagName.indexOf('-') > -1) {
        baseSetAttr(el, key, value);
    }
    else if (isBooleanAttr(key)) {
        // set attribute for blank value
        // e.g. <option disabled>Select one</option>
        if (isFalsyAttrValue(value)) {
            el.removeAttribute(key);
        }
        else {
            // technically allowfullscreen is a boolean attribute for <iframe>,
            // but Flash expects a value of "true" when used on <embed> tag
            value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
            el.setAttribute(key, value);
        }
    }
    else if (isEnumeratedAttr(key)) {
        el.setAttribute(key, convertEnumeratedValue(key, value));
    }
    else if (isXlink(key)) {
        if (isFalsyAttrValue(value)) {
            el.removeAttributeNS(xlinkNS, getXlinkProp(key));
        }
        else {
            el.setAttributeNS(xlinkNS, key, value);
        }
    }
    else {
        baseSetAttr(el, key, value);
    }
}
function baseSetAttr(el, key, value) {
    if (isFalsyAttrValue(value)) {
        el.removeAttribute(key);
    }
    else {
        // #7138: IE10 & 11 fires input event when setting placeholder on
        // <textarea>... block the first input event and remove the blocker
        // immediately.
        /* istanbul ignore if */
        if (isIE &&
            !isIE9 &&
            el.tagName === 'TEXTAREA' &&
            key === 'placeholder' &&
            value !== '' &&
            !el.__ieph) {
            var blocker_1 = function (e) {
                e.stopImmediatePropagation();
                el.removeEventListener('input', blocker_1);
            };
            el.addEventListener('input', blocker_1);
            // $flow-disable-line
            el.__ieph = true; /* IE placeholder patched */
        }
        el.setAttribute(key, value);
    }
}
var attrs = {
    create: updateAttrs,
    update: updateAttrs
};

function updateClass(oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticClass) &&
        isUndef(data.class) &&
        (isUndef(oldData) ||
            (isUndef(oldData.staticClass) && isUndef(oldData.class)))) {
        return;
    }
    var cls = genClassForVnode(vnode);
    // handle transition classes
    var transitionClass = el._transitionClasses;
    if (isDef(transitionClass)) {
        cls = concat(cls, stringifyClass(transitionClass));
    }
    // set the class
    if (cls !== el._prevClass) {
        el.setAttribute('class', cls);
        el._prevClass = cls;
    }
}
var klass$1 = {
    create: updateClass,
    update: updateClass
};

var validDivisionCharRE = /[\w).+\-_$\]]/;
function parseFilters(exp) {
    var inSingle = false;
    var inDouble = false;
    var inTemplateString = false;
    var inRegex = false;
    var curly = 0;
    var square = 0;
    var paren = 0;
    var lastFilterIndex = 0;
    var c, prev, i, expression, filters;
    for (i = 0; i < exp.length; i++) {
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 0x27 && prev !== 0x5c)
                inSingle = false;
        }
        else if (inDouble) {
            if (c === 0x22 && prev !== 0x5c)
                inDouble = false;
        }
        else if (inTemplateString) {
            if (c === 0x60 && prev !== 0x5c)
                inTemplateString = false;
        }
        else if (inRegex) {
            if (c === 0x2f && prev !== 0x5c)
                inRegex = false;
        }
        else if (c === 0x7c && // pipe
            exp.charCodeAt(i + 1) !== 0x7c &&
            exp.charCodeAt(i - 1) !== 0x7c &&
            !curly &&
            !square &&
            !paren) {
            if (expression === undefined) {
                // first filter, end of expression
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            }
            else {
                pushFilter();
            }
        }
        else {
            switch (c) {
                case 0x22:
                    inDouble = true;
                    break; // "
                case 0x27:
                    inSingle = true;
                    break; // '
                case 0x60:
                    inTemplateString = true;
                    break; // `
                case 0x28:
                    paren++;
                    break; // (
                case 0x29:
                    paren--;
                    break; // )
                case 0x5b:
                    square++;
                    break; // [
                case 0x5d:
                    square--;
                    break; // ]
                case 0x7b:
                    curly++;
                    break; // {
                case 0x7d:
                    curly--;
                    break; // }
            }
            if (c === 0x2f) {
                // /
                var j = i - 1;
                var p 
                // find first non-whitespace prev char
                = void 0;
                // find first non-whitespace prev char
                for (; j >= 0; j--) {
                    p = exp.charAt(j);
                    if (p !== ' ')
                        break;
                }
                if (!p || !validDivisionCharRE.test(p)) {
                    inRegex = true;
                }
            }
        }
    }
    if (expression === undefined) {
        expression = exp.slice(0, i).trim();
    }
    else if (lastFilterIndex !== 0) {
        pushFilter();
    }
    function pushFilter() {
        (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters) {
        for (i = 0; i < filters.length; i++) {
            expression = wrapFilter(expression, filters[i]);
        }
    }
    return expression;
}
function wrapFilter(exp, filter) {
    var i = filter.indexOf('(');
    if (i < 0) {
        // _f: resolveFilter
        return "_f(\"".concat(filter, "\")(").concat(exp, ")");
    }
    else {
        var name_1 = filter.slice(0, i);
        var args = filter.slice(i + 1);
        return "_f(\"".concat(name_1, "\")(").concat(exp).concat(args !== ')' ? ',' + args : args);
    }
}

/* eslint-disable no-unused-vars */
function baseWarn(msg, range) {
    console.error("[Vue compiler]: ".concat(msg));
}
/* eslint-enable no-unused-vars */
function pluckModuleFunction(modules, key) {
    return modules ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; }) : [];
}
function addProp(el, name, value, range, dynamic) {
    (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
    el.plain = false;
}
function addAttr(el, name, value, range, dynamic) {
    var attrs = dynamic
        ? el.dynamicAttrs || (el.dynamicAttrs = [])
        : el.attrs || (el.attrs = []);
    attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
    el.plain = false;
}
// add a raw attr (use this in preTransforms)
function addRawAttr(el, name, value, range) {
    el.attrsMap[name] = value;
    el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}
function addDirective(el, name, rawName, value, arg, isDynamicArg, modifiers, range) {
    (el.directives || (el.directives = [])).push(rangeSetItem({
        name: name,
        rawName: rawName,
        value: value,
        arg: arg,
        isDynamicArg: isDynamicArg,
        modifiers: modifiers
    }, range));
    el.plain = false;
}
function prependModifierMarker(symbol, name, dynamic) {
    return dynamic ? "_p(".concat(name, ",\"").concat(symbol, "\")") : symbol + name; // mark the event as captured
}
function addHandler(el, name, value, modifiers, important, warn, range, dynamic) {
    modifiers = modifiers || emptyObject;
    // warn prevent and passive modifier
    /* istanbul ignore if */
    if (false) {
        warn("passive and prevent can't be used together. " +
            "Passive handler can't prevent default event.", range);
    }
    // normalize click.right and click.middle since they don't actually fire
    // this is technically browser-specific, but at least for now browsers are
    // the only target envs that have right/middle clicks.
    if (modifiers.right) {
        if (dynamic) {
            name = "(".concat(name, ")==='click'?'contextmenu':(").concat(name, ")");
        }
        else if (name === 'click') {
            name = 'contextmenu';
            delete modifiers.right;
        }
    }
    else if (modifiers.middle) {
        if (dynamic) {
            name = "(".concat(name, ")==='click'?'mouseup':(").concat(name, ")");
        }
        else if (name === 'click') {
            name = 'mouseup';
        }
    }
    // check capture modifier
    if (modifiers.capture) {
        delete modifiers.capture;
        name = prependModifierMarker('!', name, dynamic);
    }
    if (modifiers.once) {
        delete modifiers.once;
        name = prependModifierMarker('~', name, dynamic);
    }
    /* istanbul ignore if */
    if (modifiers.passive) {
        delete modifiers.passive;
        name = prependModifierMarker('&', name, dynamic);
    }
    var events;
    if (modifiers.native) {
        delete modifiers.native;
        events = el.nativeEvents || (el.nativeEvents = {});
    }
    else {
        events = el.events || (el.events = {});
    }
    var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
    if (modifiers !== emptyObject) {
        newHandler.modifiers = modifiers;
    }
    var handlers = events[name];
    /* istanbul ignore if */
    if (Array.isArray(handlers)) {
        important ? handlers.unshift(newHandler) : handlers.push(newHandler);
    }
    else if (handlers) {
        events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
    }
    else {
        events[name] = newHandler;
    }
    el.plain = false;
}
function getRawBindingAttr(el, name) {
    return (el.rawAttrsMap[':' + name] ||
        el.rawAttrsMap['v-bind:' + name] ||
        el.rawAttrsMap[name]);
}
function getBindingAttr(el, name, getStatic) {
    var dynamicValue = getAndRemoveAttr(el, ':' + name) || getAndRemoveAttr(el, 'v-bind:' + name);
    if (dynamicValue != null) {
        return parseFilters(dynamicValue);
    }
    else if (getStatic !== false) {
        var staticValue = getAndRemoveAttr(el, name);
        if (staticValue != null) {
            return JSON.stringify(staticValue);
        }
    }
}
// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr(el, name, removeFromMap) {
    var val;
    if ((val = el.attrsMap[name]) != null) {
        var list = el.attrsList;
        for (var i = 0, l = list.length; i < l; i++) {
            if (list[i].name === name) {
                list.splice(i, 1);
                break;
            }
        }
    }
    if (removeFromMap) {
        delete el.attrsMap[name];
    }
    return val;
}
function getAndRemoveAttrByRegex(el, name) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
        var attr = list[i];
        if (name.test(attr.name)) {
            list.splice(i, 1);
            return attr;
        }
    }
}
function rangeSetItem(item, range) {
    if (range) {
        if (range.start != null) {
            item.start = range.start;
        }
        if (range.end != null) {
            item.end = range.end;
        }
    }
    return item;
}

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel(el, value, modifiers) {
    var _a = modifiers || {}, number = _a.number, trim = _a.trim;
    var baseValueExpression = '$$v';
    var valueExpression = baseValueExpression;
    if (trim) {
        valueExpression =
            "(typeof ".concat(baseValueExpression, " === 'string'") +
                "? ".concat(baseValueExpression, ".trim()") +
                ": ".concat(baseValueExpression, ")");
    }
    if (number) {
        valueExpression = "_n(".concat(valueExpression, ")");
    }
    var assignment = genAssignmentCode(value, valueExpression);
    el.model = {
        value: "(".concat(value, ")"),
        expression: JSON.stringify(value),
        callback: "function (".concat(baseValueExpression, ") {").concat(assignment, "}")
    };
}
/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode(value, assignment) {
    var res = parseModel(value);
    if (res.key === null) {
        return "".concat(value, "=").concat(assignment);
    }
    else {
        return "$set(".concat(res.exp, ", ").concat(res.key, ", ").concat(assignment, ")");
    }
}
/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */
var len, str, chr, index, expressionPos, expressionEndPos;
function parseModel(val) {
    // Fix https://github.com/vuejs/vue/pull/7730
    // allow v-model="obj.val " (trailing whitespace)
    val = val.trim();
    len = val.length;
    if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
        index = val.lastIndexOf('.');
        if (index > -1) {
            return {
                exp: val.slice(0, index),
                key: '"' + val.slice(index + 1) + '"'
            };
        }
        else {
            return {
                exp: val,
                key: null
            };
        }
    }
    str = val;
    index = expressionPos = expressionEndPos = 0;
    while (!eof()) {
        chr = next();
        /* istanbul ignore if */
        if (isStringStart(chr)) {
            parseString(chr);
        }
        else if (chr === 0x5b) {
            parseBracket(chr);
        }
    }
    return {
        exp: val.slice(0, expressionPos),
        key: val.slice(expressionPos + 1, expressionEndPos)
    };
}
function next() {
    return str.charCodeAt(++index);
}
function eof() {
    return index >= len;
}
function isStringStart(chr) {
    return chr === 0x22 || chr === 0x27;
}
function parseBracket(chr) {
    var inBracket = 1;
    expressionPos = index;
    while (!eof()) {
        chr = next();
        if (isStringStart(chr)) {
            parseString(chr);
            continue;
        }
        if (chr === 0x5b)
            inBracket++;
        if (chr === 0x5d)
            inBracket--;
        if (inBracket === 0) {
            expressionEndPos = index;
            break;
        }
    }
}
function parseString(chr) {
    var stringQuote = chr;
    while (!eof()) {
        chr = next();
        if (chr === stringQuote) {
            break;
        }
    }
}

var warn$1;
// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';
function model$1(el, dir, _warn) {
    warn$1 = _warn;
    var value = dir.value;
    var modifiers = dir.modifiers;
    var tag = el.tag;
    var type = el.attrsMap.type;
    if (false) {
        // inputs with type="file" are read only and setting the input's
        // value will throw an error.
        if (tag === 'input' && type === 'file') {
            warn$1("<".concat(el.tag, " v-model=\"").concat(value, "\" type=\"file\">:\n") +
                "File inputs are read only. Use a v-on:change listener instead.", el.rawAttrsMap['v-model']);
        }
    }
    if (el.component) {
        genComponentModel(el, value, modifiers);
        // component v-model doesn't need extra runtime
        return false;
    }
    else if (tag === 'select') {
        genSelect(el, value, modifiers);
    }
    else if (tag === 'input' && type === 'checkbox') {
        genCheckboxModel(el, value, modifiers);
    }
    else if (tag === 'input' && type === 'radio') {
        genRadioModel(el, value, modifiers);
    }
    else if (tag === 'input' || tag === 'textarea') {
        genDefaultModel(el, value, modifiers);
    }
    else if (!config.isReservedTag(tag)) {
        genComponentModel(el, value, modifiers);
        // component v-model doesn't need extra runtime
        return false;
    }
    else if (false) {
        warn$1("<".concat(el.tag, " v-model=\"").concat(value, "\">: ") +
            "v-model is not supported on this element type. " +
            "If you are working with contenteditable, it's recommended to " +
            'wrap a library dedicated for that purpose inside a custom component.', el.rawAttrsMap['v-model']);
    }
    // ensure runtime directive metadata
    return true;
}
function genCheckboxModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
    var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
    addProp(el, 'checked', "Array.isArray(".concat(value, ")") +
        "?_i(".concat(value, ",").concat(valueBinding, ")>-1") +
        (trueValueBinding === 'true'
            ? ":(".concat(value, ")")
            : ":_q(".concat(value, ",").concat(trueValueBinding, ")")));
    addHandler(el, 'change', "var $$a=".concat(value, ",") +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(".concat(trueValueBinding, "):(").concat(falseValueBinding, ");") +
        'if(Array.isArray($$a)){' +
        "var $$v=".concat(number ? '_n(' + valueBinding + ')' : valueBinding, ",") +
        '$$i=_i($$a,$$v);' +
        "if($$el.checked){$$i<0&&(".concat(genAssignmentCode(value, '$$a.concat([$$v])'), ")}") +
        "else{$$i>-1&&(".concat(genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))'), ")}") +
        "}else{".concat(genAssignmentCode(value, '$$c'), "}"), null, true);
}
function genRadioModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    valueBinding = number ? "_n(".concat(valueBinding, ")") : valueBinding;
    addProp(el, 'checked', "_q(".concat(value, ",").concat(valueBinding, ")"));
    addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}
function genSelect(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var selectedVal = "Array.prototype.filter" +
        ".call($event.target.options,function(o){return o.selected})" +
        ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
        "return ".concat(number ? '_n(val)' : 'val', "})");
    var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
    var code = "var $$selectedVal = ".concat(selectedVal, ";");
    code = "".concat(code, " ").concat(genAssignmentCode(value, assignment));
    addHandler(el, 'change', code, null, true);
}
function genDefaultModel(el, value, modifiers) {
    var type = el.attrsMap.type;
    // warn if v-bind:value conflicts with v-model
    // except for inputs with v-bind:type
    if (false) {
        var value_1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
        var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
        if (value_1 && !typeBinding) {
            var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
            warn$1("".concat(binding, "=\"").concat(value_1, "\" conflicts with v-model on the same element ") +
                'because the latter already expands to a value binding internally', el.rawAttrsMap[binding]);
        }
    }
    var _a = modifiers || {}, lazy = _a.lazy, number = _a.number, trim = _a.trim;
    var needCompositionGuard = !lazy && type !== 'range';
    var event = lazy ? 'change' : type === 'range' ? RANGE_TOKEN : 'input';
    var valueExpression = '$event.target.value';
    if (trim) {
        valueExpression = "$event.target.value.trim()";
    }
    if (number) {
        valueExpression = "_n(".concat(valueExpression, ")");
    }
    var code = genAssignmentCode(value, valueExpression);
    if (needCompositionGuard) {
        code = "if($event.target.composing)return;".concat(code);
    }
    addProp(el, 'value', "(".concat(value, ")"));
    addHandler(el, event, code, null, true);
    if (trim || number) {
        addHandler(el, 'blur', '$forceUpdate()');
    }
}

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents(on) {
    /* istanbul ignore if */
    if (isDef(on[RANGE_TOKEN])) {
        // IE input[type=range] only supports `change` event
        var event_1 = isIE ? 'change' : 'input';
        on[event_1] = [].concat(on[RANGE_TOKEN], on[event_1] || []);
        delete on[RANGE_TOKEN];
    }
    // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
    /* istanbul ignore if */
    if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
        on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
        delete on[CHECKBOX_RADIO_TOKEN];
    }
}
var target;
function createOnceHandler(event, handler, capture) {
    var _target = target; // save current target element in closure
    return function onceHandler() {
        var res = handler.apply(null, arguments);
        if (res !== null) {
            remove(event, onceHandler, capture, _target);
        }
    };
}
// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
function add(name, handler, capture, passive) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if (useMicrotaskFix) {
        var attachedTimestamp_1 = currentFlushTimestamp;
        var original_1 = handler;
        //@ts-expect-error
        handler = original_1._wrapper = function (e) {
            if (
            // no bubbling, should always fire.
            // this is just a safety net in case event.timeStamp is unreliable in
            // certain weird environments...
            e.target === e.currentTarget ||
                // event is fired after handler attachment
                e.timeStamp >= attachedTimestamp_1 ||
                // bail for environments that have buggy event.timeStamp implementations
                // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
                // #9681 QtWebEngine event.timeStamp is negative value
                e.timeStamp <= 0 ||
                // #9448 bail if event is fired in another document in a multi-page
                // electron/nw.js app, since event.timeStamp will be using a different
                // starting reference
                e.target.ownerDocument !== document) {
                return original_1.apply(this, arguments);
            }
        };
    }
    target.addEventListener(name, handler, supportsPassive ? { capture: capture, passive: passive } : capture);
}
function remove(name, handler, capture, _target) {
    (_target || target).removeEventListener(name, 
    //@ts-expect-error
    handler._wrapper || handler, capture);
}
function updateDOMListeners(oldVnode, vnode) {
    if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
        return;
    }
    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    // vnode is empty when removing all listeners,
    // and use old vnode dom element
    target = vnode.elm || oldVnode.elm;
    normalizeEvents(on);
    updateListeners(on, oldOn, add, remove, createOnceHandler, vnode.context);
    target = undefined;
}
var events = {
    create: updateDOMListeners,
    update: updateDOMListeners,
    // @ts-expect-error emptyNode has actually data
    destroy: function (vnode) { return updateDOMListeners(vnode, emptyNode); }
};

var svgContainer;
function updateDOMProps(oldVnode, vnode) {
    if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
        return;
    }
    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(props.__ob__) || isTrue(props._v_attr_proxy)) {
        props = vnode.data.domProps = extend({}, props);
    }
    for (key in oldProps) {
        if (!(key in props)) {
            elm[key] = '';
        }
    }
    for (key in props) {
        cur = props[key];
        // ignore children if the node has textContent or innerHTML,
        // as these will throw away existing DOM nodes and cause removal errors
        // on subsequent patches (#3360)
        if (key === 'textContent' || key === 'innerHTML') {
            if (vnode.children)
                vnode.children.length = 0;
            if (cur === oldProps[key])
                continue;
            // #6601 work around Chrome version <= 55 bug where single textNode
            // replaced by innerHTML/textContent retains its parentNode property
            if (elm.childNodes.length === 1) {
                elm.removeChild(elm.childNodes[0]);
            }
        }
        if (key === 'value' && elm.tagName !== 'PROGRESS') {
            // store value as _value as well since
            // non-string values will be stringified
            elm._value = cur;
            // avoid resetting cursor position when value is the same
            var strCur = isUndef(cur) ? '' : String(cur);
            if (shouldUpdateValue(elm, strCur)) {
                elm.value = strCur;
            }
        }
        else if (key === 'innerHTML' &&
            isSVG(elm.tagName) &&
            isUndef(elm.innerHTML)) {
            // IE doesn't support innerHTML for SVG elements
            svgContainer = svgContainer || document.createElement('div');
            svgContainer.innerHTML = "<svg>".concat(cur, "</svg>");
            var svg = svgContainer.firstChild;
            while (elm.firstChild) {
                elm.removeChild(elm.firstChild);
            }
            while (svg.firstChild) {
                elm.appendChild(svg.firstChild);
            }
        }
        else if (
        // skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        cur !== oldProps[key]) {
            // some property updates can throw
            // e.g. `value` on <progress> w/ non-finite value
            try {
                elm[key] = cur;
            }
            catch (e) { }
        }
    }
}
function shouldUpdateValue(elm, checkVal) {
    return (
    //@ts-expect-error
    !elm.composing &&
        (elm.tagName === 'OPTION' ||
            isNotInFocusAndDirty(elm, checkVal) ||
            isDirtyWithModifiers(elm, checkVal)));
}
function isNotInFocusAndDirty(elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true;
    // #6157
    // work around IE bug when accessing document.activeElement in an iframe
    try {
        notInFocus = document.activeElement !== elm;
    }
    catch (e) { }
    return notInFocus && elm.value !== checkVal;
}
function isDirtyWithModifiers(elm, newVal) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime
    if (isDef(modifiers)) {
        if (modifiers.number) {
            return toNumber(value) !== toNumber(newVal);
        }
        if (modifiers.trim) {
            return value.trim() !== newVal.trim();
        }
    }
    return value !== newVal;
}
var domProps = {
    create: updateDOMProps,
    update: updateDOMProps
};

var parseStyleText = cached(function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
        if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
});
// merge static and dynamic style data on the same vnode
function normalizeStyleData(data) {
    var style = normalizeStyleBinding(data.style);
    // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it
    return data.staticStyle ? extend(data.staticStyle, style) : style;
}
// normalize possible array / string values into Object
function normalizeStyleBinding(bindingStyle) {
    if (Array.isArray(bindingStyle)) {
        return toObject(bindingStyle);
    }
    if (typeof bindingStyle === 'string') {
        return parseStyleText(bindingStyle);
    }
    return bindingStyle;
}
/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle(vnode, checkChild) {
    var res = {};
    var styleData;
    if (checkChild) {
        var childNode = vnode;
        while (childNode.componentInstance) {
            childNode = childNode.componentInstance._vnode;
            if (childNode &&
                childNode.data &&
                (styleData = normalizeStyleData(childNode.data))) {
                extend(res, styleData);
            }
        }
    }
    if ((styleData = normalizeStyleData(vnode.data))) {
        extend(res, styleData);
    }
    var parentNode = vnode;
    // @ts-expect-error parentNode.parent not VNodeWithData
    while ((parentNode = parentNode.parent)) {
        if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
            extend(res, styleData);
        }
    }
    return res;
}

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
    /* istanbul ignore if */
    if (cssVarRE.test(name)) {
        el.style.setProperty(name, val);
    }
    else if (importantRE.test(val)) {
        el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
    }
    else {
        var normalizedName = normalize(name);
        if (Array.isArray(val)) {
            // Support values array created by autoprefixer, e.g.
            // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
            // Set them one by one, and the browser will only set those it can recognize
            for (var i = 0, len = val.length; i < len; i++) {
                el.style[normalizedName] = val[i];
            }
        }
        else {
            el.style[normalizedName] = val;
        }
    }
};
var vendorNames = ['Webkit', 'Moz', 'ms'];
var emptyStyle;
var normalize = cached(function (prop) {
    emptyStyle = emptyStyle || document.createElement('div').style;
    prop = camelize(prop);
    if (prop !== 'filter' && prop in emptyStyle) {
        return prop;
    }
    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
    for (var i = 0; i < vendorNames.length; i++) {
        var name_1 = vendorNames[i] + capName;
        if (name_1 in emptyStyle) {
            return name_1;
        }
    }
});
function updateStyle(oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticStyle) &&
        isUndef(data.style) &&
        isUndef(oldData.staticStyle) &&
        isUndef(oldData.style)) {
        return;
    }
    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
    var oldStyle = oldStaticStyle || oldStyleBinding;
    var style = normalizeStyleBinding(vnode.data.style) || {};
    // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.
    vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
    var newStyle = getStyle(vnode, true);
    for (name in oldStyle) {
        if (isUndef(newStyle[name])) {
            setProp(el, name, '');
        }
    }
    for (name in newStyle) {
        cur = newStyle[name];
        if (cur !== oldStyle[name]) {
            // ie9 setting to null has no effect, must use empty string
            setProp(el, name, cur == null ? '' : cur);
        }
    }
}
var style$1 = {
    create: updateStyle,
    update: updateStyle
};

var whitespaceRE$1 = /\s+/;
/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE$1).forEach(function (c) { return el.classList.add(c); });
        }
        else {
            el.classList.add(cls);
        }
    }
    else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        if (cur.indexOf(' ' + cls + ' ') < 0) {
            el.setAttribute('class', (cur + cls).trim());
        }
    }
}
/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE$1).forEach(function (c) { return el.classList.remove(c); });
        }
        else {
            el.classList.remove(cls);
        }
        if (!el.classList.length) {
            el.removeAttribute('class');
        }
    }
    else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        var tar = ' ' + cls + ' ';
        while (cur.indexOf(tar) >= 0) {
            cur = cur.replace(tar, ' ');
        }
        cur = cur.trim();
        if (cur) {
            el.setAttribute('class', cur);
        }
        else {
            el.removeAttribute('class');
        }
    }
}

function resolveTransition(def) {
    if (!def) {
        return;
    }
    /* istanbul ignore else */
    if (typeof def === 'object') {
        var res = {};
        if (def.css !== false) {
            extend(res, autoCssTransition(def.name || 'v'));
        }
        extend(res, def);
        return res;
    }
    else if (typeof def === 'string') {
        return autoCssTransition(def);
    }
}
var autoCssTransition = cached(function (name) {
    return {
        enterClass: "".concat(name, "-enter"),
        enterToClass: "".concat(name, "-enter-to"),
        enterActiveClass: "".concat(name, "-enter-active"),
        leaveClass: "".concat(name, "-leave"),
        leaveToClass: "".concat(name, "-leave-to"),
        leaveActiveClass: "".concat(name, "-leave-active")
    };
});
var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';
// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
    /* istanbul ignore if */
    if (window.ontransitionend === undefined &&
        window.onwebkittransitionend !== undefined) {
        transitionProp = 'WebkitTransition';
        transitionEndEvent = 'webkitTransitionEnd';
    }
    if (window.onanimationend === undefined &&
        window.onwebkitanimationend !== undefined) {
        animationProp = 'WebkitAnimation';
        animationEndEvent = 'webkitAnimationEnd';
    }
}
// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
    ? window.requestAnimationFrame
        ? window.requestAnimationFrame.bind(window)
        : setTimeout
    : /* istanbul ignore next */ function (/* istanbul ignore next */ fn) { return fn(); };
function nextFrame(fn) {
    raf(function () {
        // @ts-expect-error
        raf(fn);
    });
}
function addTransitionClass(el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
    if (transitionClasses.indexOf(cls) < 0) {
        transitionClasses.push(cls);
        addClass(el, cls);
    }
}
function removeTransitionClass(el, cls) {
    if (el._transitionClasses) {
        remove$2(el._transitionClasses, cls);
    }
    removeClass(el, cls);
}
function whenTransitionEnds(el, expectedType, cb) {
    var _a = getTransitionInfo(el, expectedType), type = _a.type, timeout = _a.timeout, propCount = _a.propCount;
    if (!type)
        return cb();
    var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
    var ended = 0;
    var end = function () {
        el.removeEventListener(event, onEnd);
        cb();
    };
    var onEnd = function (e) {
        if (e.target === el) {
            if (++ended >= propCount) {
                end();
            }
        }
    };
    setTimeout(function () {
        if (ended < propCount) {
            end();
        }
    }, timeout + 1);
    el.addEventListener(event, onEnd);
}
var transformRE = /\b(transform|all)(,|$)/;
function getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
    var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
    var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
    var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
    var animationTimeout = getTimeout(animationDelays, animationDurations);
    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    }
    else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    }
    else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type =
            timeout > 0
                ? transitionTimeout > animationTimeout
                    ? TRANSITION
                    : ANIMATION
                : null;
        propCount = type
            ? type === TRANSITION
                ? transitionDurations.length
                : animationDurations.length
            : 0;
    }
    var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function getTimeout(delays, durations) {
    /* istanbul ignore next */
    while (delays.length < durations.length) {
        delays = delays.concat(delays);
    }
    return Math.max.apply(null, durations.map(function (d, i) {
        return toMs(d) + toMs(delays[i]);
    }));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
}

function enter(vnode, toggleDisplay) {
    var el = vnode.elm;
    // call leave callback now
    if (isDef(el._leaveCb)) {
        el._leaveCb.cancelled = true;
        el._leaveCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data)) {
        return;
    }
    /* istanbul ignore if */
    if (isDef(el._enterCb) || el.nodeType !== 1) {
        return;
    }
    var css = data.css, type = data.type, enterClass = data.enterClass, enterToClass = data.enterToClass, enterActiveClass = data.enterActiveClass, appearClass = data.appearClass, appearToClass = data.appearToClass, appearActiveClass = data.appearActiveClass, beforeEnter = data.beforeEnter, enter = data.enter, afterEnter = data.afterEnter, enterCancelled = data.enterCancelled, beforeAppear = data.beforeAppear, appear = data.appear, afterAppear = data.afterAppear, appearCancelled = data.appearCancelled, duration = data.duration;
    // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.
    var context = activeInstance;
    var transitionNode = activeInstance.$vnode;
    while (transitionNode && transitionNode.parent) {
        context = transitionNode.context;
        transitionNode = transitionNode.parent;
    }
    var isAppear = !context._isMounted || !vnode.isRootInsert;
    if (isAppear && !appear && appear !== '') {
        return;
    }
    var startClass = isAppear && appearClass ? appearClass : enterClass;
    var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
    var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
    var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
    var enterHook = isAppear ? (isFunction(appear) ? appear : enter) : enter;
    var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
    var enterCancelledHook = isAppear
        ? appearCancelled || enterCancelled
        : enterCancelled;
    var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);
    if (false) {
        checkDuration(explicitEnterDuration, 'enter', vnode);
    }
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(enterHook);
    var cb = (el._enterCb = once(function () {
        if (expectsCSS) {
            removeTransitionClass(el, toClass);
            removeTransitionClass(el, activeClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, startClass);
            }
            enterCancelledHook && enterCancelledHook(el);
        }
        else {
            afterEnterHook && afterEnterHook(el);
        }
        el._enterCb = null;
    }));
    if (!vnode.data.show) {
        // remove pending leave element on enter by injecting an insert hook
        mergeVNodeHook(vnode, 'insert', function () {
            var parent = el.parentNode;
            var pendingNode = parent && parent._pending && parent._pending[vnode.key];
            if (pendingNode &&
                pendingNode.tag === vnode.tag &&
                pendingNode.elm._leaveCb) {
                pendingNode.elm._leaveCb();
            }
            enterHook && enterHook(el, cb);
        });
    }
    // start enter transition
    beforeEnterHook && beforeEnterHook(el);
    if (expectsCSS) {
        addTransitionClass(el, startClass);
        addTransitionClass(el, activeClass);
        nextFrame(function () {
            removeTransitionClass(el, startClass);
            // @ts-expect-error
            if (!cb.cancelled) {
                addTransitionClass(el, toClass);
                if (!userWantsControl) {
                    if (isValidDuration(explicitEnterDuration)) {
                        setTimeout(cb, explicitEnterDuration);
                    }
                    else {
                        whenTransitionEnds(el, type, cb);
                    }
                }
            }
        });
    }
    if (vnode.data.show) {
        toggleDisplay && toggleDisplay();
        enterHook && enterHook(el, cb);
    }
    if (!expectsCSS && !userWantsControl) {
        cb();
    }
}
function leave(vnode, rm) {
    var el = vnode.elm;
    // call enter callback now
    if (isDef(el._enterCb)) {
        el._enterCb.cancelled = true;
        el._enterCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data) || el.nodeType !== 1) {
        return rm();
    }
    /* istanbul ignore if */
    if (isDef(el._leaveCb)) {
        return;
    }
    var css = data.css, type = data.type, leaveClass = data.leaveClass, leaveToClass = data.leaveToClass, leaveActiveClass = data.leaveActiveClass, beforeLeave = data.beforeLeave, leave = data.leave, afterLeave = data.afterLeave, leaveCancelled = data.leaveCancelled, delayLeave = data.delayLeave, duration = data.duration;
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(leave);
    var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);
    if (false) {
        checkDuration(explicitLeaveDuration, 'leave', vnode);
    }
    var cb = (el._leaveCb = once(function () {
        if (el.parentNode && el.parentNode._pending) {
            el.parentNode._pending[vnode.key] = null;
        }
        if (expectsCSS) {
            removeTransitionClass(el, leaveToClass);
            removeTransitionClass(el, leaveActiveClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, leaveClass);
            }
            leaveCancelled && leaveCancelled(el);
        }
        else {
            rm();
            afterLeave && afterLeave(el);
        }
        el._leaveCb = null;
    }));
    if (delayLeave) {
        delayLeave(performLeave);
    }
    else {
        performLeave();
    }
    function performLeave() {
        // the delayed leave may have already been cancelled
        // @ts-expect-error
        if (cb.cancelled) {
            return;
        }
        // record leaving element
        if (!vnode.data.show && el.parentNode) {
            (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] =
                vnode;
        }
        beforeLeave && beforeLeave(el);
        if (expectsCSS) {
            addTransitionClass(el, leaveClass);
            addTransitionClass(el, leaveActiveClass);
            nextFrame(function () {
                removeTransitionClass(el, leaveClass);
                // @ts-expect-error
                if (!cb.cancelled) {
                    addTransitionClass(el, leaveToClass);
                    if (!userWantsControl) {
                        if (isValidDuration(explicitLeaveDuration)) {
                            setTimeout(cb, explicitLeaveDuration);
                        }
                        else {
                            whenTransitionEnds(el, type, cb);
                        }
                    }
                }
            });
        }
        leave && leave(el, cb);
        if (!expectsCSS && !userWantsControl) {
            cb();
        }
    }
}
// only used in dev mode
function checkDuration(val, name, vnode) {
    if (typeof val !== 'number') {
        warn$2("<transition> explicit ".concat(name, " duration is not a valid number - ") +
            "got ".concat(JSON.stringify(val), "."), vnode.context);
    }
    else if (isNaN(val)) {
        warn$2("<transition> explicit ".concat(name, " duration is NaN - ") +
            'the duration expression might be incorrect.', vnode.context);
    }
}
function isValidDuration(val) {
    return typeof val === 'number' && !isNaN(val);
}
/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength(fn) {
    if (isUndef(fn)) {
        return false;
    }
    // @ts-expect-error
    var invokerFns = fn.fns;
    if (isDef(invokerFns)) {
        // invoker
        return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
    }
    else {
        // @ts-expect-error
        return (fn._length || fn.length) > 1;
    }
}
function _enter(_, vnode) {
    if (vnode.data.show !== true) {
        enter(vnode);
    }
}
var transition = inBrowser
    ? {
        create: _enter,
        activate: _enter,
        remove: function (vnode, rm) {
            /* istanbul ignore else */
            if (vnode.data.show !== true) {
                // @ts-expect-error
                leave(vnode, rm);
            }
            else {
                rm();
            }
        }
    }
    : {};

var platformModules = [attrs, klass$1, events, domProps, style$1, transition];

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules$1 = platformModules.concat(baseModules);
var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules$1 });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */
/* istanbul ignore if */
if (isIE9) {
    // http://www.matts411.com/post/internet-explorer-9-oninput/
    document.addEventListener('selectionchange', function () {
        var el = document.activeElement;
        // @ts-expect-error
        if (el && el.vmodel) {
            trigger(el, 'input');
        }
    });
}
var directive = {
    inserted: function (el, binding, vnode, oldVnode) {
        if (vnode.tag === 'select') {
            // #6903
            if (oldVnode.elm && !oldVnode.elm._vOptions) {
                mergeVNodeHook(vnode, 'postpatch', function () {
                    directive.componentUpdated(el, binding, vnode);
                });
            }
            else {
                setSelected(el, binding, vnode.context);
            }
            el._vOptions = [].map.call(el.options, getValue);
        }
        else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
            el._vModifiers = binding.modifiers;
            if (!binding.modifiers.lazy) {
                el.addEventListener('compositionstart', onCompositionStart);
                el.addEventListener('compositionend', onCompositionEnd);
                // Safari < 10.2 & UIWebView doesn't fire compositionend when
                // switching focus before confirming composition choice
                // this also fixes the issue where some browsers e.g. iOS Chrome
                // fires "change" instead of "input" on autocomplete.
                el.addEventListener('change', onCompositionEnd);
                /* istanbul ignore if */
                if (isIE9) {
                    el.vmodel = true;
                }
            }
        }
    },
    componentUpdated: function (el, binding, vnode) {
        if (vnode.tag === 'select') {
            setSelected(el, binding, vnode.context);
            // in case the options rendered by v-for have changed,
            // it's possible that the value is out-of-sync with the rendered options.
            // detect such cases and filter out values that no longer has a matching
            // option in the DOM.
            var prevOptions_1 = el._vOptions;
            var curOptions_1 = (el._vOptions = [].map.call(el.options, getValue));
            if (curOptions_1.some(function (o, i) { return !looseEqual(o, prevOptions_1[i]); })) {
                // trigger change event if
                // no matching option found for at least one value
                var needReset = el.multiple
                    ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions_1); })
                    : binding.value !== binding.oldValue &&
                        hasNoMatchingOption(binding.value, curOptions_1);
                if (needReset) {
                    trigger(el, 'change');
                }
            }
        }
    }
};
function setSelected(el, binding, vm) {
    actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */
    if (isIE || isEdge) {
        setTimeout(function () {
            actuallySetSelected(el, binding, vm);
        }, 0);
    }
}
function actuallySetSelected(el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;
    if (isMultiple && !Array.isArray(value)) {
        "production" !== 'production' &&
            warn$2("<select multiple v-model=\"".concat(binding.expression, "\"> ") +
                "expects an Array value for its binding, but got ".concat(Object.prototype.toString
                    .call(value)
                    .slice(8, -1)), vm);
        return;
    }
    var selected, option;
    for (var i = 0, l = el.options.length; i < l; i++) {
        option = el.options[i];
        if (isMultiple) {
            selected = looseIndexOf(value, getValue(option)) > -1;
            if (option.selected !== selected) {
                option.selected = selected;
            }
        }
        else {
            if (looseEqual(getValue(option), value)) {
                if (el.selectedIndex !== i) {
                    el.selectedIndex = i;
                }
                return;
            }
        }
    }
    if (!isMultiple) {
        el.selectedIndex = -1;
    }
}
function hasNoMatchingOption(value, options) {
    return options.every(function (o) { return !looseEqual(o, value); });
}
function getValue(option) {
    return '_value' in option ? option._value : option.value;
}
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing)
        return;
    e.target.composing = false;
    trigger(e.target, 'input');
}
function trigger(el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}

// recursively search for possible transition defined inside the component root
function locateNode(vnode) {
    // @ts-expect-error
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
        ? locateNode(vnode.componentInstance._vnode)
        : vnode;
}
var show = {
    bind: function (el, _a, vnode) {
        var value = _a.value;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        var originalDisplay = (el.__vOriginalDisplay =
            el.style.display === 'none' ? '' : el.style.display);
        if (value && transition) {
            vnode.data.show = true;
            enter(vnode, function () {
                el.style.display = originalDisplay;
            });
        }
        else {
            el.style.display = value ? originalDisplay : 'none';
        }
    },
    update: function (el, _a, vnode) {
        var value = _a.value, oldValue = _a.oldValue;
        /* istanbul ignore if */
        if (!value === !oldValue)
            return;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        if (transition) {
            vnode.data.show = true;
            if (value) {
                enter(vnode, function () {
                    el.style.display = el.__vOriginalDisplay;
                });
            }
            else {
                leave(vnode, function () {
                    el.style.display = 'none';
                });
            }
        }
        else {
            el.style.display = value ? el.__vOriginalDisplay : 'none';
        }
    },
    unbind: function (el, binding, vnode, oldVnode, isDestroy) {
        if (!isDestroy) {
            el.style.display = el.__vOriginalDisplay;
        }
    }
};

var platformDirectives = {
    model: directive,
    show: show
};

// Provides transition support for a single element/component.
var transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [Number, String, Object]
};
// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild(vnode) {
    var compOptions = vnode && vnode.componentOptions;
    if (compOptions && compOptions.Ctor.options.abstract) {
        return getRealChild(getFirstComponentChild(compOptions.children));
    }
    else {
        return vnode;
    }
}
function extractTransitionData(comp) {
    var data = {};
    var options = comp.$options;
    // props
    for (var key in options.propsData) {
        data[key] = comp[key];
    }
    // events.
    // extract listeners and pass them directly to the transition methods
    var listeners = options._parentListeners;
    for (var key in listeners) {
        data[camelize(key)] = listeners[key];
    }
    return data;
}
function placeholder(h, rawChild) {
    // @ts-expect-error
    if (/\d-keep-alive$/.test(rawChild.tag)) {
        return h('keep-alive', {
            props: rawChild.componentOptions.propsData
        });
    }
}
function hasParentTransition(vnode) {
    while ((vnode = vnode.parent)) {
        if (vnode.data.transition) {
            return true;
        }
    }
}
function isSameChild(child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag;
}
var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };
var isVShowDirective = function (d) { return d.name === 'show'; };
var Transition = {
    name: 'transition',
    props: transitionProps,
    abstract: true,
    render: function (h) {
        var _this = this;
        var children = this.$slots.default;
        if (!children) {
            return;
        }
        // filter out text nodes (possible whitespaces)
        children = children.filter(isNotTextNode);
        /* istanbul ignore if */
        if (!children.length) {
            return;
        }
        // warn multiple elements
        if (false) {
            warn$2('<transition> can only be used on a single element. Use ' +
                '<transition-group> for lists.', this.$parent);
        }
        var mode = this.mode;
        // warn invalid mode
        if (false) {
            warn$2('invalid <transition> mode: ' + mode, this.$parent);
        }
        var rawChild = children[0];
        // if this is a component root node and the component's
        // parent container node also has transition, skip.
        if (hasParentTransition(this.$vnode)) {
            return rawChild;
        }
        // apply transition data to child
        // use getRealChild() to ignore abstract components e.g. keep-alive
        var child = getRealChild(rawChild);
        /* istanbul ignore if */
        if (!child) {
            return rawChild;
        }
        if (this._leaving) {
            return placeholder(h, rawChild);
        }
        // ensure a key that is unique to the vnode type and to this transition
        // component instance. This key will be used to remove pending leaving nodes
        // during entering.
        var id = "__transition-".concat(this._uid, "-");
        child.key =
            child.key == null
                ? child.isComment
                    ? id + 'comment'
                    : id + child.tag
                : isPrimitive(child.key)
                    ? String(child.key).indexOf(id) === 0
                        ? child.key
                        : id + child.key
                    : child.key;
        var data = ((child.data || (child.data = {})).transition =
            extractTransitionData(this));
        var oldRawChild = this._vnode;
        var oldChild = getRealChild(oldRawChild);
        // mark v-show
        // so that the transition module can hand over the control to the directive
        if (child.data.directives && child.data.directives.some(isVShowDirective)) {
            child.data.show = true;
        }
        if (oldChild &&
            oldChild.data &&
            !isSameChild(child, oldChild) &&
            !isAsyncPlaceholder(oldChild) &&
            // #6687 component root is a comment node
            !(oldChild.componentInstance &&
                oldChild.componentInstance._vnode.isComment)) {
            // replace old child transition data with fresh one
            // important for dynamic transitions!
            var oldData = (oldChild.data.transition = extend({}, data));
            // handle transition mode
            if (mode === 'out-in') {
                // return placeholder node and queue update when leave finishes
                this._leaving = true;
                mergeVNodeHook(oldData, 'afterLeave', function () {
                    _this._leaving = false;
                    _this.$forceUpdate();
                });
                return placeholder(h, rawChild);
            }
            else if (mode === 'in-out') {
                if (isAsyncPlaceholder(child)) {
                    return oldRawChild;
                }
                var delayedLeave_1;
                var performLeave = function () {
                    delayedLeave_1();
                };
                mergeVNodeHook(data, 'afterEnter', performLeave);
                mergeVNodeHook(data, 'enterCancelled', performLeave);
                mergeVNodeHook(oldData, 'delayLeave', function (leave) {
                    delayedLeave_1 = leave;
                });
            }
        }
        return rawChild;
    }
};

// Provides transition support for list items.
var props = extend({
    tag: String,
    moveClass: String
}, transitionProps);
delete props.mode;
var TransitionGroup = {
    props: props,
    beforeMount: function () {
        var _this = this;
        var update = this._update;
        this._update = function (vnode, hydrating) {
            var restoreActiveInstance = setActiveInstance(_this);
            // force removing pass
            _this.__patch__(_this._vnode, _this.kept, false, // hydrating
            true // removeOnly (!important, avoids unnecessary moves)
            );
            _this._vnode = _this.kept;
            restoreActiveInstance();
            update.call(_this, vnode, hydrating);
        };
    },
    render: function (h) {
        var tag = this.tag || this.$vnode.data.tag || 'span';
        var map = Object.create(null);
        var prevChildren = (this.prevChildren = this.children);
        var rawChildren = this.$slots.default || [];
        var children = (this.children = []);
        var transitionData = extractTransitionData(this);
        for (var i = 0; i < rawChildren.length; i++) {
            var c = rawChildren[i];
            if (c.tag) {
                if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
                    children.push(c);
                    map[c.key] = c;
                    (c.data || (c.data = {})).transition = transitionData;
                }
                else if (false) {
                    var opts = c.componentOptions;
                    var name_1 = opts
                        ? getComponentName(opts.Ctor.options) || opts.tag || ''
                        : c.tag;
                    warn$2("<transition-group> children must be keyed: <".concat(name_1, ">"));
                }
            }
        }
        if (prevChildren) {
            var kept = [];
            var removed = [];
            for (var i = 0; i < prevChildren.length; i++) {
                var c = prevChildren[i];
                c.data.transition = transitionData;
                // @ts-expect-error .getBoundingClientRect is not typed in Node
                c.data.pos = c.elm.getBoundingClientRect();
                if (map[c.key]) {
                    kept.push(c);
                }
                else {
                    removed.push(c);
                }
            }
            this.kept = h(tag, null, kept);
            this.removed = removed;
        }
        return h(tag, null, children);
    },
    updated: function () {
        var children = this.prevChildren;
        var moveClass = this.moveClass || (this.name || 'v') + '-move';
        if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
            return;
        }
        // we divide the work into three loops to avoid mixing DOM reads and writes
        // in each iteration - which helps prevent layout thrashing.
        children.forEach(callPendingCbs);
        children.forEach(recordPosition);
        children.forEach(applyTranslation);
        // force reflow to put everything in position
        // assign to this to avoid being removed in tree-shaking
        // $flow-disable-line
        this._reflow = document.body.offsetHeight;
        children.forEach(function (c) {
            if (c.data.moved) {
                var el_1 = c.elm;
                var s = el_1.style;
                addTransitionClass(el_1, moveClass);
                s.transform = s.WebkitTransform = s.transitionDuration = '';
                el_1.addEventListener(transitionEndEvent, (el_1._moveCb = function cb(e) {
                    if (e && e.target !== el_1) {
                        return;
                    }
                    if (!e || /transform$/.test(e.propertyName)) {
                        el_1.removeEventListener(transitionEndEvent, cb);
                        el_1._moveCb = null;
                        removeTransitionClass(el_1, moveClass);
                    }
                }));
            }
        });
    },
    methods: {
        hasMove: function (el, moveClass) {
            /* istanbul ignore if */
            if (!hasTransition) {
                return false;
            }
            /* istanbul ignore if */
            if (this._hasMove) {
                return this._hasMove;
            }
            // Detect whether an element with the move class applied has
            // CSS transitions. Since the element may be inside an entering
            // transition at this very moment, we make a clone of it and remove
            // all other transition classes applied to ensure only the move class
            // is applied.
            var clone = el.cloneNode();
            if (el._transitionClasses) {
                el._transitionClasses.forEach(function (cls) {
                    removeClass(clone, cls);
                });
            }
            addClass(clone, moveClass);
            clone.style.display = 'none';
            this.$el.appendChild(clone);
            var info = getTransitionInfo(clone);
            this.$el.removeChild(clone);
            return (this._hasMove = info.hasTransform);
        }
    }
};
function callPendingCbs(c) {
    /* istanbul ignore if */
    if (c.elm._moveCb) {
        c.elm._moveCb();
    }
    /* istanbul ignore if */
    if (c.elm._enterCb) {
        c.elm._enterCb();
    }
}
function recordPosition(c) {
    c.data.newPos = c.elm.getBoundingClientRect();
}
function applyTranslation(c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        c.data.moved = true;
        var s = c.elm.style;
        s.transform = s.WebkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = '0s';
    }
}

var platformComponents = {
    Transition: Transition,
    TransitionGroup: TransitionGroup
};

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;
// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);
// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;
// public mount method
Vue.prototype.$mount = function (el, hydrating) {
    el = el && inBrowser ? query(el) : undefined;
    return mountComponent(this, el, hydrating);
};
// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
    setTimeout(function () {
        if (config.devtools) {
            if (devtools) {
                devtools.emit('init', Vue);
            }
            else if (false) {
                // @ts-expect-error
                console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' +
                    'https://github.com/vuejs/vue-devtools');
            }
        }
        if (false) {
            // @ts-expect-error
            console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" +
                "Make sure to turn on production mode when deploying for production.\n" +
                "See more tips at https://vuejs.org/guide/deployment.html");
        }
    }, 0);
}

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
var buildRegex = cached(function (delimiters) {
    var open = delimiters[0].replace(regexEscapeRE, '\\$&');
    var close = delimiters[1].replace(regexEscapeRE, '\\$&');
    return new RegExp(open + '((?:.|\\n)+?)' + close, 'g');
});
function parseText(text, delimiters) {
    //@ts-expect-error
    var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
    if (!tagRE.test(text)) {
        return;
    }
    var tokens = [];
    var rawTokens = [];
    var lastIndex = (tagRE.lastIndex = 0);
    var match, index, tokenValue;
    while ((match = tagRE.exec(text))) {
        index = match.index;
        // push text token
        if (index > lastIndex) {
            rawTokens.push((tokenValue = text.slice(lastIndex, index)));
            tokens.push(JSON.stringify(tokenValue));
        }
        // tag token
        var exp = parseFilters(match[1].trim());
        tokens.push("_s(".concat(exp, ")"));
        rawTokens.push({ '@binding': exp });
        lastIndex = index + match[0].length;
    }
    if (lastIndex < text.length) {
        rawTokens.push((tokenValue = text.slice(lastIndex)));
        tokens.push(JSON.stringify(tokenValue));
    }
    return {
        expression: tokens.join('+'),
        tokens: rawTokens
    };
}

function transformNode$1(el, options) {
    var warn = options.warn || baseWarn;
    var staticClass = getAndRemoveAttr(el, 'class');
    if (false) {
        var res = parseText(staticClass, options.delimiters);
        if (res) {
            warn("class=\"".concat(staticClass, "\": ") +
                'Interpolation inside attributes has been removed. ' +
                'Use v-bind or the colon shorthand instead. For example, ' +
                'instead of <div class="{{ val }}">, use <div :class="val">.', el.rawAttrsMap['class']);
        }
    }
    if (staticClass) {
        el.staticClass = JSON.stringify(staticClass.replace(/\s+/g, ' ').trim());
    }
    var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
    if (classBinding) {
        el.classBinding = classBinding;
    }
}
function genData$2(el) {
    var data = '';
    if (el.staticClass) {
        data += "staticClass:".concat(el.staticClass, ",");
    }
    if (el.classBinding) {
        data += "class:".concat(el.classBinding, ",");
    }
    return data;
}
var klass = {
    staticKeys: ['staticClass'],
    transformNode: transformNode$1,
    genData: genData$2
};

function transformNode(el, options) {
    var warn = options.warn || baseWarn;
    var staticStyle = getAndRemoveAttr(el, 'style');
    if (staticStyle) {
        /* istanbul ignore if */
        if (false) {
            var res = parseText(staticStyle, options.delimiters);
            if (res) {
                warn("style=\"".concat(staticStyle, "\": ") +
                    'Interpolation inside attributes has been removed. ' +
                    'Use v-bind or the colon shorthand instead. For example, ' +
                    'instead of <div style="{{ val }}">, use <div :style="val">.', el.rawAttrsMap['style']);
            }
        }
        el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
    }
    var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
    if (styleBinding) {
        el.styleBinding = styleBinding;
    }
}
function genData$1(el) {
    var data = '';
    if (el.staticStyle) {
        data += "staticStyle:".concat(el.staticStyle, ",");
    }
    if (el.styleBinding) {
        data += "style:(".concat(el.styleBinding, "),");
    }
    return data;
}
var style = {
    staticKeys: ['staticStyle'],
    transformNode: transformNode,
    genData: genData$1
};

var decoder;
var he = {
    decode: function (html) {
        decoder = decoder || document.createElement('div');
        decoder.innerHTML = html;
        return decoder.textContent;
    }
};

var isUnaryTag = makeMap('area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
    'link,meta,param,source,track,wbr');
// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap('colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source');
// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap('address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
    'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
    'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
    'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
    'title,tr,track');

/**
 * Not type-checking this file because it's mostly vendor code.
 */
// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z".concat(unicodeRegExp.source, "]*");
var qnameCapture = "((?:".concat(ncname, "\\:)?").concat(ncname, ")");
var startTagOpen = new RegExp("^<".concat(qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp("^<\\/".concat(qnameCapture, "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;
// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};
var decodingMap = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&amp;': '&',
    '&#10;': '\n',
    '&#9;': '\t',
    '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;
// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) {
    return tag && isIgnoreNewlineTag(tag) && html[0] === '\n';
};
function decodeAttr(value, shouldDecodeNewlines) {
    var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
    return value.replace(re, function (match) { return decodingMap[match]; });
}
function parseHTML(html, options) {
    var stack = [];
    var expectHTML = options.expectHTML;
    var isUnaryTag = options.isUnaryTag || no;
    var canBeLeftOpenTag = options.canBeLeftOpenTag || no;
    var index = 0;
    var last, lastTag;
    var _loop_1 = function () {
        last = html;
        // Make sure we're not in a plaintext content element like script/style
        if (!lastTag || !isPlainTextElement(lastTag)) {
            var textEnd = html.indexOf('<');
            if (textEnd === 0) {
                // Comment:
                if (comment.test(html)) {
                    var commentEnd = html.indexOf('-->');
                    if (commentEnd >= 0) {
                        if (options.shouldKeepComment && options.comment) {
                            options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
                        }
                        advance(commentEnd + 3);
                        return "continue";
                    }
                }
                // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
                if (conditionalComment.test(html)) {
                    var conditionalEnd = html.indexOf(']>');
                    if (conditionalEnd >= 0) {
                        advance(conditionalEnd + 2);
                        return "continue";
                    }
                }
                // Doctype:
                var doctypeMatch = html.match(doctype);
                if (doctypeMatch) {
                    advance(doctypeMatch[0].length);
                    return "continue";
                }
                // End tag:
                var endTagMatch = html.match(endTag);
                if (endTagMatch) {
                    var curIndex = index;
                    advance(endTagMatch[0].length);
                    parseEndTag(endTagMatch[1], curIndex, index);
                    return "continue";
                }
                // Start tag:
                var startTagMatch = parseStartTag();
                if (startTagMatch) {
                    handleStartTag(startTagMatch);
                    if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
                        advance(1);
                    }
                    return "continue";
                }
            }
            var text = void 0, rest = void 0, next = void 0;
            if (textEnd >= 0) {
                rest = html.slice(textEnd);
                while (!endTag.test(rest) &&
                    !startTagOpen.test(rest) &&
                    !comment.test(rest) &&
                    !conditionalComment.test(rest)) {
                    // < in plain text, be forgiving and treat it as text
                    next = rest.indexOf('<', 1);
                    if (next < 0)
                        break;
                    textEnd += next;
                    rest = html.slice(textEnd);
                }
                text = html.substring(0, textEnd);
            }
            if (textEnd < 0) {
                text = html;
            }
            if (text) {
                advance(text.length);
            }
            if (options.chars && text) {
                options.chars(text, index - text.length, index);
            }
        }
        else {
            var endTagLength_1 = 0;
            var stackedTag_1 = lastTag.toLowerCase();
            var reStackedTag = reCache[stackedTag_1] ||
                (reCache[stackedTag_1] = new RegExp('([\\s\\S]*?)(</' + stackedTag_1 + '[^>]*>)', 'i'));
            var rest = html.replace(reStackedTag, function (all, text, endTag) {
                endTagLength_1 = endTag.length;
                if (!isPlainTextElement(stackedTag_1) && stackedTag_1 !== 'noscript') {
                    text = text
                        .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
                        .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
                }
                if (shouldIgnoreFirstNewline(stackedTag_1, text)) {
                    text = text.slice(1);
                }
                if (options.chars) {
                    options.chars(text);
                }
                return '';
            });
            index += html.length - rest.length;
            html = rest;
            parseEndTag(stackedTag_1, index - endTagLength_1, index);
        }
        if (html === last) {
            options.chars && options.chars(html);
            if (false) {
                options.warn("Mal-formatted tag at end of template: \"".concat(html, "\""), {
                    start: index + html.length
                });
            }
            return "break";
        }
    };
    while (html) {
        var state_1 = _loop_1();
        if (state_1 === "break")
            break;
    }
    // Clean up any remaining tags
    parseEndTag();
    function advance(n) {
        index += n;
        html = html.substring(n);
    }
    function parseStartTag() {
        var start = html.match(startTagOpen);
        if (start) {
            var match = {
                tagName: start[1],
                attrs: [],
                start: index
            };
            advance(start[0].length);
            var end = void 0, attr = void 0;
            while (!(end = html.match(startTagClose)) &&
                (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
                attr.start = index;
                advance(attr[0].length);
                attr.end = index;
                match.attrs.push(attr);
            }
            if (end) {
                match.unarySlash = end[1];
                advance(end[0].length);
                match.end = index;
                return match;
            }
        }
    }
    function handleStartTag(match) {
        var tagName = match.tagName;
        var unarySlash = match.unarySlash;
        if (expectHTML) {
            if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
                parseEndTag(lastTag);
            }
            if (canBeLeftOpenTag(tagName) && lastTag === tagName) {
                parseEndTag(tagName);
            }
        }
        var unary = isUnaryTag(tagName) || !!unarySlash;
        var l = match.attrs.length;
        var attrs = new Array(l);
        for (var i = 0; i < l; i++) {
            var args = match.attrs[i];
            var value = args[3] || args[4] || args[5] || '';
            var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
                ? options.shouldDecodeNewlinesForHref
                : options.shouldDecodeNewlines;
            attrs[i] = {
                name: args[1],
                value: decodeAttr(value, shouldDecodeNewlines)
            };
            if (false) {
                attrs[i].start = args.start + args[0].match(/^\s*/).length;
                attrs[i].end = args.end;
            }
        }
        if (!unary) {
            stack.push({
                tag: tagName,
                lowerCasedTag: tagName.toLowerCase(),
                attrs: attrs,
                start: match.start,
                end: match.end
            });
            lastTag = tagName;
        }
        if (options.start) {
            options.start(tagName, attrs, unary, match.start, match.end);
        }
    }
    function parseEndTag(tagName, start, end) {
        var pos, lowerCasedTagName;
        if (start == null)
            start = index;
        if (end == null)
            end = index;
        // Find the closest opened tag of the same type
        if (tagName) {
            lowerCasedTagName = tagName.toLowerCase();
            for (pos = stack.length - 1; pos >= 0; pos--) {
                if (stack[pos].lowerCasedTag === lowerCasedTagName) {
                    break;
                }
            }
        }
        else {
            // If no tag name is provided, clean shop
            pos = 0;
        }
        if (pos >= 0) {
            // Close all the open elements, up the stack
            for (var i = stack.length - 1; i >= pos; i--) {
                if (false) {
                    options.warn("tag <".concat(stack[i].tag, "> has no matching end tag."), {
                        start: stack[i].start,
                        end: stack[i].end
                    });
                }
                if (options.end) {
                    options.end(stack[i].tag, start, end);
                }
            }
            // Remove the open elements from the stack
            stack.length = pos;
            lastTag = pos && stack[pos - 1].tag;
        }
        else if (lowerCasedTagName === 'br') {
            if (options.start) {
                options.start(tagName, [], true, start, end);
            }
        }
        else if (lowerCasedTagName === 'p') {
            if (options.start) {
                options.start(tagName, [], false, start, end);
            }
            if (options.end) {
                options.end(tagName, start, end);
            }
        }
    }
}

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;
var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;
var slotRE = /^v-slot(:|$)|^#/;
var lineBreakRE = /[\r\n]/;
var whitespaceRE = /[ \f\t\r\n]+/g;
var invalidAttributeRE = /[\s"'<>\/=]/;
var decodeHTMLCached = cached(he.decode);
var emptySlotScopeToken = "_empty_";
// configurable state
var warn;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;
function createASTElement(tag, attrs, parent) {
    return {
        type: 1,
        tag: tag,
        attrsList: attrs,
        attrsMap: makeAttrsMap(attrs),
        rawAttrsMap: {},
        parent: parent,
        children: []
    };
}
/**
 * Convert HTML string to AST.
 */
function parse(template, options) {
    warn = options.warn || baseWarn;
    platformIsPreTag = options.isPreTag || no;
    platformMustUseProp = options.mustUseProp || no;
    platformGetTagNamespace = options.getTagNamespace || no;
    var isReservedTag = options.isReservedTag || no;
    maybeComponent = function (el) {
        return !!(el.component ||
            el.attrsMap[':is'] ||
            el.attrsMap['v-bind:is'] ||
            !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag)));
    };
    transforms = pluckModuleFunction(options.modules, 'transformNode');
    preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
    postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
    delimiters = options.delimiters;
    var stack = [];
    var preserveWhitespace = options.preserveWhitespace !== false;
    var whitespaceOption = options.whitespace;
    var root;
    var currentParent;
    var inVPre = false;
    var inPre = false;
    var warned = false;
    function warnOnce(msg, range) {
        if (!warned) {
            warned = true;
            warn(msg, range);
        }
    }
    function closeElement(element) {
        trimEndingWhitespace(element);
        if (!inVPre && !element.processed) {
            element = processElement(element, options);
        }
        // tree management
        if (!stack.length && element !== root) {
            // allow root elements with v-if, v-else-if and v-else
            if (root.if && (element.elseif || element.else)) {
                if (false) {
                    checkRootConstraints(element);
                }
                addIfCondition(root, {
                    exp: element.elseif,
                    block: element
                });
            }
            else if (false) {
                warnOnce("Component template should contain exactly one root element. " +
                    "If you are using v-if on multiple elements, " +
                    "use v-else-if to chain them instead.", { start: element.start });
            }
        }
        if (currentParent && !element.forbidden) {
            if (element.elseif || element.else) {
                processIfConditions(element, currentParent);
            }
            else {
                if (element.slotScope) {
                    // scoped slot
                    // keep it in the children list so that v-else(-if) conditions can
                    // find it as the prev node.
                    var name_1 = element.slotTarget || '"default"';
                    (currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name_1] = element;
                }
                currentParent.children.push(element);
                element.parent = currentParent;
            }
        }
        // final children cleanup
        // filter out scoped slots
        element.children = element.children.filter(function (c) { return !c.slotScope; });
        // remove trailing whitespace node again
        trimEndingWhitespace(element);
        // check pre state
        if (element.pre) {
            inVPre = false;
        }
        if (platformIsPreTag(element.tag)) {
            inPre = false;
        }
        // apply post-transforms
        for (var i = 0; i < postTransforms.length; i++) {
            postTransforms[i](element, options);
        }
    }
    function trimEndingWhitespace(el) {
        // remove trailing whitespace node
        if (!inPre) {
            var lastNode = void 0;
            while ((lastNode = el.children[el.children.length - 1]) &&
                lastNode.type === 3 &&
                lastNode.text === ' ') {
                el.children.pop();
            }
        }
    }
    function checkRootConstraints(el) {
        if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce("Cannot use <".concat(el.tag, "> as component root element because it may ") +
                'contain multiple nodes.', { start: el.start });
        }
        if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce('Cannot use v-for on stateful component root element because ' +
                'it renders multiple elements.', el.rawAttrsMap['v-for']);
        }
    }
    parseHTML(template, {
        warn: warn,
        expectHTML: options.expectHTML,
        isUnaryTag: options.isUnaryTag,
        canBeLeftOpenTag: options.canBeLeftOpenTag,
        shouldDecodeNewlines: options.shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
        shouldKeepComment: options.comments,
        outputSourceRange: options.outputSourceRange,
        start: function (tag, attrs, unary, start, end) {
            // check namespace.
            // inherit parent ns if there is one
            var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);
            // handle IE svg bug
            /* istanbul ignore if */
            if (isIE && ns === 'svg') {
                attrs = guardIESVGBug(attrs);
            }
            var element = createASTElement(tag, attrs, currentParent);
            if (ns) {
                element.ns = ns;
            }
            if (false) {
                if (options.outputSourceRange) {
                    element.start = start;
                    element.end = end;
                    element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
                        cumulated[attr.name] = attr;
                        return cumulated;
                    }, {});
                }
                attrs.forEach(function (attr) {
                    if (invalidAttributeRE.test(attr.name)) {
                        warn("Invalid dynamic argument expression: attribute names cannot contain " +
                            "spaces, quotes, <, >, / or =.", options.outputSourceRange
                            ? {
                                start: attr.start + attr.name.indexOf("["),
                                end: attr.start + attr.name.length
                            }
                            : undefined);
                    }
                });
            }
            if (isForbiddenTag(element) && !isServerRendering()) {
                element.forbidden = true;
                "production" !== 'production' &&
                    warn('Templates should only be responsible for mapping the state to the ' +
                        'UI. Avoid placing tags with side-effects in your templates, such as ' +
                        "<".concat(tag, ">") +
                        ', as they will not be parsed.', { start: element.start });
            }
            // apply pre-transforms
            for (var i = 0; i < preTransforms.length; i++) {
                element = preTransforms[i](element, options) || element;
            }
            if (!inVPre) {
                processPre(element);
                if (element.pre) {
                    inVPre = true;
                }
            }
            if (platformIsPreTag(element.tag)) {
                inPre = true;
            }
            if (inVPre) {
                processRawAttrs(element);
            }
            else if (!element.processed) {
                // structural directives
                processFor(element);
                processIf(element);
                processOnce(element);
            }
            if (!root) {
                root = element;
                if (false) {
                    checkRootConstraints(root);
                }
            }
            if (!unary) {
                currentParent = element;
                stack.push(element);
            }
            else {
                closeElement(element);
            }
        },
        end: function (tag, start, end) {
            var element = stack[stack.length - 1];
            // pop stack
            stack.length -= 1;
            currentParent = stack[stack.length - 1];
            if (false) {
                element.end = end;
            }
            closeElement(element);
        },
        chars: function (text, start, end) {
            if (!currentParent) {
                if (false) {
                    if (text === template) {
                        warnOnce('Component template requires a root element, rather than just text.', { start: start });
                    }
                    else if ((text = text.trim())) {
                        warnOnce("text \"".concat(text, "\" outside root element will be ignored."), {
                            start: start
                        });
                    }
                }
                return;
            }
            // IE textarea placeholder bug
            /* istanbul ignore if */
            if (isIE &&
                currentParent.tag === 'textarea' &&
                currentParent.attrsMap.placeholder === text) {
                return;
            }
            var children = currentParent.children;
            if (inPre || text.trim()) {
                text = isTextTag(currentParent)
                    ? text
                    : decodeHTMLCached(text);
            }
            else if (!children.length) {
                // remove the whitespace-only node right after an opening tag
                text = '';
            }
            else if (whitespaceOption) {
                if (whitespaceOption === 'condense') {
                    // in condense mode, remove the whitespace node if it contains
                    // line break, otherwise condense to a single space
                    text = lineBreakRE.test(text) ? '' : ' ';
                }
                else {
                    text = ' ';
                }
            }
            else {
                text = preserveWhitespace ? ' ' : '';
            }
            if (text) {
                if (!inPre && whitespaceOption === 'condense') {
                    // condense consecutive whitespaces into single space
                    text = text.replace(whitespaceRE, ' ');
                }
                var res = void 0;
                var child = void 0;
                if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
                    child = {
                        type: 2,
                        expression: res.expression,
                        tokens: res.tokens,
                        text: text
                    };
                }
                else if (text !== ' ' ||
                    !children.length ||
                    children[children.length - 1].text !== ' ') {
                    child = {
                        type: 3,
                        text: text
                    };
                }
                if (child) {
                    if (false) {
                        child.start = start;
                        child.end = end;
                    }
                    children.push(child);
                }
            }
        },
        comment: function (text, start, end) {
            // adding anything as a sibling to the root node is forbidden
            // comments should still be allowed, but ignored
            if (currentParent) {
                var child = {
                    type: 3,
                    text: text,
                    isComment: true
                };
                if (false) {
                    child.start = start;
                    child.end = end;
                }
                currentParent.children.push(child);
            }
        }
    });
    return root;
}
function processPre(el) {
    if (getAndRemoveAttr(el, 'v-pre') != null) {
        el.pre = true;
    }
}
function processRawAttrs(el) {
    var list = el.attrsList;
    var len = list.length;
    if (len) {
        var attrs = (el.attrs = new Array(len));
        for (var i = 0; i < len; i++) {
            attrs[i] = {
                name: list[i].name,
                value: JSON.stringify(list[i].value)
            };
            if (list[i].start != null) {
                attrs[i].start = list[i].start;
                attrs[i].end = list[i].end;
            }
        }
    }
    else if (!el.pre) {
        // non root node in pre blocks with no attributes
        el.plain = true;
    }
}
function processElement(element, options) {
    processKey(element);
    // determine whether this is a plain element after
    // removing structural attributes
    element.plain =
        !element.key && !element.scopedSlots && !element.attrsList.length;
    processRef(element);
    processSlotContent(element);
    processSlotOutlet(element);
    processComponent(element);
    for (var i = 0; i < transforms.length; i++) {
        element = transforms[i](element, options) || element;
    }
    processAttrs(element);
    return element;
}
function processKey(el) {
    var exp = getBindingAttr(el, 'key');
    if (exp) {
        if (false) {
            if (el.tag === 'template') {
                warn("<template> cannot be keyed. Place the key on real elements instead.", getRawBindingAttr(el, 'key'));
            }
            if (el.for) {
                var iterator = el.iterator2 || el.iterator1;
                var parent_1 = el.parent;
                if (iterator &&
                    iterator === exp &&
                    parent_1 &&
                    parent_1.tag === 'transition-group') {
                    warn("Do not use v-for index as key on <transition-group> children, " +
                        "this is the same as not using keys.", getRawBindingAttr(el, 'key'), true /* tip */);
                }
            }
        }
        el.key = exp;
    }
}
function processRef(el) {
    var ref = getBindingAttr(el, 'ref');
    if (ref) {
        el.ref = ref;
        el.refInFor = checkInFor(el);
    }
}
function processFor(el) {
    var exp;
    if ((exp = getAndRemoveAttr(el, 'v-for'))) {
        var res = parseFor(exp);
        if (res) {
            extend(el, res);
        }
        else if (false) {
            warn("Invalid v-for expression: ".concat(exp), el.rawAttrsMap['v-for']);
        }
    }
}
function parseFor(exp) {
    var inMatch = exp.match(forAliasRE);
    if (!inMatch)
        return;
    var res = {};
    res.for = inMatch[2].trim();
    var alias = inMatch[1].trim().replace(stripParensRE, '');
    var iteratorMatch = alias.match(forIteratorRE);
    if (iteratorMatch) {
        res.alias = alias.replace(forIteratorRE, '').trim();
        res.iterator1 = iteratorMatch[1].trim();
        if (iteratorMatch[2]) {
            res.iterator2 = iteratorMatch[2].trim();
        }
    }
    else {
        res.alias = alias;
    }
    return res;
}
function processIf(el) {
    var exp = getAndRemoveAttr(el, 'v-if');
    if (exp) {
        el.if = exp;
        addIfCondition(el, {
            exp: exp,
            block: el
        });
    }
    else {
        if (getAndRemoveAttr(el, 'v-else') != null) {
            el.else = true;
        }
        var elseif = getAndRemoveAttr(el, 'v-else-if');
        if (elseif) {
            el.elseif = elseif;
        }
    }
}
function processIfConditions(el, parent) {
    var prev = findPrevElement(parent.children);
    if (prev && prev.if) {
        addIfCondition(prev, {
            exp: el.elseif,
            block: el
        });
    }
    else if (false) {
        warn("v-".concat(el.elseif ? 'else-if="' + el.elseif + '"' : 'else', " ") +
            "used on element <".concat(el.tag, "> without corresponding v-if."), el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']);
    }
}
function findPrevElement(children) {
    var i = children.length;
    while (i--) {
        if (children[i].type === 1) {
            return children[i];
        }
        else {
            if (false) {
                warn("text \"".concat(children[i].text.trim(), "\" between v-if and v-else(-if) ") +
                    "will be ignored.", children[i]);
            }
            children.pop();
        }
    }
}
function addIfCondition(el, condition) {
    if (!el.ifConditions) {
        el.ifConditions = [];
    }
    el.ifConditions.push(condition);
}
function processOnce(el) {
    var once = getAndRemoveAttr(el, 'v-once');
    if (once != null) {
        el.once = true;
    }
}
// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent(el) {
    var slotScope;
    if (el.tag === 'template') {
        slotScope = getAndRemoveAttr(el, 'scope');
        /* istanbul ignore if */
        if (false) {
            warn("the \"scope\" attribute for scoped slots have been deprecated and " +
                "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
                "can also be used on plain elements in addition to <template> to " +
                "denote scoped slots.", el.rawAttrsMap['scope'], true);
        }
        el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    }
    else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
        /* istanbul ignore if */
        if (false) {
            warn("Ambiguous combined usage of slot-scope and v-for on <".concat(el.tag, "> ") +
                "(v-for takes higher priority). Use a wrapper <template> for the " +
                "scoped slot to make it clearer.", el.rawAttrsMap['slot-scope'], true);
        }
        el.slotScope = slotScope;
    }
    // slot="xxx"
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
        el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
        el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
        // preserve slot as an attribute for native shadow DOM compat
        // only for non-scoped slots.
        if (el.tag !== 'template' && !el.slotScope) {
            addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
        }
    }
    // 2.6 v-slot syntax
    {
        if (el.tag === 'template') {
            // v-slot on <template>
            var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
            if (slotBinding) {
                if (false) {
                    if (el.slotTarget || el.slotScope) {
                        warn("Unexpected mixed usage of different slot syntaxes.", el);
                    }
                    if (el.parent && !maybeComponent(el.parent)) {
                        warn("<template v-slot> can only appear at the root level inside " +
                            "the receiving component", el);
                    }
                }
                var _a = getSlotName(slotBinding), name_2 = _a.name, dynamic = _a.dynamic;
                el.slotTarget = name_2;
                el.slotTargetDynamic = dynamic;
                el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
            }
        }
        else {
            // v-slot on component, denotes default slot
            var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
            if (slotBinding) {
                if (false) {
                    if (!maybeComponent(el)) {
                        warn("v-slot can only be used on components or <template>.", slotBinding);
                    }
                    if (el.slotScope || el.slotTarget) {
                        warn("Unexpected mixed usage of different slot syntaxes.", el);
                    }
                    if (el.scopedSlots) {
                        warn("To avoid scope ambiguity, the default slot should also use " +
                            "<template> syntax when there are other named slots.", slotBinding);
                    }
                }
                // add the component's children to its default slot
                var slots = el.scopedSlots || (el.scopedSlots = {});
                var _b = getSlotName(slotBinding), name_3 = _b.name, dynamic = _b.dynamic;
                var slotContainer_1 = (slots[name_3] = createASTElement('template', [], el));
                slotContainer_1.slotTarget = name_3;
                slotContainer_1.slotTargetDynamic = dynamic;
                slotContainer_1.children = el.children.filter(function (c) {
                    if (!c.slotScope) {
                        c.parent = slotContainer_1;
                        return true;
                    }
                });
                slotContainer_1.slotScope = slotBinding.value || emptySlotScopeToken;
                // remove children as they are returned from scopedSlots now
                el.children = [];
                // mark el non-plain so data gets generated
                el.plain = false;
            }
        }
    }
}
function getSlotName(binding) {
    var name = binding.name.replace(slotRE, '');
    if (!name) {
        if (binding.name[0] !== '#') {
            name = 'default';
        }
        else if (false) {
            warn("v-slot shorthand syntax requires a slot name.", binding);
        }
    }
    return dynamicArgRE.test(name)
        ? // dynamic [name]
            { name: name.slice(1, -1), dynamic: true }
        : // static name
            { name: "\"".concat(name, "\""), dynamic: false };
}
// handle <slot/> outlets
function processSlotOutlet(el) {
    if (el.tag === 'slot') {
        el.slotName = getBindingAttr(el, 'name');
        if (false) {
            warn("`key` does not work on <slot> because slots are abstract outlets " +
                "and can possibly expand into multiple elements. " +
                "Use the key on a wrapping element instead.", getRawBindingAttr(el, 'key'));
        }
    }
}
function processComponent(el) {
    var binding;
    if ((binding = getBindingAttr(el, 'is'))) {
        el.component = binding;
    }
    if (getAndRemoveAttr(el, 'inline-template') != null) {
        el.inlineTemplate = true;
    }
}
function processAttrs(el) {
    var list = el.attrsList;
    var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
    for (i = 0, l = list.length; i < l; i++) {
        name = rawName = list[i].name;
        value = list[i].value;
        if (dirRE.test(name)) {
            // mark element as dynamic
            el.hasBindings = true;
            // modifiers
            modifiers = parseModifiers(name.replace(dirRE, ''));
            // support .foo shorthand syntax for the .prop modifier
            if (modifiers) {
                name = name.replace(modifierRE, '');
            }
            if (bindRE.test(name)) {
                // v-bind
                name = name.replace(bindRE, '');
                value = parseFilters(value);
                isDynamic = dynamicArgRE.test(name);
                if (isDynamic) {
                    name = name.slice(1, -1);
                }
                if (false) {
                    warn("The value for a v-bind expression cannot be empty. Found in \"v-bind:".concat(name, "\""));
                }
                if (modifiers) {
                    if (modifiers.prop && !isDynamic) {
                        name = camelize(name);
                        if (name === 'innerHtml')
                            name = 'innerHTML';
                    }
                    if (modifiers.camel && !isDynamic) {
                        name = camelize(name);
                    }
                    if (modifiers.sync) {
                        syncGen = genAssignmentCode(value, "$event");
                        if (!isDynamic) {
                            addHandler(el, "update:".concat(camelize(name)), syncGen, null, false, warn, list[i]);
                            if (hyphenate(name) !== camelize(name)) {
                                addHandler(el, "update:".concat(hyphenate(name)), syncGen, null, false, warn, list[i]);
                            }
                        }
                        else {
                            // handler w/ dynamic event name
                            addHandler(el, "\"update:\"+(".concat(name, ")"), syncGen, null, false, warn, list[i], true // dynamic
                            );
                        }
                    }
                }
                if ((modifiers && modifiers.prop) ||
                    (!el.component && platformMustUseProp(el.tag, el.attrsMap.type, name))) {
                    addProp(el, name, value, list[i], isDynamic);
                }
                else {
                    addAttr(el, name, value, list[i], isDynamic);
                }
            }
            else if (onRE.test(name)) {
                // v-on
                name = name.replace(onRE, '');
                isDynamic = dynamicArgRE.test(name);
                if (isDynamic) {
                    name = name.slice(1, -1);
                }
                addHandler(el, name, value, modifiers, false, warn, list[i], isDynamic);
            }
            else {
                // normal directives
                name = name.replace(dirRE, '');
                // parse arg
                var argMatch = name.match(argRE);
                var arg = argMatch && argMatch[1];
                isDynamic = false;
                if (arg) {
                    name = name.slice(0, -(arg.length + 1));
                    if (dynamicArgRE.test(arg)) {
                        arg = arg.slice(1, -1);
                        isDynamic = true;
                    }
                }
                addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
                if (false) {
                    checkForAliasModel(el, value);
                }
            }
        }
        else {
            // literal attribute
            if (false) {
                var res = parseText(value, delimiters);
                if (res) {
                    warn("".concat(name, "=\"").concat(value, "\": ") +
                        'Interpolation inside attributes has been removed. ' +
                        'Use v-bind or the colon shorthand instead. For example, ' +
                        'instead of <div id="{{ val }}">, use <div :id="val">.', list[i]);
                }
            }
            addAttr(el, name, JSON.stringify(value), list[i]);
            // #6887 firefox doesn't update muted state if set via attribute
            // even immediately after element creation
            if (!el.component &&
                name === 'muted' &&
                platformMustUseProp(el.tag, el.attrsMap.type, name)) {
                addProp(el, name, 'true', list[i]);
            }
        }
    }
}
function checkInFor(el) {
    var parent = el;
    while (parent) {
        if (parent.for !== undefined) {
            return true;
        }
        parent = parent.parent;
    }
    return false;
}
function parseModifiers(name) {
    var match = name.match(modifierRE);
    if (match) {
        var ret_1 = {};
        match.forEach(function (m) {
            ret_1[m.slice(1)] = true;
        });
        return ret_1;
    }
}
function makeAttrsMap(attrs) {
    var map = {};
    for (var i = 0, l = attrs.length; i < l; i++) {
        if (false) {
            warn('duplicate attribute: ' + attrs[i].name, attrs[i]);
        }
        map[attrs[i].name] = attrs[i].value;
    }
    return map;
}
// for script (e.g. type="x/template") or style, do not decode content
function isTextTag(el) {
    return el.tag === 'script' || el.tag === 'style';
}
function isForbiddenTag(el) {
    return (el.tag === 'style' ||
        (el.tag === 'script' &&
            (!el.attrsMap.type || el.attrsMap.type === 'text/javascript')));
}
var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;
/* istanbul ignore next */
function guardIESVGBug(attrs) {
    var res = [];
    for (var i = 0; i < attrs.length; i++) {
        var attr = attrs[i];
        if (!ieNSBug.test(attr.name)) {
            attr.name = attr.name.replace(ieNSPrefix, '');
            res.push(attr);
        }
    }
    return res;
}
function checkForAliasModel(el, value) {
    var _el = el;
    while (_el) {
        if (_el.for && _el.alias === value) {
            warn("<".concat(el.tag, " v-model=\"").concat(value, "\">: ") +
                "You are binding v-model directly to a v-for iteration alias. " +
                "This will not be able to modify the v-for source array because " +
                "writing to the alias is like modifying a function local variable. " +
                "Consider using an array of objects and use v-model on an object property instead.", el.rawAttrsMap['v-model']);
        }
        _el = _el.parent;
    }
}

/**
 * Expand input[v-model] with dynamic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */
function preTransformNode(el, options) {
    if (el.tag === 'input') {
        var map = el.attrsMap;
        if (!map['v-model']) {
            return;
        }
        var typeBinding = void 0;
        if (map[':type'] || map['v-bind:type']) {
            typeBinding = getBindingAttr(el, 'type');
        }
        if (!map.type && !typeBinding && map['v-bind']) {
            typeBinding = "(".concat(map['v-bind'], ").type");
        }
        if (typeBinding) {
            var ifCondition = getAndRemoveAttr(el, 'v-if', true);
            var ifConditionExtra = ifCondition ? "&&(".concat(ifCondition, ")") : "";
            var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
            var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
            // 1. checkbox
            var branch0 = cloneASTElement(el);
            // process for on the main node
            processFor(branch0);
            addRawAttr(branch0, 'type', 'checkbox');
            processElement(branch0, options);
            branch0.processed = true; // prevent it from double-processed
            branch0.if = "(".concat(typeBinding, ")==='checkbox'") + ifConditionExtra;
            addIfCondition(branch0, {
                exp: branch0.if,
                block: branch0
            });
            // 2. add radio else-if condition
            var branch1 = cloneASTElement(el);
            getAndRemoveAttr(branch1, 'v-for', true);
            addRawAttr(branch1, 'type', 'radio');
            processElement(branch1, options);
            addIfCondition(branch0, {
                exp: "(".concat(typeBinding, ")==='radio'") + ifConditionExtra,
                block: branch1
            });
            // 3. other
            var branch2 = cloneASTElement(el);
            getAndRemoveAttr(branch2, 'v-for', true);
            addRawAttr(branch2, ':type', typeBinding);
            processElement(branch2, options);
            addIfCondition(branch0, {
                exp: ifCondition,
                block: branch2
            });
            if (hasElse) {
                branch0.else = true;
            }
            else if (elseIfCondition) {
                branch0.elseif = elseIfCondition;
            }
            return branch0;
        }
    }
}
function cloneASTElement(el) {
    return createASTElement(el.tag, el.attrsList.slice(), el.parent);
}
var model = {
    preTransformNode: preTransformNode
};

var modules = [klass, style, model];

function text(el, dir) {
    if (dir.value) {
        addProp(el, 'textContent', "_s(".concat(dir.value, ")"), dir);
    }
}

function html(el, dir) {
    if (dir.value) {
        addProp(el, 'innerHTML', "_s(".concat(dir.value, ")"), dir);
    }
}

var directives = {
    model: model$1,
    text: text,
    html: html
};

var baseOptions = {
    expectHTML: true,
    modules: modules,
    directives: directives,
    isPreTag: isPreTag,
    isUnaryTag: isUnaryTag,
    mustUseProp: mustUseProp,
    canBeLeftOpenTag: canBeLeftOpenTag,
    isReservedTag: isReservedTag,
    getTagNamespace: getTagNamespace,
    staticKeys: genStaticKeys$1(modules)
};

var isStaticKey;
var isPlatformReservedTag;
var genStaticKeysCached = cached(genStaticKeys);
/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize(root, options) {
    if (!root)
        return;
    isStaticKey = genStaticKeysCached(options.staticKeys || '');
    isPlatformReservedTag = options.isReservedTag || no;
    // first pass: mark all non-static nodes.
    markStatic(root);
    // second pass: mark static roots.
    markStaticRoots(root, false);
}
function genStaticKeys(keys) {
    return makeMap('type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
        (keys ? ',' + keys : ''));
}
function markStatic(node) {
    node.static = isStatic(node);
    if (node.type === 1) {
        // do not make component slot content static. this avoids
        // 1. components not able to mutate slot nodes
        // 2. static slot content fails for hot-reloading
        if (!isPlatformReservedTag(node.tag) &&
            node.tag !== 'slot' &&
            node.attrsMap['inline-template'] == null) {
            return;
        }
        for (var i = 0, l = node.children.length; i < l; i++) {
            var child = node.children[i];
            markStatic(child);
            if (!child.static) {
                node.static = false;
            }
        }
        if (node.ifConditions) {
            for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                var block = node.ifConditions[i].block;
                markStatic(block);
                if (!block.static) {
                    node.static = false;
                }
            }
        }
    }
}
function markStaticRoots(node, isInFor) {
    if (node.type === 1) {
        if (node.static || node.once) {
            node.staticInFor = isInFor;
        }
        // For a node to qualify as a static root, it should have children that
        // are not just static text. Otherwise the cost of hoisting out will
        // outweigh the benefits and it's better off to just always render it fresh.
        if (node.static &&
            node.children.length &&
            !(node.children.length === 1 && node.children[0].type === 3)) {
            node.staticRoot = true;
            return;
        }
        else {
            node.staticRoot = false;
        }
        if (node.children) {
            for (var i = 0, l = node.children.length; i < l; i++) {
                markStaticRoots(node.children[i], isInFor || !!node.for);
            }
        }
        if (node.ifConditions) {
            for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                markStaticRoots(node.ifConditions[i].block, isInFor);
            }
        }
    }
}
function isStatic(node) {
    if (node.type === 2) {
        // expression
        return false;
    }
    if (node.type === 3) {
        // text
        return true;
    }
    return !!(node.pre ||
        (!node.hasBindings && // no dynamic bindings
            !node.if &&
            !node.for && // not v-if or v-for or v-else
            !isBuiltInTag(node.tag) && // not a built-in
            isPlatformReservedTag(node.tag) && // not a component
            !isDirectChildOfTemplateFor(node) &&
            Object.keys(node).every(isStaticKey)));
}
function isDirectChildOfTemplateFor(node) {
    while (node.parent) {
        node = node.parent;
        if (node.tag !== 'template') {
            return false;
        }
        if (node.for) {
            return true;
        }
    }
    return false;
}

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
// KeyboardEvent.keyCode aliases
var keyCodes = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    delete: [8, 46]
};
// KeyboardEvent.key aliases
var keyNames = {
    // #7880: IE11 and Edge use `Esc` for Escape key name.
    esc: ['Esc', 'Escape'],
    tab: 'Tab',
    enter: 'Enter',
    // #9112: IE11 uses `Spacebar` for Space key name.
    space: [' ', 'Spacebar'],
    // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
    up: ['Up', 'ArrowUp'],
    left: ['Left', 'ArrowLeft'],
    right: ['Right', 'ArrowRight'],
    down: ['Down', 'ArrowDown'],
    // #9112: IE11 uses `Del` for Delete key name.
    delete: ['Backspace', 'Delete', 'Del']
};
// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return "if(".concat(condition, ")return null;"); };
var modifierCode = {
    stop: '$event.stopPropagation();',
    prevent: '$event.preventDefault();',
    self: genGuard("$event.target !== $event.currentTarget"),
    ctrl: genGuard("!$event.ctrlKey"),
    shift: genGuard("!$event.shiftKey"),
    alt: genGuard("!$event.altKey"),
    meta: genGuard("!$event.metaKey"),
    left: genGuard("'button' in $event && $event.button !== 0"),
    middle: genGuard("'button' in $event && $event.button !== 1"),
    right: genGuard("'button' in $event && $event.button !== 2")
};
function genHandlers(events, isNative) {
    var prefix = isNative ? 'nativeOn:' : 'on:';
    var staticHandlers = "";
    var dynamicHandlers = "";
    for (var name_1 in events) {
        var handlerCode = genHandler(events[name_1]);
        //@ts-expect-error
        if (events[name_1] && events[name_1].dynamic) {
            dynamicHandlers += "".concat(name_1, ",").concat(handlerCode, ",");
        }
        else {
            staticHandlers += "\"".concat(name_1, "\":").concat(handlerCode, ",");
        }
    }
    staticHandlers = "{".concat(staticHandlers.slice(0, -1), "}");
    if (dynamicHandlers) {
        return prefix + "_d(".concat(staticHandlers, ",[").concat(dynamicHandlers.slice(0, -1), "])");
    }
    else {
        return prefix + staticHandlers;
    }
}
function genHandler(handler) {
    if (!handler) {
        return 'function(){}';
    }
    if (Array.isArray(handler)) {
        return "[".concat(handler.map(function (handler) { return genHandler(handler); }).join(','), "]");
    }
    var isMethodPath = simplePathRE.test(handler.value);
    var isFunctionExpression = fnExpRE.test(handler.value);
    var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));
    if (!handler.modifiers) {
        if (isMethodPath || isFunctionExpression) {
            return handler.value;
        }
        return "function($event){".concat(isFunctionInvocation ? "return ".concat(handler.value) : handler.value, "}"); // inline statement
    }
    else {
        var code = '';
        var genModifierCode = '';
        var keys = [];
        var _loop_1 = function (key) {
            if (modifierCode[key]) {
                genModifierCode += modifierCode[key];
                // left/right
                if (keyCodes[key]) {
                    keys.push(key);
                }
            }
            else if (key === 'exact') {
                var modifiers_1 = handler.modifiers;
                genModifierCode += genGuard(['ctrl', 'shift', 'alt', 'meta']
                    .filter(function (keyModifier) { return !modifiers_1[keyModifier]; })
                    .map(function (keyModifier) { return "$event.".concat(keyModifier, "Key"); })
                    .join('||'));
            }
            else {
                keys.push(key);
            }
        };
        for (var key in handler.modifiers) {
            _loop_1(key);
        }
        if (keys.length) {
            code += genKeyFilter(keys);
        }
        // Make sure modifiers like prevent and stop get executed after key filtering
        if (genModifierCode) {
            code += genModifierCode;
        }
        var handlerCode = isMethodPath
            ? "return ".concat(handler.value, ".apply(null, arguments)")
            : isFunctionExpression
                ? "return (".concat(handler.value, ").apply(null, arguments)")
                : isFunctionInvocation
                    ? "return ".concat(handler.value)
                    : handler.value;
        return "function($event){".concat(code).concat(handlerCode, "}");
    }
}
function genKeyFilter(keys) {
    return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
        "".concat(keys.map(genFilterCode).join('&&'), ")return null;"));
}
function genFilterCode(key) {
    var keyVal = parseInt(key, 10);
    if (keyVal) {
        return "$event.keyCode!==".concat(keyVal);
    }
    var keyCode = keyCodes[key];
    var keyName = keyNames[key];
    return ("_k($event.keyCode," +
        "".concat(JSON.stringify(key), ",") +
        "".concat(JSON.stringify(keyCode), ",") +
        "$event.key," +
        "".concat(JSON.stringify(keyName)) +
        ")");
}

function on(el, dir) {
    if (false) {
        warn$2("v-on without argument does not support modifiers.");
    }
    el.wrapListeners = function (code) { return "_g(".concat(code, ",").concat(dir.value, ")"); };
}

function bind(el, dir) {
    el.wrapData = function (code) {
        return "_b(".concat(code, ",'").concat(el.tag, "',").concat(dir.value, ",").concat(dir.modifiers && dir.modifiers.prop ? 'true' : 'false').concat(dir.modifiers && dir.modifiers.sync ? ',true' : '', ")");
    };
}

var baseDirectives = {
    on: on,
    bind: bind,
    cloak: noop
};

var CodegenState = /** @class */ (function () {
    function CodegenState(options) {
        this.options = options;
        this.warn = options.warn || baseWarn;
        this.transforms = pluckModuleFunction(options.modules, 'transformCode');
        this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
        this.directives = extend(extend({}, baseDirectives), options.directives);
        var isReservedTag = options.isReservedTag || no;
        this.maybeComponent = function (el) {
            return !!el.component || !isReservedTag(el.tag);
        };
        this.onceId = 0;
        this.staticRenderFns = [];
        this.pre = false;
    }
    return CodegenState;
}());
function generate(ast, options) {
    var state = new CodegenState(options);
    // fix #11483, Root level <script> tags should not be rendered.
    var code = ast
        ? ast.tag === 'script'
            ? 'null'
            : genElement(ast, state)
        : '_c("div")';
    return {
        render: "with(this){return ".concat(code, "}"),
        staticRenderFns: state.staticRenderFns
    };
}
function genElement(el, state) {
    if (el.parent) {
        el.pre = el.pre || el.parent.pre;
    }
    if (el.staticRoot && !el.staticProcessed) {
        return genStatic(el, state);
    }
    else if (el.once && !el.onceProcessed) {
        return genOnce(el, state);
    }
    else if (el.for && !el.forProcessed) {
        return genFor(el, state);
    }
    else if (el.if && !el.ifProcessed) {
        return genIf(el, state);
    }
    else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
        return genChildren(el, state) || 'void 0';
    }
    else if (el.tag === 'slot') {
        return genSlot(el, state);
    }
    else {
        // component or element
        var code = void 0;
        if (el.component) {
            code = genComponent(el.component, el, state);
        }
        else {
            var data = void 0;
            var maybeComponent = state.maybeComponent(el);
            if (!el.plain || (el.pre && maybeComponent)) {
                data = genData(el, state);
            }
            var tag 
            // check if this is a component in <script setup>
            = void 0;
            // check if this is a component in <script setup>
            var bindings = state.options.bindings;
            if (maybeComponent && bindings && bindings.__isScriptSetup !== false) {
                tag = checkBindingType(bindings, el.tag);
            }
            if (!tag)
                tag = "'".concat(el.tag, "'");
            var children = el.inlineTemplate ? null : genChildren(el, state, true);
            code = "_c(".concat(tag).concat(data ? ",".concat(data) : '' // data
            ).concat(children ? ",".concat(children) : '' // children
            , ")");
        }
        // module transforms
        for (var i = 0; i < state.transforms.length; i++) {
            code = state.transforms[i](el, code);
        }
        return code;
    }
}
function checkBindingType(bindings, key) {
    var camelName = camelize(key);
    var PascalName = capitalize(camelName);
    var checkType = function (type) {
        if (bindings[key] === type) {
            return key;
        }
        if (bindings[camelName] === type) {
            return camelName;
        }
        if (bindings[PascalName] === type) {
            return PascalName;
        }
    };
    var fromConst = checkType("setup-const" /* BindingTypes.SETUP_CONST */) ||
        checkType("setup-reactive-const" /* BindingTypes.SETUP_REACTIVE_CONST */);
    if (fromConst) {
        return fromConst;
    }
    var fromMaybeRef = checkType("setup-let" /* BindingTypes.SETUP_LET */) ||
        checkType("setup-ref" /* BindingTypes.SETUP_REF */) ||
        checkType("setup-maybe-ref" /* BindingTypes.SETUP_MAYBE_REF */);
    if (fromMaybeRef) {
        return fromMaybeRef;
    }
}
// hoist static sub-trees out
function genStatic(el, state) {
    el.staticProcessed = true;
    // Some elements (templates) need to behave differently inside of a v-pre
    // node.  All pre nodes are static roots, so we can use this as a location to
    // wrap a state change and reset it upon exiting the pre node.
    var originalPreState = state.pre;
    if (el.pre) {
        state.pre = el.pre;
    }
    state.staticRenderFns.push("with(this){return ".concat(genElement(el, state), "}"));
    state.pre = originalPreState;
    return "_m(".concat(state.staticRenderFns.length - 1).concat(el.staticInFor ? ',true' : '', ")");
}
// v-once
function genOnce(el, state) {
    el.onceProcessed = true;
    if (el.if && !el.ifProcessed) {
        return genIf(el, state);
    }
    else if (el.staticInFor) {
        var key = '';
        var parent_1 = el.parent;
        while (parent_1) {
            if (parent_1.for) {
                key = parent_1.key;
                break;
            }
            parent_1 = parent_1.parent;
        }
        if (!key) {
            "production" !== 'production' &&
                state.warn("v-once can only be used inside v-for that is keyed. ", el.rawAttrsMap['v-once']);
            return genElement(el, state);
        }
        return "_o(".concat(genElement(el, state), ",").concat(state.onceId++, ",").concat(key, ")");
    }
    else {
        return genStatic(el, state);
    }
}
function genIf(el, state, altGen, altEmpty) {
    el.ifProcessed = true; // avoid recursion
    return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty);
}
function genIfConditions(conditions, state, altGen, altEmpty) {
    if (!conditions.length) {
        return altEmpty || '_e()';
    }
    var condition = conditions.shift();
    if (condition.exp) {
        return "(".concat(condition.exp, ")?").concat(genTernaryExp(condition.block), ":").concat(genIfConditions(conditions, state, altGen, altEmpty));
    }
    else {
        return "".concat(genTernaryExp(condition.block));
    }
    // v-if with v-once should generate code like (a)?_m(0):_m(1)
    function genTernaryExp(el) {
        return altGen
            ? altGen(el, state)
            : el.once
                ? genOnce(el, state)
                : genElement(el, state);
    }
}
function genFor(el, state, altGen, altHelper) {
    var exp = el.for;
    var alias = el.alias;
    var iterator1 = el.iterator1 ? ",".concat(el.iterator1) : '';
    var iterator2 = el.iterator2 ? ",".concat(el.iterator2) : '';
    if (false) {
        state.warn("<".concat(el.tag, " v-for=\"").concat(alias, " in ").concat(exp, "\">: component lists rendered with ") +
            "v-for should have explicit keys. " +
            "See https://v2.vuejs.org/v2/guide/list.html#key for more info.", el.rawAttrsMap['v-for'], true /* tip */);
    }
    el.forProcessed = true; // avoid recursion
    return ("".concat(altHelper || '_l', "((").concat(exp, "),") +
        "function(".concat(alias).concat(iterator1).concat(iterator2, "){") +
        "return ".concat((altGen || genElement)(el, state)) +
        '})');
}
function genData(el, state) {
    var data = '{';
    // directives first.
    // directives may mutate the el's other properties before they are generated.
    var dirs = genDirectives(el, state);
    if (dirs)
        data += dirs + ',';
    // key
    if (el.key) {
        data += "key:".concat(el.key, ",");
    }
    // ref
    if (el.ref) {
        data += "ref:".concat(el.ref, ",");
    }
    if (el.refInFor) {
        data += "refInFor:true,";
    }
    // pre
    if (el.pre) {
        data += "pre:true,";
    }
    // record original tag name for components using "is" attribute
    if (el.component) {
        data += "tag:\"".concat(el.tag, "\",");
    }
    // module data generation functions
    for (var i = 0; i < state.dataGenFns.length; i++) {
        data += state.dataGenFns[i](el);
    }
    // attributes
    if (el.attrs) {
        data += "attrs:".concat(genProps(el.attrs), ",");
    }
    // DOM props
    if (el.props) {
        data += "domProps:".concat(genProps(el.props), ",");
    }
    // event handlers
    if (el.events) {
        data += "".concat(genHandlers(el.events, false), ",");
    }
    if (el.nativeEvents) {
        data += "".concat(genHandlers(el.nativeEvents, true), ",");
    }
    // slot target
    // only for non-scoped slots
    if (el.slotTarget && !el.slotScope) {
        data += "slot:".concat(el.slotTarget, ",");
    }
    // scoped slots
    if (el.scopedSlots) {
        data += "".concat(genScopedSlots(el, el.scopedSlots, state), ",");
    }
    // component v-model
    if (el.model) {
        data += "model:{value:".concat(el.model.value, ",callback:").concat(el.model.callback, ",expression:").concat(el.model.expression, "},");
    }
    // inline-template
    if (el.inlineTemplate) {
        var inlineTemplate = genInlineTemplate(el, state);
        if (inlineTemplate) {
            data += "".concat(inlineTemplate, ",");
        }
    }
    data = data.replace(/,$/, '') + '}';
    // v-bind dynamic argument wrap
    // v-bind with dynamic arguments must be applied using the same v-bind object
    // merge helper so that class/style/mustUseProp attrs are handled correctly.
    if (el.dynamicAttrs) {
        data = "_b(".concat(data, ",\"").concat(el.tag, "\",").concat(genProps(el.dynamicAttrs), ")");
    }
    // v-bind data wrap
    if (el.wrapData) {
        data = el.wrapData(data);
    }
    // v-on data wrap
    if (el.wrapListeners) {
        data = el.wrapListeners(data);
    }
    return data;
}
function genDirectives(el, state) {
    var dirs = el.directives;
    if (!dirs)
        return;
    var res = 'directives:[';
    var hasRuntime = false;
    var i, l, dir, needRuntime;
    for (i = 0, l = dirs.length; i < l; i++) {
        dir = dirs[i];
        needRuntime = true;
        var gen = state.directives[dir.name];
        if (gen) {
            // compile-time directive that manipulates AST.
            // returns true if it also needs a runtime counterpart.
            needRuntime = !!gen(el, dir, state.warn);
        }
        if (needRuntime) {
            hasRuntime = true;
            res += "{name:\"".concat(dir.name, "\",rawName:\"").concat(dir.rawName, "\"").concat(dir.value
                ? ",value:(".concat(dir.value, "),expression:").concat(JSON.stringify(dir.value))
                : '').concat(dir.arg ? ",arg:".concat(dir.isDynamicArg ? dir.arg : "\"".concat(dir.arg, "\"")) : '').concat(dir.modifiers ? ",modifiers:".concat(JSON.stringify(dir.modifiers)) : '', "},");
        }
    }
    if (hasRuntime) {
        return res.slice(0, -1) + ']';
    }
}
function genInlineTemplate(el, state) {
    var ast = el.children[0];
    if (false) {
        state.warn('Inline-template components must have exactly one child element.', { start: el.start });
    }
    if (ast && ast.type === 1) {
        var inlineRenderFns = generate(ast, state.options);
        return "inlineTemplate:{render:function(){".concat(inlineRenderFns.render, "},staticRenderFns:[").concat(inlineRenderFns.staticRenderFns
            .map(function (code) { return "function(){".concat(code, "}"); })
            .join(','), "]}");
    }
}
function genScopedSlots(el, slots, state) {
    // by default scoped slots are considered "stable", this allows child
    // components with only scoped slots to skip forced updates from parent.
    // but in some cases we have to bail-out of this optimization
    // for example if the slot contains dynamic names, has v-if or v-for on them...
    var needsForceUpdate = el.for ||
        Object.keys(slots).some(function (key) {
            var slot = slots[key];
            return (slot.slotTargetDynamic || slot.if || slot.for || containsSlotChild(slot) // is passing down slot from parent which may be dynamic
            );
        });
    // #9534: if a component with scoped slots is inside a conditional branch,
    // it's possible for the same component to be reused but with different
    // compiled slot content. To avoid that, we generate a unique key based on
    // the generated code of all the slot contents.
    var needsKey = !!el.if;
    // OR when it is inside another scoped slot or v-for (the reactivity may be
    // disconnected due to the intermediate scope variable)
    // #9438, #9506
    // TODO: this can be further optimized by properly analyzing in-scope bindings
    // and skip force updating ones that do not actually use scope variables.
    if (!needsForceUpdate) {
        var parent_2 = el.parent;
        while (parent_2) {
            if ((parent_2.slotScope && parent_2.slotScope !== emptySlotScopeToken) ||
                parent_2.for) {
                needsForceUpdate = true;
                break;
            }
            if (parent_2.if) {
                needsKey = true;
            }
            parent_2 = parent_2.parent;
        }
    }
    var generatedSlots = Object.keys(slots)
        .map(function (key) { return genScopedSlot(slots[key], state); })
        .join(',');
    return "scopedSlots:_u([".concat(generatedSlots, "]").concat(needsForceUpdate ? ",null,true" : "").concat(!needsForceUpdate && needsKey ? ",null,false,".concat(hash(generatedSlots)) : "", ")");
}
function hash(str) {
    var hash = 5381;
    var i = str.length;
    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    return hash >>> 0;
}
function containsSlotChild(el) {
    if (el.type === 1) {
        if (el.tag === 'slot') {
            return true;
        }
        return el.children.some(containsSlotChild);
    }
    return false;
}
function genScopedSlot(el, state) {
    var isLegacySyntax = el.attrsMap['slot-scope'];
    if (el.if && !el.ifProcessed && !isLegacySyntax) {
        return genIf(el, state, genScopedSlot, "null");
    }
    if (el.for && !el.forProcessed) {
        return genFor(el, state, genScopedSlot);
    }
    var slotScope = el.slotScope === emptySlotScopeToken ? "" : String(el.slotScope);
    var fn = "function(".concat(slotScope, "){") +
        "return ".concat(el.tag === 'template'
            ? el.if && isLegacySyntax
                ? "(".concat(el.if, ")?").concat(genChildren(el, state) || 'undefined', ":undefined")
                : genChildren(el, state) || 'undefined'
            : genElement(el, state), "}");
    // reverse proxy v-slot without scope on this.$slots
    var reverseProxy = slotScope ? "" : ",proxy:true";
    return "{key:".concat(el.slotTarget || "\"default\"", ",fn:").concat(fn).concat(reverseProxy, "}");
}
function genChildren(el, state, checkSkip, altGenElement, altGenNode) {
    var children = el.children;
    if (children.length) {
        var el_1 = children[0];
        // optimize single v-for
        if (children.length === 1 &&
            el_1.for &&
            el_1.tag !== 'template' &&
            el_1.tag !== 'slot') {
            var normalizationType_1 = checkSkip
                ? state.maybeComponent(el_1)
                    ? ",1"
                    : ",0"
                : "";
            return "".concat((altGenElement || genElement)(el_1, state)).concat(normalizationType_1);
        }
        var normalizationType = checkSkip
            ? getNormalizationType(children, state.maybeComponent)
            : 0;
        var gen_1 = altGenNode || genNode;
        return "[".concat(children.map(function (c) { return gen_1(c, state); }).join(','), "]").concat(normalizationType ? ",".concat(normalizationType) : '');
    }
}
// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType(children, maybeComponent) {
    var res = 0;
    for (var i = 0; i < children.length; i++) {
        var el = children[i];
        if (el.type !== 1) {
            continue;
        }
        if (needsNormalization(el) ||
            (el.ifConditions &&
                el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
            res = 2;
            break;
        }
        if (maybeComponent(el) ||
            (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
            res = 1;
        }
    }
    return res;
}
function needsNormalization(el) {
    return el.for !== undefined || el.tag === 'template' || el.tag === 'slot';
}
function genNode(node, state) {
    if (node.type === 1) {
        return genElement(node, state);
    }
    else if (node.type === 3 && node.isComment) {
        return genComment(node);
    }
    else {
        return genText(node);
    }
}
function genText(text) {
    return "_v(".concat(text.type === 2
        ? text.expression // no need for () because already wrapped in _s()
        : transformSpecialNewlines(JSON.stringify(text.text)), ")");
}
function genComment(comment) {
    return "_e(".concat(JSON.stringify(comment.text), ")");
}
function genSlot(el, state) {
    var slotName = el.slotName || '"default"';
    var children = genChildren(el, state);
    var res = "_t(".concat(slotName).concat(children ? ",function(){return ".concat(children, "}") : '');
    var attrs = el.attrs || el.dynamicAttrs
        ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
            // slot props are camelized
            name: camelize(attr.name),
            value: attr.value,
            dynamic: attr.dynamic
        }); }))
        : null;
    var bind = el.attrsMap['v-bind'];
    if ((attrs || bind) && !children) {
        res += ",null";
    }
    if (attrs) {
        res += ",".concat(attrs);
    }
    if (bind) {
        res += "".concat(attrs ? '' : ',null', ",").concat(bind);
    }
    return res + ')';
}
// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent(componentName, el, state) {
    var children = el.inlineTemplate ? null : genChildren(el, state, true);
    return "_c(".concat(componentName, ",").concat(genData(el, state)).concat(children ? ",".concat(children) : '', ")");
}
function genProps(props) {
    var staticProps = "";
    var dynamicProps = "";
    for (var i = 0; i < props.length; i++) {
        var prop = props[i];
        var value = transformSpecialNewlines(prop.value);
        if (prop.dynamic) {
            dynamicProps += "".concat(prop.name, ",").concat(value, ",");
        }
        else {
            staticProps += "\"".concat(prop.name, "\":").concat(value, ",");
        }
    }
    staticProps = "{".concat(staticProps.slice(0, -1), "}");
    if (dynamicProps) {
        return "_d(".concat(staticProps, ",[").concat(dynamicProps.slice(0, -1), "])");
    }
    else {
        return staticProps;
    }
}
// #3895, #4268
function transformSpecialNewlines(text) {
    return text.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' +
    ('do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
        'super,throw,while,yield,delete,export,import,return,switch,default,' +
        'extends,finally,continue,debugger,function,arguments')
        .split(',')
        .join('\\b|\\b') +
    '\\b');
// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' +
    'delete,typeof,void'.split(',').join('\\s*\\([^\\)]*\\)|\\b') +
    '\\s*\\([^\\)]*\\)');
// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
// detect problematic expressions in a template
function detectErrors(ast, warn) {
    if (ast) {
        checkNode(ast, warn);
    }
}
function checkNode(node, warn) {
    if (node.type === 1) {
        for (var name_1 in node.attrsMap) {
            if (dirRE.test(name_1)) {
                var value = node.attrsMap[name_1];
                if (value) {
                    var range = node.rawAttrsMap[name_1];
                    if (name_1 === 'v-for') {
                        checkFor(node, "v-for=\"".concat(value, "\""), warn, range);
                    }
                    else if (name_1 === 'v-slot' || name_1[0] === '#') {
                        checkFunctionParameterExpression(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                    else if (onRE.test(name_1)) {
                        checkEvent(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                    else {
                        checkExpression(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                }
            }
        }
        if (node.children) {
            for (var i = 0; i < node.children.length; i++) {
                checkNode(node.children[i], warn);
            }
        }
    }
    else if (node.type === 2) {
        checkExpression(node.expression, node.text, warn, node);
    }
}
function checkEvent(exp, text, warn, range) {
    var stripped = exp.replace(stripStringRE, '');
    var keywordMatch = stripped.match(unaryOperatorsRE);
    if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
        warn("avoid using JavaScript unary operator as property name: " +
            "\"".concat(keywordMatch[0], "\" in expression ").concat(text.trim()), range);
    }
    checkExpression(exp, text, warn, range);
}
function checkFor(node, text, warn, range) {
    checkExpression(node.for || '', text, warn, range);
    checkIdentifier(node.alias, 'v-for alias', text, warn, range);
    checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
    checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}
function checkIdentifier(ident, type, text, warn, range) {
    if (typeof ident === 'string') {
        try {
            new Function("var ".concat(ident, "=_"));
        }
        catch (e) {
            warn("invalid ".concat(type, " \"").concat(ident, "\" in expression: ").concat(text.trim()), range);
        }
    }
}
function checkExpression(exp, text, warn, range) {
    try {
        new Function("return ".concat(exp));
    }
    catch (e) {
        var keywordMatch = exp
            .replace(stripStringRE, '')
            .match(prohibitedKeywordRE);
        if (keywordMatch) {
            warn("avoid using JavaScript keyword as property name: " +
                "\"".concat(keywordMatch[0], "\"\n  Raw expression: ").concat(text.trim()), range);
        }
        else {
            warn("invalid expression: ".concat(e.message, " in\n\n") +
                "    ".concat(exp, "\n\n") +
                "  Raw expression: ".concat(text.trim(), "\n"), range);
        }
    }
}
function checkFunctionParameterExpression(exp, text, warn, range) {
    try {
        new Function(exp, '');
    }
    catch (e) {
        warn("invalid function parameter expression: ".concat(e.message, " in\n\n") +
            "    ".concat(exp, "\n\n") +
            "  Raw expression: ".concat(text.trim(), "\n"), range);
    }
}

var range = 2;
function generateCodeFrame(source, start, end) {
    if (start === void 0) { start = 0; }
    if (end === void 0) { end = source.length; }
    var lines = source.split(/\r?\n/);
    var count = 0;
    var res = [];
    for (var i = 0; i < lines.length; i++) {
        count += lines[i].length + 1;
        if (count >= start) {
            for (var j = i - range; j <= i + range || end > count; j++) {
                if (j < 0 || j >= lines.length)
                    continue;
                res.push("".concat(j + 1).concat(repeat(" ", 3 - String(j + 1).length), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    var pad = start - (count - lineLength) + 1;
                    var length_1 = end > count ? lineLength - pad : end - start;
                    res.push("   |  " + repeat(" ", pad) + repeat("^", length_1));
                }
                else if (j > i) {
                    if (end > count) {
                        var length_2 = Math.min(end - count, lineLength);
                        res.push("   |  " + repeat("^", length_2));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join('\n');
}
function repeat(str, n) {
    var result = '';
    if (n > 0) {
        // eslint-disable-next-line no-constant-condition
        while (true) {
            // eslint-disable-line
            if (n & 1)
                result += str;
            n >>>= 1;
            if (n <= 0)
                break;
            str += str;
        }
    }
    return result;
}

function createFunction(code, errors) {
    try {
        return new Function(code);
    }
    catch (err) {
        errors.push({ err: err, code: code });
        return noop;
    }
}
function createCompileToFunctionFn(compile) {
    var cache = Object.create(null);
    return function compileToFunctions(template, options, vm) {
        options = extend({}, options);
        var warn = options.warn || warn$2;
        delete options.warn;
        /* istanbul ignore if */
        if (false) {
            // detect possible CSP restriction
            try {
                new Function('return 1');
            }
            catch (e) {
                if (e.toString().match(/unsafe-eval|CSP/)) {
                    warn('It seems you are using the standalone build of Vue.js in an ' +
                        'environment with Content Security Policy that prohibits unsafe-eval. ' +
                        'The template compiler cannot work in this environment. Consider ' +
                        'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
                        'templates into render functions.');
                }
            }
        }
        // check cache
        var key = options.delimiters
            ? String(options.delimiters) + template
            : template;
        if (cache[key]) {
            return cache[key];
        }
        // compile
        var compiled = compile(template, options);
        // check compilation errors/tips
        if (false) {
            if (compiled.errors && compiled.errors.length) {
                if (options.outputSourceRange) {
                    compiled.errors.forEach(function (e) {
                        warn("Error compiling template:\n\n".concat(e.msg, "\n\n") +
                            generateCodeFrame(template, e.start, e.end), vm);
                    });
                }
                else {
                    warn("Error compiling template:\n\n".concat(template, "\n\n") +
                        compiled.errors.map(function (e) { return "- ".concat(e); }).join('\n') +
                        '\n', vm);
                }
            }
            if (compiled.tips && compiled.tips.length) {
                if (options.outputSourceRange) {
                    compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
                }
                else {
                    compiled.tips.forEach(function (msg) { return tip(msg, vm); });
                }
            }
        }
        // turn code into functions
        var res = {};
        var fnGenErrors = [];
        res.render = createFunction(compiled.render, fnGenErrors);
        res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
            return createFunction(code, fnGenErrors);
        });
        // check function generation errors.
        // this should only happen if there is a bug in the compiler itself.
        // mostly for codegen development use
        /* istanbul ignore if */
        if (false) {
            if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
                warn("Failed to generate render function:\n\n" +
                    fnGenErrors
                        .map(function (_a) {
                        var err = _a.err, code = _a.code;
                        return "".concat(err.toString(), " in\n\n").concat(code, "\n");
                    })
                        .join('\n'), vm);
            }
        }
        return (cache[key] = res);
    };
}

function createCompilerCreator(baseCompile) {
    return function createCompiler(baseOptions) {
        function compile(template, options) {
            var finalOptions = Object.create(baseOptions);
            var errors = [];
            var tips = [];
            var warn = function (msg, range, tip) {
                (tip ? tips : errors).push(msg);
            };
            if (options) {
                if (false) {
                    // $flow-disable-line
                    var leadingSpaceLength_1 = template.match(/^\s*/)[0].length;
                    warn = function (msg, range, tip) {
                        var data = typeof msg === 'string' ? { msg: msg } : msg;
                        if (range) {
                            if (range.start != null) {
                                data.start = range.start + leadingSpaceLength_1;
                            }
                            if (range.end != null) {
                                data.end = range.end + leadingSpaceLength_1;
                            }
                        }
                        (tip ? tips : errors).push(data);
                    };
                }
                // merge custom modules
                if (options.modules) {
                    finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
                }
                // merge custom directives
                if (options.directives) {
                    finalOptions.directives = extend(Object.create(baseOptions.directives || null), options.directives);
                }
                // copy other options
                for (var key in options) {
                    if (key !== 'modules' && key !== 'directives') {
                        finalOptions[key] = options[key];
                    }
                }
            }
            finalOptions.warn = warn;
            var compiled = baseCompile(template.trim(), finalOptions);
            if (false) {
                detectErrors(compiled.ast, warn);
            }
            compiled.errors = errors;
            compiled.tips = tips;
            return compiled;
        }
        return {
            compile: compile,
            compileToFunctions: createCompileToFunctionFn(compile)
        };
    };
}

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile(template, options) {
    var ast = parse(template.trim(), options);
    if (options.optimize !== false) {
        optimize(ast, options);
    }
    var code = generate(ast, options);
    return {
        ast: ast,
        render: code.render,
        staticRenderFns: code.staticRenderFns
    };
});

var _a = createCompiler(baseOptions), compileToFunctions = _a.compileToFunctions;

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode(href) {
    div = div || document.createElement('div');
    div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
    return div.innerHTML.indexOf('&#10;') > 0;
}
// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser
    ? getShouldDecode(true)
    : false;

var idToTemplate = cached(function (id) {
    var el = query(id);
    return el && el.innerHTML;
});
var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (el, hydrating) {
    el = el && query(el);
    /* istanbul ignore if */
    if (el === document.body || el === document.documentElement) {
        "production" !== 'production' &&
            warn$2("Do not mount Vue to <html> or <body> - mount to normal elements instead.");
        return this;
    }
    var options = this.$options;
    // resolve template/el and convert to render function
    if (!options.render) {
        var template = options.template;
        if (template) {
            if (typeof template === 'string') {
                if (template.charAt(0) === '#') {
                    template = idToTemplate(template);
                    /* istanbul ignore if */
                    if (false) {
                        warn$2("Template element not found or is empty: ".concat(options.template), this);
                    }
                }
            }
            else if (template.nodeType) {
                template = template.innerHTML;
            }
            else {
                if (false) {
                    warn$2('invalid template option:' + template, this);
                }
                return this;
            }
        }
        else if (el) {
            // @ts-expect-error
            template = getOuterHTML(el);
        }
        if (template) {
            /* istanbul ignore if */
            if (false) {
                mark('compile');
            }
            var _a = compileToFunctions(template, {
                outputSourceRange: "production" !== 'production',
                shouldDecodeNewlines: shouldDecodeNewlines,
                shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
                delimiters: options.delimiters,
                comments: options.comments
            }, this), render = _a.render, staticRenderFns = _a.staticRenderFns;
            options.render = render;
            options.staticRenderFns = staticRenderFns;
            /* istanbul ignore if */
            if (false) {
                mark('compile end');
                measure("vue ".concat(this._name, " compile"), 'compile', 'compile end');
            }
        }
    }
    return mount.call(this, el, hydrating);
};
/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML(el) {
    if (el.outerHTML) {
        return el.outerHTML;
    }
    else {
        var container = document.createElement('div');
        container.appendChild(el.cloneNode(true));
        return container.innerHTML;
    }
}
Vue.compile = compileToFunctions;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(100), __webpack_require__(251).setImmediate))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(252);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(100)))

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(100), __webpack_require__(253)))

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(255);
__webpack_require__(262);
__webpack_require__(263);
__webpack_require__(264);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(267);
__webpack_require__(268);
__webpack_require__(269);
__webpack_require__(270);
__webpack_require__(271);
__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(274);
__webpack_require__(275);
__webpack_require__(276);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(111);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(181);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(158);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
__webpack_require__(218);
__webpack_require__(449);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(465);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(526);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(546);
__webpack_require__(549);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);

module.exports = __webpack_require__(137);


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(256);
__webpack_require__(258);
__webpack_require__(259);
__webpack_require__(181);
__webpack_require__(261);


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var call = __webpack_require__(6);
var uncurryThis = __webpack_require__(2);
var IS_PURE = __webpack_require__(20);
var DESCRIPTORS = __webpack_require__(4);
var NATIVE_SYMBOL = __webpack_require__(69);
var fails = __webpack_require__(1);
var hasOwn = __webpack_require__(12);
var isPrototypeOf = __webpack_require__(38);
var anObject = __webpack_require__(7);
var toIndexedObject = __webpack_require__(23);
var toPropertyKey = __webpack_require__(57);
var $toString = __webpack_require__(5);
var createPropertyDescriptor = __webpack_require__(37);
var nativeObjectCreate = __webpack_require__(39);
var objectKeys = __webpack_require__(85);
var getOwnPropertyNamesModule = __webpack_require__(58);
var getOwnPropertyNamesExternal = __webpack_require__(136);
var getOwnPropertySymbolsModule = __webpack_require__(106);
var getOwnPropertyDescriptorModule = __webpack_require__(26);
var definePropertyModule = __webpack_require__(17);
var definePropertiesModule = __webpack_require__(135);
var propertyIsEnumerableModule = __webpack_require__(101);
var defineBuiltIn = __webpack_require__(16);
var defineBuiltInAccessor = __webpack_require__(24);
var shared = __webpack_require__(70);
var sharedKey = __webpack_require__(104);
var hiddenKeys = __webpack_require__(82);
var uid = __webpack_require__(71);
var wellKnownSymbol = __webpack_require__(11);
var wrappedWellKnownSymbolModule = __webpack_require__(178);
var defineWellKnownSymbol = __webpack_require__(30);
var defineSymbolToPrimitive = __webpack_require__(179);
var setToStringTag = __webpack_require__(33);
var InternalStateModule = __webpack_require__(22);
var $forEach = __webpack_require__(25).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var RangeError = global.RangeError;
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var fallbackDefineProperty = function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
};

var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a !== 7;
}) ? fallbackDefineProperty : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      var $this = this === undefined ? global : this;
      if ($this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn($this, HIDDEN) && hasOwn($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
      var descriptor = createPropertyDescriptor(1, value);
      try {
        setSymbolDescriptor($this, tag, descriptor);
      } catch (error) {
        if (!(error instanceof RangeError)) throw error;
        fallbackDefineProperty($this, tag, descriptor);
      }
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(60);
var isConstructor = __webpack_require__(73);
var isObject = __webpack_require__(9);
var wellKnownSymbol = __webpack_require__(11);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var getBuiltIn = __webpack_require__(15);
var hasOwn = __webpack_require__(12);
var toString = __webpack_require__(5);
var shared = __webpack_require__(70);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(180);

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var hasOwn = __webpack_require__(12);
var isSymbol = __webpack_require__(61);
var tryToString = __webpack_require__(62);
var shared = __webpack_require__(70);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(180);

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var isArray = __webpack_require__(60);
var isCallable = __webpack_require__(10);
var classof = __webpack_require__(27);
var toString = __webpack_require__(5);

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var NATIVE_SYMBOL = __webpack_require__(69);
var fails = __webpack_require__(1);
var getOwnPropertySymbolsModule = __webpack_require__(106);
var toObject = __webpack_require__(13);

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(4);
var global = __webpack_require__(3);
var uncurryThis = __webpack_require__(2);
var hasOwn = __webpack_require__(12);
var isCallable = __webpack_require__(10);
var isPrototypeOf = __webpack_require__(38);
var toString = __webpack_require__(5);
var defineBuiltInAccessor = __webpack_require__(24);
var copyConstructorProperties = __webpack_require__(105);

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(30);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(30);

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(30);

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(30);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(30);

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(30);

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol('matchAll');


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(30);

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(30);

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(30);

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(30);

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(30);
var defineSymbolToPrimitive = __webpack_require__(179);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(15);
var defineWellKnownSymbol = __webpack_require__(30);
var setToStringTag = __webpack_require__(33);

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(30);

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var apply = __webpack_require__(40);
var wrapErrorConstructorWithCause = __webpack_require__(182);

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED = new Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var aCallable = __webpack_require__(19);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(16);
var errorToString = __webpack_require__(188);

var ErrorPrototype = Error.prototype;

// `Error.prototype.toString` method fix
// https://tc39.es/ecma262/#sec-error.prototype.tostring
if (ErrorPrototype.toString !== errorToString) {
  defineBuiltIn(ErrorPrototype, 'toString', errorToString);
}


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(280);


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var isPrototypeOf = __webpack_require__(38);
var getPrototypeOf = __webpack_require__(34);
var setPrototypeOf = __webpack_require__(45);
var copyConstructorProperties = __webpack_require__(105);
var create = __webpack_require__(39);
var createNonEnumerableProperty = __webpack_require__(28);
var createPropertyDescriptor = __webpack_require__(37);
var installErrorCause = __webpack_require__(185);
var installErrorStack = __webpack_require__(186);
var iterate = __webpack_require__(46);
var normalizeStringArgument = __webpack_require__(88);
var wellKnownSymbol = __webpack_require__(11);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Error = Error;
var push = [].push;

var $AggregateError = function AggregateError(errors, message /* , options */) {
  var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
  var that;
  if (setPrototypeOf) {
    that = setPrototypeOf(new $Error(), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
  } else {
    that = isInstance ? this : create(AggregateErrorPrototype);
    createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
  }
  if (message !== undefined) createNonEnumerableProperty(that, 'message', normalizeStringArgument(message));
  installErrorStack(that, $AggregateError, that.stack, 1);
  if (arguments.length > 2) installErrorCause(that, arguments[2]);
  var errorsArray = [];
  iterate(errors, push, { that: errorsArray });
  createNonEnumerableProperty(that, 'errors', errorsArray);
  return that;
};

if (setPrototypeOf) setPrototypeOf($AggregateError, $Error);
else copyConstructorProperties($AggregateError, $Error, { name: true });

var AggregateErrorPrototype = $AggregateError.prototype = create($Error.prototype, {
  constructor: createPropertyDescriptor(1, $AggregateError),
  message: createPropertyDescriptor(1, ''),
  name: createPropertyDescriptor(1, 'AggregateError')
});

// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$({ global: true, constructor: true, arity: 2 }, {
  AggregateError: $AggregateError
});


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var getBuiltIn = __webpack_require__(15);
var apply = __webpack_require__(40);
var fails = __webpack_require__(1);
var wrapErrorConstructorWithCause = __webpack_require__(182);

var AGGREGATE_ERROR = 'AggregateError';
var $AggregateError = getBuiltIn(AGGREGATE_ERROR);

var FORCED = !fails(function () {
  return $AggregateError([1]).errors[0] !== 1;
}) && fails(function () {
  return $AggregateError([1], AGGREGATE_ERROR, { cause: 7 }).cause !== 7;
});

// https://tc39.es/ecma262/#sec-aggregate-error
$({ global: true, constructor: true, arity: 2, forced: FORCED }, {
  AggregateError: wrapErrorConstructorWithCause(AGGREGATE_ERROR, function (init) {
    // eslint-disable-next-line no-unused-vars -- required for functions `.length`
    return function AggregateError(errors, message) { return apply(init, this, arguments); };
  }, FORCED, true)
});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var toObject = __webpack_require__(13);
var lengthOfArrayLike = __webpack_require__(14);
var toIntegerOrInfinity = __webpack_require__(21);
var addToUnscopables = __webpack_require__(31);

// `Array.prototype.at` method
// https://tc39.es/ecma262/#sec-array.prototype.at
$({ target: 'Array', proto: true }, {
  at: function at(index) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return (k < 0 || k >= len) ? undefined : O[k];
  }
});

addToUnscopables('at');


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var fails = __webpack_require__(1);
var isArray = __webpack_require__(60);
var isObject = __webpack_require__(9);
var toObject = __webpack_require__(13);
var lengthOfArrayLike = __webpack_require__(14);
var doesNotExceedSafeInteger = __webpack_require__(75);
var createProperty = __webpack_require__(53);
var arraySpeciesCreate = __webpack_require__(87);
var arrayMethodHasSpeciesSupport = __webpack_require__(91);
var wellKnownSymbol = __webpack_require__(11);
var V8_VERSION = __webpack_require__(50);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var copyWithin = __webpack_require__(190);
var addToUnscopables = __webpack_require__(31);

// `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
$({ target: 'Array', proto: true }, {
  copyWithin: copyWithin
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('copyWithin');


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $every = __webpack_require__(25).every;
var arrayMethodIsStrict = __webpack_require__(54);

var STRICT_METHOD = arrayMethodIsStrict('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var fill = __webpack_require__(141);
var addToUnscopables = __webpack_require__(31);

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $filter = __webpack_require__(25).filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(91);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $find = __webpack_require__(25).find;
var addToUnscopables = __webpack_require__(31);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $findIndex = __webpack_require__(25).findIndex;
var addToUnscopables = __webpack_require__(31);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $findLast = __webpack_require__(109).findLast;
var addToUnscopables = __webpack_require__(31);

// `Array.prototype.findLast` method
// https://tc39.es/ecma262/#sec-array.prototype.findlast
$({ target: 'Array', proto: true }, {
  findLast: function findLast(callbackfn /* , that = undefined */) {
    return $findLast(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('findLast');


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $findLastIndex = __webpack_require__(109).findLastIndex;
var addToUnscopables = __webpack_require__(31);

// `Array.prototype.findLastIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findlastindex
$({ target: 'Array', proto: true }, {
  findLastIndex: function findLastIndex(callbackfn /* , that = undefined */) {
    return $findLastIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('findLastIndex');


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(191);
var toObject = __webpack_require__(13);
var lengthOfArrayLike = __webpack_require__(14);
var toIntegerOrInfinity = __webpack_require__(21);
var arraySpeciesCreate = __webpack_require__(87);

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
    return A;
  }
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(191);
var aCallable = __webpack_require__(19);
var toObject = __webpack_require__(13);
var lengthOfArrayLike = __webpack_require__(14);
var arraySpeciesCreate = __webpack_require__(87);

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var forEach = __webpack_require__(192);

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$({ target: 'Array', proto: true, forced: [].forEach !== forEach }, {
  forEach: forEach
});


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var from = __webpack_require__(193);
var checkCorrectnessOfIteration = __webpack_require__(110);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(7);
var iteratorClose = __webpack_require__(189);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $includes = __webpack_require__(83).includes;
var fails = __webpack_require__(1);
var addToUnscopables = __webpack_require__(31);

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-indexof -- required for testing */
var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(59);
var $indexOf = __webpack_require__(83).indexOf;
var arrayMethodIsStrict = __webpack_require__(54);

var nativeIndexOf = uncurryThis([].indexOf);

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
var FORCED = NEGATIVE_ZERO || !arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: FORCED }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf(this, searchElement, fromIndex) || 0
      : $indexOf(this, searchElement, fromIndex);
  }
});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var isArray = __webpack_require__(60);

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var IndexedObject = __webpack_require__(68);
var toIndexedObject = __webpack_require__(23);
var arrayMethodIsStrict = __webpack_require__(54);

var nativeJoin = uncurryThis([].join);

var ES3_STRINGS = IndexedObject !== Object;
var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: FORCED }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var lastIndexOf = __webpack_require__(195);

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $map = __webpack_require__(25).map;
var arrayMethodHasSpeciesSupport = __webpack_require__(91);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var fails = __webpack_require__(1);
var isConstructor = __webpack_require__(73);
var createProperty = __webpack_require__(53);

var $Array = Array;

var ISNT_GENERIC = fails(function () {
  function F() { /* empty */ }
  // eslint-disable-next-line es/no-array-of -- safe
  return !($Array.of.call(F) instanceof F);
});

// `Array.of` method
// https://tc39.es/ecma262/#sec-array.of
// WebKit Array.of isn't generic
$({ target: 'Array', stat: true, forced: ISNT_GENERIC }, {
  of: function of(/* ...args */) {
    var index = 0;
    var argumentsLength = arguments.length;
    var result = new (isConstructor(this) ? this : $Array)(argumentsLength);
    while (argumentsLength > index) createProperty(result, index, arguments[index++]);
    result.length = argumentsLength;
    return result;
  }
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var toObject = __webpack_require__(13);
var lengthOfArrayLike = __webpack_require__(14);
var setArrayLength = __webpack_require__(144);
var doesNotExceedSafeInteger = __webpack_require__(75);
var fails = __webpack_require__(1);

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $reduce = __webpack_require__(112).left;
var arrayMethodIsStrict = __webpack_require__(54);
var CHROME_VERSION = __webpack_require__(50);
var IS_NODE = __webpack_require__(55);

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $reduceRight = __webpack_require__(112).right;
var arrayMethodIsStrict = __webpack_require__(54);
var CHROME_VERSION = __webpack_require__(50);
var IS_NODE = __webpack_require__(55);

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduceRight');

// `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var isArray = __webpack_require__(60);

var nativeReverse = uncurryThis([].reverse);
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse(this);
  }
});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var isArray = __webpack_require__(60);
var isConstructor = __webpack_require__(73);
var isObject = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(43);
var lengthOfArrayLike = __webpack_require__(14);
var toIndexedObject = __webpack_require__(23);
var createProperty = __webpack_require__(53);
var wellKnownSymbol = __webpack_require__(11);
var arrayMethodHasSpeciesSupport = __webpack_require__(91);
var nativeSlice = __webpack_require__(63);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $some = __webpack_require__(25).some;
var arrayMethodIsStrict = __webpack_require__(54);

var STRICT_METHOD = arrayMethodIsStrict('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var aCallable = __webpack_require__(19);
var toObject = __webpack_require__(13);
var lengthOfArrayLike = __webpack_require__(14);
var deletePropertyOrThrow = __webpack_require__(108);
var toString = __webpack_require__(5);
var fails = __webpack_require__(1);
var internalSort = __webpack_require__(145);
var arrayMethodIsStrict = __webpack_require__(54);
var FF = __webpack_require__(196);
var IE_OR_EDGE = __webpack_require__(197);
var V8 = __webpack_require__(50);
var WEBKIT = __webpack_require__(146);

var test = [];
var nativeSort = uncurryThis(test.sort);
var push = uncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var setSpecies = __webpack_require__(76);

// `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species
setSpecies('Array');


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var toObject = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(43);
var toIntegerOrInfinity = __webpack_require__(21);
var lengthOfArrayLike = __webpack_require__(14);
var setArrayLength = __webpack_require__(144);
var doesNotExceedSafeInteger = __webpack_require__(75);
var arraySpeciesCreate = __webpack_require__(87);
var createProperty = __webpack_require__(53);
var deletePropertyOrThrow = __webpack_require__(108);
var arrayMethodHasSpeciesSupport = __webpack_require__(91);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    setArrayLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var arrayToReversed = __webpack_require__(198);
var toIndexedObject = __webpack_require__(23);
var addToUnscopables = __webpack_require__(31);

var $Array = Array;

// `Array.prototype.toReversed` method
// https://tc39.es/ecma262/#sec-array.prototype.toreversed
$({ target: 'Array', proto: true }, {
  toReversed: function toReversed() {
    return arrayToReversed(toIndexedObject(this), $Array);
  }
});

addToUnscopables('toReversed');


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var aCallable = __webpack_require__(19);
var toIndexedObject = __webpack_require__(23);
var arrayFromConstructorAndList = __webpack_require__(147);
var getBuiltInPrototypeMethod = __webpack_require__(315);
var addToUnscopables = __webpack_require__(31);

var $Array = Array;
var sort = uncurryThis(getBuiltInPrototypeMethod('Array', 'sort'));

// `Array.prototype.toSorted` method
// https://tc39.es/ecma262/#sec-array.prototype.tosorted
$({ target: 'Array', proto: true }, {
  toSorted: function toSorted(compareFn) {
    if (compareFn !== undefined) aCallable(compareFn);
    var O = toIndexedObject(this);
    var A = arrayFromConstructorAndList($Array, O);
    return sort(A, compareFn);
  }
});

addToUnscopables('toSorted');


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);

module.exports = function (CONSTRUCTOR, METHOD) {
  var Constructor = global[CONSTRUCTOR];
  var Prototype = Constructor && Constructor.prototype;
  return Prototype && Prototype[METHOD];
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var addToUnscopables = __webpack_require__(31);
var doesNotExceedSafeInteger = __webpack_require__(75);
var lengthOfArrayLike = __webpack_require__(14);
var toAbsoluteIndex = __webpack_require__(43);
var toIndexedObject = __webpack_require__(23);
var toIntegerOrInfinity = __webpack_require__(21);

var $Array = Array;
var max = Math.max;
var min = Math.min;

// `Array.prototype.toSpliced` method
// https://tc39.es/ecma262/#sec-array.prototype.tospliced
$({ target: 'Array', proto: true }, {
  toSpliced: function toSpliced(start, deleteCount /* , ...items */) {
    var O = toIndexedObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var k = 0;
    var insertCount, actualDeleteCount, newLen, A;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    newLen = doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = $Array(newLen);

    for (; k < actualStart; k++) A[k] = O[k];
    for (; k < actualStart + insertCount; k++) A[k] = arguments[k - actualStart + 2];
    for (; k < newLen; k++) A[k] = O[k + actualDeleteCount - insertCount];

    return A;
  }
});

addToUnscopables('toSpliced');


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__(31);

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__(31);

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var toObject = __webpack_require__(13);
var lengthOfArrayLike = __webpack_require__(14);
var setArrayLength = __webpack_require__(144);
var deletePropertyOrThrow = __webpack_require__(108);
var doesNotExceedSafeInteger = __webpack_require__(75);

// IE8-
var INCORRECT_RESULT = [].unshift(0) !== 1;

// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).unshift();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_RESULT || !properErrorOnNonWritableLength();

// `Array.prototype.unshift` method
// https://tc39.es/ecma262/#sec-array.prototype.unshift
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  unshift: function unshift(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    if (argCount) {
      doesNotExceedSafeInteger(len + argCount);
      var k = len;
      while (k--) {
        var to = k + argCount;
        if (k in O) O[to] = O[k];
        else deletePropertyOrThrow(O, to);
      }
      for (var j = 0; j < argCount; j++) {
        O[j] = arguments[j];
      }
    } return setArrayLength(O, len + argCount);
  }
});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var arrayWith = __webpack_require__(199);
var toIndexedObject = __webpack_require__(23);

var $Array = Array;

// `Array.prototype.with` method
// https://tc39.es/ecma262/#sec-array.prototype.with
$({ target: 'Array', proto: true }, {
  'with': function (index, value) {
    return arrayWith(toIndexedObject(this), $Array, index, value);
  }
});


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var arrayBufferModule = __webpack_require__(113);
var setSpecies = __webpack_require__(76);

var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = global[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$({ global: true, constructor: true, forced: NativeArrayBuffer !== ArrayBuffer }, {
  ArrayBuffer: ArrayBuffer
});

setSpecies(ARRAY_BUFFER);


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var sign = __webpack_require__(149);

var abs = Math.abs;

var EPSILON = 2.220446049250313e-16; // Number.EPSILON
var INVERSE_EPSILON = 1 / EPSILON;

var roundTiesToEven = function (n) {
  return n + INVERSE_EPSILON - INVERSE_EPSILON;
};

module.exports = function (x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
  var n = +x;
  var absolute = abs(n);
  var s = sign(n);
  if (absolute < FLOAT_MIN_VALUE) return s * roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
  var a = (1 + FLOAT_EPSILON / EPSILON) * absolute;
  var result = a - (a - absolute);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
  return s * result;
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array = Array;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number !== number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number !== number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    c = pow(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent += eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa += pow(2, mantissaLength);
    exponent -= eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

module.exports = {
  pack: pack,
  unpack: unpack
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var ArrayBufferViewCore = __webpack_require__(8);

var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;

// `ArrayBuffer.isView` method
// https://tc39.es/ecma262/#sec-arraybuffer.isview
$({ target: 'ArrayBuffer', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
  isView: ArrayBufferViewCore.isView
});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(59);
var fails = __webpack_require__(1);
var ArrayBufferModule = __webpack_require__(113);
var anObject = __webpack_require__(7);
var toAbsoluteIndex = __webpack_require__(43);
var toLength = __webpack_require__(32);
var speciesConstructor = __webpack_require__(77);

var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var DataViewPrototype = DataView.prototype;
var nativeArrayBufferSlice = uncurryThis(ArrayBuffer.prototype.slice);
var getUint8 = uncurryThis(DataViewPrototype.getUint8);
var setUint8 = uncurryThis(DataViewPrototype.setUint8);

var INCORRECT_SLICE = fails(function () {
  return !new ArrayBuffer(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice && end === undefined) {
      return nativeArrayBufferSlice(anObject(this), start); // FF fix
    }
    var length = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = new (speciesConstructor(this, ArrayBuffer))(toLength(fin - first));
    var viewSource = new DataView(this);
    var viewTarget = new DataView(result);
    var index = 0;
    while (first < fin) {
      setUint8(viewTarget, index++, getUint8(viewSource, first++));
    } return result;
  }
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(327);


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var ArrayBufferModule = __webpack_require__(113);
var NATIVE_ARRAY_BUFFER = __webpack_require__(148);

// `DataView` constructor
// https://tc39.es/ecma262/#sec-dataview-constructor
$({ global: true, constructor: true, forced: !NATIVE_ARRAY_BUFFER }, {
  DataView: ArrayBufferModule.DataView
});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(1);

// IE8- non-standard case
var FORCED = fails(function () {
  // eslint-disable-next-line es/no-date-prototype-getyear-setyear -- detection
  return new Date(16e11).getYear() !== 120;
});

var getFullYear = uncurryThis(Date.prototype.getFullYear);

// `Date.prototype.getYear` method
// https://tc39.es/ecma262/#sec-date.prototype.getyear
$({ target: 'Date', proto: true, forced: FORCED }, {
  getYear: function getYear() {
    return getFullYear(this) - 1900;
  }
});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);

var $Date = Date;
var thisTimeValue = uncurryThis($Date.prototype.getTime);

// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$({ target: 'Date', stat: true }, {
  now: function now() {
    return thisTimeValue(new $Date());
  }
});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var toIntegerOrInfinity = __webpack_require__(21);

var DatePrototype = Date.prototype;
var thisTimeValue = uncurryThis(DatePrototype.getTime);
var setFullYear = uncurryThis(DatePrototype.setFullYear);

// `Date.prototype.setYear` method
// https://tc39.es/ecma262/#sec-date.prototype.setyear
$({ target: 'Date', proto: true }, {
  setYear: function setYear(year) {
    // validate
    thisTimeValue(this);
    var yi = toIntegerOrInfinity(year);
    var yyyy = yi >= 0 && yi <= 99 ? yi + 1900 : yi;
    return setFullYear(this, yyyy);
  }
});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);

// `Date.prototype.toGMTString` method
// https://tc39.es/ecma262/#sec-date.prototype.togmtstring
$({ target: 'Date', proto: true }, {
  toGMTString: Date.prototype.toUTCString
});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var toISOString = __webpack_require__(333);

// `Date.prototype.toISOString` method
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit has a broken implementations
$({ target: 'Date', proto: true, forced: Date.prototype.toISOString !== toISOString }, {
  toISOString: toISOString
});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(1);
var padStart = __webpack_require__(151).start;

var $RangeError = RangeError;
var $isFinite = isFinite;
var abs = Math.abs;
var DatePrototype = Date.prototype;
var nativeDateToISOString = DatePrototype.toISOString;
var thisTimeValue = uncurryThis(DatePrototype.getTime);
var getUTCDate = uncurryThis(DatePrototype.getUTCDate);
var getUTCFullYear = uncurryThis(DatePrototype.getUTCFullYear);
var getUTCHours = uncurryThis(DatePrototype.getUTCHours);
var getUTCMilliseconds = uncurryThis(DatePrototype.getUTCMilliseconds);
var getUTCMinutes = uncurryThis(DatePrototype.getUTCMinutes);
var getUTCMonth = uncurryThis(DatePrototype.getUTCMonth);
var getUTCSeconds = uncurryThis(DatePrototype.getUTCSeconds);

// `Date.prototype.toISOString` method implementation
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit fails here:
module.exports = (fails(function () {
  return nativeDateToISOString.call(new Date(-5e13 - 1)) !== '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  nativeDateToISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!$isFinite(thisTimeValue(this))) throw new $RangeError('Invalid time value');
  var date = this;
  var year = getUTCFullYear(date);
  var milliseconds = getUTCMilliseconds(date);
  var sign = year < 0 ? '-' : year > 9999 ? '+' : '';
  return sign + padStart(abs(year), sign ? 6 : 4, 0) +
    '-' + padStart(getUTCMonth(date) + 1, 2, 0) +
    '-' + padStart(getUTCDate(date), 2, 0) +
    'T' + padStart(getUTCHours(date), 2, 0) +
    ':' + padStart(getUTCMinutes(date), 2, 0) +
    ':' + padStart(getUTCSeconds(date), 2, 0) +
    '.' + padStart(milliseconds, 3, 0) +
    'Z';
} : nativeDateToISOString;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var fails = __webpack_require__(1);
var toObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(102);

var FORCED = fails(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
});

// `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson
$({ target: 'Date', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O, 'number');
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(12);
var defineBuiltIn = __webpack_require__(16);
var dateToPrimitive = __webpack_require__(336);
var wellKnownSymbol = __webpack_require__(11);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!hasOwn(DatePrototype, TO_PRIMITIVE)) {
  defineBuiltIn(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(7);
var ordinaryToPrimitive = __webpack_require__(171);

var $TypeError = TypeError;

// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports = function (hint) {
  anObject(this);
  if (hint === 'string' || hint === 'default') hint = 'string';
  else if (hint !== 'number') throw new $TypeError('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
var uncurryThis = __webpack_require__(2);
var defineBuiltIn = __webpack_require__(16);

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var nativeDateToString = uncurryThis(DatePrototype[TO_STRING]);
var thisTimeValue = uncurryThis(DatePrototype.getTime);

// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (String(new Date(NaN)) !== INVALID_DATE) {
  defineBuiltIn(DatePrototype, TO_STRING, function toString() {
    var value = thisTimeValue(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? nativeDateToString(this) : INVALID_DATE;
  });
}


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var toString = __webpack_require__(5);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var exec = uncurryThis(/./.exec);
var numberToString = uncurryThis(1.0.toString);
var toUpperCase = uncurryThis(''.toUpperCase);

var raw = /[\w*+\-./@]/;

var hex = function (code, length) {
  var result = numberToString(code, 16);
  while (result.length < length) result = '0' + result;
  return result;
};

// `escape` method
// https://tc39.es/ecma262/#sec-escape-string
$({ global: true }, {
  escape: function escape(string) {
    var str = toString(string);
    var result = '';
    var length = str.length;
    var index = 0;
    var chr, code;
    while (index < length) {
      chr = charAt(str, index++);
      if (exec(raw, chr)) {
        result += chr;
      } else {
        code = charCodeAt(chr, 0);
        if (code < 256) {
          result += '%' + hex(code, 2);
        } else {
          result += '%u' + toUpperCase(hex(code, 4));
        }
      }
    } return result;
  }
});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(0);
var bind = __webpack_require__(202);

// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$({ target: 'Function', proto: true, forced: Function.bind !== bind }, {
  bind: bind
});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(10);
var isObject = __webpack_require__(9);
var definePropertyModule = __webpack_require__(17);
var getPrototypeOf = __webpack_require__(34);
var wellKnownSymbol = __webpack_require__(11);
var makeBuiltIn = __webpack_require__(130);

var HAS_INSTANCE = wellKnownSymbol('hasInstance');
var FunctionPrototype = Function.prototype;

// `Function.prototype[@@hasInstance]` method
// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance
if (!(HAS_INSTANCE in FunctionPrototype)) {
  definePropertyModule.f(FunctionPrototype, HAS_INSTANCE, { value: makeBuiltIn(function (O) {
    if (!isCallable(this) || !isObject(O)) return false;
    var P = this.prototype;
    if (!isObject(P)) return O instanceof this;
    // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
    while (O = getPrototypeOf(O)) if (P === O) return true;
    return false;
  }, HAS_INSTANCE) });
}


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var FUNCTION_NAME_EXISTS = __webpack_require__(72).EXISTS;
var uncurryThis = __webpack_require__(2);
var defineBuiltInAccessor = __webpack_require__(24);

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineBuiltInAccessor(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true, forced: global.globalThis !== global }, {
  globalThis: global
});


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var setToStringTag = __webpack_require__(33);

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(345);


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(115);
var collectionStrong = __webpack_require__(203);

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var log1p = __webpack_require__(204);

// eslint-disable-next-line es/no-math-acosh -- required for testing
var $acosh = Math.acosh;
var log = Math.log;
var sqrt = Math.sqrt;
var LN2 = Math.LN2;

var FORCED = !$acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  || Math.floor($acosh(Number.MAX_VALUE)) !== 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  || $acosh(Infinity) !== Infinity;

// `Math.acosh` method
// https://tc39.es/ecma262/#sec-math.acosh
$({ target: 'Math', stat: true, forced: FORCED }, {
  acosh: function acosh(x) {
    var n = +x;
    return n < 1 ? NaN : n > 94906265.62425156
      ? log(n) + LN2
      : log1p(n - 1 + sqrt(n - 1) * sqrt(n + 1));
  }
});


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);

// eslint-disable-next-line es/no-math-asinh -- required for testing
var $asinh = Math.asinh;
var log = Math.log;
var sqrt = Math.sqrt;

function asinh(x) {
  var n = +x;
  return !isFinite(n) || n === 0 ? n : n < 0 ? -asinh(-n) : log(n + sqrt(n * n + 1));
}

var FORCED = !($asinh && 1 / $asinh(0) > 0);

// `Math.asinh` method
// https://tc39.es/ecma262/#sec-math.asinh
// Tor Browser bug: Math.asinh(0) -> -0
$({ target: 'Math', stat: true, forced: FORCED }, {
  asinh: asinh
});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);

// eslint-disable-next-line es/no-math-atanh -- required for testing
var $atanh = Math.atanh;
var log = Math.log;

var FORCED = !($atanh && 1 / $atanh(-0) < 0);

// `Math.atanh` method
// https://tc39.es/ecma262/#sec-math.atanh
// Tor Browser bug: Math.atanh(-0) -> 0
$({ target: 'Math', stat: true, forced: FORCED }, {
  atanh: function atanh(x) {
    var n = +x;
    return n === 0 ? n : log((1 + n) / (1 - n)) / 2;
  }
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var sign = __webpack_require__(149);

var abs = Math.abs;
var pow = Math.pow;

// `Math.cbrt` method
// https://tc39.es/ecma262/#sec-math.cbrt
$({ target: 'Math', stat: true }, {
  cbrt: function cbrt(x) {
    var n = +x;
    return sign(n) * pow(abs(n), 1 / 3);
  }
});


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);

var floor = Math.floor;
var log = Math.log;
var LOG2E = Math.LOG2E;

// `Math.clz32` method
// https://tc39.es/ecma262/#sec-math.clz32
$({ target: 'Math', stat: true }, {
  clz32: function clz32(x) {
    var n = x >>> 0;
    return n ? 31 - floor(log(n + 0.5) * LOG2E) : 32;
  }
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var expm1 = __webpack_require__(116);

// eslint-disable-next-line es/no-math-cosh -- required for testing
var $cosh = Math.cosh;
var abs = Math.abs;
var E = Math.E;

var FORCED = !$cosh || $cosh(710) === Infinity;

// `Math.cosh` method
// https://tc39.es/ecma262/#sec-math.cosh
$({ target: 'Math', stat: true, forced: FORCED }, {
  cosh: function cosh(x) {
    var t = expm1(abs(x) - 1) + 1;
    return (t + 1 / (t * E * E)) * (E / 2);
  }
});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var expm1 = __webpack_require__(116);

// `Math.expm1` method
// https://tc39.es/ecma262/#sec-math.expm1
// eslint-disable-next-line es/no-math-expm1 -- required for testing
$({ target: 'Math', stat: true, forced: expm1 !== Math.expm1 }, { expm1: expm1 });


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var fround = __webpack_require__(201);

// `Math.fround` method
// https://tc39.es/ecma262/#sec-math.fround
$({ target: 'Math', stat: true }, { fround: fround });


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);

// eslint-disable-next-line es/no-math-hypot -- required for testing
var $hypot = Math.hypot;
var abs = Math.abs;
var sqrt = Math.sqrt;

// Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546
var FORCED = !!$hypot && $hypot(Infinity, NaN) !== Infinity;

// `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot
$({ target: 'Math', stat: true, arity: 2, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  hypot: function hypot(value1, value2) {
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * sqrt(sum);
  }
});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var fails = __webpack_require__(1);

// eslint-disable-next-line es/no-math-imul -- required for testing
var $imul = Math.imul;

var FORCED = fails(function () {
  return $imul(0xFFFFFFFF, 5) !== -5 || $imul.length !== 2;
});

// `Math.imul` method
// https://tc39.es/ecma262/#sec-math.imul
// some WebKit versions fails with big numbers, some has wrong arity
$({ target: 'Math', stat: true, forced: FORCED }, {
  imul: function imul(x, y) {
    var UINT16 = 0xFFFF;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var log10 = __webpack_require__(205);

// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
$({ target: 'Math', stat: true }, {
  log10: log10
});


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var log1p = __webpack_require__(204);

// `Math.log1p` method
// https://tc39.es/ecma262/#sec-math.log1p
$({ target: 'Math', stat: true }, { log1p: log1p });


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);

var log = Math.log;
var LN2 = Math.LN2;

// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
$({ target: 'Math', stat: true }, {
  log2: function log2(x) {
    return log(x) / LN2;
  }
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var sign = __webpack_require__(149);

// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$({ target: 'Math', stat: true }, {
  sign: sign
});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var fails = __webpack_require__(1);
var expm1 = __webpack_require__(116);

var abs = Math.abs;
var exp = Math.exp;
var E = Math.E;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-math-sinh -- required for testing
  return Math.sinh(-2e-17) !== -2e-17;
});

// `Math.sinh` method
// https://tc39.es/ecma262/#sec-math.sinh
// V8 near Chromium 38 has a problem with very small numbers
$({ target: 'Math', stat: true, forced: FORCED }, {
  sinh: function sinh(x) {
    var n = +x;
    return abs(n) < 1 ? (expm1(n) - expm1(-n)) / 2 : (exp(n - 1) - exp(-n - 1)) * (E / 2);
  }
});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var expm1 = __webpack_require__(116);

var exp = Math.exp;

// `Math.tanh` method
// https://tc39.es/ecma262/#sec-math.tanh
$({ target: 'Math', stat: true }, {
  tanh: function tanh(x) {
    var n = +x;
    var a = expm1(n);
    var b = expm1(-n);
    return a === Infinity ? 1 : b === Infinity ? -1 : (a - b) / (exp(n) + exp(-n));
  }
});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var setToStringTag = __webpack_require__(33);

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var trunc = __webpack_require__(176);

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$({ target: 'Math', stat: true }, {
  trunc: trunc
});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var IS_PURE = __webpack_require__(20);
var DESCRIPTORS = __webpack_require__(4);
var global = __webpack_require__(3);
var path = __webpack_require__(137);
var uncurryThis = __webpack_require__(2);
var isForced = __webpack_require__(84);
var hasOwn = __webpack_require__(12);
var inheritIfRequired = __webpack_require__(74);
var isPrototypeOf = __webpack_require__(38);
var isSymbol = __webpack_require__(61);
var toPrimitive = __webpack_require__(102);
var fails = __webpack_require__(1);
var getOwnPropertyNames = __webpack_require__(58).f;
var getOwnPropertyDescriptor = __webpack_require__(26).f;
var defineProperty = __webpack_require__(17).f;
var thisNumberValue = __webpack_require__(117);
var trim = __webpack_require__(79).trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var PureNumberNamespace = path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var stringSlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw new TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        // fast equal of /^0b[01]+$/i
        case 66:
        case 98:
          radix = 2;
          maxCode = 49;
          break;
        // fast equal of /^0o[0-7]+$/i
        case 79:
        case 111:
          radix = 8;
          maxCode = 55;
          break;
        default:
          return +it;
      }
      digits = stringSlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));

var calledWithNew = function (dummy) {
  // includes check on 1..constructor(foo) case
  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};

NumberWrapper.prototype = NumberPrototype;
if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;

$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
  Number: NumberWrapper
});

// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties = function (target, source) {
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);

// `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon
$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
  EPSILON: Math.pow(2, -52)
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var numberIsFinite = __webpack_require__(367);

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$({ target: 'Number', stat: true }, { isFinite: numberIsFinite });


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);

var globalIsFinite = global.isFinite;

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
module.exports = Number.isFinite || function isFinite(it) {
  return typeof it == 'number' && globalIsFinite(it);
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var isIntegralNumber = __webpack_require__(154);

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isIntegralNumber
});


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number;
  }
});


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var isIntegralNumber = __webpack_require__(154);

var abs = Math.abs;

// `Number.isSafeInteger` method
// https://tc39.es/ecma262/#sec-number.issafeinteger
$({ target: 'Number', stat: true }, {
  isSafeInteger: function isSafeInteger(number) {
    return isIntegralNumber(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
  }
});


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);

// `Number.MIN_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.min_safe_integer
$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
  MIN_SAFE_INTEGER: -0x1FFFFFFFFFFFFF
});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var parseFloat = __webpack_require__(206);

// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseFloat !== parseFloat }, {
  parseFloat: parseFloat
});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var parseInt = __webpack_require__(207);

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseInt !== parseInt }, {
  parseInt: parseInt
});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var toIntegerOrInfinity = __webpack_require__(21);
var thisNumberValue = __webpack_require__(117);
var $repeat = __webpack_require__(114);
var log10 = __webpack_require__(205);
var fails = __webpack_require__(1);

var $RangeError = RangeError;
var $String = String;
var $isFinite = isFinite;
var abs = Math.abs;
var floor = Math.floor;
var pow = Math.pow;
var round = Math.round;
var nativeToExponential = uncurryThis(1.0.toExponential);
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);

// Edge 17-
var ROUNDS_PROPERLY = nativeToExponential(-6.9e-11, 4) === '-6.9000e-11'
  // IE11- && Edge 14-
  && nativeToExponential(1.255, 2) === '1.25e+0'
  // FF86-, V8 ~ Chrome 49-50
  && nativeToExponential(12345, 3) === '1.235e+4'
  // FF86-, V8 ~ Chrome 49-50
  && nativeToExponential(25, 0) === '3e+1';

// IE8-
var throwsOnInfinityFraction = function () {
  return fails(function () {
    nativeToExponential(1, Infinity);
  }) && fails(function () {
    nativeToExponential(1, -Infinity);
  });
};

// Safari <11 && FF <50
var properNonFiniteThisCheck = function () {
  return !fails(function () {
    nativeToExponential(Infinity, Infinity);
    nativeToExponential(NaN, Infinity);
  });
};

var FORCED = !ROUNDS_PROPERLY || !throwsOnInfinityFraction() || !properNonFiniteThisCheck();

// `Number.prototype.toExponential` method
// https://tc39.es/ecma262/#sec-number.prototype.toexponential
$({ target: 'Number', proto: true, forced: FORCED }, {
  toExponential: function toExponential(fractionDigits) {
    var x = thisNumberValue(this);
    if (fractionDigits === undefined) return nativeToExponential(x);
    var f = toIntegerOrInfinity(fractionDigits);
    if (!$isFinite(x)) return String(x);
    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (f < 0 || f > 20) throw new $RangeError('Incorrect fraction digits');
    if (ROUNDS_PROPERLY) return nativeToExponential(x, f);
    var s = '';
    var m = '';
    var e = 0;
    var c = '';
    var d = '';
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x === 0) {
      e = 0;
      m = repeat('0', f + 1);
    } else {
      // this block is based on https://gist.github.com/SheetJSDev/1100ad56b9f856c95299ed0e068eea08
      // TODO: improve accuracy with big fraction digits
      var l = log10(x);
      e = floor(l);
      var n = 0;
      var w = pow(10, e - f);
      n = round(x / w);
      if (2 * x >= (2 * n + 1) * w) {
        n += 1;
      }
      if (n >= pow(10, f + 1)) {
        n /= 10;
        e += 1;
      }
      m = $String(n);
    }
    if (f !== 0) {
      m = stringSlice(m, 0, 1) + '.' + stringSlice(m, 1);
    }
    if (e === 0) {
      c = '+';
      d = '0';
    } else {
      c = e > 0 ? '+' : '-';
      d = $String(abs(e));
    }
    m += 'e' + c + d;
    return s + m;
  }
});


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var toIntegerOrInfinity = __webpack_require__(21);
var thisNumberValue = __webpack_require__(117);
var $repeat = __webpack_require__(114);
var fails = __webpack_require__(1);

var $RangeError = RangeError;
var $String = String;
var floor = Math.floor;
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var nativeToFixed = uncurryThis(1.0.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = fails(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw new $RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(1);
var thisNumberValue = __webpack_require__(117);

var nativeToPrecision = uncurryThis(1.0.toPrecision);

var FORCED = fails(function () {
  // IE7-
  return nativeToPrecision(1, undefined) !== '1';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToPrecision({});
});

// `Number.prototype.toPrecision` method
// https://tc39.es/ecma262/#sec-number.prototype.toprecision
$({ target: 'Number', proto: true, forced: FORCED }, {
  toPrecision: function toPrecision(precision) {
    return precision === undefined
      ? nativeToPrecision(thisNumberValue(this))
      : nativeToPrecision(thisNumberValue(this), precision);
  }
});


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var assign = __webpack_require__(208);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(4);
var create = __webpack_require__(39);

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  create: create
});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(4);
var FORCED = __webpack_require__(119);
var aCallable = __webpack_require__(19);
var toObject = __webpack_require__(13);
var definePropertyModule = __webpack_require__(17);

// `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __defineGetter__: function __defineGetter__(P, getter) {
      definePropertyModule.f(toObject(this), P, { get: aCallable(getter), enumerable: true, configurable: true });
    }
  });
}


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(4);
var defineProperties = __webpack_require__(135).f;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$({ target: 'Object', stat: true, forced: Object.defineProperties !== defineProperties, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(4);
var defineProperty = __webpack_require__(17).f;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$({ target: 'Object', stat: true, forced: Object.defineProperty !== defineProperty, sham: !DESCRIPTORS }, {
  defineProperty: defineProperty
});


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(4);
var FORCED = __webpack_require__(119);
var aCallable = __webpack_require__(19);
var toObject = __webpack_require__(13);
var definePropertyModule = __webpack_require__(17);

// `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __defineSetter__: function __defineSetter__(P, setter) {
      definePropertyModule.f(toObject(this), P, { set: aCallable(setter), enumerable: true, configurable: true });
    }
  });
}


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $entries = __webpack_require__(209).entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var FREEZING = __webpack_require__(78);
var fails = __webpack_require__(1);
var isObject = __webpack_require__(9);
var onFreeze = __webpack_require__(64).onFreeze;

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var iterate = __webpack_require__(46);
var createProperty = __webpack_require__(53);

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var fails = __webpack_require__(1);
var toIndexedObject = __webpack_require__(23);
var nativeGetOwnPropertyDescriptor = __webpack_require__(26).f;
var DESCRIPTORS = __webpack_require__(4);

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(4);
var ownKeys = __webpack_require__(132);
var toIndexedObject = __webpack_require__(23);
var getOwnPropertyDescriptorModule = __webpack_require__(26);
var createProperty = __webpack_require__(53);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var fails = __webpack_require__(1);
var getOwnPropertyNames = __webpack_require__(136).f;

// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames: getOwnPropertyNames
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var fails = __webpack_require__(1);
var toObject = __webpack_require__(13);
var nativeGetPrototypeOf = __webpack_require__(34);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(139);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var hasOwn = __webpack_require__(12);

// `Object.hasOwn` method
// https://tc39.es/ecma262/#sec-object.hasown
$({ target: 'Object', stat: true }, {
  hasOwn: hasOwn
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var is = __webpack_require__(210);

// `Object.is` method
// https://tc39.es/ecma262/#sec-object.is
$({ target: 'Object', stat: true }, {
  is: is
});


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $isExtensible = __webpack_require__(152);

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
// eslint-disable-next-line es/no-object-isextensible -- safe
$({ target: 'Object', stat: true, forced: Object.isExtensible !== $isExtensible }, {
  isExtensible: $isExtensible
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var fails = __webpack_require__(1);
var isObject = __webpack_require__(9);
var classof = __webpack_require__(27);
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(153);

// eslint-disable-next-line es/no-object-isfrozen -- safe
var $isFrozen = Object.isFrozen;

var FORCED = ARRAY_BUFFER_NON_EXTENSIBLE || fails(function () { $isFrozen(1); });

// `Object.isFrozen` method
// https://tc39.es/ecma262/#sec-object.isfrozen
$({ target: 'Object', stat: true, forced: FORCED }, {
  isFrozen: function isFrozen(it) {
    if (!isObject(it)) return true;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return true;
    return $isFrozen ? $isFrozen(it) : false;
  }
});


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var fails = __webpack_require__(1);
var isObject = __webpack_require__(9);
var classof = __webpack_require__(27);
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(153);

// eslint-disable-next-line es/no-object-issealed -- safe
var $isSealed = Object.isSealed;

var FORCED = ARRAY_BUFFER_NON_EXTENSIBLE || fails(function () { $isSealed(1); });

// `Object.isSealed` method
// https://tc39.es/ecma262/#sec-object.issealed
$({ target: 'Object', stat: true, forced: FORCED }, {
  isSealed: function isSealed(it) {
    if (!isObject(it)) return true;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return true;
    return $isSealed ? $isSealed(it) : false;
  }
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var toObject = __webpack_require__(13);
var nativeKeys = __webpack_require__(85);
var fails = __webpack_require__(1);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(4);
var FORCED = __webpack_require__(119);
var toObject = __webpack_require__(13);
var toPropertyKey = __webpack_require__(57);
var getPrototypeOf = __webpack_require__(34);
var getOwnPropertyDescriptor = __webpack_require__(26).f;

// `Object.prototype.__lookupGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __lookupGetter__: function __lookupGetter__(P) {
      var O = toObject(this);
      var key = toPropertyKey(P);
      var desc;
      do {
        if (desc = getOwnPropertyDescriptor(O, key)) return desc.get;
      } while (O = getPrototypeOf(O));
    }
  });
}


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(4);
var FORCED = __webpack_require__(119);
var toObject = __webpack_require__(13);
var toPropertyKey = __webpack_require__(57);
var getPrototypeOf = __webpack_require__(34);
var getOwnPropertyDescriptor = __webpack_require__(26).f;

// `Object.prototype.__lookupSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __lookupSetter__: function __lookupSetter__(P) {
      var O = toObject(this);
      var key = toPropertyKey(P);
      var desc;
      do {
        if (desc = getOwnPropertyDescriptor(O, key)) return desc.set;
      } while (O = getPrototypeOf(O));
    }
  });
}


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var isObject = __webpack_require__(9);
var onFreeze = __webpack_require__(64).onFreeze;
var FREEZING = __webpack_require__(78);
var fails = __webpack_require__(1);

// eslint-disable-next-line es/no-object-preventextensions -- safe
var $preventExtensions = Object.preventExtensions;
var FAILS_ON_PRIMITIVES = fails(function () { $preventExtensions(1); });

// `Object.preventExtensions` method
// https://tc39.es/ecma262/#sec-object.preventextensions
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  preventExtensions: function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(onFreeze(it)) : it;
  }
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var defineBuiltInAccessor = __webpack_require__(24);
var isObject = __webpack_require__(9);
var toObject = __webpack_require__(13);
var requireObjectCoercible = __webpack_require__(18);

// eslint-disable-next-line es/no-object-getprototypeof -- safe
var getPrototypeOf = Object.getPrototypeOf;
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var setPrototypeOf = Object.setPrototypeOf;
var ObjectPrototype = Object.prototype;
var PROTO = '__proto__';

// `Object.prototype.__proto__` accessor
// https://tc39.es/ecma262/#sec-object.prototype.__proto__
if (DESCRIPTORS && getPrototypeOf && setPrototypeOf && !(PROTO in ObjectPrototype)) try {
  defineBuiltInAccessor(ObjectPrototype, PROTO, {
    configurable: true,
    get: function __proto__() {
      return getPrototypeOf(toObject(this));
    },
    set: function __proto__(proto) {
      var O = requireObjectCoercible(this);
      if (!isObject(proto) && proto !== null || !isObject(O)) return;
      setPrototypeOf(O, proto);
    }
  });
} catch (error) { /* empty */ }


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var isObject = __webpack_require__(9);
var onFreeze = __webpack_require__(64).onFreeze;
var FREEZING = __webpack_require__(78);
var fails = __webpack_require__(1);

// eslint-disable-next-line es/no-object-seal -- safe
var $seal = Object.seal;
var FAILS_ON_PRIMITIVES = fails(function () { $seal(1); });

// `Object.seal` method
// https://tc39.es/ecma262/#sec-object.seal
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  seal: function seal(it) {
    return $seal && isObject(it) ? $seal(onFreeze(it)) : it;
  }
});


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var setPrototypeOf = __webpack_require__(45);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(134);
var defineBuiltIn = __webpack_require__(16);
var toString = __webpack_require__(404);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(134);
var classof = __webpack_require__(44);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $values = __webpack_require__(209).values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $parseFloat = __webpack_require__(206);

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$({ global: true, forced: parseFloat !== $parseFloat }, {
  parseFloat: $parseFloat
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $parseInt = __webpack_require__(207);

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt !== $parseInt }, {
  parseInt: $parseInt
});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(409);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var IS_PURE = __webpack_require__(20);
var IS_NODE = __webpack_require__(55);
var global = __webpack_require__(3);
var call = __webpack_require__(6);
var defineBuiltIn = __webpack_require__(16);
var setPrototypeOf = __webpack_require__(45);
var setToStringTag = __webpack_require__(33);
var setSpecies = __webpack_require__(76);
var aCallable = __webpack_require__(19);
var isCallable = __webpack_require__(10);
var isObject = __webpack_require__(9);
var anInstance = __webpack_require__(47);
var speciesConstructor = __webpack_require__(77);
var task = __webpack_require__(120).set;
var microtask = __webpack_require__(212);
var hostReportErrors = __webpack_require__(412);
var perform = __webpack_require__(94);
var Queue = __webpack_require__(213);
var InternalStateModule = __webpack_require__(22);
var NativePromiseConstructor = __webpack_require__(80);
var PromiseConstructorDetection = __webpack_require__(95);
var newPromiseCapabilityModule = __webpack_require__(65);

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(51);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(51);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var call = __webpack_require__(6);
var aCallable = __webpack_require__(19);
var newPromiseCapabilityModule = __webpack_require__(65);
var perform = __webpack_require__(94);
var iterate = __webpack_require__(46);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(121);

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var IS_PURE = __webpack_require__(20);
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(95).CONSTRUCTOR;
var NativePromiseConstructor = __webpack_require__(80);
var getBuiltIn = __webpack_require__(15);
var isCallable = __webpack_require__(10);
var defineBuiltIn = __webpack_require__(16);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var call = __webpack_require__(6);
var aCallable = __webpack_require__(19);
var newPromiseCapabilityModule = __webpack_require__(65);
var perform = __webpack_require__(94);
var iterate = __webpack_require__(46);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(121);

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var call = __webpack_require__(6);
var newPromiseCapabilityModule = __webpack_require__(65);
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(95).CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var getBuiltIn = __webpack_require__(15);
var IS_PURE = __webpack_require__(20);
var NativePromiseConstructor = __webpack_require__(80);
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(95).CONSTRUCTOR;
var promiseResolve = __webpack_require__(215);

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var call = __webpack_require__(6);
var aCallable = __webpack_require__(19);
var newPromiseCapabilityModule = __webpack_require__(65);
var perform = __webpack_require__(94);
var iterate = __webpack_require__(46);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(121);

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var call = __webpack_require__(6);
var aCallable = __webpack_require__(19);
var getBuiltIn = __webpack_require__(15);
var newPromiseCapabilityModule = __webpack_require__(65);
var perform = __webpack_require__(94);
var iterate = __webpack_require__(46);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(121);

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  any: function any(iterable) {
    var C = this;
    var AggregateError = getBuiltIn('AggregateError');
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var IS_PURE = __webpack_require__(20);
var NativePromiseConstructor = __webpack_require__(80);
var fails = __webpack_require__(1);
var getBuiltIn = __webpack_require__(15);
var isCallable = __webpack_require__(10);
var speciesConstructor = __webpack_require__(77);
var promiseResolve = __webpack_require__(215);
var defineBuiltIn = __webpack_require__(16);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var functionApply = __webpack_require__(40);
var aCallable = __webpack_require__(19);
var anObject = __webpack_require__(7);
var fails = __webpack_require__(1);

// MS Edge argumentsList argument is optional
var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.apply(function () { /* empty */ });
});

// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$({ target: 'Reflect', stat: true, forced: OPTIONAL_ARGUMENTS_LIST }, {
  apply: function apply(target, thisArgument, argumentsList) {
    return functionApply(aCallable(target), thisArgument, anObject(argumentsList));
  }
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var getBuiltIn = __webpack_require__(15);
var apply = __webpack_require__(40);
var bind = __webpack_require__(202);
var aConstructor = __webpack_require__(150);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(9);
var create = __webpack_require__(39);
var fails = __webpack_require__(1);

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target === newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(4);
var anObject = __webpack_require__(7);
var toPropertyKey = __webpack_require__(57);
var definePropertyModule = __webpack_require__(17);
var fails = __webpack_require__(1);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
var ERROR_INSTEAD_OF_FALSE = fails(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.defineProperty(definePropertyModule.f({}, 1, { value: 1 }), 1, { value: 2 });
});

// `Reflect.defineProperty` method
// https://tc39.es/ecma262/#sec-reflect.defineproperty
$({ target: 'Reflect', stat: true, forced: ERROR_INSTEAD_OF_FALSE, sham: !DESCRIPTORS }, {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    var key = toPropertyKey(propertyKey);
    anObject(attributes);
    try {
      definePropertyModule.f(target, key, attributes);
      return true;
    } catch (error) {
      return false;
    }
  }
});


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var anObject = __webpack_require__(7);
var getOwnPropertyDescriptor = __webpack_require__(26).f;

// `Reflect.deleteProperty` method
// https://tc39.es/ecma262/#sec-reflect.deleteproperty
$({ target: 'Reflect', stat: true }, {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var descriptor = getOwnPropertyDescriptor(anObject(target), propertyKey);
    return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var call = __webpack_require__(6);
var isObject = __webpack_require__(9);
var anObject = __webpack_require__(7);
var isDataDescriptor = __webpack_require__(216);
var getOwnPropertyDescriptorModule = __webpack_require__(26);
var getPrototypeOf = __webpack_require__(34);

// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject(target) === receiver) return target[propertyKey];
  descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey);
  if (descriptor) return isDataDescriptor(descriptor)
    ? descriptor.value
    : descriptor.get === undefined ? undefined : call(descriptor.get, receiver);
  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}

$({ target: 'Reflect', stat: true }, {
  get: get
});


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(4);
var anObject = __webpack_require__(7);
var getOwnPropertyDescriptorModule = __webpack_require__(26);

// `Reflect.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor
$({ target: 'Reflect', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var anObject = __webpack_require__(7);
var objectGetPrototypeOf = __webpack_require__(34);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(139);

// `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof
$({ target: 'Reflect', stat: true, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(target) {
    return objectGetPrototypeOf(anObject(target));
  }
});


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);

// `Reflect.has` method
// https://tc39.es/ecma262/#sec-reflect.has
$({ target: 'Reflect', stat: true }, {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var anObject = __webpack_require__(7);
var $isExtensible = __webpack_require__(152);

// `Reflect.isExtensible` method
// https://tc39.es/ecma262/#sec-reflect.isextensible
$({ target: 'Reflect', stat: true }, {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible(target);
  }
});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var ownKeys = __webpack_require__(132);

// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$({ target: 'Reflect', stat: true }, {
  ownKeys: ownKeys
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var getBuiltIn = __webpack_require__(15);
var anObject = __webpack_require__(7);
var FREEZING = __webpack_require__(78);

// `Reflect.preventExtensions` method
// https://tc39.es/ecma262/#sec-reflect.preventextensions
$({ target: 'Reflect', stat: true, sham: !FREEZING }, {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      var objectPreventExtensions = getBuiltIn('Object', 'preventExtensions');
      if (objectPreventExtensions) objectPreventExtensions(target);
      return true;
    } catch (error) {
      return false;
    }
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var call = __webpack_require__(6);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(9);
var isDataDescriptor = __webpack_require__(216);
var fails = __webpack_require__(1);
var definePropertyModule = __webpack_require__(17);
var getOwnPropertyDescriptorModule = __webpack_require__(26);
var getPrototypeOf = __webpack_require__(34);
var createPropertyDescriptor = __webpack_require__(37);

// `Reflect.set` method
// https://tc39.es/ecma262/#sec-reflect.set
function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDescriptor = getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
  var existingDescriptor, prototype, setter;
  if (!ownDescriptor) {
    if (isObject(prototype = getPrototypeOf(target))) {
      return set(prototype, propertyKey, V, receiver);
    }
    ownDescriptor = createPropertyDescriptor(0);
  }
  if (isDataDescriptor(ownDescriptor)) {
    if (ownDescriptor.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = getOwnPropertyDescriptorModule.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      definePropertyModule.f(receiver, propertyKey, existingDescriptor);
    } else definePropertyModule.f(receiver, propertyKey, createPropertyDescriptor(0, V));
  } else {
    setter = ownDescriptor.set;
    if (setter === undefined) return false;
    call(setter, receiver, V);
  } return true;
}

// MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype
var MS_EDGE_BUG = fails(function () {
  var Constructor = function () { /* empty */ };
  var object = definePropertyModule.f(new Constructor(), 'a', { configurable: true });
  // eslint-disable-next-line es/no-reflect -- required for testing
  return Reflect.set(Constructor.prototype, 'a', 1, object) !== false;
});

$({ target: 'Reflect', stat: true, forced: MS_EDGE_BUG }, {
  set: set
});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var anObject = __webpack_require__(7);
var aPossiblePrototype = __webpack_require__(183);
var objectSetPrototypeOf = __webpack_require__(45);

// `Reflect.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.setprototypeof
if (objectSetPrototypeOf) $({ target: 'Reflect', stat: true }, {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    anObject(target);
    aPossiblePrototype(proto);
    try {
      objectSetPrototypeOf(target, proto);
      return true;
    } catch (error) {
      return false;
    }
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var setToStringTag = __webpack_require__(33);

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(global.Reflect, 'Reflect', true);


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var global = __webpack_require__(3);
var uncurryThis = __webpack_require__(2);
var isForced = __webpack_require__(84);
var inheritIfRequired = __webpack_require__(74);
var createNonEnumerableProperty = __webpack_require__(28);
var getOwnPropertyNames = __webpack_require__(58).f;
var isPrototypeOf = __webpack_require__(38);
var isRegExp = __webpack_require__(96);
var toString = __webpack_require__(5);
var getRegExpFlags = __webpack_require__(97);
var stickyHelpers = __webpack_require__(122);
var proxyAccessor = __webpack_require__(184);
var defineBuiltIn = __webpack_require__(16);
var fails = __webpack_require__(1);
var hasOwn = __webpack_require__(12);
var enforceInternalState = __webpack_require__(22).enforce;
var setSpecies = __webpack_require__(76);
var wellKnownSymbol = __webpack_require__(11);
var UNSUPPORTED_DOT_ALL = __webpack_require__(157);
var UNSUPPORTED_NCG = __webpack_require__(217);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global.SyntaxError;
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr += charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  defineBuiltIn(global, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var UNSUPPORTED_DOT_ALL = __webpack_require__(157);
var classof = __webpack_require__(27);
var defineBuiltInAccessor = __webpack_require__(24);
var getInternalState = __webpack_require__(22).get;

var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
  defineBuiltInAccessor(RegExpPrototype, 'dotAll', {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).dotAll;
      }
      throw new $TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(4);
var defineBuiltInAccessor = __webpack_require__(24);
var regExpFlags = __webpack_require__(156);
var fails = __webpack_require__(1);

// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var RegExp = global.RegExp;
var RegExpPrototype = RegExp.prototype;

var FORCED = DESCRIPTORS && fails(function () {
  var INDICES_SUPPORT = true;
  try {
    RegExp('.', 'd');
  } catch (error) {
    INDICES_SUPPORT = false;
  }

  var O = {};
  // modern V8 bug
  var calls = '';
  var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';

  var addGetter = function (key, chr) {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(O, key, { get: function () {
      calls += chr;
      return true;
    } });
  };

  var pairs = {
    dotAll: 's',
    global: 'g',
    ignoreCase: 'i',
    multiline: 'm',
    sticky: 'y'
  };

  if (INDICES_SUPPORT) pairs.hasIndices = 'd';

  for (var key in pairs) addGetter(key, pairs[key]);

  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
  var result = Object.getOwnPropertyDescriptor(RegExpPrototype, 'flags').get.call(O);

  return result !== expected || calls !== expected;
});

// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if (FORCED) defineBuiltInAccessor(RegExpPrototype, 'flags', {
  configurable: true,
  get: regExpFlags
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var MISSED_STICKY = __webpack_require__(122).MISSED_STICKY;
var classof = __webpack_require__(27);
var defineBuiltInAccessor = __webpack_require__(24);
var getInternalState = __webpack_require__(22).get;

var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;

// `RegExp.prototype.sticky` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky
if (DESCRIPTORS && MISSED_STICKY) {
  defineBuiltInAccessor(RegExpPrototype, 'sticky', {
    configurable: true,
    get: function sticky() {
      if (this === RegExpPrototype) return;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).sticky;
      }
      throw new $TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(158);
var $ = __webpack_require__(0);
var call = __webpack_require__(6);
var isCallable = __webpack_require__(10);
var anObject = __webpack_require__(7);
var toString = __webpack_require__(5);

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject(this);
    var string = toString(S);
    var exec = R.exec;
    if (!isCallable(exec)) return call(nativeTest, R, string);
    var result = call(exec, R, string);
    if (result === null) return false;
    anObject(result);
    return true;
  }
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PROPER_FUNCTION_NAME = __webpack_require__(72).PROPER;
var defineBuiltIn = __webpack_require__(16);
var anObject = __webpack_require__(7);
var $toString = __webpack_require__(5);
var fails = __webpack_require__(1);
var getRegExpFlags = __webpack_require__(97);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(442);


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(115);
var collectionStrong = __webpack_require__(203);

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var requireObjectCoercible = __webpack_require__(18);
var toIntegerOrInfinity = __webpack_require__(21);
var toString = __webpack_require__(5);
var fails = __webpack_require__(1);

var charAt = uncurryThis(''.charAt);

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-array-string-prototype-at -- safe
  return '𠮷'.at(-2) !== '\uD842';
});

// `String.prototype.at` method
// https://tc39.es/ecma262/#sec-string.prototype.at
$({ target: 'String', proto: true, forced: FORCED }, {
  at: function at(index) {
    var S = toString(requireObjectCoercible(this));
    var len = S.length;
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return (k < 0 || k >= len) ? undefined : charAt(S, k);
  }
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var codeAt = __webpack_require__(124).codeAt;

// `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat
$({ target: 'String', proto: true }, {
  codePointAt: function codePointAt(pos) {
    return codeAt(this, pos);
  }
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(59);
var getOwnPropertyDescriptor = __webpack_require__(26).f;
var toLength = __webpack_require__(32);
var toString = __webpack_require__(5);
var notARegExp = __webpack_require__(159);
var requireObjectCoercible = __webpack_require__(18);
var correctIsRegExpLogic = __webpack_require__(160);
var IS_PURE = __webpack_require__(20);

// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var nativeEndsWith = uncurryThis(''.endsWith);
var slice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return nativeEndsWith
      ? nativeEndsWith(that, search, end)
      : slice(that, end - search.length, end) === search;
  }
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(43);

var $RangeError = RangeError;
var fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;
var join = uncurryThis([].join);

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length !== 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$({ target: 'String', stat: true, arity: 1, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw new $RangeError(code + ' is not a valid code point');
      elements[i] = code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
    } return join(elements, '');
  }
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var notARegExp = __webpack_require__(159);
var requireObjectCoercible = __webpack_require__(18);
var toString = __webpack_require__(5);
var correctIsRegExpLogic = __webpack_require__(160);

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var requireObjectCoercible = __webpack_require__(18);
var toString = __webpack_require__(5);

var charCodeAt = uncurryThis(''.charCodeAt);

// `String.prototype.isWellFormed` method
// https://github.com/tc39/proposal-is-usv-string
$({ target: 'String', proto: true }, {
  isWellFormed: function isWellFormed() {
    var S = toString(requireObjectCoercible(this));
    var length = S.length;
    for (var i = 0; i < length; i++) {
      var charCode = charCodeAt(S, i);
      // single UTF-16 code unit
      if ((charCode & 0xF800) !== 0xD800) continue;
      // unpaired surrogate
      if (charCode >= 0xDC00 || ++i >= length || (charCodeAt(S, i) & 0xFC00) !== 0xDC00) return false;
    } return true;
  }
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(125);
var anObject = __webpack_require__(7);
var isNullOrUndefined = __webpack_require__(29);
var toLength = __webpack_require__(32);
var toString = __webpack_require__(5);
var requireObjectCoercible = __webpack_require__(18);
var getMethod = __webpack_require__(52);
var advanceStringIndex = __webpack_require__(126);
var regExpExec = __webpack_require__(98);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-string-prototype-matchall -- safe */
var $ = __webpack_require__(0);
var call = __webpack_require__(6);
var uncurryThis = __webpack_require__(59);
var createIteratorConstructor = __webpack_require__(143);
var createIterResultObject = __webpack_require__(92);
var requireObjectCoercible = __webpack_require__(18);
var toLength = __webpack_require__(32);
var toString = __webpack_require__(5);
var anObject = __webpack_require__(7);
var isNullOrUndefined = __webpack_require__(29);
var classof = __webpack_require__(27);
var isRegExp = __webpack_require__(96);
var getRegExpFlags = __webpack_require__(97);
var getMethod = __webpack_require__(52);
var defineBuiltIn = __webpack_require__(16);
var fails = __webpack_require__(1);
var wellKnownSymbol = __webpack_require__(11);
var speciesConstructor = __webpack_require__(77);
var advanceStringIndex = __webpack_require__(126);
var regExpExec = __webpack_require__(98);
var InternalStateModule = __webpack_require__(22);
var IS_PURE = __webpack_require__(20);

var MATCH_ALL = wellKnownSymbol('matchAll');
var REGEXP_STRING = 'RegExp String';
var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;
var stringIndexOf = uncurryThis(''.indexOf);
var nativeMatchAll = uncurryThis(''.matchAll);

var WORKS_WITH_NON_GLOBAL_REGEX = !!nativeMatchAll && !fails(function () {
  nativeMatchAll('a', /./);
});

var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
  setInternalState(this, {
    type: REGEXP_STRING_ITERATOR,
    regexp: regexp,
    string: string,
    global: $global,
    unicode: fullUnicode,
    done: false
  });
}, REGEXP_STRING, function next() {
  var state = getInternalState(this);
  if (state.done) return createIterResultObject(undefined, true);
  var R = state.regexp;
  var S = state.string;
  var match = regExpExec(R, S);
  if (match === null) {
    state.done = true;
    return createIterResultObject(undefined, true);
  }
  if (state.global) {
    if (toString(match[0]) === '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
    return createIterResultObject(match, false);
  }
  state.done = true;
  return createIterResultObject(match, false);
});

var $matchAll = function (string) {
  var R = anObject(this);
  var S = toString(string);
  var C = speciesConstructor(R, RegExp);
  var flags = toString(getRegExpFlags(R));
  var matcher, $global, fullUnicode;
  matcher = new C(C === RegExp ? R.source : R, flags);
  $global = !!~stringIndexOf(flags, 'g');
  fullUnicode = !!~stringIndexOf(flags, 'u');
  matcher.lastIndex = toLength(R.lastIndex);
  return new $RegExpStringIterator(matcher, S, $global, fullUnicode);
};

// `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall
$({ target: 'String', proto: true, forced: WORKS_WITH_NON_GLOBAL_REGEX }, {
  matchAll: function matchAll(regexp) {
    var O = requireObjectCoercible(this);
    var flags, S, matcher, rx;
    if (!isNullOrUndefined(regexp)) {
      if (isRegExp(regexp)) {
        flags = toString(requireObjectCoercible(getRegExpFlags(regexp)));
        if (!~stringIndexOf(flags, 'g')) throw new $TypeError('`.matchAll` does not allow non-global regexes');
      }
      if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
      matcher = getMethod(regexp, MATCH_ALL);
      if (matcher === undefined && IS_PURE && classof(regexp) === 'RegExp') matcher = $matchAll;
      if (matcher) return call(matcher, regexp, O);
    } else if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
    S = toString(O);
    rx = new RegExp(regexp, 'g');
    return IS_PURE ? call($matchAll, rx, S) : rx[MATCH_ALL](S);
  }
});

IS_PURE || MATCH_ALL in RegExpPrototype || defineBuiltIn(RegExpPrototype, MATCH_ALL, $matchAll);


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $padEnd = __webpack_require__(151).end;
var WEBKIT_BUG = __webpack_require__(219);

// `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $padStart = __webpack_require__(151).start;
var WEBKIT_BUG = __webpack_require__(219);

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var toIndexedObject = __webpack_require__(23);
var toObject = __webpack_require__(13);
var toString = __webpack_require__(5);
var lengthOfArrayLike = __webpack_require__(14);

var push = uncurryThis([].push);
var join = uncurryThis([].join);

// `String.raw` method
// https://tc39.es/ecma262/#sec-string.raw
$({ target: 'String', stat: true }, {
  raw: function raw(template) {
    var rawTemplate = toIndexedObject(toObject(template).raw);
    var literalSegments = lengthOfArrayLike(rawTemplate);
    if (!literalSegments) return '';
    var argumentsLength = arguments.length;
    var elements = [];
    var i = 0;
    while (true) {
      push(elements, toString(rawTemplate[i++]));
      if (i === literalSegments) return join(elements, '');
      if (i < argumentsLength) push(elements, toString(arguments[i]));
    }
  }
});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var repeat = __webpack_require__(114);

// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$({ target: 'String', proto: true }, {
  repeat: repeat
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__(40);
var call = __webpack_require__(6);
var uncurryThis = __webpack_require__(2);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(125);
var fails = __webpack_require__(1);
var anObject = __webpack_require__(7);
var isCallable = __webpack_require__(10);
var isNullOrUndefined = __webpack_require__(29);
var toIntegerOrInfinity = __webpack_require__(21);
var toLength = __webpack_require__(32);
var toString = __webpack_require__(5);
var requireObjectCoercible = __webpack_require__(18);
var advanceStringIndex = __webpack_require__(126);
var getMethod = __webpack_require__(52);
var getSubstitution = __webpack_require__(220);
var regExpExec = __webpack_require__(98);
var wellKnownSymbol = __webpack_require__(11);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var call = __webpack_require__(6);
var uncurryThis = __webpack_require__(2);
var requireObjectCoercible = __webpack_require__(18);
var isCallable = __webpack_require__(10);
var isNullOrUndefined = __webpack_require__(29);
var isRegExp = __webpack_require__(96);
var toString = __webpack_require__(5);
var getMethod = __webpack_require__(52);
var getRegExpFlags = __webpack_require__(97);
var getSubstitution = __webpack_require__(220);
var wellKnownSymbol = __webpack_require__(11);
var IS_PURE = __webpack_require__(20);

var REPLACE = wellKnownSymbol('replace');
var $TypeError = TypeError;
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var max = Math.max;

var stringIndexOf = function (string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return indexOf(string, searchValue, fromIndex);
};

// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$({ target: 'String', proto: true }, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';
    if (!isNullOrUndefined(searchValue)) {
      IS_REG_EXP = isRegExp(searchValue);
      if (IS_REG_EXP) {
        flags = toString(requireObjectCoercible(getRegExpFlags(searchValue)));
        if (!~indexOf(flags, 'g')) throw new $TypeError('`.replaceAll` does not allow non-global regexes');
      }
      replacer = getMethod(searchValue, REPLACE);
      if (replacer) {
        return call(replacer, searchValue, O, replaceValue);
      } else if (IS_PURE && IS_REG_EXP) {
        return replace(toString(O), searchValue, replaceValue);
      }
    }
    string = toString(O);
    searchString = toString(searchValue);
    functionalReplace = isCallable(replaceValue);
    if (!functionalReplace) replaceValue = toString(replaceValue);
    searchLength = searchString.length;
    advanceBy = max(1, searchLength);
    position = stringIndexOf(string, searchString, 0);
    while (position !== -1) {
      replacement = functionalReplace
        ? toString(replaceValue(searchString, position, string))
        : getSubstitution(searchString, string, position, [], undefined, replaceValue);
      result += stringSlice(string, endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf(string, searchString, position + advanceBy);
    }
    if (endOfLastMatch < string.length) {
      result += stringSlice(string, endOfLastMatch);
    }
    return result;
  }
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(125);
var anObject = __webpack_require__(7);
var isNullOrUndefined = __webpack_require__(29);
var requireObjectCoercible = __webpack_require__(18);
var sameValue = __webpack_require__(210);
var toString = __webpack_require__(5);
var getMethod = __webpack_require__(52);
var regExpExec = __webpack_require__(98);

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__(40);
var call = __webpack_require__(6);
var uncurryThis = __webpack_require__(2);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(125);
var anObject = __webpack_require__(7);
var isNullOrUndefined = __webpack_require__(29);
var isRegExp = __webpack_require__(96);
var requireObjectCoercible = __webpack_require__(18);
var speciesConstructor = __webpack_require__(77);
var advanceStringIndex = __webpack_require__(126);
var toLength = __webpack_require__(32);
var toString = __webpack_require__(5);
var getMethod = __webpack_require__(52);
var arraySlice = __webpack_require__(86);
var callRegExpExec = __webpack_require__(98);
var regexpExec = __webpack_require__(123);
var stickyHelpers = __webpack_require__(122);
var fails = __webpack_require__(1);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] === 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length !== 4 ||
    'ab'.split(/(?:ab)*/).length !== 2 ||
    '.'.split(/(.?)(.?)/).length !== 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(59);
var getOwnPropertyDescriptor = __webpack_require__(26).f;
var toLength = __webpack_require__(32);
var toString = __webpack_require__(5);
var notARegExp = __webpack_require__(159);
var requireObjectCoercible = __webpack_require__(18);
var correctIsRegExpLogic = __webpack_require__(160);
var IS_PURE = __webpack_require__(20);

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var requireObjectCoercible = __webpack_require__(18);
var toIntegerOrInfinity = __webpack_require__(21);
var toString = __webpack_require__(5);

var stringSlice = uncurryThis(''.slice);
var max = Math.max;
var min = Math.min;

// eslint-disable-next-line unicorn/prefer-string-slice -- required for testing
var FORCED = !''.substr || 'ab'.substr(-1) !== 'b';

// `String.prototype.substr` method
// https://tc39.es/ecma262/#sec-string.prototype.substr
$({ target: 'String', proto: true, forced: FORCED }, {
  substr: function substr(start, length) {
    var that = toString(requireObjectCoercible(this));
    var size = that.length;
    var intStart = toIntegerOrInfinity(start);
    var intLength, intEnd;
    if (intStart === Infinity) intStart = 0;
    if (intStart < 0) intStart = max(size + intStart, 0);
    intLength = length === undefined ? size : toIntegerOrInfinity(length);
    if (intLength <= 0 || intLength === Infinity) return '';
    intEnd = min(intStart + intLength, size);
    return intStart >= intEnd ? '' : stringSlice(that, intStart, intEnd);
  }
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var call = __webpack_require__(6);
var uncurryThis = __webpack_require__(2);
var requireObjectCoercible = __webpack_require__(18);
var toString = __webpack_require__(5);
var fails = __webpack_require__(1);

var $Array = Array;
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var join = uncurryThis([].join);
// eslint-disable-next-line es/no-string-prototype-iswellformed-towellformed -- safe
var $toWellFormed = ''.toWellFormed;
var REPLACEMENT_CHARACTER = '\uFFFD';

// Safari bug
var TO_STRING_CONVERSION_BUG = $toWellFormed && fails(function () {
  return call($toWellFormed, 1) !== '1';
});

// `String.prototype.toWellFormed` method
// https://github.com/tc39/proposal-is-usv-string
$({ target: 'String', proto: true, forced: TO_STRING_CONVERSION_BUG }, {
  toWellFormed: function toWellFormed() {
    var S = toString(requireObjectCoercible(this));
    if (TO_STRING_CONVERSION_BUG) return call($toWellFormed, S);
    var length = S.length;
    var result = $Array(length);
    for (var i = 0; i < length; i++) {
      var charCode = charCodeAt(S, i);
      // single UTF-16 code unit
      if ((charCode & 0xF800) !== 0xD800) result[i] = charAt(S, i);
      // unpaired surrogate
      else if (charCode >= 0xDC00 || i + 1 >= length || (charCodeAt(S, i + 1) & 0xFC00) !== 0xDC00) result[i] = REPLACEMENT_CHARACTER;
      // surrogate pair
      else {
        result[i] = charAt(S, i);
        result[++i] = charAt(S, i);
      }
    } return join(result, '');
  }
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var $trim = __webpack_require__(79).trim;
var forcedStringTrimMethod = __webpack_require__(161);

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this line from `core-js@4`
__webpack_require__(464);
var $ = __webpack_require__(0);
var trimEnd = __webpack_require__(221);

// `String.prototype.trimEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$({ target: 'String', proto: true, name: 'trimEnd', forced: ''.trimEnd !== trimEnd }, {
  trimEnd: trimEnd
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var trimEnd = __webpack_require__(221);

// `String.prototype.trimRight` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$({ target: 'String', proto: true, name: 'trimEnd', forced: ''.trimRight !== trimEnd }, {
  trimRight: trimEnd
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this line from `core-js@4`
__webpack_require__(466);
var $ = __webpack_require__(0);
var trimStart = __webpack_require__(222);

// `String.prototype.trimStart` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$({ target: 'String', proto: true, name: 'trimStart', forced: ''.trimStart !== trimStart }, {
  trimStart: trimStart
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var trimStart = __webpack_require__(222);

// `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$({ target: 'String', proto: true, name: 'trimStart', forced: ''.trimLeft !== trimStart }, {
  trimLeft: trimStart
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
  anchor: function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.big` method
// https://tc39.es/ecma262/#sec-string.prototype.big
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('big') }, {
  big: function big() {
    return createHTML(this, 'big', '', '');
  }
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.blink` method
// https://tc39.es/ecma262/#sec-string.prototype.blink
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('blink') }, {
  blink: function blink() {
    return createHTML(this, 'blink', '', '');
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
  bold: function bold() {
    return createHTML(this, 'b', '', '');
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fixed') }, {
  fixed: function fixed() {
    return createHTML(this, 'tt', '', '');
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.fontcolor` method
// https://tc39.es/ecma262/#sec-string.prototype.fontcolor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fontcolor') }, {
  fontcolor: function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  }
});


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.fontsize` method
// https://tc39.es/ecma262/#sec-string.prototype.fontsize
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fontsize') }, {
  fontsize: function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('italics') }, {
  italics: function italics() {
    return createHTML(this, 'i', '', '');
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.strike` method
// https://tc39.es/ecma262/#sec-string.prototype.strike
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('strike') }, {
  strike: function strike() {
    return createHTML(this, 'strike', '', '');
  }
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
  sub: function sub() {
    return createHTML(this, 'sub', '', '');
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var createHTML = __webpack_require__(35);
var forcedStringHTMLMethod = __webpack_require__(36);

// `String.prototype.sup` method
// https://tc39.es/ecma262/#sec-string.prototype.sup
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sup') }, {
  sup: function sup() {
    return createHTML(this, 'sup', '', '');
  }
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createTypedArrayConstructor = __webpack_require__(56);

// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Float32', function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(21);

var $RangeError = RangeError;

module.exports = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw new $RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var round = Math.round;

module.exports = function (it) {
  var value = round(it);
  return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createTypedArrayConstructor = __webpack_require__(56);

// `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Float64', function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createTypedArrayConstructor = __webpack_require__(56);

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int8', function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createTypedArrayConstructor = __webpack_require__(56);

// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int16', function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createTypedArrayConstructor = __webpack_require__(56);

// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int32', function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createTypedArrayConstructor = __webpack_require__(56);

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createTypedArrayConstructor = __webpack_require__(56);

// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createTypedArrayConstructor = __webpack_require__(56);

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint16', function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var createTypedArrayConstructor = __webpack_require__(56);

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint32', function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var lengthOfArrayLike = __webpack_require__(14);
var toIntegerOrInfinity = __webpack_require__(21);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.at` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.at
exportTypedArrayMethod('at', function at(index) {
  var O = aTypedArray(this);
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
  return (k < 0 || k >= len) ? undefined : O[k];
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var ArrayBufferViewCore = __webpack_require__(8);
var $ArrayCopyWithin = __webpack_require__(190);

var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
  return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $every = __webpack_require__(25).every;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $fill = __webpack_require__(141);
var toBigInt = __webpack_require__(163);
var classof = __webpack_require__(44);
var call = __webpack_require__(6);
var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(1);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var slice = uncurryThis(''.slice);

// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails(function () {
  var count = 0;
  // eslint-disable-next-line es/no-typed-arrays -- safe
  new Int8Array(2).fill({ valueOf: function () { return count++; } });
  return count !== 1;
});

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  aTypedArray(this);
  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return call($fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $filter = __webpack_require__(25).filter;
var fromSpeciesAndList = __webpack_require__(496);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSpeciesAndList(this, list);
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var arrayFromConstructorAndList = __webpack_require__(147);
var typedArraySpeciesConstructor = __webpack_require__(127);

module.exports = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $find = __webpack_require__(25).find;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $findIndex = __webpack_require__(25).findIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $findLast = __webpack_require__(109).findLast;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findLast` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findlast
exportTypedArrayMethod('findLast', function findLast(predicate /* , thisArg */) {
  return $findLast(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $findLastIndex = __webpack_require__(109).findLastIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findLastIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findlastindex
exportTypedArrayMethod('findLastIndex', function findLastIndex(predicate /* , thisArg */) {
  return $findLastIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $forEach = __webpack_require__(25).forEach;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(162);
var exportTypedArrayStaticMethod = __webpack_require__(8).exportTypedArrayStaticMethod;
var typedArrayFrom = __webpack_require__(224);

// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
exportTypedArrayStaticMethod('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $includes = __webpack_require__(83).includes;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $indexOf = __webpack_require__(83).indexOf;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var fails = __webpack_require__(1);
var uncurryThis = __webpack_require__(2);
var ArrayBufferViewCore = __webpack_require__(8);
var ArrayIterators = __webpack_require__(111);
var wellKnownSymbol = __webpack_require__(11);

var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array = global.Uint8Array;
var arrayValues = uncurryThis(ArrayIterators.values);
var arrayKeys = uncurryThis(ArrayIterators.keys);
var arrayEntries = uncurryThis(ArrayIterators.entries);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array && Uint8Array.prototype;

var GENERIC = !fails(function () {
  TypedArrayPrototype[ITERATOR].call([1]);
});

var ITERATOR_IS_VALUES = !!TypedArrayPrototype
  && TypedArrayPrototype.values
  && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values
  && TypedArrayPrototype.values.name === 'values';

var typedArrayValues = function values() {
  return arrayValues(aTypedArray(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod('entries', function entries() {
  return arrayEntries(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod('keys', function keys() {
  return arrayKeys(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var uncurryThis = __webpack_require__(2);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = uncurryThis([].join);

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
exportTypedArrayMethod('join', function join(separator) {
  return $join(aTypedArray(this), separator);
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var apply = __webpack_require__(40);
var $lastIndexOf = __webpack_require__(195);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  var length = arguments.length;
  return apply($lastIndexOf, aTypedArray(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $map = __webpack_require__(25).map;
var typedArraySpeciesConstructor = __webpack_require__(127);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
  return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor(O))(length);
  });
});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(162);

var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayStaticMethod = ArrayBufferViewCore.exportTypedArrayStaticMethod;

// `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of
exportTypedArrayStaticMethod('of', function of(/* ...items */) {
  var index = 0;
  var length = arguments.length;
  var result = new (aTypedArrayConstructor(this))(length);
  while (length > index) result[index] = arguments[index++];
  return result;
}, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $reduce = __webpack_require__(112).left;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $reduceRight = __webpack_require__(112).right;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var floor = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod('reverse', function reverse() {
  var that = this;
  var length = aTypedArray(that).length;
  var middle = floor(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var call = __webpack_require__(6);
var ArrayBufferViewCore = __webpack_require__(8);
var lengthOfArrayLike = __webpack_require__(14);
var toOffset = __webpack_require__(223);
var toIndexedObject = __webpack_require__(13);
var fails = __webpack_require__(1);

var RangeError = global.RangeError;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw new RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var typedArraySpeciesConstructor = __webpack_require__(127);
var fails = __webpack_require__(1);
var arraySlice = __webpack_require__(63);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod('slice', function slice(start, end) {
  var list = arraySlice(aTypedArray(this), start, end);
  var C = typedArraySpeciesConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED);


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var $some = __webpack_require__(25).some;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var uncurryThis = __webpack_require__(59);
var fails = __webpack_require__(1);
var aCallable = __webpack_require__(19);
var internalSort = __webpack_require__(145);
var ArrayBufferViewCore = __webpack_require__(8);
var FF = __webpack_require__(196);
var IE_OR_EDGE = __webpack_require__(197);
var V8 = __webpack_require__(50);
var WEBKIT = __webpack_require__(146);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = global.Uint16Array;
var nativeSort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function () {
  nativeSort(new Uint16Array(2), null);
}) && fails(function () {
  nativeSort(new Uint16Array(2), {});
}));

var STABLE_SORT = !!nativeSort && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort(this, comparefn);

  return internalSort(aTypedArray(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var toLength = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(43);
var typedArraySpeciesConstructor = __webpack_require__(127);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod('subarray', function subarray(begin, end) {
  var O = aTypedArray(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var apply = __webpack_require__(40);
var ArrayBufferViewCore = __webpack_require__(8);
var fails = __webpack_require__(1);
var arraySlice = __webpack_require__(63);

var Int8Array = global.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
  $toLocaleString.call(new Int8Array(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() !== new Int8Array([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return apply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
    arraySlice(arguments)
  );
}, FORCED);


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var arrayToReversed = __webpack_require__(198);
var ArrayBufferViewCore = __webpack_require__(8);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// `%TypedArray%.prototype.toReversed` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.toreversed
exportTypedArrayMethod('toReversed', function toReversed() {
  return arrayToReversed(aTypedArray(this), getTypedArrayConstructor(this));
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(8);
var uncurryThis = __webpack_require__(2);
var aCallable = __webpack_require__(19);
var arrayFromConstructorAndList = __webpack_require__(147);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var sort = uncurryThis(ArrayBufferViewCore.TypedArrayPrototype.sort);

// `%TypedArray%.prototype.toSorted` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tosorted
exportTypedArrayMethod('toSorted', function toSorted(compareFn) {
  if (compareFn !== undefined) aCallable(compareFn);
  var O = aTypedArray(this);
  var A = arrayFromConstructorAndList(getTypedArrayConstructor(O), O);
  return sort(A, compareFn);
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var exportTypedArrayMethod = __webpack_require__(8).exportTypedArrayMethod;
var fails = __webpack_require__(1);
var global = __webpack_require__(3);
var uncurryThis = __webpack_require__(2);

var Uint8Array = global.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var join = uncurryThis([].join);

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return join(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString !== arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var arrayWith = __webpack_require__(199);
var ArrayBufferViewCore = __webpack_require__(8);
var isBigIntArray = __webpack_require__(225);
var toIntegerOrInfinity = __webpack_require__(21);
var toBigInt = __webpack_require__(163);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var PROPER_ORDER = !!function () {
  try {
    // eslint-disable-next-line no-throw-literal, es/no-typed-arrays, es/no-array-prototype-with -- required for testing
    new Int8Array(1)['with'](2, { valueOf: function () { throw 8; } });
  } catch (error) {
    // some early implementations, like WebKit, does not follow the final semantic
    // https://github.com/tc39/proposal-change-array-by-copy/pull/86
    return error === 8;
  }
}();

// `%TypedArray%.prototype.with` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.with
exportTypedArrayMethod('with', { 'with': function (index, value) {
  var O = aTypedArray(this);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualValue = isBigIntArray(O) ? toBigInt(value) : +value;
  return arrayWith(O, getTypedArrayConstructor(O), relativeIndex, actualValue);
} }['with'], !PROPER_ORDER);


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var uncurryThis = __webpack_require__(2);
var toString = __webpack_require__(5);

var fromCharCode = String.fromCharCode;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var stringSlice = uncurryThis(''.slice);

var hex2 = /^[\da-f]{2}$/i;
var hex4 = /^[\da-f]{4}$/i;

// `unescape` method
// https://tc39.es/ecma262/#sec-unescape-string
$({ global: true }, {
  unescape: function unescape(string) {
    var str = toString(string);
    var result = '';
    var length = str.length;
    var index = 0;
    var chr, part;
    while (index < length) {
      chr = charAt(str, index++);
      if (chr === '%') {
        if (charAt(str, index) === 'u') {
          part = stringSlice(str, index + 1, index + 5);
          if (exec(hex4, part)) {
            result += fromCharCode(parseInt(part, 16));
            index += 5;
            continue;
          }
        } else {
          part = stringSlice(str, index, index + 2);
          if (exec(hex2, part)) {
            result += fromCharCode(parseInt(part, 16));
            index += 2;
            continue;
          }
        }
      }
      result += chr;
    } return result;
  }
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(525);


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FREEZING = __webpack_require__(78);
var global = __webpack_require__(3);
var uncurryThis = __webpack_require__(2);
var defineBuiltIns = __webpack_require__(93);
var InternalMetadataModule = __webpack_require__(64);
var collection = __webpack_require__(115);
var collectionWeak = __webpack_require__(226);
var isObject = __webpack_require__(9);
var enforceInternalState = __webpack_require__(22).enforce;
var fails = __webpack_require__(1);
var NATIVE_WEAK_MAP = __webpack_require__(174);

var $Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = $Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var isFrozen = $Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var isSealed = $Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var freeze = $Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var seal = $Object.seal;

var FROZEN = {};
var SEALED = {};
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection('WeakMap', wrapper, collectionWeak);
var WeakMapPrototype = $WeakMap.prototype;
var nativeSet = uncurryThis(WeakMapPrototype.set);

// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var hasMSEdgeFreezingBug = function () {
  return FREEZING && fails(function () {
    var frozenArray = freeze([]);
    nativeSet(new $WeakMap(), frozenArray, 1);
    return !isFrozen(frozenArray);
  });
};

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP) if (IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
  var nativeHas = uncurryThis(WeakMapPrototype.has);
  var nativeGet = uncurryThis(WeakMapPrototype.get);
  defineBuiltIns(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen['delete'](key);
      } return nativeDelete(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      } return nativeHas(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      } return nativeGet(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else nativeSet(this, key, value);
      return this;
    }
  });
// Chakra Edge frozen keys fix
} else if (hasMSEdgeFreezingBug()) {
  defineBuiltIns(WeakMapPrototype, {
    set: function set(key, value) {
      var arrayIntegrityLevel;
      if (isArray(key)) {
        if (isFrozen(key)) arrayIntegrityLevel = FROZEN;
        else if (isSealed(key)) arrayIntegrityLevel = SEALED;
      }
      nativeSet(this, key, value);
      if (arrayIntegrityLevel === FROZEN) freeze(key);
      if (arrayIntegrityLevel === SEALED) seal(key);
      return this;
    }
  });
}


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(527);


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(115);
var collectionWeak = __webpack_require__(226);

// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
collection('WeakSet', function (init) {
  return function WeakSet() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionWeak);


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var getBuiltIn = __webpack_require__(15);
var uncurryThis = __webpack_require__(2);
var call = __webpack_require__(6);
var fails = __webpack_require__(1);
var toString = __webpack_require__(5);
var hasOwn = __webpack_require__(12);
var validateArgumentsLength = __webpack_require__(42);
var ctoi = __webpack_require__(227).ctoi;

var disallowed = /[^\d+/a-z]/i;
var whitespaces = /[\t\n\f\r ]+/g;
var finalEq = /[=]{1,2}$/;

var $atob = getBuiltIn('atob');
var fromCharCode = String.fromCharCode;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var exec = uncurryThis(disallowed.exec);

var NO_SPACES_IGNORE = fails(function () {
  return $atob(' ') !== '';
});

var NO_ENCODING_CHECK = !fails(function () {
  $atob('a');
});

var NO_ARG_RECEIVING_CHECK = !NO_SPACES_IGNORE && !NO_ENCODING_CHECK && !fails(function () {
  $atob();
});

var WRONG_ARITY = !NO_SPACES_IGNORE && !NO_ENCODING_CHECK && $atob.length !== 1;

// `atob` method
// https://html.spec.whatwg.org/multipage/webappapis.html#dom-atob
$({ global: true, bind: true, enumerable: true, forced: NO_SPACES_IGNORE || NO_ENCODING_CHECK || NO_ARG_RECEIVING_CHECK || WRONG_ARITY }, {
  atob: function atob(data) {
    validateArgumentsLength(arguments.length, 1);
    // `webpack` dev server bug on IE global methods - use call(fn, global, ...)
    if (NO_ARG_RECEIVING_CHECK || WRONG_ARITY) return call($atob, global, data);
    var string = replace(toString(data), whitespaces, '');
    var output = '';
    var position = 0;
    var bc = 0;
    var chr, bs;
    if (string.length % 4 === 0) {
      string = replace(string, finalEq, '');
    }
    if (string.length % 4 === 1 || exec(disallowed, string)) {
      throw new (getBuiltIn('DOMException'))('The string is not correctly encoded', 'InvalidCharacterError');
    }
    while (chr = charAt(string, position++)) {
      if (hasOwn(ctoi, chr)) {
        bs = bc % 4 ? bs * 64 + ctoi[chr] : ctoi[chr];
        if (bc++ % 4) output += fromCharCode(255 & bs >> (-2 * bc & 6));
      }
    } return output;
  }
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var getBuiltIn = __webpack_require__(15);
var uncurryThis = __webpack_require__(2);
var call = __webpack_require__(6);
var fails = __webpack_require__(1);
var toString = __webpack_require__(5);
var validateArgumentsLength = __webpack_require__(42);
var itoc = __webpack_require__(227).itoc;

var $btoa = getBuiltIn('btoa');
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);

var NO_ARG_RECEIVING_CHECK = !!$btoa && !fails(function () {
  $btoa();
});

var WRONG_ARG_CONVERSION = !!$btoa && fails(function () {
  return $btoa(null) !== 'bnVsbA==';
});

var WRONG_ARITY = !!$btoa && $btoa.length !== 1;

// `btoa` method
// https://html.spec.whatwg.org/multipage/webappapis.html#dom-btoa
$({ global: true, bind: true, enumerable: true, forced: NO_ARG_RECEIVING_CHECK || WRONG_ARG_CONVERSION || WRONG_ARITY }, {
  btoa: function btoa(data) {
    validateArgumentsLength(arguments.length, 1);
    // `webpack` dev server bug on IE global methods - use call(fn, global, ...)
    if (NO_ARG_RECEIVING_CHECK || WRONG_ARG_CONVERSION || WRONG_ARITY) return call($btoa, global, toString(data));
    var string = toString(data);
    var output = '';
    var position = 0;
    var map = itoc;
    var block, charCode;
    while (charAt(string, position) || (map = '=', position % 1)) {
      charCode = charCodeAt(string, position += 3 / 4);
      if (charCode > 0xFF) {
        throw new (getBuiltIn('DOMException'))('The string contains characters outside of the Latin1 range', 'InvalidCharacterError');
      }
      block = block << 8 | charCode;
      output += charAt(map, 63 & block >> 8 - position % 1 * 8);
    } return output;
  }
});


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var DOMIterables = __webpack_require__(228);
var DOMTokenListPrototype = __webpack_require__(229);
var forEach = __webpack_require__(192);
var createNonEnumerableProperty = __webpack_require__(28);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var DOMIterables = __webpack_require__(228);
var DOMTokenListPrototype = __webpack_require__(229);
var ArrayIteratorMethods = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(28);
var wellKnownSymbol = __webpack_require__(11);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var tryNodeRequire = __webpack_require__(230);
var getBuiltIn = __webpack_require__(15);
var fails = __webpack_require__(1);
var create = __webpack_require__(39);
var createPropertyDescriptor = __webpack_require__(37);
var defineProperty = __webpack_require__(17).f;
var defineBuiltIn = __webpack_require__(16);
var defineBuiltInAccessor = __webpack_require__(24);
var hasOwn = __webpack_require__(12);
var anInstance = __webpack_require__(47);
var anObject = __webpack_require__(7);
var errorToString = __webpack_require__(188);
var normalizeStringArgument = __webpack_require__(88);
var DOMExceptionConstants = __webpack_require__(231);
var clearErrorStack = __webpack_require__(138);
var InternalStateModule = __webpack_require__(22);
var DESCRIPTORS = __webpack_require__(4);
var IS_PURE = __webpack_require__(20);

var DOM_EXCEPTION = 'DOMException';
var DATA_CLONE_ERR = 'DATA_CLONE_ERR';
var Error = getBuiltIn('Error');
// NodeJS < 17.0 does not expose `DOMException` to global
var NativeDOMException = getBuiltIn(DOM_EXCEPTION) || (function () {
  try {
    // NodeJS < 15.0 does not expose `MessageChannel` to global
    var MessageChannel = getBuiltIn('MessageChannel') || tryNodeRequire('worker_threads').MessageChannel;
    // eslint-disable-next-line es/no-weak-map, unicorn/require-post-message-target-origin -- safe
    new MessageChannel().port1.postMessage(new WeakMap());
  } catch (error) {
    if (error.name === DATA_CLONE_ERR && error.code === 25) return error.constructor;
  }
})();
var NativeDOMExceptionPrototype = NativeDOMException && NativeDOMException.prototype;
var ErrorPrototype = Error.prototype;
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(DOM_EXCEPTION);
var HAS_STACK = 'stack' in new Error(DOM_EXCEPTION);

var codeFor = function (name) {
  return hasOwn(DOMExceptionConstants, name) && DOMExceptionConstants[name].m ? DOMExceptionConstants[name].c : 0;
};

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var code = codeFor(name);
  setInternalState(this, {
    type: DOM_EXCEPTION,
    name: name,
    message: message,
    code: code
  });
  if (!DESCRIPTORS) {
    this.name = name;
    this.message = message;
    this.code = code;
  }
  if (HAS_STACK) {
    var error = new Error(message);
    error.name = DOM_EXCEPTION;
    defineProperty(this, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
  }
};

var DOMExceptionPrototype = $DOMException.prototype = create(ErrorPrototype);

var createGetterDescriptor = function (get) {
  return { enumerable: true, configurable: true, get: get };
};

var getterFor = function (key) {
  return createGetterDescriptor(function () {
    return getInternalState(this)[key];
  });
};

if (DESCRIPTORS) {
  // `DOMException.prototype.code` getter
  defineBuiltInAccessor(DOMExceptionPrototype, 'code', getterFor('code'));
  // `DOMException.prototype.message` getter
  defineBuiltInAccessor(DOMExceptionPrototype, 'message', getterFor('message'));
  // `DOMException.prototype.name` getter
  defineBuiltInAccessor(DOMExceptionPrototype, 'name', getterFor('name'));
}

defineProperty(DOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, $DOMException));

// FF36- DOMException is a function, but can't be constructed
var INCORRECT_CONSTRUCTOR = fails(function () {
  return !(new NativeDOMException() instanceof Error);
});

// Safari 10.1 / Chrome 32- / IE8- DOMException.prototype.toString bugs
var INCORRECT_TO_STRING = INCORRECT_CONSTRUCTOR || fails(function () {
  return ErrorPrototype.toString !== errorToString || String(new NativeDOMException(1, 2)) !== '2: 1';
});

// Deno 1.6.3- DOMException.prototype.code just missed
var INCORRECT_CODE = INCORRECT_CONSTRUCTOR || fails(function () {
  return new NativeDOMException(1, 'DataCloneError').code !== 25;
});

// Deno 1.6.3- DOMException constants just missed
var MISSED_CONSTANTS = INCORRECT_CONSTRUCTOR
  || NativeDOMException[DATA_CLONE_ERR] !== 25
  || NativeDOMExceptionPrototype[DATA_CLONE_ERR] !== 25;

var FORCED_CONSTRUCTOR = IS_PURE ? INCORRECT_TO_STRING || INCORRECT_CODE || MISSED_CONSTANTS : INCORRECT_CONSTRUCTOR;

// `DOMException` constructor
// https://webidl.spec.whatwg.org/#idl-DOMException
$({ global: true, constructor: true, forced: FORCED_CONSTRUCTOR }, {
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (INCORRECT_TO_STRING && (IS_PURE || NativeDOMException === PolyfilledDOMException)) {
  defineBuiltIn(PolyfilledDOMExceptionPrototype, 'toString', errorToString);
}

if (INCORRECT_CODE && DESCRIPTORS && NativeDOMException === PolyfilledDOMException) {
  defineBuiltInAccessor(PolyfilledDOMExceptionPrototype, 'code', createGetterDescriptor(function () {
    return codeFor(anObject(this).name);
  }));
}

// `DOMException` constants
for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
  var constant = DOMExceptionConstants[key];
  var constantName = constant.s;
  var descriptor = createPropertyDescriptor(6, constant.c);
  if (!hasOwn(PolyfilledDOMException, constantName)) {
    defineProperty(PolyfilledDOMException, constantName, descriptor);
  }
  if (!hasOwn(PolyfilledDOMExceptionPrototype, constantName)) {
    defineProperty(PolyfilledDOMExceptionPrototype, constantName, descriptor);
  }
}


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var getBuiltIn = __webpack_require__(15);
var createPropertyDescriptor = __webpack_require__(37);
var defineProperty = __webpack_require__(17).f;
var hasOwn = __webpack_require__(12);
var anInstance = __webpack_require__(47);
var inheritIfRequired = __webpack_require__(74);
var normalizeStringArgument = __webpack_require__(88);
var DOMExceptionConstants = __webpack_require__(231);
var clearErrorStack = __webpack_require__(138);
var DESCRIPTORS = __webpack_require__(4);
var IS_PURE = __webpack_require__(20);

var DOM_EXCEPTION = 'DOMException';
var Error = getBuiltIn('Error');
var NativeDOMException = getBuiltIn(DOM_EXCEPTION);

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var that = new NativeDOMException(message, name);
  var error = new Error(message);
  error.name = DOM_EXCEPTION;
  defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
  inheritIfRequired(that, this, $DOMException);
  return that;
};

var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;

var ERROR_HAS_STACK = 'stack' in new Error(DOM_EXCEPTION);
var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var descriptor = NativeDOMException && DESCRIPTORS && Object.getOwnPropertyDescriptor(global, DOM_EXCEPTION);

// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
// https://github.com/Jarred-Sumner/bun/issues/399
var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);

var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;

// `DOMException` constructor patch for `.stack` where it's required
// https://webidl.spec.whatwg.org/#es-DOMException-specialness
$({ global: true, constructor: true, forced: IS_PURE || FORCED_CONSTRUCTOR }, { // TODO: fix export logic
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
  if (!IS_PURE) {
    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
  }

  for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
    var constant = DOMExceptionConstants[key];
    var constantName = constant.s;
    if (!hasOwn(PolyfilledDOMException, constantName)) {
      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
    }
  }
}


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(15);
var setToStringTag = __webpack_require__(33);

var DOM_EXCEPTION = 'DOMException';

// `DOMException.prototype[@@toStringTag]` property
setToStringTag(getBuiltIn(DOM_EXCEPTION), DOM_EXCEPTION);


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(536);
__webpack_require__(537);


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var clearImmediate = __webpack_require__(120).clear;

// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$({ global: true, bind: true, enumerable: true, forced: global.clearImmediate !== clearImmediate }, {
  clearImmediate: clearImmediate
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var setTask = __webpack_require__(120).set;
var schedulersFix = __webpack_require__(164);

// https://github.com/oven-sh/bun/issues/1633
var setImmediate = global.setImmediate ? schedulersFix(setTask, false) : setTask;

// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$({ global: true, bind: true, enumerable: true, forced: global.setImmediate !== setImmediate }, {
  setImmediate: setImmediate
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* global Bun -- Deno case */
module.exports = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var microtask = __webpack_require__(212);
var aCallable = __webpack_require__(19);
var validateArgumentsLength = __webpack_require__(42);
var IS_NODE = __webpack_require__(55);

var process = global.process;

// `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
$({ global: true, enumerable: true, dontCallGetSet: true }, {
  queueMicrotask: function queueMicrotask(fn) {
    validateArgumentsLength(arguments.length, 1);
    aCallable(fn);
    var domain = IS_NODE && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var defineBuiltInAccessor = __webpack_require__(24);
var DESCRIPTORS = __webpack_require__(4);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var INCORRECT_VALUE = global.self !== global;

// `self` getter
// https://html.spec.whatwg.org/multipage/window-object.html#dom-self
try {
  if (DESCRIPTORS) {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var descriptor = Object.getOwnPropertyDescriptor(global, 'self');
    // some engines have `self`, but with incorrect descriptor
    // https://github.com/denoland/deno/issues/15765
    if (INCORRECT_VALUE || !descriptor || !descriptor.get || !descriptor.enumerable) {
      defineBuiltInAccessor(global, 'self', {
        get: function self() {
          return global;
        },
        set: function self(value) {
          if (this !== global) throw new $TypeError('Illegal invocation');
          defineProperty(global, 'self', {
            value: value,
            writable: true,
            configurable: true,
            enumerable: true
          });
        },
        configurable: true,
        enumerable: true
      });
    }
  } else $({ global: true, simple: true, forced: INCORRECT_VALUE }, {
    self: global
  });
} catch (error) { /* empty */ }


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(20);
var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var getBuiltIn = __webpack_require__(15);
var uncurryThis = __webpack_require__(2);
var fails = __webpack_require__(1);
var uid = __webpack_require__(71);
var isCallable = __webpack_require__(10);
var isConstructor = __webpack_require__(73);
var isNullOrUndefined = __webpack_require__(29);
var isObject = __webpack_require__(9);
var isSymbol = __webpack_require__(61);
var iterate = __webpack_require__(46);
var anObject = __webpack_require__(7);
var classof = __webpack_require__(44);
var hasOwn = __webpack_require__(12);
var createProperty = __webpack_require__(53);
var createNonEnumerableProperty = __webpack_require__(28);
var lengthOfArrayLike = __webpack_require__(14);
var validateArgumentsLength = __webpack_require__(42);
var getRegExpFlags = __webpack_require__(97);
var MapHelpers = __webpack_require__(542);
var SetHelpers = __webpack_require__(232);
var setIterate = __webpack_require__(543);
var detachTransferable = __webpack_require__(545);
var ERROR_STACK_INSTALLABLE = __webpack_require__(187);
var PROPER_STRUCTURED_CLONE_TRANSFER = __webpack_require__(233);

var Object = global.Object;
var Array = global.Array;
var Date = global.Date;
var Error = global.Error;
var TypeError = global.TypeError;
var PerformanceMark = global.PerformanceMark;
var DOMException = getBuiltIn('DOMException');
var Map = MapHelpers.Map;
var mapHas = MapHelpers.has;
var mapGet = MapHelpers.get;
var mapSet = MapHelpers.set;
var Set = SetHelpers.Set;
var setAdd = SetHelpers.add;
var setHas = SetHelpers.has;
var objectKeys = getBuiltIn('Object', 'keys');
var push = uncurryThis([].push);
var thisBooleanValue = uncurryThis(true.valueOf);
var thisNumberValue = uncurryThis(1.0.valueOf);
var thisStringValue = uncurryThis(''.valueOf);
var thisTimeValue = uncurryThis(Date.prototype.getTime);
var PERFORMANCE_MARK = uid('structuredClone');
var DATA_CLONE_ERROR = 'DataCloneError';
var TRANSFERRING = 'Transferring';

var checkBasicSemantic = function (structuredCloneImplementation) {
  return !fails(function () {
    var set1 = new global.Set([7]);
    var set2 = structuredCloneImplementation(set1);
    var number = structuredCloneImplementation(Object(7));
    return set2 === set1 || !set2.has(7) || !isObject(number) || +number !== 7;
  }) && structuredCloneImplementation;
};

var checkErrorsCloning = function (structuredCloneImplementation, $Error) {
  return !fails(function () {
    var error = new $Error();
    var test = structuredCloneImplementation({ a: error, b: error });
    return !(test && test.a === test.b && test.a instanceof $Error && test.a.stack === error.stack);
  });
};

// https://github.com/whatwg/html/pull/5749
var checkNewErrorsCloningSemantic = function (structuredCloneImplementation) {
  return !fails(function () {
    var test = structuredCloneImplementation(new global.AggregateError([1], PERFORMANCE_MARK, { cause: 3 }));
    return test.name !== 'AggregateError' || test.errors[0] !== 1 || test.message !== PERFORMANCE_MARK || test.cause !== 3;
  });
};

// FF94+, Safari 15.4+, Chrome 98+, NodeJS 17.0+, Deno 1.13+
// FF<103 and Safari implementations can't clone errors
// https://bugzilla.mozilla.org/show_bug.cgi?id=1556604
// FF103 can clone errors, but `.stack` of clone is an empty string
// https://bugzilla.mozilla.org/show_bug.cgi?id=1778762
// FF104+ fixed it on usual errors, but not on DOMExceptions
// https://bugzilla.mozilla.org/show_bug.cgi?id=1777321
// Chrome <102 returns `null` if cloned object contains multiple references to one error
// https://bugs.chromium.org/p/v8/issues/detail?id=12542
// NodeJS implementation can't clone DOMExceptions
// https://github.com/nodejs/node/issues/41038
// only FF103+ supports new (html/5749) error cloning semantic
var nativeStructuredClone = global.structuredClone;

var FORCED_REPLACEMENT = IS_PURE
  || !checkErrorsCloning(nativeStructuredClone, Error)
  || !checkErrorsCloning(nativeStructuredClone, DOMException)
  || !checkNewErrorsCloningSemantic(nativeStructuredClone);

// Chrome 82+, Safari 14.1+, Deno 1.11+
// Chrome 78-81 implementation swaps `.name` and `.message` of cloned `DOMException`
// Chrome returns `null` if cloned object contains multiple references to one error
// Safari 14.1 implementation doesn't clone some `RegExp` flags, so requires a workaround
// Safari implementation can't clone errors
// Deno 1.2-1.10 implementations too naive
// NodeJS 16.0+ does not have `PerformanceMark` constructor
// NodeJS <17.2 structured cloning implementation from `performance.mark` is too naive
// and can't clone, for example, `RegExp` or some boxed primitives
// https://github.com/nodejs/node/issues/40840
// no one of those implementations supports new (html/5749) error cloning semantic
var structuredCloneFromMark = !nativeStructuredClone && checkBasicSemantic(function (value) {
  return new PerformanceMark(PERFORMANCE_MARK, { detail: value }).detail;
});

var nativeRestrictedStructuredClone = checkBasicSemantic(nativeStructuredClone) || structuredCloneFromMark;

var throwUncloneable = function (type) {
  throw new DOMException('Uncloneable type: ' + type, DATA_CLONE_ERROR);
};

var throwUnpolyfillable = function (type, action) {
  throw new DOMException((action || 'Cloning') + ' of ' + type + ' cannot be properly polyfilled in this engine', DATA_CLONE_ERROR);
};

var tryNativeRestrictedStructuredClone = function (value, type) {
  if (!nativeRestrictedStructuredClone) throwUnpolyfillable(type);
  return nativeRestrictedStructuredClone(value);
};

var createDataTransfer = function () {
  var dataTransfer;
  try {
    dataTransfer = new global.DataTransfer();
  } catch (error) {
    try {
      dataTransfer = new global.ClipboardEvent('').clipboardData;
    } catch (error2) { /* empty */ }
  }
  return dataTransfer && dataTransfer.items && dataTransfer.files ? dataTransfer : null;
};

var cloneBuffer = function (value, map, $type) {
  if (mapHas(map, value)) return mapGet(map, value);

  var type = $type || classof(value);
  var clone, length, options, source, target, i;

  if (type === 'SharedArrayBuffer') {
    if (nativeRestrictedStructuredClone) clone = nativeRestrictedStructuredClone(value);
    // SharedArrayBuffer should use shared memory, we can't polyfill it, so return the original
    else clone = value;
  } else {
    var DataView = global.DataView;

    // `ArrayBuffer#slice` is not available in IE10
    // `ArrayBuffer#slice` and `DataView` are not available in old FF
    if (!DataView && !isCallable(value.slice)) throwUnpolyfillable('ArrayBuffer');
    // detached buffers throws in `DataView` and `.slice`
    try {
      if (isCallable(value.slice) && !value.resizable) {
        clone = value.slice(0);
      } else {
        length = value.byteLength;
        options = 'maxByteLength' in value ? { maxByteLength: value.maxByteLength } : undefined;
        clone = new ArrayBuffer(length, options);
        source = new DataView(value);
        target = new DataView(clone);
        for (i = 0; i < length; i++) {
          target.setUint8(i, source.getUint8(i));
        }
      }
    } catch (error) {
      throw new DOMException('ArrayBuffer is detached', DATA_CLONE_ERROR);
    }
  }

  mapSet(map, value, clone);

  return clone;
};

var cloneView = function (value, type, offset, length, map) {
  var C = global[type];
  // in some old engines like Safari 9, typeof C is 'object'
  // on Uint8ClampedArray or some other constructors
  if (!isObject(C)) throwUnpolyfillable(type);
  return new C(cloneBuffer(value.buffer, map), offset, length);
};

var structuredCloneInternal = function (value, map) {
  if (isSymbol(value)) throwUncloneable('Symbol');
  if (!isObject(value)) return value;
  // effectively preserves circular references
  if (map) {
    if (mapHas(map, value)) return mapGet(map, value);
  } else map = new Map();

  var type = classof(value);
  var C, name, cloned, dataTransfer, i, length, keys, key;

  switch (type) {
    case 'Array':
      cloned = Array(lengthOfArrayLike(value));
      break;
    case 'Object':
      cloned = {};
      break;
    case 'Map':
      cloned = new Map();
      break;
    case 'Set':
      cloned = new Set();
      break;
    case 'RegExp':
      // in this block because of a Safari 14.1 bug
      // old FF does not clone regexes passed to the constructor, so get the source and flags directly
      cloned = new RegExp(value.source, getRegExpFlags(value));
      break;
    case 'Error':
      name = value.name;
      switch (name) {
        case 'AggregateError':
          cloned = new (getBuiltIn(name))([]);
          break;
        case 'EvalError':
        case 'RangeError':
        case 'ReferenceError':
        case 'SuppressedError':
        case 'SyntaxError':
        case 'TypeError':
        case 'URIError':
          cloned = new (getBuiltIn(name))();
          break;
        case 'CompileError':
        case 'LinkError':
        case 'RuntimeError':
          cloned = new (getBuiltIn('WebAssembly', name))();
          break;
        default:
          cloned = new Error();
      }
      break;
    case 'DOMException':
      cloned = new DOMException(value.message, value.name);
      break;
    case 'ArrayBuffer':
    case 'SharedArrayBuffer':
      cloned = cloneBuffer(value, map, type);
      break;
    case 'DataView':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float16Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'BigInt64Array':
    case 'BigUint64Array':
      length = type === 'DataView' ? value.byteLength : value.length;
      cloned = cloneView(value, type, value.byteOffset, length, map);
      break;
    case 'DOMQuad':
      try {
        cloned = new DOMQuad(
          structuredCloneInternal(value.p1, map),
          structuredCloneInternal(value.p2, map),
          structuredCloneInternal(value.p3, map),
          structuredCloneInternal(value.p4, map)
        );
      } catch (error) {
        cloned = tryNativeRestrictedStructuredClone(value, type);
      }
      break;
    case 'File':
      if (nativeRestrictedStructuredClone) try {
        cloned = nativeRestrictedStructuredClone(value);
        // NodeJS 20.0.0 bug, https://github.com/nodejs/node/issues/47612
        if (classof(cloned) !== type) cloned = undefined;
      } catch (error) { /* empty */ }
      if (!cloned) try {
        cloned = new File([value], value.name, value);
      } catch (error) { /* empty */ }
      if (!cloned) throwUnpolyfillable(type);
      break;
    case 'FileList':
      dataTransfer = createDataTransfer();
      if (dataTransfer) {
        for (i = 0, length = lengthOfArrayLike(value); i < length; i++) {
          dataTransfer.items.add(structuredCloneInternal(value[i], map));
        }
        cloned = dataTransfer.files;
      } else cloned = tryNativeRestrictedStructuredClone(value, type);
      break;
    case 'ImageData':
      // Safari 9 ImageData is a constructor, but typeof ImageData is 'object'
      try {
        cloned = new ImageData(
          structuredCloneInternal(value.data, map),
          value.width,
          value.height,
          { colorSpace: value.colorSpace }
        );
      } catch (error) {
        cloned = tryNativeRestrictedStructuredClone(value, type);
      } break;
    default:
      if (nativeRestrictedStructuredClone) {
        cloned = nativeRestrictedStructuredClone(value);
      } else switch (type) {
        case 'BigInt':
          // can be a 3rd party polyfill
          cloned = Object(value.valueOf());
          break;
        case 'Boolean':
          cloned = Object(thisBooleanValue(value));
          break;
        case 'Number':
          cloned = Object(thisNumberValue(value));
          break;
        case 'String':
          cloned = Object(thisStringValue(value));
          break;
        case 'Date':
          cloned = new Date(thisTimeValue(value));
          break;
        case 'Blob':
          try {
            cloned = value.slice(0, value.size, value.type);
          } catch (error) {
            throwUnpolyfillable(type);
          } break;
        case 'DOMPoint':
        case 'DOMPointReadOnly':
          C = global[type];
          try {
            cloned = C.fromPoint
              ? C.fromPoint(value)
              : new C(value.x, value.y, value.z, value.w);
          } catch (error) {
            throwUnpolyfillable(type);
          } break;
        case 'DOMRect':
        case 'DOMRectReadOnly':
          C = global[type];
          try {
            cloned = C.fromRect
              ? C.fromRect(value)
              : new C(value.x, value.y, value.width, value.height);
          } catch (error) {
            throwUnpolyfillable(type);
          } break;
        case 'DOMMatrix':
        case 'DOMMatrixReadOnly':
          C = global[type];
          try {
            cloned = C.fromMatrix
              ? C.fromMatrix(value)
              : new C(value);
          } catch (error) {
            throwUnpolyfillable(type);
          } break;
        case 'AudioData':
        case 'VideoFrame':
          if (!isCallable(value.clone)) throwUnpolyfillable(type);
          try {
            cloned = value.clone();
          } catch (error) {
            throwUncloneable(type);
          } break;
        case 'CropTarget':
        case 'CryptoKey':
        case 'FileSystemDirectoryHandle':
        case 'FileSystemFileHandle':
        case 'FileSystemHandle':
        case 'GPUCompilationInfo':
        case 'GPUCompilationMessage':
        case 'ImageBitmap':
        case 'RTCCertificate':
        case 'WebAssembly.Module':
          throwUnpolyfillable(type);
          // break omitted
        default:
          throwUncloneable(type);
      }
  }

  mapSet(map, value, cloned);

  switch (type) {
    case 'Array':
    case 'Object':
      keys = objectKeys(value);
      for (i = 0, length = lengthOfArrayLike(keys); i < length; i++) {
        key = keys[i];
        createProperty(cloned, key, structuredCloneInternal(value[key], map));
      } break;
    case 'Map':
      value.forEach(function (v, k) {
        mapSet(cloned, structuredCloneInternal(k, map), structuredCloneInternal(v, map));
      });
      break;
    case 'Set':
      value.forEach(function (v) {
        setAdd(cloned, structuredCloneInternal(v, map));
      });
      break;
    case 'Error':
      createNonEnumerableProperty(cloned, 'message', structuredCloneInternal(value.message, map));
      if (hasOwn(value, 'cause')) {
        createNonEnumerableProperty(cloned, 'cause', structuredCloneInternal(value.cause, map));
      }
      if (name === 'AggregateError') {
        cloned.errors = structuredCloneInternal(value.errors, map);
      } else if (name === 'SuppressedError') {
        cloned.error = structuredCloneInternal(value.error, map);
        cloned.suppressed = structuredCloneInternal(value.suppressed, map);
      } // break omitted
    case 'DOMException':
      if (ERROR_STACK_INSTALLABLE) {
        createNonEnumerableProperty(cloned, 'stack', structuredCloneInternal(value.stack, map));
      }
  }

  return cloned;
};

var tryToTransfer = function (rawTransfer, map) {
  if (!isObject(rawTransfer)) throw new TypeError('Transfer option cannot be converted to a sequence');

  var transfer = [];

  iterate(rawTransfer, function (value) {
    push(transfer, anObject(value));
  });

  var i = 0;
  var length = lengthOfArrayLike(transfer);
  var buffers = new Set();
  var value, type, C, transferred, canvas, context;

  while (i < length) {
    value = transfer[i++];

    type = classof(value);

    if (type === 'ArrayBuffer' ? setHas(buffers, value) : mapHas(map, value)) {
      throw new DOMException('Duplicate transferable', DATA_CLONE_ERROR);
    }

    if (type === 'ArrayBuffer') {
      setAdd(buffers, value);
      continue;
    }

    if (PROPER_STRUCTURED_CLONE_TRANSFER) {
      transferred = nativeStructuredClone(value, { transfer: [value] });
    } else switch (type) {
      case 'ImageBitmap':
        C = global.OffscreenCanvas;
        if (!isConstructor(C)) throwUnpolyfillable(type, TRANSFERRING);
        try {
          canvas = new C(value.width, value.height);
          context = canvas.getContext('bitmaprenderer');
          context.transferFromImageBitmap(value);
          transferred = canvas.transferToImageBitmap();
        } catch (error) { /* empty */ }
        break;
      case 'AudioData':
      case 'VideoFrame':
        if (!isCallable(value.clone) || !isCallable(value.close)) throwUnpolyfillable(type, TRANSFERRING);
        try {
          transferred = value.clone();
          value.close();
        } catch (error) { /* empty */ }
        break;
      case 'MediaSourceHandle':
      case 'MessagePort':
      case 'OffscreenCanvas':
      case 'ReadableStream':
      case 'TransformStream':
      case 'WritableStream':
        throwUnpolyfillable(type, TRANSFERRING);
    }

    if (transferred === undefined) throw new DOMException('This object cannot be transferred: ' + type, DATA_CLONE_ERROR);

    mapSet(map, value, transferred);
  }

  return buffers;
};

var detachBuffers = function (buffers) {
  setIterate(buffers, function (buffer) {
    if (PROPER_STRUCTURED_CLONE_TRANSFER) {
      nativeRestrictedStructuredClone(buffer, { transfer: [buffer] });
    } else if (isCallable(buffer.transfer)) {
      buffer.transfer();
    } else if (detachTransferable) {
      detachTransferable(buffer);
    } else {
      throwUnpolyfillable('ArrayBuffer', TRANSFERRING);
    }
  });
};

// `structuredClone` method
// https://html.spec.whatwg.org/multipage/structured-data.html#dom-structuredclone
$({ global: true, enumerable: true, sham: !PROPER_STRUCTURED_CLONE_TRANSFER, forced: FORCED_REPLACEMENT }, {
  structuredClone: function structuredClone(value /* , { transfer } */) {
    var options = validateArgumentsLength(arguments.length, 1) > 1 && !isNullOrUndefined(arguments[1]) ? anObject(arguments[1]) : undefined;
    var transfer = options ? options.transfer : undefined;
    var map, buffers;

    if (transfer !== undefined) {
      map = new Map();
      buffers = tryToTransfer(transfer, map);
    }

    var clone = structuredCloneInternal(value, map);

    // since of an issue with cloning views of transferred buffers, we a forced to detach them later
    // https://github.com/zloirock/core-js/issues/1265
    if (buffers) detachBuffers(buffers);

    return clone;
  }
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);

// eslint-disable-next-line es/no-map -- safe
var MapPrototype = Map.prototype;

module.exports = {
  // eslint-disable-next-line es/no-map -- safe
  Map: Map,
  set: uncurryThis(MapPrototype.set),
  get: uncurryThis(MapPrototype.get),
  has: uncurryThis(MapPrototype.has),
  remove: uncurryThis(MapPrototype['delete']),
  proto: MapPrototype
};


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(2);
var iterateSimple = __webpack_require__(544);
var SetHelpers = __webpack_require__(232);

var Set = SetHelpers.Set;
var SetPrototype = SetHelpers.proto;
var forEach = uncurryThis(SetPrototype.forEach);
var keys = uncurryThis(SetPrototype.keys);
var next = keys(new Set()).next;

module.exports = function (set, fn, interruptible) {
  return interruptible ? iterateSimple({ iterator: keys(set), next: next }, fn) : forEach(set, fn);
};


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6);

module.exports = function (record, fn, ITERATOR_INSTEAD_OF_RECORD) {
  var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
  var next = record.next;
  var step, result;
  while (!(step = call(next, iterator)).done) {
    result = fn(step.value);
    if (result !== undefined) return result;
  }
};


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var tryNodeRequire = __webpack_require__(230);
var PROPER_STRUCTURED_CLONE_TRANSFER = __webpack_require__(233);

var structuredClone = global.structuredClone;
var $ArrayBuffer = global.ArrayBuffer;
var $MessageChannel = global.MessageChannel;
var detach = false;
var WorkerThreads, channel, buffer, $detach;

if (PROPER_STRUCTURED_CLONE_TRANSFER) {
  detach = function (transferable) {
    structuredClone(transferable, { transfer: [transferable] });
  };
} else if ($ArrayBuffer) try {
  if (!$MessageChannel) {
    WorkerThreads = tryNodeRequire('worker_threads');
    if (WorkerThreads) $MessageChannel = WorkerThreads.MessageChannel;
  }

  if ($MessageChannel) {
    channel = new $MessageChannel();
    buffer = new $ArrayBuffer(2);

    $detach = function (transferable) {
      channel.port1.postMessage(null, [transferable]);
    };

    if (buffer.byteLength === 2) {
      $detach(buffer);
      if (buffer.byteLength === 0) detach = $detach;
    }
  }
} catch (error) { /* empty */ }

module.exports = detach;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(547);
__webpack_require__(548);


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var schedulersFix = __webpack_require__(164);

var setInterval = schedulersFix(global.setInterval, true);

// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$({ global: true, bind: true, forced: global.setInterval !== setInterval }, {
  setInterval: setInterval
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var global = __webpack_require__(3);
var schedulersFix = __webpack_require__(164);

var setTimeout = schedulersFix(global.setTimeout, true);

// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$({ global: true, bind: true, forced: global.setTimeout !== setTimeout }, {
  setTimeout: setTimeout
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(550);


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__(218);
var $ = __webpack_require__(0);
var DESCRIPTORS = __webpack_require__(4);
var USE_NATIVE_URL = __webpack_require__(165);
var global = __webpack_require__(3);
var bind = __webpack_require__(41);
var uncurryThis = __webpack_require__(2);
var defineBuiltIn = __webpack_require__(16);
var defineBuiltInAccessor = __webpack_require__(24);
var anInstance = __webpack_require__(47);
var hasOwn = __webpack_require__(12);
var assign = __webpack_require__(208);
var arrayFrom = __webpack_require__(193);
var arraySlice = __webpack_require__(86);
var codeAt = __webpack_require__(124).codeAt;
var toASCII = __webpack_require__(551);
var $toString = __webpack_require__(5);
var setToStringTag = __webpack_require__(33);
var validateArgumentsLength = __webpack_require__(42);
var URLSearchParamsModule = __webpack_require__(234);
var InternalStateModule = __webpack_require__(22);

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global.URL;
var TypeError = global.TypeError;
var parseInt = global.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.0.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var toLowerCase = uncurryThis(''.toLowerCase);
var unshift = uncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] === '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part === '') return input;
    radix = 10;
    if (part.length > 1 && charAt(part, 0) === '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice(part, radix === 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
      number = parseInt(part, radix);
    }
    push(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index === partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt(input, pointer);
  };

  if (chr() === ':') {
    if (charAt(input, 1) !== ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex === 8) return;
    if (chr() === ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() === '.') {
      if (length === 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() === '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec(DIGIT, chr())) return;
        while (exec(DIGIT, chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece === 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
      }
      if (numbersSeen !== 4) return;
      break;
    } else if (chr() === ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex !== 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex !== 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    } return join(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length === 2 && exec(ALPHA, charAt(string, 0))
    && ((second = charAt(string, 1)) === ':' || (!normalized && second === '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
    string.length === 2 ||
    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw new TypeError(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw new TypeError(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) {
            buffer += toLowerCase(chr);
          } else if (chr === ':') {
            if (stateOverride && (
              (url.isSpecial() !== hasOwn(specialSchemes, buffer)) ||
              (buffer === 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme === 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme === 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme === url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] === '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr !== '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr === '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme === 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr === '/' && codePoints[pointer + 1] === '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr === '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr === EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr === '/' || (chr === '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr === '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr === '/' || chr === '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr === '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr !== '/' || charAt(buffer, pointer + 1) !== '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr !== '/' && chr !== '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr === '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint === ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer === '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme === 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr === ':' && !seenBracket) {
            if (buffer === '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride === HOSTNAME) return;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer === '') return INVALID_HOST;
            if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr === '[') seenBracket = true;
            else if (chr === ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer !== '') {
              var port = parseInt(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr === '/' || chr === '\\') state = FILE_SLASH;
          else if (base && base.scheme === 'file') {
            switch (chr) {
              case EOF:
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                break;
              case '?':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = '';
                state = QUERY;
                break;
              case '#':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                url.fragment = '';
                state = FRAGMENT;
                break;
              default:
                if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                  url.host = base.host;
                  url.path = arraySlice(base.path);
                  url.shortenPath();
                }
                state = PATH;
                continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr === '/' || chr === '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme === 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer === '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host === 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr !== '/' && chr !== '\\') continue;
          } else if (!stateOverride && chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            state = PATH;
            if (chr !== '/') continue;
          } break;

        case PATH:
          if (
            chr === EOF || chr === '/' ||
            (chr === '\\' && url.isSpecial()) ||
            (!stateOverride && (chr === '?' || chr === '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else {
              if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
              }
              push(url.path, buffer);
            }
            buffer = '';
            if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr === '?') {
              url.query = '';
              state = QUERY;
            } else if (chr === '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            if (chr === "'" && url.isSpecial()) url.query += '%27';
            else if (chr === '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt(input, 0) === '[') {
      if (charAt(input, input.length - 1) !== ']') return INVALID_HOST;
      result = parseIPv6(stringSlice(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username !== '' || this.password !== '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme === 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw new TypeError(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme === 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme === 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString(port);
    if (port === '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString(search);
    if (search === '') {
      this.query = null;
    } else {
      if (charAt(search, 0) === '?') search = stringSlice(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString(hash);
    if (hash === '') {
      this.fragment = null;
      return;
    }
    if (charAt(hash, 0) === '#') hash = stringSlice(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis = __webpack_require__(2);

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError = RangeError;
var exec = uncurryThis(regexSeparators.exec);
var floor = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis(''.charCodeAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var split = uncurryThis(''.split);
var toLowerCase = uncurryThis(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) === 0xDC00) { // Low surrogate.
        push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push(output, value);
        counter--;
      }
    } else {
      push(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor(delta / baseMinusTMin);
    k += base;
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw new $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw new $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue === n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
          k += base;
        }

        push(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join(output, '');
};

module.exports = function (input) {
  var encoded = [];
  var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join(encoded, '.');
};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var getBuiltIn = __webpack_require__(15);
var fails = __webpack_require__(1);
var validateArgumentsLength = __webpack_require__(42);
var toString = __webpack_require__(5);
var USE_NATIVE_URL = __webpack_require__(165);

var URL = getBuiltIn('URL');

// https://github.com/nodejs/node/issues/47505
// https://github.com/denoland/deno/issues/18893
var THROWS_WITHOUT_ARGUMENTS = USE_NATIVE_URL && fails(function () {
  URL.canParse();
});

// `URL.canParse` method
// https://url.spec.whatwg.org/#dom-url-canparse
$({ target: 'URL', stat: true, forced: !THROWS_WITHOUT_ARGUMENTS }, {
  canParse: function canParse(url) {
    var length = validateArgumentsLength(arguments.length, 1);
    var urlString = toString(url);
    var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
    try {
      return !!new URL(urlString, base);
    } catch (error) {
      return false;
    }
  }
});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(0);
var call = __webpack_require__(6);

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return call(URL.prototype.toString, this);
  }
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__(234);


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(16);
var uncurryThis = __webpack_require__(2);
var toString = __webpack_require__(5);
var validateArgumentsLength = __webpack_require__(42);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var append = uncurryThis(URLSearchParamsPrototype.append);
var $delete = uncurryThis(URLSearchParamsPrototype['delete']);
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
var push = uncurryThis([].push);
var params = new $URLSearchParams('a=1&a=2&b=3');

params['delete']('a', 1);
// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
params['delete']('b', undefined);

if (params + '' !== 'a=2') {
  defineBuiltIn(URLSearchParamsPrototype, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach(this, function (v, k) { // also validates `this`
      push(entries, { key: k, value: v });
    });
    validateArgumentsLength(length, 1);
    var key = toString(name);
    var value = toString($value);
    var index = 0;
    var dindex = 0;
    var found = false;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index++];
      if (found || entry.key === key) {
        found = true;
        $delete(this, entry.key);
      } else dindex++;
    }
    while (dindex < entriesLength) {
      entry = entries[dindex++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, { enumerable: true, unsafe: true });
}


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(16);
var uncurryThis = __webpack_require__(2);
var toString = __webpack_require__(5);
var validateArgumentsLength = __webpack_require__(42);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var getAll = uncurryThis(URLSearchParamsPrototype.getAll);
var $has = uncurryThis(URLSearchParamsPrototype.has);
var params = new $URLSearchParams('a=1');

// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
if (params.has('a', 2) || !params.has('a', undefined)) {
  defineBuiltIn(URLSearchParamsPrototype, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength(length, 1);
    var value = toString($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    } return false;
  }, { enumerable: true, unsafe: true });
}


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(4);
var uncurryThis = __webpack_require__(2);
var defineBuiltInAccessor = __webpack_require__(24);

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable || iterable === "") {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    throw new TypeError(typeof iterable + " is not iterable");
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WiV_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58fef9be_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WiV_vue__ = __webpack_require__(573);
function injectStyle (ssrContext) {
  __webpack_require__(560)
}
var normalizeComponent = __webpack_require__(48)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58fef9be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WiV_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58fef9be_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WiV_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(561);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(67)("07036317", content, true, {});

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(66)(false);
// imports


// module
exports.push([module.i, ".vueWivSearchBar_container[data-v-58fef9be]{display:flex;align-items:center;margin-bottom:25px}.vueWivSearchBar_input[data-v-58fef9be]{padding:8px 12px;border:1px solid #ccc;border-radius:4px;flex-grow:1}.vueWivSearchBar_button[data-v-58fef9be]{margin-left:5px;background-color:#428da1;font-size:15px;padding:9.5px 24px;border-radius:4px;color:#fff!important;border:none;cursor:pointer}.contentContainer[data-v-58fef9be]{display:flex;gap:20px}.dropdownContainer[data-v-58fef9be]{display:flex;gap:10px;flex-wrap:wrap;margin-bottom:70px;justify-content:space-between}.leftSection[data-v-58fef9be]{flex:2;background-color:#016d89;height:500px}.rightSection[data-v-58fef9be]{flex:2;overflow-y:auto;height:500px}.jobListing[data-v-58fef9be]{display:flex;justify-content:space-between;align-items:stretch;background-color:#d9e8ec;margin-bottom:5px}.jobListing>div[data-v-58fef9be]{padding:25px;color:#646154;font-family:Arial,Helvetica,sans-serif;font-size:16px}.jobListing>button[data-v-58fef9be]{border-radius:0!important;background-color:#428da1}.seeMore[data-v-58fef9be]{background-color:#428da1;font-size:15px;padding:5px 25px;font-weight:300;color:#fff!important;border:none;cursor:pointer}.seeMore a[data-v-58fef9be]{text-decoration:none;color:#fff!important}.resultCounter[data-v-58fef9be]{font-size:13px;margin-bottom:10px;margin-top:-20px}.resultCounterMobile[data-v-58fef9be]{font-size:13px;margin-bottom:0;margin-top:0;font-weight:700}.noResultsAvailable[data-v-58fef9be]{padding:30px;text-align:center;font-size:25px;font-weight:500;color:#016d89}@media (max-width:768px){.contentContainer[data-v-58fef9be]{display:flex;flex-direction:column}.buttonToggleMapMobile[data-v-58fef9be],.toggleButtons[data-v-58fef9be]{display:flex;justify-content:center;align-items:center}.buttonToggleMapMobile[data-v-58fef9be]{background-color:#fff;color:#016d89;border-radius:4px;border-color:#016d89;text-align:center;padding:15px;cursor:pointer;gap:10px}.dropdown-filter[data-v-58fef9be]{width:90vw!important;position:relative}.dropdownContainer[data-v-58fef9be]{display:flex;gap:10px;flex-wrap:wrap;margin-bottom:70px;justify-content:flex-start;flex-direction:column;align-content:center;align-items:center}}", ""]);

// exports


/***/ }),
/* 562 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownFilter_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4da447d8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownFilter_vue__ = __webpack_require__(566);
function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var normalizeComponent = __webpack_require__(48)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4da447d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropdownFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4da447d8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropdownFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(565);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(67)("7aef7f15", content, true, {});

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(66)(false);
// imports


// module
exports.push([module.i, ".dropdown-filter[data-v-4da447d8]{width:168px;position:relative}.dropdownTitle[data-v-4da447d8]{color:#333;font-family:Barlow,Sans-serif;font-size:17px;font-weight:400;text-wrap:nowrap}.dropdown-filter .dropdown-button[data-v-4da447d8]{width:100%;display:flex;text-align:left;font-weight:400;color:#016d89;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:transparent;border-radius:8px;background:#428da1;color:#fff;padding:.5rem 1rem;font-size:1rem;border-radius:4px;transition:all .3s;flex-wrap:nowrap;justify-content:flex-start;align-items:center;border:none}.dropdown-filter .dropdown-list[data-v-4da447d8]{width:100%;padding:.5rem 0;box-sizing:border-box;position:absolute;top:100%;left:0;border:1px solid #ddd;background-color:#fff;z-index:10;border-bottom-left-radius:8px;border-bottom-right-radius:8px}.dropdown-filter .dropdown-list .item[data-v-4da447d8]{padding:.5rem 1rem;display:flex}.dropdown-filter .dropdown-list .item input[type=checkbox][data-v-4da447d8]{margin-right:.5rem}.dropdownLabel[data-v-4da447d8]{font-family:Barlow,Sans-serif;font-weight:500;color:#016d89}.NofFilter[data-v-4da447d8]{background-color:#016d89;padding:9px;margin-right:8px;color:#fff;width:15px;height:15px;border-radius:50%;display:flex;align-items:center;justify-content:center;align-content:center;flex-wrap:wrap}", ""]);

// exports


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-filter"},[_c('span',{staticClass:"dropdownTitle"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{staticClass:"dropdown-button",on:{"click":_vm.toggleDropdown}},[(_vm.selectedItems.length>0)?_c('span',{staticClass:"NofFilter"},[_vm._v(_vm._s(_vm.selectedItems.length))]):_vm._e(),_vm._v("  "+_vm._s(_vm.placeholder)+"\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"dropdown-list"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.checked),expression:"item.checked"}],attrs:{"type":"checkbox","id":item.name},domProps:{"checked":Array.isArray(item.checked)?_vm._i(item.checked,null)>-1:(item.checked)},on:{"change":[function($event){var $$a=item.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "checked", $$c)}},function($event){return _vm.handleToggleBox(item)}]}}),_vm._v(" "),_c('label',{staticClass:"dropdownLabel",attrs:{"for":item.name}},[_vm._v(_vm._s(item.name))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gmaps_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3343ac2d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gmaps_vue__ = __webpack_require__(570);
function injectStyle (ssrContext) {
  __webpack_require__(568)
}
var normalizeComponent = __webpack_require__(48)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3343ac2d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gmaps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3343ac2d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gmaps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(569);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(67)("5ec222f4", content, true, {});

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(66)(false);
// imports


// module
exports.push([module.i, ".info-content[data-v-3343ac2d]{padding:10px;color:#016d89;font-family:Myriad Pro Regular,Sans-serif;font-weight:500;font-size:16px;font-weight:700}.info-content a[data-v-3343ac2d]{color:#016d89!important}", ""]);

// exports


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GmapMap',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.mapCenter,"zoom":13,"options":{mapTypeControl: false},"options":_vm.mapStyle}},_vm._l((_vm.markers),function(m,index){return _c('GmapMarker',{key:index,attrs:{"position":{ lat: m.lat, lng: m.lng },"icon":_vm.markerIcon},on:{"click":function($event){return _vm.openInfoWindow(m)}}},[_c('GmapInfoWindow',{attrs:{"options":{ maxWidth: 200 },"position":{ lat: m.lat, lng: m.lng },"opened":m === _vm.currentMarker},on:{"closeclick":function($event){_vm.currentMarker = null}}},[_c('div',{staticClass:"info-content"},[_c('a',{attrs:{"href":m.link}},[_vm._v(_vm._s(m.info))])])])],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var database=[{"id":11321,"date":"2023-09-11T19:07:07","date_gmt":"2023-09-11T19:07:07","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11321"},"modified":"2023-10-31T20:49:48","modified_gmt":"2023-10-31T20:49:48","slug":"permanent-family-physician-physician-lead-ubc-student-health-services","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-physician-lead-ubc-student-health-services/","title":{"rendered":"Permanent Family Physician, Physician Lead &#8211; UBC Student Health Services"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[215],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8996,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"The salary for this position will be a minimum of 225,882 to a max of $282,352 (for a full-time role). ","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.2457018","job_listing-clinic_lattitude":49.2643047,"job_listing-job_location":"49.2643047%-123.2457018","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11321"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8996"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11321"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11321"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11321"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11321"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11321"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11321"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11320,"date":"2023-09-11T18:58:44","date_gmt":"2023-09-11T18:58:44","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11320"},"modified":"2023-10-31T20:49:33","modified_gmt":"2023-10-31T20:49:33","slug":"permanent-family-physician-medical-office-on-commercial-and-e-11th","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-medical-office-on-commercial-and-e-11th/","title":{"rendered":"Permanent Family Physician &#8211; Medical Office on Commercial and E 11th"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[146],"joblisting_ft_pt":[216],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8791,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0695196","job_listing-clinic_lattitude":49.2607267,"job_listing-job_location":"49.2607267%-123.0695196","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11320"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8791"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11320"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11320"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11320"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11320"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11320"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11320"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11319,"date":"2023-09-11T18:55:08","date_gmt":"2023-09-11T18:55:08","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11319"},"modified":"2023-09-11T18:55:08","modified_gmt":"2023-09-11T18:55:08","slug":"locum-family-physician-simply-wellness","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-simply-wellness/","title":{"rendered":"Locum Family Physician &#8211; Simply Wellness"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8964,"set_specific_time":true,"job_listing-start_date":"20231001","job_listing-end_date":"20231012","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Office hours ~830am-5pm, Avg number of pts ~30-40/day, flexible 4-6 pts/hour, virtual and in person","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0674904","job_listing-clinic_lattitude":49.2460432,"job_listing-job_location":"49.2460432%-123.0674904","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11319"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8964"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11319"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11319"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11319"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11319"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11319"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11319"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11205,"date":"2023-08-30T19:40:13","date_gmt":"2023-08-30T19:40:13","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11205"},"modified":"2023-08-30T19:40:13","modified_gmt":"2023-08-30T19:40:13","slug":"permanent-part-time-fp-for-long-term-care-panel-at-lakeview-care-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-part-time-fp-for-long-term-care-panel-at-lakeview-care-centre/","title":{"rendered":"Permanent Part-Time FP for Long Term Care Panel at Lakeview Care Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[138],"joblisting_community":[145],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9142,"set_specific_time":false,"job_listing-start_date":"20230729","job_listing-end_date":"20240101","non_specific_date_message":"Negotiable","job_listing-remuneration":"Fee-for-Service with additional incentive payments (see further information below)","job_listing-description":"Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>\r\n&nbsp;","job_listing-job_specifics":"The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0665503","job_listing-clinic_lattitude":49.2535766,"job_listing-job_location":"49.2535766%-123.0665503","email_recipient":"ltc@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11205"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9142"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11205"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11205"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11205"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11205"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11205"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11205"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11201,"date":"2023-08-30T00:47:06","date_gmt":"2023-08-30T00:47:06","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11201"},"modified":"2023-08-30T18:46:07","modified_gmt":"2023-08-30T18:46:07","slug":"nurse-practitioner-pacific-medical-clinic-fraser-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-pacific-medical-clinic-fraser-st/","title":{"rendered":"Nurse Practitioner &#8211; Pacific Medical Clinic (Fraser St.)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":9305,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0902688","job_listing-clinic_lattitude":49.2285535,"job_listing-job_location":"49.2285535%-123.0902688","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11201"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9305"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11201"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11201"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11201"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11201"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11201"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11201"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11200,"date":"2023-08-30T00:46:05","date_gmt":"2023-08-30T00:46:05","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11200"},"modified":"2023-08-30T18:44:23","modified_gmt":"2023-08-30T18:44:23","slug":"nurse-practitioner-iss-of-bc-welcome-centre-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-iss-of-bc-welcome-centre-clinic/","title":{"rendered":"Nurse Practitioner &#8211; ISS of BC Welcome Centre Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8868,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0653303","job_listing-clinic_lattitude":49.2610006,"job_listing-job_location":"49.2610006%-123.0653303","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11200"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8868"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11200"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11200"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11200"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11200"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11200"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11200"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11198,"date":"2023-08-30T00:44:46","date_gmt":"2023-08-30T00:44:46","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11198"},"modified":"2023-08-30T18:44:04","modified_gmt":"2023-08-30T18:44:04","slug":"nurse-practitioner-care-point-medical-clinic-joyce-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-care-point-medical-clinic-joyce-st/","title":{"rendered":"Nurse Practitioner &#8211; Care Point Medical Clinic (Joyce St.)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8758,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0319535","job_listing-clinic_lattitude":49.2378195,"job_listing-job_location":"49.2378195%-123.0319535","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11198"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8758"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11198"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11198"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11198"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11198"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11198"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11198"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11197,"date":"2023-08-30T00:43:32","date_gmt":"2023-08-30T00:43:32","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11197"},"modified":"2023-08-30T18:43:41","modified_gmt":"2023-08-30T18:43:41","slug":"nurse-practitioner-blue-water-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-blue-water-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; Blue Water Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8749,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0380326","job_listing-clinic_lattitude":49.2352974,"job_listing-job_location":"49.2352974%-123.0380326","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11197"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8749"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11197"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11197"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11197"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11197"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11197"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11197"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11196,"date":"2023-08-30T00:42:28","date_gmt":"2023-08-30T00:42:28","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11196"},"modified":"2023-08-30T18:43:18","modified_gmt":"2023-08-30T18:43:18","slug":"nurse-practitioner-well-health-hasting-sunrise-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-well-health-hasting-sunrise-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; WELL Health Hasting Sunrise Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":9015,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.058289","job_listing-clinic_lattitude":49.2809177,"job_listing-job_location":"49.2809177%-123.058289","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11196"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9015"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11196"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11196"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11196"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11196"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11196"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11196"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11195,"date":"2023-08-30T00:41:30","date_gmt":"2023-08-30T00:41:30","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11195"},"modified":"2023-08-30T18:42:55","modified_gmt":"2023-08-30T18:42:55","slug":"nurse-practitioner-urban-native-youth-association","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-urban-native-youth-association/","title":{"rendered":"Nurse Practitioner &#8211; Urban Native Youth Association"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":9003,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0715372","job_listing-clinic_lattitude":49.2810865,"job_listing-job_location":"49.2810865%-123.0715372","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11195"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9003"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11195"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11195"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11195"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11195"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11195"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11195"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11194,"date":"2023-08-30T00:40:22","date_gmt":"2023-08-30T00:40:22","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11194"},"modified":"2023-08-30T18:42:21","modified_gmt":"2023-08-30T18:42:21","slug":"nurse-practitioner-kilala-lelum","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-kilala-lelum/","title":{"rendered":"Nurse Practitioner &#8211; Kilala Lelum"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8886,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.090832","job_listing-clinic_lattitude":49.2829122,"job_listing-job_location":"49.2829122%-123.090832","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11194"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8886"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11194"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11194"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11194"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11194"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11194"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11194"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11192,"date":"2023-08-30T00:38:05","date_gmt":"2023-08-30T00:38:05","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11192"},"modified":"2023-08-30T18:41:23","modified_gmt":"2023-08-30T18:41:23","slug":"nurse-practitioner-doc-side-medical","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-doc-side-medical/","title":{"rendered":"Nurse Practitioner &#8211; Doc-Side Medical"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8822,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0901345","job_listing-clinic_lattitude":49.2809015,"job_listing-job_location":"49.2809015%-123.0901345","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11192"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8822"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11192"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11192"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11192"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11192"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11192"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11192"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11191,"date":"2023-08-30T00:36:34","date_gmt":"2023-08-30T00:36:34","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11191"},"modified":"2023-08-30T18:41:04","modified_gmt":"2023-08-30T18:41:04","slug":"nurse-practitioner-care-point-medical-clinic-commercial-dr","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-care-point-medical-clinic-commercial-dr/","title":{"rendered":"Nurse Practitioner &#8211; Care Point Medical Clinic (Commercial Dr)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8754,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.069817","job_listing-clinic_lattitude":49.2701651,"job_listing-job_location":"49.2701651%-123.069817","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11191"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8754"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11191"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11191"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11191"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11191"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11191"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11191"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11190,"date":"2023-08-30T00:34:44","date_gmt":"2023-08-30T00:34:44","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11190"},"modified":"2023-08-30T18:40:22","modified_gmt":"2023-08-30T18:40:22","slug":"nurse-practitioner-yaletown-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-yaletown-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; Yaletown Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":9030,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1228869","job_listing-clinic_lattitude":49.2732651,"job_listing-job_location":"49.2732651%-123.1228869","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11190"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9030"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11190"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11190"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11190"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11190"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11190"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11190"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11189,"date":"2023-08-30T00:33:08","date_gmt":"2023-08-30T00:33:08","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11189"},"modified":"2023-08-30T18:39:55","modified_gmt":"2023-08-30T18:39:55","slug":"nurse-practitioner-well-health-city-view-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-well-health-city-view-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; WELL Health City View Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":9010,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1196326","job_listing-clinic_lattitude":49.2635805,"job_listing-job_location":"49.2635805%-123.1196326","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11189"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9010"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11189"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11189"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11189"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11189"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11189"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11189"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11188,"date":"2023-08-30T00:31:59","date_gmt":"2023-08-30T00:31:59","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11188"},"modified":"2023-08-30T18:26:26","modified_gmt":"2023-08-30T18:26:26","slug":"nurse-practitioner-vancouver-family-practice-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-vancouver-family-practice-centre/","title":{"rendered":"Nurse Practitioner &#8211; Vancouver Family Practice Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":9005,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1165465","job_listing-clinic_lattitude":49.2609085,"job_listing-job_location":"49.2609085%-123.1165465","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11188"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9005"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11188"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11188"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11188"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11188"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11188"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11188"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11187,"date":"2023-08-30T00:28:58","date_gmt":"2023-08-30T00:28:58","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11187"},"modified":"2023-08-30T18:26:03","modified_gmt":"2023-08-30T18:26:03","slug":"nurse-practitioner-seymour-health-centre-hornby","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-seymour-health-centre-hornby/","title":{"rendered":"Nurse Practitioner &#8211; Seymour Health Centre (Hornby)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":"","set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11187"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11187"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11187"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11187"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11187"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11187"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11187"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11185,"date":"2023-08-30T00:26:38","date_gmt":"2023-08-30T00:26:38","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11185"},"modified":"2023-08-30T18:25:42","modified_gmt":"2023-08-30T18:25:42","slug":"nurse-practitioner-seymour-health-centre-granville","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-seymour-health-centre-granville/","title":{"rendered":"Nurse Practitioner &#8211; Seymour Health Centre (Granville)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8963,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1395812","job_listing-clinic_lattitude":49.2652565,"job_listing-job_location":"49.2652565%-123.1395812","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11185"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8963"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11185"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11185"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11185"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11185"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11185"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11185"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11184,"date":"2023-08-30T00:25:48","date_gmt":"2023-08-30T00:25:48","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11184"},"modified":"2023-08-30T18:25:16","modified_gmt":"2023-08-30T18:25:16","slug":"nurse-practitioner-granville-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-granville-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; Granville Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8843,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1383608","job_listing-clinic_lattitude":49.2629811,"job_listing-job_location":"49.2629811%-123.1383608","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11184"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8843"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11184"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11184"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11184"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11184"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11184"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11184"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11183,"date":"2023-08-30T00:24:13","date_gmt":"2023-08-30T00:24:13","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11183"},"modified":"2023-08-30T18:24:19","modified_gmt":"2023-08-30T18:24:19","slug":"nurse-practitioner-genetica-medical-and-wellness-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-genetica-medical-and-wellness-centre/","title":{"rendered":"Nurse Practitioner &#8211; Genetica Medical and Wellness Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8839,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1280715","job_listing-clinic_lattitude":49.2793325,"job_listing-job_location":"49.2793325%-123.1280715","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11183"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8839"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11183"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11183"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11183"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11183"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11183"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11183"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11182,"date":"2023-08-30T00:18:16","date_gmt":"2023-08-30T00:18:16","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11182"},"modified":"2023-08-30T18:23:45","modified_gmt":"2023-08-30T18:23:45","slug":"nurse-practitioner-denman-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-denman-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; Denman Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8820,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1410324","job_listing-clinic_lattitude":49.287948,"job_listing-job_location":"49.287948%-123.1410324","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11182"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8820"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11182"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11182"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11182"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11182"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11182"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11182"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11181,"date":"2023-08-30T00:17:14","date_gmt":"2023-08-30T00:17:14","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11181"},"modified":"2023-08-30T18:15:12","modified_gmt":"2023-08-30T18:15:12","slug":"nurse-practitioner-coal-harbour-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-coal-harbour-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; Coal Harbour Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8798,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1243287","job_listing-clinic_lattitude":49.2876168,"job_listing-job_location":"49.2876168%-123.1243287","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11181"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8798"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11181"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11181"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11181"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11181"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11181"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11181"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11180,"date":"2023-08-30T00:15:53","date_gmt":"2023-08-30T00:15:53","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11180"},"modified":"2023-08-30T18:13:51","modified_gmt":"2023-08-30T18:13:51","slug":"nurse-practitioner-caya-health","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-caya-health/","title":{"rendered":"Nurse Practitioner &#8211; CAYA Health"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141,140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9729,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1161003","job_listing-clinic_lattitude":49.2608996,"job_listing-job_location":"49.2608996%-123.1161003","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11180"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9729"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11180"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11180"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11180"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11180"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11180"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11180"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11179,"date":"2023-08-30T00:13:25","date_gmt":"2023-08-30T00:13:25","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11179"},"modified":"2023-08-30T18:11:57","modified_gmt":"2023-08-30T18:11:57","slug":"nurse-practitioner-care-point-medical-clinic-davie-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-care-point-medical-clinic-davie-st/","title":{"rendered":"Nurse Practitioner &#8211; Care Point Medical Clinic (Davie St)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8756,"set_specific_time":false,"job_listing-start_date":"20230829","job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"<span data-contrast=\"none\">This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</span>\r\n\r\n<span data-contrast=\"none\">This will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</span>\r\n\r\n<span data-contrast=\"none\">Interested candidates should apply to this posting or email the Vancouver Division at </span><a href=\"mailto:recruitment@van-division.yarko.dev\"><span data-contrast=\"auto\">recruitment@van-division.yarko.dev</span></a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1313165","job_listing-clinic_lattitude":49.2807463,"job_listing-job_location":"49.2807463%-123.1313165","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11179"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8756"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11179"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11179"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11179"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11179"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11179"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11179"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11172,"date":"2023-08-29T19:59:57","date_gmt":"2023-08-29T19:59:57","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11172"},"modified":"2023-08-30T15:57:49","modified_gmt":"2023-08-30T15:57:49","slug":"nurse-practitioner-south-hill-family-health-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-south-hill-family-health-centre/","title":{"rendered":"Nurse Practitioner &#8211; South Hill Family Health Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8975,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0802276","job_listing-clinic_lattitude":49.2525625,"job_listing-job_location":"49.2525625%-123.0802276","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11172"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8975"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11172"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11172"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11172"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11172"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11172"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11172"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11171,"date":"2023-08-29T17:21:03","date_gmt":"2023-08-29T17:21:03","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11171"},"modified":"2023-08-29T17:21:03","modified_gmt":"2023-08-29T17:21:03","slug":"nurse-practitioner-vycare-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-vycare-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; VyCare Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":9007,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.026608","job_listing-clinic_lattitude":49.2323817,"job_listing-job_location":"49.2323817%-123.026608","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11171"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9007"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11171"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11171"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11171"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11171"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11171"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11171"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11170,"date":"2023-08-29T17:19:06","date_gmt":"2023-08-29T17:19:06","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11170"},"modified":"2023-08-29T17:19:06","modified_gmt":"2023-08-29T17:19:06","slug":"nurse-practitioner-mint-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-mint-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; Mint Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":10901,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0597165","job_listing-clinic_lattitude":49.2428127,"job_listing-job_location":"49.2428127%-123.0597165","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11170"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10901"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11170"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11170"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11170"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11170"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11170"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11170"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11169,"date":"2023-08-29T16:38:33","date_gmt":"2023-08-29T16:38:33","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11169"},"modified":"2023-08-29T16:38:33","modified_gmt":"2023-08-29T16:38:33","slug":"nurse-practitioner-tlc-medical-clinic-granville","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-tlc-medical-clinic-granville/","title":{"rendered":"Nurse Practitioner &#8211; TLC Medical Clinic (Granville)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8993,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1409633","job_listing-clinic_lattitude":49.2195936,"job_listing-job_location":"49.2195936%-123.1409633","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11169"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8993"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11169"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11169"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11169"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11169"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11169"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11169"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11168,"date":"2023-08-29T16:32:56","date_gmt":"2023-08-29T16:32:56","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11168"},"modified":"2023-08-29T16:32:56","modified_gmt":"2023-08-29T16:32:56","slug":"nurse-practitioner-well-health-medical-clinic-kerrisdale","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-well-health-medical-clinic-kerrisdale/","title":{"rendered":"Nurse Practitioner &#8211; WELL Health Medical Clinic (Kerrisdale)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":9016,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1534977","job_listing-clinic_lattitude":49.2337865,"job_listing-job_location":"49.2337865%-123.1534977","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11168"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9016"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11168"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11168"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11168"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11168"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11168"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11168"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11167,"date":"2023-08-29T16:31:04","date_gmt":"2023-08-29T16:31:04","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11167"},"modified":"2023-08-29T16:33:28","modified_gmt":"2023-08-29T16:33:28","slug":"nurse-practitioner-well-health-medical-clinic-point-grey","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-well-health-medical-clinic-point-grey/","title":{"rendered":"Nurse Practitioner &#8211; WELL Health Medical Clinic (Point Grey)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":9018,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.2075374","job_listing-clinic_lattitude":49.2636084,"job_listing-job_location":"49.2636084%-123.2075374","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11167"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9018"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11167"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11167"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11167"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11167"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11167"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11167"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11156,"date":"2023-08-25T19:26:28","date_gmt":"2023-08-25T19:26:28","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11156"},"modified":"2023-08-25T19:26:28","modified_gmt":"2023-08-25T19:26:28","slug":"nurse-practitioner-mid-main-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-mid-main-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; Mid-Main Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8932,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1012107","job_listing-clinic_lattitude":49.265259,"job_listing-job_location":"49.265259%-123.1012107","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11156"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8932"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11156"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11156"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11156"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11156"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11156"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11156"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11153,"date":"2023-08-25T19:24:42","date_gmt":"2023-08-25T19:24:42","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11153"},"modified":"2023-08-25T19:24:42","modified_gmt":"2023-08-25T19:24:42","slug":"nurse-practitioner-pacific-medical-clinic-kingsway","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-pacific-medical-clinic-kingsway/","title":{"rendered":"Nurse Practitioner &#8211; Pacific Medical Clinic (Kingsway)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8945,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0647964","job_listing-clinic_lattitude":49.2446808,"job_listing-job_location":"49.2446808%-123.0647964","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11153"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8945"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11153"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11153"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11153"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11153"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11153"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11153"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11152,"date":"2023-08-25T19:22:21","date_gmt":"2023-08-25T19:22:21","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11152"},"modified":"2023-08-25T19:22:21","modified_gmt":"2023-08-25T19:22:21","slug":"nurse-practitioner-simply-wellness","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-simply-wellness/","title":{"rendered":"Nurse Practitioner &#8211; Simply Wellness"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8964,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0674904","job_listing-clinic_lattitude":49.2460432,"job_listing-job_location":"49.2460432%-123.0674904","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11152"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8964"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11152"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11152"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11152"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11152"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11152"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11152"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11151,"date":"2023-08-25T19:20:37","date_gmt":"2023-08-25T19:20:37","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11151"},"modified":"2023-08-25T19:20:37","modified_gmt":"2023-08-25T19:20:37","slug":"nurse-practitioner-yyoung-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-yyoung-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; yYoung Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":9032,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>\r\n\r\n&nbsp;","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1009101","job_listing-clinic_lattitude":49.2699771,"job_listing-job_location":"49.2699771%-123.1009101","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11151"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9032"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11151"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11151"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11151"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11151"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11151"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11151"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11150,"date":"2023-08-25T19:18:55","date_gmt":"2023-08-25T19:18:55","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11150"},"modified":"2023-08-25T19:18:55","modified_gmt":"2023-08-25T19:18:55","slug":"nurse-practitioner-medical-office-on-granville-and-w-70th","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-medical-office-on-granville-and-w-70th/","title":{"rendered":"Nurse Practitioner &#8211; Medical Office on Granville and W 70th"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8785,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>\r\n\r\n&nbsp;","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.140125","job_listing-clinic_lattitude":49.2088037,"job_listing-job_location":"49.2088037%-123.140125","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11150"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8785"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11150"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11150"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11150"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11150"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11150"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11150"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11149,"date":"2023-08-25T19:16:51","date_gmt":"2023-08-25T19:16:51","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11149"},"modified":"2023-08-25T19:16:51","modified_gmt":"2023-08-25T19:16:51","slug":"nurse-practitioner-fraser-street-medical","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-fraser-street-medical/","title":{"rendered":"Nurse Practitioner &#8211; Fraser Street Medical"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8838,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>\r\n\r\n&nbsp;","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0903124","job_listing-clinic_lattitude":49.2304914,"job_listing-job_location":"49.2304914%-123.0903124","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11149"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8838"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11149"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11149"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11149"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11149"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11149"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11149"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11147,"date":"2023-08-25T19:07:53","date_gmt":"2023-08-25T19:07:53","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11147"},"modified":"2023-08-25T19:07:53","modified_gmt":"2023-08-25T19:07:53","slug":"nurse-practitioner-oak-tree-family-medicine","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-oak-tree-family-medicine/","title":{"rendered":"Nurse Practitioner &#8211; Oak Tree Family Medicine"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":"","job_listing-clinic":10549,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>\r\n\r\n&nbsp;","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0659687","job_listing-clinic_lattitude":49.2237087,"job_listing-job_location":"49.2237087%-123.0659687","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11147"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10549"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11147"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11147"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11147"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11147"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11147"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11147"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11146,"date":"2023-08-25T19:04:40","date_gmt":"2023-08-25T19:04:40","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11146"},"modified":"2023-08-25T19:14:50","modified_gmt":"2023-08-25T19:14:50","slug":"nurse-practitioner-dr-ps-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-dr-ps-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; Dr. PS Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":"","job_listing-clinic":9049,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>\r\n\r\n&nbsp;","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.101429","job_listing-clinic_lattitude":49.2248253,"job_listing-job_location":"49.2248253%-123.101429","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11146"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9049"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11146"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11146"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11146"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11146"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11146"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11146"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11145,"date":"2023-08-25T19:02:13","date_gmt":"2023-08-25T19:02:13","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11145"},"modified":"2023-08-25T19:14:07","modified_gmt":"2023-08-25T19:14:07","slug":"nurse-practitioner-sina-medical-and-aesthetics-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-sina-medical-and-aesthetics-clinic/","title":{"rendered":"Nurse Practitioner &#8211; Sina Medical and Aesthetics Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":"","job_listing-clinic":8967,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1194461","job_listing-clinic_lattitude":49.2793002,"job_listing-job_location":"49.2793002%-123.1194461","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11145"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8967"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11145"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11145"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11145"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11145"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11145"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11145"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11144,"date":"2023-08-25T19:00:11","date_gmt":"2023-08-25T19:00:11","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11144"},"modified":"2023-08-25T19:12:46","modified_gmt":"2023-08-25T19:12:46","slug":"nurse-practitioner-south-vancouver-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-south-vancouver-medical-clinic/","title":{"rendered":"Nurse Practitioner &#8211; South Vancouver Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":"","job_listing-clinic":8980,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0994426","job_listing-clinic_lattitude":49.2098082,"job_listing-job_location":"49.2098082%-123.0994426","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11144"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8980"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11144"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11144"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11144"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11144"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11144"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11144"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11143,"date":"2023-08-25T18:56:15","date_gmt":"2023-08-25T18:56:15","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11143"},"modified":"2023-08-25T19:11:37","modified_gmt":"2023-08-25T19:11:37","slug":"nurse-practitioner-tlc-medical-clinic-marine-drive","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-tlc-medical-clinic-marine-drive/","title":{"rendered":"Nurse Practitioner &#8211; TLC Medical Clinic (Marine Drive)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":"","job_listing-clinic":9629,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0904915","job_listing-clinic_lattitude":49.2114363,"job_listing-job_location":"49.2114363%-123.0904915","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11143"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9629"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11143"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11143"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11143"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11143"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11143"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11143"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11140,"date":"2023-08-25T18:52:07","date_gmt":"2023-08-25T18:52:07","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11140"},"modified":"2023-08-25T19:09:23","modified_gmt":"2023-08-25T19:09:23","slug":"nurse-practitioner-tlc-medical-clinic-knight-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-tlc-medical-clinic-knight-st/","title":{"rendered":"Nurse Practitioner &#8211; TLC Medical Clinic (Knight St.)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8994,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Contact for more information","job_listing-remuneration":"NP Contract","job_listing-description":"","job_listing-job_specifics":"This Vancouver clinic is looking to have a Nurse Practitioner join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.\r\n\r\nThis will be a full-time or part-time salaried position. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.\r\n\r\nInterested candidates should apply to this posting or email the Vancouver Division at <a href=\"mailto:recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.076322","job_listing-clinic_lattitude":49.2325315,"job_listing-job_location":"49.2325315%-123.076322","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11140"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8994"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11140"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11140"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11140"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11140"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11140"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11140"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11125,"date":"2023-08-21T20:41:24","date_gmt":"2023-08-21T20:41:24","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11125"},"modified":"2023-08-30T18:47:38","modified_gmt":"2023-08-30T18:47:38","slug":"permanent-family-physician-mint-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-mint-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Mint Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":10901,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25 split to annual maximum; 100% panel payment (LFP or FFS) to physician","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0597165","job_listing-clinic_lattitude":49.2428127,"job_listing-job_location":"49.2428127%-123.0597165","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11125"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10901"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11125"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11125"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11125"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11125"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11125"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11125"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11124,"date":"2023-08-21T20:40:04","date_gmt":"2023-08-21T20:40:04","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11124"},"modified":"2023-08-21T20:42:12","modified_gmt":"2023-08-21T20:42:12","slug":"locum-family-physician-mint-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-mint-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Mint Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":10901,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25 split to annual maximum; 100% panel payment (LFP or FFS) to physician.","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0597165","job_listing-clinic_lattitude":49.2428127,"job_listing-job_location":"49.2428127%-123.0597165","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11124"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10901"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11124"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11124"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11124"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11124"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11124"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11124"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11036,"date":"2023-08-14T21:48:34","date_gmt":"2023-08-14T21:48:34","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11036"},"modified":"2023-08-14T21:48:34","modified_gmt":"2023-08-14T21:48:34","slug":"locum-family-physician-raven-song-community-health-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-raven-song-community-health-centre/","title":{"rendered":"Locum Family Physician &#8211; Raven Song Community Health Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[189],"joblisting_community":[143],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8951,"set_specific_time":true,"job_listing-start_date":"20230801","job_listing-end_date":"20240201","non_specific_date_message":"Negotiable","job_listing-remuneration":"Sessional","job_listing-description":"","job_listing-job_specifics":"0.4-0.6 FTE","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1042735","job_listing-clinic_lattitude":49.2635524,"job_listing-job_location":"49.2635524%-123.1042735","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11036"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8951"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11036"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11036"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11036"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11036"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11036"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11036"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11035,"date":"2023-08-14T21:46:44","date_gmt":"2023-08-14T21:46:44","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11035"},"modified":"2023-08-14T21:46:44","modified_gmt":"2023-08-14T21:46:44","slug":"locum-family-physician-alberni-medical-clinic-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-alberni-medical-clinic-2/","title":{"rendered":"Locum Family Physician &#8211; Alberni Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9244,"set_specific_time":true,"job_listing-start_date":"20231220","job_listing-end_date":"20240112","non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1281668","job_listing-clinic_lattitude":49.2879721,"job_listing-job_location":"49.2879721%-123.1281668","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11035"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9244"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11035"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11035"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11035"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11035"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11035"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11035"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11034,"date":"2023-08-14T21:45:14","date_gmt":"2023-08-14T21:45:14","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11034"},"modified":"2023-08-14T21:45:14","modified_gmt":"2023-08-14T21:45:14","slug":"permanent-family-physician-chen-medical-and-mental-health-group","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-chen-medical-and-mental-health-group/","title":{"rendered":"Permanent Family Physician &#8211; Chen Medical and Mental Health Group"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8833,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1170634","job_listing-clinic_lattitude":49.2328589,"job_listing-job_location":"49.2328589%-123.1170634","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11034"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8833"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11034"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11034"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11034"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11034"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11034"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11034"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11033,"date":"2023-08-14T21:44:01","date_gmt":"2023-08-14T21:44:01","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11033"},"modified":"2023-08-14T21:44:01","modified_gmt":"2023-08-14T21:44:01","slug":"locum-family-physician-chen-medical-and-mental-health-group","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-chen-medical-and-mental-health-group/","title":{"rendered":"Locum Family Physician &#8211; Chen Medical and Mental Health Group"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8833,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1170634","job_listing-clinic_lattitude":49.2328589,"job_listing-job_location":"49.2328589%-123.1170634","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11033"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8833"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11033"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11033"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11033"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11033"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11033"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11033"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11032,"date":"2023-08-14T21:42:19","date_gmt":"2023-08-14T21:42:19","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11032"},"modified":"2023-09-11T18:40:08","modified_gmt":"2023-09-11T18:40:08","slug":"locum-family-physician-pacific-medical-clinic-fraser-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-pacific-medical-clinic-fraser-2/","title":{"rendered":"Locum Family Physician &#8211; Pacific Medical Clinic (Fraser)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9305,"set_specific_time":false,"job_listing-start_date":"20230801","job_listing-end_date":"20230831","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0902688","job_listing-clinic_lattitude":49.2285535,"job_listing-job_location":"49.2285535%-123.0902688","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11032"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9305"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11032"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11032"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11032"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11032"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11032"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11032"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11030,"date":"2023-08-14T21:40:45","date_gmt":"2023-08-14T21:40:45","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=11030"},"modified":"2023-09-11T18:38:24","modified_gmt":"2023-09-11T18:38:24","slug":"locum-family-physician-pacific-medical-clinic-kingsway","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-pacific-medical-clinic-kingsway/","title":{"rendered":"Locum Family Physician &#8211; Pacific Medical Clinic (Kingsway)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8945,"set_specific_time":false,"job_listing-start_date":"20230801","job_listing-end_date":"20230831","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0647964","job_listing-clinic_lattitude":49.2446808,"job_listing-job_location":"49.2446808%-123.0647964","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/11030"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8945"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11030"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=11030"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=11030"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=11030"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=11030"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=11030"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10864,"date":"2023-07-27T20:32:38","date_gmt":"2023-07-27T20:32:38","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10864"},"modified":"2023-08-04T18:03:28","modified_gmt":"2023-08-04T18:03:28","slug":"permanent-part-time-fp-for-long-term-care-panel-at-villa-carital","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-part-time-fp-for-long-term-care-panel-at-villa-carital/","title":{"rendered":"Permanent Part-Time FP for Long Term Care Panel at Villa Carital"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[138],"joblisting_community":[145],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":10862,"set_specific_time":false,"job_listing-start_date":"20230601","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Fee-for-Service with additional incentive payments (see further information below)","job_listing-description":"Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>\r\n&nbsp;","job_listing-job_specifics":"The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0520852","job_listing-clinic_lattitude":49.2566507,"job_listing-job_location":"49.2566507%-123.0520852","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":"ltc@van-division.yarko.dev"},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10864"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10862"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10864"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10864"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10864"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10864"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10864"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10864"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10852,"date":"2023-07-25T19:49:23","date_gmt":"2023-07-25T19:49:23","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10852"},"modified":"2023-07-25T19:49:23","modified_gmt":"2023-07-25T19:49:23","slug":"locum-family-physician-oakridge-medical-vancouver","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-oakridge-medical-vancouver/","title":{"rendered":"Locum Family Physician &#8211; Oakridge Medical Vancouver"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8942,"set_specific_time":true,"job_listing-start_date":"20240101","job_listing-end_date":"20241001","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Maternity Leave - January 2024 for 9 months with the possibility to extend.\r\nMonday, Tuesday, Wednesday; Additional days can be accommodated if preferred","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1170634","job_listing-clinic_lattitude":49.2328589,"job_listing-job_location":"49.2328589%-123.1170634","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10852"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8942"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10852"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10852"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10852"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10852"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10852"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10852"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10851,"date":"2023-07-25T19:42:47","date_gmt":"2023-07-25T19:42:47","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10851"},"modified":"2023-07-25T19:42:47","modified_gmt":"2023-07-25T19:42:47","slug":"locum-family-physician-mid-main-medical-clinic-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-mid-main-medical-clinic-2/","title":{"rendered":"Locum Family Physician &#8211; Mid-Main Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8932,"set_specific_time":true,"job_listing-start_date":"20231115","job_listing-end_date":"20240115","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 90% forms","job_listing-description":"","job_listing-job_specifics":"2 days per week with flexibility to add more days if preferred","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1012107","job_listing-clinic_lattitude":49.265259,"job_listing-job_location":"49.265259%-123.1012107","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10851"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8932"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10851"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10851"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10851"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10851"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10851"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10851"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10850,"date":"2023-07-25T19:39:38","date_gmt":"2023-07-25T19:39:38","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10850"},"modified":"2023-07-25T19:39:38","modified_gmt":"2023-07-25T19:39:38","slug":"locum-family-physician-ultima-medicentre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-ultima-medicentre/","title":{"rendered":"Locum Family Physician &#8211; Ultima Medicentre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8997,"set_specific_time":true,"job_listing-start_date":"20231117","job_listing-end_date":"20231201","non_specific_date_message":"Negotiable","job_listing-remuneration":"65/35","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1214363","job_listing-clinic_lattitude":49.2864943,"job_listing-job_location":"49.2864943%-123.1214363","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10850"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8997"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10850"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10850"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10850"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10850"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10850"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10850"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10709,"date":"2023-06-30T20:48:16","date_gmt":"2023-06-30T20:48:16","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10709"},"modified":"2023-06-30T20:48:16","modified_gmt":"2023-06-30T20:48:16","slug":"permanent-family-physician-highroads-medical-clinic-broadway-cambie","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-highroads-medical-clinic-broadway-cambie/","title":{"rendered":"Permanent Family Physician &#8211; Highroads Medical Clinic (Broadway &#038; Cambie)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8862,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1165484","job_listing-clinic_lattitude":49.2630608,"job_listing-job_location":"49.2630608%-123.1165484","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10709"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8862"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10709"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10709"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10709"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10709"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10709"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10709"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10708,"date":"2023-06-30T20:47:33","date_gmt":"2023-06-30T20:47:33","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10708"},"modified":"2023-07-15T18:07:08","modified_gmt":"2023-07-15T18:07:08","slug":"locum-family-physician-highroads-medical-clinic-broadway-cambie","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-highroads-medical-clinic-broadway-cambie/","title":{"rendered":"Locum Family Physician &#8211; Highroads Medical Clinic (Broadway &#038; Cambie)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8862,"set_specific_time":true,"job_listing-start_date":"20230715","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1165484","job_listing-clinic_lattitude":49.2630608,"job_listing-job_location":"49.2630608%-123.1165484","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10708"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8862"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10708"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10708"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10708"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10708"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10708"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10708"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10704,"date":"2023-06-30T19:04:46","date_gmt":"2023-06-30T19:04:46","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10704"},"modified":"2023-07-25T22:16:41","modified_gmt":"2023-07-25T22:16:41","slug":"permanent-family-physician-promis-medical-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-promis-medical-centre/","title":{"rendered":"Permanent Family Physician &#8211; Promis Medical Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":10702,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, negotiable to 0%. Qualifying physicians interested in joining the clinic full-time will be offered a lucrative signing bonus","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1299861","job_listing-clinic_lattitude":49.2905367,"job_listing-job_location":"49.2905367%-123.1299861","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10704"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10702"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10704"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10704"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10704"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10704"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10704"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10704"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10703,"date":"2023-06-30T19:04:08","date_gmt":"2023-06-30T19:04:08","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10703"},"modified":"2023-06-30T19:04:08","modified_gmt":"2023-06-30T19:04:08","slug":"locum-family-physician-promis-medical-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-promis-medical-centre/","title":{"rendered":"Locum Family Physician &#8211; Promis Medical Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":10702,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, negotiable","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1299861","job_listing-clinic_lattitude":49.2905367,"job_listing-job_location":"49.2905367%-123.1299861","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10703"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10702"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10703"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10703"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10703"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10703"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10703"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10703"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10683,"date":"2023-06-27T21:38:55","date_gmt":"2023-06-27T21:38:55","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10683"},"modified":"2023-06-27T21:38:55","modified_gmt":"2023-06-27T21:38:55","slug":"locum-family-physician-woodland-family-practice-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-woodland-family-practice-2/","title":{"rendered":"Locum Family Physician &#8211; Woodland Family Practice"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9626,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.05629","job_listing-clinic_lattitude":49.2708927,"job_listing-job_location":"49.2708927%-123.05629","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10683"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9626"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10683"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10683"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10683"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10683"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10683"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10683"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10682,"date":"2023-06-27T21:37:40","date_gmt":"2023-06-27T21:37:40","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10682"},"modified":"2023-08-21T19:13:59","modified_gmt":"2023-08-21T19:13:59","slug":"locum-family-physician-lotus-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-lotus-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Lotus Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8894,"set_specific_time":false,"job_listing-start_date":"20230801","job_listing-end_date":"20230831","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"2-5 days per week","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0758294","job_listing-clinic_lattitude":49.2496366,"job_listing-job_location":"49.2496366%-123.0758294","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10682"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8894"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10682"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10682"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10682"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10682"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10682"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10682"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10681,"date":"2023-06-27T21:35:49","date_gmt":"2023-06-27T21:35:49","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10681"},"modified":"2023-06-27T21:35:49","modified_gmt":"2023-06-27T21:35:49","slug":"locum-family-physician-john-ruedy-clinic-at-st-pauls-hospital","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-john-ruedy-clinic-at-st-pauls-hospital/","title":{"rendered":"Locum Family Physician &#8211; John Ruedy Clinic at St. Paul&#8217;s Hospital"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9923,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Sessional","job_listing-description":"","job_listing-job_specifics":"2 positions available. 1 full day per week, or alternately 2 half days per week, to a maximum of 2 days per week.\r\nPhysicians will be fully supported by a comprehensive interdisciplinary team and attach a longitudinal panel of patients. The successful candidate will be Licentiates of the Medical Council of Canada and hold a current BC Medical License with the College of Physicians &amp; Surgeons of BC (CPSBC) and meet credentialing requirements at PHC (this includes sign-ff from the applicant's respective Department Head). Applicants with experience in addiction medicine and or HIV medicine will be prioritized. Educational opportunities are available for interested candidates without HIV medicine expertise. Experience working with multidisciplinary teams is an asset.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1282326","job_listing-clinic_lattitude":49.2805247,"job_listing-job_location":"49.2805247%-123.1282326","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10681"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9923"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10681"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10681"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10681"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10681"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10681"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10681"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10679,"date":"2023-06-27T21:33:10","date_gmt":"2023-06-27T21:33:10","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10679"},"modified":"2023-06-27T21:33:25","modified_gmt":"2023-06-27T21:33:25","slug":"10679","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/10679/","title":{"rendered":"Permanent Family Physician &#8211; Medical Office on Granville and W 70th"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8785,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.140125","job_listing-clinic_lattitude":49.2088037,"job_listing-job_location":"49.2088037%-123.140125","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10679"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8785"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10679"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10679"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10679"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10679"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10679"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10679"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10678,"date":"2023-06-27T21:31:36","date_gmt":"2023-06-27T21:31:36","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10678"},"modified":"2023-06-27T21:31:36","modified_gmt":"2023-06-27T21:31:36","slug":"locum-family-physician-ting-medical-clinic-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-ting-medical-clinic-2/","title":{"rendered":"Locum Family Physician &#8211; Ting Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8992,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Tuesday, Thursday and Friday afternoons, ongoing","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1250251","job_listing-clinic_lattitude":49.2637081,"job_listing-job_location":"49.2637081%-123.1250251","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10678"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8992"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10678"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10678"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10678"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10678"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10678"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10678"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10676,"date":"2023-06-27T21:28:17","date_gmt":"2023-06-27T21:28:17","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10676"},"modified":"2023-06-27T21:28:17","modified_gmt":"2023-06-27T21:28:17","slug":"locum-family-physician-marpole-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-marpole-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Marpole Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8927,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, $100 hourly minimum","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1408284","job_listing-clinic_lattitude":49.2075155,"job_listing-job_location":"49.2075155%-123.1408284","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10676"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8927"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10676"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10676"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10676"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10676"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10676"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10676"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10662,"date":"2023-06-26T16:08:22","date_gmt":"2023-06-26T16:08:22","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10662"},"modified":"2023-09-08T15:24:18","modified_gmt":"2023-09-08T15:24:18","slug":"mid-level-moa-reach-community-health-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/mid-level-moa-reach-community-health-centre/","title":{"rendered":"Mid-Level MOA &#8211; REACH Community Health Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[181],"joblisting_job_type":[202],"joblisting_clinic_type":[189],"joblisting_community":[146],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Clinic Staff","job_listing-job_type":["Mid-Level MOA"],"job_listing-clinic":8952,"set_specific_time":false,"job_listing-start_date":"20230529","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Dependent on experience","job_listing-description":"","job_listing-job_specifics":"The MOA contributes to all aspects of clinic operations and patient care, providing detailed and pro-active administrative and clinical support to patients and colleagues in a team-based environment. Working to full scope, the MOA is committed to supporting the provision of longitudinal primary care to patients with complex health and social needs, and approaches this task with empathy and cultural humility. The clinic is open extended hours and the post-holder may be required, in cooperation with other MOAs, to work on weekends and evenings, and in rare instances, provide short notice cover for sickness absence.\r\n\r\nThe following skills are essential for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Experience in a Family Practice office\r\n✓ Good organizational and time management skills\r\n✓ Past EMR experience\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n\r\nThe following skills are considered strong assets for this position:\r\n✓ Knowledge of MSP billing\r\n✓ Past Experience with MSP billing\r\n✓ certification as a Medical Office Assistant from an accredited educational institution, or equivalent\r\nexperience\r\n\r\nWorking with vulnerable and marginalized populations, taking vitals for patients","job_listing-information":"","job_listing-other_information":"<ul>\r\n \t<li>Immediate Support staff: Medical Office Assistants, Licensed Practical Nurses, Registered Nurses, Social\r\nWorkers, Nurse Practitioners, Physicians, Counsellors</li>\r\n \t<li>Secondary Support staff: Pharmacy, Administration, Cross-cultural Health Promoters</li>\r\n \t<li>Interdepartment activities and events</li>\r\n \t<li>Extended health benefits</li>\r\n</ul>","job_listing-clinic_longitude":"-123.0698458","job_listing-clinic_lattitude":49.2744039,"job_listing-job_location":"49.2744039%-123.0698458","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10662"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8952"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10662"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10662"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10662"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10662"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10662"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10662"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10652,"date":"2023-06-23T16:57:25","date_gmt":"2023-06-23T16:57:25","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10652"},"modified":"2023-09-08T15:24:56","modified_gmt":"2023-09-08T15:24:56","slug":"mid-level-moa-heather-medical-clinic-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/mid-level-moa-heather-medical-clinic-2/","title":{"rendered":"Mid-Level MOA – Heather Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[181],"joblisting_job_type":[202],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Clinic Staff","job_listing-job_type":["Mid-Level MOA"],"job_listing-clinic":8848,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Dependent on experience","job_listing-description":"","job_listing-job_specifics":"The following skills are essential for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Experience in a Family Practice office\r\n✓ Good organizational and time management skills\r\n✓ Past EMR experience\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n\r\nThe following skills are considered strong assets for this position:\r\n✓ Knowledge of MSP billing","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1204025","job_listing-clinic_lattitude":49.2630891,"job_listing-job_location":"49.2630891%-123.1204025","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10652"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8848"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10652"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10652"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10652"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10652"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10652"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10652"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10649,"date":"2023-06-22T15:27:41","date_gmt":"2023-06-22T15:27:41","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10649"},"modified":"2023-09-08T15:25:13","modified_gmt":"2023-09-08T15:25:13","slug":"mid-level-moa-citymed","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/mid-level-moa-citymed/","title":{"rendered":"Mid-Level MOA &#8211; CityMed"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[181],"joblisting_job_type":[202],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8783,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Dependent on experience","job_listing-description":"","job_listing-job_specifics":"The following skills are essential for this position:\r\n\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Experience in a Family Practice office\r\n✓ Good organizational and time management skills\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\nThe following skills are considered strong assets for this position:\r\n✓ Past EMR experience\r\n✓ Knowledge of MSP billing\r\n✓ Past Experience with MSP billing\r\n\r\nDuties may be amended or added to from time to time at the discretion of the clinic manager\r\n\r\ni) Patient flow – checking in, preparing, and taking patients to their exam room\r\nii) Room preparation – cleaning, tidying, restocking and otherwise preparing exam or treatment rooms as\r\nneeded before and after each patient encounter.\r\niii) Answer inquiries by phone and in person in a helpful, respectful, professional and efficient manner.\r\niv) Maintain appointment schedule and manages appointment recalls.\r\nv) Maintain relevant potions of the patient’s electronic medical record, and ensure patient information is\r\naccurate and current.\r\nvi) Ensure exam rooms are stocked appropriately.\r\nvii) Maintain patient confidentiality, as per the Employment Agreement and Confidentiality Agreement.\r\nviii) Clean and sterilize reusable equipment and instruments.\r\nix) Maintain the overall cleanliness, tidiness and organization of the Clinic.\r\nx) Perform simple patient preparation tasks such as weighing, measuring, or checking blood pressure or\r\nother vital signs, as directed; document findings in the patient’s medical record.\r\nxi) Process and submit billings for multiple payers (MSP, ICBC, WCB, etc.) and invoice and collect noninsured\r\nfees where applicable.\r\nxii) Order, receive, and stock kitchen, office and medical supplies.\r\nxiii) Maintain accurate Clinic supplies inventory.\r\nxiv) Perform any other related clinical, administrative or special tasks as required.\r\n\r\nGeneral Skills:\r\n\r\ni) Demonstrate a team-focused work ethic.\r\nii) Good written and verbal communication skills.\r\niii) Proficiency with a computer including using the internet and electronic medical records\r\niv) Speed and accuracy in performing tasks and entering data.v) Good problem-solving ability.\r\nvi) Demonstrates good judgement.\r\n\r\nClinical Skills and Abilities (training will be provided):\r\n\r\ni) Measure and document a patient’s blood pressure using an automated blood pressure cuff.\r\nii) Prepare patients and set up exam rooms for various purposes and procedures, including pap smears,\r\nexcisions, biopsies, contraceptive device insertions, lacerations, etc.\r\niii) Prepare vaccines as needed.\r\niv) Accurately measure patient height and weight (including children and infants).\r\nv) Measure head circumference for infants\r\nvi) Operate the autoclave.\r\nvii) Perform and record results for various lab tests done at the Clinic such as urine dips and pregnancy\r\ntests.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1005344","job_listing-clinic_lattitude":49.26613,"job_listing-job_location":"49.26613%-123.1005344","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10649"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8783"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10649"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10649"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10649"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10649"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10649"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10649"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10643,"date":"2023-06-20T17:43:04","date_gmt":"2023-06-20T17:43:04","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10643"},"modified":"2023-06-20T17:43:04","modified_gmt":"2023-06-20T17:43:04","slug":"locum-family-physician-dr-kevin-yue-and-dr-an-qi-angie-xiong-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-dr-kevin-yue-and-dr-an-qi-angie-xiong-clinic/","title":{"rendered":"Locum Family Physician &#8211; Dr. Kevin Yue and Dr. An Qi Angie Xiong Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9053,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"","job_listing-description":"","job_listing-job_specifics":"1-4 Weeks through the year for vacation relief","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0657048","job_listing-clinic_lattitude":49.2339906,"job_listing-job_location":"49.2339906%-123.0657048","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10643"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9053"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10643"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10643"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10643"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10643"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10643"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10643"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10642,"date":"2023-06-20T17:40:59","date_gmt":"2023-06-20T17:40:59","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10642"},"modified":"2023-06-20T17:40:59","modified_gmt":"2023-06-20T17:40:59","slug":"locum-family-physician-medical-office-on-e-10th-and-commercial","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-medical-office-on-e-10th-and-commercial/","title":{"rendered":"Locum Family Physician &#8211; Medical Office on E 10th and Commercial"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8796,"set_specific_time":true,"job_listing-start_date":"20230901","job_listing-end_date":"20230915","non_specific_date_message":"Negotiable","job_listing-remuneration":"80/20, $800 Daily minimum","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0685699","job_listing-clinic_lattitude":49.2612024,"job_listing-job_location":"49.2612024%-123.0685699","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10642"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8796"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10642"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10642"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10642"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10642"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10642"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10642"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10641,"date":"2023-06-20T17:39:06","date_gmt":"2023-06-20T17:39:06","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10641"},"modified":"2023-06-20T17:39:06","modified_gmt":"2023-06-20T17:39:06","slug":"locum-family-physician-ubc-student-health-services","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-ubc-student-health-services/","title":{"rendered":"Locum Family Physician &#8211; UBC Student Health Services"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8996,"set_specific_time":true,"job_listing-start_date":"20230620","job_listing-end_date":"20240831","non_specific_date_message":"Negotiable","job_listing-remuneration":"Salaried","job_listing-description":"","job_listing-job_specifics":"Now-August 31, 2024 (PT at 20 hours/week)/Now-August 31, 2024 (PT at 21 hours/week)","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.2457018","job_listing-clinic_lattitude":49.2643047,"job_listing-job_location":"49.2643047%-123.2457018","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10641"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8996"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10641"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10641"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10641"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10641"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10641"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10641"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10640,"date":"2023-06-20T17:36:26","date_gmt":"2023-06-20T17:36:26","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10640"},"modified":"2023-09-11T18:07:31","modified_gmt":"2023-09-11T18:07:31","slug":"locum-family-physician-caya-health-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-caya-health-centre/","title":{"rendered":"Locum Family Physician &#8211; CAYA Health Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9729,"set_specific_time":false,"job_listing-start_date":"20230701","job_listing-end_date":"20230831","non_specific_date_message":"Negotiable","job_listing-remuneration":"","job_listing-description":"","job_listing-job_specifics":"Locum needed for 3-6 months, 2 days/week in person and 2 days/week virtual.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1161003","job_listing-clinic_lattitude":49.2608996,"job_listing-job_location":"49.2608996%-123.1161003","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10640"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9729"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10640"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10640"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10640"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10640"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10640"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10640"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10637,"date":"2023-06-20T17:29:25","date_gmt":"2023-06-20T17:29:25","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10637"},"modified":"2023-06-26T22:47:27","modified_gmt":"2023-06-26T22:47:27","slug":"locum-family-physician-broadway-plaza-family-practice-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-broadway-plaza-family-practice-2/","title":{"rendered":"Locum Family Physician &#8211; Broadway Plaza Family Practice"},"excerpt":{"rendered":"<p>Multiple dates available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8751,"set_specific_time":true,"job_listing-start_date":"20230712","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 100% private billings","job_listing-description":"","job_listing-job_specifics":"July 12-19, 2023\r\nDecember 18-22, 2023","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1181345","job_listing-clinic_lattitude":49.2636573,"job_listing-job_location":"49.2636573%-123.1181345","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10637"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8751"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10637"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10637"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10637"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10637"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10637"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10637"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10631,"date":"2023-06-20T16:32:23","date_gmt":"2023-06-20T16:32:23","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10631"},"modified":"2023-06-20T16:32:23","modified_gmt":"2023-06-20T16:32:23","slug":"locum-family-physician-homevive","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-homevive/","title":{"rendered":"Locum Family Physician &#8211; HomeVIVE"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8865,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"$115 per home visit, $20 per phone call","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1211227","job_listing-clinic_lattitude":49.2615829,"job_listing-job_location":"49.2615829%-123.1211227","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10631"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8865"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10631"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10631"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10631"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10631"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10631"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10631"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10630,"date":"2023-06-20T16:30:34","date_gmt":"2023-06-20T16:30:34","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10630"},"modified":"2023-06-20T16:30:34","modified_gmt":"2023-06-20T16:30:34","slug":"locum-family-physician-medical-office-on-davie-and-burrard","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-medical-office-on-davie-and-burrard/","title":{"rendered":"Locum Family Physician &#8211; Medical Office on Davie and Burrard"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8792,"set_specific_time":true,"job_listing-start_date":"20230904","job_listing-end_date":"20230922","non_specific_date_message":"Negotiable","job_listing-remuneration":"80/20","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1283259","job_listing-clinic_lattitude":49.2793171,"job_listing-job_location":"49.2793171%-123.1283259","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10630"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8792"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10630"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10630"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10630"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10630"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10630"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10630"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10552,"date":"2023-06-05T23:44:31","date_gmt":"2023-06-05T23:44:31","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10552"},"modified":"2023-06-05T23:44:31","modified_gmt":"2023-06-05T23:44:31","slug":"locum-family-physician-oak-tree-family-medicine","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-oak-tree-family-medicine/","title":{"rendered":"Locum Family Physician &#8211; Oak Tree Family Medicine"},"excerpt":{"rendered":"<p>Multiple Dates Available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":10549,"set_specific_time":true,"job_listing-start_date":"20230815","job_listing-end_date":"20230929","non_specific_date_message":"Negotiable","job_listing-remuneration":"Negotiable","job_listing-description":"","job_listing-job_specifics":"August 15th-18th, 2023\r\nSeptember 25th-29th, 2023","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0659687","job_listing-clinic_lattitude":49.2237087,"job_listing-job_location":"49.2237087%-123.0659687","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10552"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10549"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10552"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10552"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10552"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10552"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10552"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10552"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10551,"date":"2023-06-05T23:41:59","date_gmt":"2023-06-05T23:41:59","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10551"},"modified":"2023-06-05T23:41:59","modified_gmt":"2023-06-05T23:41:59","slug":"locum-family-physician-medical-clinic-on-e-hastings-and-garden","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-medical-clinic-on-e-hastings-and-garden/","title":{"rendered":"Locum Family Physician &#8211; Medical Clinic on E Hastings and Garden"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9050,"set_specific_time":true,"job_listing-start_date":"20230905","job_listing-end_date":"20230922","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 100% for forms","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.058851","job_listing-clinic_lattitude":49.281285,"job_listing-job_location":"49.281285%-123.058851","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10551"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9050"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10551"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10551"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10551"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10551"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10551"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10551"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10550,"date":"2023-06-05T23:39:49","date_gmt":"2023-06-05T23:39:49","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10550"},"modified":"2023-08-14T21:34:01","modified_gmt":"2023-08-14T21:34:01","slug":"permanent-family-physician-vancouver-family-practice-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-vancouver-family-practice-centre/","title":{"rendered":"Permanent Family Physician &#8211; Vancouver Family Practice Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9005,"set_specific_time":true,"job_listing-start_date":"20230605","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Population Based Funding Model","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candiadates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1165465","job_listing-clinic_lattitude":49.2609085,"job_listing-job_location":"49.2609085%-123.1165465","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10550"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9005"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10550"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10550"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10550"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10550"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10550"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10550"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10548,"date":"2023-06-05T23:35:49","date_gmt":"2023-06-05T23:35:49","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10548"},"modified":"2023-06-05T23:35:49","modified_gmt":"2023-06-05T23:35:49","slug":"permanent-family-physician-oak-tree-family-medicine","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-oak-tree-family-medicine/","title":{"rendered":"Permanent Family Physician &#8211; Oak Tree Family Medicine"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":10549,"set_specific_time":true,"job_listing-start_date":"20230605","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Negotiable","job_listing-description":"","job_listing-job_specifics":"No on call or after-hours requirements. Clinic offers flexible hours and workdays with doctors on staff willing to mentor new to practice physicians if desired. Cross coverage is available.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0659687","job_listing-clinic_lattitude":49.2237087,"job_listing-job_location":"49.2237087%-123.0659687","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10548"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10549"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10548"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10548"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10548"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10548"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10548"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10548"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10547,"date":"2023-06-05T23:31:48","date_gmt":"2023-06-05T23:31:48","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10547"},"modified":"2023-06-05T23:31:48","modified_gmt":"2023-06-05T23:31:48","slug":"locum-family-physician-heather-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-heather-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Heather Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8848,"set_specific_time":true,"job_listing-start_date":"20230605","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Approximately 5 hours per week","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1204025","job_listing-clinic_lattitude":49.2630891,"job_listing-job_location":"49.2630891%-123.1204025","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10547"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8848"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10547"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10547"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10547"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10547"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10547"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10547"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10510,"date":"2023-05-25T18:44:16","date_gmt":"2023-05-25T18:44:16","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10510"},"modified":"2023-09-08T15:25:41","modified_gmt":"2023-09-08T15:25:41","slug":"senior-moa-care-point-medical-and-wellness","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/senior-moa-care-point-medical-and-wellness/","title":{"rendered":"Senior MOA &#8211; Care Point Medical and Wellness"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[181],"joblisting_job_type":[204],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Clinic Staff","job_listing-job_type":["Senior MOA"],"job_listing-clinic":8758,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Dependent on experience","job_listing-description":"","job_listing-job_specifics":"The following skills are essential for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Experience in a Family Practice office\r\n✓ Good organizational and time management skills\r\n✓ Past EMR experience\r\n✓ Knowledge of MSP billing\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n✓ Past Experience with MSP billing\r\n\r\nThe following skills are considered strong assets for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Experience in a Family Practice office\r\n✓ Good organizational and time management skills\r\n✓ Past EMR experience\r\n✓ Knowledge of MSP billing\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n✓ Past Experience with MSP billing","job_listing-information":"","job_listing-other_information":"Duties:\r\n\r\n-Anticipate and complete all administrative duties for medical staff\r\n-Maintain reception area\r\n-Scheduling and confirming appointments\r\n-Manage office inventory and equipment; anticipate needed supplies and order them accordingly\r\n-Maintaining updated and accurate patient records\r\n-Provides exceptional customer service at all times, to patients, visitors and colleagues\r\n-Ensure that the examination rooms are always clean and stocked, prepare examinations in advance.\r\n-Submit MSP, ICBC, and WCB Billings\r\n-Review and Submit private and MSP refusals and rejections\r\n-Create and maintain, staff schedules, provider schedules and day sheets\r\n-Perform daily, weekly, and monthly bookkeeping\r\n-Support training of new staff and providers\r\n-Any other related responsibilities that are within the scope and competence of the Senior Medical Office Assistant\r\n\r\nQualifications and Skills:\r\n\r\n- Certification as a Medical Office Assistant from an accredited educational institution\r\n- A minimum of 4 years practical experience in a similar roles\r\n- Excellent knowledge of Medical Terminology\r\n- Experience in using EMR (INPUT)\r\n- Communicates well and can work collaboratively with team members a patients\r\n- Ability to multi-task and prioritize duties\r\n- Punctual and Professional\r\n\r\nAdditional Practice Information\r\n<ul>\r\n \t<li>This office currently has 3 MOA's, 2 Nurse Practitioners, and 1 Full Time Physician and 1 Part time Physician.</li>\r\n \t<li>Benefits: Causal Dress, On site parking, Transit Accessible, Dental care, Extended health care, Flexible schedule, Paid time off</li>\r\n</ul>","job_listing-clinic_longitude":"-123.0319535","job_listing-clinic_lattitude":49.2378195,"job_listing-job_location":"49.2378195%-123.0319535","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10510"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8758"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10510"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10510"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10510"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10510"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10510"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10510"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10409,"date":"2023-05-18T22:03:51","date_gmt":"2023-05-18T22:03:51","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10409"},"modified":"2023-09-08T15:25:59","modified_gmt":"2023-09-08T15:25:59","slug":"mid-level-moa-reach-community-health-cenre-urgent-primary-care-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/mid-level-moa-reach-community-health-cenre-urgent-primary-care-centre/","title":{"rendered":"Mid-Level MOA &#8211; REACH Community Health Centre UPCC"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[181],"joblisting_job_type":[202],"joblisting_clinic_type":[189,188],"joblisting_community":[146],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Clinic Staff","job_listing-job_type":["Mid-Level MOA"],"job_listing-clinic":8956,"set_specific_time":false,"job_listing-start_date":"20230529","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Dependent on experience","job_listing-description":"","job_listing-job_specifics":"This position provides team-based care and works to full scope as an MOA. The MOA performs job duties through a trauma informed care framework and culturally sensitive and safe lens for families and individuals. Reporting to the Operations Manager, the MOA contributes to the operations of the UPCC through administrative and clinical support to our care providers in a team-based environment. Together with the interprofessional team they will play an important role in assessing urgency, and deciding on who the most appropriate team member is to meet their needs. The MOA will have the opportunity to work flexible hours on evenings and weekends.\r\n\r\nThe following skills are essential for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Good organizational and time management skills\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n\r\nThe following skills are considered strong assets for this position:\r\n✓ Experience in a Family Practice office\r\n✓ Past EMR experience\r\n\r\nCertification as a Medical Office Assistant from an accredited educational institution, or equivalent experience.","job_listing-information":"","job_listing-other_information":"<ul>\r\n \t<li>Immediate Support staff: Medical Office Assistants, Licensed Practical Nurses, Registered Nurses, Social Workers, Nurse Practitioners, Physicians</li>\r\n \t<li>Secondary Support staff: Pharmacy, administration</li>\r\n \t<li>Interdepartment activities and events</li>\r\n \t<li>Extended Health Benefits</li>\r\n</ul>","job_listing-clinic_longitude":"-123.0698458","job_listing-clinic_lattitude":49.2744039,"job_listing-job_location":"49.2744039%-123.0698458","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10409"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8956"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10409"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10409"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10409"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10409"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10409"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10409"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10312,"date":"2023-05-08T18:13:13","date_gmt":"2023-05-08T18:13:13","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10312"},"modified":"2023-06-30T19:26:20","modified_gmt":"2023-06-30T19:26:20","slug":"locum-family-physician-mid-main-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-mid-main-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Mid-Main Medical Clinic"},"excerpt":{"rendered":"<p>Multiple dates available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[189],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8932,"set_specific_time":true,"job_listing-start_date":"20230701","job_listing-end_date":"20231031","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 90% forms","job_listing-description":"","job_listing-job_specifics":"Physicians can choose to cover July 1-October 31, 2023, or partial dates at their preference.\r\n\r\nJuly 8-16, 2023\r\nJuly 17-21, 2023\r\nJuly 22-30, 2023\r\nJuly 22-August 7, 2023\r\nJuly 24-August 18, 2023\r\nAugust 8-11, 2023\r\nAugust 10-24, 2023\r\nAugust 29-September 6, 2023\r\nSeptember 8-October 1, 2023\r\nSeptember 9-25, 2023\r\nSeptember 11-October 13, 2023","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1012107","job_listing-clinic_lattitude":49.265259,"job_listing-job_location":"49.265259%-123.1012107","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10312"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8932"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10312"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10312"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10312"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10312"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10312"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10312"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10311,"date":"2023-05-08T17:58:55","date_gmt":"2023-05-08T17:58:55","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10311"},"modified":"2023-05-08T17:58:55","modified_gmt":"2023-05-08T17:58:55","slug":"locum-family-physician-khatsahlano-medical-clinic-3","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-khatsahlano-medical-clinic-3/","title":{"rendered":"Locum Family Physician &#8211; Khatsahlano Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8884,"set_specific_time":true,"job_listing-start_date":"20230918","job_listing-end_date":"20231015","non_specific_date_message":"Negotiable","job_listing-remuneration":" 75/25 direct care and private patients, 85/15 indirect care","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1658517","job_listing-clinic_lattitude":49.264274,"job_listing-job_location":"49.264274%-123.1658517","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10311"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8884"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10311"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10311"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10311"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10311"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10311"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10311"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10310,"date":"2023-05-08T17:56:52","date_gmt":"2023-05-08T17:56:52","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10310"},"modified":"2023-05-08T17:56:52","modified_gmt":"2023-05-08T17:56:52","slug":"locum-family-physician-care-point-medical-clinic-davie-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-care-point-medical-clinic-davie-st/","title":{"rendered":"Locum Family Physician &#8211; Care Point Medical Clinic (Davie St.)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8756,"set_specific_time":true,"job_listing-start_date":"20230508","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30 Weekdays, 75/25 Weekends","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1313165","job_listing-clinic_lattitude":49.2807463,"job_listing-job_location":"49.2807463%-123.1313165","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10310"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8756"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10310"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10310"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10310"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10310"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10310"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10310"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10309,"date":"2023-05-08T17:55:13","date_gmt":"2023-05-08T17:55:13","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10309"},"modified":"2023-05-08T17:57:13","modified_gmt":"2023-05-08T17:57:13","slug":"permanent-family-physician-care-point-medical-clinic-davie-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-care-point-medical-clinic-davie-st/","title":{"rendered":"Permanent Family Physician &#8211; Care Point Medical Clinic (Davie St.)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8756,"set_specific_time":true,"job_listing-start_date":"20230508","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30 Weekdays, 75/25 Weekends","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1313165","job_listing-clinic_lattitude":49.2807463,"job_listing-job_location":"49.2807463%-123.1313165","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10309"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8756"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10309"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10309"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10309"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10309"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10309"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10309"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10308,"date":"2023-05-08T17:52:05","date_gmt":"2023-05-08T17:52:05","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10308"},"modified":"2023-05-08T17:52:05","modified_gmt":"2023-05-08T17:52:05","slug":"locum-family-physician-care-point-medical-clinic-commercial-dr","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-care-point-medical-clinic-commercial-dr/","title":{"rendered":"Locum Family Physician &#8211; Care Point Medical Clinic (Commercial Dr.)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8754,"set_specific_time":true,"job_listing-start_date":"20230508","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30 weekdays, 75/25 weekends","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.069817","job_listing-clinic_lattitude":49.2701651,"job_listing-job_location":"49.2701651%-123.069817","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10308"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8754"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10308"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10308"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10308"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10308"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10308"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10308"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10255,"date":"2023-05-01T21:55:57","date_gmt":"2023-05-01T21:55:57","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10255"},"modified":"2023-09-08T15:26:12","modified_gmt":"2023-09-08T15:26:12","slug":"junior-moa-care-point-medical-wellness","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/junior-moa-care-point-medical-wellness/","title":{"rendered":"Junior MOA &#8211; Care Point Medical &#038; Wellness"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[181],"joblisting_job_type":[200],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Clinic Staff","job_listing-job_type":["Junior MOA"],"job_listing-clinic":8756,"set_specific_time":false,"job_listing-start_date":"20230508","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Dependent on experience","job_listing-description":"","job_listing-job_specifics":"Regular MOAs duties, answering the phone, registering patients, assisting physicians.\r\n\r\nSkills &amp; Experience:\r\nThe following skills are essential for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Knowledge of MSP billing\r\n✓ Proficient in English (both verbal and written)\r\n✓ Past Experience with MSP billing\r\n\r\nThe following skills are considered strong assets for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Past EMR experience\r\n✓ Knowledge of MSP billing\r\n✓ Past Experience with MSP billing","job_listing-information":"","job_listing-other_information":"We have 2 F/T MOAs and a clinic manager.  Extended medical after 3 months.","job_listing-clinic_longitude":"-123.1313165","job_listing-clinic_lattitude":49.2807463,"job_listing-job_location":"49.2807463%-123.1313165","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":"Job seekers applying for Clinic Staff positions are invited to upload their resume using the \"Select files\" option below."},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10255"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8756"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10255"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10255"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10255"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10255"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10255"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10255"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10029,"date":"2023-04-07T00:31:39","date_gmt":"2023-04-07T00:31:39","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10029"},"modified":"2023-08-09T20:51:30","modified_gmt":"2023-08-09T20:51:30","slug":"nurse-practitioner-pacific-medical-clinic-grandview","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/nurse-practitioner-pacific-medical-clinic-grandview/","title":{"rendered":"Nurse Practitioner &#8211; Pacific Medical Clinic (Grandview)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[132],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Nurse Practitioner","job_listing-job_type":["Permanent"],"job_listing-clinic":8944,"set_specific_time":true,"job_listing-start_date":"20230406","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"","job_listing-description":"","job_listing-job_specifics":"<p style=\"margin-bottom: 0in;\">This Vancouver clinic is looking to include a Nurse Practitioner to join their clinical team. As part of a multi-disciplinary approach to full-service family medicine, an interested NP would work collaboratively in the team environment and start their own patient panel as per Ministry requirements.</p>\r\n<p style=\"margin-bottom: 0in;\">This will be a full-time salaried position. To cover overhead costs, the Ministry has allocated additional funding for the clinic. This clinic is excited to add to their team a Nurse Practitioner interested in working together to provide primary care for the surrounding community of patients. This initiative is part of Primary Care Networks (PCNs) evolving in Vancouver. NPs interested in this opportunity should be willing to work collaboratively and participate in PCN development in the community.</p>\r\n<p style=\"margin-bottom: 0in;\">Interested candidates should apply to this posting or email the Vancouver Division at <a style=\"overflow-wrap: break-word;\" title=\"mailto:recruitment@van-division.yarko.dev\" href=\"mailto:recruitment@van-division.yarko.dev\" target=\"_blank\" rel=\"noopener\" aria-label=\"Link recruitment@van-division.yarko.dev\">recruitment@van-division.yarko.dev</a></p>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0367346","job_listing-clinic_lattitude":49.2589696,"job_listing-job_location":"49.2589696%-123.0367346","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10029"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8944"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10029"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10029"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10029"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10029"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10029"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10029"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10028,"date":"2023-04-07T00:30:02","date_gmt":"2023-04-07T00:30:02","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10028"},"modified":"2023-05-02T23:08:49","modified_gmt":"2023-05-02T23:08:49","slug":"locum-family-physician-bayswater-family-practice-4","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-bayswater-family-practice-4/","title":{"rendered":"Locum Family Physician &#8211; Bayswater Family Practice"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8745,"set_specific_time":true,"job_listing-start_date":"20231218","job_listing-end_date":"20240112","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1715196","job_listing-clinic_lattitude":49.2644675,"job_listing-job_location":"49.2644675%-123.1715196","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10028"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8745"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10028"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10028"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10028"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10028"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10028"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10028"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10024,"date":"2023-04-06T17:55:55","date_gmt":"2023-04-06T17:55:55","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10024"},"modified":"2023-09-08T15:26:49","modified_gmt":"2023-09-08T15:26:49","slug":"mid-level-moa-ubc-student-health-services","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/mid-level-moa-ubc-student-health-services/","title":{"rendered":"Mid-Level MOA &#8211; UBC Student Health Services"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[181],"joblisting_job_type":[202],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Clinic Staff","job_listing-job_type":["Mid-Level MOA"],"job_listing-clinic":8996,"set_specific_time":true,"job_listing-start_date":"20230501","job_listing-end_date":"20240501","non_specific_date_message":"Negotiable","job_listing-remuneration":"Dependent on experience","job_listing-description":"","job_listing-job_specifics":"Within the context of a client centred model of care and in accordance with the vision\r\nand values of the VP Students portfolio, the Secretary to Medical Professionals is part of a team\r\nproviding a full range of clerical services in the support of client care. The position performs\r\nclerical/reception functions such as scheduling, and data entry. Duties range form routine to complex\r\nand include maintaining a highly confidential electronic medical record system, correspondence and\r\ncommunication. The Secretary to Medical Professionals receives payments, prepares financial and\r\nstatistical reports, types and prepares a variety of reports and other materials utilizing computer systems and software relevant to the job. Maintains an inventory of stationery and medical supplies. This position requires good judgment, the ability to work cooperatively in a fast paced environment, and the ability to respond with tact and sensitivity to a variety of patients and to perform all the duties with strict confidentiality.\r\n\r\n<em>Organizational Status</em>\r\nWorks under the direction and reports to the Manager. Takes instructions from director, manager and physicians.\r\n\r\n<em>Work Performed</em>\r\n<em>1. Customer Service</em>\r\n\r\nProvides efficient seamless and accessible reception service as demonstrated by:\r\nResponding respectfully and sensitively, to a culturally diverse stakeholder population (students, faculty, staff, colleagues, parents, and campus visitors).\r\nEffective verbal and nonverbal communication (welcoming and warm manner, empathic listening, ability to clarify and assess what is being asked, speaking clearly and articulately, ability to diffuse situations involving ill, anxious, or frustrated individuals\r\nEffective written communication (ability to clarify and assess what is being requested, responding\r\nconcisely, accurately, and articulately in writing to email inquiries and correspondence.\r\nProviding timely service with minimal supervision and working effectively during high volume periods.\r\nWorking collaboratively within a service team context to ensure high standards of service provision in\r\naccordance with Student Health Service policies.\r\n\r\n<em>Deals with customer service complaints effectively as demonstrated by:</em>\r\nCollaborating with parties involved to address difficulties.\r\nNegotiating positive outcomes.\r\nDetermines the urgency of requests for services and works closely with the Manager to  manage smooth flow of patients.\r\nSchedules appointments for physicians and nurses.\r\nCommunicates with other clinical offices, departments and units to coordinate client appointments and testing.\r\nRegisters students for appointments and obtains and enters data into computerized electronic medical record system.\r\nVerifies student registration status and health insurance status using established computerized database systems.\r\nAssists students in using the electronic medical record system.\r\nReceives, scans and imports and transfers diagnostic reports from external laboratories to clinic medical record system\r\nResponds to requests for records and information releasing information to authorized personnel in\r\naccordance with established standards and guidelines and procedures.\r\nTranscription of physician clinical notes, reports and letters.\r\n\r\n<em>2. Financial Support</em>\r\nReviews physician and nursing billing and diagnostic code entries for errors and omissions and corrects accordingly.\r\nReviews patient medical forms for completion (Workers Compensation Board of BC, Insurance\r\nCompanies, 3rd Party Medicals, etc) and bills accordingly.\r\nProcesses Medical/Legal requests and bills accordingly.\r\nPrepares billing claims and performs electronic transmission and retrieval of claims to Health Insurance Agencies.\r\nReconciles, reviews and makes necessary corrections of computerized claims (i.e. rejections,\r\nadjustments, payless and on hold claims).\r\nPrepares and mails invoices for patient and private insurance company accounts.\r\nProcesses receipts for incoming payments by cash, cheques and electronic transactions.\r\nPrepares cash and cheque deposits.\r\nFollow up and cost recovery of outstanding accounts.\r\nMaintains equipment rental logs and mails invoices on overdue accounts.\r\nMaintains billing and diagnostic code files for the purpose of patient billing.\r\nCompiles financial reports utilizing word processing and spreadsheet software.\r\nResponds to oral and written patient billing inquiries.\r\nPrepares and/or performs data entry of financial documents (cash deposits, journal vouchers, invoices, travel claims, etc)\r\nAssists the Manager with maintaining, reconciling and reporting financial records by recording in word processing and spreadsheet software.\r\nMaintains and files purchase requisitions, invoices and supporting documents.\r\nPrepares invoices to external businesses, organizations, agencies, prepares journal vouchers for internal charges for services, rendered to various university departments.\r\n\r\n<em>3. Administrative Support</em>\r\nProvides a full range of administrative support and duties associated with the care of patients at Student Health Service.\r\nTypes a variety of materials from draft copy, formats and edits electronic drafts using a variety of\r\ncomputer applications.\r\nPhotocopies and faxes a wide variety of forms and documents.\r\nAssists with preparation of protocol and procedure manuals.\r\nEnsures that clinical, reception and waiting room space are well maintained ensuring that office supplies and information materials are stocked.\r\nSorts and distributes mail and incoming faxes.\r\nMaintains photocopiers, printer, and video equipment.\r\nPrepares statistical reports on patient contacts to clinic.\r\nMaintains an inventory of stationary and medical supplies.\r\nPrepares data tapes for electronic medical record back up system, reviews computer logs and reports\r\ndiscrepancies to unit Manager.\r\nFiles miscellaneous documents\r\n\r\n<em>4. Communications</em>\r\nScreens and responds accurately to a variety of in-person, written and oral inquiries of an interpretive\r\nnature and provides referral information for students as appropriate.\r\nProvides accurate and clear information to the public, students and the university community regarding health and wellness services as well as other campus resources.\r\nProvides medical information within the boundaries of training and protocols of the unit.\r\nMaintains strict confidentiality of student information and medical records.\r\n\r\n<em>5. Clinical Support</em>\r\nEnsures clinical examination rooms are well maintained ensuring that medical and stationary supplies are stocked.\r\nOrganizes equipment and examination rooms for diagnostic procedures and treatments as required.\r\nPerforms minor diagnostic procedures and testing as requested by physicians or nurses.\r\nAttends medical examinations on request by physician.\r\nSubmits requests for medical and stationary supplies to unit Manager.\r\nCleaning and sterilization of medical equipment and instruments.\r\n\r\n<em>6. General Office Duties</em>\r\nPerforms other duties as required.\r\nThis position requires the ability to function in all areas of the department. This position requires direct interaction with patients and medical personal on a daily basis. The incumbent has frequent exposure to minor and major disagreeable conditions such as biomedical and non-biomedical wastes. Tasks are completed under pressure with frequent interruptions.\r\n\r\n<em>Consequence of Error/Judgement</em>\r\nAll information must be accurate and provided in a respectful, timely and supportive way. Failure to\r\nprovide service that meets these standards may impact negatively on access to services, jeopardize\r\nstudent s wellbeing, and result in increased risk to the university. Errors or incorrect decisions could\r\nresult in direct costs, lost opportunities, delays for students and staff. Damage to the unit s and to the\r\nUniversity s reputation may occur if the incumbent does not deal tactfully and helpfully with students,\r\nparents, faculty members and others.\r\n\r\n<em>Supervision Received</em>\r\nWorks cooperatively in a team environment under the supervision of the manager. Sets priorities and\r\nperforms most duties independently, occasionally consulting manager with reference to new or complex problems. Reports problems, discrepancies and office issues to the Manager.\r\nSupervision Given\r\nWorks cooperatively with other employees.","job_listing-information":"","job_listing-other_information":"<em>Minimum Qualifications</em>\r\nHigh school graduation, plus one year of post secondary education, plus completion of a Medical or\r\nDental Office Assistant program (including terminology), plus three years of related experience, or an\r\nequivalent combination of education and experience.\r\n\r\n<em>Preferred Qualifications</em>\r\nWithout Medical Office Assistant training three year's related experience in a medical office or clinic.\r\nMedical terminology required.\r\nAbility to use word processing, spreadsheet, database, scheduling and electronic mail applications at an intermediate level.\r\nProficiency with electronic medical records.\r\nAbility to prioritize, organize and work effectively under pressure.\r\nAbility to exercise tact and discretion when handling sensitive and/or confidential matters.\r\nDemonstrates clear understanding of confidentiality in the medical work place.\r\nAbility to maintain accuracy and attention to detail.\r\nAbility to compose routine correspondence using clear, concise medical English.\r\nAbility to work both independently and within a team environment.\r\nAbility to deal with a diversity of people in a calm, courteous, and effective manner.\r\nAbility to build rapport and provide service to people who are experiencing stress, pain and health\r\nconcerns.\r\nAbility to communicate effectively and concisely verbally and in writing.\r\nAbility to provide quality service to customers in a courteous, patient manner.\r\nAbility to effectively manage multiple tasks and priorities within a fast paced, high volume clinical area.\r\nAbility to perform basic arithmetic including calculating clinic charges, taking payments, making change\r\nand keeping accurate sales records.\r\nMust be able to reconcile daily transactions with electronic and cash receipts.\r\nAbility to accurately transcribe medical dictation.\r\nFamiliarity with MSP and other billing procedures.","job_listing-clinic_longitude":"-123.2457018","job_listing-clinic_lattitude":49.2643047,"job_listing-job_location":"49.2643047%-123.2457018","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":"Job seekers applying for Clinic Staff positions are invited to upload their resume using the \"Select files\" option below."},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10024"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8996"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10024"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10024"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10024"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10024"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10024"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10024"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10003,"date":"2023-04-05T05:14:12","date_gmt":"2023-04-05T05:14:12","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10003"},"modified":"2023-08-04T18:01:30","modified_gmt":"2023-08-04T18:01:30","slug":"blenheim-lodge","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/blenheim-lodge/","title":{"rendered":"Permanent Part-Time FP for Long Term Care Panel at Blenheim Lodge"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[138],"joblisting_community":[144],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":10002,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Fee-for-Service with additional incentive payments (see further information below)","job_listing-description":"Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>","job_listing-job_specifics":"The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1792919","job_listing-clinic_lattitude":49.257381,"job_listing-job_location":"49.257381%-123.1792919","email_recipient":"ltc@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10003"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10002"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10003"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10003"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10003"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10003"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10003"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10003"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10000,"date":"2023-04-04T18:29:09","date_gmt":"2023-04-04T18:29:09","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=10000"},"modified":"2023-09-08T15:27:25","modified_gmt":"2023-09-08T15:27:25","slug":"junior-moa-westcoast-family-medicine","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/junior-moa-westcoast-family-medicine/","title":{"rendered":"Junior MOA &#8211; Westcoast Family Medicine"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[181],"joblisting_job_type":[200],"joblisting_clinic_type":[140],"joblisting_community":[146],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Clinic Staff","job_listing-job_type":["Junior MOA"],"job_listing-clinic":9024,"set_specific_time":false,"job_listing-start_date":"20230501","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Dependent on experience","job_listing-description":"","job_listing-job_specifics":"An incoming MOA will greet patients, identify their needs, direct patients to exam rooms, book appointments, follow up referrals, book investigations, and perform EMR filing of import box. The MOA will also be tasked with answering the phones and support 2-3 family physicians in this busy, fast-paced work environment. A Junior MOA is expected to get know our patients and understand their needs.\r\n\r\nThe following skills are essential for this position:\r\n\r\n✓ Must have an MOA certificate\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Good organizational and time management skills\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n\r\nThe following skills are considered strong assets for this position:\r\n✓ Able to collaborate effectively with colleagues and doctors\r\n✓ Customer service focus and strong people skills\r\n✓ Experience in a Family Practice office\r\n✓ Good organizational and time management skills\r\n✓ Past EMR experience\r\n✓ Knowledge of MSP billing\r\n✓ Proficient computer skills and ability to troubleshoot minor IT problems\r\n✓ Proficient in English (both verbal and written)\r\n✓ Past Experience with MSP billing\r\n\r\nFriendly able to multitask and remain kind\r\n\r\nPlease attach your CV below to be considered for this position.\r\n\r\n&nbsp;","job_listing-information":"","job_listing-other_information":"This team-based family practice environment has three other MOAs and includes staff perks such as coffee Friday and staff appreciation days.","job_listing-clinic_longitude":"-123.0568593","job_listing-clinic_lattitude":49.2732643,"job_listing-job_location":"49.2732643%-123.0568593","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/10000"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9024"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10000"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=10000"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=10000"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=10000"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=10000"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=10000"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9992,"date":"2023-04-03T19:11:24","date_gmt":"2023-04-03T19:11:24","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9992"},"modified":"2023-04-20T17:30:02","modified_gmt":"2023-04-20T17:30:02","slug":"locum-family-physician-seymour-health-centre-hornby-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-seymour-health-centre-hornby-2/","title":{"rendered":"Locum Family Physician &#8211; Seymour Health Centre (Hornby)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8962,"set_specific_time":true,"job_listing-start_date":"20230901","job_listing-end_date":"20240228","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"The physician has roughly 1000 patients on their panel with a wide variety of patient types. The incoming locum will have access to 2 exam rooms and is free to create a schedule that works for them from Monday to Friday between 7:30am and 5:00pm, full or part time, and can see walk-in patients if desired.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1293994","job_listing-clinic_lattitude":49.2774715,"job_listing-job_location":"49.2774715%-123.1293994","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":"Job seekers applying for Clinic Staff positions are invited to upload their resume using the \"Select files\" option below."},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9992"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8962"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9992"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9992"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9992"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9992"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9992"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9992"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9930,"date":"2023-03-24T22:02:00","date_gmt":"2023-03-24T22:02:00","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9930"},"modified":"2023-04-25T22:13:45","modified_gmt":"2023-04-25T22:13:45","slug":"locum-family-physician-seymour-health-centre-hornby","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-seymour-health-centre-hornby/","title":{"rendered":"Locum Family Physician &#8211; Seymour Health Centre (Hornby)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8962,"set_specific_time":true,"job_listing-start_date":"20230324","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Flexible Locum for Primary Care Clinic","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1293994","job_listing-clinic_lattitude":49.2774715,"job_listing-job_location":"49.2774715%-123.1293994","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9930"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8962"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9930"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9930"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9930"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9930"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9930"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9930"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9924,"date":"2023-03-24T18:21:37","date_gmt":"2023-03-24T18:21:37","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9924"},"modified":"2023-04-25T22:13:57","modified_gmt":"2023-04-25T22:13:57","slug":"permanent-family-physician-john-ruedy-clinic-st-pauls-hospital","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-john-ruedy-clinic-st-pauls-hospital/","title":{"rendered":"Permanent Family Physician &#8211; John Ruedy Clinic, St. Paul&#8217;s Hospital"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9923,"set_specific_time":true,"job_listing-start_date":"20230324","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Physicians receive a blended compensation through either Medical Services Plan billing or hospital sessional support for services provided","job_listing-description":"","job_listing-job_specifics":"2 Permanent physicians needed - 1 full day per week, or alternately 2 half days per week, to a maximum of 2 days per week. Physicians will be fully supported by a comprehensive interdisciplinary team and attach a longitudinal panel of patients. The successful candidate will be Licentiates of the Medical Council of Canada and hold a current BC Medical License with the College of Physicians &amp; Surgeons of BC (CPSBC) and meet credentialing requirements at PHC (this includes sign-ff from the applicant's respective Department Head). Applicants with experience in addiction medicine and or HIV medicine will be prioritized. Educational opportunities are available for interested candidates without HIV medicine expertise. Experience working with multidisciplinary teams is an asset.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1282326","job_listing-clinic_lattitude":49.2805247,"job_listing-job_location":"49.2805247%-123.1282326","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9924"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9923"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9924"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9924"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9924"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9924"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9924"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9924"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9782,"date":"2023-03-16T17:40:34","date_gmt":"2023-03-16T17:40:34","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9782"},"modified":"2023-04-25T22:14:16","modified_gmt":"2023-04-25T22:14:16","slug":"permanent-family-physician-forward-care-medical-clinic-east-vancouver-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-forward-care-medical-clinic-east-vancouver-2/","title":{"rendered":"Permanent Family Physician &#8211; Forward Care Medical Clinic (East Vancouver)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8836,"set_specific_time":true,"job_listing-start_date":"20231003","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 100% for medical/legal reports","job_listing-description":"","job_listing-job_specifics":"Starting in October 2023","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0504595","job_listing-clinic_lattitude":49.2326142,"job_listing-job_location":"49.2326142%-123.0504595","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9782"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8836"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9782"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9782"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9782"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9782"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9782"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9782"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9731,"date":"2023-03-14T15:46:16","date_gmt":"2023-03-14T15:46:16","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9731"},"modified":"2023-06-05T21:42:41","modified_gmt":"2023-06-05T21:42:41","slug":"permanent-family-physician-caya-health-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-caya-health-centre/","title":{"rendered":"Permanent Family Physician &#8211; CAYA Health Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9729,"set_specific_time":true,"job_listing-start_date":"20230501","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"Full and part time opportunities available. There is space for 1 physician to be working at a time, with access to 2 rooms during their shift; A full-time physician can expect to see 25-35 patients per day.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1161003","job_listing-clinic_lattitude":49.2608996,"job_listing-job_location":"49.2608996%-123.1161003","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9731"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9729"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9731"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9731"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9731"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9731"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9731"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9731"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9683,"date":"2023-03-10T22:19:11","date_gmt":"2023-03-10T22:19:11","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9683"},"modified":"2023-09-11T18:03:10","modified_gmt":"2023-09-11T18:03:10","slug":"locum-family-physician-bayswater-family-practice-3","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-bayswater-family-practice-3/","title":{"rendered":"Locum Family Physician &#8211; Bayswater Family Practice"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8745,"set_specific_time":true,"job_listing-start_date":"20231218","job_listing-end_date":"20240105","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Locum coverage needed 2.5-3 days per week. There are 20-25 patients booked per day with a mix of virtual and in person appointments. The physician's patient panel is full spectrum with primarily young to middle-aged families, some elderly patients, and very few complex patients.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1715196","job_listing-clinic_lattitude":49.2644675,"job_listing-job_location":"49.2644675%-123.1715196","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9683"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8745"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9683"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9683"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9683"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9683"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9683"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9683"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9682,"date":"2023-03-10T22:16:12","date_gmt":"2023-03-10T22:16:12","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9682"},"modified":"2023-04-25T22:15:58","modified_gmt":"2023-04-25T22:15:58","slug":"locum-family-physician-broadway-plaza-family-practice","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-broadway-plaza-family-practice/","title":{"rendered":"Locum Family Physician &#8211; Broadway Plaza Family Practice"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8751,"set_specific_time":true,"job_listing-start_date":"20230922","job_listing-end_date":"20231004","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 100% private billings","job_listing-description":"","job_listing-job_specifics":"Monday, Tuesday, Wednesday and Friday","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1181345","job_listing-clinic_lattitude":49.2636573,"job_listing-job_location":"49.2636573%-123.1181345","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9682"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8751"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9682"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9682"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9682"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9682"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9682"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9682"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9646,"date":"2023-03-08T17:08:46","date_gmt":"2023-03-08T17:08:46","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9646"},"modified":"2023-05-08T18:51:21","modified_gmt":"2023-05-08T18:51:21","slug":"permanent-family-physician-takeover-medical-office-on-41st-and-cambie","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-takeover-medical-office-on-41st-and-cambie/","title":{"rendered":"Permanent Family Physician (Takeover) &#8211; Medical Office on 41st and Cambie"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":10316,"set_specific_time":true,"job_listing-start_date":"20231101","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"The patient population is primarily female with specialties in obstetrics and pediatrics, with some patients speaking Cantonese or Mandarin.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9646"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10316"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9646"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9646"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9646"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9646"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9646"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9646"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9645,"date":"2023-03-08T17:05:57","date_gmt":"2023-03-08T17:05:57","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9645"},"modified":"2023-05-08T18:43:14","modified_gmt":"2023-05-08T18:43:14","slug":"permanent-family-physician-takeover-medical-office-on-kingsway-and-joyce","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-takeover-medical-office-on-kingsway-and-joyce/","title":{"rendered":"Permanent Family Physician (Takeover) &#8211; Medical Office on Kingsway and Joyce"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":10313,"set_specific_time":true,"job_listing-start_date":"20230701","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, negotiable hourly minimum","job_listing-description":"","job_listing-job_specifics":"Panel takeover starting July, 2023. 0.7 FTE, locum trial period accepted.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9645"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10313"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9645"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9645"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9645"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9645"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9645"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9645"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9641,"date":"2023-03-08T00:32:53","date_gmt":"2023-03-08T00:32:53","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9641"},"modified":"2023-05-08T18:48:54","modified_gmt":"2023-05-08T18:48:54","slug":"permanent-family-physician-takeover-medical-office-on-laurel-and-8th","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-takeover-medical-office-on-laurel-and-8th/","title":{"rendered":"Permanent Family Physician (Takeover) &#8211; Medical Office on Laurel and 8th"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8889,"set_specific_time":true,"job_listing-start_date":"20230307","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"This practice does not require obstetrics but has the option to do prenatal care and obstetrical delivery as well as minor surgeries if the new FP has interest. The retiring FP practices in English and Chinese and although experience with Chinese is not essential it would be an asset.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1234119","job_listing-clinic_lattitude":49.2640253,"job_listing-job_location":"49.2640253%-123.1234119","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9641"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8889"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9641"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9641"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9641"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9641"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9641"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9641"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9639,"date":"2023-03-08T00:25:50","date_gmt":"2023-03-08T00:25:50","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9639"},"modified":"2023-05-08T18:57:39","modified_gmt":"2023-05-08T18:57:39","slug":"permanent-family-physician-takeover-medical-office-on-burrard-and-davie","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-takeover-medical-office-on-burrard-and-davie/","title":{"rendered":"Permanent Family Physician (Takeover) &#8211; Medical Office on Burrard and Davie"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":10318,"set_specific_time":true,"job_listing-start_date":"20240101","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"The current physician sees an average of 30+ patients per day. Proficiency in Russian or Polish is considered an asset, however, it is not required.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9639"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10318"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9639"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9639"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9639"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9639"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9639"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9639"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9638,"date":"2023-03-08T00:21:49","date_gmt":"2023-03-08T00:21:49","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9638"},"modified":"2023-05-08T18:54:53","modified_gmt":"2023-05-08T18:54:53","slug":"permanent-family-physician-takeover-medical-office-on-kingsway-and-baldwin","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-takeover-medical-office-on-kingsway-and-baldwin/","title":{"rendered":"Permanent Family Physician (Takeover) &#8211; Medical Office on Kingsway and Baldwin"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":10317,"set_specific_time":true,"job_listing-start_date":"20230901","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9638"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/10317"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9638"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9638"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9638"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9638"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9638"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9638"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9637,"date":"2023-03-07T23:08:55","date_gmt":"2023-03-07T23:08:55","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9637"},"modified":"2023-08-04T18:41:23","modified_gmt":"2023-08-04T18:41:23","slug":"permanent-family-physician-tlc-medical-clinic-fraser","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-tlc-medical-clinic-fraser/","title":{"rendered":"Permanent Family Physician &#8211; TLC Medical Clinic (Marine Drive)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9629,"set_specific_time":true,"job_listing-start_date":"20230307","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0904915","job_listing-clinic_lattitude":49.2114363,"job_listing-job_location":"49.2114363%-123.0904915","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9637"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9629"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9637"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9637"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9637"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9637"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9637"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9637"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9636,"date":"2023-03-07T23:07:39","date_gmt":"2023-03-07T23:07:39","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9636"},"modified":"2023-03-07T23:07:39","modified_gmt":"2023-03-07T23:07:39","slug":"locum-family-physician-tlc-medical-clinic-fraser","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-tlc-medical-clinic-fraser/","title":{"rendered":"Locum Family Physician &#8211; TLC Medical Clinic (Fraser)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9629,"set_specific_time":true,"job_listing-start_date":"20230307","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0904915","job_listing-clinic_lattitude":49.2114363,"job_listing-job_location":"49.2114363%-123.0904915","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9636"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9629"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9636"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9636"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9636"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9636"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9636"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9636"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9628,"date":"2023-03-07T22:13:39","date_gmt":"2023-03-07T22:13:39","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9628"},"modified":"2023-07-25T18:50:37","modified_gmt":"2023-07-25T18:50:37","slug":"locum-family-physician-woodland-family-practice","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-woodland-family-practice/","title":{"rendered":"Locum Family Physician &#8211; Woodland Family Practice"},"excerpt":{"rendered":"<p>Multiple Dates Available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9626,"set_specific_time":true,"job_listing-start_date":"20231218","job_listing-end_date":"20240831","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Flexible Locum Needed - Long term and short term opportunities available/\r\nDecember 18, 2023-January 5, 2024\r\nJuly/August 2024","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.05629","job_listing-clinic_lattitude":49.2708927,"job_listing-job_location":"49.2708927%-123.05629","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9628"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9626"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9628"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9628"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9628"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9628"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9628"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9628"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9627,"date":"2023-03-07T22:11:24","date_gmt":"2023-03-07T22:11:24","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9627"},"modified":"2023-04-25T22:17:31","modified_gmt":"2023-04-25T22:17:31","slug":"permanent-family-physician-woodland-family-practice","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-woodland-family-practice/","title":{"rendered":"Permanent Family Physician &#8211; Woodland Family Practice"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9626,"set_specific_time":true,"job_listing-start_date":"20230307","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"3 days per week","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.05629","job_listing-clinic_lattitude":49.2708927,"job_listing-job_location":"49.2708927%-123.05629","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9627"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9626"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9627"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9627"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9627"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9627"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9627"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9627"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9615,"date":"2023-03-06T23:46:16","date_gmt":"2023-03-06T23:46:16","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9615"},"modified":"2023-03-06T23:46:25","modified_gmt":"2023-03-06T23:46:25","slug":"permanent-family-physician-st-pauls-maternity-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-st-pauls-maternity-clinic/","title":{"rendered":"Permanent Family Physician &#8211; St. Paul&#8217;s Maternity Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8929,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Sessional","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1282326","job_listing-clinic_lattitude":49.2805247,"job_listing-job_location":"49.2805247%-123.1282326","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9615"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8929"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9615"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9615"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9615"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9615"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9615"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9615"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9614,"date":"2023-03-06T23:37:00","date_gmt":"2023-03-06T23:37:00","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9614"},"modified":"2023-04-25T22:17:49","modified_gmt":"2023-04-25T22:17:49","slug":"locum-family-physician-st-pauls-maternity-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-st-pauls-maternity-clinic/","title":{"rendered":"Locum Family Physician &#8211; St. Paul&#8217;s Maternity Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8929,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":"20240229","non_specific_date_message":"Negotiable","job_listing-remuneration":"Sessional","job_listing-description":"","job_listing-job_specifics":"Maternity leave coverage - February 2023, every Wednesday alternating clinic and call for one year (day can be flexible)","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1282326","job_listing-clinic_lattitude":49.2805247,"job_listing-job_location":"49.2805247%-123.1282326","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9614"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8929"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9614"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9614"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9614"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9614"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9614"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9614"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9611,"date":"2023-03-06T23:26:00","date_gmt":"2023-03-06T23:26:00","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9611"},"modified":"2023-04-25T22:19:15","modified_gmt":"2023-04-25T22:19:15","slug":"permanent-family-physician-ubc-student-health-services","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-ubc-student-health-services/","title":{"rendered":"Permanent Family Physician &#8211; UBC Student Health Services"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8996,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Salaried ($118.69/hour + 19.2% vacation)","job_listing-description":"","job_listing-job_specifics":"0.5 FTE","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.2457018","job_listing-clinic_lattitude":49.2643047,"job_listing-job_location":"49.2643047%-123.2457018","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9611"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8996"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9611"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9611"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9611"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9611"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9611"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9611"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9610,"date":"2023-03-06T23:24:06","date_gmt":"2023-03-06T23:24:06","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9610"},"modified":"2023-03-27T21:10:00","modified_gmt":"2023-03-27T21:10:00","slug":"locum-family-physician-luma-medical-centre-society","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-luma-medical-centre-society/","title":{"rendered":"Locum Family Physician &#8211; Lu&#8217;Ma Medical Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8907,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Alternate Payment Model","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0563331","job_listing-clinic_lattitude":49.257386,"job_listing-job_location":"49.257386%-123.0563331","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9610"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8907"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9610"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9610"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9610"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9610"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9610"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9610"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9607,"date":"2023-03-06T23:16:50","date_gmt":"2023-03-06T23:16:50","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9607"},"modified":"2023-05-02T23:12:48","modified_gmt":"2023-05-02T23:12:48","slug":"locum-family-physician-fraser-street-medical","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-fraser-street-medical/","title":{"rendered":"Locum Family Physician &#8211; Fraser Street Medical"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8838,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Ongoing needs, multiple dates available","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0903124","job_listing-clinic_lattitude":49.2304914,"job_listing-job_location":"49.2304914%-123.0903124","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9607"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8838"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9607"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9607"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9607"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9607"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9607"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9607"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9606,"date":"2023-03-06T23:08:15","date_gmt":"2023-03-06T23:08:15","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9606"},"modified":"2023-04-25T22:19:35","modified_gmt":"2023-04-25T22:19:35","slug":"locum-family-physician-medical-office-on-laurel-and-8th","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-medical-office-on-laurel-and-8th/","title":{"rendered":"Locum Family Physician &#8211; Medical Office on Laurel and 8th"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8794,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Christmas, New Years, and Spring Break coverage preferred","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1234119","job_listing-clinic_lattitude":49.2640253,"job_listing-job_location":"49.2640253%-123.1234119","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9606"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8794"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9606"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9606"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9606"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9606"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9606"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9606"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9605,"date":"2023-03-06T23:04:29","date_gmt":"2023-03-06T23:04:29","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9605"},"modified":"2023-04-25T22:19:45","modified_gmt":"2023-04-25T22:19:45","slug":"permanent-family-physician-medical-office-on-nanaimo-and-pender","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-medical-office-on-nanaimo-and-pender/","title":{"rendered":"Permanent Family Physician &#8211; Medical Office on Nanaimo and Pender"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8793,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"1-2 days per week","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0559482","job_listing-clinic_lattitude":49.2805384,"job_listing-job_location":"49.2805384%-123.0559482","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9605"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8793"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9605"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9605"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9605"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9605"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9605"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9605"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9604,"date":"2023-03-06T23:03:05","date_gmt":"2023-03-06T23:03:05","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9604"},"modified":"2023-03-06T23:03:05","modified_gmt":"2023-03-06T23:03:05","slug":"permanent-family-physician-medical-office-on-laurel-and-8th","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-medical-office-on-laurel-and-8th/","title":{"rendered":"Permanent Family Physician &#8211; Medical Office on Laurel and 8th"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8794,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Cost Sharing Agreement","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1234119","job_listing-clinic_lattitude":49.2640253,"job_listing-job_location":"49.2640253%-123.1234119","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9604"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8794"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9604"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9604"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9604"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9604"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9604"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9604"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9598,"date":"2023-03-06T21:26:46","date_gmt":"2023-03-06T21:26:46","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9598"},"modified":"2023-04-25T22:19:57","modified_gmt":"2023-04-25T22:19:57","slug":"permanent-family-physician-forward-care-medical-clinic-oakridge","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-forward-care-medical-clinic-oakridge/","title":{"rendered":"Permanent Family Physician &#8211; Forward Care Medical Clinic (Oakridge)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8834,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 100% for medical/legal reports","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1170634","job_listing-clinic_lattitude":49.2328589,"job_listing-job_location":"49.2328589%-123.1170634","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9598"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8834"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9598"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9598"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9598"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9598"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9598"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9598"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9597,"date":"2023-03-06T21:24:44","date_gmt":"2023-03-06T21:24:44","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9597"},"modified":"2023-07-25T17:58:44","modified_gmt":"2023-07-25T17:58:44","slug":"locum-family-physician-forward-care-medical-clinic-oakridge","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-forward-care-medical-clinic-oakridge/","title":{"rendered":"Locum Family Physician &#8211; Forward Care Medical Clinic (Oakridge)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8834,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 100% for medical/legal reports","job_listing-description":"","job_listing-job_specifics":"Long term and short term opportunities available","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1170634","job_listing-clinic_lattitude":49.2328589,"job_listing-job_location":"49.2328589%-123.1170634","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9597"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8834"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9597"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9597"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9597"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9597"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9597"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9597"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9596,"date":"2023-03-06T21:22:50","date_gmt":"2023-03-06T21:22:50","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9596"},"modified":"2023-03-06T21:22:50","modified_gmt":"2023-03-06T21:22:50","slug":"locum-family-physician-vycare-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-vycare-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; VyCare Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9007,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Negotiable","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.026608","job_listing-clinic_lattitude":49.2323817,"job_listing-job_location":"49.2323817%-123.026608","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9596"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9007"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9596"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9596"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9596"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9596"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9596"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9596"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9595,"date":"2023-03-06T21:08:13","date_gmt":"2023-03-06T21:08:13","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9595"},"modified":"2023-03-27T21:10:51","modified_gmt":"2023-03-27T21:10:51","slug":"permanent-family-physician-homevive-program","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-homevive-program/","title":{"rendered":"Permanent Family Physician &#8211; Home-Vive"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8865,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"$115 per home visit, $20 per telephone call","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1211227","job_listing-clinic_lattitude":49.2615829,"job_listing-job_location":"49.2615829%-123.1211227","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9595"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8865"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9595"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9595"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9595"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9595"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9595"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9595"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9594,"date":"2023-03-06T21:06:08","date_gmt":"2023-03-06T21:06:08","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9594"},"modified":"2023-05-04T21:56:42","modified_gmt":"2023-05-04T21:56:42","slug":"locum-family-physician-south-vancouver-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-south-vancouver-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; South Vancouver Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8980,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0994426","job_listing-clinic_lattitude":49.2098082,"job_listing-job_location":"49.2098082%-123.0994426","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9594"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8980"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9594"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9594"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9594"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9594"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9594"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9594"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9593,"date":"2023-03-06T21:04:36","date_gmt":"2023-03-06T21:04:36","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9593"},"modified":"2023-05-04T22:47:41","modified_gmt":"2023-05-04T22:47:41","slug":"permanent-family-physician-reach-community-health-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-reach-community-health-centre/","title":{"rendered":"Permanent Family Physician &#8211; Reach Community Health Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[189],"joblisting_community":[146],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8952,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Alternate Payment Model","job_listing-description":"","job_listing-job_specifics":"The provider will see an average of 15-20 patients a day, consisting of medically and psychosocially complex care including addictions care. Addictions care patients make up approximately 5-10% of the patient panel but account for a larger proportion of the clinic’s monthly visits, however the clinic serves full-spectrum family medicine from cradle to grave. There may be house calls for homebound patients, as well as early prenatal care up to 20 weeks, however there is no obstetrics or 3rd trimester care. No inpatient hospital work required.\r\n\r\nThe incoming FP will negotiate their set weekly schedule with the CHC, and there may be some flexibility in weekly scheduling thereafter, however this will be constrained by room availability. One day a week permanent staff/MRP’s will perform Telehealth, but all new locums are always required on site.\r\n\r\nRemuneration is in the form of sessional pay, with a patient panel focus on addictions and complexity.\r\n\r\n<span style=\"text-decoration: underline;\"><strong>Qualifications include:</strong></span>\r\n<ul>\r\n \t<li>Physician registered (Full) with the College of Physicians and Surgeons of B.C.</li>\r\n \t<li>Certification with the College of Family Physicians of Canada.</li>\r\n \t<li>Commitment and ability to implement REACH’s strategic goals, mission, vision, and values.</li>\r\n \t<li>A background in working with youth, mental health, addictions, fragile families, refugees, and frail elderly desired.</li>\r\n \t<li>Current methadone exception and Suboxone certification or willingness to obtain same.</li>\r\n \t<li>An awareness of the impact of colonization on Aboriginal peoples and understanding of cultural competency as a care provider.</li>\r\n \t<li>Ability to speak more than one language is an asset.</li>\r\n \t<li>Experience or training in delivering medical education an asset.</li>\r\n \t<li>Experience or training in primary care research and policy an asset.</li>\r\n</ul>\r\n<strong>Positions: </strong>2\r\n<strong>FTE:</strong> 0.7 FTE\r\n<strong>Facility Type:</strong> Community Health Centre\r\n<strong>Health Authority:</strong> Vancouver Coastal Health\r\n<strong>Sub-specialty:</strong> Addiction Medicine\r\n<strong>Scheduling:</strong> 0.7 FTE is 3 days a week of direct patient care, including 1 evening session 5pm-8pm each week, 3.5hrs/wk administrative duties. 1hr/wk team or quality improvement meetings.\r\n<strong>On-Call Hours:</strong> Yes (Telephone on-call support after hours 1:8)\r\n<strong>Compensation:</strong> Approximately $300,000/FTE *Alternative Payment Arrangement – Service Contract 1.0 FTE = 1680hrs/year\r\n<strong>Overhead:</strong> 9.5%\r\n<strong>Benefits and/or Incentives:</strong> Vacation/Study Leave: Up to 7 weeks a year unpaid as part of service contract agreement.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0698458","job_listing-clinic_lattitude":49.2744039,"job_listing-job_location":"49.2744039%-123.0698458","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9593"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8952"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9593"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9593"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9593"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9593"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9593"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9593"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9592,"date":"2023-03-06T21:00:09","date_gmt":"2023-03-06T21:00:09","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9592"},"modified":"2023-06-02T21:07:29","modified_gmt":"2023-06-02T21:07:29","slug":"locum-family-physician-reach-community-health-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-reach-community-health-centre/","title":{"rendered":"Locum Family Physician &#8211; Reach Community Health Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[189],"joblisting_community":[146],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8952,"set_specific_time":true,"job_listing-start_date":"20230801","job_listing-end_date":"20230929","non_specific_date_message":"Negotiable","job_listing-remuneration":"Alternate Payment Model","job_listing-description":"","job_listing-job_specifics":"June 26-July 14 (1 locum: 3-4 days per week)\r\nAugust 1-September 29 (2 locums: up to 5 days per week)\r\n\r\nThe provider will see an average of 15-20 patients a day, consisting of medically and psychosocially complex care including addictions care. Addictions care patients make up approximately 5-10% of the patient panel but account for a larger proportion of the clinic’s monthly visits, however the clinic serves full-spectrum family medicine from cradle to grave. There may be house calls for homebound patients, as well as early prenatal care up to 20 weeks, however there is no obstetrics or 3rd trimester care. No inpatient hospital work required.\r\n\r\nRemuneration is in the form of sessional pay, with a patient panel focus on addictions and complexity.\r\n\r\n<strong>Qualifications include:</strong>\r\n<ul>\r\n \t<li>Physician registered (Full) with the College of Physicians and Surgeons of B.C.</li>\r\n \t<li>Certification with the College of Family Physicians of Canada.</li>\r\n \t<li>Commitment and ability to implement REACH’s strategic goals, mission, vision, and values.</li>\r\n \t<li>A background in working with youth, mental health, addictions, fragile families, refugees, and frail elderly desired.</li>\r\n \t<li>Current methadone exception and Suboxone certification or willingness to obtain same.</li>\r\n \t<li>An awareness of the impact of colonization on Aboriginal peoples and understanding of cultural competency as a care provider.</li>\r\n \t<li>Ability to speak more than one language is an asset.</li>\r\n \t<li>Experience or training in delivering medical education an asset.</li>\r\n \t<li>Experience or training in primary care research and policy an asset.</li>\r\n</ul>\r\n<strong>Facility Type:</strong> Community Health Centre\r\n<strong>Health Authority:</strong> Vancouver Coastal Health\r\n<strong>Sub-specialty:</strong> Addiction Medicine\r\n<strong>On-Call Hours:</strong> Yes (Telephone on-call support after hours 1:8)\r\n<strong>Overhead:</strong> 9.5%","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0698458","job_listing-clinic_lattitude":49.2744039,"job_listing-job_location":"49.2744039%-123.0698458","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9592"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8952"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9592"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9592"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9592"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9592"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9592"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9592"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9591,"date":"2023-03-06T20:55:34","date_gmt":"2023-03-06T20:55:34","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9591"},"modified":"2023-03-06T20:55:34","modified_gmt":"2023-03-06T20:55:34","slug":"locum-family-physician-reach-urgent-primary-care-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-reach-urgent-primary-care-centre/","title":{"rendered":"Locum Family Physician &#8211; Reach Urgent &#038; Primary Care Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[188],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8956,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"$163.39/hr. (0.8 FTE- 28 hours per week)","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0698458","job_listing-clinic_lattitude":49.2744039,"job_listing-job_location":"49.2744039%-123.0698458","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9591"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8956"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9591"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9591"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9591"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9591"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9591"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9591"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9589,"date":"2023-03-06T20:46:11","date_gmt":"2023-03-06T20:46:11","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9589"},"modified":"2023-03-06T20:46:11","modified_gmt":"2023-03-06T20:46:11","slug":"permanent-family-physician-urban-native-youth-association","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-urban-native-youth-association/","title":{"rendered":"Permanent Family Physician &#8211; Urban Native Youth Association"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9003,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Alternate Payment Model","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0715372","job_listing-clinic_lattitude":49.2810865,"job_listing-job_location":"49.2810865%-123.0715372","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9589"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9003"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9589"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9589"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9589"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9589"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9589"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9589"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9586,"date":"2023-03-06T20:23:17","date_gmt":"2023-03-06T20:23:17","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9586"},"modified":"2023-04-25T22:20:45","modified_gmt":"2023-04-25T22:20:45","slug":"locum-family-physician-georgia-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-georgia-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Georgia Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8840,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"Wednesday and Friday shifts available - 12:30pm-4:30pm ongoing","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1342138","job_listing-clinic_lattitude":49.2924601,"job_listing-job_location":"49.2924601%-123.1342138","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9586"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8840"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9586"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9586"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9586"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9586"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9586"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9586"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9584,"date":"2023-03-06T20:16:21","date_gmt":"2023-03-06T20:16:21","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9584"},"modified":"2023-08-21T19:39:38","modified_gmt":"2023-08-21T19:39:38","slug":"locum-family-physician-yyoung-medical-clinic-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-yyoung-medical-clinic-2/","title":{"rendered":"Locum Family Physician &#8211; yYoung Medical Clinic"},"excerpt":{"rendered":"<p>Multiple Dates Available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9032,"set_specific_time":true,"job_listing-start_date":"20231120","job_listing-end_date":"20230430","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, $100 hourly minimum","job_listing-description":"","job_listing-job_specifics":"November 20-December 1, 2023\r\nMarch-April 2024 (6-8 weeks paternity leave)","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1009101","job_listing-clinic_lattitude":49.2699771,"job_listing-job_location":"49.2699771%-123.1009101","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9584"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9032"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9584"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9584"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9584"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9584"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9584"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9584"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9576,"date":"2023-03-06T20:13:05","date_gmt":"2023-03-06T20:13:05","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9576"},"modified":"2023-04-25T22:22:13","modified_gmt":"2023-04-25T22:22:13","slug":"permanent-family-physician-marine-gateway-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-marine-gateway-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Marine Gateway Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9577,"set_specific_time":true,"job_listing-start_date":"20230323","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1165058","job_listing-clinic_lattitude":49.2099136,"job_listing-job_location":"49.2099136%-123.1165058","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9576"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9577"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9576"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9576"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9576"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9576"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9576"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9576"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9575,"date":"2023-03-06T20:09:52","date_gmt":"2023-03-06T20:09:52","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9575"},"modified":"2023-03-06T20:09:52","modified_gmt":"2023-03-06T20:09:52","slug":"permanent-family-physician-georgia-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-georgia-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Georgia Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8840,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1342138","job_listing-clinic_lattitude":49.2924601,"job_listing-job_location":"49.2924601%-123.1342138","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9575"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8840"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9575"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9575"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9575"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9575"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9575"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9575"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9574,"date":"2023-03-06T20:08:18","date_gmt":"2023-03-06T20:08:18","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9574"},"modified":"2023-03-06T20:08:18","modified_gmt":"2023-03-06T20:08:18","slug":"locum-family-physician-granville-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-granville-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Granville Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8843,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1383608","job_listing-clinic_lattitude":49.2629811,"job_listing-job_location":"49.2629811%-123.1383608","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9574"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8843"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9574"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9574"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9574"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9574"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9574"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9574"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9573,"date":"2023-03-06T20:06:50","date_gmt":"2023-03-06T20:06:50","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9573"},"modified":"2023-04-25T22:22:15","modified_gmt":"2023-04-25T22:22:15","slug":"permanent-family-physician-vycare-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-vycare-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; VyCare Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9007,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Negotiable","job_listing-description":"","job_listing-job_specifics":"Open to both fully licensed and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.026608","job_listing-clinic_lattitude":49.2323817,"job_listing-job_location":"49.2323817%-123.026608","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9573"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9007"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9573"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9573"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9573"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9573"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9573"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9573"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9572,"date":"2023-03-06T20:04:44","date_gmt":"2023-03-06T20:04:44","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9572"},"modified":"2023-03-06T20:04:44","modified_gmt":"2023-03-06T20:04:44","slug":"permanent-family-physician-queens-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-queens-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Queens Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8948,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0599773","job_listing-clinic_lattitude":49.2429212,"job_listing-job_location":"49.2429212%-123.0599773","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9572"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8948"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9572"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9572"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9572"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9572"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9572"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9572"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9571,"date":"2023-03-06T20:02:56","date_gmt":"2023-03-06T20:02:56","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9571"},"modified":"2023-04-25T22:22:24","modified_gmt":"2023-04-25T22:22:24","slug":"permanent-family-physician-loyal-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-loyal-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Loyal Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8897,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1216604","job_listing-clinic_lattitude":49.285265,"job_listing-job_location":"49.285265%-123.1216604","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9571"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8897"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9571"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9571"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9571"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9571"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9571"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9571"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9570,"date":"2023-03-06T19:59:40","date_gmt":"2023-03-06T19:59:40","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9570"},"modified":"2023-03-06T19:59:40","modified_gmt":"2023-03-06T19:59:40","slug":"locum-family-physician-little-mountain-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-little-mountain-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Little Mountain Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8890,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1165484","job_listing-clinic_lattitude":49.2630608,"job_listing-job_location":"49.2630608%-123.1165484","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9570"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8890"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9570"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9570"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9570"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9570"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9570"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9570"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9567,"date":"2023-03-06T18:57:49","date_gmt":"2023-03-06T18:57:49","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9567"},"modified":"2023-04-25T22:22:45","modified_gmt":"2023-04-25T22:22:45","slug":"permanent-family-physician-well-health-medical-clinic-city-view","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-well-health-medical-clinic-city-view/","title":{"rendered":"Permanent Family Physician &#8211; WELL Health Medical Clinic (City View)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9010,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1196326","job_listing-clinic_lattitude":49.2635805,"job_listing-job_location":"49.2635805%-123.1196326","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9567"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9010"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9567"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9567"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9567"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9567"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9567"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9567"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9566,"date":"2023-03-06T18:56:06","date_gmt":"2023-03-06T18:56:06","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9566"},"modified":"2023-03-06T18:56:06","modified_gmt":"2023-03-06T18:56:06","slug":"locum-family-physician-sina-medical-and-aesthetics-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-sina-medical-and-aesthetics-clinic/","title":{"rendered":"Locum Family Physician &#8211; Sina Medical and Aesthetics Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8967,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1194461","job_listing-clinic_lattitude":49.2793002,"job_listing-job_location":"49.2793002%-123.1194461","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9566"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8967"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9566"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9566"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9566"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9566"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9566"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9566"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9564,"date":"2023-03-06T18:52:35","date_gmt":"2023-03-06T18:52:35","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9564"},"modified":"2023-05-04T21:56:49","modified_gmt":"2023-05-04T21:56:49","slug":"permanent-family-physician-south-vancouver-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-south-vancouver-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; South Vancouver Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8980,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0994426","job_listing-clinic_lattitude":49.2098082,"job_listing-job_location":"49.2098082%-123.0994426","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9564"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8980"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9564"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9564"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9564"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9564"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9564"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9564"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9563,"date":"2023-03-06T18:50:27","date_gmt":"2023-03-06T18:50:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9563"},"modified":"2023-03-06T18:50:27","modified_gmt":"2023-03-06T18:50:27","slug":"permanent-family-physician-iss-of-bc-welcome-centre-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-iss-of-bc-welcome-centre-clinic/","title":{"rendered":"Permanent Family Physician &#8211; ISS of BC Welcome Centre Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8868,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":"20230306","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0653303","job_listing-clinic_lattitude":49.2610006,"job_listing-job_location":"49.2610006%-123.0653303","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9563"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8868"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9563"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9563"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9563"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9563"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9563"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9563"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9562,"date":"2023-03-06T18:46:51","date_gmt":"2023-03-06T18:46:51","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9562"},"modified":"2023-03-06T18:46:51","modified_gmt":"2023-03-06T18:46:51","slug":"locum-family-physician-iss-of-bc-welcome-centre-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-iss-of-bc-welcome-centre-clinic/","title":{"rendered":"Locum Family Physician &#8211; ISS of BC Welcome Centre Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8868,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0653303","job_listing-clinic_lattitude":49.2610006,"job_listing-job_location":"49.2610006%-123.0653303","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9562"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8868"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9562"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9562"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9562"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9562"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9562"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9562"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9561,"date":"2023-03-06T18:24:58","date_gmt":"2023-03-06T18:24:58","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9561"},"modified":"2023-03-06T18:25:11","modified_gmt":"2023-03-06T18:25:11","slug":"permanent-family-physician-pharmachoice-main","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-pharmachoice-main/","title":{"rendered":"Permanent Family Physician &#8211; PharmaChoice Main"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8947,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"100% of billings","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1007979","job_listing-clinic_lattitude":49.2504517,"job_listing-job_location":"49.2504517%-123.1007979","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9561"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8947"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9561"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9561"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9561"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9561"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9561"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9561"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9560,"date":"2023-03-06T18:21:55","date_gmt":"2023-03-06T18:21:55","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9560"},"modified":"2023-04-25T22:23:14","modified_gmt":"2023-04-25T22:23:14","slug":"permanent-family-physician-west-10th-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-west-10th-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; West 10th Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9022,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"The clinic has space for one full time or two part time physicians\r\nOpen to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.2033665","job_listing-clinic_lattitude":49.2638745,"job_listing-job_location":"49.2638745%-123.2033665","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9560"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9022"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9560"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9560"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9560"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9560"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9560"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9560"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9559,"date":"2023-03-06T18:16:31","date_gmt":"2023-03-06T18:16:31","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9559"},"modified":"2023-05-08T22:14:39","modified_gmt":"2023-05-08T22:14:39","slug":"permanent-family-physician-heather-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-heather-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Heather Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8848,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"Open to both fully and provisionally licensed candidates","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1204025","job_listing-clinic_lattitude":49.2630891,"job_listing-job_location":"49.2630891%-123.1204025","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9559"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8848"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9559"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9559"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9559"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9559"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9559"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9559"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9558,"date":"2023-03-06T18:12:45","date_gmt":"2023-03-06T18:12:45","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9558"},"modified":"2023-04-25T22:24:10","modified_gmt":"2023-04-25T22:24:10","slug":"permanent-family-physician-granville-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-granville-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Granville Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8843,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1383608","job_listing-clinic_lattitude":49.2629811,"job_listing-job_location":"49.2629811%-123.1383608","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9558"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8843"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9558"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9558"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9558"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9558"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9558"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9558"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9557,"date":"2023-03-06T18:10:53","date_gmt":"2023-03-06T18:10:53","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9557"},"modified":"2023-04-25T22:24:20","modified_gmt":"2023-04-25T22:24:20","slug":"permanent-family-physician-sina-medical-and-aesthetics-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-sina-medical-and-aesthetics-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Sina Medical and Aesthetics Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8967,"set_specific_time":true,"job_listing-start_date":"20230306","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"Room for 1-2 fulltime physician, open to provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1194461","job_listing-clinic_lattitude":49.2793002,"job_listing-job_location":"49.2793002%-123.1194461","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9557"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8967"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9557"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9557"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9557"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9557"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9557"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9557"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9556,"date":"2023-03-04T00:35:46","date_gmt":"2023-03-04T00:35:46","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9556"},"modified":"2023-03-04T00:35:46","modified_gmt":"2023-03-04T00:35:46","slug":"permanent-family-physician-yaletown-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-yaletown-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Yaletown Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9030,"set_specific_time":true,"job_listing-start_date":"20230303","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, $100 hourly minimum","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1228869","job_listing-clinic_lattitude":49.2732651,"job_listing-job_location":"49.2732651%-123.1228869","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9556"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9030"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9556"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9556"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9556"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9556"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9556"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9556"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9554,"date":"2023-03-04T00:05:43","date_gmt":"2023-03-04T00:05:43","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9554"},"modified":"2023-08-14T21:27:35","modified_gmt":"2023-08-14T21:27:35","slug":"locum-family-physician-bayswater-family-practice-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-bayswater-family-practice-2/","title":{"rendered":"Locum Family Physician &#8211; Bayswater Family Practice"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8745,"set_specific_time":true,"job_listing-start_date":"20231218","job_listing-end_date":"20240104","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1715196","job_listing-clinic_lattitude":49.2644675,"job_listing-job_location":"49.2644675%-123.1715196","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9554"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8745"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9554"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9554"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9554"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9554"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9554"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9554"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9553,"date":"2023-03-04T00:03:14","date_gmt":"2023-03-04T00:03:14","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9553"},"modified":"2023-07-10T22:54:18","modified_gmt":"2023-07-10T22:54:18","slug":"locum-family-physician-yaletown-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-yaletown-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Yaletown Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9030,"set_specific_time":false,"job_listing-start_date":"20230303","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, $100 hourly minimum","job_listing-description":"","job_listing-job_specifics":"Monday-Friday 9am-3pm or 3pm-8pm, Saturdays 10am-5pm\r\nLong term locum for Weekends (80/20 billing split, 3-6 months)","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1228869","job_listing-clinic_lattitude":49.2732651,"job_listing-job_location":"49.2732651%-123.1228869","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9553"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9030"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9553"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9553"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9553"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9553"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9553"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9553"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9551,"date":"2023-03-03T23:29:19","date_gmt":"2023-03-03T23:29:19","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9551"},"modified":"2023-04-25T22:25:48","modified_gmt":"2023-04-25T22:25:48","slug":"locum-family-physician-oakridge-medical-group","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-oakridge-medical-group/","title":{"rendered":"Locum Family Physician &#8211; Oakridge Medical Group"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8943,"set_specific_time":true,"job_listing-start_date":"20230303","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1158391","job_listing-clinic_lattitude":49.2347432,"job_listing-job_location":"49.2347432%-123.1158391","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9551"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8943"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9551"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9551"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9551"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9551"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9551"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9551"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9550,"date":"2023-03-03T23:18:07","date_gmt":"2023-03-03T23:18:07","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9550"},"modified":"2023-08-21T19:12:22","modified_gmt":"2023-08-21T19:12:22","slug":"locum-family-physician-kariba-health","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-kariba-health/","title":{"rendered":"Locum Family Physician &#8211; Kariba Health"},"excerpt":{"rendered":"<p>Multiple Dates Available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8871,"set_specific_time":true,"job_listing-start_date":"20230701","job_listing-end_date":"20240131","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Maternity Leave Locum - November 2023 through May/June 2024\r\nFlexible Locum to cover overflow 1-3 days per week)","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1533438","job_listing-clinic_lattitude":49.2622939,"job_listing-job_location":"49.2622939%-123.1533438","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9550"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8871"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9550"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9550"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9550"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9550"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9550"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9550"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9380,"date":"2023-02-24T00:35:18","date_gmt":"2023-02-24T00:35:18","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9380"},"modified":"2023-04-25T22:26:10","modified_gmt":"2023-04-25T22:26:10","slug":"permanent-family-physician-yyoung-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-yyoung-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; yYoung Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9032,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"This clinic is seeking permanent family physicians for their walk-in clinic, or to start a patient panel.\r\nOpen to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1009101","job_listing-clinic_lattitude":49.2699771,"job_listing-job_location":"49.2699771%-123.1009101","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9380"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9032"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9380"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9380"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9380"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9380"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9380"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9380"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9379,"date":"2023-02-24T00:31:00","date_gmt":"2023-02-24T00:31:00","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9379"},"modified":"2023-06-05T19:39:45","modified_gmt":"2023-06-05T19:39:45","slug":"locum-family-physician-yyoung-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-yyoung-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; yYoung Medical Clinic"},"excerpt":{"rendered":"<p>Multiple opportunities available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9032,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Coverage for the walk-in clinic/Overflow coverage for 2 physician's","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1009101","job_listing-clinic_lattitude":49.2699771,"job_listing-job_location":"49.2699771%-123.1009101","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9379"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9032"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9379"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9379"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9379"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9379"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9379"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9379"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9378,"date":"2023-02-24T00:28:56","date_gmt":"2023-02-24T00:28:56","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9378"},"modified":"2023-04-25T22:26:26","modified_gmt":"2023-04-25T22:26:26","slug":"permanent-family-physician-medical-office-on-w-broadway-and-willow-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-medical-office-on-w-broadway-and-willow-st/","title":{"rendered":"Permanent Family Physician &#8211; Medical Office on W Broadway and Willow"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9048,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"3 Days/Week","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1250251","job_listing-clinic_lattitude":49.2637081,"job_listing-job_location":"49.2637081%-123.1250251","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9378"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9048"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9378"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9378"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9378"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9378"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9378"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9378"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9377,"date":"2023-02-24T00:26:15","date_gmt":"2023-02-24T00:26:15","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9377"},"modified":"2023-09-11T18:18:25","modified_gmt":"2023-09-11T18:18:25","slug":"locum-family-physician-medical-office-on-w-50th-and-main-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-medical-office-on-w-50th-and-main-st/","title":{"rendered":"Locum Family Physician &#8211; Dr. PS Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9049,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Negotiable","job_listing-description":"","job_listing-job_specifics":"1–3 month locum with the ability to extend or become permanent","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.101429","job_listing-clinic_lattitude":49.2248253,"job_listing-job_location":"49.2248253%-123.101429","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9377"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9049"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9377"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9377"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9377"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9377"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9377"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9377"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9376,"date":"2023-02-24T00:24:04","date_gmt":"2023-02-24T00:24:04","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9376"},"modified":"2023-09-11T18:18:06","modified_gmt":"2023-09-11T18:18:06","slug":"permanent-family-physician-medical-office-on-w-50th-and-main-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-medical-office-on-w-50th-and-main-st/","title":{"rendered":"Permanent Family Physician &#8211; Dr. PS Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9049,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Negotiable","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.101429","job_listing-clinic_lattitude":49.2248253,"job_listing-job_location":"49.2248253%-123.101429","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9376"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9049"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9376"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9376"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9376"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9376"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9376"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9376"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9375,"date":"2023-02-24T00:20:42","date_gmt":"2023-02-24T00:20:42","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9375"},"modified":"2023-04-25T22:26:57","modified_gmt":"2023-04-25T22:26:57","slug":"locum-family-physician-medical-office-on-nanaimo-st-and-e-pender-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-medical-office-on-nanaimo-st-and-e-pender-st/","title":{"rendered":"Locum Family Physician- Medical Office on Nanaimo and E Pender"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8793,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"This clinic is seeking a locum for any 2 weeks in the year. The coverage needed would include 4 days per week with a half day on Wednesday.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0559482","job_listing-clinic_lattitude":49.2805384,"job_listing-job_location":"49.2805384%-123.0559482","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9375"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8793"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9375"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9375"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9375"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9375"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9375"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9375"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9374,"date":"2023-02-24T00:16:16","date_gmt":"2023-02-24T00:16:16","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9374"},"modified":"2023-03-27T21:16:13","modified_gmt":"2023-03-27T21:16:13","slug":"permanent-family-physician-medical-office-on-dunbar-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-medical-office-on-dunbar-st/","title":{"rendered":"Permanent Family Physician &#8211; Medical Office on Dunbar and W 17th"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9337,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1853382","job_listing-clinic_lattitude":49.2566473,"job_listing-job_location":"49.2566473%-123.1853382","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9374"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9337"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9374"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9374"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9374"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9374"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9374"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9374"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9368,"date":"2023-02-23T23:45:27","date_gmt":"2023-02-23T23:45:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9368"},"modified":"2023-04-25T22:27:37","modified_gmt":"2023-04-25T22:27:37","slug":"permanent-family-physician-well-health-point-grey-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-well-health-point-grey-clinic/","title":{"rendered":"Permanent Family Physician &#8211; WELL Health Medical Clinic (Point Grey)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9018,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.2075374","job_listing-clinic_lattitude":49.2636084,"job_listing-job_location":"49.2636084%-123.2075374","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9368"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9018"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9368"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9368"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9368"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9368"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9368"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9368"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9367,"date":"2023-02-23T23:43:36","date_gmt":"2023-02-23T23:43:36","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9367"},"modified":"2023-03-16T18:36:43","modified_gmt":"2023-03-16T18:36:43","slug":"flexible-locum-family-physician-well-health-point-grey-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/flexible-locum-family-physician-well-health-point-grey-clinic/","title":{"rendered":"Locum Family Physician &#8211; WELL Health Medical Clinic (Point Grey)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9018,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.2075374","job_listing-clinic_lattitude":49.2636084,"job_listing-job_location":"49.2636084%-123.2075374","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9367"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9018"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9367"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9367"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9367"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9367"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9367"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9367"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9366,"date":"2023-02-23T23:41:25","date_gmt":"2023-02-23T23:41:25","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9366"},"modified":"2023-03-16T18:37:00","modified_gmt":"2023-03-16T18:37:00","slug":"flexible-locum-family-physician-well-health-kerrisdale-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/flexible-locum-family-physician-well-health-kerrisdale-clinic/","title":{"rendered":"Locum Family Physician &#8211; WELL Health Medical Clinic (Kerrisdale)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9016,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1534977","job_listing-clinic_lattitude":49.2337865,"job_listing-job_location":"49.2337865%-123.1534977","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9366"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9016"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9366"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9366"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9366"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9366"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9366"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9366"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9365,"date":"2023-02-23T23:35:59","date_gmt":"2023-02-23T23:35:59","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9365"},"modified":"2023-04-25T22:28:42","modified_gmt":"2023-04-25T22:28:42","slug":"permanent-family-physician-well-health-kerrisdale-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-well-health-kerrisdale-clinic/","title":{"rendered":"Permanent Family Physician &#8211; WELL Health Medical Clinic (Kerrisdale)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9016,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1534977","job_listing-clinic_lattitude":49.2337865,"job_listing-job_location":"49.2337865%-123.1534977","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9365"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9016"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9365"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9365"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9365"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9365"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9365"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9365"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9363,"date":"2023-02-23T23:27:39","date_gmt":"2023-02-23T23:27:39","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9363"},"modified":"2023-03-16T18:37:29","modified_gmt":"2023-03-16T18:37:29","slug":"flexible-locum-family-physician-well-health-hastings-sunrise-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/flexible-locum-family-physician-well-health-hastings-sunrise-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; WELL Health Medical Clinic (Hastings Sunrise)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9015,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.058289","job_listing-clinic_lattitude":49.2809177,"job_listing-job_location":"49.2809177%-123.058289","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9363"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9015"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9363"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9363"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9363"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9363"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9363"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9363"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9362,"date":"2023-02-23T23:25:59","date_gmt":"2023-02-23T23:25:59","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9362"},"modified":"2023-03-16T18:37:37","modified_gmt":"2023-03-16T18:37:37","slug":"permanent-family-physician-well-health-hastings-sunrise-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-well-health-hastings-sunrise-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; WELL Health Medical Clinic (Hastings Sunrise)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9015,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.058289","job_listing-clinic_lattitude":49.2809177,"job_listing-job_location":"49.2809177%-123.058289","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9362"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9015"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9362"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9362"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9362"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9362"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9362"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9362"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9359,"date":"2023-02-23T23:19:17","date_gmt":"2023-02-23T23:19:17","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9359"},"modified":"2023-04-25T22:29:09","modified_gmt":"2023-04-25T22:29:09","slug":"permanent-family-physician-seymour-health-centre-hornby-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-seymour-health-centre-hornby-st/","title":{"rendered":"Permanent Family Physician &#8211; Seymour Health Centre (Hornby)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8962,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Negotiable, 70/30 billing split OR salary model available for any physicians interested","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1293994","job_listing-clinic_lattitude":49.2774715,"job_listing-job_location":"49.2774715%-123.1293994","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9359"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8962"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9359"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9359"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9359"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9359"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9359"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9359"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9357,"date":"2023-02-23T23:14:19","date_gmt":"2023-02-23T23:14:19","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9357"},"modified":"2023-06-05T21:04:51","modified_gmt":"2023-06-05T21:04:51","slug":"locum-family-physician-seymour-health-centre-granville-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-seymour-health-centre-granville-st/","title":{"rendered":"Locum Family Physician &#8211; Seymour Health Centre (Granville)"},"excerpt":{"rendered":"<p>Multiple Opportunities Available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8963,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Walk-In Locum/Flexible Locum","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1395812","job_listing-clinic_lattitude":49.2652565,"job_listing-job_location":"49.2652565%-123.1395812","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9357"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8963"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9357"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9357"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9357"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9357"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9357"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9357"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9354,"date":"2023-02-23T23:13:09","date_gmt":"2023-02-23T23:13:09","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9354"},"modified":"2023-04-25T22:29:26","modified_gmt":"2023-04-25T22:29:26","slug":"permanent-family-physician-seymour-health-centre-granville-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-seymour-health-centre-granville-st/","title":{"rendered":"Permanent Family Physician &#8211; Seymour Health Centre (Granville)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8963,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1395812","job_listing-clinic_lattitude":49.2652565,"job_listing-job_location":"49.2652565%-123.1395812","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9354"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8963"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9354"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9354"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9354"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9354"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9354"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9354"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9353,"date":"2023-02-23T22:54:05","date_gmt":"2023-02-23T22:54:05","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9353"},"modified":"2023-03-03T22:29:19","modified_gmt":"2023-03-03T22:29:19","slug":"permanent-family-physician-marpole-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-marpole-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Marpole Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8927,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, $100 hourly minimum","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9353"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8927"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9353"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9353"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9353"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9353"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9353"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9353"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9351,"date":"2023-02-23T22:50:07","date_gmt":"2023-02-23T22:50:07","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9351"},"modified":"2023-04-25T22:29:35","modified_gmt":"2023-04-25T22:29:35","slug":"permanent-family-physician-mariners-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-mariners-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Mariners Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8926,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"65/35","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1283259","job_listing-clinic_lattitude":49.2793171,"job_listing-job_location":"49.2793171%-123.1283259","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9351"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8926"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9351"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9351"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9351"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9351"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9351"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9351"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9350,"date":"2023-02-23T22:36:37","date_gmt":"2023-02-23T22:36:37","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9350"},"modified":"2023-04-25T22:29:44","modified_gmt":"2023-04-25T22:29:44","slug":"locum-family-physician-khatsahlano-medical-clinic-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-khatsahlano-medical-clinic-2/","title":{"rendered":"Locum Family Physician &#8211; Khatsahlano Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8884,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25 direct care and private patients, 85/15 indirect care, 100% of billings for admin and annual patient panel payment","job_listing-description":"","job_listing-job_specifics":"Monday-Sunday shifts available","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1658517","job_listing-clinic_lattitude":49.264274,"job_listing-job_location":"49.264274%-123.1658517","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9350"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8884"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9350"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9350"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9350"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9350"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9350"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9350"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9325,"date":"2023-02-23T22:34:23","date_gmt":"2023-02-23T22:34:23","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9325"},"modified":"2023-03-21T16:30:31","modified_gmt":"2023-03-21T16:30:31","slug":"locum-family-physician-khatsahlano-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-khatsahlano-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Khatsahlano Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8884,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25 direct care and private patients, 85/15 indirect care, 100% of billings for admin and annual patient panel payment","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1658517","job_listing-clinic_lattitude":49.264274,"job_listing-job_location":"49.264274%-123.1658517","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9325"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8884"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9325"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9325"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9325"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9325"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9325"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9325"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9340,"date":"2023-02-23T21:50:00","date_gmt":"2023-02-23T21:50:00","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9340"},"modified":"2023-07-25T17:34:07","modified_gmt":"2023-07-25T17:34:07","slug":"locum-family-physician-bayswater-family-practice","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-bayswater-family-practice/","title":{"rendered":"Locum Family Physician &#8211; Bayswater Family Practice"},"excerpt":{"rendered":"<p>Multiple Dates Available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8745,"set_specific_time":false,"job_listing-start_date":"20230601","job_listing-end_date":"20230930","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Saturday Mornings (2-4 per month)","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1715196","job_listing-clinic_lattitude":49.2644675,"job_listing-job_location":"49.2644675%-123.1715196","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9340"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8745"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9340"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9340"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9340"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9340"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9340"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9340"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9339,"date":"2023-02-23T21:46:55","date_gmt":"2023-02-23T21:46:55","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9339"},"modified":"2023-05-02T23:01:23","modified_gmt":"2023-05-02T23:01:23","slug":"permanent-family-physician-bayswater-family-practice","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-bayswater-family-practice/","title":{"rendered":"Permanent Family Physician &#8211; Bayswater Family Practice"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8745,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1715196","job_listing-clinic_lattitude":49.2644675,"job_listing-job_location":"49.2644675%-123.1715196","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9339"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8745"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9339"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9339"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9339"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9339"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9339"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9339"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9336,"date":"2023-02-23T21:33:24","date_gmt":"2023-02-23T21:33:24","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9336"},"modified":"2023-03-03T22:29:19","modified_gmt":"2023-03-03T22:29:19","slug":"locum-family-physician-medical-office-on-dunbar-and-w-17th","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-medical-office-on-dunbar-and-w-17th/","title":{"rendered":"Locum Family Physician &#8211; Medical Office on Dunbar and W 17th"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9337,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9336"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9337"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9336"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9336"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9336"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9336"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9336"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9336"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9335,"date":"2023-02-23T21:29:37","date_gmt":"2023-02-23T21:29:37","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9335"},"modified":"2023-03-03T22:29:19","modified_gmt":"2023-03-03T22:29:19","slug":"permanent-family-physician-salish-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-salish-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Salish Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8961,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9335"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8961"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9335"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9335"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9335"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9335"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9335"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9335"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9334,"date":"2023-02-23T21:24:49","date_gmt":"2023-02-23T21:24:49","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9334"},"modified":"2023-08-21T19:36:38","modified_gmt":"2023-08-21T19:36:38","slug":"locum-family-physician-vancouver-family-practice-centre-2","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-vancouver-family-practice-centre-2/","title":{"rendered":"Locum Family Physician &#8211; Vancouver Family Practice Centre"},"excerpt":{"rendered":"<p>Multiple Dates Available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9005,"set_specific_time":true,"job_listing-start_date":"20230901","job_listing-end_date":"20240115","non_specific_date_message":"Negotiable","job_listing-remuneration":"Population Based Funding Model","job_listing-description":"September 1, 2023-January 15, 2024 (2 days per week)\r\n\r\nLong-term Locum to cover overflow for multiple physicians in the practice. This opportunity can be full time or part time, and hours are flexible between 8:30am and 6pm Monday through Thursday, 8:30am-5pm Fridays, and 10am-2pm Saturdays.  These are typical family practices with a range of ages and illness, with no special focus. Patients are scheduled every 15 minutes or longer when needed.\r\n\r\nDecember/Christmas locum to cover overflow for multiple physicians in the practice. This opportunity can be full time or part time, with a combination of in person and virtual visits.","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1165465","job_listing-clinic_lattitude":49.2609085,"job_listing-job_location":"49.2609085%-123.1165465","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9334"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9005"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9334"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9334"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9334"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9334"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9334"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9334"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9330,"date":"2023-02-23T21:12:18","date_gmt":"2023-02-23T21:12:18","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9330"},"modified":"2023-06-05T20:21:38","modified_gmt":"2023-06-05T20:21:38","slug":"locum-family-physician-vancouver-aboriginal-health-society","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-vancouver-aboriginal-health-society/","title":{"rendered":"Locum Family Physician &#8211; Vancouver Aboriginal Health Society"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9004,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Sessional","job_listing-description":"","job_listing-job_specifics":"Ongoing needs for day, Wednesday evening, and Saturday shifts. Full or half days available.\r\n\r\nThe clinic is looking for physicians who can provide trauma-informed, culturally competent care to their specific patient population. Interested candidates must have a methadone license and be competent in prescribing opioid agonist therapy.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0942149","job_listing-clinic_lattitude":49.2814816,"job_listing-job_location":"49.2814816%-123.0942149","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9330"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9004"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9330"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9330"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9330"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9330"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9330"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9330"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9329,"date":"2023-02-23T21:09:29","date_gmt":"2023-02-23T21:09:29","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9329"},"modified":"2023-04-25T22:32:06","modified_gmt":"2023-04-25T22:32:06","slug":"locum-family-physician-una-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-una-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; UNA Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9002,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, $100 hourly minimum","job_listing-description":"","job_listing-job_specifics":"Long term opportunity","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1274989","job_listing-clinic_lattitude":49.257934,"job_listing-job_location":"49.257934%-123.1274989","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9329"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9002"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9329"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9329"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9329"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9329"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9329"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9329"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9328,"date":"2023-02-23T21:07:52","date_gmt":"2023-02-23T21:07:52","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9328"},"modified":"2023-04-25T22:32:15","modified_gmt":"2023-04-25T22:32:15","slug":"permanent-family-physician-una-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-una-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; UNA Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9002,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, $100 hourly minimum","job_listing-description":"","job_listing-job_specifics":"Open to provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1274989","job_listing-clinic_lattitude":49.257934,"job_listing-job_location":"49.257934%-123.1274989","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9328"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9002"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9328"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9328"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9328"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9328"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9328"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9328"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9327,"date":"2023-02-23T21:05:57","date_gmt":"2023-02-23T21:05:57","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9327"},"modified":"2023-03-03T22:29:19","modified_gmt":"2023-03-03T22:29:19","slug":"permanent-family-physician-total-care-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-total-care-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Total Care Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8911,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Negotiable","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9327"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8911"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9327"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9327"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9327"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9327"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9327"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9327"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9326,"date":"2023-02-23T21:04:07","date_gmt":"2023-02-23T21:04:07","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9326"},"modified":"2023-03-03T22:29:19","modified_gmt":"2023-03-03T22:29:19","slug":"locum-family-physician-tlc-medical-clinic-knight-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-tlc-medical-clinic-knight-st/","title":{"rendered":"Locum Family Physician &#8211; TLC Medical Clinic (Knight St.)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8994,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9326"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8994"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9326"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9326"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9326"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9326"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9326"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9326"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9324,"date":"2023-02-23T21:03:02","date_gmt":"2023-02-23T21:03:02","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9324"},"modified":"2023-04-25T22:32:31","modified_gmt":"2023-04-25T22:32:31","slug":"permanent-family-physician-tlc-medical-clinic-knight-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-tlc-medical-clinic-knight-st/","title":{"rendered":"Permanent Family Physician &#8211; TLC Medical Clinic (Knight St.)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8994,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"Open to provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.076322","job_listing-clinic_lattitude":49.2325315,"job_listing-job_location":"49.2325315%-123.076322","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9324"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8994"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9324"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9324"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9324"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9324"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9324"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9324"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9322,"date":"2023-02-23T21:02:17","date_gmt":"2023-02-23T21:02:17","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9322"},"modified":"2023-04-25T22:32:41","modified_gmt":"2023-04-25T22:32:41","slug":"permanent-family-physician-khatsahlano-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-khatsahlano-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Khatsahlano Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8884,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25 direct care and private patients, 85/15 indirect care, 100% of billings for admin and annual patient panel payment","job_listing-description":"","job_listing-job_specifics":"Shifts are available Monday to Sunday, 9:00am to 5:00pm.\r\nThis opportunity is open to fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1658517","job_listing-clinic_lattitude":49.264274,"job_listing-job_location":"49.264274%-123.1658517","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9322"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8884"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9322"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9322"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9322"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9322"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9322"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9322"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9323,"date":"2023-02-23T21:01:31","date_gmt":"2023-02-23T21:01:31","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9323"},"modified":"2023-05-12T12:46:59","modified_gmt":"2023-05-12T12:46:59","slug":"permanent-family-physician-tlc-medical-clinic-granville","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-tlc-medical-clinic-granville/","title":{"rendered":"Permanent Family Physician &#8211; TLC Medical Clinic (Granville)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8993,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 90/10 on private and out of office work","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1409633","job_listing-clinic_lattitude":49.2195936,"job_listing-job_location":"49.2195936%-123.1409633","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9323"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8993"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9323"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9323"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9323"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9323"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9323"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9323"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9321,"date":"2023-02-23T20:59:27","date_gmt":"2023-02-23T20:59:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9321"},"modified":"2023-03-03T22:30:02","modified_gmt":"2023-03-03T22:30:02","slug":"locum-family-physician-tlc-medical-clinic-granville","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-tlc-medical-clinic-granville/","title":{"rendered":"Locum Family Physician &#8211; TLC Medical Clinic (Granville)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8993,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 90/10 on private and out of office work","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9321"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8993"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9321"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9321"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9321"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9321"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9321"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9321"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9319,"date":"2023-02-23T20:42:03","date_gmt":"2023-02-23T20:42:03","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9319"},"modified":"2023-03-03T22:30:02","modified_gmt":"2023-03-03T22:30:02","slug":"locum-family-physician-south-hill-family-health-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-south-hill-family-health-centre/","title":{"rendered":"Locum Family Physician &#8211; South Hill Family Health Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8975,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":"20231231","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9319"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8975"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9319"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9319"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9319"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9319"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9319"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9319"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9318,"date":"2023-02-23T20:39:23","date_gmt":"2023-02-23T20:39:23","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9318"},"modified":"2023-05-04T21:48:35","modified_gmt":"2023-05-04T21:48:35","slug":"locum-family-physician-sky-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-sky-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Sky Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8974,"set_specific_time":true,"job_listing-start_date":"20230301","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1283259","job_listing-clinic_lattitude":49.2793171,"job_listing-job_location":"49.2793171%-123.1283259","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9318"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8974"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9318"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9318"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9318"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9318"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9318"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9318"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9298,"date":"2023-02-23T20:36:34","date_gmt":"2023-02-23T20:36:34","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9298"},"modified":"2023-03-27T21:26:26","modified_gmt":"2023-03-27T21:26:26","slug":"locum-family-physician-keefer-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-keefer-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Keefer Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8878,"set_specific_time":true,"job_listing-start_date":"20230327","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"80/20, $1000 daily minimum (8 hour shift)","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1013456","job_listing-clinic_lattitude":49.2793542,"job_listing-job_location":"49.2793542%-123.1013456","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9298"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8878"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9298"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9298"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9298"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9298"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9298"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9298"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9316,"date":"2023-02-23T20:36:21","date_gmt":"2023-02-23T20:36:21","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9316"},"modified":"2023-05-04T21:48:52","modified_gmt":"2023-05-04T21:48:52","slug":"permanent-family-physician-sky-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-sky-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Sky Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8974,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1283259","job_listing-clinic_lattitude":49.2793171,"job_listing-job_location":"49.2793171%-123.1283259","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9316"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8974"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9316"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9316"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9316"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9316"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9316"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9316"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9315,"date":"2023-02-23T20:34:27","date_gmt":"2023-02-23T20:34:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9315"},"modified":"2023-07-25T18:38:34","modified_gmt":"2023-07-25T18:38:34","slug":"locum-family-physician-simply-wellness-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-simply-wellness-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Simply Wellness Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8964,"set_specific_time":false,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0674904","job_listing-clinic_lattitude":49.2460432,"job_listing-job_location":"49.2460432%-123.0674904","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9315"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8964"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9315"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9315"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9315"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9315"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9315"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9315"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9314,"date":"2023-02-23T20:32:30","date_gmt":"2023-02-23T20:32:30","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9314"},"modified":"2023-04-25T22:33:45","modified_gmt":"2023-04-25T22:33:45","slug":"permanent-family-physician-simply-wellness-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-simply-wellness-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Simply Wellness Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8964,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0674904","job_listing-clinic_lattitude":49.2460432,"job_listing-job_location":"49.2460432%-123.0674904","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9314"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8964"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9314"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9314"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9314"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9314"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9314"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9314"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9312,"date":"2023-02-23T20:28:55","date_gmt":"2023-02-23T20:28:55","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9312"},"modified":"2023-03-03T22:30:03","modified_gmt":"2023-03-03T22:30:03","slug":"locum-family-physician-point-grey-gp-and-naturopathic-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-point-grey-gp-and-naturopathic-clinic/","title":{"rendered":"Locum Family Physician &#8211; Point Grey GP and Naturopathic Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9311,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9312"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9311"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9312"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9312"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9312"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9312"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9312"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9312"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9310,"date":"2023-02-23T20:27:42","date_gmt":"2023-02-23T20:27:42","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9310"},"modified":"2023-03-03T22:30:03","modified_gmt":"2023-03-03T22:30:03","slug":"permanent-family-physician-point-grey-gp-and-naturopathic-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-point-grey-gp-and-naturopathic-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Point Grey GP and Naturopathic Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9311,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9310"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9311"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9310"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9310"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9310"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9310"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9310"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9310"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9308,"date":"2023-02-23T20:21:16","date_gmt":"2023-02-23T20:21:16","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9308"},"modified":"2023-09-11T21:25:48","modified_gmt":"2023-09-11T21:25:48","slug":"permanent-family-physician-pacific-medical-clinic-kingsway","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-pacific-medical-clinic-kingsway/","title":{"rendered":"Permanent Family Physician &#8211; Pacific Medical Clinic (Kingsway)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8945,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0647964","job_listing-clinic_lattitude":49.2446808,"job_listing-job_location":"49.2446808%-123.0647964","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9308"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8945"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9308"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9308"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9308"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9308"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9308"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9308"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9307,"date":"2023-02-23T20:19:03","date_gmt":"2023-02-23T20:19:03","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9307"},"modified":"2023-09-11T18:37:19","modified_gmt":"2023-09-11T18:37:19","slug":"locum-family-physician-pacific-medical-clinic-grandview","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-pacific-medical-clinic-grandview/","title":{"rendered":"Locum Family Physician &#8211; Pacific Medical Clinic (Grandview)"},"excerpt":{"rendered":"<p>Multiple dates available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8944,"set_specific_time":true,"job_listing-start_date":"20231113","job_listing-end_date":"20240105","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 100% for forms and OB on-call services","job_listing-description":"","job_listing-job_specifics":"Dates Available:\r\nNovember 13th-17th, 2023\r\nDecember 18th, 2023-January 5th, 2024","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0367346","job_listing-clinic_lattitude":49.2589696,"job_listing-job_location":"49.2589696%-123.0367346","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9307"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8944"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9307"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9307"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9307"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9307"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9307"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9307"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9306,"date":"2023-02-23T20:16:32","date_gmt":"2023-02-23T20:16:32","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9306"},"modified":"2023-03-03T22:30:03","modified_gmt":"2023-03-03T22:30:03","slug":"permanent-family-physician-pacific-medical-clinic-grandview","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-pacific-medical-clinic-grandview/","title":{"rendered":"Permanent Family Physician &#8211; Pacific Medical Clinic (Grandview)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8944,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 100% for forms and OB on-call services","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9306"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8944"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9306"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9306"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9306"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9306"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9306"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9306"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9304,"date":"2023-02-23T20:14:21","date_gmt":"2023-02-23T20:14:21","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9304"},"modified":"2023-09-11T18:30:43","modified_gmt":"2023-09-11T18:30:43","slug":"permanent-family-physician-pacific-medical-clinic-fraser","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-pacific-medical-clinic-fraser/","title":{"rendered":"Permanent Family Physician &#8211; Pacific Medical Clinic (Fraser)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9305,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed physicians","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0902688","job_listing-clinic_lattitude":49.2285535,"job_listing-job_location":"49.2285535%-123.0902688","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9304"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9305"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9304"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9304"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9304"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9304"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9304"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9304"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9303,"date":"2023-02-23T20:10:57","date_gmt":"2023-02-23T20:10:57","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9303"},"modified":"2023-03-03T22:30:03","modified_gmt":"2023-03-03T22:30:03","slug":"permanent-family-physician-northeast-urgent-and-primary-care-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-northeast-urgent-and-primary-care-centre/","title":{"rendered":"Permanent Family Physician &#8211; Northeast Urgent and Primary Care Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[188],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8939,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Sessional","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9303"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8939"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9303"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9303"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9303"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9303"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9303"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9303"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9301,"date":"2023-02-23T19:38:42","date_gmt":"2023-02-23T19:38:42","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9301"},"modified":"2023-03-03T22:30:45","modified_gmt":"2023-03-03T22:30:45","slug":"locum-family-physician-laurel-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-laurel-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Laurel Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8889,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":"20230223","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9301"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8889"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9301"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9301"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9301"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9301"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9301"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9301"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9296,"date":"2023-02-23T19:27:41","date_gmt":"2023-02-23T19:27:41","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9296"},"modified":"2023-07-25T17:39:39","modified_gmt":"2023-07-25T17:39:39","slug":"locum-family-physician-eighth-avenue-family-maternity-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-eighth-avenue-family-maternity-clinic/","title":{"rendered":"Locum Family Physician &#8211; Eighth Avenue Family &#038; Maternity Clinic"},"excerpt":{"rendered":"<p>Multiple dates available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8742,"set_specific_time":true,"job_listing-start_date":"20230901","job_listing-end_date":"20240201","non_specific_date_message":"Negotiable","job_listing-remuneration":"65/35","job_listing-description":"","job_listing-job_specifics":"Starting September 1, 2023: 3 half days per week, maternity care and call group optional, 70/30 billing split\r\nMaternity Locum: February 1, 2023-February 1, 2024. 4 half days per week, 65/35 split","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1234119","job_listing-clinic_lattitude":49.2640253,"job_listing-job_location":"49.2640253%-123.1234119","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9296"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8742"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9296"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9296"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9296"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9296"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9296"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9296"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9292,"date":"2023-02-23T19:27:18","date_gmt":"2023-02-23T19:27:18","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9292"},"modified":"2023-04-25T22:35:30","modified_gmt":"2023-04-25T22:35:30","slug":"permanent-family-physician-keefer-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-keefer-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Keefer Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8878,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, $1000 daily minimum (8 hour shift)","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1013456","job_listing-clinic_lattitude":49.2793542,"job_listing-job_location":"49.2793542%-123.1013456","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9292"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8878"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9292"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9292"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9292"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9292"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9292"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9292"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9295,"date":"2023-02-23T19:24:34","date_gmt":"2023-02-23T19:24:34","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9295"},"modified":"2023-04-03T18:29:33","modified_gmt":"2023-04-03T18:29:33","slug":"permanent-family-physician-eighth-avenue-family-maternity-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-eighth-avenue-family-maternity-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Eighth Avenue Family &#038; Maternity Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8742,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"75/25","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1234119","job_listing-clinic_lattitude":49.2640253,"job_listing-job_location":"49.2640253%-123.1234119","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9295"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8742"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9295"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9295"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9295"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9295"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9295"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9295"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9291,"date":"2023-02-23T19:12:59","date_gmt":"2023-02-23T19:12:59","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9291"},"modified":"2023-04-25T22:35:41","modified_gmt":"2023-04-25T22:35:41","slug":"permanent-family-physician-choice-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-choice-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Choice Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8774,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.115106","job_listing-clinic_lattitude":49.2863236,"job_listing-job_location":"49.2863236%-123.115106","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9291"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8774"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9291"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9291"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9291"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9291"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9291"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9291"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9289,"date":"2023-02-23T19:05:09","date_gmt":"2023-02-23T19:05:09","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9289"},"modified":"2023-04-25T22:35:51","modified_gmt":"2023-04-25T22:35:51","slug":"locum-family-physician-choice-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-choice-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Choice Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8774,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"1–3-month locum with the opportunity to extend","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.115106","job_listing-clinic_lattitude":49.2863236,"job_listing-job_location":"49.2863236%-123.115106","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9289"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8774"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9289"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9289"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9289"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9289"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9289"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9289"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9286,"date":"2023-02-23T18:54:47","date_gmt":"2023-02-23T18:54:47","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9286"},"modified":"2023-04-25T22:36:02","modified_gmt":"2023-04-25T22:36:02","slug":"permanent-family-physician-kariba-health","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-kariba-health/","title":{"rendered":"Permanent Family Physician &#8211; Kariba Health"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[144],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8871,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"4-5 days per week, open to provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1533438","job_listing-clinic_lattitude":49.2622939,"job_listing-job_location":"49.2622939%-123.1533438","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9286"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8871"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9286"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9286"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9286"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9286"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9286"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9286"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9284,"date":"2023-02-23T18:49:56","date_gmt":"2023-02-23T18:49:56","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9284"},"modified":"2023-06-30T20:39:58","modified_gmt":"2023-06-30T20:39:58","slug":"locum-family-physician-highroads-medical-clinic-kerrisdale","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-highroads-medical-clinic-kerrisdale/","title":{"rendered":"Locum Family Physician &#8211; Highroads Medical Clinic (Kerrisdale)"},"excerpt":{"rendered":"<p>Multiple Opportunities Available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8859,"set_specific_time":true,"job_listing-start_date":"20230701","job_listing-end_date":"20230930","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Urgent Medical Leave","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1547082","job_listing-clinic_lattitude":49.2322668,"job_listing-job_location":"49.2322668%-123.1547082","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9284"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8859"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9284"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9284"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9284"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9284"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9284"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9284"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9283,"date":"2023-02-23T18:49:55","date_gmt":"2023-02-23T18:49:55","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9283"},"modified":"2023-06-09T17:03:08","modified_gmt":"2023-06-09T17:03:08","slug":"locum-family-physician-downtown-community-health-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-downtown-community-health-centre/","title":{"rendered":"Locum Family Physician &#8211; Downtown Community Health Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[189],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8832,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Alternate Payment Model","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9283"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8832"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9283"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9283"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9283"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9283"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9283"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9283"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9281,"date":"2023-02-23T18:47:04","date_gmt":"2023-02-23T18:47:04","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9281"},"modified":"2023-03-03T22:30:45","modified_gmt":"2023-03-03T22:30:45","slug":"permanent-family-physician-doc-side-medical","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-doc-side-medical/","title":{"rendered":"Permanent Family Physician &#8211; Doc-Side Medical"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Family Practice","job_listing-job_type":["Permanent"],"job_listing-clinic":8822,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9281"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8822"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9281"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9281"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9281"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9281"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9281"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9281"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9280,"date":"2023-02-23T18:45:09","date_gmt":"2023-02-23T18:45:09","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9280"},"modified":"2023-03-03T22:30:45","modified_gmt":"2023-03-03T22:30:45","slug":"permanent-family-physician-denman-medical-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-denman-medical-centre/","title":{"rendered":"Permanent Family Physician &#8211; Denman Medical Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[],"acf":{"job_listing-practice_type":"Family Practice","job_listing-job_type":["Permanent"],"job_listing-clinic":8820,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9280"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8820"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9280"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9280"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9280"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9280"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9280"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9280"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9272,"date":"2023-02-23T18:43:43","date_gmt":"2023-02-23T18:43:43","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9272"},"modified":"2023-03-03T22:30:45","modified_gmt":"2023-03-03T22:30:45","slug":"locum-family-physician-denman-medical-centre","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-denman-medical-centre/","title":{"rendered":"Locum Family Physician &#8211; Denman Medical Centre"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Practice","job_listing-job_type":["Locum"],"job_listing-clinic":8820,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9272"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8820"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9272"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9272"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9272"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9272"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9272"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9272"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9270,"date":"2023-02-23T18:40:20","date_gmt":"2023-02-23T18:40:20","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9270"},"modified":"2023-03-27T21:22:31","modified_gmt":"2023-03-27T21:22:31","slug":"locum-family-physician-cross-roads-walk-in-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-cross-roads-walk-in-clinic/","title":{"rendered":"Locum Family Physician &#8211; Cross Roads Walk in Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8809,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"65/25","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1153912","job_listing-clinic_lattitude":49.2634635,"job_listing-job_location":"49.2634635%-123.1153912","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9270"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8809"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9270"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9270"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9270"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9270"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9270"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9270"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9269,"date":"2023-02-23T18:38:31","date_gmt":"2023-02-23T18:38:31","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9269"},"modified":"2023-03-03T22:30:45","modified_gmt":"2023-03-03T22:30:45","slug":"permanent-family-physician-cross-roads-walk-in-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-cross-roads-walk-in-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Cross Roads Walk in Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[139],"joblisting_community":[147],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Family Practice","job_listing-job_type":["Permanent"],"job_listing-clinic":8809,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"65/25","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9269"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8809"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9269"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9269"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9269"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9269"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9269"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9269"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9267,"date":"2023-02-23T18:36:02","date_gmt":"2023-02-23T18:36:02","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9267"},"modified":"2023-03-03T22:31:15","modified_gmt":"2023-03-03T22:31:15","slug":"permanent-family-physician-coal-harbour-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-coal-harbour-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Coal Harbour Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Family Practice","job_listing-job_type":["Permanent"],"job_listing-clinic":8798,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9267"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8798"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9267"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9267"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9267"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9267"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9267"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9267"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9263,"date":"2023-02-23T18:25:56","date_gmt":"2023-02-23T18:25:56","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9263"},"modified":"2023-03-27T21:22:56","modified_gmt":"2023-03-27T21:22:56","slug":"permanent-family-physician-city-med","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-city-med/","title":{"rendered":"Permanent Family Physician &#8211; CityMed"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8783,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"80/20","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1005344","job_listing-clinic_lattitude":49.26613,"job_listing-job_location":"49.26613%-123.1005344","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9263"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8783"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9263"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9263"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9263"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9263"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9263"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9263"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9264,"date":"2023-02-23T18:09:02","date_gmt":"2023-02-23T18:09:02","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9264"},"modified":"2023-04-25T22:37:46","modified_gmt":"2023-04-25T22:37:46","slug":"permanent-family-physician-caritas-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-caritas-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Caritas Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8762,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, $750 daily minimum","job_listing-description":"","job_listing-job_specifics":"Full-time and part-time opportunities available","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0657014","job_listing-clinic_lattitude":49.2340685,"job_listing-job_location":"49.2340685%-123.0657014","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9264"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8762"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9264"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9264"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9264"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9264"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9264"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9264"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9261,"date":"2023-02-23T18:05:04","date_gmt":"2023-02-23T18:05:04","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9261"},"modified":"2023-04-25T22:37:54","modified_gmt":"2023-04-25T22:37:54","slug":"flexible-locum-caritas-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/flexible-locum-caritas-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Caritas Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8762,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, $750 daily minimum","job_listing-description":"","job_listing-job_specifics":"Full-time and part-time opportunities available","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0657014","job_listing-clinic_lattitude":49.2340685,"job_listing-job_location":"49.2340685%-123.0657014","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9261"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8762"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9261"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9261"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9261"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9261"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9261"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9261"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9257,"date":"2023-02-22T20:47:48","date_gmt":"2023-02-22T20:47:48","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9257"},"modified":"2023-04-25T22:38:10","modified_gmt":"2023-04-25T22:38:10","slug":"permanent-family-physician-genetica-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-genetica-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Genetica Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8839,"set_specific_time":true,"job_listing-start_date":"20230222","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"72/28, Negotiable","job_listing-description":"","job_listing-job_specifics":"Permanent family physician needed - Full and part time opportunities available with the ability to cover the walk-in and/or establish a regular patient panel. The clinic is able to accommodate specialist and special interest/subspecialty practices and is open to provisionally licensed candidates.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1280715","job_listing-clinic_lattitude":49.2793325,"job_listing-job_location":"49.2793325%-123.1280715","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9257"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8839"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9257"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9257"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9257"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9257"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9257"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9257"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9256,"date":"2023-02-22T20:43:08","date_gmt":"2023-02-22T20:43:08","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9256"},"modified":"2023-04-25T22:38:15","modified_gmt":"2023-04-25T22:38:15","slug":"locum-family-physician-genetica-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-genetica-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Genetica Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8839,"set_specific_time":true,"job_listing-start_date":"20230222","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"72/28, Negotiable","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1280715","job_listing-clinic_lattitude":49.2793325,"job_listing-job_location":"49.2793325%-123.1280715","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9256"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8839"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9256"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9256"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9256"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9256"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9256"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9256"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9255,"date":"2023-02-22T20:41:08","date_gmt":"2023-02-22T20:41:08","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9255"},"modified":"2023-04-25T22:38:21","modified_gmt":"2023-04-25T22:38:21","slug":"permanent-family-physician-forward-care-medical-clinic-east-vancouver","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-forward-care-medical-clinic-east-vancouver/","title":{"rendered":"Permanent Family Physician &#8211; Forward Care Medical Clinic (East Vancouver)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8836,"set_specific_time":true,"job_listing-start_date":"20230222","job_listing-end_date":"20230222","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 100% for medical/legal reports","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0504595","job_listing-clinic_lattitude":49.2326142,"job_listing-job_location":"49.2326142%-123.0504595","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9255"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8836"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9255"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9255"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9255"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9255"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9255"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9255"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9254,"date":"2023-02-22T20:39:06","date_gmt":"2023-02-22T20:39:06","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9254"},"modified":"2023-04-25T22:38:35","modified_gmt":"2023-04-25T22:38:35","slug":"locum-family-physician-forward-care-medical-clinic-east-vancouver","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-forward-care-medical-clinic-east-vancouver/","title":{"rendered":"Locum Family Physician &#8211; Forward Care Medical Clinic (East Vancouver)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[142],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8836,"set_specific_time":true,"job_listing-start_date":"20230222","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 100% for medical/legal reports","job_listing-description":"","job_listing-job_specifics":"Saturdays, long term and short-term opportunities available","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0504595","job_listing-clinic_lattitude":49.2326142,"job_listing-job_location":"49.2326142%-123.0504595","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9254"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8836"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9254"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9254"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9254"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9254"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9254"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9254"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9253,"date":"2023-02-22T20:20:52","date_gmt":"2023-02-22T20:20:52","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9253"},"modified":"2023-04-25T22:38:46","modified_gmt":"2023-04-25T22:38:46","slug":"permanent-family-physician-ting-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-ting-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Ting Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8992,"set_specific_time":true,"job_listing-start_date":"20230222","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Wednesdays full day plus 2-3 hours per week on Monday, Tuesday, Thursday or Friday afternoons","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1250251","job_listing-clinic_lattitude":49.2637081,"job_listing-job_location":"49.2637081%-123.1250251","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9253"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8992"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9253"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9253"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9253"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9253"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9253"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9253"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9248,"date":"2023-02-22T20:02:44","date_gmt":"2023-02-22T20:02:44","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9248"},"modified":"2023-05-02T23:26:18","modified_gmt":"2023-05-02T23:26:18","slug":"permanent-family-physician-alberni-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-alberni-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Alberni Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9244,"set_specific_time":true,"job_listing-start_date":"20230222","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1281668","job_listing-clinic_lattitude":49.2879721,"job_listing-job_location":"49.2879721%-123.1281668","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9248"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9244"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9248"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9248"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9248"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9248"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9248"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9248"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9246,"date":"2023-02-22T20:00:41","date_gmt":"2023-02-22T20:00:41","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9246"},"modified":"2023-04-25T22:39:05","modified_gmt":"2023-04-25T22:39:05","slug":"locum-family-physician-alberni-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-alberni-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Alberni Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9244,"set_specific_time":true,"job_listing-start_date":"20230222","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1281668","job_listing-clinic_lattitude":49.2879721,"job_listing-job_location":"49.2879721%-123.1281668","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9246"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9244"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9246"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9246"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9246"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9246"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9246"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9246"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9247,"date":"2023-02-22T20:00:07","date_gmt":"2023-02-22T20:00:07","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9247"},"modified":"2023-04-25T22:39:13","modified_gmt":"2023-04-25T22:39:13","slug":"permanent-family-physician-care-point-medical-clinic-joyce-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-care-point-medical-clinic-joyce-st/","title":{"rendered":"Permanent Family Physician &#8211; Care Point Medical Clinic (Joyce)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8758,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 75/25 weekend shifts","job_listing-description":"","job_listing-job_specifics":"Open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0319535","job_listing-clinic_lattitude":49.2378195,"job_listing-job_location":"49.2378195%-123.0319535","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9247"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8758"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9247"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9247"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9247"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9247"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9247"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9247"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9245,"date":"2023-02-22T19:57:49","date_gmt":"2023-02-22T19:57:49","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9245"},"modified":"2023-03-03T22:28:12","modified_gmt":"2023-03-03T22:28:12","slug":"part-time-flexible-locum-care-point-medical-clinic-joyce-st","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/part-time-flexible-locum-care-point-medical-clinic-joyce-st/","title":{"rendered":"Locum Family Physician &#8211; Care Point Medical Clinic (Joyce)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8758,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 75/25 weekend shifts","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"","job_listing-clinic_lattitude":"","job_listing-job_location":"%","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9245"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8758"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9245"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9245"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9245"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9245"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9245"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9245"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9242,"date":"2023-02-22T19:52:51","date_gmt":"2023-02-22T19:52:51","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9242"},"modified":"2023-05-02T23:26:44","modified_gmt":"2023-05-02T23:26:44","slug":"locum-family-physician-acadia-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-family-physician-acadia-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Acadia Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":9240,"set_specific_time":true,"job_listing-start_date":"20230222","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.2371773","job_listing-clinic_lattitude":49.2653879,"job_listing-job_location":"49.2653879%-123.2371773","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9242"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9240"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9242"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9242"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9242"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9242"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9242"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9242"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9241,"date":"2023-02-22T19:49:36","date_gmt":"2023-02-22T19:49:36","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9241"},"modified":"2023-05-02T19:27:13","modified_gmt":"2023-05-02T19:27:13","slug":"full-time-permanent-family-physician-care-point-medical-clinic-commercial-dr","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/full-time-permanent-family-physician-care-point-medical-clinic-commercial-dr/","title":{"rendered":"Permanent Family Physician &#8211; Care Point Medical Clinic (Commercial)"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[146],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8754,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, 75/25 weekend shifts (APP contracts available)","job_listing-description":"","job_listing-job_specifics":"Monday-Friday 2pm-6pm/7pm, Saturdays 9am-4pm","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.069817","job_listing-clinic_lattitude":49.2701651,"job_listing-job_location":"49.2701651%-123.069817","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9241"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8754"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9241"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9241"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9241"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9241"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9241"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9241"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9232,"date":"2023-02-22T19:49:19","date_gmt":"2023-02-22T19:49:19","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9232"},"modified":"2023-04-25T22:39:34","modified_gmt":"2023-04-25T22:39:34","slug":"permanent-family-physician-acadia-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-acadia-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Acadia Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[144],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":9240,"set_specific_time":true,"job_listing-start_date":"20230222","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.2371773","job_listing-clinic_lattitude":49.2653879,"job_listing-job_location":"49.2653879%-123.2371773","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9232"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/9240"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9232"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9232"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9232"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9232"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9232"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9232"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9239,"date":"2023-02-22T19:39:47","date_gmt":"2023-02-22T19:39:47","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9239"},"modified":"2023-04-25T22:39:42","modified_gmt":"2023-04-25T22:39:42","slug":"long-term-locum-blue-water-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/long-term-locum-blue-water-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Blue Water Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8749,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, negotiable hourly minimum","job_listing-description":"","job_listing-job_specifics":"Long Term Locum","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0380326","job_listing-clinic_lattitude":49.2352974,"job_listing-job_location":"49.2352974%-123.0380326","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9239"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8749"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9239"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9239"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9239"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9239"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9239"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9239"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9235,"date":"2023-02-22T19:38:56","date_gmt":"2023-02-22T19:38:56","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9235"},"modified":"2023-04-25T22:39:53","modified_gmt":"2023-04-25T22:39:53","slug":"permanent-family-physician-blue-water-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-blue-water-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Blue Water Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[140],"joblisting_community":[145],"joblisting_ft_pt":[],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8749,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30, negotiable hourly minimum","job_listing-description":"","job_listing-job_specifics":"This opportunity is open to both fully and provisionally licensed candidates","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0380326","job_listing-clinic_lattitude":49.2352974,"job_listing-job_location":"49.2352974%-123.0380326","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9235"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8749"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9235"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9235"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9235"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9235"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9235"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9235"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9234,"date":"2023-02-22T19:32:17","date_gmt":"2023-02-22T19:32:17","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9234"},"modified":"2023-03-27T21:24:42","modified_gmt":"2023-03-27T21:24:42","slug":"flexible-locum-city-med-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/flexible-locum-city-med-clinic/","title":{"rendered":"Locum Family Physician &#8211; CityMed"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[143],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8783,"set_specific_time":true,"job_listing-start_date":"20230222","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"80/20","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1005344","job_listing-clinic_lattitude":49.26613,"job_listing-job_location":"49.26613%-123.1005344","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9234"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8783"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9234"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9234"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9234"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9234"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9234"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9234"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9231,"date":"2023-02-22T19:21:48","date_gmt":"2023-02-22T19:21:48","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9231"},"modified":"2023-07-25T17:36:13","modified_gmt":"2023-07-25T17:36:13","slug":"part-time-locum-broadway-plaza-family-practice","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/part-time-locum-broadway-plaza-family-practice/","title":{"rendered":"Locum Family Physician &#8211; Broadway Plaza Family Practice"},"excerpt":{"rendered":"<p>Multiple dates available</p>\n","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[141],"joblisting_community":[147],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8751,"set_specific_time":true,"job_listing-start_date":"20230908","job_listing-end_date":"20230922","non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"Long term locum - Fridays/September 8-22, 2023","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1181345","job_listing-clinic_lattitude":49.2636573,"job_listing-job_location":"49.2636573%-123.1181345","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9231"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8751"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9231"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9231"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9231"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9231"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9231"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9231"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9230,"date":"2023-02-22T19:14:59","date_gmt":"2023-02-22T19:14:59","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9230"},"modified":"2023-05-02T23:27:59","modified_gmt":"2023-05-02T23:27:59","slug":"flexible-locum-aquarius-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/flexible-locum-aquarius-medical-clinic/","title":{"rendered":"Locum Family Physician &#8211; Aquarius Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[207,206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Locum"],"job_listing-clinic":8743,"set_specific_time":true,"job_listing-start_date":"20230223","job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1205414","job_listing-clinic_lattitude":49.2738533,"job_listing-job_location":"49.2738533%-123.1205414","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9230"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8743"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9230"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9230"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9230"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9230"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9230"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9230"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9227,"date":"2023-02-22T18:50:24","date_gmt":"2023-02-22T18:50:24","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=9227"},"modified":"2023-05-02T23:27:53","modified_gmt":"2023-05-02T23:27:53","slug":"permanent-family-physician-aquarius-medical-clinic","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/permanent-family-physician-aquarius-medical-clinic/","title":{"rendered":"Permanent Family Physician &#8211; Aquarius Medical Clinic"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[],"joblisting_clinic_type":[140],"joblisting_community":[147],"joblisting_ft_pt":[],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":8743,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"70/30","job_listing-description":"","job_listing-job_specifics":"This opportunity is open to both fully and provisionally licensed candidates.","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1205414","job_listing-clinic_lattitude":49.2738533,"job_listing-job_location":"49.2738533%-123.1205414","email_recipient":"recruitment@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/9227"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8743"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9227"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=9227"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=9227"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=9227"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=9227"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=9227"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8377,"date":"2022-12-16T01:06:20","date_gmt":"2022-12-16T01:06:20","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=8377"},"modified":"2023-02-22T08:29:33","modified_gmt":"2023-02-22T08:29:33","slug":"locum-little-mountain-place","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/locum-little-mountain-place/","title":{"rendered":"Locum Part-Time FP for Long Term Care Panel at Little Mountain Place"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[138],"joblisting_community":[143],"joblisting_ft_pt":[],"acf":{"job_listing-practice_type":"Family Practice","job_listing-job_type":["Locum"],"job_listing-clinic":8376,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Fee-for-Service with additional incentive payments (see further information below)","job_listing-description":"If you have experience in care of the elderly or an interest in this work, augment your practice with a long term care panel! Long Term Care (LTC) locum placements provide flexibility, allow you to diversify your work and to get a feel for the LTC landscape in Vancouver.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You qualify for the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Depending on the duration of the locum work, participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplementing other family practice work with a LTC locum adds variety to your workday</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There is a strong LTC community of practice and a variety of care homes throughout the city providing interesting locum and permanent opportunities</li>\r\n \t<li>You can join the LTCI Locum Roster and flexibly turn on/off your availability to take locum opportunities</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>","job_listing-job_specifics":"The Vancouver Division of Family Practice LTCI enables physicians who work in long term care and commit to the LTCI Locum Roster Agreement to receive additional funding if they meet five identified best practice expectations in their care home work. The best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; and completed documentation in charts.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI Locum Roster and take on a locum placement also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed prorated for the length of the locum agreement</li>\r\n \t<li>If participating in the after-hours care program, payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0997913","job_listing-clinic_lattitude":49.2375107,"job_listing-job_location":"49.2375107%-123.0997913","email_recipient":"ltc@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/8377"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8376"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8377"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=8377"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=8377"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=8377"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=8377"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=8377"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8375,"date":"2022-12-16T00:53:42","date_gmt":"2022-12-16T00:53:42","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=8375"},"modified":"2023-02-22T08:30:01","modified_gmt":"2023-02-22T08:30:01","slug":"louis-brier","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/louis-brier/","title":{"rendered":"Permanent Part-Time FP for Long Term Care Panel at Louis Brier Home and Hospital &#038; Weinberg Residence"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[138],"joblisting_community":[144],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Practice","job_listing-job_type":["Permanent"],"job_listing-clinic":8374,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Fee-for-Service with additional incentive payments (see further information below)","job_listing-description":"Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>","job_listing-job_specifics":"The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1292208","job_listing-clinic_lattitude":49.2345285,"job_listing-job_location":"49.2345285%-123.1292208","email_recipient":"ltc@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/8375"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/8374"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8375"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=8375"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=8375"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=8375"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=8375"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=8375"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7926,"date":"2022-11-18T06:38:31","date_gmt":"2022-11-18T06:38:31","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=7926"},"modified":"2023-02-22T08:30:33","modified_gmt":"2023-02-22T08:30:33","slug":"long-term-care-locum-roster","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/long-term-care-locum-roster/","title":{"rendered":"Locum Part-Time FP for Long Term Care Locum Roster"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[137],"joblisting_clinic_type":[138],"joblisting_community":[147,146,145,144,143,142],"joblisting_ft_pt":[],"acf":{"job_listing-practice_type":"Family Practice","job_listing-job_type":["Locum"],"job_listing-clinic":7925,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Fee-for-Service with additional incentive payments (see further information below)","job_listing-description":"If you have experience in care of the elderly or an interest in this work and would like to be placed on our Long Term Care Initiative (LTCI) Locum Roster, please contact us. Long Term Care (LTC) locum opportunities will be filled from this roster of physicians. Locum placements provide flexibility, allow you to diversify your work and to get a feel for the LTC landscape in Vancouver.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You qualify for the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Depending on the duration of the locum work, participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplementing other family practice work with a LTC locum adds variety to your workday</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There is a strong LTC community of practice and a variety of care homes throughout the city providing interesting locum opportunities</li>\r\n \t<li>Once you are accepted onto the locum roster you can flexibly turn on/off your availability to take locum opportunities</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>","job_listing-job_specifics":"The Vancouver Division of Family Practice LTCI enables physicians who work in long term care and commit to the LTCI Locum Roster Agreement to receive additional funding if they meet five identified best practice expectations in their care home work. The best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; and completed documentation in charts.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI Locum Roster and take on a locum placement also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed prorated for the length of the locum agreement</li>\r\n \t<li>If participating in the after-hours care program, payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1213494","job_listing-clinic_lattitude":49.2635975,"job_listing-job_location":"49.2635975%-123.1213494","email_recipient":"ltc@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/7926"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/7925"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7926"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=7926"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=7926"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=7926"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=7926"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=7926"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7924,"date":"2022-11-18T06:18:16","date_gmt":"2022-11-18T06:18:16","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=7924"},"modified":"2023-08-14T23:50:48","modified_gmt":"2023-08-14T23:50:48","slug":"villa-cathay-care-home","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/villa-cathay-care-home/","title":{"rendered":"Permanent Part-Time FP for Long Term Care Panel at Villa Cathay Care Home"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[138],"joblisting_community":[146],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Physician","job_listing-job_type":["Permanent"],"job_listing-clinic":7923,"set_specific_time":false,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Fee-for-Service with additional incentive payments (see further information below)","job_listing-description":"Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>","job_listing-job_specifics":"The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.0836056","job_listing-clinic_lattitude":49.2771776,"job_listing-job_location":"49.2771776%-123.0836056","email_recipient":"ltc@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/7924"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/7923"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7924"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=7924"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=7924"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=7924"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=7924"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=7924"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7922,"date":"2022-11-18T06:14:27","date_gmt":"2022-11-18T06:14:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=7922"},"modified":"2023-02-22T08:31:36","modified_gmt":"2023-02-22T08:31:36","slug":"sunrise-senior-living-of-vancouver","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/sunrise-senior-living-of-vancouver/","title":{"rendered":"Permanent Part-Time FP for Long Term Care Panel at Sunrise Senior Living of Vancouver"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[138],"joblisting_community":[142],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Practice","job_listing-job_type":["Permanent"],"job_listing-clinic":7921,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Fee-for-Service with additional incentive payments (see further information below)","job_listing-description":"Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>","job_listing-job_specifics":"The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1277386","job_listing-clinic_lattitude":49.2196624,"job_listing-job_location":"49.2196624%-123.1277386","email_recipient":"ltc@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/7922"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/7921"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7922"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=7922"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=7922"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=7922"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=7922"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=7922"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7920,"date":"2022-11-18T06:07:02","date_gmt":"2022-11-18T06:07:02","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=7920"},"modified":"2023-02-22T08:32:10","modified_gmt":"2023-02-22T08:32:10","slug":"crofton-manor","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/crofton-manor/","title":{"rendered":"Permanent Part-Time FP for Long Term Care Panel at Crofton Manor"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[138],"joblisting_community":[144],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Practice","job_listing-job_type":["Permanent"],"job_listing-clinic":6387,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Fee-for-Service with additional incentive payments (see further information below)","job_listing-description":"Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>","job_listing-job_specifics":"The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.1677477","job_listing-clinic_lattitude":49.235294,"job_listing-job_location":"49.235294%-123.1677477","email_recipient":"ltc@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/7920"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/6387"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7920"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=7920"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=7920"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=7920"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=7920"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=7920"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7919,"date":"2022-11-18T06:00:41","date_gmt":"2022-11-18T06:00:41","guid":{"rendered":"https://van-division.yarko.dev/?post_type=job_listing&#038;p=7919"},"modified":"2023-02-22T08:32:43","modified_gmt":"2023-02-22T08:32:43","slug":"britannia-lodge","status":"publish","type":"job_listing","link":"https://van-division.yarko.dev/job_listing/britannia-lodge/","title":{"rendered":"Permanent Part-Time FP for Long Term Care Panel at Britannia Lodge"},"excerpt":{"rendered":"","protected":false},"template":"","joblisting_practice_type":[131],"joblisting_job_type":[136],"joblisting_clinic_type":[138],"joblisting_community":[146],"joblisting_ft_pt":[206],"acf":{"job_listing-practice_type":"Family Practice","job_listing-job_type":["Permanent"],"job_listing-clinic":6449,"set_specific_time":true,"job_listing-start_date":null,"job_listing-end_date":null,"non_specific_date_message":"Negotiable","job_listing-remuneration":"Fee-for-Service with additional incentive payments (see further information below)","job_listing-description":"Now is the time to augment your practice with a long term care panel! Multiple long term care (LTC) homes have exciting opportunities for you to provide the challenging, diverse, and impactful work of caring for the frail elderly.\r\n\r\nWhy long term care?\r\n<ul>\r\n \t<li>Specialized mental health population; expand on your mental health skillset and apply your expertise to a LTC setting</li>\r\n \t<li>You will become part of a supportive physician community</li>\r\n \t<li>Each care home works closely with an interdisciplinary care team to provide holistic resident-centered care</li>\r\n \t<li>You have the opportunity to join the Long Term Care Initiative (LTCI) which includes the following:\r\n<ul>\r\n \t<li>Incentive payments in addition to fee-for-service billings</li>\r\n \t<li>Paid mentorship opportunities</li>\r\n \t<li>Participation in a self-scheduling, paid, after-hours care system (commitment of only one week of coverage per quarter; coverage is shared amongst the Vancouver LTCI practitioners)</li>\r\n \t<li>Opportunities for paid participation in long term care-specific events</li>\r\n \t<li>Opportunities to participate in LTC quality improvement projects and CME</li>\r\n</ul>\r\n</li>\r\n \t<li>You can develop and grow your skills in providing care for the frail elderly and transfer these skills to your work in community and hospital settings</li>\r\n \t<li>Allows for flexibility in your schedule – supplement other family practice work with a LTC panel to add variety to your workday. You can work with the care home leadership to set the size of your panel and your availability for providing care</li>\r\n \t<li>Caring for the frail elderly is both challenging and incredibly rewarding</li>\r\n</ul>\r\n&nbsp;\r\n\r\nWhy now?\r\n<ul>\r\n \t<li>There are a number of vacancies for long term care physicians and therefore you will have greater opportunity to select the specific care home or area you would like to work in</li>\r\n \t<li>With an ageing population, care of the frail elderly will become increasingly important in both community and long term care settings</li>\r\n</ul>","job_listing-job_specifics":"The Vancouver Division of Family Practice Long Term Care Initiative (LTCI) enables physicians who work in long term care and commit to a formal relationship with a care home to receive additional funding if they meet six identified best practice expectations in their care home work. The six best-practices include regular proactive visits; on-site medication reviews; attendance at care conferences; involvement in 24/7 on call; completed documentation in charts; and attendance at quarterly meetings with other care home-attached practitioners and care home leadership.\r\n\r\nRemuneration: LTCI care home panels are remunerated through fee-for-service. All physicians who join the LTCI and take on a panel between 5 to 35 beds also qualify for the following incentive payments:\r\n<ul>\r\n \t<li>Yearly stipend payment of $220 per bed</li>\r\n \t<li>After-hours care payments of $800 for weekday shifts (5pm to 8am Monday to Thursday) and $1,000 for weekend shifts (5pm Friday to 8am Monday)</li>\r\n</ul>","job_listing-information":"","job_listing-other_information":"","job_listing-clinic_longitude":"-123.065204","job_listing-clinic_lattitude":49.2750673,"job_listing-job_location":"49.2750673%-123.065204","email_recipient":"ltc@van-division.yarko.dev","resume-invite":""},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing/7919"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/job_listing"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/job_listing"}],"acf:post":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/clinic/6449"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7919"}],"wp:term":[{"taxonomy":"joblisting_practice_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_practice_type?post=7919"},{"taxonomy":"joblisting_job_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_job_type?post=7919"},{"taxonomy":"joblisting_clinic_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_clinic_type?post=7919"},{"taxonomy":"joblisting_community","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_community?post=7919"},{"taxonomy":"joblisting_ft_pt","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/joblisting_ft_pt?post=7919"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}}];/* harmony default export */ __webpack_exports__["a"] = (database);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return jobType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return community; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return practiceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fullPartTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clinicType; });
var jobType = [{
    "id": 13,
    "count": 0,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_job_type/clinic-manager/",
    "name": "Clinic Manager",
    "slug": "clinic-manager",
    "taxonomy": "joblisting_job_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type/13"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_job_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_job_type=13"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 15,
    "count": 18,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_job_type/locum/",
    "name": "Locum",
    "slug": "locum",
    "taxonomy": "joblisting_job_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type/15"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_job_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_job_type=15"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 323,
    "count": 8,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_job_type/moa/",
    "name": "MOA",
    "slug": "moa",
    "taxonomy": "joblisting_job_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type/323"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_job_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_job_type=323"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 17,
    "count": 40,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_job_type/permanent/",
    "name": "Permanent",
    "slug": "permanent",
    "taxonomy": "joblisting_job_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type/17"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_job_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_job_type=17"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 324,
    "count": 7,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_job_type/teaching-opportunities/",
    "name": "Teaching Opportunities",
    "slug": "teaching-opportunities",
    "taxonomy": "joblisting_job_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type/324"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_job_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_job_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_job_type=324"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}];

var community = [{
    "id": 315,
    "count": 10,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/all-victoria/",
    "name": "All Victoria",
    "slug": "all-victoria",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/315"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=315"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 319,
    "count": 2,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/brentwood-bay/",
    "name": "Brentwood Bay",
    "slug": "brentwood-bay",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/319"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=319"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 321,
    "count": 2,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/cordova-bay/",
    "name": "Cordova Bay",
    "slug": "cordova-bay",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/321"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=321"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 92,
    "count": 5,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/downtown/",
    "name": "Downtown",
    "slug": "downtown",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/92"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=92"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 85,
    "count": 7,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/fairfield/",
    "name": "Fairfield",
    "slug": "fairfield",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/85"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=85"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 87,
    "count": 8,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/fernwood/",
    "name": "Fernwood",
    "slug": "fernwood",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/87"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=87"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 90,
    "count": 5,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/gordon-head/",
    "name": "Gordon Head",
    "slug": "gordon-head",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/90"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=90"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 81,
    "count": 1,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/interurban/",
    "name": "Interurban",
    "slug": "interurban",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/81"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=81"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 88,
    "count": 2,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/james-bay/",
    "name": "James Bay",
    "slug": "james-bay",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/88"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=88"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 317,
    "count": 2,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/langford/",
    "name": "Langford",
    "slug": "langford",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/317"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=317"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 89,
    "count": 9,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/oak-bay/",
    "name": "Oak Bay",
    "slug": "oak-bay",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/89"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=89"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 86,
    "count": 9,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/oaklands/",
    "name": "Oaklands",
    "slug": "oaklands",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/86"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=86"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 83,
    "count": 5,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/quadra/",
    "name": "Quadra",
    "slug": "quadra",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/83"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=83"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 316,
    "count": 10,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/saanich/",
    "name": "Saanich",
    "slug": "saanich",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/316"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=316"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 91,
    "count": 1,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/shelbourne/",
    "name": "Shelbourne",
    "slug": "shelbourne",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/91"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=91"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 318,
    "count": 2,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/sidney/",
    "name": "Sidney",
    "slug": "sidney",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/318"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=318"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 84,
    "count": 1,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/swan-lake/",
    "name": "Swan Lake",
    "slug": "swan-lake",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/84"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=84"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 82,
    "count": 8,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/tillicum/",
    "name": "Tillicum",
    "slug": "tillicum",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/82"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=82"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 93,
    "count": 1,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/vic-west/",
    "name": "Vic West",
    "slug": "vic-west",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/93"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=93"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 320,
    "count": 2,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_community/view-royal/",
    "name": "View Royal",
    "slug": "view-royal",
    "taxonomy": "joblisting_community",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community/320"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_community"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_community"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_community=320"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}];

var practiceType = [{
    "id": 100,
    "count": 8,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_practice_type/clinic-staff/",
    "name": "Clinic Staff",
    "slug": "clinic-staff",
    "taxonomy": "joblisting_practice_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_practice_type/100"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_practice_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_practice_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_practice_type=100"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 98,
    "count": 62,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_practice_type/family-physician/",
    "name": "Family Physician",
    "slug": "family-physician",
    "taxonomy": "joblisting_practice_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_practice_type/98"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_practice_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_practice_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_practice_type=98"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 99,
    "count": 4,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_practice_type/nurse-practitioner/",
    "name": "Nurse Practitioner",
    "slug": "nurse-practitioner",
    "taxonomy": "joblisting_practice_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_practice_type/99"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_practice_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_practice_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_practice_type=99"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}];

var fullPartTime = [{
    "id": 32,
    "count": 45,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_ft_pt/full-time-2/",
    "name": "Full-Time",
    "slug": "full-time-2",
    "taxonomy": "joblisting_ft_pt",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_ft_pt/32"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_ft_pt"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_ft_pt"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_ft_pt=32"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 31,
    "count": 53,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_ft_pt/full-time/",
    "name": "Part-Time",
    "slug": "full-time",
    "taxonomy": "joblisting_ft_pt",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_ft_pt/31"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_ft_pt"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_ft_pt"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_ft_pt=31"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}];

var clinicType = [{
    "id": 19,
    "count": 3,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/community-health-centre-chc/",
    "name": "Community Health Centre (CHC)",
    "slug": "community-health-centre-chc",
    "taxonomy": "joblisting_clinic_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/19"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=19"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 20,
    "count": 37,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/family-practice/",
    "name": "Family Practice",
    "slug": "family-practice",
    "taxonomy": "joblisting_clinic_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/20"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=20"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 21,
    "count": 13,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/family-practice-and-walk-in-hybrid/",
    "name": "Family Practice and Walk-In Hybrid",
    "slug": "family-practice-and-walk-in-hybrid",
    "taxonomy": "joblisting_clinic_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/21"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=21"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 342,
    "count": 1,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/local-initiatives/",
    "name": "Local Initiatives",
    "slug": "local-initiatives",
    "taxonomy": "joblisting_clinic_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/342"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=342"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 22,
    "count": 1,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/long-term-care-home/",
    "name": "Long Term Care Home",
    "slug": "long-term-care-home",
    "taxonomy": "joblisting_clinic_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/22"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=22"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 322,
    "count": 7,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/teaching-opportunities/",
    "name": "Teaching Opportunities",
    "slug": "teaching-opportunities",
    "taxonomy": "joblisting_clinic_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/322"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=322"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 23,
    "count": 1,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/urgent-primary-care-centre-upcc/",
    "name": "Urgent Primary Care Centre (UPCC)",
    "slug": "urgent-primary-care-centre-upcc",
    "taxonomy": "joblisting_clinic_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/23"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=23"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}, {
    "id": 24,
    "count": 11,
    "description": "",
    "link": "https://vicdiv-dev.yarko.dev/joblisting_clinic_type/walk-in-clinic/",
    "name": "Walk-in Clinic",
    "slug": "walk-in-clinic",
    "taxonomy": "joblisting_clinic_type",
    "parent": 0,
    "meta": [],
    "acf": [],
    "_links": {
        "self": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type/24"
        }],
        "collection": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/joblisting_clinic_type"
        }],
        "about": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/taxonomies/joblisting_clinic_type"
        }],
        "wp:post_type": [{
            "href": "https://vicdiv-dev.yarko.dev/wp-json/wp/v2/job_listing?joblisting_clinic_type=24"
        }],
        "curies": [{
            "name": "wp",
            "href": "https://api.w.org/{rel}",
            "templated": true
        }]
    }
}];

/*


// Get the current site URL
const siteURL = window.location.origin;

// Define the taxonomy rest base
const taxonomyRestBase = 'joblisting_clinic_type'; // Replace 'your_taxonomy_rest_base' with the rest base of your taxonomy

// Function to fetch terms of a taxonomy
function fetchTerms() {
    fetch(`${siteURL}/wp-json/wp/v2/${taxonomyRestBase}`)
        .then(response => response.json())
        .then(terms => {
            // Process the terms here
            processTerms(terms);
        }).catch(error => console.error('Error:', error));
}

// Function to process terms
function processTerms(terms) {
    const processedTerms = terms.map(term => {
        return {
            id: term.id,
            count: term.count,
            description: term.description,
            link: term.link,
            name: term.name,
            slug: term.slug,
            taxonomy: term.taxonomy,
            parent: term.parent,
            meta: term.meta,
            acf: term.acf, // Assuming ACF plugin is used and these fields are available
            _links: term._links
        };
    });

    console.log(processedTerms);
}

// Trigger the fetch operation
fetchTerms();


*/

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vueWiVContainer"},[_c('div',{staticClass:"vueWivSearchBar_container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"vueWivSearchBar_input",attrs:{"placeholder":"Search..."},domProps:{"value":(_vm.searchTerm)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.performUnifiedSearch.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"vueWivSearchBar_button",on:{"click":_vm.performUnifiedSearch}},[_vm._v("Search")])]),_vm._v(" "),_c('div',{staticClass:"dropdownContainer"},[_c('DropdownFilter',{attrs:{"title":"Job Title","placeholder":"Select filters...","items":_vm.practiceTypeNames},on:{"item-toggled":_vm.handleItemsToggle}}),_vm._v(" "),_c('DropdownFilter',{attrs:{"title":"Job Details","placeholder":"Select filters...","items":_vm.jobTypeNames},on:{"item-toggled":_vm.handleItemsToggle}}),_vm._v(" "),_c('DropdownFilter',{attrs:{"title":"Full-time / Part-time","placeholder":"Select filters...","items":_vm.fullPartTimeNames},on:{"item-toggled":_vm.handleItemsToggle}}),_vm._v(" "),_c('DropdownFilter',{attrs:{"title":"Practice Setting","placeholder":"Select filters...","items":_vm.clinicTypeNames},on:{"item-toggled":_vm.handleItemsToggle}}),_vm._v(" "),_c('DropdownFilter',{attrs:{"title":"Communities","placeholder":"Select filters...","items":_vm.communityNames},on:{"item-toggled":_vm.handleItemsToggle}})],1)]),_vm._v(" "),(!_vm.isSmallScreen)?_c('div',{staticClass:"resultCounter"},[_vm._v(_vm._s(_vm.jobs.length)+" Results ")]):_vm._e(),_vm._v(" "),(!_vm.isSmallScreen)?_c('div',{staticClass:"contentContainer"},[_c('div',{staticClass:"leftSection"},[_c('Gmaps',{attrs:{"markers":_vm.mapMarkers}})],1),_vm._v(" "),_c('div',{staticClass:"rightSection"},[_vm._l((_vm.jobs),function(job){return _c('div',{key:job.id,staticClass:"jobListing"},[_c('div',{domProps:{"innerHTML":_vm._s(job.title.rendered)}}),_vm._v(" "),_c('button',{staticClass:"seeMore"},[_c('a',{attrs:{"href":job.link}},[_vm._v("See More")])])])}),_vm._v(" "),(_vm.jobs.length == 0)?_c('div',{staticClass:"noResultsAvailable"},[_vm._v("\n                No available positions based on your filter selection\n            ")]):_vm._e()],2)]):_vm._e(),_vm._v(" "),(_vm.isSmallScreen)?_c('div',{staticClass:"contentContainer"},[_c('div',{staticClass:"toggleButtons"},[_c('div',{staticClass:"buttonToggleMapMobile",class:{ active: _vm.currentView === 'list' },on:{"click":function($event){_vm.currentView = 'list'}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('path',{attrs:{"d":"M7 5H21V7H7V5ZM7 13V11H21V13H7ZM4 4.5C4.39782 4.5 4.77936 4.65804 5.06066 4.93934C5.34196 5.22064 5.5 5.60218 5.5 6C5.5 6.39782 5.34196 6.77936 5.06066 7.06066C4.77936 7.34196 4.39782 7.5 4 7.5C3.60218 7.5 3.22064 7.34196 2.93934 7.06066C2.65804 6.77936 2.5 6.39782 2.5 6C2.5 5.60218 2.65804 5.22064 2.93934 4.93934C3.22064 4.65804 3.60218 4.5 4 4.5ZM4 10.5C4.39782 10.5 4.77936 10.658 5.06066 10.9393C5.34196 11.2206 5.5 11.6022 5.5 12C5.5 12.3978 5.34196 12.7794 5.06066 13.0607C4.77936 13.342 4.39782 13.5 4 13.5C3.60218 13.5 3.22064 13.342 2.93934 13.0607C2.65804 12.7794 2.5 12.3978 2.5 12C2.5 11.6022 2.65804 11.2206 2.93934 10.9393C3.22064 10.658 3.60218 10.5 4 10.5ZM7 19V17H21V19H7ZM4 16.5C4.39782 16.5 4.77936 16.658 5.06066 16.9393C5.34196 17.2206 5.5 17.6022 5.5 18C5.5 18.3978 5.34196 18.7794 5.06066 19.0607C4.77936 19.342 4.39782 19.5 4 19.5C3.60218 19.5 3.22064 19.342 2.93934 19.0607C2.65804 18.7794 2.5 18.3978 2.5 18C2.5 17.6022 2.65804 17.2206 2.93934 16.9393C3.22064 16.658 3.60218 16.5 4 16.5Z","fill":"#006D8A"}})]),_vm._v("\n                List view\n            ")]),_vm._v(" "),_c('div',{staticClass:"buttonToggleMapMobile",class:{ active: _vm.currentView === 'map' },on:{"click":function($event){_vm.currentView = 'map'}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"}},[_c('path',{attrs:{"d":"M17.5 0L17.34 0.03L12 2.1L6 0L0.36 1.9C0.15 1.97 0 2.15 0 2.38V17.5C0 17.78 0.22 18 0.5 18L0.66 17.97L6 15.9L12 18L17.64 16.1C17.85 16.03 18 15.85 18 15.62V0.5C18 0.22 17.78 0 17.5 0ZM12 16L6 13.89V2L12 4.11V16Z","fill":"#006D8A"}})]),_vm._v("\n                On the map\n            ")])]),_vm._v(" "),_c('div',{staticClass:"resultCounterMobile"},[_vm._v(_vm._s(_vm.jobs.length)+" Results ")]),_vm._v(" "),(_vm.currentView === 'list')?_c('div',{staticClass:"listSection"},[_vm._l((_vm.jobs),function(job){return _c('div',{key:job.id,staticClass:"jobListing"},[_c('div',{domProps:{"innerHTML":_vm._s(job.title.rendered)}}),_vm._v(" "),_c('button',{staticClass:"seeMore"},[_c('a',{attrs:{"href":job.link}},[_vm._v("See More")])])])}),_vm._v(" "),(_vm.jobs.length == 0)?_c('div',{staticClass:"noResultsAvailable"},[_vm._v("\n                No available positions based on your filter selection\n            ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.currentView === 'map')?_c('div',{staticClass:"mapSection"},[_c('Gmaps',{attrs:{"markers":_vm.mapMarkers}})],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allResources_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_802423b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allResources_vue__ = __webpack_require__(578);
function injectStyle (ssrContext) {
  __webpack_require__(575)
}
var normalizeComponent = __webpack_require__(48)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allResources_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_802423b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allResources_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(576);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(67)("334abe11", content, true, {});

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(66)(false);
// imports


// module
exports.push([module.i, ".vueContainer{align-content:center}.filter-container,.vueContainer{display:flex;flex-direction:column;align-items:center}.filter-container{width:100%}.search-row{display:flex;justify-content:space-between;width:100%;margin-bottom:10px}.search-row input{border-radius:0;border-color:#cccc}.search-row button{border-radius:0;transition:.5s;margin-left:5px;border:1px solid #006d8a;background:#428da1!important;color:#fff!important;padding:.5rem 1rem;font-size:1rem;border-radius:4px}.search-row button:hover{background-color:#cd6c33;border-color:#cd6c33}.filters-row{display:flex;justify-content:space-between;flex-wrap:wrap;gap:10px;WIDTH:100%}.filter-column{margin-bottom:20px;width:200px;display:flex;flex-direction:column;align-items:start}.filter-title{text-align:left;margin-bottom:5px;margin-top:10px;color:#333;font-family:Robotos Slab,Sans-serif;font-size:17px;font-weight:400;text-wrap:nowrap}.dropdown-button{border:1px solid #006d8a;display:flex;text-align:left;width:100%;cursor:pointer;position:relative;transition:.5s;align-content:center;justify-content:flex-start;align-items:center;background:#428da1!important;color:#fff!important;padding:.5rem 1rem;font-size:1rem;border-radius:4px;transition:all .3s;flex-wrap:nowrap}.resetFilterButtonContainer{width:100%;display:flex;justify-content:flex-end}.resetFilterButon{border:1px solid #006d8a;display:flex;text-align:left;width:120px;cursor:pointer;position:relative;transition:.5s;align-content:center;justify-content:flex-start;align-items:center;background:#428da1!important;color:#fff!important;padding:.5rem 1rem;font-size:1rem;border-radius:4px;transition:all .3s;flex-wrap:nowrap}.dropdown-button:hover{border:1px solid #cd6c33;background-color:#f9f9f9;color:#006d8a}.dropdown-button .arrow{position:absolute;right:16px;top:50%;transform:translateY(-50%);display:none}.checkbox-dropdown{display:none;border:1px solid #ccc;position:absolute;background-color:#fff;width:100%;box-shadow:0 2px 5px rgba(0,0,0,.2);z-index:10}.checkbox-dropdown.show{display:flex;flex-direction:column;width:200px;margin-top:79px}.checkbox-option{padding:10px 16px;display:flex;align-items:center}.checkbox-option:last-child{border-bottom:none}.checkbox-option input[type=checkbox]{margin-right:8px}.checkbox-option label{font-family:Barlow,Sans-serif;font-weight:500;color:#006d8a}.apply-button{padding:10px 16px;background-color:#006d8a;color:#fff;border:none;border-radius:0;cursor:pointer;margin-top:10px;align-self:end;transition:.5s}.apply-button:hover{background-color:#cd6c33}@media (max-width:768px){.filters-row{flex-direction:column}.filter-column{margin-bottom:0}.filter-column,.search-row{width:100%}.checkbox-dropdown.show{width:90vw}.resetFilterButtonContainer{width:100%;display:flex;justify-content:center;margin-top:25px}}.results-container{display:flex;flex-wrap:wrap;gap:16px;justify-content:space-between;margin-top:20px;width:100%}.result-card{display:flex;box-shadow:0 2px 4px rgba(0,0,0,.1);margin-bottom:16px;background:#fff;overflow:hidden;text-align:center;height:390px;width:270px!important;flex-direction:column;position:relative;border-radius:8px}.hover-overlay{position:absolute;top:0;left:0;right:0;bottom:0;padding:30px;color:#fff;opacity:0;display:flex;align-items:center;justify-content:center;transition:opacity .3s ease;pointer-events:none}.result-card:hover .hover-overlay{opacity:1}.hover-title{transition:opacity .3s ease;text-transform:uppercase;font-weight:700;font-size:26px;color:#fff}.result-icon{background-color:#009688;padding:20px;width:150px!important;min-height:150px!important;height:150px!important;border-radius:50%;margin:16px auto;display:flex;align-items:center;justify-content:center;position:relative;overflow:visible}.imgIconResult{width:120px}.result-summary{font-size:14px;color:#666;padding:0 16px;margin-top:8px;margin-bottom:8px;height:135px;text-align:left}.result-title{color:#fff;padding:5px;font-size:17px;font-weight:700;height:95px;display:flex;align-items:center;justify-content:center;z-index:0}.first-colCard{border:1px solid #006d8a}.second-colCard{border:1px solid #bbbf9a}.third-colCard{border:1px solid #e48f5b}.first-col{background-color:#006d8a}.second-col{background-color:#bbbf9a}.third-col{background-color:#e48f5b}.first-colIcon{background-color:#006d8a}.second-colIcon{background-color:#bbbf9a}.third-colIcon{background-color:#e48f5b}.first-colHover{background-color:#006d8a}.second-colHover{background-color:#bbbf9a}.third-colHover{background-color:#e48f5b}@media (max-width:768px){.result-card{flex-basis:100%}}.NofFilter{background-color:#006d8a;padding:9px;margin-right:5px;color:#fff;width:15px;height:15px;border-radius:50%;align-content:center;flex-wrap:wrap}.NofFilter,.pagination-controls{display:flex;align-items:center;justify-content:center}.pagination-controls span{margin:15px}.loaderContainer{display:flex;justify-content:center;width:100%}.loader{border:10px solid #f3f3f3;border-top:10px solid #006d8a;border-radius:50%;width:50px;height:50px;animation:spin 2s linear infinite;margin-top:50px}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var database=[{"id":11215,"date":"2023-09-06T18:31:10","date_gmt":"2023-09-06T18:31:10","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=11215"},"modified":"2023-09-11T18:29:02","modified_gmt":"2023-09-11T18:29:02","slug":"pcn-new-cervix-self-screening","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/pcn-new-cervix-self-screening/","title":{"rendered":"New Cervix Self-Screening HPV Test"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[212],"acf":{"post-icon":10158,"post-excerpt":"It is expected that starting in January of 2024, people in BC can complete cervix self-screening to test for HPV.","related_resources":[71],"related_campaigns":[],"related_events":[176]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/11215"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11215"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11215"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=11215"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11157,"date":"2023-08-28T19:11:40","date_gmt":"2023-08-28T19:11:40","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=11157"},"modified":"2023-08-28T19:13:59","modified_gmt":"2023-08-28T19:13:59","slug":"but-i-dont-do-maternity-care-cme-series","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/but-i-dont-do-maternity-care-cme-series/","title":{"rendered":"But I Don’t Do Maternity Care CME series"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[],"acf":{"post-icon":2270,"post-excerpt":"The Division is proud to be collaborating with UBC CPD to create the But I Don’t Do Maternity Care CME series","related_resources":[148],"related_campaigns":[91],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/11157"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11157"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11157"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=11157"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6410,"date":"2023-08-22T09:49:33","date_gmt":"2023-08-22T09:49:33","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=6410"},"modified":"2023-09-18T21:37:37","modified_gmt":"2023-09-18T21:37:37","slug":"agm","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/agm/","title":{"rendered":"Annual General Meeting 2023"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[179],"acf":{"post-icon":2240,"post-excerpt":"Important information about your 2023 Annual General Meeting (AGM) and the membership vote, to be held Thursday October 19th.","related_resources":[167],"related_campaigns":[179],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/6410"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6410"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6410"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=6410"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10953,"date":"2023-08-10T23:53:09","date_gmt":"2023-08-10T23:53:09","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=10953"},"modified":"2023-08-10T23:53:09","modified_gmt":"2023-08-10T23:53:09","slug":"a-day-in-the-life-of-a-preceptor-cme","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/a-day-in-the-life-of-a-preceptor-cme/","title":{"rendered":"A Day in the Life of a Preceptor CME"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[],"acf":{"post-icon":9438,"post-excerpt":"Learn about being a preceptor","related_resources":[],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/10953"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10953"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10953"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=10953"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10195,"date":"2023-05-09T17:50:39","date_gmt":"2023-05-09T17:50:39","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=10195"},"modified":"2023-08-16T23:21:55","modified_gmt":"2023-08-16T23:21:55","slug":"community-of-practice-supporting-chinese-speaking-patients","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/community-of-practice-supporting-chinese-speaking-patients/","title":{"rendered":"CoP Supporting Chinese-speaking Patients"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[],"acf":{"post-icon":9438,"post-excerpt":"Resources from community partners that provide translation, social prescribing, patient navigation","related_resources":[196,119],"related_campaigns":[],"related_events":[173]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/10195"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10195"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/173"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/196"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10195"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=10195"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9701,"date":"2023-03-21T19:31:02","date_gmt":"2023-03-21T19:31:02","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=9701"},"modified":"2023-05-24T23:33:03","modified_gmt":"2023-05-24T23:33:03","slug":"clinical-management-of-alcohol-use-disorder","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/clinical-management-of-alcohol-use-disorder/","title":{"rendered":"Clinical Management of Alcohol Use Disorder"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[],"acf":{"post-icon":2240,"post-excerpt":"Information and resources on the Clinical Management of Alcohol Use Disorder.","related_resources":[119],"related_campaigns":[117],"related_events":[198]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/9701"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9701"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9701"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=9701"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8847,"date":"2023-03-20T17:12:50","date_gmt":"2023-03-20T17:12:50","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=8847"},"modified":"2023-05-24T16:01:38","modified_gmt":"2023-05-24T16:01:38","slug":"understanding-the-access-assessment-centre","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/understanding-the-access-assessment-centre/","title":{"rendered":"Understanding the Access &#038; Assessment Centre"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[117],"acf":{"post-icon":2268,"post-excerpt":"Details on how to effectively use the AAC in Vancouver.","related_resources":[119],"related_campaigns":[117],"related_events":[198]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/8847"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8847"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8847"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8847"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8734,"date":"2023-03-03T20:06:42","date_gmt":"2023-03-03T20:06:42","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=8734"},"modified":"2023-08-18T16:20:44","modified_gmt":"2023-08-18T16:20:44","slug":"membership-pins","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/membership-pins/","title":{"rendered":"Membership Pins"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[],"acf":{"post-icon":2668,"post-excerpt":"The Vancouver Division is proud to recognize long term members with a commemorative Years of Membership pin.","related_resources":[111],"related_campaigns":[165],"related_events":[171]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/8734"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8734"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/111"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8734"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8734"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8707,"date":"2023-02-07T23:28:27","date_gmt":"2023-02-07T23:28:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=8707"},"modified":"2023-05-24T23:27:18","modified_gmt":"2023-05-24T23:27:18","slug":"physician-peer-support","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/physician-peer-support/","title":{"rendered":"Physician Peer Support"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[165],"acf":{"post-icon":2268,"post-excerpt":"Supporting physician colleagues in a 1:1 setting to improve coping and self-management skills.","related_resources":[195,129],"related_campaigns":[165],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/8707"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8707"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/195"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8707"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8707"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8601,"date":"2023-01-13T23:10:30","date_gmt":"2023-01-13T23:10:30","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=8601"},"modified":"2023-09-12T22:11:05","modified_gmt":"2023-09-12T22:11:05","slug":"pcn-ipt-engagement-series","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/pcn-ipt-engagement-series/","title":{"rendered":"PCN Interprofessional Team (IPT) Engagement Series"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[152],"acf":{"post-icon":2240,"post-excerpt":"A new online series to connect Interprofessional Team (IPT) clinicians and primary care providers working together in PCNs.","related_resources":[153],"related_campaigns":[152],"related_events":[205]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/8601"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8601"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/205"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8601"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8601"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8270,"date":"2022-11-30T10:28:16","date_gmt":"2022-11-30T10:28:16","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=8270"},"modified":"2023-06-02T22:37:40","modified_gmt":"2023-06-02T22:37:40","slug":"grow-your-practice-pai","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/grow-your-practice-pai/","title":{"rendered":"Grow Your Practice &#8211; Patient Attachment Initiative"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[],"acf":{"post-icon":2240,"post-excerpt":"Growing Your Practice: Accepting patients through the Vancouver Division","related_resources":[162],"related_campaigns":[150],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/8270"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8270"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/162"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8270"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8270"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8084,"date":"2022-11-24T13:26:41","date_gmt":"2022-11-24T13:26:41","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=8084"},"modified":"2023-06-02T22:49:09","modified_gmt":"2023-06-02T22:49:09","slug":"grow-your-practice-batch-rate-matching","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/grow-your-practice-batch-rate-matching/","title":{"rendered":"Grow Your Practice &#8211; Batch-Rate Matching Program"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[],"acf":{"post-icon":2240,"post-excerpt":"Growing Your Practice: Accepting patients through the Vancouver Division","related_resources":[162],"related_campaigns":[150],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/8084"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8084"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/162"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8084"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8084"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8077,"date":"2022-11-24T12:01:08","date_gmt":"2022-11-24T12:01:08","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=8077"},"modified":"2023-08-10T19:48:20","modified_gmt":"2023-08-10T19:48:20","slug":"retirement-support","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/retirement-support/","title":{"rendered":"Retirement Support"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[],"acf":{"post-icon":2240,"post-excerpt":"Retirement Support – access support in preparing for and during your transition to retirement.","related_resources":[72],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/8077"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8077"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8077"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8077"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8071,"date":"2022-11-24T11:22:58","date_gmt":"2022-11-24T11:22:58","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=8071"},"modified":"2023-05-10T12:39:25","modified_gmt":"2023-05-10T12:39:25","slug":"ntp-pcn-contracts","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/ntp-pcn-contracts/","title":{"rendered":"New To Practice (NTP) Primary Care Network (PCN) Contracts"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[],"acf":{"post-icon":2240,"post-excerpt":"NTP PCN Contracts initiative to help recruit family physicians in BC.","related_resources":[],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/8071"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8071"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8071"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=8071"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7530,"date":"2022-11-04T18:10:47","date_gmt":"2022-11-04T18:10:47","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=7530"},"modified":"2022-11-09T00:40:13","modified_gmt":"2022-11-09T00:40:13","slug":"engagement-project","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/engagement-project/","title":{"rendered":"New to Practice &#038; Resident Engagement Project"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[],"acf":{"post-icon":2240,"post-excerpt":"Engaging and understanding what attracts new-to-practice and resident physicians to primary care, and how to retain them.","related_resources":[],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/7530"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=7530"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7530"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=7530"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6789,"date":"2022-10-12T10:09:21","date_gmt":"2022-10-12T10:09:21","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=6789"},"modified":"2022-11-17T09:45:14","modified_gmt":"2022-11-17T09:45:14","slug":"clinic-grants-2022-23","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/clinic-grants-2022-23/","title":{"rendered":"Clinic Grants 2022/23"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[185],"acf":{"post-icon":2240,"post-excerpt":"VDOFP Grants for PMH Practice Improvement and Building Primary Care Networks","related_resources":[186],"related_campaigns":[168],"related_events":[171]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/6789"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6789"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/186"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6789"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=6789"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6030,"date":"2022-09-28T09:56:49","date_gmt":"2022-09-28T09:56:49","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=6030"},"modified":"2022-12-21T19:05:46","modified_gmt":"2022-12-21T19:05:46","slug":"flu-vaccine-2022","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/flu-vaccine-2022/","title":{"rendered":"Flu Vaccine 2022/23"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[168],"acf":{"post-icon":2240,"post-excerpt":"Important information on influenza vaccine delivery and availability.","related_resources":[169],"related_campaigns":[152,164],"related_events":[156]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/6030"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6030"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/169"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6030"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=6030"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6583,"date":"2022-09-27T16:31:09","date_gmt":"2022-09-27T16:31:09","guid":{"rendered":"https://van-division.yarko.dev/?post_type=initiative&#038;p=6583"},"modified":"2022-10-12T16:57:20","modified_gmt":"2022-10-12T16:57:20","slug":"primary-care-crisis","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/primary-care-crisis/","title":{"rendered":"Primary Care Crisis"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[184],"acf":{"post-icon":2240,"post-excerpt":"The Vancouver Division of Family Practice and partner organizations support for the current Primary Care Crisis in Vancouver.","related_resources":[170],"related_campaigns":[154],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/6583"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6583"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/170"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6583"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=6583"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":2859,"date":"2022-06-16T04:17:03","date_gmt":"2022-06-16T04:17:03","guid":{"rendered":"https://van-division.yarko.dev/?post_type=campaign&#038;p=2859"},"modified":"2023-03-21T21:17:43","modified_gmt":"2023-03-21T21:17:43","slug":"cbt-skills-group","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/cbt-skills-group/","title":{"rendered":"CBT Skills Groups"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[79,117],"acf":{"post-icon":2240,"post-excerpt":"CBT Skills Groups is a MSP-covered skills training program designed by psychiatrists and taught by physicians.","related_resources":[119,118],"related_campaigns":[79,117,165],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/2859"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=2859"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2859"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=2859"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":2588,"date":"2022-06-15T14:10:09","date_gmt":"2022-06-15T14:10:09","guid":{"rendered":"https://van-division.yarko.dev/?post_type=campaign&#038;p=2588"},"modified":"2023-03-06T21:38:12","modified_gmt":"2023-03-06T21:38:12","slug":"easi-maternity-care-project","status":"publish","type":"initiative","link":"https://van-division.yarko.dev/initiative/easi-maternity-care-project/","title":{"rendered":"EASI Maternity Care Project"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","campaign_topic":[91],"acf":{"post-icon":2240,"post-excerpt":"The EASI Maternity Care Project has involved a collection of maternity providers, allied health and patients.","related_resources":[148],"related_campaigns":[91,184],"related_events":[176]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative/2588"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/initiative"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/initiative"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=2588"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/184"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2588"}],"wp:term":[{"taxonomy":"campaign_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic?post=2588"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11323,"date":"2023-09-12T21:46:54","date_gmt":"2023-09-12T21:46:54","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=11323"},"modified":"2023-09-12T22:09:39","modified_gmt":"2023-09-12T22:09:39","slug":"ipt-engagement-series-a-multidisciplinary-approach-to-managing-substance-use-marijuana-dependency","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/ipt-engagement-series-a-multidisciplinary-approach-to-managing-substance-use-marijuana-dependency/","title":{"rendered":"IPT Engagement Series: A Multidisciplinary Approach to Managing Substance Misuse (marijuana dependency)"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":"","post-excerpt":"This series helps to connect IPT (Interprofessional Team) clinicians and primary care providers working together in PCNs.","related_resources":[],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/11323"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11323"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11323"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=11323"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10657,"date":"2023-08-22T15:00:50","date_gmt":"2023-08-22T15:00:50","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=10657"},"modified":"2023-08-22T22:29:53","modified_gmt":"2023-08-22T22:29:53","slug":"vancouver-division-2023-annual-general-meeting","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/vancouver-division-2023-annual-general-meeting/","title":{"rendered":"Vancouver Division 2023 Annual General Meeting"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"The Vancouver Division of Family Practice Annual General Meeting (AGM) will take place on Thursday October 19, 2023 at 6:00pm","related_resources":[167],"related_campaigns":[],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/10657"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10657"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10657"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10657"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11118,"date":"2023-08-21T19:22:28","date_gmt":"2023-08-21T19:22:28","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=11118"},"modified":"2023-08-21T19:22:28","modified_gmt":"2023-08-21T19:22:28","slug":"bc-echo-on-substance-use-session","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/bc-echo-on-substance-use-session/","title":{"rendered":"BC Echo on Substance Use Session"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"Care Guidance for Benzodiazepine Prescribing\r\n","related_resources":[119],"related_campaigns":[],"related_events":[197]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/11118"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11118"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/197"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11118"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=11118"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11116,"date":"2023-08-21T18:31:38","date_gmt":"2023-08-21T18:31:38","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=11116"},"modified":"2023-08-21T18:31:38","modified_gmt":"2023-08-21T18:31:38","slug":"therapeutics-initiative-annual-course","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/therapeutics-initiative-annual-course/","title":{"rendered":"Therapeutics Initiative Annual Course"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"This year’s TI conference will be offered virtually on Saturday, October 14th, 2023, from 8:30 am-12:45 pm.","related_resources":[71],"related_campaigns":[],"related_events":[176]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/11116"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11116"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11116"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=11116"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11114,"date":"2023-08-21T18:17:18","date_gmt":"2023-08-21T18:17:18","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=11114"},"modified":"2023-08-21T18:17:18","modified_gmt":"2023-08-21T18:17:18","slug":"35th-annual-diabetes-directors-seminar","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/35th-annual-diabetes-directors-seminar/","title":{"rendered":"35th Annual Diabetes Directors Seminar"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"An annual gathering of leading diabetes experts and caregivers across British Columbia.","related_resources":[71],"related_campaigns":[],"related_events":[176]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/11114"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11114"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11114"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=11114"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11120,"date":"2023-08-20T19:32:06","date_gmt":"2023-08-20T19:32:06","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=11120"},"modified":"2023-08-22T22:27:18","modified_gmt":"2023-08-22T22:27:18","slug":"vlat-learning-session-pillars-of-harm-reduction-for-youth","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/vlat-learning-session-pillars-of-harm-reduction-for-youth/","title":{"rendered":"VLAT Learning Session: Pillars of Harm Reduction for Youth"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"This session is organized by the Vancouver LAT, a coalition of organizations (including the VDoFP) ","related_resources":[119],"related_campaigns":[],"related_events":[197]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/11120"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=11120"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/197"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11120"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=11120"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10967,"date":"2023-08-11T00:15:38","date_gmt":"2023-08-11T00:15:38","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=10967"},"modified":"2023-08-11T00:15:38","modified_gmt":"2023-08-11T00:15:38","slug":"healthy-minds-healthy-distractions","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/healthy-minds-healthy-distractions/","title":{"rendered":"Healthy Minds, Healthy Distractions"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"In this hands-on workshop, participants can try cedar bark weaving and learn ways to support Indigenous Cultural Safety.","related_resources":[129],"related_campaigns":[165],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/10967"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10967"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10967"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10967"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10405,"date":"2023-05-16T16:18:40","date_gmt":"2023-05-16T16:18:40","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=10405"},"modified":"2023-05-16T16:18:40","modified_gmt":"2023-05-16T16:18:40","slug":"bccsu-session-on-considerations-for-stimulant-use-disorder-care","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/bccsu-session-on-considerations-for-stimulant-use-disorder-care/","title":{"rendered":"BCCSU Session on Considerations for Stimulant Use Disorder Care"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"Join the upcoming CME accredited BC ECHO on Substance Use session on Considerations for Stimulant Use Disorder Care","related_resources":[119],"related_campaigns":[117],"related_events":[198]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/10405"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10405"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10405"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10405"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10258,"date":"2023-05-02T19:27:25","date_gmt":"2023-05-02T19:27:25","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=10258"},"modified":"2023-08-16T23:35:44","modified_gmt":"2023-08-16T23:35:44","slug":"but-i-dont-do-maternity-care-cme-series-online","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/but-i-dont-do-maternity-care-cme-series-online/","title":{"rendered":"But I Don’t Do Maternity Care CME series (Online)"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"Focus on maternity care and deliveries for a workshop focused on preconception and early prenatal care.","related_resources":[148],"related_campaigns":[91],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/10258"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10258"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10258"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10258"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10257,"date":"2023-05-02T19:26:43","date_gmt":"2023-05-02T19:26:43","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=10257"},"modified":"2023-05-02T19:27:54","modified_gmt":"2023-05-02T19:27:54","slug":"but-i-dont-do-maternity-care-cme-series-in-person","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/but-i-dont-do-maternity-care-cme-series-in-person/","title":{"rendered":"But I Don’t Do Maternity Care CME series (In-Person)"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"Focus on maternity care and deliveries for a workshop focused on preconception and early prenatal care.","related_resources":[148,71],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/10257"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10257"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10257"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10257"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10090,"date":"2023-04-18T17:18:18","date_gmt":"2023-04-18T17:18:18","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=10090"},"modified":"2023-08-16T23:37:29","modified_gmt":"2023-08-16T23:37:29","slug":"implants-and-iuds-comparing-and-inserting-long-acting-reversible-contraceptives-larc","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/implants-and-iuds-comparing-and-inserting-long-acting-reversible-contraceptives-larc/","title":{"rendered":"Implants and IUDs: Comparing and Inserting Long Acting Reversible Contraceptives"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"Join us in person at Morris J Wosk Centre for Dialogue in Vancouver, BC to discover the contraceptive landscape","related_resources":[71],"related_campaigns":[],"related_events":[176]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/10090"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10090"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10090"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10090"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10082,"date":"2023-04-17T22:27:31","date_gmt":"2023-04-17T22:27:31","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=10082"},"modified":"2023-04-18T17:10:57","modified_gmt":"2023-04-18T17:10:57","slug":"bcaccs-matters-of-the-mind-understanding-eating-disorders","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/bcaccs-matters-of-the-mind-understanding-eating-disorders/","title":{"rendered":"BCACC&#8217;s Matters of the Mind: Understanding Eating Disorders"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"Causes, contributing factors, common myths, and how to support someone in recovery.","related_resources":[],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/10082"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10082"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10082"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10082"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10081,"date":"2023-04-17T22:24:16","date_gmt":"2023-04-17T22:24:16","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=10081"},"modified":"2023-08-16T23:38:29","modified_gmt":"2023-08-16T23:38:29","slug":"understanding-the-new-health-professions-and-occupations-act-webinar","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/understanding-the-new-health-professions-and-occupations-act-webinar/","title":{"rendered":"Understanding the new Health Professions and Occupations Act Webinar"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"Understand what the HPOA will mean for physicians, patients, and the profession as whole","related_resources":[163],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/10081"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10081"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10081"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10081"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10650,"date":"2023-04-04T19:49:57","date_gmt":"2023-04-04T19:49:57","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=10650"},"modified":"2023-08-16T17:27:28","modified_gmt":"2023-08-16T17:27:28","slug":"vancouver-division-summer-block-party","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/vancouver-division-summer-block-party/","title":{"rendered":"Vancouver Division Summer Block Party"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"Join for our Summer Block Party at St James' Community Square!","related_resources":[129],"related_campaigns":[165],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/10650"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10650"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10650"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10650"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9997,"date":"2023-04-04T19:05:30","date_gmt":"2023-04-04T19:05:30","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=9997"},"modified":"2023-04-04T19:05:30","modified_gmt":"2023-04-04T19:05:30","slug":"acute-care-of-at-risk-newborns-acorn-workshop","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/acute-care-of-at-risk-newborns-acorn-workshop/","title":{"rendered":"Acute Care of At-Risk Newborns (ACoRN) Workshop"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"","related_resources":[148],"related_campaigns":[],"related_events":[176]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/9997"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9997"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9997"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9997"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9962,"date":"2023-03-29T23:25:20","date_gmt":"2023-03-29T23:25:20","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=9962"},"modified":"2023-05-03T20:27:46","modified_gmt":"2023-05-03T20:27:46","slug":"ipt-engagement-series-a-multidisciplinary-approach-to-intimate-partner-violence","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/ipt-engagement-series-a-multidisciplinary-approach-to-intimate-partner-violence/","title":{"rendered":"IPT Engagement Series: A Multidisciplinary Approach to Intimate Partner Violence"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":"","post-excerpt":"A new series to connect IPT (Interprofessional Team) clinicians and primary care providers working together in PCNs.","related_resources":[153],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/9962"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9962"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9962"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9962"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9961,"date":"2023-03-29T21:52:58","date_gmt":"2023-03-29T21:52:58","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=9961"},"modified":"2023-05-03T20:20:25","modified_gmt":"2023-05-03T20:20:25","slug":"ipt-engagement-series-a-multidisciplinary-approach-to-patients-with-low-socio-economic-status","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/ipt-engagement-series-a-multidisciplinary-approach-to-patients-with-low-socio-economic-status/","title":{"rendered":"IPT Engagement Series: A Multidisciplinary Approach to Patients with Low Socio-economic Status"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":"","post-excerpt":"A new series to connect IPT (Interprofessional Team) clinicians and primary care providers working together in PCNs.","related_resources":[153],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/9961"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9961"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9961"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9961"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9833,"date":"2023-03-21T22:00:21","date_gmt":"2023-03-21T22:00:21","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=9833"},"modified":"2023-04-26T22:44:30","modified_gmt":"2023-04-26T22:44:30","slug":"first-nations-community-longhouse-experiential-learning-session","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/first-nations-community-longhouse-experiential-learning-session/","title":{"rendered":"First Nations Community &#038; Longhouse Experiential Learning Session"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"A cultural experiential learning session for physicians held by JCCs, Musqueam First Nation and Len Pierre Consulting","related_resources":[],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/9833"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9833"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9833"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9833"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9822,"date":"2023-03-21T20:30:24","date_gmt":"2023-03-21T20:30:24","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=9822"},"modified":"2023-08-16T23:42:26","modified_gmt":"2023-08-16T23:42:26","slug":"bccsu-session-on-opioid-use-disorder-and-continuity-of-care-when-transitioning-between-settings-from-acute-care-to-community","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/bccsu-session-on-opioid-use-disorder-and-continuity-of-care-when-transitioning-between-settings-from-acute-care-to-community/","title":{"rendered":"BCCSU Session on Opioid Use Disorder and Continuity of Care"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"Session covers Opioid Use Disorder and Continuity of Care Transitioning Between Settings: From Acute Care to Community","related_resources":[119],"related_campaigns":[117],"related_events":[198]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/9822"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9822"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9822"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9822"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9819,"date":"2023-03-21T20:01:38","date_gmt":"2023-03-21T20:01:38","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=9819"},"modified":"2023-05-12T21:08:59","modified_gmt":"2023-05-12T21:08:59","slug":"22nd-annual-bc-endocrine-day","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/22nd-annual-bc-endocrine-day/","title":{"rendered":"22nd Annual BC Endocrine Day"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"The Endocrine Research Society is hosting an interactive case-based review of common endocrine problems.","related_resources":[],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/9819"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9819"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9819"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9819"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9696,"date":"2023-03-21T18:04:36","date_gmt":"2023-03-21T18:04:36","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=9696"},"modified":"2023-03-27T20:40:54","modified_gmt":"2023-03-27T20:40:54","slug":"ipt-engagement-series-a-multidisciplinary-approach-to-managing-obesity","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/ipt-engagement-series-a-multidisciplinary-approach-to-managing-obesity/","title":{"rendered":"IPT Engagement Series: A Multidisciplinary Approach to Managing Obesity"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"Part of a new series to connect IPT (Interprofessional Team) clinicians and primary care providers working together in PCNs.","related_resources":[],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/9696"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9696"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9696"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9696"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9642,"date":"2023-03-08T16:53:42","date_gmt":"2023-03-08T16:53:42","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=9642"},"modified":"2023-04-14T22:23:21","modified_gmt":"2023-04-14T22:23:21","slug":"career-options-explorations","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/career-options-explorations/","title":{"rendered":"Career Options &#038; Explorations Event"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":"","post-excerpt":"Career Options and Explorations Event will help family physicians prepare for the many professional decisions they will face.","related_resources":[163,162,70],"related_campaigns":[185],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/9642"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9642"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/185"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/70"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/162"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9642"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9642"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10553,"date":"2023-03-07T16:15:59","date_gmt":"2023-03-07T16:15:59","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=10553"},"modified":"2023-08-16T17:33:15","modified_gmt":"2023-08-16T17:33:15","slug":"2023-physician-clinic-owners-forum-clinic-culture-hr","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/2023-physician-clinic-owners-forum-clinic-culture-hr/","title":{"rendered":"2023 Physician Clinic Owners Forum &#8211; Clinic Culture &#038; HR"},"featured_media":0,"comment_status":"closed","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":2271,"post-excerpt":"Register for the 2023 Physician Clinic Owners Forum by no later than Friday, June 16th.\r\n\r\n","related_resources":[186,190,163],"related_campaigns":[],"related_events":[205]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/10553"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=10553"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/205"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/190"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/186"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10553"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=10553"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9293,"date":"2023-02-23T19:29:24","date_gmt":"2023-02-23T19:29:24","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=9293"},"modified":"2023-04-18T20:04:26","modified_gmt":"2023-04-18T20:04:26","slug":"ipt-engagement-series-a-multidisciplinary-approach-to-managing-pain","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/ipt-engagement-series-a-multidisciplinary-approach-to-managing-pain/","title":{"rendered":"IPT Engagement Series: A Multidisciplinary Approach to Managing Pain"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[],"acf":{"post-icon":"","post-excerpt":"Part of a new series to connect IPT (Interprofessional Team) clinicians and primary care providers working together in PCNs.","related_resources":[153],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/9293"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=9293"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9293"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=9293"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8599,"date":"2023-01-13T22:43:25","date_gmt":"2023-01-13T22:43:25","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=8599"},"modified":"2023-04-18T20:10:10","modified_gmt":"2023-04-18T20:10:10","slug":"a-multidisciplinary-approach-to-managing-anxiety","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/a-multidisciplinary-approach-to-managing-anxiety/","title":{"rendered":"IPT Engagement Series: A Multidisciplinary Approach to Managing Anxiety"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[205],"acf":{"post-icon":2271,"post-excerpt":"Part of a new series to connect IPT (Interprofessional Team) clinicians and primary care providers working together in PCNs.","related_resources":[153],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/8599"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8599"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8599"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=8599"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8349,"date":"2022-12-12T16:47:51","date_gmt":"2022-12-12T16:47:51","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=8349"},"modified":"2023-01-25T18:31:19","modified_gmt":"2023-01-25T18:31:19","slug":"clinical-management-of-alcohol-use-disorder-workshop","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/clinical-management-of-alcohol-use-disorder-workshop/","title":{"rendered":"Clinical Management of Alcohol Use Disorder Workshop"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[173,198,172],"acf":{"post-icon":2271,"post-excerpt":"Need support for clinical management of alcohol use disorder? Join Dr. Olivia Brooks for a CME-accredited workshop.","related_resources":[119,195],"related_campaigns":[165,117],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/8349"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8349"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/195"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8349"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=8349"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8039,"date":"2022-11-22T22:43:05","date_gmt":"2022-11-22T22:43:05","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=8039"},"modified":"2022-11-22T22:43:05","modified_gmt":"2022-11-22T22:43:05","slug":"58th-annual-family-practice-review","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/58th-annual-family-practice-review/","title":{"rendered":"58th Annual Family Practice Review"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[178],"acf":{"post-icon":2271,"post-excerpt":"Join Drs Marnie Wilson and Emily G. McDonald on December 14 at 12 pm for a Best Evidence Webinar. ","related_resources":[180,119],"related_campaigns":[165],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/8039"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8039"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8039"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=8039"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8037,"date":"2022-11-22T22:25:33","date_gmt":"2022-11-22T22:25:33","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=8037"},"modified":"2022-11-22T22:36:41","modified_gmt":"2022-11-22T22:36:41","slug":"best-evidence-webinar-drug-drug-interactions-in-older-adults-with-polypharmacy-prescribed-nirmatrelvir-ritonavir","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/best-evidence-webinar-drug-drug-interactions-in-older-adults-with-polypharmacy-prescribed-nirmatrelvir-ritonavir/","title":{"rendered":"Best Evidence Webinar: Drug-drug interactions in older adults with polypharmacy prescribed nirmatrelvir-ritonavir"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[178],"acf":{"post-icon":2271,"post-excerpt":"Join Drs Marnie Wilson and Emily G. McDonald on December 14 at 12 pm for a Best Evidence Webinar. ","related_resources":[180,119],"related_campaigns":[165],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/8037"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=8037"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8037"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=8037"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7621,"date":"2022-11-09T00:48:49","date_gmt":"2022-11-09T00:48:49","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=7621"},"modified":"2022-11-09T00:48:49","modified_gmt":"2022-11-09T00:48:49","slug":"best-evidence-webinar-climate-conscious-inhaler-prescribing","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/best-evidence-webinar-climate-conscious-inhaler-prescribing/","title":{"rendered":"Best Evidence Webinar: Climate-Conscious Inhaler Prescribing"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[178],"acf":{"post-icon":2271,"post-excerpt":"Climate-Conscious Inhaler Prescribing: Tackling Climate Change, One Pen Stroke at a Time will take place November 16.","related_resources":[180,119],"related_campaigns":[165],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/7621"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=7621"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7621"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=7621"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7594,"date":"2022-11-08T01:45:46","date_gmt":"2022-11-08T01:45:46","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=7594"},"modified":"2022-11-08T01:49:37","modified_gmt":"2022-11-08T01:49:37","slug":"icon-virtual-chinese-health-forum","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/icon-virtual-chinese-health-forum/","title":{"rendered":"iCON Virtual Chinese Health Forum"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[178],"acf":{"post-icon":2271,"post-excerpt":"iCON Chinese Health Forum: “Take Charge of Your Health: Living Well Together with Diabetes” will take place November 19 & 20.","related_resources":[180,119],"related_campaigns":[165],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/7594"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=7594"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7594"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=7594"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6740,"date":"2022-10-06T22:01:07","date_gmt":"2022-10-06T22:01:07","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=6740"},"modified":"2022-10-13T16:50:39","modified_gmt":"2022-10-13T16:50:39","slug":"celebrating-indigenous-physicians-in-bc-cultural-safety-and-anti-racism-from-indigenous-physicians-perspectives","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/celebrating-indigenous-physicians-in-bc-cultural-safety-and-anti-racism-from-indigenous-physicians-perspectives/","title":{"rendered":"Celebrating Indigenous Physicians in BC: Cultural Safety and Anti-Racism"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[178],"acf":{"post-icon":2271,"post-excerpt":"Celebrate the 20th anniversary of the UBC Faculty of Medicine’s Indigenous Pathway program with this webinar.","related_resources":[180,119],"related_campaigns":[152,165],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/6740"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6740"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6740"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6740"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6739,"date":"2022-10-06T21:24:59","date_gmt":"2022-10-06T21:24:59","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=6739"},"modified":"2022-10-06T21:24:59","modified_gmt":"2022-10-06T21:24:59","slug":"fast-evidence-in-person-workshop","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/fast-evidence-in-person-workshop/","title":{"rendered":"FAST Evidence: In-Person Workshop"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[178],"acf":{"post-icon":2271,"post-excerpt":"Learn how to find accurate evidence-based medical information fast!","related_resources":[180,119],"related_campaigns":[152,165],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/6739"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6739"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6739"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6739"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6738,"date":"2022-10-06T21:18:48","date_gmt":"2022-10-06T21:18:48","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=6738"},"modified":"2022-10-13T16:52:39","modified_gmt":"2022-10-13T16:52:39","slug":"communication-course-navigating-challenging-conversations-across-the-system","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/communication-course-navigating-challenging-conversations-across-the-system/","title":{"rendered":"Communication: Navigating Challenging Conversations Across the System"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[178],"acf":{"post-icon":2271,"post-excerpt":"In this one-day workshop you will learn a simple four-stage framework to navigate difficult conversations.","related_resources":[180,119],"related_campaigns":[152,165],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/6738"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6738"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6738"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6738"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6259,"date":"2022-09-01T02:10:34","date_gmt":"2022-09-01T02:10:34","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=6259"},"modified":"2022-09-01T02:11:35","modified_gmt":"2022-09-01T02:11:35","slug":"68th-annual-st-pauls-family-medicine-conference","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/68th-annual-st-pauls-family-medicine-conference/","title":{"rendered":"68th Annual St. Paul’s Family Medicine Conference"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[178],"acf":{"post-icon":2271,"post-excerpt":"Register to attend virtually or in-person at the Vancouver Convention Centre (West).","related_resources":[125],"related_campaigns":[152],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/6259"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6259"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/125"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6259"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6259"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6258,"date":"2022-09-01T02:03:32","date_gmt":"2022-09-01T02:03:32","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=6258"},"modified":"2022-09-01T02:04:47","modified_gmt":"2022-09-01T02:04:47","slug":"considerations-for-alcohol-use-disorder-care-among-youth","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/considerations-for-alcohol-use-disorder-care-among-youth/","title":{"rendered":"Considerations for Alcohol Use Disorder Care Among Youth"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[176],"acf":{"post-icon":2271,"post-excerpt":"This session will include a didactic lecture, case presentation, and participant discussion.","related_resources":[71,170],"related_campaigns":[117],"related_events":[156]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/6258"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6258"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/170"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6258"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6258"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6025,"date":"2022-08-31T08:05:38","date_gmt":"2022-08-31T08:05:38","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=6025"},"modified":"2022-09-08T17:48:45","modified_gmt":"2022-09-08T17:48:45","slug":"membership-voting","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/membership-voting/","title":{"rendered":"Membership Voting"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[166],"acf":{"post-icon":2271,"post-excerpt":"The voting for the Vancouver Division of Family Practice Board of Directors will take place from October 6-20, online.","related_resources":[167],"related_campaigns":[179],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/6025"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6025"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6025"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6025"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5869,"date":"2022-08-31T08:00:11","date_gmt":"2022-08-31T08:00:11","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=5869"},"modified":"2023-07-13T15:54:49","modified_gmt":"2023-07-13T15:54:49","slug":"2022-agm","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/2022-agm/","title":{"rendered":"2022 Elections &#038; Annual General Meeting"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[166],"acf":{"post-icon":2271,"post-excerpt":"The 2022 Annual General Meeting (AGM) and the membership vote will be held Thursday October 27th.","related_resources":[167],"related_campaigns":[179],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/5869"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=5869"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5869"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=5869"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6072,"date":"2022-08-30T03:11:27","date_gmt":"2022-08-30T03:11:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=6072"},"modified":"2022-09-15T15:21:03","modified_gmt":"2022-09-15T15:21:03","slug":"healthy-minds-healthy-distractions-series","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/healthy-minds-healthy-distractions-series/","title":{"rendered":"Healthy Minds Healthy Distractions Series"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[172],"acf":{"post-icon":2271,"post-excerpt":"Join us for our Healthy Minds Healthy Distractions Series","related_resources":[129],"related_campaigns":[165],"related_events":[171]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/6072"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6072"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6072"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6072"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6070,"date":"2022-08-30T02:49:28","date_gmt":"2022-08-30T02:49:28","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=6070"},"modified":"2022-10-26T23:00:10","modified_gmt":"2022-10-26T23:00:10","slug":"coffee-with-colleagues","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/coffee-with-colleagues/","title":{"rendered":"Coffee with Colleagues"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[171],"acf":{"post-icon":2271,"post-excerpt":"An opportunity to learn from and connect with your colleagues.","related_resources":[153,129],"related_campaigns":[152,165],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/6070"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=6070"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6070"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=6070"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":4320,"date":"2022-07-07T16:29:17","date_gmt":"2022-07-07T16:29:17","guid":{"rendered":"https://van-division.yarko.dev/?post_type=event&#038;p=4320"},"modified":"2023-01-13T03:29:06","modified_gmt":"2023-01-13T03:29:06","slug":"primary-care-crisis","status":"publish","type":"event","link":"https://van-division.yarko.dev/event/primary-care-crisis/","title":{"rendered":"Summer Engagement Event"},"featured_media":0,"comment_status":"open","ping_status":"closed","template":"","event_topic":[156],"acf":{"post-icon":2271,"post-excerpt":"An event discussing the state of primary care and providing valuable updates for family physicians in Vancouver.","related_resources":[170],"related_campaigns":[79,91],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event/4320"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/event"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/event"}],"replies":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/comments?post=4320"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/170"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=4320"}],"wp:term":[{"taxonomy":"event_topic","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic?post=4320"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11129,"date":"2023-08-22T18:54:18","date_gmt":"2023-08-22T18:54:18","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=11129"},"modified":"2023-08-23T22:05:47","modified_gmt":"2023-08-23T22:05:47","slug":"how-to-choose-a-maternity-care-provider-pdf","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/how-to-choose-a-maternity-care-provider-pdf/","title":{"rendered":"How to Choose a Maternity Care Provider PDF"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":9438,"post-excerpt":"Patients can use this guide to find a maternity care provider","resource-introduction":"","resource-text":"Choosing a maternity care provider is an important personal decision to make as patients begin their pregnancy and parenting journey.\r\n\r\nThis PDF provides advice on choosing a maternity care provider. More information can be found at <a href=\"https://pregnancyvancouver.ca/home/#/\">PregnancyVancouver.ca</a>.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the PDF","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2023/08/How-to-Choose-a-Maternity-Care-Provider-Final.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[148],"related_campaigns":[91],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/11129"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11129"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=11129"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=11129"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=11129"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11113,"date":"2023-08-18T21:17:56","date_gmt":"2023-08-18T21:17:56","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=11113"},"modified":"2023-08-18T21:18:37","modified_gmt":"2023-08-18T21:18:37","slug":"doctors-of-bc-new-locum-registration-form","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/doctors-of-bc-new-locum-registration-form/","title":{"rendered":"Doctors of BC New Locum Registration Form"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":10158,"post-excerpt":"The new Doctors of BC LFP Locum registration form is ready","resource-introduction":"","resource-text":"<p data-pm-slice=\"1 1 []\">The new Doctors of BC LFP Locum registration form is ready to be completed as soon as possible by all physicians who are/will be billing under the LFP Payment Model for locum services.</p>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Locum Registration Form","resource-button_link":"https://www.doctorsofbc.ca/lfp/locum-registration-form","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/11113"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11113"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=11113"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=11113"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=11113"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":11042,"date":"2023-08-15T17:09:12","date_gmt":"2023-08-15T17:09:12","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=11042"},"modified":"2023-08-15T17:09:12","modified_gmt":"2023-08-15T17:09:12","slug":"2023-heatwave-advice","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/2023-heatwave-advice/","title":{"rendered":"2023 Heatwave Advice"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":9438,"post-excerpt":"Advice for Coping with Extreme Heat","resource-introduction":"","resource-text":"VCH have put together a collection of resources for coping with the current heatwave affecting Metro Vancouver.\r\n\r\nThese resources include a registration for MOSAIC's wellness checks for seniors who do not speak English or French, a guide on creating cooling spaces during hot weather, information on wildfire smoke etc.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":true,"resource-faq_header":"New VCH Heat Resources","resource-faq_accordion_content":[{"resource-acc-item-title":"Extreme Heat Resource List","resource-acc-item-content":"Access VCH's full list of heat resources <a href=\"https://www.vch.ca/en/extreme-heat\">here</a>. "},{"resource-acc-item-title":"2023 Heat Season Preparedness For Community Organizations","resource-acc-item-content":"Download this guide <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/08/2023-Heat-Season-Preparedness-and-Updates.pdf\">here</a>. "},{"resource-acc-item-title":"Creating Cooling Spaces During Hot Weather: Guidance for Community Organizations","resource-acc-item-content":"Download this guide <a href=\"https://www.vch.ca/en/media/19776\">here</a>. "},{"resource-acc-item-title":"BCCDC's Wildfire Fact Sheet","resource-acc-item-content":"Download this resource <a href=\"http://www.bccdc.ca/resource-gallery/Documents/Guidelines%20and%20Forms/Guidelines%20and%20Manuals/Health-Environment/BCCDC_WildFire_FactSheet_HotWeather.pdf\">here</a>. "},{"resource-acc-item-title":"MOSAIC Registration ","resource-acc-item-content":"MOSAIC is running heat wellness checks for seniors who do not speak English or French. Seniors\r\ncan opt-in or family, friends or organizations can refer them.\r\n\r\nRegister <a href=\"https://forms.office.com/pages/responsepage.aspx?id=oYLp8z13YUiPvD8CoJr6MKH-tf2pxt9MnhYRJqmYWzxUQUVWUEtDRlA1T0xSOFc3NUVYM0dJRFA5Sy4u6\">here</a>. "}],"related_resources":[],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/11042"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=11042"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=11042"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=11042"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=11042"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10891,"date":"2023-08-02T19:58:44","date_gmt":"2023-08-02T19:58:44","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10891"},"modified":"2023-08-02T21:16:23","modified_gmt":"2023-08-02T21:16:23","slug":"division-bylaws","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/division-bylaws/","title":{"rendered":"Division Bylaws"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":9438,"post-excerpt":"Official PDF copy of the Vancouver Division of Family Practice bylaws, updated in 2016 by the membership.","resource-introduction":"","resource-text":"This is a copy of the Vancouver Division of Family Practice bylaws, which were updated in 2016 as part of the overall update of the organization's constitution and bylaws to coincide with changes to the BC Societies Act.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"View the Division Bylaws","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2023/08/BC-Society-Act-Bylaw-2016.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[167],"related_campaigns":[179],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10891"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10891"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10891"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10891"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10891"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10890,"date":"2023-08-02T19:56:48","date_gmt":"2023-08-02T19:56:48","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10890"},"modified":"2023-08-02T21:18:30","modified_gmt":"2023-08-02T21:18:30","slug":"division-constitution","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/division-constitution/","title":{"rendered":"Division Constitution"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":9438,"post-excerpt":"Official PDF copy of the Vancouver Division of Family Practice constitution, updated in 2016 by the membership.","resource-introduction":"","resource-text":"This is a copy of the Vancouver Division of Family Practice constitution, which was updated in 2016 as part of the overall update of the organization's constitution and bylaws to coincide with changes to the BC Societies Act.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"View the Division Constitution","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2023/08/BC-Society-Act-Constitution-2016.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[167],"related_campaigns":[179],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10890"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10890"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10890"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10890"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10890"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10809,"date":"2023-07-10T23:56:22","date_gmt":"2023-07-10T23:56:22","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10809"},"modified":"2023-07-11T16:33:39","modified_gmt":"2023-07-11T16:33:39","slug":"checklist-pdfs-for-physicians-closing-or-transitioning-out-of-practice","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/checklist-pdfs-for-physicians-closing-or-transitioning-out-of-practice/","title":{"rendered":"PDF Checklists for Physicians Closing or Transitioning Out of Practice"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":10158,"post-excerpt":"Recruitment and Retention provide physicians two different resources depending on their situation","resource-introduction":"","resource-text":"As part of supporting physicians closing practice and transitioning out of their clinic, Vancouver Division's Recruitment and Retention give them two different resources depending on their situation.\r\n\r\nBelow are PDF Checklists for physicians to use in these situations:\r\n<ul>\r\n \t<li>Closing their Practice</li>\r\n \t<li>Practice Takeover</li>\r\n</ul>\r\nLog in to access.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":true,"resource-faq_header":"PDF Checklists","resource-faq_accordion_content":[{"resource-acc-item-title":"Checklist to Close","resource-acc-item-content":"Find the checklist <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/07/20230710-Checklist-to-Close-V2.pdf\">here</a>."},{"resource-acc-item-title":"Checklist for Practice Takeover","resource-acc-item-content":"Find the checklist <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/07/20230710-Practice-Takeover-v2.pdf\">here</a>"}],"related_resources":[72],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10809"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10809"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10809"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10809"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10809"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10629,"date":"2023-06-20T16:44:15","date_gmt":"2023-06-20T16:44:15","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10629"},"modified":"2023-06-27T22:13:14","modified_gmt":"2023-06-27T22:13:14","slug":"icon-intercultural-online-health-network-health-resources-for-the-chinese-and-south-asian-communities","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/icon-intercultural-online-health-network-health-resources-for-the-chinese-and-south-asian-communities/","title":{"rendered":"iCON &#8211; Health Resources for the Chinese and South Asian Communities"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":10158,"post-excerpt":"UBC’s iCON works to advance person- and family-centred care in B.C. through a community-driven approach.","resource-introduction":"","resource-text":"UBC’s InterCultural Online Health Network (iCON) works to advance person- and family-centred care in B.C. through a community-driven approach.\r\n\r\nThey do this by working with multicultural communities (Chinese and South Asian) to tailor health information in a way that empowers patients and family caregivers with the knowledge to better manage chronic diseases, navigate primary care and use digital tools to support their health.\r\n\r\niCON has provided <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/06/2023-03-02_iCON-poster-Chinese-EN-version.pdf\">Chinese</a> and <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/06/2023-03-08_iCON-poster-Punjabi-EN-version.pdf\">Punjabi</a>-language posters for doctors to share with patients and family caregivers .","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[195,71,73],"related_campaigns":[],"related_events":[173,176]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10629"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/173"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/73"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/195"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10629"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10629"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10629"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10629"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10605,"date":"2023-06-13T00:20:07","date_gmt":"2023-06-13T00:20:07","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10605"},"modified":"2023-08-01T18:02:05","modified_gmt":"2023-08-01T18:02:05","slug":"frailty-roadmap-for-families","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/frailty-roadmap-for-families/","title":{"rendered":"Frailty Roadmap for Families"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":10133,"post-excerpt":"A guide to help ensure safety, provide comfort, and improve the quality of life for you or your loved one","resource-introduction":"","resource-text":"This brochure is a basic roadmap of the territory, to help families orient themselves on the journey they are traveling, and see what’s coming farther along the road.\r\n\r\nThe frailty journey can be roughly divided into early, middle, and late stages, then end of life. This guide outlines the features of each stage, the signposts that tell you where you are on this road, and what may be coming up next. Included are questions that can help you clarify where you are, and suggestions about things we can do as a family and care team to give you or your loved one the best possible quality of life where they are right now","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Frailty Roadmap Here","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2023/06/Frailty-Roadmap-For-Families-Digital-_-Print.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[180,71],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10605"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10605"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10605"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10605"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10605"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10591,"date":"2023-06-12T18:29:46","date_gmt":"2023-06-12T18:29:46","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10591"},"modified":"2023-06-12T18:29:46","modified_gmt":"2023-06-12T18:29:46","slug":"vch-hip-or-knee-osteoarthritis-resource-collection","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/vch-hip-or-knee-osteoarthritis-resource-collection/","title":{"rendered":"VCH Hip or Knee Osteoarthritis Resource Collection"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":10133,"post-excerpt":"It is important to learn more about your osteoarthritis and take an active part in your treatment.","resource-introduction":"","resource-text":"Vancouver Coastal Health have put together a collection of resources on the management of Hip or Knee Osteoarthritis.\r\n<p data-pm-slice=\"1 1 []\">This resource provides advice on:</p>\r\n<p data-pm-slice=\"1 1 []\">This resource provides advice on:</p>\r\n\r\n<ul>\r\n \t<li data-pm-slice=\"1 1 []\">education,</li>\r\n \t<li data-pm-slice=\"1 1 []\">physical activity,</li>\r\n \t<li data-pm-slice=\"1 1 []\">pain management,</li>\r\n \t<li data-pm-slice=\"1 1 []\">healthy eating and weight loss,</li>\r\n \t<li data-pm-slice=\"1 1 []\">self care,</li>\r\n \t<li data-pm-slice=\"1 1 []\">social support</li>\r\n \t<li data-pm-slice=\"1 1 []\">and other services for patients with osteoarthritis.</li>\r\n</ul>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Resource here","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2023/06/OA-Hip-and-Knee-OA-FB.340.M36-1-2.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[180,71],"related_campaigns":[],"related_events":[176]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10591"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10591"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10591"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10591"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10591"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10291,"date":"2023-05-05T19:37:47","date_gmt":"2023-05-05T19:37:47","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10291"},"modified":"2023-05-05T19:37:47","modified_gmt":"2023-05-05T19:37:47","slug":"physician-health-program","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/physician-health-program/","title":{"rendered":"Physician Health Program"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":10158,"post-excerpt":"The PHP helpline for confidential, personalized assistance is open 24/7","resource-introduction":"","resource-text":"<p data-pm-slice=\"1 1 [&quot;list&quot;,{},&quot;list_item&quot;,{&quot;indent&quot;:1,&quot;type&quot;:&quot;bulleted&quot;}]\">Physician Health Program is a responsive, high quality care provider and community services navigator for physicians, trainees and their families. The PHP helpline for confidential, personalized assistance with issues such as mental health, relationship stress, career and life transitions, substance use and concern for colleague is open 24/7.</p>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Learn more here","resource-button_link":"https://www.physicianhealth.com/","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[129,119],"related_campaigns":[165,117],"related_events":[172,198]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10291"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10291"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10291"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10291"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10291"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10290,"date":"2023-05-05T19:28:46","date_gmt":"2023-05-05T19:28:46","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10290"},"modified":"2023-05-05T19:28:46","modified_gmt":"2023-05-05T19:28:46","slug":"get-attached-to-a-family-doctor","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/get-attached-to-a-family-doctor/","title":{"rendered":"Get Attached to a Family Doctor"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":10158,"post-excerpt":"Physician Health Program believes that all physicians should establish a relationship with a primary care provider","resource-introduction":"","resource-text":"<p data-pm-slice=\"1 1 [&quot;list&quot;,{},&quot;list_item&quot;,{&quot;indent&quot;:1,&quot;type&quot;:&quot;bulleted&quot;}]\">The Physician Health Program (PHP) believes that all physicians should establish a long-term, trusting relationship with a primary care provider (PCP). Complete the form through this link to be matched with a PCP.</p>\r\n<p data-pm-slice=\"1 1 [&quot;list&quot;,{},&quot;list_item&quot;,{&quot;indent&quot;:1,&quot;type&quot;:&quot;bulleted&quot;}]\">PCPs can be in short supply. Given the constraints, there are program policies that can be found through the link below.</p>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Access the Form Here","resource-button_link":"https://www.physicianhealth.com/gp/d4d/","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[129,119],"related_campaigns":[165,117],"related_events":[172,198]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10290"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10290"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10290"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10290"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10290"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10289,"date":"2023-05-05T19:09:33","date_gmt":"2023-05-05T19:09:33","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10289"},"modified":"2023-05-05T19:09:33","modified_gmt":"2023-05-05T19:09:33","slug":"cma-wellness-hub","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/cma-wellness-hub/","title":{"rendered":"CMA Wellness Hub"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":10158,"post-excerpt":"The CMA Wellness Hub provides reliable wellness tools and resources to empower physicians","resource-introduction":"","resource-text":"The 2017 CMA National Physician Health Survey found that the stigma associated with mental health issues remains a relevant barrier to accessing physician health program services.\r\n<p data-pm-slice=\"1 1 [&quot;list&quot;,{},&quot;list_item&quot;,{&quot;indent&quot;:1,&quot;type&quot;:&quot;bulleted&quot;}]\">The CMA Wellness Hub provides reliable wellness tools and resources to empower physicians, medical learners, leaders and educators to create change in the culture of medicine through a multi-pronged approach.</p>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"View this Resource ","resource-button_link":"https://www.cma.ca/physician-wellness-hub","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[129,119],"related_campaigns":[117,165],"related_events":[172,198]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10289"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10289"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10289"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10289"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10289"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10256,"date":"2023-05-02T15:19:29","date_gmt":"2023-05-02T15:19:29","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10256"},"modified":"2023-05-03T22:48:33","modified_gmt":"2023-05-03T22:48:33","slug":"access-for-ct-scans-in-the-lower-mainland","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/access-for-ct-scans-in-the-lower-mainland/","title":{"rendered":"Access for CT Scans in the Lower Mainland"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":9438,"post-excerpt":"Non-urgent outpatients wait times for CT services in the Lower Mainland are above wait time bench marks and increasing. ","resource-introduction":"","resource-text":"There continues to be significant demand for Computed Tomography (CT) services across all Lower Mainland Medical Imaging (LMMI) sites. LMMI continues to see increased demand for inpatient and emergency imaging which is affecting our ability to perform non-urgent outpatient exams. While wait times for urgent outpatients continue to remain stable, LMMI sites are receiving more requisitions than they are able to complete.\r\n\r\nTo improve patient access, CT requisitions may be sent to other surrounding sites with shorter outpatient wait lists. Redistributed patients are slotted into queues at t he new sit e based on the original requisition received date.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Guide Here","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2023/05/KYI_MI_Access-for-CT-Scans-LMMI-April-2023.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[180,71],"related_campaigns":[],"related_events":[176]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10256"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10256"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10256"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10256"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10256"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10188,"date":"2023-04-26T23:15:56","date_gmt":"2023-04-26T23:15:56","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10188"},"modified":"2023-08-01T17:54:27","modified_gmt":"2023-08-01T17:54:27","slug":"honouring-our-babies-safer-sleep-toolkit","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/honouring-our-babies-safer-sleep-toolkit/","title":{"rendered":"Honouring Our Babies Safer Sleep Toolkit"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"Honouring Our Babies Safer Sleep Toolkit: Facilitator Guide and Cards 3rd Edition 2023","resource-introduction":"","resource-text":"Perinatal Services BC have put together the Honouring Our Babies Safer Sleep Toolkit: Facilitator Guide and Cards 3<sup>rd</sup> Edition 2023, including important information and recommendations on how to facilitate conversations with Indigenous parents/caregivers on safer sleep options. It encourages informed shared decision making on safer sleep with a focus on the strengths of Indigenous knowledge, cultural values and practices using a two-eyed seeing approach.\r\n\r\nThe refreshed toolkit has a number of updates and key alignments:\r\n<ul>\r\n \t<li>It was informed by Indigenous family members, Elders, and a variety of health-care providers including midwives, registered nurses, birth workers and Doulas.</li>\r\n \t<li>It is an update from the Honouring Our Babies: Safe Sleep Cards: Facilitator Guide 2017.</li>\r\n \t<li>It aligns with <em>PSBC's Safer Infant Sleep</em> resource, which was updated in 2022.</li>\r\n \t<li>It aligns with best practice recommendations and current clinical guidelines.</li>\r\n \t<li>It provides key messages for infants at increased risk of sleep-related infant death.</li>\r\n \t<li>It consists of 21 illustrated cards, four of which have been newly developed, and a facilitator's guide.</li>\r\n</ul>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Find the toolkit here","resource-button_link":"http://www.perinatalservicesbc.ca/health-professionals/professional-resources/indigenous-resources/safe-sleep-toolkit","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[148],"related_campaigns":[91],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10188"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10188"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10188"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10188"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10188"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10177,"date":"2023-04-25T16:55:13","date_gmt":"2023-04-25T16:55:13","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10177"},"modified":"2023-08-01T17:57:38","modified_gmt":"2023-08-01T17:57:38","slug":"accessing-a-telephone-interpreter","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/accessing-a-telephone-interpreter/","title":{"rendered":"Accessing a Telephone Interpreter"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":9438,"post-excerpt":"How to access telephone interpreters for your patients","resource-introduction":"","resource-text":"The Provincial Language Service (a <a href=\"http://www.phsa.ca/interpreting\" target=\"_blank\" rel=\"noopener\">service of the Provincial Health Services Authority</a>) can provide interpreting services to any BC primary health care provider and can be accessed over the phone on demand within minutes.\r\n\r\nBC Providers who use telephone interpreting in their offices report it to be timely, helpful and reasonable to use, even on a busy day. Professional interpreters (for more than 200 languages) convey a message's content, meaning and ton, which can improve clinical outcomes and help to reduce errors. Patient and family satisfaction with care can increase, as a professional interpreter can allow them to focus solely on understand their illness or to support a loved one.\r\n\r\nProfessional interpreters abide by confidentiality standards and help meet Personal Information Protection Act (PIPA) standards.\r\n\r\nVancouver Division members and primary care providers within Vancouver PCNs can access this services free-of-charge using the access code provided.\r\n\r\nLogin to access the code and access information.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the PDF","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2023/04/NewPoster_TelephoneInterpreting_April2018-1.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[71,195],"related_campaigns":[],"related_events":[176,173]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10177"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/173"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/176"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/195"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/71"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10177"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10177"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10177"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10177"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10099,"date":"2023-04-20T00:03:36","date_gmt":"2023-04-20T00:03:36","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10099"},"modified":"2023-04-28T22:55:58","modified_gmt":"2023-04-28T22:55:58","slug":"vsb-student-health-information-sharing-form","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/vsb-student-health-information-sharing-form/","title":{"rendered":"VSB Student Health Information Sharing Form"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"Vancouver School Board and Vancouver Division fillable Student Health Information Sharing Form","resource-introduction":"","resource-text":"The Vancouver Division and the Vancouver School Board (VSB) brought together 20 family physicians (FPs) and 20 VSB staff to identify challenges in sharing the right information between each other. Key lesson from the discussion was that often information is shared that inadvertently creates barriers to provide timely and appropriate feedback and perspective.\r\n\r\nThe result the creation of following fillable forms that lay out the key information that either primary care providers or school staff specifically find most helpful. The first is for FPs to use and the second is for VSB staff.\r\n<ul>\r\n \t<li><strong>From Primary Care Providers to School Staff -</strong> This 2-page fillable form is a communication tool for primary care providers to share student information with the student’s school staff. The categories in the form identify key information that the school staff are interested in learning about the student. Download the fillable PDF for <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/04/cymhsu-doc.-physician-to-vsb-staff-v6.pdf\">here.</a></li>\r\n \t<li><strong><strong>From School Staff to Primary Care Providers - </strong></strong>If you are working with a school teacher, counsellor, or any school staff, you can share this form with them for any young patient you have. VSB staff can use this form to share relevant information to a student's family physician that they have concerns or questions about the student’s behaviour. Download the fillable PDF form <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/04/cymhsu-doc.-vsb-staff-to-physician-v6.pdf\">here</a>.</li>\r\n</ul>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"","resource-faq_accordion_content":null,"related_resources":[119],"related_campaigns":[117],"related_events":[198]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10099"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10099"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10099"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10099"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10099"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10279,"date":"2023-04-19T18:52:44","date_gmt":"2023-04-19T18:52:44","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10279"},"modified":"2023-05-03T19:02:34","modified_gmt":"2023-05-03T19:02:34","slug":"fast-facts-april-19-2023","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-april-19-2023/","title":{"rendered":"Fast Facts &#8211; April 19, 2023"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/20230125-fast-facts-9574281","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[129,74,174],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10279"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10279"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10279"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10279"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10279"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10092,"date":"2023-04-18T17:51:13","date_gmt":"2023-04-18T17:51:13","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10092"},"modified":"2023-05-11T21:39:58","modified_gmt":"2023-05-11T21:39:58","slug":"dementia-resource-collection","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/dementia-resource-collection/","title":{"rendered":"Dementia Resource Collection"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":9438,"post-excerpt":"The purpose of the tool is to assist FPs in managing their patients' dementia journey and to provide resources","resource-introduction":"","resource-text":"Through this Shared Care project, patients, caregivers, and HCPs created a Coordinating Dementia Tool and Dementia Companion Handbook. The purpose of the tool is to assist FPs in managing their patients' dementia journey and to provide resources, referrals and associated billing codes in appointment-size pieces.\r\n\r\n&nbsp;\r\n\r\nIf you would like hard copies of the handbook for your patients, please contact <a href=\"mailto:mdefer@providencehealth.bc.ca\">Miranda</a> for info.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":true,"resource-faq_header":"Coordinating Dementia Tool and The Dementia Companion Handbook","resource-faq_accordion_content":[{"resource-acc-item-title":"The Dementia Companion Handbook","resource-acc-item-content":"Download your Dementia Companion Book <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/04/Dementia-Companion-Handbook_online.pdf\">here</a>. "},{"resource-acc-item-title":"Coordinating Dementia Tool ","resource-acc-item-content":"Download the fillable physician tool <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/04/Dementia-Companion-Handbook_online.pdf\">here</a>."}],"related_resources":[119,180],"related_campaigns":[],"related_events":[198]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10092"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10092"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10092"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10092"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10092"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":10278,"date":"2023-04-05T18:43:53","date_gmt":"2023-04-05T18:43:53","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=10278"},"modified":"2023-05-03T18:54:44","modified_gmt":"2023-05-03T18:54:44","slug":"fast-facts-april-5-2023","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-april-5-2023/","title":{"rendered":"Fast Facts &#8211; April 5, 2023"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/20230125-fast-facts-9571381","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[129,74,174],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/10278"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=10278"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=10278"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=10278"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=10278"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9874,"date":"2023-03-22T23:09:59","date_gmt":"2023-03-22T23:09:59","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=9874"},"modified":"2023-08-01T18:13:36","modified_gmt":"2023-08-01T18:13:36","slug":"fast-facts-march-22-2023","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-march-22-2023/","title":{"rendered":"Fast Facts &#8211; March 22, 2023"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/20230125-fast-facts-9568141","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/9874"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9874"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9874"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9874"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9874"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9853,"date":"2023-03-21T23:33:27","date_gmt":"2023-03-21T23:33:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=9853"},"modified":"2023-08-01T18:16:35","modified_gmt":"2023-08-01T18:16:35","slug":"intentionality-starts-with-compassion-dr-derek-chang","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/intentionality-starts-with-compassion-dr-derek-chang/","title":{"rendered":"Intentionality Starts with Compassion &#8211; Dr. Derek Chang"},"featured_media":0,"template":"","resource_type":[195],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"Dr. Derek Chang outlines how intentionality and compassion are key for JEDI","resource-introduction":"Dr. Derek Chang outlines how intentionality and compassion are key for JEDI","resource-text":"<div class=\"page\" data-page-number=\"1\" data-loaded=\"true\">\r\n<div><img class=\"alignnone size-medium wp-image-9855\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/03/DC_photo_copy-300x300.jpg\" alt=\"\" width=\"300\" height=\"300\" /></div>\r\n<div></div>\r\n<div></div>\r\n<div class=\"textLayer\">\r\n\r\n<span style=\"font-weight: 400;\">As family physicians, we have been experiencing enormous pressure; the pandemic and multiple crises have added even more weight to our shoulders. We are doing our best to meet our patients’ needs with limited resources and constrained systems. In recent years, the discussion around Justice, Equity, Diversity, and Inclusion (JEDI) has been front and centre in our society, particularly in healthcare. The In Plain Sight report is a prominent example. I recognize the importance of JEDI and its beneficial and critical role for our patients and our profession. However, with so many competing priorities, my bandwidth often becomes limited.</span>\r\n\r\n<span style=\"font-weight: 400;\">In </span><i><span style=\"font-weight: 400;\">Thinking, Fast and Slow</span></i><span style=\"font-weight: 400;\">, Daniel Kahneman described two modes of thinking: system 1 is fast and automatic, while system 2 is slow and deliberate. It’s not that one system is better than the other; the two systems complement each other and are both crucial for our survival as human beings.</span>\r\n\r\n<span style=\"font-weight: 400;\">When stressed or tired, our system 1 kicks in more readily. We operate in a fast and automatic mode where our unconscious biases can dominate how we think and what we do. I’ve noticed that in my clinical practice and daily life: when my bandwidth decreases, I tend to make up stories or jump to conclusions based on my assumptions or biases.</span>\r\n\r\n<span style=\"font-weight: 400;\">I’ve been thinking about how to foreground system 2 in my thoughts and actions—How can I be more intentional in how I think and what I do? I haven’t quite figured out how to navigate this tension effectively, but one surprising tool I found helpful is practicing compassion.</span>\r\n\r\n<span style=\"font-weight: 400;\">As I was reading more about compassion, I came across the teaching by Joan Halifax, a Zen Buddhist teacher, anthropologist, ecologist, civil rights activist, hospice caregiver, and author. In her book Standing at the Edge, she wrote, “Compassion is defined as feeling genuine concern about the suffering of another and desiring to improve that one’s welfare. Compassion also helps us meet our own suffering, and that of others, with an appropriate response.”</span>\r\n\r\n<span style=\"font-weight: 400;\">Compassion is a complex and messy concept, and I don’t want to pretend I’ve fully grasped it. However, I do find the practice of compassion helps me slow down and be more intentional in my thoughts and actions. Compassion reminds me to recognize when my bandwidth is becoming limited and pay attention to my needs. Compassion also motivates me to meet the suffering of others and improve their welfare, which includes the work of JEDI.</span>\r\n\r\n<span style=\"font-weight: 400;\">For me, intentionality is key for JEDI, and it starts with compassion. I want to end with the wisdom of Joan Halifax, which I use as the background on my phone screen to remind myself to practice compassion:</span>\r\n\r\n<i><span style=\"font-weight: 400;\">May I offer my care and presence unconditionally, knowing that it may be met by gratitude, indifference, anger, or anguish.</span></i>\r\n\r\n<i><span style=\"font-weight: 400;\">May I offer love, knowing that Icannot control the course of life, suffering, or death.</span></i>\r\n\r\n<i><span style=\"font-weight: 400;\">May I find the inner resources to truly be able to give.</span></i>\r\n\r\n<i><span style=\"font-weight: 400;\">May I be peaceful and let go of expectations.</span></i>\r\n\r\n<i><span style=\"font-weight: 400;\">May I accept things as they are.</span></i>\r\n\r\n<i><span style=\"font-weight: 400;\">May I see my limits compassionately, just as I view the suffering of others.</span></i>\r\n\r\n&nbsp;\r\n\r\n<span style=\"font-weight: 400;\">References:</span>\r\n\r\n<a href=\"https://engage.gov.bc.ca/app/uploads/sites/613/2020/11/In-Plain-Sight-Summary-Report.pdf\"><span style=\"font-weight: 400;\">https://engage.gov.bc.ca/app/uploads/sites/613/2020/11/In-Plain-Sight-Summary-Report.pdf</span></a>\r\n\r\n<span style=\"font-weight: 400;\">Kahneman, D. (2012). Thinking, fast and slow. Penguin Books.</span>\r\n\r\n<span style=\"font-weight: 400;\">Halifax, J. (2018). </span><i><span style=\"font-weight: 400;\">Standing at the edge: Finding freedom where fear and courage meet</span></i><span style=\"font-weight: 400;\"> (First edition). Flatiron Books.</span>\r\n\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[195],"related_campaigns":[],"related_events":[173]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/9853"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/173"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/195"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9853"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9853"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9853"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9853"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9824,"date":"2023-03-21T23:04:50","date_gmt":"2023-03-21T23:04:50","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=9824"},"modified":"2023-03-21T23:04:50","modified_gmt":"2023-03-21T23:04:50","slug":"vancouver-clinics-seeing-benefits-of-colocated-pharmacists","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/vancouver-clinics-seeing-benefits-of-colocated-pharmacists/","title":{"rendered":"Vancouver Clinics Seeing Benefits of Colocated Pharmacists"},"featured_media":9826,"template":"","resource_type":[],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"Read about one pharmacist's experience with colocation to clinics in Vancouver","resource-introduction":"Read about one pharmacist's experience with colocation to clinics in Vancouver","resource-text":"<img class=\"alignnone wp-image-9825\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/03/217a5395_52342984522_o-300x200.jpg\" alt=\"\" width=\"371\" height=\"247\" />\r\n\r\n<span style=\"font-weight: 400;\">Clinics in Vancouver are beginning to take advantage of a program that allows utilization of the services of clinical pharmacists in their clinic on a rotational basis</span><span style=\"font-weight: 400;\">. Allied health resources have been centralized in the Interprofessional Team (IPT) structure, and pharmacists can also be colocated within clinics, if requested. The result has been a win-win scenario, welcomed by both doctors and patients. </span>\r\n<h2><b>How the Colocation Program Works </b></h2>\r\n<span style=\"font-weight: 400;\">Clinics with the necessary space can have the pharmacists within their physical clinic, while those who can’t accommodate this arrangement are still able to participate. </span>\r\n\r\n<span style=\"font-weight: 400;\">“You can colocate virtually,” explains Saori Yamamoto, CNM for PCN 3 of the Vancouver Division. “Your pharmacist would be at a different location, but their time would be dedicated to you.” </span>\r\n\r\n<span style=\"font-weight: 400;\">In addition to facilitating the colocation, the program provides assistance with overhead, orientation and training. </span>\r\n<h2><b>Family Doctors are Extremely Busy</b></h2>\r\n<span style=\"font-weight: 400;\">Ruby Sangha has been a pharmacist for 26 years, spending most of that time doing clinical work at VGH. She transferred to primary care about a year ago, and has spent each Wednesday since December working at Fraser Street Medical. She believes that the program provides value to clinics. </span>\r\n\r\n<span style=\"font-weight: 400;\">“Family doctors are extremely busy and there’s not always enough time in the day to tackle some of the issues that patients are bringing up,” says Sangha. “We can answer some of those questions, we can do the lit search.” </span>\r\n\r\n<span style=\"font-weight: 400;\">Sangha’s hospital work has prepared her for any challenges that may arise. </span>\r\n\r\n<span style=\"font-weight: 400;\">“I can do this,” she says. “I’ve done it for 19 years.”</span><span style=\"font-weight: 400;\"> </span>\r\n<h2><b>A Day in the Life of a Colocated Clinical Pharmacist  </b></h2>\r\n<span style=\"font-weight: 400;\">Sangha says that on a typical day at Fraser Street Medical she’ll see five or six patients. </span>\r\n\r\n<span style=\"font-weight: 400;\">“Initial appointments are usually around an hour, with pre-emptive work being done beforehand,” she says.</span>\r\n\r\n<span style=\"font-weight: 400;\">Accessing Care Connect, PharmaNet and, if possible, the office EMR helps the clinical pharmacist understand the patient’s medical history. </span>\r\n\r\n<span style=\"font-weight: 400;\">“I’ll meet with the patient, interview them, discuss their needs, and get their perspective,” says Sangha. “I’ll attempt to determine if there is room for improvement in terms of medication optimization and then present that information to the doctor.” </span>\r\n\r\n<span style=\"font-weight: 400;\">Sangha observes that some patients are discharged from hospital without truly understanding why their medications have changed. In such cases, she thinks that one on one time with pharmacists provides true value. </span>\r\n\r\n<span style=\"font-weight: 400;\">“One of the benefits is being able to go over some of those things with the patients,” she says. “I do a bit more digging in order to figure out the whys and hows.” </span>\r\n\r\n<span style=\"font-weight: 400;\">Yamamoto also sees benefits for the patient. </span>\r\n\r\n<span style=\"font-weight: 400;\">“Perhaps they can’t afford their medication,” she says. “The clinical pharmacists don’t dispense the medication, but they can suggest options that the patient could then discuss with their doctor. Sometimes these options are more affordable or have less side effects.” </span>\r\n<h2><b>Utilizing a Shared Decision Model </b></h2>\r\n<span style=\"font-weight: 400;\">Sangha believes in incorporating patients’ thoughts on the medication they receive. </span>\r\n\r\n<span style=\"font-weight: 400;\">“They’re at the forefront of primary care,” she says. “We need the patient to buy into those decisions, it can’t be a one-sided thing.” </span>\r\n\r\n<span style=\"font-weight: 400;\">She’s found patients to be grateful for the additional time and care, and speaks of a particular patient that she recently worked with. </span>\r\n\r\n<span style=\"font-weight: 400;\">“A patient of mine had a procedure that was done not too long ago that created some complications in her life,” she recalls. “I found there was a level of mistrust before I jumped into the picture. I was able to recognize that there was a need to go slow and build a relationship.” </span>\r\n\r\n<span style=\"font-weight: 400;\">Yamamoto agrees. “It’s patient-centered care,” she says. “It empowers patients to have a choice.”  </span>\r\n<h2><b>Ability to Mold the Program </b></h2>\r\n<span style=\"font-weight: 400;\">Sangha enjoyed the team-based model employed during her years at the hospital, and is pleased to see this dynamic at play within primary care. She’s also grateful to be in a position where she can utilize her experience to help shape an evolving system.</span>\r\n\r\n<span style=\"font-weight: 400;\">“After 19 years with the hospital, I felt like a primary care network position was an opportunity to use my experience to help mold this program,” she says. “The pharmacy program is being led by UBC in conjunction with Fraser Health, so there is structure on hand already, but I think our experience comes into play on some of the smaller aspects of the role.”</span><span style=\"font-weight: 400;\"> </span>\r\n\r\n<span style=\"font-weight: 400;\">Sangha says that things have been picking up of late and is excited for the trend to continue. </span>\r\n\r\n<span style=\"font-weight: 400;\">“There are currently six pharmacists within the Vancouver primary care network, and all of us come with strong experience,” she says. “The more exposure we get within doctors’ offices, the more we can showcase what we’re able to do. I think our range of experience and perspectives allow us to open doors and make a difference by getting more involved in patient care.” </span>\r\n\r\n&nbsp;\r\n\r\n<b>Cited Sources</b><b> </b>\r\n\r\n<b>Direct communication with Saori Yamamoto and Ruby Sangha</b>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[153],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/9824"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"}],"wp:featuredmedia":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/media/9826"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9824"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9824"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9824"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9824"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9674,"date":"2023-03-21T21:35:40","date_gmt":"2023-03-21T21:35:40","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=9674"},"modified":"2023-04-21T20:26:24","modified_gmt":"2023-04-21T20:26:24","slug":"medical-office-assistant-moa-job-posting-form","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/medical-office-assistant-moa-job-posting-form/","title":{"rendered":"Medical Office Assistant (MOA) Job Posting Form"},"featured_media":0,"template":"","resource_type":[190],"resource_cat":[],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"This form is intended for use by clinics and family physicians who are seeking to recruit clinic staff.","resource-introduction":"","resource-text":"<span style=\"font-weight: 400;\">The </span><i><span style=\"font-weight: 400;\">Medical Office Assistant (MOA) Job Posting Service </span></i><span style=\"font-weight: 400;\">has been developed to address the need for clinic office staff in family practice clinics in the city of Vancouver. This service allows clinics to recruit for different levels of office staff such as: Junior MOAs, Mid-Level MOAs, Senior MOAs, and Clinic Managers. This service was developed with a physician centered and clinic-led approach in mind as it allows clinics to gauge suitability of candidates on their own terms. </span>\r\n\r\nTo fill out this form, please login. For additional information regarding this service, please contact your regional Community Network Manager (CNM) <a href=\"https://van-division.yarko.dev/pcn-vancouver/\">here</a> or login to view more.\r\n\r\n<span style=\"font-weight: 400;\">Please note that the </span><i><span style=\"font-weight: 400;\">MOA Job Postings service</span></i><span style=\"font-weight: 400;\"> is distinct from the Family Physicians (FPs) and Nurse Practitioners (NPs) <a href=\"https://van-division.yarko.dev/recruitment-retention/\">recruitment programs</a>. </span>\r\n\r\n<span style=\"font-weight: 400;\">If you are an MOA seeking opportunities in Vancouver, please visit our </span><b><a href=\"https://van-division.yarko.dev/work-in-vancouver/\">Work in Vancouver</a> </b><span style=\"font-weight: 400;\">webpage and filter 'Job Title' for a list of current clinic staff opportunities.</span>\r\n\r\nView: <a href=\"http://van-division.yarko.dev/wp-content/uploads/2023/04/MOA-Program-4.pdf\" target=\"_blank\" rel=\"noopener\">MOA Job Posting Workflow - Physician/Clinic Perspective</a>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Complete Form Here","resource-button_link":"https://forms.gle/xWrcuEnNfZkdoGDLA","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163,190],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/9674"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/190"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9674"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9674"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9674"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9674"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9873,"date":"2023-03-03T23:07:43","date_gmt":"2023-03-03T23:07:43","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=9873"},"modified":"2023-08-01T18:22:27","modified_gmt":"2023-08-01T18:22:27","slug":"fast-facts-march-3-2023","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-march-3-2023/","title":{"rendered":"Fast Facts &#8211; March 3, 2023"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/20230125-fast-facts-9563009","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/9873"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9873"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9873"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9873"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9873"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9872,"date":"2023-02-22T23:05:38","date_gmt":"2023-02-22T23:05:38","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=9872"},"modified":"2023-08-01T18:22:59","modified_gmt":"2023-08-01T18:22:59","slug":"fast-facts-february-22-2023","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-february-22-2023/","title":{"rendered":"Fast Facts &#8211; February 22, 2023"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/20230125-fast-facts-9558217","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/9872"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9872"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9872"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9872"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9872"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9871,"date":"2023-02-08T23:03:52","date_gmt":"2023-02-08T23:03:52","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=9871"},"modified":"2023-08-01T18:25:22","modified_gmt":"2023-08-01T18:25:22","slug":"fast-facts-february-8-2023","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-february-8-2023/","title":{"rendered":"Fast Facts &#8211; February 8, 2023"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/20230125-fast-facts-9552361","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/9871"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9871"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9871"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9871"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9871"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8739,"date":"2023-02-08T02:06:30","date_gmt":"2023-02-08T02:06:30","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8739"},"modified":"2023-04-25T20:50:25","modified_gmt":"2023-04-25T20:50:25","slug":"patient-handout-on-benzodiazepines","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/patient-handout-on-benzodiazepines/","title":{"rendered":"Patient Handout on Benzodiazepines"},"featured_media":0,"template":"","resource_type":[199,124,119],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"Patient handout on using benzodiazepines.","resource-introduction":"","resource-text":"<div class=\"post_body_wrapper\">\r\n<div class=\"post-body-container\">\r\n<div class=\"post-body-renderer-component post_body\">\r\n<div class=\"post-body-content\">\r\n<div class=\"body_text redactor-styles redactor-in\">The Vancouver Community Action Team is one of many CATs around the province responding to the overdose crisis. Vancouver Division members have been engaged on this partner project since 2018. VCAT has recently created a \"Benzo Basics\" handout on using benzodiazepines, which you can share with patients.</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download Document","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2023/02/Benzo-basics-1.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[199],"related_campaigns":[],"related_events":[197]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8739"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/197"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/199"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8739"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8739"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8739"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8739"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8735,"date":"2023-02-08T01:37:20","date_gmt":"2023-02-08T01:37:20","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8735"},"modified":"2023-02-08T01:37:20","modified_gmt":"2023-02-08T01:37:20","slug":"vancouver-division-cbt-skills-group-address-mental-health","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/vancouver-division-cbt-skills-group-address-mental-health/","title":{"rendered":"Vancouver Division &#038; CBT Skills Group Address Mental Health"},"featured_media":8737,"template":"","resource_type":[118,119],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"The Division supports a program designed to take pressure off FPs managing their patients' mental health concerns.","resource-introduction":"The Division supports a program designed to take pressure off FPs managing their patients' mental health concerns.","resource-text":"<img class=\"aligncenter wp-image-8737 size-full\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/02/pexels-christina-morillo-1181712-1.jpg\" alt=\"\" width=\"1200\" height=\"800\" />\r\n\r\nWe know from talking to our members that mental health is top of mind for both doctors and members of the community alike. Tackling this problem will require significant resources which aren’t always available to family doctors. Many individuals experiencing health issues like depression or anxiety can fall through the cracks. To help, the Vancouver Division has been providing resources and partnership to the CBT Skills Group, an effective and exciting program designed to provide education and healing to patients who don’t qualify for medication or referral to psychiatry.\r\n\r\nAccording to <a href=\"https://van-division.yarko.dev/contact-us/\">Justin Ho</a>, Director of Membership Engagement and Collaboration at Vancouver Division, better support in this area is a priority.\r\n“Family doctors and other team members have told us that resources are needed,” says Ho. “With this in mind, Vancouver Division has been working with the CBT Skills Group to deliver solutions that provide value to doctors as well as patients.”\r\n<h3>What is the CBT Skills Group?</h3>\r\nThe Cognitive Behavioural Therapy Skills Group offers MSP-funded, online group therapy sessions to adults who are experiencing moderate depression, anxiety, or other lower-acuity mental health issues.\r\n\r\n“Mental health can be improved when patients are taught to recognize, understand, and manage patterns of feeling, thinking, and behaving,” explains Ho. “The CBT Skills Group facilitates learning while providing participants with valuable tools.”\r\n\r\nThe program was designed by psychiatrists and is taught by physicians, integrating neuroscience, mindfulness, and cognitive behavioural therapy skills and concepts.\r\n\r\n“Vancouver Division is supporting this initiative by providing resources and expertise which assist in strategic development and marketing,” says Ho. “We’re listening to our doctors and providing help where it’s needed.”\r\n<h3>Doctor Sees Benefits of Program</h3>\r\nOne doctor who sees the value of the initiative is Dr. Christine Singh. “The process really works well,” she says. “For patients with mental health concerns, these skills are so important.”\r\nSingh has been impressed with the way the program has been conceived and run.\r\n“I believe that it’s rooted in altruism,” she says. “I’ve recently taken the course myself and I really appreciate the approach my colleagues have taken. They’re kind, compassionate, experienced, skilled, and enthusiastic. I really feel that it’s coming from a good place.”\r\n<h3>Group Setting Fosters Vital Connection</h3>\r\nAs Dr. Singh sees it, the group aspect of the program is a key component of its success.\r\n\r\n“Patients with mental health issues can feel very isolated,” she says. “They may have cognitive distortions where they believe that no one else shares their experience. When they get involved with a group, they realize that these thinking patterns are common. Suddenly they’re not alone.”\r\n\r\nThe program offers therapeutic value within the confines of a safe circle. Dr. Singh believes that connection and understanding are part of the healing process.\r\n\r\n“Mental health is often about disconnection and feeling outside,” she says. “I think this program allows people to realize that they can participate in other groups as well. It allows people to move on with a level of social skills that go beyond CBT.”\r\n<h3>Flexible, Accessible, and Responsive</h3>\r\nThe CBT Skills Group values accessibility, offering scheduling alternatives that meet as many people’s needs as possible. The course is currently available throughout British Columbia in an online format.\r\n\r\n“I think the virtual version is great,” says Dr. Singh. “It allows a lot of different people to gain access.”\r\n\r\nNot only is the program responsive to patients, but to practitioners as well. At the conclusion of the patient’s experience their doctor receives a feedback report, allowing them to stay current with the patient’s progress.\r\n<h3>Program a ‘Game Changer’</h3>\r\nVancouver Division’s partnership with CBT Skills Group is just another example of our ongoing efforts to address the needs and concerns voiced by our members.\r\n\r\n“It’s important to raise awareness about mental health and to offer resources that can be used to address the issue,” says Ho. “That’s exactly what our involvement with this initiative seeks to accomplish.”\r\n\r\nAccording to Dr. Singh, the program hits the mark.\r\n\r\n“As family doctors, we don’t always have enough time to really do this work ourselves,” she says. “I feel confident making referrals to this program. It’s a real game-changer for my practice and my patients.”\r\n\r\n<a href=\"https://van-division.yarko.dev/initiative/cbt-skills-group/\">Learn more about the CBT Skills Group.</a>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[118,119],"related_campaigns":[79],"related_events":[198,197]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8735"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/197"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/198"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"}],"wp:featuredmedia":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/media/8737"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8735"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8735"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8735"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8735"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9870,"date":"2023-01-25T22:59:25","date_gmt":"2023-01-25T22:59:25","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=9870"},"modified":"2023-08-01T18:29:19","modified_gmt":"2023-08-01T18:29:19","slug":"fast-facts-january-25-2023","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-january-25-2023/","title":{"rendered":"Fast Facts &#8211; January 25, 2023"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9546289","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/9870"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9870"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9870"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9870"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9870"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8660,"date":"2023-01-25T18:46:36","date_gmt":"2023-01-25T18:46:36","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8660"},"modified":"2023-02-07T23:51:30","modified_gmt":"2023-02-07T23:51:30","slug":"longitudinal-family-physician-payment-model","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/longitudinal-family-physician-payment-model/","title":{"rendered":"Longitudinal Family Physician Payment Model"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Details on the Longitudinal Family Physician Payment Schedule launching February 1, 2023. ","resource-introduction":"","resource-text":"Doctors of BC and BC Family Doctors shared the <a href=\"https://divisionsdispatch.cmail19.com/t/t-l-fjdukhl-jtkludlrkj-r/\" target=\"_blank\" rel=\"noopener\">Longitudinal Family Physician Payment Schedule</a> with physicians last week. We are further sharing to ensure physicians have access to the information they need to make an informed choice about enroling in the model, which launches February 1.\r\n\r\nSupports available:\r\n<ol>\r\n \t<li>The Physician <a href=\"https://divisionsdispatch.cmail19.com/t/t-l-fjdukhl-jtkludlrkj-y/\" target=\"_blank\" rel=\"noopener\">pathway to enroling</a> in the LFP Payment model walks doctors through the steps to take toward registration.</li>\r\n \t<li>FAQs are available on the <a href=\"https://divisionsdispatch.cmail19.com/t/t-l-fjdukhl-jtkludlrkj-j/\" target=\"_blank\" rel=\"noopener\">Doctors of BC</a> website and on the <a href=\"https://divisionsdispatch.cmail19.com/t/t-l-fjdukhl-jtkludlrkj-t/\" target=\"_blank\" rel=\"noopener\">BC Family Doctors</a> website. Both pages require member log-in.</li>\r\n \t<li>The BC Family Doctors website will soon feature detailed billing information, including a Billing Question Library and case examples. If physicians are not yet a member of BC Family Doctors, they can <a href=\"https://divisionsdispatch.cmail19.com/t/t-l-fjdukhl-jtkludlrkj-i/\" target=\"_blank\" rel=\"noopener\">join here.</a></li>\r\n \t<li>Information webinars: DoBC and BCFD hosted Webinars - the recordings can be <a href=\"https://www.youtube.com/watch?v=sOr0R5EDxqQ\">found here</a>.</li>\r\n</ol>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":true,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[155],"related_campaigns":[154],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8660"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/155"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8660"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8660"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8660"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8660"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8654,"date":"2023-01-25T04:45:07","date_gmt":"2023-01-25T04:45:07","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8654"},"modified":"2023-01-25T15:20:04","modified_gmt":"2023-01-25T15:20:04","slug":"for-the-care-point-davie-st-clinic-more-space-equals-more-service","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/for-the-care-point-davie-st-clinic-more-space-equals-more-service/","title":{"rendered":"For the Care Point Davie St. Clinic, More Space Equals More Service"},"featured_media":8656,"template":"","resource_type":[186,196,162,70],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"A Division grant helps Care Point digitize files, free space for new examination rooms and serve the community better.","resource-introduction":"A Vancouver Division grant helps Care Point Clinic digitize files, free space for new examination rooms and serve the community better.","resource-text":"<img class=\"aligncenter wp-image-8656 size-large\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/01/P1230170-1024x768.jpg\" alt=\"A taxi drives by the Care Point Clinic on Davie Street in Vancouver's West End Neighbourhood.\" width=\"1024\" height=\"768\" />\r\n\r\nRunning a successful community family practice clinic requires certain things, key among them is a proper amount of suitable patient space.\r\n\r\n“Two or three years ago we were in deep trouble,” admits Clinic Manager Aleks Dukic at the <a href=\"https://www.carepoint.ca/\" target=\"_blank\" rel=\"noopener\">Care Point Clinic</a> on Davie Street. “We didn’t have enough clinicians and the clinic was declining.”\r\n\r\nThese Vancouver Division grants are for PMH practice improvement and building primary care networks. Thanks in part to this, the clinic has been able to expand its usable patient space, in the process greatly enhancing the level of service they’re able to offer the community.\r\n<h3>Clinic Upgrade: From File Rooms to Exam Rooms</h3>\r\nThe clinic started with only three exam rooms, but in the past several years has quickly expanded to become a five, and now seven room facility.\r\n\r\n“To go from three exam rooms to seven in two or three years is huge,” says Dukic. As she explains, the expansion proved appealing not only to patients, but staff as well. “It’s helped us attract physicians as well as nurse practitioners.”\r\n\r\nThe most recent room expansion came about when the clinic opened two new exam rooms that had previously been dedicated to the storage of patient records. To make this possible, the clinic began digitizing their files, a major task that was kicked off with the Division grant.\r\n\r\n“We have five or six clinicians at the moment and nobody wants to work evenings,” says Dukic. “We had to adjust and try to make more space.”\r\n\r\n[caption id=\"attachment_8655\" align=\"alignright\" width=\"400\"]<img class=\"wp-image-8655 size-full\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/01/P1230167-e1674621318376.jpg\" alt=\"Clinic staff stand outside the Care Point Clinic on Davie Street in Vancouver's West End neighbourhood.\" width=\"400\" height=\"533\" /> Left to right: FP Dr. Catherine Allen-Ayodabo, FP Dr. Kelsie Nixon, Care Point COO Christine Lavelle Martin and Clinic Manager Aleks Dukic.[/caption]\r\n<h3>Managing Space Effectively</h3>\r\nWhat’s important when it comes to managing space within a clinic? According to Christine Lavelle-Martin, a good game plan goes a long way. “People have an image of a shiny, new clinic, but that’s not necessarily what’s needed,” says the Chief Operating Office of Care Point. “Instead, it’s the smart use of space.”\r\n\r\nFor her part, Dukic does the majority of her work while at the clinic and the rest at home if her office space is needed. “Everything is web-based, so it doesn’t always matter if I’m here or not,” she says.\r\n\r\nDukic explains how one physician made maximal use of her space. “Younger physicians don’t realize that, with support, they can work in just one room,” she says. “I used to have a doctor who would sit in one room and see over 40 patients in her six hour shift. She would then go back to the doctor’s room to complete her work.”\r\n<h3>Telemedicine Alleviates Pressure on Office Traffic</h3>\r\nPhysicians at the clinic utilize Telemedicine as well, a practice that has benefits for both the patients and the clinic itself.\r\n\r\n“If the need is something minor, such as a renewal or prescription, it’s not always necessary for patients to be physically present,” says Dukic. Using a single space with no need for exam equipment, a doctor can provide a patient with a video consultation, review their records, and send a prescription with the push of a button. “This prevents patients from having to take time off work,” she says.\r\n\r\nLess foot traffic also means less congestion at the facility. “You can see that my reception area is tiny, so when I have six clinicians working at a time, it can be tight,” says Dukic.\r\n<h3>Clinic Environment Good for New Graduates</h3>\r\nDukic believes that facilities such as the Care Point clinic on Davies Street are ideal for new graduates who may not want to immediately tackle the challenge of opening their own practice. “You don’t even need to bring a stethoscope,” she says, “that’s all on the company.”\r\n\r\nAdministrative headaches are handled by management and MOAs, enabling physicians to focus on medicine. “You spend however many hours you want to spend at the clinic, then go home,” she says.\r\n<h3>Healthy, Growing Clinic</h3>\r\nOperating in its expanded physical space, the Care Point clinic continues to thrive. “I have a doctor here who is taking new patients,” says Dukic.\r\n\r\nThis is sure to be welcome news to the West End and the future looks even brighter.\r\n\r\n“We’ve been newly purchased,” announces Lavelle-Martin, “and the intention of our new ownership team is to invest in the clinics, so more upgrades are coming.” The success of the clinic, and others like it, ripples far beyond the facilities’ walls. “We’re trying to help both community patients and our business,” explains Dukic.\r\n\r\n<span style=\"font-weight: 400;\"><em>Photos: previously patient file rooms, the Davie St clinic team has almost finished converting two offices into usable patient space.</em> </span>\r\n\r\n<img class=\"wp-image-8657 size-full alignleft\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/01/IMG_5472-scaled-e1674621558200.jpeg\" alt=\"\" width=\"300\" height=\"400\" /><img class=\"wp-image-8658 size-full alignleft\" src=\"http://van-division.yarko.dev/wp-content/uploads/2023/01/IMG_5473-scaled-e1674621569321.jpeg\" alt=\"\" width=\"300\" height=\"400\" />\r\n<h3>Cited Sources</h3>\r\n<em>Direct communication with Christine Lavelle-Martin and Aleksandra Dukic.</em>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[186,196,162,70],"related_campaigns":[185],"related_events":[187]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8654"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/187"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/185"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/70"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/162"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/196"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/186"}],"wp:featuredmedia":[{"embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/media/8656"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8654"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8654"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8654"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8654"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8613,"date":"2023-01-18T23:37:45","date_gmt":"2023-01-18T23:37:45","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8613"},"modified":"2023-01-18T23:37:45","modified_gmt":"2023-01-18T23:37:45","slug":"safe-clinic-environment-poster","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/safe-clinic-environment-poster/","title":{"rendered":"Safe Clinic Environment Poster"},"featured_media":0,"template":"","resource_type":[163],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"Printable poster reminding patients to be respectful to staff.","resource-introduction":"Printable Clinic Poster","resource-text":"Use this poster in your clinic to remind patients to be respectful with staff.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":8614,"resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download Poster","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2023/01/20230118-SafeEnvironmentPoster.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163],"related_campaigns":[165],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8613"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8613"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8613"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8613"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8613"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9869,"date":"2023-01-11T22:54:58","date_gmt":"2023-01-11T22:54:58","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=9869"},"modified":"2023-08-01T18:41:17","modified_gmt":"2023-08-01T18:41:17","slug":"fast-facts-january-11-2023","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-january-11-2023/","title":{"rendered":"Fast Facts &#8211; January 11, 2023"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9546289","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/9869"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9869"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9869"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9869"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9869"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":9867,"date":"2022-12-21T21:31:21","date_gmt":"2022-12-21T21:31:21","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=9867"},"modified":"2023-08-01T18:42:43","modified_gmt":"2023-08-01T18:42:43","slug":"fast-facts-december-21st-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-december-21st-2022/","title":{"rendered":"Fast Facts &#8211; December 21, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9542541","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/9867"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=9867"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=9867"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=9867"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=9867"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8416,"date":"2022-12-19T23:27:32","date_gmt":"2022-12-19T23:27:32","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8416"},"modified":"2022-12-20T00:52:10","modified_gmt":"2022-12-20T00:52:10","slug":"letter-regarding-consultant-physicians-requesting-re-referrals","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/letter-regarding-consultant-physicians-requesting-re-referrals/","title":{"rendered":"Letter Regarding Consultant Physicians Requesting Re-Referrals"},"featured_media":0,"template":"","resource_type":[199,170],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"A letter to Membership regarding consultant physicians requesting re-referrals.","resource-introduction":"Letter to Membership","resource-text":"<p data-pm-slice=\"1 1 []\">Over the past several months, a number of members have reached out to the Division expressing concerns about the re-referral process; in particular, family doctors are asked to provide a No Charge Referral (03333) after a 6-month period, even if the patient is receiving specialist care for an ongoing condition. In July, the Division’s Continuity of Care Committee met with representatives from Doctors of BC’s Consultation Working Group and Tariff Committee to discuss the issue and the Referral Process FAQ. The findings can be accessed below.</p>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Findings","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/12/Letter-To-Membership-vd.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[170],"related_campaigns":[184],"related_events":[156]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8416"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/184"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/170"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8416"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8416"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8416"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8416"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8371,"date":"2022-12-16T00:34:17","date_gmt":"2022-12-16T00:34:17","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8371"},"modified":"2022-12-16T00:42:24","modified_gmt":"2022-12-16T00:42:24","slug":"cbt-skills-group-referral-form","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/cbt-skills-group-referral-form/","title":{"rendered":"CBT Skills Group Referral Form"},"featured_media":0,"template":"","resource_type":[118,124,119],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Access the CBT Skills Group referral form.","resource-introduction":"","resource-text":"Access the CBT Skills Group referral form.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Access the Referral Form","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/12/CBT-SKILLS-GROUP-PROVINCIAL-REFERRAL-FORM-FILLABLE-2021.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[118,119],"related_campaigns":[79],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8371"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8371"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8371"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8371"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8371"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8342,"date":"2022-12-08T17:12:08","date_gmt":"2022-12-08T17:12:08","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8342"},"modified":"2022-12-08T17:15:17","modified_gmt":"2022-12-08T17:15:17","slug":"chinese-speaking-cop-focus-group-summary","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/chinese-speaking-cop-focus-group-summary/","title":{"rendered":"Chinese Speaking CoP Focus Group Summary"},"featured_media":0,"template":"","resource_type":[196,195],"resource_cat":[],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"A summary of two focus group sessions held for Community of Practice supporting Chinese-speaking patients.","resource-introduction":"","resource-text":"The Community of Practice (CoP) supporting Chinese Speaking Patients has identified the need to bolster the provision of culturally appropriate care for many patients who only speak Chinese.\r\n\r\nIn response to this issue, the Vancouver Division held a two-part virtual focus group with nineteen CoP members and FPs in the Chinatown area to learn what they foresee for the future of their practices and patients.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Summary","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/12/VDoFP-Chinese-Language-V3.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[119,196],"related_campaigns":[],"related_events":[173]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8342"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/173"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/196"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8342"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8342"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8342"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8342"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8332,"date":"2022-12-08T01:26:14","date_gmt":"2022-12-08T01:26:14","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8332"},"modified":"2023-08-01T18:54:33","modified_gmt":"2023-08-01T18:54:33","slug":"fast-facts-december-7-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-december-7-2022/","title":{"rendered":"Fast Facts &#8211; December 7, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/96b25d681e9b/youre-invited-for-a-sneak-peek-9531741","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8332"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8332"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8332"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8332"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8332"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8106,"date":"2022-12-08T01:20:08","date_gmt":"2022-12-08T01:20:08","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8106"},"modified":"2023-05-01T18:20:26","modified_gmt":"2023-05-01T18:20:26","slug":"child-and-youth-mental-health-and-substance-use-resource-guide","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/child-and-youth-mental-health-and-substance-use-resource-guide/","title":{"rendered":"Child and Youth Mental Health and Substance Use Resource Guide"},"featured_media":0,"template":"","resource_type":[119],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Supporting children, youth, and their families seeking and receiving timely access to local mental health resources.","resource-introduction":"","resource-text":"<span style=\"font-weight: 400;\">The Vancouver Local Action Team (LAT) was part of the provincial </span><a href=\"http://sharedcarebc.ca/completed-work/cymhsu-collaborative\" target=\"_blank\" rel=\"noopener\"><span style=\"font-weight: 400;\">Child and Youth Mental Health and Substance Use (CYMHSU) Collaborative</span></a><span style=\"font-weight: 400;\">. Since the conclusion of this provincial initiative, the individuals and organizations involved in the Vancouver LAT have continued to work together. Our purpose is to support children, youth, and their families seeking and receiving timely access to local mental health and substance use resources. We believe that mental health is just as important as physical health.</span>\r\n\r\n<span style=\"font-weight: 400;\">Active member organizations include the Vancouver School Board, Vancouver Parks and Recreation, Vancouver Coastal Health, Vancouver Division of Family Practice, YWCA Metro Vancouver, Pacific Community Resources, Family Services of Greater Vancouver, Pacific Autism Network, and the Crisis Centre of BC. For more information about the Vancouver LAT and the Vancouver Division’s involvement. Each member is showcased via video below. </span>\r\n\r\n<span style=\"font-weight: 400;\">The guide was first compiled by the Vancouver LAT in 2017 and was fully revised in December 2021. </span>\r\n\r\nAccess an <a href=\"https://vancouverlat.wixsite.com/resource-directory\" target=\"_blank\" rel=\"noopener\">additional online directory of resources </a>here.\r\n\r\nPromote the directory in your clinic space with these posters available for download and print.\r\n<ul>\r\n \t<li>Poster 1: <a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/12/vancouver-youth-resource-directoy-Nov-2021.pdf\">Colour</a> or <a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/12/vancouver-youth-resource-directoy-Nov-2021-BW.pdf\">Black and White</a></li>\r\n \t<li>Poster 2: <a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/12/vancouver-youth-resource-directoy-Nov-2021-v2.pdf\">Colour</a> or <a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/12/vancouver-youth-resource-directoy-Nov-2021-BW-v2.pdf\">Black and White</a></li>\r\n</ul>\r\n&nbsp;","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":true,"resource-faq_header":"Vancouver Child and Youth Mental Health Resources","resource-faq_accordion_content":[{"resource-acc-item-title":"1. Online Youth Resource Guide","resource-acc-item-content":"<p><a href=\"https://vancouverlat.wixsite.com/resource-directory\" target=\"_blank\">Vancouver LAT Resource Directory</a></p>\r\n<p><strong>WHO:</strong> Youth of any age (12-18)</p>\r\n<p><strong>WHAT:</strong> An online guide intended as a starting point for youth for support in mental health, medical services, sexual abuse, counselling, and places to go.</p>\r\n<p><strong>WHERE:</strong> <a href=\"https://vancouverlat.wixsite.com/resource-directory\">Online</a></p>\r\n<p><strong>Referrals:</strong> N/A</p>\r\n<p>Intended to be simple in design, this online directory is a starting point for youth on where to go for help. Services and resources are categorized by topic, with key resources listed for each. Each topic is meant to act as key access point rather than an exhaustive list of each resource:</p>\r\n<ul>\r\n<li>Sexual abuse supports\r\n<li>Mental health supports\r\n<li>Medical services\r\n<li>Counselling\r\n<li>Chat options\r\n<li>Programs and places to go\r\n</ul><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777156342/01c1c31e39\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777156342?h=01c1c31e39\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"},{"resource-acc-item-title":"2. Foundry Vancouver Granville","resource-acc-item-content":"<p><a href=\"https://FoundryBC.ca\" target=\"_blank\">FoundryBC.ca</a></p>\r\n<p>(604) 806-9415</p>\r\n<p>icymhp@providencehealth.bc.ca</p>\r\n<p><strong>WHO:</strong>  Youth 12-24</p>\r\n<p><strong>WHAT:</strong> A place to access mental health care, substance use services, youth and family peer support, and social services, all under one roof. Primary care team available by phone.</p>\r\n<p><strong>WHERE:</strong> 1260 Granville, Vancouver</p>\r\n<p><strong>Referrals:</strong> Self, professional, or family referrals welcome: certain criteria apply to some programs. See below for more information.</p>\r\n<p>Youth should expect wrap-around care that is gender-affirming and trauma-informed in a youth-friendly environment. </p>\r\n<ul>\r\n<li>Website provides tools, articles, and stories\r\n<li>App allows youth to book appointments, get resources\r\n<li>Virtual services include drop-in counselling, peer supports, and groups for youth and families\r\n</ul><br>\r\n<p>Granville specifically:</p>\r\n<ul>\r\n<li>Primary care: limited drop-in: 1-5pm\r\n<li>Episodic care: drop-in, no expectation of ongoing care (ie sexual health)\r\n<li>Longitudinal care*\r\n<li>Psych consults*\r\n<li>Intensive case management*\r\n<li>Substance use: OAT, drug checking \r\n<li>Counselling: brief, solution-based (drop-in: 1 session)\r\n<li>Youth programming: groups, cooking, field trip, youth advisory committee, peer support \r\n</ul><br>\r\n<p>*certain criteria apply</p><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777158191/2307348b09\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777158191?h=2307348b09\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"},{"resource-acc-item-title":"3. TransCare BC","resource-acc-item-content":"<p><a href=\"http://www.phsa.ca/transcarebc/\"</a></p>\r\n<p>(866) 999-1514</p>\r\n<p>transcareteam@phsa.ca</p>\r\n<p><strong>WHO:</strong> Trans and gender-diverse people of Vancouver</p>\r\n<p><strong>WHAT:</strong> A small team of health navigators who work with care providers, clients, and their families to navigate the healthcare system and connect with gender-affirming care.</p>\r\n<p><strong>WHERE:</strong> Online self-referral</p>\r\n<p>TransCare BC provides supports and client navigation of resources. Although it is not a clinic, it is a small team of health navigators who work with care providers, clients, and their families to access information, resources, navigate the healthcare system and connect with gender-affirming care providers. Some limited, brief, direct client care includes surgical readiness assessment and aftercare linkage (i.e., if you’re travelling for surgery). They keep an inventory of providers and pathways. The #1 referral request is to primary care providers able to provide care to trans patients. </p><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777159648/465057e0d5\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777159648?h=465057e0d5\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"},{"resource-acc-item-title":"4. Pacific Community Resources Society: Broadway Youth Resource Centre","resource-acc-item-content":"<p><a href=\"https://pcrs.ca/service-types/youth/\" target=\"_blank\">Youth and Family Support | Pacific Community Resources Society (pcrs.ca)</a></p>\r\n<p>(604) 709-5720</p>\r\n<p><a href=\"mailto:byrcreception@pcrs.ca\" target=\"_blank\">byrcreception@pcrs.ca</a></p>\r\n\r\n<p><strong>WHO:</strong> Youth aged 13-24</p>\r\n<p><strong>WHAT:</strong> The BYRC is a one-stop youth centre that provides a wide range of social, health, education, employment, and life skills services to youth</p>\r\n<p><strong>WHERE:</strong> 2455 Fraser, Vancouver</p>\r\n<p><strong>Referrals:</strong> Self, professional, family: in person or by email</p>\r\n<p>Self-referral can take place either in person or by email. NP available for drop-in visits once a week, and staff can provide referrals to other programming for substance use, housing, and Indigenous victim services. An alternative school is also on site (certain criteria applies). A fresh food kit is offered weekly along with a staple pantry that is accessible Monday to Friday. \r\n<p>Youth can expect a warm, inviting welcome and access to a youth worker if needed, along with food, programming, access to computers, and a nonjudgmental space. </p>\r\n<p>Daily programming includes: \r\n<ul>\r\n<li>Substance use support</li>\r\n<li>Mental health support</li>\r\n<li>Self-care</li>\r\n<li>Art therapy</li>\r\n<li>Life skills</li>\r\n</ul><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777160756/a9a48f64fe\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777160756?h=a9a48f64fe\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"},{"resource-acc-item-title":"5. Crisis Centre of BC","resource-acc-item-content":"<p><a href=\"https://crisiscentre.bc.ca\" target=\"_blank\">https://crisiscentre.bc.ca</a></p>\r\n<p>Mental Health Support Line (24/7): 310-6789</p>\r\n<p>Suicide Support Line (24/7): 1-800-SUICIDE</p>\r\n<p>Youth in BC: (12pm-1am Daily): <a href=\"https://youthinbc.com\" target=\"_blank\">https://youthinbc.com</a></p>\r\n\r\n<p><strong>WHO:</strong> Anyone needing crisis support, suicide prevention, and postvention\r\n<p><strong>WHAT:</strong> Immediate access to barrier-free support through 24/7 phone lines and online services\r\n<p><strong>WHERE:</strong> Phone, online chat\r\n<p><strong>Referrals:</strong> N/A\r\n<p>The Crisis Centre of BC provides help and hope to individuals, organizations, and communities. Services span the spectrum of crisis support, suicide prevention, and postvention. Youth can expect immediate access to barrier-free support through 24/7 phone lines and online services. The Centre also provides education, training, and support programs that promote mental wellness and community capacity Referrals and self-referrals are available to anyone regardless of age. Collaborative, client-centered care. </p><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777162088/fa5edb2af2\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777162088?h=fa5edb2af2\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"},{"resource-acc-item-title":"6.  VCH: Child and Youth Mental Health Teams and Substance Use Services","resource-acc-item-content":"<p>Youth substance use services - <a href=\"http://www.vch.ca/public-health/children-youth-schools/youth-health/youth-addiction\" target=\"_blank\">Vancouver Coastal Health (vch.ca)</a></p>\r\n<p>(604) 209-3705 (call for referrals or help with referral process)</p>\r\n\r\n<p><strong>WHO:</strong> Youth aged 13-25 who use substances or alcohol and want support</p>\r\n<p><strong>WHAT:</strong> Trauma-informed, harm reduction approach in addressing substance use</p>\r\n<p><strong>WHERE:</strong> varies- see webpage</p>\r\n<p><strong>Referrals:</strong> call (604) 209-3705</p>\r\n<p>The VCH Youth Substance Use Services is for ages 13-25 who use substances or alcohol and want support addressing their substance use, whether that be reducing, modifying, or using safely. Centralized intake is available 7 days a week. 4 NPs are on staff to offer primary care as well as substance use support (e.g., OAT). The focus is trauma-informed with a harm reduction approach, friendly staff, and non-judgmental attitude. Food is a big part of what they do and is always available.  Services offered include:</p>\r\n<ul>\r\n<li>Cultural services\r\n<li>Social work\r\n<li>Outreach support \r\n<li>Case management \r\n<li>Weekly support for substance use goals\r\n<li>Help with basic needs\r\n<li>Family work\r\n<li>Connection to services \r\n<li>Referrals\r\n<li>Day treatment program\r\n</ul><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777162822\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777162822?h=b0985ca68d\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"},{"resource-acc-item-title":"7. Vancouver Parks: Youth Programming and Services","resource-acc-item-content":"<p><a href=\"https://vancouver.ca/people-programs/youth.aspx\" target=\"_blank\">Youth engagement and support | City of Vancouver</a></p>\r\n\r\n<p><strong>WHO:</strong> Ages 8-19</p>\r\n<p><strong>WHAT:</strong> Low-barrier activities for youth</p>\r\n<p><strong>WHERE:</strong> Various locations across the lower Mainland</p>\r\n<p><strong>Referrals:</strong> not needed; low/no-barrier access.</p>\r\n\r\n<p>Vancouver Parks Youth Programming is open for anyone ages 8-19 at their local community center. Each community center has its own Youth Community Programmer.</p>\r\n<p> A sense of belonging, low-barrier, not just sports: arts, social, dance, games room, ping pong, video games, relationship building. 1-on-1 office meetings available Monday-Friday, F 9-5, no/low cost. </p>\r\n<p>Leisure access program, offers occasional dental/vaccine clinic. </p>\r\n<p>Advocacy Volunteer opportunities: A chance for youth to make a difference in their community. Connected to many other CHY services in this list! Longer hours than many services, open Christmas, and New Year’s. A safe space. Harm reduction supplies available. Condoms available. Help for bus tickets. Menstrual products in all washrooms. Youth should come and expect an easy or nonexistent intake process. Trans celebration. Gender-affirming.  Scribing services. Multilingual.</p><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777166255/3c1851e8a9\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777166255?h=3c1851e8a9\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"},{"resource-acc-item-title":"8. Vancouver School Board: Services and Supports for Students","resource-acc-item-content":"<p><a href=\"https://www.vsb.bc.ca/page/5151/mental-health\" target=\"_blank\">Vancouver School Board (vsb.bc.ca)</a></p>\r\n\r\n<p><strong>WHO:</strong> School-aged children and youth enrolled in the VSB.</p>\r\n<p><strong>WHAT:</strong> Academic, social, emotional, and career support</p>\r\n<p><strong>WHERE:</strong> At schools in the VSB.</p>\r\n<p><strong>Referrals:</strong> Can happen by students, teachers, administrators, parents, and guardians.  </p> \r\n\r\nFind the VSB Student Health Information Sharing Forms <a href=\"https://van-division.yarko.dev/resource/vsb-student-health-information-sharing-form/\">here</a>. \r\n\r\n<p>School counsellors provide services to all school-aged children and youth enrolled in the VSB, their families, and their educators. Referral can happen by students, teachers, administrators, parents and guardians.</p>\r\n<p>Expect continued, consistent, and ongoing academic, social, emotional, and career support from kindergarten through grade 12.</p>\r\n<p>Facilitates referrals within community. </p><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777167181/1f07e6f01d\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777167181?h=1f07e6f01d\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"},{"resource-acc-item-title":"9. YMCA of Greater Vancouver: Y Mind","resource-acc-item-content":"<p>Website: <a href=\"https://www.gv.ymca.ca/mental-wellness\" target=\"_blank\">ymca.ca/mental-wellness</a>\r\n<p>Email: <a href=\"mailto:YMind@gv.ymca.ca\" target=\"_blank\">YMind@gv.ymca.ca</a></p>\r\n\r\n<p><strong>WHO:</strong> 13-18</p>\r\n<p><strong>WHAT:</strong> Aims for early intervention to stress/mild-moderate anxiety</p>\r\n<p><strong>WHERE:</strong> Various locations</p>\r\n<p><strong>Referral:</strong> self and professional both welcome. Email for information.</p>\r\n\r\n<p>Approach: ACT: Acceptance and Commitment Therapy</p>\r\n<p>Anxiety is a part of life, not a problem to get rid of. </p>\r\n<p>Offers tools such as mindfulness to notice a make room for uncomfortable feelings, which allow us to move towards what is important to us, even in the presence of uncomfortable feelings. Ultimately this leads to a more rich and fulfilling life. </p>\r\n<p>Age: 13+ (13-18, 18-30): Mild-moderate anxiety; aim for early intervention and prevention. No diagnosis required. Group setting, main focus on anxiety/stress; 7-week commitment required.\r\n<p>Outcomes: decreased anxiety symptoms, increased wellbeing, improved mindfulness and greater psychological flexibility.</p>\r\n<p>Referral: self, professional both welcome. YMind will reach out with program information.</p><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777167809/930128e520\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777167809?h=930128e520\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"},{"resource-acc-item-title":"10.  Directions Youth Services","resource-acc-item-content":"<p><a href=\"https://www.directionsyouthservices.ca/\" target=\"_blank\">Directionsyouthservices.ca</a></p>\r\n<p>(604) 633-1472 / (866) 249-6884</p>\r\n<p><a href=\"mailto:directions@fsgv.ca\" target=\"_blank\">directions@fsgv.ca</a></p>\r\n\r\n<p><strong>WHO:</strong> Low-income youth under 25 </p>\r\n<p><strong>WHAT:</strong> Low-barrier services for youth experiencing homelessness as a result of abuse, neglect, substance use, or mental health challenges</p>\r\n<p><strong>WHERE:</strong> 1138 Burrard St., Vancouver</p>\r\n<p>Open program can be referred to and accessed at any time. Criteria is typically: youth under 25; low income; in need of housing; mental/physical disability; but will help anyone in crisis under age 25 and is a safe place.</p>\r\n<ul>\r\n<li>24/7/365 low-barrier service\r\n<li>Washrooms and showers\r\n<li>Meals, snacks, pantry program\r\n<li>Shelter: extra mats for extreme weather\r\n<li>Harm reduction supplies and information\r\n<li>Pet room\r\n<li>SYJA Pre-employment \r\n<li>Media/arts programming\r\n<li>Primary care 2x weekly\r\n<li>2 Safehouses for ages 16-18\r\n<li>Youth Detox: (criteria not as low barrier; see presentation/website)\r\n</ul><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777169145/2179320a8d\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777169145?h=2179320a8d\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"},{"resource-acc-item-title":"11. Family Smart","resource-acc-item-content":"<p><a href=\"https://familysmart.ca/\" target=\"_blank\">Familysmart.ca</a></p>\r\n<p>(855) 887-8004</p>\r\n\r\n<p><strong>WHO:</strong> For families of children, youth, and young adults.</p>\r\n<p><strong>WHAT:</strong> An organization that helps young people by helping the adults who care for them\r\n<p><strong>WHERE:</strong> see website</p>\r\n<p><strong>Referrals:</strong> <a href=\"https://familysmart.ca/refer-people/\" target=\"_blank\">Refer People - FamilySmart</a></p>\r\n\r\n<p>Families can self-refer: no diagnosis, no waitlist, free. Can refer a family with consent. \r\nWe help children and young people by helping their family and other caring adults in their lives. We know that when families are supported alongside of their children, youth, and young adults, things go better.</p>\r\n<p>Peer Support Workers are parents who lead with their own lived experience of supporting child, youth, or young adult through the mental health and/or substance use system. Support for all stages of the journey. </p>\r\n<ul>\r\n<li>Provides emotional support and mentoring to parents and caregivers \r\n<li>Connects families to resources and information about services and supports\r\n<li>Helps with service navigation, what to expect when accessing services\r\n<li>Can meet by phone, email, video chat.\r\n<li>Monthly virtual events to share experiences and strategies that help in hard moments \r\n<li>Focus on strengthening understanding and connection with our kids. \r\n<li>Free monthly workshops for families with repeated ER visits or inpatient experiences with mental health or substance use \r\n<ul>\r\n<li>Topics include safety at home and managing once emerging from crisis \r\n</ul></ul><br>\r\n\r\n<p><strong><a href=\"https://vimeo.com/777170429/29d250b674\" target=\"_blank\">Watch the Video</a></strong></p>\r\n<iframe src=\"https://player.vimeo.com/video/777170429?h=29d250b674\" width=\"640\" height=\"564\" frameborder=\"0\" allow=\"autoplay; fullscreen\" allowfullscreen></iframe>"}],"related_resources":[118,119],"related_campaigns":[79,117],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8106"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8106"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8106"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8106"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8106"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8319,"date":"2022-12-06T21:38:31","date_gmt":"2022-12-06T21:38:31","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8319"},"modified":"2022-12-06T22:30:32","modified_gmt":"2022-12-06T22:30:32","slug":"vch-adult-day-programs","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/vch-adult-day-programs/","title":{"rendered":"VCH Adult Day Programs"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Adult day services assist seniors and adults with disabilities to continue to live in their own homes.","resource-introduction":"","resource-text":"Adult day services assist seniors and adults with disabilities to continue to live in their own homes by providing supportive group programs and activities in the community. There are 12 funded Adult Day Programs in Vancouver and after a challenging period of closure in the heat of the pandemic, they are up and running again. There are Adult Day Program spaces available across the city.\r\n\r\nFor more information or to access the Referral form, please see the resources below.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":true,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":[{"resource-acc-item-title":"Vancouver Home and Community Referral Form","resource-acc-item-content":"To access this service, an individual requires a referral to a Home Health Case Manager. To make a Home Health Case Manager Referral anyone may call Vancouver Community Central Intake at (604) 263-7377. A Health Care Professional <strong><a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/12/Vancouver-home-and-community-referral-form.pdf\">can complete the Central Intake Referral form </a></strong> and fax it to (604) 267- 3419."},{"resource-acc-item-title":"VC Adult Day Programs Info Sheet - December 2022","resource-acc-item-content":"Adult Day Programs are designed for adults who have physical and/or memory challenges or are living with a chronic illness. The program is for individuals who may struggle to attend programs at conventional community centers. Clients of VCH Adult Day Programs travel to a location in their community 1-2 days per week where they are met by knowledgeable and caring staff offering a variety of services.\r\n\r\n<p><strong><a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/12/VC-Adult-Day-Programs-December-2022.pdf\">Learn More about the programs here.</a></strong>"}],"related_resources":[180,119],"related_campaigns":[117],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8319"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8319"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8319"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8319"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8319"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8272,"date":"2022-11-30T10:46:29","date_gmt":"2022-11-30T10:46:29","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8272"},"modified":"2022-11-30T10:46:29","modified_gmt":"2022-11-30T10:46:29","slug":"accepting-provider-reminder","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/accepting-provider-reminder/","title":{"rendered":"Accepting Provider Reminder Emails"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":"","post-excerpt":"Reminder email to accepting providers about patient panel. ","resource-introduction":"","resource-text":"An example email providers receive from the Vancouver Division. ","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Email Template","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/11/Accepting-Provider-Reminder-Emails.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8272"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8272"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8272"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8272"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8272"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8271,"date":"2022-11-30T10:42:52","date_gmt":"2022-11-30T10:42:52","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8271"},"modified":"2022-11-30T10:44:19","modified_gmt":"2022-11-30T10:44:19","slug":"introduction-to-new-primary-care-provider","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/introduction-to-new-primary-care-provider/","title":{"rendered":"Introduction to New Primary Care Provider"},"featured_media":0,"template":"","resource_type":[],"resource_cat":[],"catalogue":[],"acf":{"post-icon":"","post-excerpt":"Email to patients receive from the Vancouver Division introducing their new primary care provider.","resource-introduction":"","resource-text":"An example email patients receive from the Vancouver Division introducing their new primary care provider. ","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Letter Template","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/11/Reallocation-Email-Example.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8271"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8271"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8271"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8271"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8271"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8235,"date":"2022-11-25T08:13:36","date_gmt":"2022-11-25T08:13:36","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8235"},"modified":"2022-11-25T08:29:02","modified_gmt":"2022-11-25T08:29:02","slug":"cbt-mh-tiers","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/cbt-mh-tiers/","title":{"rendered":"CBT and Mental Health Tiers of Service"},"featured_media":0,"template":"","resource_type":[118,124,119],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Where CBT Skills intersect with Mental Health Tiers of Service.","resource-introduction":"","resource-text":"Understand where CBT Skills intersect with Mental Health Tiers of Service. Further information is also available via the <a href=\"https://van-division.yarko.dev/mhsu\" target=\"_blank\" rel=\"noopener\">Mental Health and Substance Use (MHSU) page</a>.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":8208,"resource-header_2":"","resource-extended-info-2":"","resource-content":"<a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/11/MH-Tiers-of-care-CBT.pdf\">MH Tiers of care &amp; CBT</a>","resource-button_text":"View the Image","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/11/MH-Tiers-of-care-CBT.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[118,119],"related_campaigns":[79],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8235"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8235"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8235"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8235"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8235"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":8234,"date":"2022-11-25T00:23:14","date_gmt":"2022-11-25T00:23:14","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=8234"},"modified":"2023-08-01T19:15:50","modified_gmt":"2023-08-01T19:15:50","slug":"fast-facts-november-23-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-november-23-2022/","title":{"rendered":"Fast Facts &#8211; November 23, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9531677","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/8234"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=8234"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=8234"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=8234"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=8234"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7650,"date":"2022-11-10T19:21:54","date_gmt":"2022-11-10T19:21:54","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7650"},"modified":"2023-08-01T19:20:08","modified_gmt":"2023-08-01T19:20:08","slug":"fast-facts-november-09-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-november-09-2022/","title":{"rendered":"Fast Facts &#8211; November 09, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9527841","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7650"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7650"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7650"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7650"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7650"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7591,"date":"2022-11-08T01:04:00","date_gmt":"2022-11-08T01:04:00","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7591"},"modified":"2022-11-08T01:04:00","modified_gmt":"2022-11-08T01:04:00","slug":"urgent-and-primary-care-centres","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/urgent-and-primary-care-centres/","title":{"rendered":"Urgent and Primary Care Centres"},"featured_media":0,"template":"","resource_type":[73],"resource_cat":[92],"catalogue":[194],"acf":{"post-icon":2270,"post-excerpt":"Urgent and Primary Care Centres are available with extended hours for same-day, non-life-threatening injuries and illnesses.","resource-introduction":"","resource-text":"<a href=\"http://www.vch.ca/your-care/urgent-and-primary-care-centres\" target=\"_blank\" rel=\"noopener\">Urgent and Primary Care Centres</a> are available with extended hours for same-day, non-life-threatening injuries and illnesses","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Find Urgent and Primary Care Centres","resource-button_link":"http://www.vch.ca/your-care/urgent-and-primary-care-centres","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7591"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7591"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7591"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7591"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7591"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7590,"date":"2022-11-08T01:02:29","date_gmt":"2022-11-08T01:02:29","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7590"},"modified":"2022-11-08T01:06:20","modified_gmt":"2022-11-08T01:06:20","slug":"bc211","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/bc211/","title":{"rendered":"bc211"},"featured_media":0,"template":"","resource_type":[73],"resource_cat":[92],"catalogue":[191,193],"acf":{"post-icon":2270,"post-excerpt":"bc211 is a free 24/7, confidential multilingual service that links people to resources for help, where and when they need it.","resource-introduction":"","resource-text":"<section class=\"has_ae_slider elementor-section elementor-top-section elementor-element elementor-element-cfa5162 elementor-section-boxed elementor-section-height-default elementor-section-height-default ae-bg-gallery-type-default\" data-id=\"cfa5162\" data-element_type=\"section\" data-settings=\"{&quot;_ha_eqh_enable&quot;:false}\">\r\n<div class=\"elementor-container elementor-column-gap-default\">\r\n<div class=\"has_ae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3e89cbb ae-bg-gallery-type-default\" data-id=\"3e89cbb\" data-element_type=\"column\">\r\n<div class=\"elementor-widget-wrap elementor-element-populated\">\r\n<div class=\"elementor-element elementor-element-eda2540 elementor-widget elementor-widget-text-editor\" data-id=\"eda2540\" data-element_type=\"widget\" data-widget_type=\"text-editor.default\">\r\n<div class=\"elementor-widget-container\">\r\n\r\n<a href=\"https://bc.211.ca/\" target=\"_blank\" rel=\"noopener\">bc211</a> is a free 24/7, confidential multilingual service that links people to resources for help, where and when they need it.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</section><section class=\"has_ae_slider elementor-section elementor-top-section elementor-element elementor-element-ca579c6 elementor-section-boxed elementor-section-height-default elementor-section-height-default ae-bg-gallery-type-default\" data-id=\"ca579c6\" data-element_type=\"section\" data-settings=\"{&quot;_ha_eqh_enable&quot;:false}\">\r\n<div class=\"elementor-container elementor-column-gap-default\">\r\n<div class=\"has_ae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6440caa ae-bg-gallery-type-default\" data-id=\"6440caa\" data-element_type=\"column\">\r\n<div class=\"elementor-widget-wrap elementor-element-populated\"></div>\r\n</div>\r\n</div>\r\n</section>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Visit bc211","resource-button_link":"https://bc.211.ca/","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[73],"related_campaigns":[91,117,184],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7590"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/184"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/73"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7590"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7590"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7590"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7590"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7589,"date":"2022-11-08T01:00:30","date_gmt":"2022-11-08T01:00:30","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7589"},"modified":"2022-11-08T01:06:53","modified_gmt":"2022-11-08T01:06:53","slug":"healthlinkbc","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/healthlinkbc/","title":{"rendered":"HealthlinkBC"},"featured_media":0,"template":"","resource_type":[73],"resource_cat":[92],"catalogue":[191,193],"acf":{"post-icon":2270,"post-excerpt":"A free provincial health information and advice phone line.","resource-introduction":"","resource-text":"<a href=\"https://www.healthlinkbc.ca/health-services/search-services-your-area\" target=\"_blank\" rel=\"noopener\">HealthlinkBC</a> or call 8-1-1, is a free provincial health information and advice phone line. You can speak to a health service navigator who can help you find information and services, or connect you directly to a registered nurse, registered dietitian, qualified exercise professional or pharmacist.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Visit HealthlinkBC","resource-button_link":"https://www.healthlinkbc.ca/health-services/search-services-your-area","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[73],"related_campaigns":[79,91,117],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7589"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/73"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7589"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7589"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7589"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7589"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7588,"date":"2022-11-08T00:57:27","date_gmt":"2022-11-08T00:57:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7588"},"modified":"2022-11-08T01:07:39","modified_gmt":"2022-11-08T01:07:39","slug":"medimap","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/medimap/","title":{"rendered":"Medimap"},"featured_media":0,"template":"","resource_type":[73],"resource_cat":[92],"catalogue":[191,193],"acf":{"post-icon":2270,"post-excerpt":"Locate the nearest walk-in clinic and their wait-times.","resource-introduction":"","resource-text":"Compare availability and book an appointment with a wide variety of local care providers in one place. Our vision is to be the go-to resource for easy access to care across the globe.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Go to Medimap","resource-button_link":"https://medimap.ca/","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[73],"related_campaigns":[79,91,117],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7588"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/73"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7588"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7588"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7588"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7588"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7425,"date":"2022-10-31T22:22:58","date_gmt":"2022-10-31T22:22:58","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7425"},"modified":"2023-08-01T19:43:21","modified_gmt":"2023-08-01T19:43:21","slug":"fast-facts-october-26-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-october-26-2022/","title":{"rendered":"Fast Facts &#8211; October 26, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9067373","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7425"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7425"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7425"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7425"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7425"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7424,"date":"2022-10-31T22:21:27","date_gmt":"2022-10-31T22:21:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7424"},"modified":"2022-10-31T22:22:50","modified_gmt":"2022-10-31T22:22:50","slug":"fast-facts-october-12-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-october-12-2022/","title":{"rendered":"Fast Facts &#8211; October 12, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9063857","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[166,172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7424"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7424"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7424"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7424"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7424"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7419,"date":"2022-10-31T15:43:36","date_gmt":"2022-10-31T15:43:36","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7419"},"modified":"2022-11-08T01:08:17","modified_gmt":"2022-11-08T01:08:17","slug":"find-a-doctor-bc","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/find-a-doctor-bc/","title":{"rendered":"Find a Doctor BC"},"featured_media":0,"template":"","resource_type":[73],"resource_cat":[92],"catalogue":[191,192],"acf":{"post-icon":2270,"post-excerpt":"A site that is updated by the public regularly.","resource-introduction":"","resource-text":"Find a Doctor BC is a website dedicated to helping patients help each other find family practitioners accepting new patients.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Find a Doctor BC","resource-button_link":"https://www.findadoctorbc.ca/","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[73],"related_campaigns":[184,117],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7419"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/184"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/73"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7419"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7419"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7419"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7419"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7418,"date":"2022-10-31T15:38:17","date_gmt":"2022-10-31T15:38:17","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7418"},"modified":"2022-11-08T01:08:58","modified_gmt":"2022-11-08T01:08:58","slug":"pathways-medical-care-directory","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/pathways-medical-care-directory/","title":{"rendered":"Pathways Medical Care Directory"},"featured_media":0,"template":"","resource_type":[73],"resource_cat":[92],"catalogue":[191,192],"acf":{"post-icon":2270,"post-excerpt":"Use the “Find Care” search function","resource-introduction":"","resource-text":"<a href=\"https://pathwaysmedicalcare.ca/\" data-type=\"URL\" data-id=\"https://pathwaysmedicalcare.ca/\" data-wpel-link=\"internal\">PathwaysMedicalCare.ca</a> is a new one-stop online directory to easily find information about doctors and medical clinics in British Columbia.\r\n\r\n<a href=\"https://pathwaysmedicalcare.ca/\" data-type=\"URL\" data-id=\"https://pathwaysmedicalcare.ca/\" data-wpel-link=\"internal\">PathwaysMedicalCare.ca</a> helps patients find details of how to connect with doctors for virtual care by phone or video and also provides latest clinic updates.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Pathways Medical Care Directory","resource-button_link":"https://pathwaysmedicalcare.ca/about/","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[73],"related_campaigns":[184,117],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7418"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/184"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/73"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7418"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7418"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7418"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7418"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7396,"date":"2022-10-27T16:21:17","date_gmt":"2022-10-27T16:21:17","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7396"},"modified":"2022-10-27T16:21:17","modified_gmt":"2022-10-27T16:21:17","slug":"2021-22-vdofp-annual-report","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/2021-22-vdofp-annual-report/","title":{"rendered":"2021/22 VDoFP Annual Report"},"featured_media":0,"template":"","resource_type":[167],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Read the annual report for the 2021-2022 year.","resource-introduction":"","resource-text":"Read the annual report for the 2021-2022 year.\r\n\r\nIncludes:\r\n<ul>\r\n \t<li>Messages:\r\n<ul>\r\n \t<li>Executive Director Message</li>\r\n \t<li>Board Chair Message</li>\r\n</ul>\r\n</li>\r\n \t<li>Organizational Overview</li>\r\n \t<li>Financial Report</li>\r\n \t<li>Reports:\r\n<ul>\r\n \t<li>Primary Care Networks</li>\r\n \t<li>PCN Project Team</li>\r\n \t<li>Physician Wellness</li>\r\n \t<li>Member Engagement</li>\r\n \t<li>Mental Health &amp; Substance Use</li>\r\n \t<li>Maternity Care</li>\r\n \t<li>Recruitment &amp; Retention</li>\r\n \t<li>Patient Attachment Initiative</li>\r\n \t<li>Seniors’ Care</li>\r\n</ul>\r\n</li>\r\n</ul>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Report","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/10/VDoFP-2021-22-Annual-Report.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[167],"related_campaigns":[179],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7396"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7396"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7396"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7396"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7396"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7389,"date":"2022-10-26T23:00:30","date_gmt":"2022-10-26T23:00:30","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7389"},"modified":"2022-10-26T23:01:22","modified_gmt":"2022-10-26T23:01:22","slug":"member-survey-infographic","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/member-survey-infographic/","title":{"rendered":"Member Survey Infographic"},"featured_media":0,"template":"","resource_type":[167,125],"resource_cat":[],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Valuable member insight from our 2022 member-wide survey.","resource-introduction":"","resource-text":"Valuable member insight from our 2022 member-wide survey.\r\n<ul>\r\n \t<li>249 responses from a diverse cross section of members (20% response rate)</li>\r\n \t<li>Survey Focus Areas\r\n<ul>\r\n \t<li>COVID-19 Impacts</li>\r\n \t<li>Preferred methods of communication and engagement</li>\r\n \t<li>Current thoughts on program areas</li>\r\n \t<li>Baseline demographics on member diversity</li>\r\n</ul>\r\n</li>\r\n</ul>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Browse the infographic","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/10/Member-Needs-Survey-Infographic-2022.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[167],"related_campaigns":[179],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7389"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7389"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7389"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7389"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7389"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7385,"date":"2022-10-26T22:55:09","date_gmt":"2022-10-26T22:55:09","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7385"},"modified":"2022-10-26T22:56:26","modified_gmt":"2022-10-26T22:56:26","slug":"member-survey-briefing-notes","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/member-survey-briefing-notes/","title":{"rendered":"Member Survey Briefing Notes"},"featured_media":0,"template":"","resource_type":[167,125],"resource_cat":[],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Sharing additional results from the 2022 Member Needs and Engagement survey.","resource-introduction":"","resource-text":"<ul>\r\n \t<li>The anonymized survey was open for 16 days (Feb 25-Mar 13)</li>\r\n \t<li>249 responses were received from a diverse cross section of members (20% response rate)\r\nThe survey collected answers on the following four topic areas:\r\n<ol>\r\n \t<li>COVID-19 impacts</li>\r\n \t<li>Current opinions on Division communications and engagement</li>\r\n \t<li>Up-to-date feedback on program areas</li>\r\n \t<li>Baseline demographics on member diversity</li>\r\n</ol>\r\n</li>\r\n</ul>\r\n<div class=\"page\" title=\"Page 2\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nIncluded are highlighted survey results based on information that are informing different Division departments and areas.\r\n\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the notes","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/10/Briefing-Note-June-2022-Board-Meeting-Member-Survey.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[167],"related_campaigns":[179],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7385"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7385"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7385"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7385"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7385"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7259,"date":"2022-10-24T15:31:10","date_gmt":"2022-10-24T15:31:10","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7259"},"modified":"2023-07-13T18:33:45","modified_gmt":"2023-07-13T18:33:45","slug":"2023-24-strategic-priorities-vancouver-division-of-family-practice","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/2023-24-strategic-priorities-vancouver-division-of-family-practice/","title":{"rendered":"2023-24 Strategic Priorities &#8211; Vancouver Division of Family Practice"},"featured_media":0,"template":"","resource_type":[167],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"Read the 2022-23 Strategic Priorities for the Vancouver Division of Family Practice.","resource-introduction":"","resource-text":"Read the 2023-24 Strategic Priorities for the Vancouver Division of Family Practice.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"<a href=\"http://van-division.yarko.dev/wp-content/uploads/2022/10/Vancouver-Division-8a-2022-Strat-Priorities-Revised.pdf\">Vancouver Division 8a-2022 Strat Priorities Revised</a>","resource-button_text":"Access the Strategic Plan","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/10/2023-Strat-Priorities-Final.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[167],"related_campaigns":[],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7259"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7259"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7259"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7259"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7259"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6868,"date":"2022-10-12T10:07:52","date_gmt":"2022-10-12T10:07:52","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6868"},"modified":"2023-01-02T18:10:49","modified_gmt":"2023-01-02T18:10:49","slug":"clinic-grant-faq-2022-23","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/clinic-grant-faq-2022-23/","title":{"rendered":"Clinic Grant FAQ 2022/23"},"featured_media":0,"template":"","resource_type":[186],"resource_cat":[],"catalogue":[],"acf":{"post-icon":"","post-excerpt":"","resource-introduction":"","resource-text":"This FAQ regroups the major questions asked by Family Physicians as of <strong>November 15th</strong>. We will update this FAQ as we receive further questions from FPs.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":true,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":[{"resource-acc-item-title":"What’s the purpose of the grant?","resource-acc-item-content":"The Vancouver Division of Family Practice (VDOFP) is proud to offer our community family practice clinics a one-time financial grant to support your ideas to improve your Patient Medical Home practices and to build your Primary Care Networks. Our objective is to encourage as many clinics as possible to access the grants for a project that will make a meaningful difference to your clinic and staff."},{"resource-acc-item-title":"Which clinics are eligible?","resource-acc-item-content":"The clinic grant program is available to PMHs providing primary care to patients in the community, and not in a care facility (e.g. hospital facility). PMH's providing community based primary care, but funded primarily by another entity (e.g. VCH), may receive funding for programs supporting improvements for Division members providing patient care."},{"resource-acc-item-title":"How much grant funding can each clinic receive?","resource-acc-item-content":"Grant amounts are funded based on the number of physician full-time equivalent (FTE) at a clinic. Clinics with:\r\n<ul>\r\n<li><b>1 family physician FTE</b> will receive <b>$1,500</b></li>\r\n<li><b>2 - 4 family physician FTEs</b> will receive <b>$3,000</b></li>\r\n<li><b>5 or more family physician FTEs</b> will receive <b>$4,500</b></li>\r\n</ul>\r\n<br>For example, if your clinic has 2 full-time physicians and 3 physicians that see patients half-time, the clinic is eligible for $3,000 (2 + 1.5 FTEs = 3.5 FTEs)."},{"resource-acc-item-title":"Can multiple clinics partner on a project?","resource-acc-item-content":"Yes. Clinics may work together on a joint project the positively benefits each clinic. Each clinic will be awarded the grant based on the number of physicians working at each clinic, up to $4,500 per clinic. Only one Clinic Owner or Clinic Manager needs to submit the grant request on behalf of all clinics involved."},{"resource-acc-item-title":"Can multiple physicians in a clinic submit different grant applications?","resource-acc-item-content":"No. The application is for the entire clinic (or group of clinics). A single application can include multiple ideas that all support the improvement of Patient Medical Homes and building Primary Care Networks. "},{"resource-acc-item-title":"How do I apply? And when do I apply?","resource-acc-item-content":"Each clinic or group of clinics may request one grant for a project of its choice, using the online application form here: <b><a href=\"https://tinyurl.com/ytnz42ps\" target=\"blank\">Clinic Grant Application</a></b>. We encourage Clinic Owners and Clinic Managers representing an individual clinic (or representing a group of clinics) to apply on behalf of the entire clinic. <br>\r\nPlease submit your application prior to November 16, 2022. <br>\r\nIf you have any questions or would like support to submit your application, please contact your Community Network Manager (CNM) or email <a href=\"mailto:pcn@van-division.yarko.dev\">pcn@van-division.yarko.dev</a>"},{"resource-acc-item-title":"What types of projects will the grant fund?","resource-acc-item-content":"The grant is to encourage clinics to invest in practice support and networking, two things that clinics may have been unable to work on given the impact of COVID-19 and the primary care crisis. <br>\r\nClinic grants can be used for a variety of improvements - from support upgrading office furniture and performing renovations through to paying for MOA training.<br>\r\nHere are some more project ideas (and feel free to propose something that is meaningful to your individual clinic):\r\n<ul>\r\n<li>Digitize / remove old charts from the clinic </li>\r\n<li>Upgrade your EMR </li>\r\n<li>Implement an online patient appointment booking tool  </li>\r\n<li>Update clinic software or expand clinic Wi-Fi  </li>\r\n<li>Improve patient spaces within your clinic (seating, room dividers, accessibility improvements)</li>\r\n<li>Train clinic staff on principles of Team Based Care </li>\r\n<li>Train your MOAs on new technology or other skills  </li>\r\n<li>Update your employment contracts or associate agreements</li> \r\n<li>Evaluate clinic technology privacy and security, and implement improvements </li>\r\n<li>Create a clinic website on Pathways </li>\r\n</ul>\r\n<br>\r\nIf you're looking for more ideas, <a href=https://van-division.yarko.dev/resource/clinic-grant-report-december-2021-march-2022/\">here are examples of programs that were undertaken during the 2021/22 clinic grant program</a>. "},{"resource-acc-item-title":"Can the grants be used towards the purchase of computers?","resource-acc-item-content":"Many clinics use the grant to improve their operations through technology. Grants can be used towards the purchase of computer hardware that is <b>not attached</b> to clinical equipment. This would include clinic computers used by physicians and staff.\r\n\r\n\r\nGrants <b>cannot</b> be awarded for purchase of clinical equipment or computer hardware to provide direct patient care, or where other funding already exists. Please see the FAQ item on Exclusions."},{"resource-acc-item-title":"Are there any exclusions?","resource-acc-item-content":"Grants cannot be awarded for purchase of clinical equipment or computers to provide direct patient care, or where other funding already exists: \r\n<ul>\r\n<li>E.g., GPSC already offers funding for clinics to perform panel management and to implement Health Data Coalition’s EMR data portal.</li>\r\n<li>E.g. 2, The Ministry of Health provides free PPE to clinics, and a clinic should not need to use this grant to obtain PPE. </li>\r\n</ul>"},{"resource-acc-item-title":"When will the grant money be awarded?","resource-acc-item-content":"Clinics will receive 80% of the funds shortly after project approval, and the remaining 20% of the funds at project completion."},{"resource-acc-item-title":"How long do I have to complete my project?","resource-acc-item-content":"Projects must be completed by <b>February 28, 2023</b> providing clinics up to four (4) months to achieve their desired outcomes."},{"resource-acc-item-title":"How do I receive the remaining 20% of the grant funding?","resource-acc-item-content":"A clinic (or group of clinics) will receive the remaining 20% of project funds upon project completion. We will send you a template to provide a brief update on your project, after which you will receive the remaining funding."},{"resource-acc-item-title":"Will the grant cover ongoing costs associated with the projects? ","resource-acc-item-content":"No. The grant will cover the clinic’s initial project costs, and it is the clinic’s responsibility to pay for any ongoing costs beyond the initial project.  "},{"resource-acc-item-title":"Who should I contact with questions or for support? ","resource-acc-item-content":"If you have any questions or comments about the grant or your project idea, please contact your Community Network Manager (CNM) or email <a href=\"mailto:pcn@van-division.yarko.dev\">pcn@van-division.yarko.dev</a>"}],"related_resources":[],"related_campaigns":[185,184],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6868"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/184"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/185"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6868"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6868"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6868"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6868"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6695,"date":"2022-10-03T15:53:31","date_gmt":"2022-10-03T15:53:31","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6695"},"modified":"2022-10-03T15:53:31","modified_gmt":"2022-10-03T15:53:31","slug":"fast-facts-september-28-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-september-28-2022/","title":{"rendered":"Fast Facts &#8211; September 28, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9059597","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[166,172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6695"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6695"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6695"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6695"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6695"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6694,"date":"2022-10-03T15:51:00","date_gmt":"2022-10-03T15:51:00","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6694"},"modified":"2022-10-03T15:51:00","modified_gmt":"2022-10-03T15:51:00","slug":"fast-facts-september-14-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-september-14-2022/","title":{"rendered":"Fast Facts &#8211; September 14, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9055409","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[166,172,171]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6694"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6694"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6694"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6694"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6694"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7126,"date":"2022-09-22T10:00:14","date_gmt":"2022-09-22T10:00:14","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7126"},"modified":"2022-10-19T19:17:11","modified_gmt":"2022-10-19T19:17:11","slug":"clinic-grant-report-december-2021-march-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/clinic-grant-report-december-2021-march-2022/","title":{"rendered":"Clinic Grant Report – December 2021-March 2022"},"featured_media":0,"template":"","resource_type":[186,125],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Clinic grant support overview, impact and efficacy report.","resource-introduction":"Clinic grant support overview, impact and efficacy report.","resource-text":"<div class=\"page\" title=\"Page 1\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nBetween December 2021 and March 2022, Vancouver-based primary care clinics received one-time grants to support patient medical home (PMH) related practice improvements. Most of the work focused on improving clinic operations.\r\n\r\n</div>\r\nDownload the PDF infographic report on this page.\r\n\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Report","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/10/VDFP_Clinic-Grant-Report-V7-1.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[186],"related_campaigns":[185],"related_events":[187]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7126"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/187"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/185"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/186"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7126"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7126"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7126"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7126"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6482,"date":"2022-09-14T22:48:44","date_gmt":"2022-09-14T22:48:44","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6482"},"modified":"2022-10-05T17:40:06","modified_gmt":"2022-10-05T17:40:06","slug":"flu-vaccine-faq-2022-23","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/flu-vaccine-faq-2022-23/","title":{"rendered":"Flu Vaccine FAQ 2022/23"},"featured_media":0,"template":"","resource_type":[169],"resource_cat":[],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 1\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis FAQ regroups the major questions asked by Family Physicians and responses from VCH and the Vancouver Division as of <strong>October 4th, 2022</strong>. We will update this FAQ as we receive new information from VCH and further questions from FPs.\r\n\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Access the FAQ","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/10/VDFP_Influenza-2022-V2.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[169],"related_campaigns":[168],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6482"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/169"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6482"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6482"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6482"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6482"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6464,"date":"2022-09-13T23:08:49","date_gmt":"2022-09-13T23:08:49","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6464"},"modified":"2022-09-13T23:44:04","modified_gmt":"2022-09-13T23:44:04","slug":"flu-vaccine-campaign-2022-23","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/flu-vaccine-campaign-2022-23/","title":{"rendered":"Flu Vaccine 2022 VCH Bulletin #1"},"featured_media":0,"template":"","resource_type":[169],"resource_cat":[],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"VCH Influenza Vaccine Campaign 2022-2023: Bulletin #1","resource-introduction":"","resource-text":"The provincial influenza vaccination campaign is set to start in October. Influenza vaccine will be offered to BC residents at community COVID-19 booster clinics, pharmacies, as well as physician and nurse practitioner offices. Vancouver Coastal Health has released a bulletin more information about eligibility, ordering and distribution.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Bulletin","resource-button_link":"http://www.vch.ca/Documents/PhysicianNPUpdate_InfluenzaVaccineCampaign_Bulletin1.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[169],"related_campaigns":[168],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6464"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/169"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6464"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6464"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6464"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6464"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7130,"date":"2022-09-13T10:00:47","date_gmt":"2022-09-13T10:00:47","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7130"},"modified":"2022-10-19T19:18:02","modified_gmt":"2022-10-19T19:18:02","slug":"security-technology-project-report-january-march-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/security-technology-project-report-january-march-2022/","title":{"rendered":"Security &#038; Technology Project Report – January-March 2022"},"featured_media":0,"template":"","resource_type":[125],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Infographic report on the quality, impact and suggestions.","resource-introduction":"Infographic report on the quality, impact and suggestions.","resource-text":"<div class=\"page\" title=\"Page 1\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nDivision members were invited to participate in an assessment of their virtual or in-clinic security and technology. The assessment was intended to support onboarding to CareConnect and Pathways, two key elements of an information technology enabled Patient Medical Home. Each provincial portal requires adherence to protocols and standards.\r\n\r\nPhysicians completed the assessments which involved documenting the current state of their systems (virtual environments and in-office environments) through a phone interview or by completing a DTO/Vancouver Division needs assessment; meeting with a consultant who completed an on-site assessment and produced a scorecard that included recommendations; and completing an end- of-project survey.\r\n\r\nDownload the PDF infographic report on this page.\r\n\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Report","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/10/VDFP_SecurityTechnology-Project-Report-V4.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[70],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7130"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/70"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7130"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7130"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7130"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7130"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6446,"date":"2022-09-12T16:06:26","date_gmt":"2022-09-12T16:06:26","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6446"},"modified":"2022-09-12T16:06:49","modified_gmt":"2022-09-12T16:06:49","slug":"ltci-physician-statement-of-interest","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/ltci-physician-statement-of-interest/","title":{"rendered":"LTCI Physician Statement of Interest"},"featured_media":0,"template":"","resource_type":[180],"resource_cat":[78],"catalogue":[],"acf":{"post-icon":2269,"post-excerpt":"A physician statement of interest for working in a long term care home.","resource-introduction":"","resource-text":"If you are interested in getting more information about working with a care home, or would like to note your interest for future long term care opportunities, please complete and return the <a href=\"https://vandivision.wpengine.com/wp-content/uploads/2021/03/LTCI-Physician-Statement-of-Interest-2.pdf\">LTCI Physician Statement of Interest</a> form.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Access the Form","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/09/LTCI-Physician-Statement-of-Interest-2.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[180],"related_campaigns":[152,179],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6446"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/180"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6446"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6446"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6446"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6446"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6261,"date":"2022-09-01T02:18:31","date_gmt":"2022-09-01T02:18:31","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6261"},"modified":"2022-09-01T02:18:31","modified_gmt":"2022-09-01T02:18:31","slug":"fast-facts-august-31-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-august-31-2022/","title":{"rendered":"Fast Facts &#8211; August 31, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/youre-invited-for-a-sneak-peek-9052197","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174,74,129],"related_campaigns":[],"related_events":[166,178,172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6261"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/178"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6261"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6261"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6261"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6261"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6257,"date":"2022-09-01T01:58:34","date_gmt":"2022-09-01T01:58:34","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6257"},"modified":"2022-09-01T01:58:34","modified_gmt":"2022-09-01T01:58:34","slug":"funding-for-clinical-observerships","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/funding-for-clinical-observerships/","title":{"rendered":"Funding for Clinical Observerships"},"featured_media":0,"template":"","resource_type":[175],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"Douglas College has obtained funding to support their clients with obtaining Clinical Observerships.","resource-introduction":"","resource-text":"The Career Paths for Skilled Immigrants program aims to help skilled immigrants gain their license to practice and find work in their field of expertise. As part of Career Paths' goal to help IMGs gain exposure and strengthen their CaRMS applications, Douglas College has obtained funding to support their clients with obtaining Clinical Observerships.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Learn More","resource-button_link":"https://mcusercontent.com/a11596f5ef77e17a39fbb52d3/files/46e0b6d5-6f89-27d4-7904-0281ee30b5b7/Career_Paths_Clinical_Observership_Funding.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[170],"related_campaigns":[],"related_events":[156,166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6257"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/170"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6257"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6257"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6257"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6257"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6256,"date":"2022-09-01T01:56:03","date_gmt":"2022-09-01T01:56:03","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6256"},"modified":"2022-10-01T09:07:18","modified_gmt":"2022-10-01T09:07:18","slug":"new-supports-for-family-doctors","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/new-supports-for-family-doctors/","title":{"rendered":"New Supports for Family Doctors"},"featured_media":0,"template":"","resource_type":[170],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"This interim funding will work to keep your doors open while a new payment model is introduced and implemented.","resource-introduction":"","resource-text":"The Ministry of Health and Doctors of BC are providing $118 million in stabilization funding to family doctors throughout the province. This interim funding will work to keep your doors open while a new payment model is introduced and implemented.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Full Announcement","resource-button_link":"https://news.gov.bc.ca/releases/2022HLTH0172-001282","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[170],"related_campaigns":[],"related_events":[171]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6256"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/170"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6256"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6256"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6256"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6256"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6255,"date":"2022-09-01T01:48:57","date_gmt":"2022-09-01T01:48:57","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6255"},"modified":"2022-09-01T01:50:31","modified_gmt":"2022-09-01T01:50:31","slug":"covid-19","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/covid-19/","title":{"rendered":"COVID-19 Resource Collection"},"featured_media":0,"template":"","resource_type":[74,124],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Stay up-to-date on clinical guidelines, support for your practice, and patient resources.","resource-introduction":"","resource-text":"Stay up-to-date on clinical guidelines, support for your practice, and patient resources.\r\n\r\n<strong>Canada COVID-19 Epidemiology Update</strong> - <a href=\"https://health-infobase.canada.ca/covid-19/#_blank\" target=\"_blank\" rel=\"noopener\">Click Here</a>\r\n\r\n<strong>Provincial COVID-19 Data (and Vaccine) Dashboard</strong> - <a href=\"https://experience.arcgis.com/experience/a6f23959a8b14bfa989e3cda29297ded\" target=\"_blank\" rel=\"noopener\">Click Here</a>\r\n\r\n<strong>COVID-19 Vaccination Updates</strong> - <a href=\"https://www2.gov.bc.ca/gov/content/covid-19/vaccine/plan\" target=\"_blank\" rel=\"noopener\">BC Government</a> | <a href=\"http://www.bccdc.ca/health-info/diseases-conditions/covid-19/covid-19-vaccine\" target=\"_blank\" rel=\"noopener\">BCCDC</a>\r\n\r\n<strong>Clinical Practice Guide</strong> - <a href=\"http://www.bccdc.ca/Health-Professionals-Site/Documents/COVID-treatment/ClinicalPracticeGuide_Evusheld.pdf\" target=\"_blank\" rel=\"noopener\">The use of Evusheld</a>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[174],"related_campaigns":[168,152],"related_events":[156]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6255"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/174"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6255"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6255"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6255"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6255"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6253,"date":"2022-09-01T01:45:09","date_gmt":"2022-09-01T01:45:09","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6253"},"modified":"2022-09-01T01:50:16","modified_gmt":"2022-09-01T01:50:16","slug":"monkeypox","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/monkeypox/","title":{"rendered":"Monkeypox Resource Collection"},"featured_media":0,"template":"","resource_type":[124,174],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Stay up-to-date on clinical guidelines and emerging information.","resource-introduction":"Stay up-to-date on clinical guidelines and emerging information.","resource-text":"<strong>Monkeypox Surveillance Report</strong> - <a href=\"http://www.bccdc.ca/Health-Info-Site/Documents/Monkeypox/Epidemiological_Summary/MPX_Epi_Summary_20220822.pdf\" target=\"_blank\" rel=\"noopener\">An epidemiological summary</a> released on August 22, 2022.\r\n\r\n<strong>Monkeypox General Update</strong> - Stay up to date on the province’s <a href=\"http://www.bccdc.ca/health-professionals/clinical-resources/monkeypox\" target=\"_blank\" rel=\"noopener\">active cases, immunization and treatment</a>.\r\n\r\n<strong>Vaccine Appointments - </strong><a href=\"https://vchcdimms.janeapp.com/\" target=\"_blank\" rel=\"noopener\">Appointments available</a> for the Imvamune vaccine.\r\n\r\n<strong>Clinical Resources</strong> - <a href=\"https://www.picnet.ca/wp-content/uploads/MonkeyIPACGuidanceHC_08Aug2022Final.pdf\" target=\"_blank\" rel=\"noopener\">Interim Infection Prevention and Control Guidance</a> for Monkeypox in Health Care Settings.\r\n\r\n&nbsp;\r\n\r\n<em>UPDATED August 31, 2022</em>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[74],"related_campaigns":[168,152],"related_events":[156]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6253"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/74"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6253"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6253"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6253"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6253"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6151,"date":"2022-08-30T07:22:24","date_gmt":"2022-08-30T07:22:24","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6151"},"modified":"2022-08-30T07:22:24","modified_gmt":"2022-08-30T07:22:24","slug":"fast-facts-august-16-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-august-16-2022/","title":{"rendered":"Fast Facts &#8211; August 16, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/fast-facts-9048589","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[126],"related_campaigns":[165,168],"related_events":[171]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6151"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6151"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6151"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6151"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6151"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6147,"date":"2022-08-30T07:19:51","date_gmt":"2022-08-30T07:19:51","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6147"},"modified":"2022-08-30T07:19:51","modified_gmt":"2022-08-30T07:19:51","slug":"fast-facts-august-3-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-august-3-2022/","title":{"rendered":"Fast Facts &#8211; August 3, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/fast-facts-9045633","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[126],"related_campaigns":[168,165],"related_events":[171]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6147"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/171"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6147"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6147"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6147"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6147"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6035,"date":"2022-08-29T22:25:08","date_gmt":"2022-08-29T22:25:08","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6035"},"modified":"2022-10-04T20:20:48","modified_gmt":"2022-10-04T20:20:48","slug":"primary-care-crisis-event-resources","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/primary-care-crisis-event-resources/","title":{"rendered":"Primary Care Crisis Event: Overview and FAQ"},"featured_media":0,"template":"","resource_type":[170,125],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"Learn about the answers to FAQs we heard from members at our Primary Care Crisis event.","resource-introduction":"","resource-text":"On July 21st, 2022, the Vancouver Divisions of Family Practice hosted an event to allow members to gather in person and online to hear from partner organizations on what they are doing to address the current primary care crisis in Vancouver. Leaders from the Doctors of BC, BC Family Doctors, The College of BC Family Doctors and the General Practice Services Committee attended to share their ongoing plans to support family doctors in the province.\r\n\r\n60 Members attended the in-person event at the Arbutus Club and over 120 members joined in online to hear from the partners and bring their questions forward.\r\n\r\nBelow you will find useful information and links from the event.\r\n<h2>Your Partners</h2>\r\n&nbsp;\r\n<table>\r\n<tbody>\r\n<tr>\r\n<th>Partner</th>\r\n<th>Representative(s)</th>\r\n<th>Partner Mission</th>\r\n<th>Partner Advocacy</th>\r\n</tr>\r\n<tr>\r\n<td><a href=\"https://www.doctorsofbc.ca/about-us\" target=\"_blank\" rel=\"noopener\"><span data-contrast=\"none\">Doctors of BC</span></a></td>\r\n<td>Dr. Brenda Hefford – Vice President</td>\r\n<td>To promote a social, economic, and political climate in which members can provide British Columbians with the highest standard of health care, while achieving maximum professional satisfaction and fair economic reward.</td>\r\n<td><a href=\"https://www.doctorsofbc.ca/advocacy-policy/advocacy/areas-focus/advocating-primary-care\" target=\"_blank\" rel=\"noopener\">Advocating for Primary Care</a> &amp; <a href=\"https://www.doctorsofbc.ca/presidents-letter/primary-care-consultation-update\" target=\"_blank\" rel=\"noopener\">President’s Letter – August 8<sup>th</sup> 2022</a></td>\r\n</tr>\r\n<tr>\r\n<td><a href=\"https://bcfamilydocs.ca/about-us/\" target=\"_blank\" rel=\"noopener\">BC Family Doctors</a></td>\r\n<td>Dr. Renee Fernandez – Executive Director</td>\r\n<td>BC Family Doctors advocates for the economic and professional well-being of family doctors in BC. Our purpose is to build an environment where family doctors thrive.</td>\r\n<td><a href=\"https://bcfamilydocs.ca/wp-content/uploads/2022/04/BCFD_Toolkit_FINAL.pdf\" target=\"_blank\" rel=\"noopener\">Speak out for Family Medicine Toolkit</a> &amp; <a href=\"https://bcfamilydocs.ca/everyone-deserves-a-family-doctor/\" target=\"_blank\" rel=\"noopener\">Social Media Campaign</a></td>\r\n</tr>\r\n<tr>\r\n<td><a href=\"https://gpscbc.ca/what-we-do\" target=\"_blank\" rel=\"noopener\">General Practice Services Committee</a></td>\r\n<td>Dr. Sari Cooper – Co-Chair</td>\r\n<td>Strengthen longitudinal family practice as the foundation of an integrated system of care.</td>\r\n<td></td>\r\n</tr>\r\n<tr>\r\n<td><a href=\"https://bccfp.bc.ca/about-us/\" target=\"_blank\" rel=\"noopener\"><span data-contrast=\"none\">BC College of Family Physicians</span></a></td>\r\n<td><span data-contrast=\"auto\">Dr. David May – President </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559740&quot;:259}\"> </span><span data-contrast=\"auto\">Toby Achtman – Executive Director</span></td>\r\n<td>Leading family medicine to improve the health of all people in Canada—by setting standards for education, certifying and supporting family physicians, championing advocacy and research, and honouring the patient-physician relationship as being core to the profession.</td>\r\n<td><a href=\"https://bccfp.bc.ca/wp-content/uploads/2022/04/AdvocacyToolKit_FINAL.pdf\" target=\"_blank\" rel=\"noopener\"><span data-contrast=\"none\">Advocacy Tool Kit</span></a><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335551550&quot;:2,&quot;335551620&quot;:2,&quot;335559740&quot;:259}\"> </span></td>\r\n</tr>\r\n<tr>\r\n<td><a href=\"https://health.ubc.ca/\" target=\"_blank\" rel=\"noopener\"><span data-contrast=\"none\">University of British Columbia</span></a><span data-contrast=\"auto\"> </span></td>\r\n<td><span data-contrast=\"none\">Dr. Christie Newton – Associate Head Education and Engagement, Department of Family Practice /Associate Vice President Health </span><i><span data-contrast=\"none\">pro tem</span></i><span data-contrast=\"none\"> </span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559740&quot;:259}\"> </span></td>\r\n<td><span data-contrast=\"auto\">Connecting people, ideas, and actions to advance health outcomes, equity, and systems</span><span data-ccp-props=\"{&quot;201341983&quot;:0,&quot;335559740&quot;:259}\"> </span></td>\r\n<td></td>\r\n</tr>\r\n</tbody>\r\n</table>\r\n&nbsp;\r\n\r\n<span class=\"TextRun SCXW99874672 BCX9\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW99874672 BCX9\">Additional </span><span class=\"NormalTextRun SCXW99874672 BCX9\">ways to get involved</span><span class=\"NormalTextRun SCXW99874672 BCX9\">:</span></span>\r\n<ul>\r\n \t<li><a class=\"Hyperlink SCXW99874672 BCX9\" href=\"https://bchealthcarematters.com/\" target=\"_blank\" rel=\"noreferrer noopener\"><span class=\"TextRun Underlined SCXW99874672 BCX9\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW99874672 BCX9\" data-ccp-charstyle=\"Hyperlink\">BC Health Care Matters</span></span></a></li>\r\n \t<li><a href=\"https://bccfp.bc.ca/myfamilydoctorcares/\" target=\"_blank\" rel=\"noopener\"><span class=\"TextRun SCXW99874672 BCX9\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"auto\"><span class=\"NormalTextRun SCXW99874672 BCX9\">My Family Doctor Cares</span></span></a></li>\r\n \t<li><a class=\"Hyperlink SCXW99874672 BCX9\" href=\"https://thetyee.ca/News/2022/08/12/The-Vancouver-Plan-Seven-Minutes/?utm_source=daily&amp;utm_medium=email&amp;utm_campaign=120822\" target=\"_blank\" rel=\"noreferrer noopener\"><span class=\"TextRun Underlined SCXW99874672 BCX9\" lang=\"EN-US\" xml:lang=\"EN-US\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW99874672 BCX9\" data-ccp-charstyle=\"Hyperlink\">The Vancouver Plan, in Seven Minutes</span></span></a></li>\r\n</ul>\r\n<img class=\"alignnone wp-image-6036 size-full\" src=\"http://van-division.yarko.dev/wp-content/uploads/2022/08/HopesForTheFuture.jpeg\" alt=\"\" width=\"720\" height=\"405\" />\r\n<h2>FAQ</h2>\r\nThe following questions were asked by our in-person and online members during the event. Our partners have provided the following answers as applicable.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":true,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":[{"resource-acc-item-title":"What is the future of the fee for service (FFS) payment model?","resource-acc-item-content":"<p>Question:</p>\r\n<p>What do you think lies ahead for the future of the fee for service payment model? Is FFS being slowly phased out in favour of alternative payment models? Is FFS being negotiated in the PMA with complexity and time modifiers - also gender inequalities?</p>\r\n\r\n<p>Responses:</p>\r\n\r\n<p><strong>BC Family Doctors</strong></p>\r\n\r\n<p>There is no one good answer on how to pay a FP. All the needs are different because everyone has different panel types. The idea of a single model is not going to work. We need a menu of good options. FFS is not a problem but it manifests in BC as a problem – there are jurisdictions in the country where FFS work and these are ones where they promote relationship and the role it has in high quality patient care. We need to modernize it to not be a burden to bill. We know everyone doesn’t want to be FFS so the question is whether we can create several good models all with an increased funding basket.</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>Negotiations being done based on fees and they are making something to see what benefits family medicine. They have reduced the fees for corporations. The College has also collected data on all the remuneration model and the evidence is strong that one size doesn’t fit all. Point towards a blended model</p>"},{"resource-acc-item-title":"Why are practices responsible for the costs of EMRs?","resource-acc-item-content":"<p>Question:</p>\r\n<p>EMRs are tools that we use to help the patients and using them properly will affect the patient care. The prices are going up significantly and are hard to afford. Why does the government not pay for the EMR?</p>\r\n\r\n<p>Response:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>We agree that there needs to be simpler and fewer EMRs that talk to each other. Each individual practice having to negotiate data transfers is unacceptable. Conversations have happened.</p>"},{"resource-acc-item-title":"Why is so much of the funding for primary care in BC used for administration rather than patient care?","resource-acc-item-content":"<p>Question:</p>\r\n<p>I do not think the BC system is poorly funded. Where has the money gone? There are a lot of administrative wages. Every time we complain about anything, a pilot project is made that has already been done and no one is checking. How do we move the funding to patient care vs. an administrative person that doesn't get back to us. Why do we have so many administrative people in your system?</p>\r\n\r\n<p>Responses:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>The health authorities shouldn’t be where the funding goes. The government has agreed to take a look at that. There are ways the health authorities work that add to the burdens rather than supporting the systems of primary care. We need to look at what the health authorities role in primary care is. They should be supporting – not adding to the burdens.</p>\r\n\r\n<p><strong>GPSC</strong></p>\r\n\r\n<p>We have been working with Divisions and other organizations to run engagement sessions in hopes of listening to the voice of the physicians. We have heard that PCN is a burden when it should be a benefit. GPSC's role is to work on this. We are hopeful that we can make change in where the power lies in the community and the design of the system in the near future.</p>"},{"resource-acc-item-title":"There are some concerns with the new contracts (new to practice and group). Instead, could the fee-for-service payment model be improved to include time spent doing paperwork?","resource-acc-item-content":"<p>Question:</p>\r\n<p>I would love to do community care but I do hospital now. A lot of people are scared to enter a contract because there are a number of requirements, such as numbers in your patient panel, etc. Are people aware of this issue? Would there be FFS but include paperwork? I am asking about both contracts (NTP and group).</p>\r\n\r\n<p>Responses:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>Even within FFS, we aren’t pure FFS. Some of the fees like the CLFP is not an actual fee. You do something, you get paid for it. Sometimes we get caught in the terminology.\r\n– Contracts – within family physician world, NTP and group contracts. Have been developed, have pros and have cons. Still not valued at the level they should be valued. They are complex and there are a lot of pages to them. There are restrictions on who can access them. However, a lot of the doctors on the contracts feel there is improvement.</p>\r\n\r\n<p><strong>BC College of Family Physicians</strong></p>\r\n\r\n<p>Worries about the debate re: contract and FFS. FP doing longitudinal care are not paid adequately but because of compensation. We need to compensate giving good quality care.</p>\r\n\r\n<p><strong>GPSC</strong></p>\r\n\r\n<p>We are looking at different ways to measure attachment while minimizing burden.</p>\r\n\r\n<p><strong>University of BC</strong></p>\r\n\r\n<p>The College is looking at panel sizes and capitation models. The patient requirements haven’t factored complexity.</p>"},{"resource-acc-item-title":"Do specialists agree that support for family doctors is needed?","resource-acc-item-content":"<p>Question:</p>\r\n<p>Where are the specialists as to engaging with the idea that more funding needs to go to family medicine?</p>\r\n\r\n<p>Response:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>Within the engagement work, we have had a lot of feedback from specialists as well. They agree that support for family doctors is needed. Inequity in the specialist world exists as well and we won’t fix it all tomorrow, but shows another reason why the parallel track is needed. Rise of staffing, overhead, etc. they are also having some of these challenges.</p>"},{"resource-acc-item-title":"What is happening to alleviate the large overhead costs for family practices in Vancouver?","resource-acc-item-content":"<p>Question:</p>\r\n<p>Robust amount for overhead in family medicine - is this something that DoBC is working towards?</p>\r\n\r\n<p>Response:<p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>We are. It is one of the areas that shows flaws in the system. The MOH is sets their own bars with what they are offering their new to practice doctors. We have something that can be pushed on.</p>"},{"resource-acc-item-title":"Are there any updates with how the PCNs are governed?","resource-acc-item-content":"<p>Question:</p>\r\n<p>Role of health authorities in PCN. We know the struggles. In this space, PCNs were designed to support family medicine. How can we have PCN reform if there's no flexibility in the governance?</p>\r\n\r\n<p>Responses:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>The intent behind PCN governance was to give more of a voice to the practitioners but the opposite has happened. Let’s say we get PCN governance through this. The PCN still has from the funding from the government where certain decisions are made. That shows there is an issue and a problem. The GPSC will take leadership and the Divisions need to be a part of the leadership for representation.</p>\r\n\r\n<p><strong>BC College of Family Physicians</strong></p>\r\n\r\n<p>The PCN is PMH – PCN is not a PMH. The two are not the same. We need to do a lot of work to get our clinics to be PMHs. PCN is a building block for PMH. They are linked but not the same thing.</p>\r\n\r\n<p><strong>GPSC</strong></p>\r\n\r\n<p>This is where GPSC fits in well. We hear this from every Division. Almost all Division have this problem. All the PCN pieces need to be coordinated and integrated where patients have agency.</p>"},{"resource-acc-item-title":"Will there be more compensation for physicians to teach family practice?","resource-acc-item-content":"<p>Question:</p>\r\n<p>As a UBC instructor, we spend a half day with Med students in LTC and we only get pair $90 for a session from UBC. Even the hourly rate has not been updated for years and is much less than sessional pay. Why would anyone choose to teach - what it takes out of practice and with the current compensation? Poor pay, less offices, less family physicians willing to take learners, so who is training new family physicians? Who would want to be an underpaid, overworked small business owner?</p>\r\n\r\n<p>Response:</p>\r\n\r\n<p><strong>University of BC</strong></p>\r\n\r\n<p>There is currently a pilot project funded by the Ministry of Health aimed at improving practice based teaching for family practice residents. Preceptors involved in the project receive 0.1FTE (approx. $17,500/year) to take on 2 family practice residents (each resident in their clinic for 4 months) It is a 3 year project and if we demonstrate improved recruitment and retention to these teaching clinics the MOH may fund a phase two to expand to additional clinics. UBC also needs to recognize the value of clinical education. The Faculty of Medicine is underfunded compared to other faculties of the University. There is ongoing advocacy for improved remuneration for clinical education. That noted there is poor understanding of the different costs of community based practice vs. facility based practice (ex. ambulatory specialty clinics). There is a growing understanding that in order to sustain clinical education within the community to ensure grads are work force ready, we need to transform the system to better support the clinical learning environment. We need to support the teachers.</p>\r\n\r\n<p>We already know that 90% of students have no intent of working primary care. This is primarily because they don’t have the team support.</p>"},{"resource-acc-item-title":"Can business training be added to the FP residency program?","resource-acc-item-content":"<p>Question:</p>\r\n<p>UBC - can you have a community doctor do a business class? It's difficult to negotiate with doctors that do not understand overhead. </p>\r\n\r\n<p>Response:</p>\r\n\r\n<p><strong>University of BC</strong></p>\r\n\r\n<p>There are significant challenges with adding to the residency curriculum. There are so many things – like business management, point of care ultrasound, dermoscopy, cultural safety and humility, virtual care, post and long covid care, complex care, health system leadership, …The issue has become what can be removed to allow for things to be added? The other issue is that in order to preserve mental health and work life balance, residents have fewer clinical education days per year (ie; on average a resident will work 176 days per year) To address this the CFPC has proposed to extend residency. The key will be to create a very different – ie; community based, service oriented, extension to better support a transition to practice.</p>"},{"resource-acc-item-title":"Is there a way that partners can help with MOA retention?","resource-acc-item-content":"<p>Question:</p>\r\n<p>Can the ministry provide a MOA teaching course? I cannot keep up after I train them and they get a higher paying job.</p>\r\n\r\n<p>Response:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>The value of MOA has come up over and over again. The need to support the MOA, pay the MOA etc. has come out very strongly in the engagement.</p>\r\n"},{"resource-acc-item-title":"What is happening around group contracts, pensions and benefits for family practice?","resource-acc-item-content":"<p>Question:</p>\r\n<p>It took me so long to get on a PCN group contract and I asked for help repeatedly and was not given any. There are options in the contract at the start but they were made no longer options from the MOH after I got on it. The MOH opposes our rules. Doctors of BC was nowhere to be found to help us. We only went on a contract to save our practice. Who is handling the negotiations at Doctors of BC? We don't have pensions or benefits and it is so demoralizing. Months have gone by and we need to rely on the media. Where are the negotiations? I can make $300,000 without overhead working at the hospital vs. $90,000 + 40% overhead. We should be telling the young grads this instead of trying to get them into a contract. This system needs to be more transparent. It can't take years to figure this out.</p>\r\n\r\n<p>Responses:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>One of the things communicated today was that we need answers for the Fall. There are too many flaws in the current system. The funder needs to change the way things are done.</p>\r\n\r\n<p><strong>GPSC</strong></p>\r\n\r\n<p>We need to change the infrastructure – community FPs carry the weight. Admin burdens are different as we are “relationship professionals” – it is a service driven and mission driven profession.We need change to happen this calendar year. We have less than 6 months to figure this out. We are going to fight like hell.</p>"},{"resource-acc-item-title":"Will family practitioners get paid more, like in the UK?","resource-acc-item-content":"<p>Question:</p>\r\n<p>In the UK, FPs are paid higher than any other specialty. If we truly value primary care, we as a society should put our money where our mouth is and address the disparity/inequity in remuneration.</p>\r\n\r\n<p>Responses:</p>\r\n\r\n<p><strong>Doctors of BC</strong></p>\r\n\r\n<p>The reality is that family medicine is the least compensated specialty that you can go to. All of you toiling in your practices, can likely make more doing other things. Yet, it’s the bedrock of the system. I don’t think we’ll get to the point where we are paid the most, but at the bare minimum, we should be paid equitabilty to other specialties. This is what Docs of BC has advocated for.</p>\r\n\r\n<p><strong>BC College of Family Physicians</strong></p>\r\n\r\n<p>There needs to be huge advance for doctors in BC. Community FPs needs to be paid at a higher rate than a hospitalists for example. Equitable is a good step forward but we need to do more than that!</p>"}],"related_resources":[163],"related_campaigns":[],"related_events":[172]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6035"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/172"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6035"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6035"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6035"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6035"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":6031,"date":"2022-08-29T17:05:16","date_gmt":"2022-08-29T17:05:16","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=6031"},"modified":"2022-09-13T23:39:08","modified_gmt":"2022-09-13T23:39:08","slug":"flu-vaccine-2021-findings","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/flu-vaccine-2021-findings/","title":{"rendered":"Flu Vaccine Delivery Program Report 2021"},"featured_media":0,"template":"","resource_type":[169,125],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"Vancouver Division findings from the 2021/22 Flu Vaccine Delivery Program.","resource-introduction":"Flu Vaccine Delivery Program 2021/22","resource-text":"<div class=\"page\" title=\"Page 1\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThe Vancouver Division of Family Practice partnered with Vancouver Costal Health to provide flu vaccines to Vancouver clinics. The program was promoted between September 2021 and January 2022. Clinics could select to have vaccines delivered directly to their offices or to pick them up from their local Community Health Clinic. Sixty-nine physicians completed the program evaluation survey which represents approximately 35% of participating clinics. Among survey respondents, 47% had their vaccines delivered, 37% picked up their vaccines, and 16% took advantage of both options. The cost per delivery was $33.90.\r\n\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Report","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/08/VDFP_Flu-Vaccine-Delivery-Program-Report.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[169,125],"related_campaigns":[168],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/6031"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/168"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/125"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/169"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=6031"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=6031"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=6031"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=6031"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5871,"date":"2022-08-03T20:44:14","date_gmt":"2022-08-03T20:44:14","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5871"},"modified":"2023-09-18T21:47:24","modified_gmt":"2023-09-18T21:47:24","slug":"2023-membership-vote","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/2023-membership-vote/","title":{"rendered":"2023 Membership Vote Details"},"featured_media":0,"template":"","resource_type":[167,128],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Information on timelines and the nomination process.","resource-introduction":"","resource-text":"<h5>Introduction</h5>\r\nThere are two parts to the membership vote this year, with eligible members voting via online ballot between September 28 and October 12. They two parts of the this year's vote are:\r\n<ol>\r\n \t<li style=\"list-style-type: none;\">\r\n<ol>\r\n \t<li><strong>The 2023 Board of Directors Election</strong> - This year there are six (6) board of director positions open for election: five (5) FP Member Director positions and one (1) Resident Member Director position. <a href=\"https://forms.office.com/r/YNeMucfLEX\" target=\"_blank\" rel=\"noopener\">Click here</a> for the nominations form. Nominations period is Thu, August 17 to Monday, September 11. <strong>UPDATE</strong> - Nominations have now closed. Because there are more available board positions than candidates, there will not be a board of directors election.</li>\r\n \t<li><strong>Bylaw Changes</strong> - The membership will be asked to consider two bylaw changes as part of this year's membership vote. One is to add clarity on the appointment of Directors during vacancies and the other is to create a Past Chair Role.</li>\r\n</ol>\r\n</li>\r\n</ol>\r\n&nbsp;\r\n<h5>Choosing Between Board Participation Versus Project Participation</h5>\r\nIn compliance with the BC Societies Act, if a member is elected to the board of directors of the Vancouver Division, they are ineligible to engage and be remunerated for any activities at the day-to-day operations and programming level of the Division. Meaning a member must choose between being a board member OR participating in committees, working groups, programs or projects. A member cannot be remunerated for both. For a detailed chart on the difference, please <a href=\"https://vdofp.sharepoint.com/:b:/g/EXkPBaTRcOBJkWtWPu5OlO0B31p-nOB6LwWANAVWSNtmBQ?e=Doydyd\" target=\"_blank\" rel=\"noopener\">click here.</a>\r\n\r\n<strong><em>Are there any exceptions? </em></strong>Yes, there is one exception, which is for members interested in serving on the board who are also officially a part of the Vancouver Division’s Long-Term Care Initiative program.\r\n<h5>Additional Information</h5>\r\nPlease login to see additional information on the above along with details on eligibility, timelines, and the proposed bylaw changes. Election results will be announced and ratified at the <a href=\"https://van-division.yarko.dev/initiative/annual-general-meeting-2023/\">Annual General Meeting</a>.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":true,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":[{"resource-acc-item-title":"What are the important dates?","resource-acc-item-content":"<b>Nomination Period:</b> Thursday, August 17th, 2023 at 12:00:00 am PT – Monday, September 11th, 2023 at 11:59:59 pm PT. You can find the nominations form <a href=\"https://forms.office.com/r/YNeMucfLEX\" target=\"_blank\" rel=\"noopener\">here</a>.<br>\r\n<br>\r\n<b>Voting Period:</b> Thursday, September 28th 2023 at 12:00:00 am PT – Thursday, October 12th, 2023 at 11:59:59 pm PT.\r\n"},{"resource-acc-item-title":"How do I vote?","resource-acc-item-content":"Voting for both the board elections and bylaw changes will take place through an electronic voting process facilitated by <a href=\"http://www.simplyvoting.com/\" target=\"_blank\" rel=\"noopener\">www.simplyvoting.com</a>. Members eligible to vote will be sent an email on September 28th with a unique link to access their online ballot. Members will be required to cast votes for the full number of vacancies on the board. The voting period is between Thursday, September 28th at 12:00am PT and Thursday, October 12th at 11:59pm PT. Election results will be announced and ratified at the <a href=\"https://VancouverDivisionAGM.eventbrite.ca/?aff=Website\" target=\"_blank\" rel=\"noopener\">Annual General Meeting</a>, taking place on the evening of Thursday, October 19th, 2023."},{"resource-acc-item-title":"Who is eligible to run for a board position?","resource-acc-item-content":"Candidates must be a general member in good standing with the Division and the College of Family Physicians to be on the Board of Directors.<br><br>\r\nActively Practicing and Resident members are eligible for election to the board and to participate in the membership vote. Retired members, as associate members, are not eligible to participate.\r\n"},{"resource-acc-item-title":"What board positions are available this year?","resource-acc-item-content":"<b>Board Composition:</b> The board is comprised of 8 members – seven (7) FP Member Directors and one (1) Resident Member Director physician.<br><br>\r\n\r\n<b>Positions Up for Election:</b> For this year’s election, there are six (6) board of director positions open for election – five (5) FP Member Director positions and one (1) Resident Member Director position.<br><br>\r\n\r\n<i>Please note: All applications received will undergo an initial review by the Vancouver Division’s Nominations Committee.</i>"},{"resource-acc-item-title":"If I have a board member, can I still do project work of the Division and be remunerated for it?","resource-acc-item-content":"In accordance with the BC Societies Act, the Division constitution and bylaws (when updated in 2016) provide clear policies and procedures that govern the role of a board member.<br><br>\r\n\r\n<b>How is governance leadership defined in the current bylaws and constitution?</b><br><br>\r\n\r\nAs described in the BC Societies Act there must be a separation between the people who provide leadership for the overall governance of the organization and the people who provide leadership by actively engaging in the work of the Division at the committee or program level.<br><br>\r\n\r\n<b>What does that mean if you are considering being on the Board of Directors?</b><br><br>\r\n\r\nIf a member is elected to the board of directors of the Vancouver Division, they are ineligible to engage and be remunerated for any activities at the day-to-day operations and programming level of the Division. Meaning a member must choose between being a board member OR participating in committees, working group, programs or projects. A member cannot be remunerated for both.<br><br>\r\n\r\nFor a detailed chart on the difference, please <a href=\"https://vdofp.sharepoint.com/:b:/g/EXkPBaTRcOBJkWtWPu5OlO0B31p-nOB6LwWANAVWSNtmBQ?e=Doydyd\" target=\"_blank\" rel=\"noopener\">click here.</a><br><br>\r\n\r\n<b>Are there any exceptions?</b><br><br>\r\n\r\nThere is one exception, which is for members interested in serving on the board who are also officially a part of the Vancouver Division’s Long-Term Care Initiative program."},{"resource-acc-item-title":"How do I put myself forward as a candidate for the board?","resource-acc-item-content":"Find the nominations form <a href=\"https://forms.office.com/r/YNeMucfLEX\" target=\"_blank\" rel=\"noopener\">here</a>\r\n"},{"resource-acc-item-title":"Is there a role description for the board of directors?","resource-acc-item-content":"Yes, we have created a short role description that explains the role of the board. <a href=\"https://vdofp.sharepoint.com/:b:/g/ERdIe4vj6cxHrD8WMOA3pR0B58G3b8B9d7tosNtSwdWYWg?e=fMfE1V\" target=\"_blank\" rel=\"noopener\">Click here</a> to read it. If you are considering a board position, we have also compiled some <a href=\"https://vdofp.sharepoint.com/:b:/g/Ef-MsIFWrixJoRKqXPPbNtUB0tNRQe0pi8aqiw7etKVgng?e=eNgNBh\" target=\"_blank\" rel=\"noopener\">key points for you to consider</a>. "},{"resource-acc-item-title":"What are the bylaw amendment being proposed this year?","resource-acc-item-content":"The Division membership will be asked to consider and vote on two changes to the organization's bylaws. Voting on the bylaw changes will done at the same time and same ballot as the board election.<br><br>\r\n\r\n<b>Proposed Bylaw Change 1: Appointment of Directors</b><br><br>\r\n\r\n<u>Context</u><br>\r\nThe following proposed change to the Bylaws enables the Board to appoint Directors to fill Board vacancies (for a one-year term) in the event that the number of available seats exceeds the number of members who run, in a given year. <br><br>\r\n\r\nCurrently, the Board can only appoint a new Director if a sitting Director exits their seat early. Should seats remain unfilled after election, the Division is at risk of having fewer Directors than required for the Board. An appointed seat would re-open for election in the following year. <br><br>\r\n\r\n<u>Motion</u><br>\r\nMotion – That the wording of Section 7.9 be amended as follows: <b><i>If a Director ceases to hold office before the expiry of his or her term, or there are vacant seats after the election pursuant to 5.1(f), the Board, by Board Resolution, may appoint a Member qualified in accordance with section 7.5. to fill the resulting vacancy. </b></i><br><br>\r\n\r\n<a href=\"https://vdofp.sharepoint.com/:b:/g/EZgliEU8T1tLlcDRg9JzT2MBQUQOz2uTQj0mRaupyVVCXg?e=kdMBdb\" target=\"_blank\" rel=\"noopener\">Click here</a> for a full description.<br><br>\r\n\r\n<b>Proposed Bylaw Change 2: Creation of a Past Chair Role</b><br><br>\r\n\r\n<u>Context</u><br>\r\nThe following proposed change to the Bylaws creates the position of Past Chair, enabling a Chair who has completed six consecutive years on the Board to sit on the Board for a further year in the role of Past Chair, to support continuity and the transfer of corporate memory on the Board and Executive.<br><br>\r\n\r\nThe role of the Past Chair and the compensation would be in line with others on the Executive Committee and reflected in the Division Policy.<br><br>\r\n\r\nFurther, as an administrative change, section 7.7 would also be amended to remove “provided that such Member is still eligible during that period to be appointed to fill a vacancy in the Board under Bylaw 7.9 hereof”, as it conflates the ability to be elected after leaving the Board for at least one year with the appointment process.<br><br>\r\n\r\n<u>Motion</u><br>\r\nMotion – That the wording of Section 7.7 be amended as follows: <b><i>There will be a limit of three (3) consecutive terms, after which a <u>Member</u> is not eligible for re-election as a Director until they have ceased to be a Director for at least one (1) year.  However, if the Chair completes three (3) consecutive Board terms, they may be appointed for an additional one-year term to serve in the capacity of Past-Chair.</b></i><br><br>\r\n\r\n<a href=\"https://vdofp.sharepoint.com/:b:/g/ERZjCMj06TJKg1h5OPH-eNIBx556-ZlHmrs2vUxUfu3AXg?e=j1AxPw\" target=\"_blank\" rel=\"noopener\">Click here</a> for a full description.\r\n"}],"related_resources":[167],"related_campaigns":[179],"related_events":[166]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5871"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/166"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/179"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/167"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5871"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5871"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5871"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5871"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5736,"date":"2022-08-02T22:51:57","date_gmt":"2022-08-02T22:51:57","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5736"},"modified":"2022-12-13T10:06:12","modified_gmt":"2022-12-13T10:06:12","slug":"community-programs-workshops-courses","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/community-programs-workshops-courses/","title":{"rendered":"Community Programs, Workshops &#038; Courses"},"featured_media":0,"template":"","resource_type":[124,129],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Programs, courses and workshops for Physician Wellness in Vancouver.","resource-introduction":"","resource-text":"<a href=\"https://ubccpd.ca/collaborate/portfolios/cbt-skills#:~:text=The%20Cognitive%20Behavioural%20Therapy%20(CBT,%2Dbased%20self%2Dmanagement%20strategies\" target=\"_blank\" rel=\"noopener\">CBT Skills Physician Wellness Group Training</a> – Physician-only CBT Skills group offered in partnership by the CBT Skills Group Society and UBC Continuing Professional Development and the Shared Care Committee.\r\n\r\n<a href=\"https://cpa.ca/corona-virus/psychservices/\">Psychologists Giving Back to Front Line Service Providers</a> – Registered psychology practitioners are donating services\r\n\r\n<a href=\"https://oreo2.itracmediav4.com/v?uuid=546326c0-f1e5-49e2-9d63-90b64c239f5c\">YMCA’s Y Mind – Free, Online Mental Wellness Program for Youth &amp; Adults</a>\r\n\r\n<a href=\"https://www.coursera.org/learn/manage-health-covid-19\">Mind Control: Managing Your Mental Health During COVID-19 – Online Course</a> – University of Toronto\r\n\r\n<a href=\"https://online.bouncebackonline.ca/\">BounceBack Online Course</a> – CBT Modules – CMHA and PHSA","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[129],"related_campaigns":[165],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5736"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/129"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5736"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5736"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5736"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5736"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5730,"date":"2022-08-02T22:21:01","date_gmt":"2022-08-02T22:21:01","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5730"},"modified":"2022-09-08T16:06:40","modified_gmt":"2022-09-08T16:06:40","slug":"pcn-family-physician-service-contracts","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/pcn-family-physician-service-contracts/","title":{"rendered":"PCN FP Service Contracts"},"featured_media":0,"template":"","resource_type":[155,124],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Information on how we can support salaried service contract funded positions for family physicians.","resource-introduction":"","resource-text":"Welcome to Vancouver Division’s opportunities for family physician service contract  – access information on how we can support salaried service contract funded positions for family physicians as part of Vancouver’s Primary Care Network development. The Ministry of Health has announced a new initiative to help recruit family physicians in BC. They have created salaried service contract funded positions for family physicians interested in starting patient panels, who haven’t already had a permanent practice.  Vancouver has been allocated a pre-determined number of positions for full service family practice and we are currently identifying interested clinics and eligible candidates.\r\n\r\nThe salaried service contract positions for Vancouver are limited in number, and will be filled as mutual matches are made. The process will be the same as the current process for recruiting locums and permanent physicians to clinics through the Division. When clinics are looking for help recruiting a physician, they can reach out to our team. We post the opportunity on a variety of different platforms on their behalf, and circulate the opportunity to eligible physicians who might be a good fit. Based on physician preferences, we introduce clinics and physicians to determine if there is a mutual fit to explore. With support, physicians and clinics can together decide to move forward.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[155],"related_campaigns":[152,164],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5730"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/155"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5730"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5730"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5730"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5730"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5729,"date":"2022-08-02T22:19:10","date_gmt":"2022-08-02T22:19:10","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5729"},"modified":"2022-09-08T16:06:53","modified_gmt":"2022-09-08T16:06:53","slug":"pcn-nurse-practitioner-service-contracts","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/pcn-nurse-practitioner-service-contracts/","title":{"rendered":"PCN NP Service Contracts"},"featured_media":0,"template":"","resource_type":[124,149],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Information on how we can support salaried service contract funded positions for Nurse Practitioners.","resource-introduction":"","resource-text":"Welcome to Vancouver Division’s opportunities for Nurse Practitioner service contracts – access information on how we can support salaried service contract funded positions for Nurse Practitioners as part of Vancouver’s Primary Care Network development. The Ministry of Health has announced a new initiative to help improve patient attachment in BC. They have created Nurse Practitioner (NP) funded positions for NPs interested in starting patient panels within Patient Medical Homes (PMH). Vancouver has been allocated a pre-determined number of positions for NPs in practice and we are currently identifying interested clinics.\r\n\r\nThe NP positions allocated for Vancouver are limited and will be filled as mutual matches are made. The process will be the same as the current process for recruiting physicians to clinics through the Division. When clinics are looking for help recruiting an NP, they can reach out to our team. We will post the opportunity on Health Match BC on their behalf, and circulate the opportunity to NPs who might be a good fit. Based on candidate preferences, we introduce clinics and NPs to determine if there is a fit to explore. With support, NPs and clinics can identify if a clinic-practitioner agreement is the best way to move forward.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[149],"related_campaigns":[152,164],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5729"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5729"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5729"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5729"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5729"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5633,"date":"2022-08-02T20:50:51","date_gmt":"2022-08-02T20:50:51","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5633"},"modified":"2022-08-02T20:50:51","modified_gmt":"2022-08-02T20:50:51","slug":"interprofessional-teams-ipt-one-pager","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/interprofessional-teams-ipt-one-pager/","title":{"rendered":"Interprofessional Teams (IPT) One-Pager"},"featured_media":0,"template":"","resource_type":[124,153],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Vancouver Division of Family Practice and Vancouver Coastal Health (VCH) have partnered to implement IPTs.","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nVancouver Division of Family Practice and Vancouver Coastal Health (VCH) have partnered to implement IPTs as part of the Primary Care Network (PCN) in your region.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Guide","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/08/IPT_Poster-V6.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[153],"related_campaigns":[152,164],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5633"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5633"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5633"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5633"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5633"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5624,"date":"2022-08-02T20:00:57","date_gmt":"2022-08-02T20:00:57","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5624"},"modified":"2022-08-02T20:00:57","modified_gmt":"2022-08-02T20:00:57","slug":"primary-care-clinical-pharmacist-pccp-package","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/primary-care-clinical-pharmacist-pccp-package/","title":{"rendered":"Primary Care Clinical Pharmacist (PCCP) Package"},"featured_media":0,"template":"","resource_type":[124,153],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"How a primary care clinic may choose to work with a PCCP & the processes involved in working in a team-based care environment","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 2\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThe Primary Care Clinical Pharmacist (PCCP) Package is intended to provide an overview of how a primary care clinic may choose to work with a PCCP, and the processes involved in working in a team-based care environment with a PCCP. The documents included intend to guide primary care providers to find the best way their clinic can collaborate with a PCCP to best support the needs of their patient population.\r\n\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Guide","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/08/Clinical-Pharmacist-Package-v7-2.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[153],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5624"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/153"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5624"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5624"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5624"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5624"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5622,"date":"2022-08-02T19:43:06","date_gmt":"2022-08-02T19:43:06","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5622"},"modified":"2023-01-11T23:40:23","modified_gmt":"2023-01-11T23:40:23","slug":"existing-and-new-employee-contract-templates","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/existing-and-new-employee-contract-templates/","title":{"rendered":"Existing and New Employee Contract Templates"},"featured_media":0,"template":"","resource_type":[151],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"Legal contract templates serving clinic owners for new and existing clinic employees such as MOAs, and office managers.","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 2\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nLegal contract templates serving clinic owners with a base document upon which they can build their own clinic contracts for new and existing clinic employees such as MOAs, and office managers.\r\n\r\nTo access these templates, please use this link to <a title=\"Request access to Existing and New Employee Contract Templates\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Existing%20And%20New%20Employee%20Contract%20Templates%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163],"related_campaigns":[152,150,154],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5622"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5622"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5622"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5622"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5622"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5621,"date":"2022-08-02T19:42:02","date_gmt":"2022-08-02T19:42:02","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5621"},"modified":"2023-01-11T23:41:28","modified_gmt":"2023-01-11T23:41:28","slug":"associate-and-locum-contract-templates","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/associate-and-locum-contract-templates/","title":{"rendered":"Associate and Locum Contract Templates"},"featured_media":0,"template":"","resource_type":[151],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"Legal contract templates serving clinic owners for physician associates and locums.","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 2\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nLegal contract templates serving clinic owners with a base document upon which they can build their own clinic contracts for physician associates and locums.\r\n\r\nTo access these templates, please use this link to <a title=\"Request access to Associate and Locum Contract Templates\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Associate%20and%20Locum%20Contract%20Templates%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163],"related_campaigns":[152,154,150],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5621"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5621"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5621"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5621"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5621"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5620,"date":"2022-08-02T19:40:00","date_gmt":"2022-08-02T19:40:00","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5620"},"modified":"2023-01-11T23:43:46","modified_gmt":"2023-01-11T23:43:46","slug":"patient-record-stewardship-legal-advisory-guide","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/patient-record-stewardship-legal-advisory-guide/","title":{"rendered":"Patient Record Stewardship Legal Advisory Guide"},"featured_media":0,"template":"","resource_type":[151],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"An advisory guide to help inform clinics and clinic owners on the various acceptable paths towards patient record stewardship","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 2\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nAn advisory guide to help inform clinics and clinic owners on the various acceptable paths towards patient record stewardship as outlined by the CPSBC.\r\n\r\nTo access this guide, please use this link to <a title=\"Request access to Patient Record Stewardship Legal Advisory Guide\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Patient%20Record%20Stewardship%20Legal%20Advisory%20Guide%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163],"related_campaigns":[152,150,154],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5620"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5620"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5620"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5620"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5620"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5619,"date":"2022-08-02T19:38:44","date_gmt":"2022-08-02T19:38:44","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5619"},"modified":"2022-12-19T14:01:00","modified_gmt":"2022-12-19T14:01:00","slug":"patient-panel-calculator","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/patient-panel-calculator/","title":{"rendered":"Patient Panel Calculator"},"featured_media":0,"template":"","resource_type":[163],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"This tool serves physicians in all stages of their career to determine the ideal and balanced patient panel size.","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 2\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis tool serves physicians in all stages of their career to determine the ideal and balanced patient panel size with consideration to their lifestyle, career preferences, and industry trends.\r\n\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to Patient Panel Calculator\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Patient%20Panel%20Calculator%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n<img class=\"alignnone size-full wp-image-8406\" src=\"http://van-division.yarko.dev/wp-content/uploads/2022/08/Screen-Shot-2022-12-19-at-2.55.55-PM.png\" alt=\"Patient Panel Calculator\" width=\"167\" height=\"182\" />\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163],"related_campaigns":[152,154,150],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5619"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5619"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5619"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5619"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5619"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5617,"date":"2022-08-02T19:35:43","date_gmt":"2022-08-02T19:35:43","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5617"},"modified":"2023-01-11T23:05:47","modified_gmt":"2023-01-11T23:05:47","slug":"rn-lpn-business-case","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/rn-lpn-business-case/","title":{"rendered":"RN/LPN Business Case"},"featured_media":0,"template":"","resource_type":[163],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"This model aims to help weigh the business opportunity of integrating an RN or LPN into a family practice.","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis model aims to help weigh the business opportunity of integrating an RN or LPN into a family practice. The tool seeks to outline both the direct revenue and indirect value of such a position.\r\n\r\n</div>\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to RN/LPN Business Case\" href=\"mailto:pcn@van-division.yarko.dev?Subject=RN/LPN%20Business%20Case%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163],"related_campaigns":[152,150,154],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5617"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5617"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5617"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5617"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5617"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5616,"date":"2022-08-02T19:33:38","date_gmt":"2022-08-02T19:33:38","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5616"},"modified":"2023-04-22T03:14:11","modified_gmt":"2023-04-22T03:14:11","slug":"moa-role-task-analysis","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/moa-role-task-analysis/","title":{"rendered":"MOA Role &#038; Task Analysis"},"featured_media":0,"template":"","resource_type":[163],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"For physicians and clinics considering hiring new staff, to determine appropriate and competitive wages.","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis model seeks to support physicians employing staff and prospective clinics considering hiring new staff, to determine appropriate and competitive wages.\r\n\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to MOA Role &amp; Task Analysis\" href=\"mailto:pcn@van-division.yarko.dev?Subject=MOA%20Role%20and%20Task%20Analysis%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5616"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5616"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5616"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5616"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5616"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5615,"date":"2022-08-02T19:30:15","date_gmt":"2022-08-02T19:30:15","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5615"},"modified":"2023-01-11T23:11:54","modified_gmt":"2023-01-11T23:11:54","slug":"emr-comparison-tool","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/emr-comparison-tool/","title":{"rendered":"EMR Comparison Tool"},"featured_media":0,"template":"","resource_type":[163],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"Supporting provider and clinic decisions related to implementing or switching their Electronic Medical Records (EMR) system.","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis model aims to support provider and clinic decisions related to implementing or switching their Electronic Medical Records (EMR) system. This tool will allow interested physicians to compare commonly available EMRs based on start-up costs and ongoing financial commitments, as well as included and purchasable options.\r\n\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to EMR Comparison Tool\" href=\"mailto:pcn@van-division.yarko.dev?Subject=EMR%20Comparison%20Tool%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163],"related_campaigns":[152,154,150],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5615"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5615"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5615"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5615"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5615"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5614,"date":"2022-08-02T19:28:05","date_gmt":"2022-08-02T19:28:05","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5614"},"modified":"2023-01-11T23:30:26","modified_gmt":"2023-01-11T23:30:26","slug":"clinic-financial-driver-overview","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/clinic-financial-driver-overview/","title":{"rendered":"Clinic Financial Driver Overview"},"featured_media":0,"template":"","resource_type":[163],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"This model aims to facilitate financially informed and cognizant decision making.","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis model aims to facilitate financially informed and cognizant decision making by supporting physicians to better understand the following areas:\r\n<ul>\r\n \t<li>Key financial drivers in their clinic</li>\r\n \t<li>Analysis and insight based on clinic financial performance</li>\r\n \t<li>The impact of different scenarios on future financial performance</li>\r\n</ul>\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to Clinic Financial Driver\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Clinic%20Financial%20Driver%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163],"related_campaigns":[152,154,150],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5614"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5614"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5614"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5614"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5614"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5613,"date":"2022-08-02T17:15:42","date_gmt":"2022-08-02T17:15:42","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5613"},"modified":"2023-01-11T23:32:29","modified_gmt":"2023-01-11T23:32:29","slug":"capacity-potential-analysis-tool","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/capacity-potential-analysis-tool/","title":{"rendered":"Capacity Potential Analysis Tool"},"featured_media":0,"template":"","resource_type":[163],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"This model aims to help analyze a clinic’s current utilization of their space.","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis model aims to help analyze a clinic’s current utilization of their space. It also seeks to outline shifts that might result in suboptimal use of space. Clinics can decide if they want to seek better utilization, or appreciate the utility of the flexibility they might enjoy in their current state.\r\n\r\n</div>\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to Capacity Potential Analysis Tool\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Capacity%20Potential%20Analysis%20Tool%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163],"related_campaigns":[152,150,154],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5613"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5613"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5613"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5613"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5613"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5609,"date":"2022-07-28T17:08:58","date_gmt":"2022-07-28T17:08:58","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5609"},"modified":"2022-07-28T17:08:58","modified_gmt":"2022-07-28T17:08:58","slug":"moa-guide-retirement","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/moa-guide-retirement/","title":{"rendered":"MOA Guide &#8211; Retirement"},"featured_media":0,"template":"","resource_type":[128,72],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"A process outline for MOAs supporting a retiring physician.","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Guide","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/MOA-Guide.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[72],"related_campaigns":[154,152,150],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5609"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5609"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5609"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5609"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5609"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5607,"date":"2022-07-28T17:05:52","date_gmt":"2022-07-28T17:05:52","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5607"},"modified":"2022-08-03T00:14:15","modified_gmt":"2022-08-03T00:14:15","slug":"paramedical-notification-letter","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/paramedical-notification-letter/","title":{"rendered":"Paramedical Notification Letter"},"featured_media":0,"template":"","resource_type":[127,72],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"A letter to inform paramedical services of a practice closure.","resource-introduction":"","resource-text":"A letter to inform paramedical services of a practice closure.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Letter Template","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/Paramedical-Services-Notification-Letter.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[72],"related_campaigns":[152,164],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5607"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5607"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5607"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5607"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5607"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5605,"date":"2022-07-28T17:03:31","date_gmt":"2022-07-28T17:03:31","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5605"},"modified":"2022-08-03T00:14:43","modified_gmt":"2022-08-03T00:14:43","slug":"colleague-notification-letter","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/colleague-notification-letter/","title":{"rendered":"Colleague Notification Letter"},"featured_media":0,"template":"","resource_type":[127,72],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"A form letter to colleagues informing them of your retirement.","resource-introduction":"","resource-text":"A form letter to colleagues informing them of your retirement.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Letter Template","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/Colleague-Notification-Letter.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[72],"related_campaigns":[152,165,164],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5605"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5605"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5605"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5605"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5605"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5603,"date":"2022-07-28T16:57:52","date_gmt":"2022-07-28T16:57:52","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5603"},"modified":"2022-08-03T00:15:10","modified_gmt":"2022-08-03T00:15:10","slug":"takeover-notification-letter","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/takeover-notification-letter/","title":{"rendered":"Takeover Notification Letter"},"featured_media":0,"template":"","resource_type":[127,72],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"A form letter to inform patients of your leaving and introduce them to the physician taking over your practice.","resource-introduction":"","resource-text":"A form letter to inform patients of your leaving and introduce them to the physician taking over your practice.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Letter Template","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/Takeover-Notification-Letter.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[72],"related_campaigns":[152,165,164],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5603"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5603"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5603"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5603"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5603"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5598,"date":"2022-07-28T16:53:38","date_gmt":"2022-07-28T16:53:38","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5598"},"modified":"2022-12-01T09:28:43","modified_gmt":"2022-12-01T09:28:43","slug":"retirement-notification-letter-template-outside-vancouver","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/retirement-notification-letter-template-outside-vancouver/","title":{"rendered":"Retirement Notification Letter Template &#8211; Out of Vancouver Patients"},"featured_media":0,"template":"","resource_type":[127,72],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"A letter used to notify patients of your retirement.","resource-introduction":"","resource-text":"This letter is personalized by and sent by the retiring physician. It is used to notify patients of their retirement. It also includes directions for patients to opt in to receive help finding a new healthcare provider and resources to search for care in their community.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Letter Template","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/11/Out-of-Van-Patients-Notification-Letter.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[72],"related_campaigns":[152,165,164],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5598"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5598"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5598"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5598"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5598"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5566,"date":"2022-07-28T00:55:41","date_gmt":"2022-07-28T00:55:41","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5566"},"modified":"2023-01-11T23:35:10","modified_gmt":"2023-01-11T23:35:10","slug":"associate-fee-structure","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/associate-fee-structure/","title":{"rendered":"Associate Fee Structure"},"featured_media":0,"template":"","resource_type":[163],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"This model helps providers and clinics, exploring a professional relationship, in identifying a suitable fee structure.","resource-introduction":"","resource-text":"<div class=\"page\" title=\"Page 1\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n\r\nThis model aims to help providers and clinics, exploring a professional relationship, in identifying a suitable fee structure. The tool allows providers and clinics to get a sense of the financial differences between available options and highlights some of the pros and cons of different fee structures.\r\n\r\nOne main goal of this tool is to facilitate transparency and to encourage full information for all parties to allow for better decision making. Both physicians and clinics can understand the key differences and similarities with different remuneration models, and weigh the pros and cons of each.\r\n\r\nThis tool is best used in consultation with your CNM who can explain the criteria and the benefits of the tool.\r\n\r\nUse this link to <a title=\"Request access to Associate Fee Structure\" href=\"mailto:pcn@van-division.yarko.dev?Subject=Associate%20Fee%20Structure%20Access%20Request\">Request Access</a> from your CNM or <a href=\"https://van-division.yarko.dev/pcn-vancouver/#CNM\">contact your CNM directly</a>.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[163],"related_campaigns":[152,154,150],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5566"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/163"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5566"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5566"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5566"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5566"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5568,"date":"2022-07-26T23:06:56","date_gmt":"2022-07-26T23:06:56","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5568"},"modified":"2022-08-03T00:37:40","modified_gmt":"2022-08-03T00:37:40","slug":"accepting-provider-reminder-email","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/accepting-provider-reminder-email/","title":{"rendered":"Accepting Provider Reminder Email"},"featured_media":0,"template":"","resource_type":[127,162],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"We will send two reminder emails to the accepting provider and their front desk staff.","resource-introduction":"","resource-text":"We will send two reminder emails to the accepting provider and their front desk staff one week before patients receive the reallocation email.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Email Template","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/Accepting-Provider-Reminder-Emails.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[162],"related_campaigns":[152,164],"related_events":[156]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5568"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"event_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/event_topic/156"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/164"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/162"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5568"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5568"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5568"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5568"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5785,"date":"2022-07-20T00:34:02","date_gmt":"2022-07-20T00:34:02","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5785"},"modified":"2022-08-30T07:19:40","modified_gmt":"2022-08-30T07:19:40","slug":"fast-facts-july-20-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-july-20-2022/","title":{"rendered":"Fast Facts &#8211; July 20, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/54d00550d432/fast-facts-9042413","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[126],"related_campaigns":[117,152,165],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5785"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5785"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5785"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5785"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5785"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5357,"date":"2022-07-18T12:28:27","date_gmt":"2022-07-18T12:28:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5357"},"modified":"2022-07-18T12:29:18","modified_gmt":"2022-07-18T12:29:18","slug":"qualification-criteria-for-np-service-contracts","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/qualification-criteria-for-np-service-contracts/","title":{"rendered":"Qualification Criteria for NP Service Contracts"},"featured_media":0,"template":"","resource_type":[124,149],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"See if you or your clinic is eligible to participate in the NP Service Contracts program.","resource-introduction":"","resource-text":"<div class=\"field-wrapper body field field-node--body field-name-body field-type-text-with-summary field-label-hidden\">\r\n<div class=\"field-items\">\r\n<div class=\"field-item\">\r\n<div class=\"field-wrapper field field-node--field-lower-body field-name-field-lower-body field-type-text-long field-label-hidden\">\r\n<div class=\"field-items\">\r\n<div class=\"field-item\">\r\n\r\nThese contracts are one piece of the Primary Care Network development underway in Vancouver. Clinics and NPs interested in the contract opportunities must be willing to participate in Primary Care Network development in their local areas as they evolve.\r\n\r\nThe Ministry of Health has approved Community Health Areas (CHAs) 1 – 6 to start implementing NP contracted providers. Currently, CHA-1 and CHA-3 are full for NP positions but we are actively recruiting for CHA-2, 4, 5, and 6.\r\n\r\nThese criteria were put in place to identify clinics that will be a supportive environment for NPs to start a practice, with the goal of long-term attachment.\r\n<h3>Qualification Criteria for Clinics</h3>\r\n<ul>\r\n \t<li>EMR</li>\r\n \t<li>More than two physicians at the clinic</li>\r\n \t<li>Physical space to accommodate an NP</li>\r\n \t<li>Full service family practice</li>\r\n \t<li>Buy-in from other physicians at the clinic</li>\r\n \t<li>Practice must be willing to work toward the attributes of the Patient Medical home</li>\r\n \t<li>Practice must be willing to join the PCN once it is established</li>\r\n \t<li>Practice must commit to involvement in Vancouver Division’s<em> </em>PMH and PCN development</li>\r\n \t<li>No one clinic or clinic owner in a CHA can receive more than 40% of allocated NPs for the region <em>*any clinic granted more than one NP will be reviewed and confirmed eligible on a case by case basis </em></li>\r\n \t<li>To remain eligible for additional NPs, the clinic must maintain a 1:1 FTE FP/NP ratio</li>\r\n</ul>\r\n<h3>Qualification Criteria for Nurse Practitioners</h3>\r\n<ul>\r\n \t<li>NPs who currently do not have a patient panel</li>\r\n \t<li>NPs interested in providing primary care to a patient panel</li>\r\n \t<li>Commitment to attaching patients according to MoH schedule (details in <em>NP Backgrounder and FAQ</em> document)</li>\r\n \t<li>NP must be willing to work toward the attributes of the Patient Medical home</li>\r\n \t<li>NP must be willing to join the PCN once it is established</li>\r\n \t<li>NP must commit to involvement in Vancouver Division’s PMH and PCN development</li>\r\n</ul>\r\n<h3>Express Interest</h3>\r\nIf you are interested in integrating a Nurse Practitioner into your clinic, or you are a Nurse Practitioner looking to start a patient panel under this model, please <a title=\"NP opportunities\" href=\"mailto:recruitmentvan@divisionsbc.ca\" target=\"_blank\" rel=\"noopener\">email us.</a>\r\n\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[149],"related_campaigns":[154,150,152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5357"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5357"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5357"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5357"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5357"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5356,"date":"2022-07-18T12:16:10","date_gmt":"2022-07-18T12:16:10","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5356"},"modified":"2022-07-18T12:16:10","modified_gmt":"2022-07-18T12:16:10","slug":"easi-maternity-care-project-faq","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/easi-maternity-care-project-faq/","title":{"rendered":"EASI Maternity Care Project FAQ"},"featured_media":0,"template":"","resource_type":[148,124],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"The EASI Maternity Care Project has involved a collection of maternity providers, allied health and patients.","resource-introduction":"The EASI Maternity Care Project has involved a collection of maternity providers, allied health and patients passionate about making the maternity journey in Vancouver as effective and seamlessly integrated as possible. By surveying maternity patients and providers in Vancouver, there was a clear need for easy access to quality and evidence-based information (such as tip sheets, videos, webpages, etc.) that helps patients navigate their journey while not being overwhelming. A diverse set of voices & perspectives from patients and providers have helped to identify the best resources to share. Please contact Bella Hauner at bhauner@van-division.yarko.dev if you have any questions.","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":true,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":[{"resource-acc-item-title":"What is the EASI Maternity Care Project?","resource-acc-item-content":"The EASI acronym stands for “effective and seamlessly integrated” and everyone involved in the EASI Maternity Care Project wants to make maternity care EASI – for patients and clinicians. We are a Vancouver-focused, multi-phase project focused on responding to gaps in patient preparedness along the various stages of their maternity care journey. In our current work, maternity providers from family physicians, obstetricians and midwives, along with all the key allied health involved in maternity care as well as patients are working to create a Vancouver-based online maternity information hub for patients, bringing together a curated list of all the best patient resources you can rely on. The initiative is funded by the Shared Care Committee, a joint collaborative committee of Doctors of BC and the Ministry of Health."},{"resource-acc-item-title":"What is your role?","resource-acc-item-content":"Right now, we are seeking feedback on an initial wireframe for the new online hub. Please see “We Need Your Help” for the steps to provide feedback, along with a short video."},{"resource-acc-item-title":"What is the time commitment of the Pop-up?","resource-acc-item-content":"Once onto Zoom, we hope you will spend between 5-10 minutes navigating the dynamic wireframe and narrate your feedback in real time via a recording."},{"resource-acc-item-title":"Why should I be involved in this project?","resource-acc-item-content":"Just a handful of reasons why we think you’ll want to be involved:\r\n\r\n<li>You want to make the maternity care journey easier and more supported for patients in Vancouver;\r\n<li>You will use and find value in the online information hub (as a maternity provider, as someone considering or in a maternity journey, or you have a loved one that would value this resource)\r\nand want a sneak peek at what will be in it; and\r\n<.i>This is important work and your time will be recognized. (Note: We ask for your name and contact email when you upload a feedback video, so we can follow-up with a token of appreciation.)"}],"related_resources":[148],"related_campaigns":[79,152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5356"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5356"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5356"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5356"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5356"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5355,"date":"2022-07-18T11:47:44","date_gmt":"2022-07-18T11:47:44","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5355"},"modified":"2022-08-03T00:39:06","modified_gmt":"2022-08-03T00:39:06","slug":"qualification-criteria-for-fp-service-contracts","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/qualification-criteria-for-fp-service-contracts/","title":{"rendered":"Qualification Criteria for FP Service Contracts"},"featured_media":0,"template":"","resource_type":[155,124],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"See if you or your clinic is eligible to participate in the FP Service Contracts program.","resource-introduction":"","resource-text":"<div class=\"field-wrapper body field field-node--body field-name-body field-type-text-with-summary field-label-hidden\">\r\n<div class=\"field-items\">\r\n<div class=\"field-item\">\r\n<div class=\"field-wrapper body field field-node--body field-name-body field-type-text-with-summary field-label-hidden\">\r\n<div class=\"field-items\">\r\n<div class=\"field-item\">\r\n\r\nThese contracts are one piece of the Primary Care Network development underway in Vancouver. Clinics and physicians interested in the salaried service contracts must be willing to participate in Primary Care Network development in their local areas as they evolve.\r\n\r\nAll six Community Health Areas (CHA) in Vancouver have been approved and there are positions all across the city for family physicians looking at these salaried contracts.\r\n\r\nTo browse available clinics in Vancouver, <a title=\"Practice In Vancouver\" href=\"/practice-in-vancouver/\">click here</a> to access our recruitment website.\r\n\r\n</div>\r\n</div>\r\n</div>\r\n<div class=\"field-wrapper field field-node--field-lower-body field-name-field-lower-body field-type-text-long field-label-hidden\">\r\n<div class=\"field-items\">\r\n<div class=\"field-item\">\r\n<h3>Qualification Criteria for Physicians</h3>\r\n<ul>\r\n \t<li>Family physician who currently does not have a patient panel</li>\r\n \t<li>Agreement to attach patients according to Ministry of Health schedule</li>\r\n \t<li>Physicians interested in the salaried service contract must be willing to participate in Primary Care Network development in their local areas as they evolve.</li>\r\n</ul>\r\n<h3>Helpful Information</h3>\r\n<ul>\r\n \t<li><a title=\"Health Match BC\" href=\"https://pcn.healthmatchbc.org/\" target=\"_blank\" rel=\"noopener\">Health Match BC PCN Information</a></li>\r\n \t<li><a href=\"https://van-division.yarko.dev/division/\" target=\"_blank\" rel=\"noopener\">Vancouver Division Home Page</a></li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"","resource-button_link":"","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[155],"related_campaigns":[154,150,152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5355"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/155"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5355"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5355"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5355"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5355"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":4460,"date":"2022-07-12T15:39:37","date_gmt":"2022-07-12T15:39:37","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=4460"},"modified":"2022-08-02T23:15:28","modified_gmt":"2022-08-02T23:15:28","slug":"cbt-skills-group-one-pager","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/cbt-skills-group-one-pager/","title":{"rendered":"CBT Skills Group One-Pager"},"featured_media":0,"template":"","resource_type":[118,124,119],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Go beyond medication and help your patients build mental health self-management skills with CBT Skills Group.","resource-introduction":"","resource-text":"Go beyond medication and help your patients build mental health self-management skills with CBT Skills Group.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Guide","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/VDFP_CBT-SKILLS_CNM-MEMO_20220627.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[118,119],"related_campaigns":[79],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/4460"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=4460"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=4460"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=4460"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=4460"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5782,"date":"2022-07-06T00:32:45","date_gmt":"2022-07-06T00:32:45","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5782"},"modified":"2022-08-07T00:32:10","modified_gmt":"2022-08-07T00:32:10","slug":"fast-facts-july-6-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-july-6-2022/","title":{"rendered":"Fast Facts &#8211; July 6, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/fast-facts-9039321","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[126],"related_campaigns":[117,152,165],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5782"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5782"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5782"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5782"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5782"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":4000,"date":"2022-07-04T20:50:43","date_gmt":"2022-07-04T20:50:43","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=4000"},"modified":"2022-08-03T00:41:50","modified_gmt":"2022-08-03T00:41:50","slug":"fp-backgrounder-and-faq","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fp-backgrounder-and-faq/","title":{"rendered":"FP Backgrounder and FAQ"},"featured_media":0,"template":"","resource_type":[155,124],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"Additional background and questions answered regarding the Family Practice Service Contracts.","resource-introduction":"","resource-text":"Additional background and questions answered regarding the Family Practice Service Contracts.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Guide","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/FAQs-New-to-Practice-FP-Contract.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[155],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/4000"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/155"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=4000"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=4000"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=4000"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=4000"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3999,"date":"2022-07-04T20:47:27","date_gmt":"2022-07-04T20:47:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3999"},"modified":"2022-08-03T00:40:32","modified_gmt":"2022-08-03T00:40:32","slug":"family-physician-contract-template","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/family-physician-contract-template/","title":{"rendered":"Family Physician Contract Template"},"featured_media":0,"template":"","resource_type":[155],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"A contract template for Family Physicians.","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Contract Template","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/N2P-Contract-Template_Revised.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[155],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3999"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/155"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3999"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3999"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3999"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3999"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3983,"date":"2022-07-04T20:42:04","date_gmt":"2022-07-04T20:42:04","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3983"},"modified":"2022-08-03T00:42:07","modified_gmt":"2022-08-03T00:42:07","slug":"overview-of-new-n2p-contract","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/overview-of-new-n2p-contract/","title":{"rendered":"Overview of New N2P Contract"},"featured_media":0,"template":"","resource_type":[155,124],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"An hours based contract for individual family physicians who do not have a patient panel.","resource-introduction":"","resource-text":"An hours based contract for individual family physicians who do not have a patient panel.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Guide","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/Individual-contract-for-new-to-practice-family-physicians-Guide.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[155],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3983"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/155"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3983"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3983"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3983"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3983"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3872,"date":"2022-07-04T18:18:49","date_gmt":"2022-07-04T18:18:49","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3872"},"modified":"2022-08-03T00:45:30","modified_gmt":"2022-08-03T00:45:30","slug":"nurse-practitioner-overhead-guidelines-and-principles","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/nurse-practitioner-overhead-guidelines-and-principles/","title":{"rendered":"Nurse Practitioner Overhead Guidelines and Principles"},"featured_media":0,"template":"","resource_type":[149],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"This document is provided as guidelines related to the NP overhead allocation provided within the NP service contracts.","resource-introduction":"","resource-text":"This document is provided as guidelines related to the NP overhead allocation provided within the NP service contracts.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the PDF","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/PCN_NP_Overhead_Principles_July_2019_Final.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[149],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3872"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3872"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3872"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3872"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3872"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3870,"date":"2022-07-04T18:13:19","date_gmt":"2022-07-04T18:13:19","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3870"},"modified":"2022-08-03T00:46:19","modified_gmt":"2022-08-03T00:46:19","slug":"np-practice-agreement-template","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/np-practice-agreement-template/","title":{"rendered":"NP Practice Agreement Template"},"featured_media":0,"template":"","resource_type":[149],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"This Agreement is a template intended to assist practitioners when a Contracted NP joins a practice.","resource-introduction":"","resource-text":"This Agreement is a template intended to assist practitioners when a Contracted NP joins a practice.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Contract Template","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/NP-Practice-Agreement-FINAL-181023.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[149],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3870"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3870"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3870"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3870"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3870"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3868,"date":"2022-07-04T18:07:12","date_gmt":"2022-07-04T18:07:12","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3868"},"modified":"2022-08-03T00:46:59","modified_gmt":"2022-08-03T00:46:59","slug":"ministry-primary-care-np-template","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/ministry-primary-care-np-template/","title":{"rendered":"Ministry Primary Care NP Template"},"featured_media":0,"template":"","resource_type":[149],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"A template for a Primary Care Nurse Practitioner Contract.","resource-introduction":"","resource-text":"A template for a Primary Care Nurse Practitioner Contract.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Contract Template","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/Primary-Care-NP-Template-FINAL-181023.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[149],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3868"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3868"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3868"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3868"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3868"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3866,"date":"2022-07-04T18:02:10","date_gmt":"2022-07-04T18:02:10","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3866"},"modified":"2022-08-03T00:48:39","modified_gmt":"2022-08-03T00:48:39","slug":"np-primary-care-role-summary","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/np-primary-care-role-summary/","title":{"rendered":"NP Primary Care Role Summary"},"featured_media":0,"template":"","resource_type":[149],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"The Interdisciplinary Team Based Care Policy outlines the importance of patient-centred, relationship-based care.","resource-introduction":"","resource-text":"The Interdisciplinary Team Based Care Policy outlines the importance of patient-centred, relationship-based care.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the PDF","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/NP-Primary-Care-Role-Summary.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[149],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3866"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3866"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3866"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3866"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3866"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3864,"date":"2022-07-04T17:55:18","date_gmt":"2022-07-04T17:55:18","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3864"},"modified":"2022-08-03T00:44:39","modified_gmt":"2022-08-03T00:44:39","slug":"np-backgrounder-and-faq","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/np-backgrounder-and-faq/","title":{"rendered":"NP Backgrounder and FAQ"},"featured_media":0,"template":"","resource_type":[124,149],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"The government of BC recently announced its vision for an integrated system of primary and community care across the province","resource-introduction":"","resource-text":"The government of BC recently announced its vision for an integrated system of primary and community care across the province.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the PDF","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/NP-Backgrounder-and-FAQ-Final-181023.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[149],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3864"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3864"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3864"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3864"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3864"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3862,"date":"2022-07-04T17:51:44","date_gmt":"2022-07-04T17:51:44","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3862"},"modified":"2022-08-03T00:49:07","modified_gmt":"2022-08-03T00:49:07","slug":"what-to-expect-as-a-clinic-or-np","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/what-to-expect-as-a-clinic-or-np/","title":{"rendered":"What to Expect as a Clinic or NP"},"featured_media":0,"template":"","resource_type":[149],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"What can the Nurse Practitioner and the Clinic expect?","resource-introduction":"","resource-text":"What can the Nurse Practitioner and the Clinic expect?","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the PDF","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/Contract-Positions-NP-What-to-Expect.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[149],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3862"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/149"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3862"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3862"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3862"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3862"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3859,"date":"2022-07-04T17:13:32","date_gmt":"2022-07-04T17:13:32","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3859"},"modified":"2022-07-04T17:14:18","modified_gmt":"2022-07-04T17:14:18","slug":"easi-maternity-care-project","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/easi-maternity-care-project/","title":{"rendered":"EASI Maternity Care Project"},"featured_media":0,"template":"","resource_type":[148,124],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"The EASI Maternity Care Project has involved a collection of maternity providers, allied health and patients.","resource-introduction":"","resource-text":"The EASI Maternity Care Project has involved a collection of maternity providers, allied health and patients passionate about making the maternity journey in Vancouver* as effective and seamlessly integrated as possible.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the PDF","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/Bare_PRGVAN-infog-08-17-21-1.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[148,124],"related_campaigns":[91,90],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3859"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/124"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/148"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3859"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3859"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3859"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3859"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3419,"date":"2022-06-30T17:49:20","date_gmt":"2022-06-30T17:49:20","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3419"},"modified":"2022-06-30T17:49:20","modified_gmt":"2022-06-30T17:49:20","slug":"fast-facts-may-11-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-may-11-2022/","title":{"rendered":"Fast Facts &#8211; May 11, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/fast-facts-9020881","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[126],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3419"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3419"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3419"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3419"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3419"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3418,"date":"2022-06-30T17:48:42","date_gmt":"2022-06-30T17:48:42","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3418"},"modified":"2022-07-27T01:20:25","modified_gmt":"2022-07-27T01:20:25","slug":"fast-facts-april-27-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-april-27-2022/","title":{"rendered":"Fast Facts &#8211; April 27, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/d9dddb44e7da/fast-facts-9017769","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[126],"related_campaigns":[91,79,152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3418"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/91"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3418"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3418"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3418"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3418"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3417,"date":"2022-06-30T17:47:42","date_gmt":"2022-06-30T17:47:42","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3417"},"modified":"2022-06-30T17:47:42","modified_gmt":"2022-06-30T17:47:42","slug":"fast-facts-april-13-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-april-13-2022/","title":{"rendered":"Fast Facts &#8211; April 13, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/fast-facts-9009605","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[126],"related_campaigns":[],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3417"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3417"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3417"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3417"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3417"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":3258,"date":"2022-06-29T19:50:23","date_gmt":"2022-06-29T19:50:23","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=3258"},"modified":"2022-09-26T16:37:01","modified_gmt":"2022-09-26T16:37:01","slug":"role-description-of-the-board-of-directors","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/role-description-of-the-board-of-directors/","title":{"rendered":"Ways to Get Involved"},"featured_media":0,"template":"","resource_type":[124],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"To provide clarity for members interested in leadership opportunities, the Division has created the following table.","resource-introduction":"","resource-text":"<strong>Fiduciary Duty and Duty of Care:</strong>\r\n\r\nA board member (or Director) is a fiduciary for the Division, meaning a person who holds a legal and ethical responsibility to care for the money or other assets of the organization. A Director acts ethically, and in good faith with a view to the best interests of the Division and its members, and in so doing, supports the Division in fulfilling its mission and discharging its accountabilities. A Director exercises the care, diligence and skill that a reasonably prudent person would exercise in comparable circumstances. Directors with special skill and knowledge are expected to apply that skill and knowledge to matters that come before the Board.\r\n\r\n<strong>Responsibilities and Accountabilities as a Director:</strong>\r\n<ul>\r\n \t<li>Sets, maintains, and commits to the vision, mission and values of the organization.</li>\r\n \t<li>Develops strategy (e.g., long-term strategic plan). The 2019 strategic priorities can be found on the Division website by <a href=\"https://van-division.yarko.dev/static/e60f7edfa2007715d4297862a3a1f54f/Strat-Priorities-2021.pdf\">clicking here</a>;</li>\r\n \t<li>Keeps up to date with issues and trends that affect the organization;</li>\r\n \t<li>Adheres to the Carver Model of Governance;</li>\r\n \t<li>Understands and monitors the organization’s financial affairs;</li>\r\n \t<li>Avoids any potential conflicts of interests;</li>\r\n \t<li>Understands and maintains confidentiality;</li>\r\n \t<li>Does not represent the specific interests of any constituency or group;</li>\r\n \t<li>Acts and makes decisions that are in the best interest of the Division as a whole;</li>\r\n \t<li>Creates and/or approves the organization’s policies;</li>\r\n \t<li>Selects, manages, and supports the organization’s chief executive;</li>\r\n \t<li>Ensures compliance with governing documents (e.g. constitution and by-laws);</li>\r\n \t<li>Ensures accountability and compliance with laws and regulations;</li>\r\n \t<li>Attends and prepares adequately for regular board meetings; and,</li>\r\n \t<li>Attends committee meetings as a board liaison, as required and agreed upon.</li>\r\n</ul>\r\n<strong>Type of Board Members and Term Limits:</strong>\r\n\r\nFor all types of directors, there will be a limit of three (3) consecutive terms, after which a General Member is not eligible for re-election as a Director until they have ceased to be a Director for at least one (1) year.\r\n\r\nThere are two types of directors:\r\n<ol>\r\n \t<li><strong>FP Member Directors</strong> – General Members in good standing can serve as a FP Member Director, each term being two (2) years in length.</li>\r\n \t<li><strong>Resident Member Directors</strong> – Resident Members in good standing can serve as a Resident Member Director, each term being for one (1) year in length.</li>\r\n</ol>\r\nPlease note: Associate Members (e.g. retired members) are ineligible for nomination to the board and are ineligible to nominate a member for a board position.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"View the Table","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/06/Leadership-Table-2021.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/3258"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=3258"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=3258"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=3258"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=3258"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5780,"date":"2022-06-22T00:30:27","date_gmt":"2022-06-22T00:30:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5780"},"modified":"2022-08-07T00:32:46","modified_gmt":"2022-08-07T00:32:46","slug":"fast-facts-june-22-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-june-22-2022/","title":{"rendered":"Fast Facts &#8211; June 22, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/fast-facts-9033601","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[126],"related_campaigns":[117,152,165],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5780"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5780"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5780"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5780"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5780"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":2879,"date":"2022-06-16T03:49:33","date_gmt":"2022-06-16T03:49:33","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=2879"},"modified":"2022-07-04T17:44:31","modified_gmt":"2022-07-04T17:44:31","slug":"cbt-skills-group-initiative-results","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/cbt-skills-group-initiative-results/","title":{"rendered":"CBT Skills Group Initiative Results"},"featured_media":0,"template":"","resource_type":[118,128,119,125],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"91% of physician wellness participants (64 of 69) would recommend program to colleagues.","resource-introduction":"","resource-text":"This summary presents evaluation findings from Jan-March 2022 of the CBT Skills Groups Initiative, which offers CBT Skills training to physicians and patients.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the PDF","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/06/CBTSkillsSummary_Q12022.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[118,119,125,128],"related_campaigns":[79,117],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/2879"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/79"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/128"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/125"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/118"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2879"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=2879"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=2879"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=2879"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":2532,"date":"2022-06-15T08:12:30","date_gmt":"2022-06-15T08:12:30","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=2532"},"modified":"2022-11-30T10:11:27","modified_gmt":"2022-11-30T10:11:27","slug":"notification-letter-template","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/notification-letter-template/","title":{"rendered":"Notification Letter Template – Vancouver Patients"},"featured_media":0,"template":"","resource_type":[127,72],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"A letter personalized by and sent by the retiring doctor to notify patients of their retirement.","resource-introduction":"","resource-text":"This letter is personalized by and sent by the retiring physician. It is used to notify patients of their retirement. It also includes directions for patients to opt in to receive help finding a new healthcare provider and resources to search for care in their community.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Letter Template","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/In-Van-Patients-Notification-Letter.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[72],"related_campaigns":[154,152,150],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/2532"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2532"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=2532"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=2532"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=2532"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":2530,"date":"2022-06-15T08:08:30","date_gmt":"2022-06-15T08:08:30","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=2530"},"modified":"2022-07-28T16:54:50","modified_gmt":"2022-07-28T16:54:50","slug":"sample-reallocation-letter","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/sample-reallocation-letter/","title":{"rendered":"Sample Reallocation Letter"},"featured_media":0,"template":"","resource_type":[127,162,72],"resource_cat":[92],"catalogue":[],"acf":{"post-icon":2270,"post-excerpt":"A letter template to notify patients of a new provider.","resource-introduction":"","resource-text":"This letter template is sent by the Division to patients to notify them of their new healthcare provider. The information provided in this letter includes their new providers name and clinic contact information to book an appointment. In addition, where to access their medical record.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Letter Template","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/07/In-Van-Reallocation-Email.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[72],"related_campaigns":[152,154,150],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/2530"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/150"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/154"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2530"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=2530"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=2530"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=2530"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":2526,"date":"2022-06-15T07:44:55","date_gmt":"2022-06-15T07:44:55","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=2526"},"modified":"2022-08-03T00:52:17","modified_gmt":"2022-08-03T00:52:17","slug":"cpsbc-guidelines","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/cpsbc-guidelines/","title":{"rendered":"CPSBC Guidelines"},"featured_media":0,"template":"","resource_type":[72],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"The CPSBC recommends that retiring physicians notify their patients and colleagues at least 3 months in advance.","resource-introduction":"","resource-text":"The CPSBC recommends that retiring physicians notify their patients and colleagues at least 3 months in advance of their departure. These CPSBC Guidelines outline several important considerations, such as patient medical record stewardship.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Guide","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/06/PSG-Leaving-Practice.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[72],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/2526"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2526"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=2526"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=2526"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=2526"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":2523,"date":"2022-06-15T07:42:27","date_gmt":"2022-06-15T07:42:27","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=2523"},"modified":"2022-08-03T00:52:39","modified_gmt":"2022-08-03T00:52:39","slug":"how-to-retire-guide","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/how-to-retire-guide/","title":{"rendered":"How to Retire Guide"},"featured_media":0,"template":"","resource_type":[72],"resource_cat":[77],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"The Vancouver Division created this 52-page guide ​to help family doctors map out a plan for their retirement.","resource-introduction":"","resource-text":"The Vancouver Division created this 52-page guide ​to help family doctors map out a plan for their retirement.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Download the Guide","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/06/VDoFP_Retirement_FINAL.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[72],"related_campaigns":[152],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/2523"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/72"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=2523"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=2523"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=2523"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=2523"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5779,"date":"2022-06-08T00:25:29","date_gmt":"2022-06-08T00:25:29","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5779"},"modified":"2022-08-07T00:33:13","modified_gmt":"2022-08-07T00:33:13","slug":"fast-facts-june-8-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-june-8-2022/","title":{"rendered":"Fast Facts &#8211; June 8, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/fast-facts-9030501","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[126],"related_campaigns":[117,152,165],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5779"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5779"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5779"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5779"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5779"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":5777,"date":"2022-05-25T00:24:20","date_gmt":"2022-05-25T00:24:20","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=5777"},"modified":"2022-08-07T00:33:24","modified_gmt":"2022-08-07T00:33:24","slug":"fast-facts-may-25-2022","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/fast-facts-may-25-2022/","title":{"rendered":"Fast Facts &#8211; May 25, 2022"},"featured_media":0,"template":"","resource_type":[126],"resource_cat":[76],"catalogue":[],"acf":{"post-icon":2242,"post-excerpt":"","resource-introduction":"","resource-text":"","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Read the Newsletter","resource-button_link":"https://mailchi.mp/vancouverdivision.com/fast-facts-9025897","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[126],"related_campaigns":[152,165,117],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/5777"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/165"},{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/152"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/126"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=5777"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=5777"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=5777"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=5777"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}},{"id":7391,"date":"2022-01-15T23:06:45","date_gmt":"2022-01-15T23:06:45","guid":{"rendered":"https://van-division.yarko.dev/?post_type=resource&#038;p=7391"},"modified":"2022-10-26T23:07:26","modified_gmt":"2022-10-26T23:07:26","slug":"mental-health-and-addictions-infographic","status":"publish","type":"resource","link":"https://van-division.yarko.dev/resource/mental-health-and-addictions-infographic/","title":{"rendered":"Mental Health and Addictions Infographic"},"featured_media":0,"template":"","resource_type":[119,125],"resource_cat":[],"catalogue":[],"acf":{"post-icon":2268,"post-excerpt":"An infographic synopsis of the White Paper on Mental Health and Addictions.","resource-introduction":"","resource-text":"The White Paper on Mental Health and Addictions is comprised of two parts. Through research, focus groups, and surveys from Vancouver Division family physicians, we developed a “current state” description of gaps within the system of mental health supports. In the second section we have suggested the myriad of opportunities to address the challenges with the system of mental health supports.","resource-header_1":"","resource-extended_information":"","resource-extended_info_image":"","resource-header_2":"","resource-extended-info-2":"","resource-content":"","resource-button_text":"Browse the infographic","resource-button_link":"http://van-division.yarko.dev/wp-content/uploads/2022/10/MAH-Infographic-V9.pdf","resource-button_text_email":"","resource-email_link":"","resource-video_title":"","resource-video":"","resource-youtube-video":"","resource-youtube_video_title":"","resource-self_hosted_video":"","resource-self_hosted_video_title":"","resource-infographic":"","resource-pdf_link":"","resource-faq_accordion_activator":false,"resource-faq_header":"Frequently Asked Questions","resource-faq_accordion_content":null,"related_resources":[119],"related_campaigns":[117],"related_events":[]},"aioseo_notices":[],"_links":{"self":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource/7391"}],"collection":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource"}],"about":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/types/resource"}],"acf:term":[{"embeddable":true,"taxonomy":"campaign_topic","href":"https://van-division.yarko.dev/wp-json/wp/v2/campaign_topic/117"},{"embeddable":true,"taxonomy":"resource_type","href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type/119"}],"wp:attachment":[{"href":"https://van-division.yarko.dev/wp-json/wp/v2/media?parent=7391"}],"wp:term":[{"taxonomy":"resource_type","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_type?post=7391"},{"taxonomy":"resource_cat","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/resource_cat?post=7391"},{"taxonomy":"catalogue","embeddable":true,"href":"https://van-division.yarko.dev/wp-json/wp/v2/catalogue?post=7391"}],"curies":[{"name":"wp","href":"https://api.w.org/{rel}","templated":true}]}}];/* harmony default export */ __webpack_exports__["a"] = (database);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vueContainer"},[_c('div',{staticClass:"filter-container"},[_c('div',{staticClass:"search-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.searchQuery)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applySearch.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"click":_vm.applySearch}},[_vm._v("Search")])]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropdowns),expression:"closeDropdowns"}],staticClass:"filters-row"},[_vm._l((_vm.filters),function(filter,index){return _c('div',{key:index,staticClass:"filter-column"},[_c('label',{staticClass:"filter-title"},[_vm._v(_vm._s(filter.title))]),_vm._v(" "),_c('div',{ref:"toggleButton",refInFor:true,staticClass:"dropdown-button",on:{"click":function($event){return _vm.toggleDropdown(index)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFiltersActive[index] > 0),expression:"selectedFiltersActive[index] > 0"}],staticClass:"NofFilter"},[_vm._v(_vm._s(_vm.selectedFiltersActive[index]))]),_vm._v(" Select filters...\n                       "),_c('span',{staticClass:"arrow"},[_vm._v("▼")])]),_vm._v(" "),_c('div',{staticClass:"checkbox-dropdown",class:{ 'show': filter.show }},_vm._l((filter.options),function(option){return _c('div',{key:option.name,staticClass:"checkbox-option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(option.checked),expression:"option.checked"}],attrs:{"type":"checkbox","id":option.name},domProps:{"value":option.name,"checked":Array.isArray(option.checked)?_vm._i(option.checked,option.name)>-1:(option.checked)},on:{"change":[function($event){var $$a=option.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=option.name,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(option, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(option, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(option, "checked", $$c)}},_vm.applySearch]}}),_vm._v(" "),_c('label',{attrs:{"for":option.name}},[_vm._v(_vm._s(option.name))])])}),0)])}),_vm._v(" "),_c('div',{staticClass:"resetFilterButtonContainer"},[_c('div',{staticClass:"resetFilterButon",on:{"click":_vm.clearFilters}},[_vm._v("Clear Filters")])])],2)]),_vm._v(" "),_c('div',{staticClass:"results-container"},[_vm._l((_vm.visibleResults),function(post,index){return _c('a',{key:post.id,staticClass:"result-card",class:_vm.getCardClass(index),attrs:{"href":post.link}},[_c('div',{staticClass:"result-icon",class:_vm.getIconClass(index)},[_c('img',{staticClass:"imgIconResult",attrs:{"src":_vm.getIconSrc(post),"alt":"Icon"}})]),_vm._v(" "),_c('div',{staticClass:"result-summary",domProps:{"innerHTML":_vm._s(post.acf['post-excerpt'])}}),_vm._v(" "),_c('div',{staticClass:"result-title",class:_vm.getTitleClass(index),domProps:{"innerHTML":_vm._s(post.title.rendered)}}),_vm._v(" "),_c('div',{staticClass:"hover-overlay",class:_vm.getHoverClass(index)},[_c('div',{staticClass:"hover-title",domProps:{"innerHTML":_vm._s(post.title.rendered)}})])])}),_vm._v(" "),(!_vm.firstLoadDone)?_c('div',{staticClass:"loaderContainer"},[_c('div',{staticClass:"loader"})]):(_vm.visibleResults.length < 1)?_c('div',[_vm._v("\n               No results found based on your filter selection\n           ")]):_vm._e()],2),_vm._v(" "),(_vm.firstLoadDone && _vm.filteredResults.length > _vm.visibleResults.length && _vm.visibleResults.length > 1)?_c('div',{staticClass:"load-more-controls"},[_c('button',{on:{"click":_vm.loadMoreResults}},[_vm._v("Load More")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendar_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d96ad2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_vue__ = __webpack_require__(582);
function injectStyle (ssrContext) {
  __webpack_require__(580)
}
var normalizeComponent = __webpack_require__(48)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d96ad2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(581);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(67)("ed158ae4", content, true, {});

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(66)(false);
// imports


// module
exports.push([module.i, ".calendar-navigation{font-family:Arial,sans-serif}.calendarTitle,.month-selector{font-weight:700}.month-selector>div{cursor:pointer}.week-selector{font-weight:700}.week-selector>div{cursor:pointer}.date-navigation{justify-content:space-between;background-color:#428da1;color:#fff;padding:10px;border-radius:8px 8px 0 0}.date-navigation,.month-selector,.week-selector{display:flex;align-items:center}button{background-color:transparent;border:none;color:#fff;cursor:pointer}span{margin:0 10px}.eventContainer,.events{display:flex;flex-direction:row;align-items:center}.events{padding:0 15px;border-left:7px solid #016d89;padding-left:5px;margin-left:0;height:75px;width:293.3px;min-width:293.3px;cursor:pointer}.event-time{font-size:20px;font-weight:300;display:flex;align-items:center;justify-content:flex-start}.event-name{font-size:15px}.event-name,.event-name-calendar{color:#006d8a;font-family:Roboto Slab,Sans-serif;font-weight:500}.event-name-calendar{font-size:14px}.svgClockIcon{margin-right:5px}.event-types{display:flex;justify-content:space-between}.event-type{flex-grow:1;text-align:center;padding:10px;color:#fff}.internal-event{background-color:#006d8a}.external-event{background-color:#e48f5b}.all-member-meeting{background-color:#eeb844}.board-meeting{background-color:#bbbf9a}.week-days{align-items:stretch;padding:0}.dateContainer,.week-days{display:flex;flex-direction:column}.dateContainer{width:130px;min-width:130px;align-items:center;text-align:center;transform:translateX(-20px)}.dayContainer{border:1px solid #c1c1c1;border-top:0;margin:0;min-width:100px}.day{display:flex;align-items:center;width:100%;padding:0;padding-left:15px;justify-content:flex-start;flex-direction:row}.date-number{font-size:32px;font-weight:700}.date-name{font-size:12px;color:#555;margin-top:-3px}.month-separator{height:2px;background-color:#ccc;margin-top:2px}.month-name{font-size:.75rem;color:#666;text-align:center;margin-top:3px}.event-tag{width:5px;height:100%;border-left:5px solid}.more-events{height:75px;display:flex;align-content:center;align-items:center;background-color:#ce7234;padding:0 20px;color:#fff;font-weight:700;cursor:pointer}.more-events:hover{text-decoration:underline}.dropdown-content{position:absolute;width:250px;margin-left:-21.8%;margin-top:2%;border-radius:5px;background-color:#fff;border:1px solid #d5d5d5}.eventdropdownItem{padding:10px;border-bottom:1px solid #d5d5d5;cursor:pointer}@media (max-width:1060px){.events{width:255px;min-width:255px}}.tooltip{margin-left:0;margin-top:7%}.dropdown-tooltip,.tooltip{position:absolute;width:auto;min-width:200px;max-width:700px;border-radius:5px;background-color:#fff;border:1px solid #d5d5d5;padding:10px;overflow:hidden;cursor:default;box-shadow:0 4px 8px rgba(0,0,0,.1);z-index:1000}.dropdown-tooltip{right:0;top:-1px}.dropdown-tooltip:after{content:\"\";position:absolute;bottom:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent #fff}@media (max-width:720px){.tooltip{width:95%;margin-left:0;margin-top:7%}.dropdown-tooltip,.tooltip{z-index:99;max-width:600px;border-radius:5px;background-color:#fff;border:1px solid #d5d5d5;padding:10px;overflow:hidden;box-shadow:0 4px 8px rgba(0,0,0,.1)}.dropdown-tooltip{right:0;width:100%;top:-1px}.close-button{position:absolute;top:5px;right:10px;cursor:pointer;color:grey;font-size:15px;font-family:monospace}}.tooltip a{color:#e48f5b}.close-button{position:absolute;top:5px;right:10px;cursor:pointer;color:grey;font-size:15px;font-family:monospace}@media (max-width:720px){.date-navigation{display:flex;flex-direction:column}.month-selector{padding-top:15px;padding-bottom:15px}.calendarTitle{order:-1}.eventContainer{display:flex;flex-direction:column;align-items:stretch;width:100%}.day{justify-content:flex-start!important}.dateContainer{display:flex;width:80px;min-width:80px;align-items:center;flex-direction:column;text-align:center;transform:translateX(-10px)}.more-events{height:40px;text-align:center;justify-content:center}.dropdown-content{width:unset!important;margin-top:0}.dropdown-content,.tooltip{position:absolute;margin-left:0;border-radius:5px;background-color:#fff;border:1px solid #d5d5d5}.tooltip{width:95%;left:10px;z-index:99;min-width:100px;max-width:600px;margin-top:7%;padding:10px;overflow:hidden}}", ""]);

// exports


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-navigation"},[_c('div',{staticClass:"date-navigation"},[_c('div',{staticClass:"month-selector"},[_c('div',{on:{"click":function($event){return _vm.changeMonth(-1)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"}},[_c('path',{attrs:{"d":"M12.4649 16.2576C12.0974 16.6251 11.5049 16.6251 11.1374 16.2576L4.90492 10.0251C4.61242 9.73258 4.61242 9.26008 4.90492 8.96758L11.1374 2.73508C11.5049 2.36758 12.0974 2.36758 12.4649 2.73508C12.8324 3.10258 12.8324 3.69508 12.4649 4.06258L7.03492 9.50008L12.4724 14.9376C12.8324 15.2976 12.8324 15.8976 12.4649 16.2576Z","fill":"white"}})])]),_vm._v(" "),_c('span',{staticStyle:{"width":"130px","text-align":"center"}},[_vm._v(_vm._s(_vm.currentMonthYear))]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.changeMonth(1)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"}},[_c('path',{attrs:{"d":"M5.53508 16.2576C5.90258 16.6251 6.49508 16.6251 6.86258 16.2576L13.0951 10.0251C13.3876 9.73258 13.3876 9.26008 13.0951 8.96758L6.86258 2.73508C6.49508 2.36758 5.90258 2.36758 5.53508 2.73508C5.16758 3.10258 5.16758 3.69508 5.53508 4.06258L10.9651 9.50008L5.52758 14.9376C5.16758 15.2976 5.16758 15.8976 5.53508 16.2576Z","fill":"white"}})])])]),_vm._v(" "),_c('div',{staticClass:"calendarTitle"},[_vm._v("Event Calendar")]),_vm._v(" "),_c('div',{staticClass:"week-selector"},[_c('div',{on:{"click":function($event){return _vm.changeWeek(-1)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"}},[_c('path',{attrs:{"d":"M12.4649 16.2576C12.0974 16.6251 11.5049 16.6251 11.1374 16.2576L4.90492 10.0251C4.61242 9.73258 4.61242 9.26008 4.90492 8.96758L11.1374 2.73508C11.5049 2.36758 12.0974 2.36758 12.4649 2.73508C12.8324 3.10258 12.8324 3.69508 12.4649 4.06258L7.03492 9.50008L12.4724 14.9376C12.8324 15.2976 12.8324 15.8976 12.4649 16.2576Z","fill":"white"}})])]),_vm._v(" "),_c('span',{staticStyle:{"width":"130px","text-align":"center","margin-top":"-7px"}},[_vm._v(_vm._s(_vm.currentWeek))]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.changeWeek(1)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"}},[_c('path',{attrs:{"d":"M5.53508 16.2576C5.90258 16.6251 6.49508 16.6251 6.86258 16.2576L13.0951 10.0251C13.3876 9.73258 13.3876 9.26008 13.0951 8.96758L6.86258 2.73508C6.49508 2.36758 5.90258 2.36758 5.53508 2.73508C5.16758 3.10258 5.16758 3.69508 5.53508 4.06258L10.9651 9.50008L5.52758 14.9376C5.16758 15.2976 5.16758 15.8976 5.53508 16.2576Z","fill":"white"}})])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"week-days"},_vm._l((_vm.weekDays),function(day,dayIndex){return _c('div',{key:dayIndex,staticClass:"dayContainer"},[_c('div',{staticClass:"day",style:({ 'justify-content': _vm.eventsForDate(day.fullDate).length > _vm.maxEventsToShow ? 'space-between' : '' })},[_c('div',{staticClass:"dateContainer"},[_c('div',{staticClass:"date-number"},[_vm._v(_vm._s(day.date))]),_vm._v(" "),_c('div',{staticClass:"date-name"},[_vm._v(_vm._s(day.name))])]),_vm._v(" "),_c('div',{staticClass:"eventContainer"},[_vm._l((_vm.eventsForDate(day.fullDate)),function(event,eventIndex){return (eventIndex < _vm.maxEventsToShow)?_c('div',{key:eventIndex,staticClass:"events",style:({ borderColor: _vm.getTagColor(event.tag) }),on:{"click":function($event){return _vm.showTooltip(event)}}},[_c('div',{staticClass:"event-details"},[_c('div',{staticClass:"event-time"},[_c('svg',{staticClass:"svgClockIcon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"17","viewBox":"0 0 20 21","fill":"none"}},[_c('path',{attrs:{"d":"M10 18.5C12.1217 18.5 14.1566 17.6571 15.6569 16.1569C17.1571 14.6566 18 12.6217 18 10.5C18 8.37827 17.1571 6.34344 15.6569 4.84315C14.1566 3.34285 12.1217 2.5 10 2.5C7.87827 2.5 5.84344 3.34285 4.34315 4.84315C2.84285 6.34344 2 8.37827 2 10.5C2 12.6217 2.84285 14.6566 4.34315 16.1569C5.84344 17.6571 7.87827 18.5 10 18.5ZM10 0.5C11.3132 0.5 12.6136 0.758658 13.8268 1.2612C15.0401 1.76375 16.1425 2.50035 17.0711 3.42893C17.9997 4.35752 18.7362 5.45991 19.2388 6.67317C19.7413 7.88642 20 9.18678 20 10.5C20 13.1522 18.9464 15.6957 17.0711 17.5711C15.1957 19.4464 12.6522 20.5 10 20.5C4.47 20.5 0 16 0 10.5C0 7.84784 1.05357 5.3043 2.92893 3.42893C4.8043 1.55357 7.34784 0.5 10 0.5ZM10.5 5.5V10.75L15 13.42L14.25 14.65L9 11.5V5.5H10.5Z","fill":"#333333"}})]),_vm._v(_vm._s(event.time))]),_vm._v(" "),_c('div',{staticClass:"event-name-calendar"},[_vm._v(_vm._s(event.name))])]),_vm._v(" "),(_vm.activeTooltip === event)?_c('div',{staticClass:"tooltip"},[_c('div',{staticClass:"close-button",on:{"click":function($event){$event.stopPropagation();return _vm.closeTooltip.apply(null, arguments)}}},[_vm._v("X")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"event-details"},[_c('div',{staticClass:"event-name",staticStyle:{"padding-top":"5px","padding-bottom":"5px","padding-right":"20px"}},[_vm._v(_vm._s(event.name))]),_vm._v(" "),_c('div',{staticClass:"event-time"},[_c('svg',{staticClass:"svgClockIcon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"17","viewBox":"0 0 20 21","fill":"none"}},[_c('path',{attrs:{"d":"M10 18.5C12.1217 18.5 14.1566 17.6571 15.6569 16.1569C17.1571 14.6566 18 12.6217 18 10.5C18 8.37827 17.1571 6.34344 15.6569 4.84315C14.1566 3.34285 12.1217 2.5 10 2.5C7.87827 2.5 5.84344 3.34285 4.34315 4.84315C2.84285 6.34344 2 8.37827 2 10.5C2 12.6217 2.84285 14.6566 4.34315 16.1569C5.84344 17.6571 7.87827 18.5 10 18.5ZM10 0.5C11.3132 0.5 12.6136 0.758658 13.8268 1.2612C15.0401 1.76375 16.1425 2.50035 17.0711 3.42893C17.9997 4.35752 18.7362 5.45991 19.2388 6.67317C19.7413 7.88642 20 9.18678 20 10.5C20 13.1522 18.9464 15.6957 17.0711 17.5711C15.1957 19.4464 12.6522 20.5 10 20.5C4.47 20.5 0 16 0 10.5C0 7.84784 1.05357 5.3043 2.92893 3.42893C4.8043 1.55357 7.34784 0.5 10 0.5ZM10.5 5.5V10.75L15 13.42L14.25 14.65L9 11.5V5.5H10.5Z","fill":"#333333"}})]),_vm._v(_vm._s(event.time))])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.parseDescription(event.description))}})])]):_vm._e()]):_vm._e()}),_vm._v(" "),(_vm.eventsForDate(day.fullDate).length > _vm.maxEventsToShow)?_c('div',{staticClass:"more-events",on:{"click":function($event){return _vm.toggleDropdown(dayIndex)}}},[_vm._v("\n                            +"+_vm._s(_vm.eventsForDate(day.fullDate).length - _vm.maxEventsToShow)+" events\n                        ")]):_vm._e(),_vm._v(" "),(_vm.activeDayForDropdown === dayIndex)?_c('div',{staticClass:"dropdown"},[_c('div',{staticClass:"dropdown-content"},_vm._l((_vm.eventsForDate(day.fullDate).slice(_vm.maxEventsToShow)),function(event,eventIndex){return _c('div',{key:eventIndex},[_c('div',{staticClass:"eventdropdownItem",on:{"click":function($event){return _vm.toggleDropdownTooltip(event)}}},[_c('div',{staticClass:"event-time"},[_c('svg',{staticClass:"svgClockIcon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"17","viewBox":"0 0 20 21","fill":"none"}},[_c('path',{attrs:{"d":"M10 18.5C12.1217 18.5 14.1566 17.6571 15.6569 16.1569C17.1571 14.6566 18 12.6217 18 10.5C18 8.37827 17.1571 6.34344 15.6569 4.84315C14.1566 3.34285 12.1217 2.5 10 2.5C7.87827 2.5 5.84344 3.34285 4.34315 4.84315C2.84285 6.34344 2 8.37827 2 10.5C2 12.6217 2.84285 14.6566 4.34315 16.1569C5.84344 17.6571 7.87827 18.5 10 18.5ZM10 0.5C11.3132 0.5 12.6136 0.758658 13.8268 1.2612C15.0401 1.76375 16.1425 2.50035 17.0711 3.42893C17.9997 4.35752 18.7362 5.45991 19.2388 6.67317C19.7413 7.88642 20 9.18678 20 10.5C20 13.1522 18.9464 15.6957 17.0711 17.5711C15.1957 19.4464 12.6522 20.5 10 20.5C4.47 20.5 0 16 0 10.5C0 7.84784 1.05357 5.3043 2.92893 3.42893C4.8043 1.55357 7.34784 0.5 10 0.5ZM10.5 5.5V10.75L15 13.42L14.25 14.65L9 11.5V5.5H10.5Z","fill":"#333333"}})]),_vm._v(_vm._s(event.time)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"event-name"},[_vm._v(_vm._s(event.name))])]),_vm._v(" "),(_vm.activeTooltip === event)?_c('div',{ref:"dropdownTooltip-{{event.name}}",refInFor:true,staticClass:"dropdown-tooltip"},[_c('div',{staticClass:"close-button",on:{"click":function($event){$event.stopPropagation();return _vm.closeTooltip.apply(null, arguments)}}},[_vm._v("X")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"event-details"},[_c('div',{staticClass:"event-name",staticStyle:{"padding-top":"5px","padding-bottom":"5px","padding-right":"20px"}},[_vm._v(_vm._s(event.name))]),_vm._v(" "),_c('div',{staticClass:"event-time"},[_c('svg',{staticClass:"svgClockIcon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"17","viewBox":"0 0 20 21","fill":"none"}},[_c('path',{attrs:{"d":"M10 18.5C12.1217 18.5 14.1566 17.6571 15.6569 16.1569C17.1571 14.6566 18 12.6217 18 10.5C18 8.37827 17.1571 6.34344 15.6569 4.84315C14.1566 3.34285 12.1217 2.5 10 2.5C7.87827 2.5 5.84344 3.34285 4.34315 4.84315C2.84285 6.34344 2 8.37827 2 10.5C2 12.6217 2.84285 14.6566 4.34315 16.1569C5.84344 17.6571 7.87827 18.5 10 18.5ZM10 0.5C11.3132 0.5 12.6136 0.758658 13.8268 1.2612C15.0401 1.76375 16.1425 2.50035 17.0711 3.42893C17.9997 4.35752 18.7362 5.45991 19.2388 6.67317C19.7413 7.88642 20 9.18678 20 10.5C20 13.1522 18.9464 15.6957 17.0711 17.5711C15.1957 19.4464 12.6522 20.5 10 20.5C4.47 20.5 0 16 0 10.5C0 7.84784 1.05357 5.3043 2.92893 3.42893C4.8043 1.55357 7.34784 0.5 10 0.5ZM10.5 5.5V10.75L15 13.42L14.25 14.65L9 11.5V5.5H10.5Z","fill":"#333333"}})]),_vm._v(_vm._s(event.time)+"\n                        ")])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.parseDescription(event.description))}})])]):_vm._e()])}),0)]):_vm._e()],2)]),_vm._v(" "),(_vm.isLastDayOfMonth(day.fullDate))?_c('div',[_c('div',{staticClass:"month-name"},[_vm._v(_vm._s(_vm.getMonthName(day.fullDate)))]),_vm._v(" "),_c('div',{staticClass:"month-separator"})]):_vm._e()])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-types"},[_c('div',{staticClass:"event-type internal-event"},[_vm._v("Internal event")]),_vm._v(" "),_c('div',{staticClass:"event-type external-event"},[_vm._v("External event")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreetViewPanorama = exports.MountableMixin = exports.Autocomplete = exports.MapElementFactory = exports.MapElementMixin = exports.PlaceInput = exports.Map = exports.InfoWindow = exports.Rectangle = exports.Cluster = exports.Circle = exports.Polygon = exports.Polyline = exports.Marker = exports.loadGmapApi = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Vue component imports


exports.install = install;
exports.gmapApi = gmapApi;

var _lazyValue = __webpack_require__(584);

var _lazyValue2 = _interopRequireDefault(_lazyValue);

var _manager = __webpack_require__(585);

var _marker = __webpack_require__(586);

var _marker2 = _interopRequireDefault(_marker);

var _polyline = __webpack_require__(587);

var _polyline2 = _interopRequireDefault(_polyline);

var _polygon = __webpack_require__(588);

var _polygon2 = _interopRequireDefault(_polygon);

var _circle = __webpack_require__(589);

var _circle2 = _interopRequireDefault(_circle);

var _rectangle = __webpack_require__(590);

var _rectangle2 = _interopRequireDefault(_rectangle);

var _infoWindow = __webpack_require__(591);

var _infoWindow2 = _interopRequireDefault(_infoWindow);

var _map = __webpack_require__(594);

var _map2 = _interopRequireDefault(_map);

var _streetViewPanorama = __webpack_require__(599);

var _streetViewPanorama2 = _interopRequireDefault(_streetViewPanorama);

var _placeInput = __webpack_require__(604);

var _placeInput2 = _interopRequireDefault(_placeInput);

var _autocomplete = __webpack_require__(606);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _mapElementMixin = __webpack_require__(241);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _mapElementFactory = __webpack_require__(49);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

var _mountableMixin = __webpack_require__(168);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// HACK: Cluster should be loaded conditionally
// However in the web version, it's not possible to write
// `import 'vue2-google-maps/src/components/cluster'`, so we need to
// import it anyway (but we don't have to register it)
// Therefore we use babel-plugin-transform-inline-environment-variables to
// set BUILD_DEV to truthy / falsy
var Cluster = undefined;

var GmapApi = null;

// export everything
exports.loadGmapApi = _manager.loadGmapApi;
exports.Marker = _marker2.default;
exports.Polyline = _polyline2.default;
exports.Polygon = _polygon2.default;
exports.Circle = _circle2.default;
exports.Cluster = Cluster;
exports.Rectangle = _rectangle2.default;
exports.InfoWindow = _infoWindow2.default;
exports.Map = _map2.default;
exports.PlaceInput = _placeInput2.default;
exports.MapElementMixin = _mapElementMixin2.default;
exports.MapElementFactory = _mapElementFactory2.default;
exports.Autocomplete = _autocomplete2.default;
exports.MountableMixin = _mountableMixin2.default;
exports.StreetViewPanorama = _streetViewPanorama2.default;
function install(Vue, options) {
  // Set defaults
  options = _extends({
    installComponents: true,
    autobindAllEvents: false
  }, options);

  // Update the global `GmapApi`. This will allow
  // components to use the `google` global reactively
  // via:
  //   import {gmapApi} from 'vue2-google-maps'
  //   export default {  computed: { google: gmapApi }  }
  GmapApi = new Vue({ data: { gmapApi: null } });

  var defaultResizeBus = new Vue();

  // Use a lazy to only load the API when
  // a VGM component is loaded
  var gmapApiPromiseLazy = makeGmapApiPromiseLazy(options);

  Vue.mixin({
    created: function created() {
      this.$gmapDefaultResizeBus = defaultResizeBus;
      this.$gmapOptions = options;
      this.$gmapApiPromiseLazy = gmapApiPromiseLazy;
    }
  });
  Vue.$gmapDefaultResizeBus = defaultResizeBus;
  Vue.$gmapApiPromiseLazy = gmapApiPromiseLazy;

  if (options.installComponents) {
    Vue.component('GmapMap', _map2.default);
    Vue.component('GmapMarker', _marker2.default);
    Vue.component('GmapInfoWindow', _infoWindow2.default);
    Vue.component('GmapPolyline', _polyline2.default);
    Vue.component('GmapPolygon', _polygon2.default);
    Vue.component('GmapCircle', _circle2.default);
    Vue.component('GmapRectangle', _rectangle2.default);
    Vue.component('GmapAutocomplete', _autocomplete2.default);
    Vue.component('GmapPlaceInput', _placeInput2.default);
    Vue.component('GmapStreetViewPanorama', _streetViewPanorama2.default);
  }
}

function makeGmapApiPromiseLazy(options) {
  // Things to do once the API is loaded
  function onApiLoaded() {
    GmapApi.gmapApi = {};
    return window.google;
  }

  if (options.load) {
    // If library should load the API
    return (0, _lazyValue2.default)(function () {
      // Load the
      // This will only be evaluated once
      if (typeof window === 'undefined') {
        // server side -- never resolve this promise
        return new Promise(function () {}).then(onApiLoaded);
      } else {
        return new Promise(function (resolve, reject) {
          try {
            window['vueGoogleMapsInit'] = resolve;
            (0, _manager.loadGmapApi)(options.load, options.loadCn);
          } catch (err) {
            reject(err);
          }
        }).then(onApiLoaded);
      }
    });
  } else {
    // If library should not handle API, provide
    // end-users with the global `vueGoogleMapsInit: () => undefined`
    // when the Google Maps API has been loaded
    var promise = new Promise(function (resolve) {
      if (typeof window === 'undefined') {
        // Do nothing if run from server-side
        return;
      }
      window['vueGoogleMapsInit'] = resolve;
    }).then(onApiLoaded);

    return (0, _lazyValue2.default)(function () {
      return promise;
    });
  }
}

function gmapApi() {
  return GmapApi.gmapApi && window.google;
}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// This piece of code was orignally written by sindresorhus and can be seen here
// https://github.com/sindresorhus/lazy-value/blob/master/index.js

exports.default = function (fn) {
  var called = false;
  var ret = void 0;

  return function () {
    if (!called) {
      called = true;
      ret = fn();
    }

    return ret;
  };
};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isApiSetUp = false;

/**
 * @param apiKey    API Key, or object with the URL parameters. For example
 *                  to use Google Maps Premium API, pass
 *                    `{ client: <YOUR-CLIENT-ID> }`.
 *                  You may pass the libraries and/or version (as `v`) parameter into
 *                  this parameter and skip the next two parameters
 * @param version   Google Maps version
 * @param libraries Libraries to load (@see
 *                  https://developers.google.com/maps/documentation/javascript/libraries)
 * @param loadCn    Boolean. If set to true, the map will be loaded from google maps China
 *                  (@see https://developers.google.com/maps/documentation/javascript/basics#GoogleMapsChina)
 *
 * Example:
 * ```
 *      import {load} from 'vue-google-maps'
 *
 *      load(<YOUR-API-KEY>)
 *
 *      load({
 *              key: <YOUR-API-KEY>,
 *      })
 *
 *      load({
 *              client: <YOUR-CLIENT-ID>,
 *              channel: <YOUR CHANNEL>
 *      })
 * ```
 */
var loadGmapApi = exports.loadGmapApi = function (options, loadCn) {
  if (typeof document === 'undefined') {
    // Do nothing if run from server-side
    return;
  }
  if (!isApiSetUp) {
    isApiSetUp = true;

    var googleMapScript = document.createElement('SCRIPT');

    // Allow options to be an object.
    // This is to support more esoteric means of loading Google Maps,
    // such as Google for business
    // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
      throw new Error('options should  be an object');
    }

    // libraries
    if (Array.prototype.isPrototypeOf(options.libraries)) {
      options.libraries = options.libraries.join(',');
    }
    options['callback'] = 'vueGoogleMapsInit';

    var baseUrl = 'https://maps.googleapis.com/';

    if (typeof loadCn === 'boolean' && loadCn === true) {
      baseUrl = 'https://maps.google.cn/';
    }

    var url = baseUrl + 'maps/api/js?' + Object.keys(options).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(options[key]);
    }).join('&');

    googleMapScript.setAttribute('src', url);
    googleMapScript.setAttribute('async', '');
    googleMapScript.setAttribute('defer', '');
    document.head.appendChild(googleMapScript);
  } else {
    throw new Error('You already started the loading of google maps');
  }
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(49);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  animation: {
    twoWay: true,
    type: Number
  },
  attribution: {
    type: Object
  },
  clickable: {
    type: Boolean,
    twoWay: true,
    default: true
  },
  cursor: {
    type: String,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    twoWay: true,
    default: false
  },
  icon: {
    twoWay: true
  },
  label: {},
  opacity: {
    type: Number,
    default: 1
  },
  options: {
    type: Object
  },
  place: {
    type: Object
  },
  position: {
    type: Object,
    twoWay: true
  },
  shape: {
    type: Object,
    twoWay: true
  },
  title: {
    type: String,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  },
  visible: {
    twoWay: true,
    default: true
  }
};

var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];

/**
 * @class Marker
 *
 * Marker class with extra support for
 *
 * - Embedded info windows
 * - Clustered markers
 *
 * Support for clustered markers is for backward-compatability
 * reasons. Otherwise we should use a cluster-marker mixin or
 * subclass.
 */
exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'marker',
  ctr: function ctr() {
    return google.maps.Marker;
  },

  inject: {
    '$clusterPromise': {
      default: null
    }
  },

  render: function render(h) {
    if (!this.$slots.default || this.$slots.default.length === 0) {
      return '';
    } else if (this.$slots.default.length === 1) {
      // So that infowindows can have a marker parent
      return this.$slots.default[0];
    } else {
      return h('div', this.$slots.default);
    }
  },
  destroyed: function destroyed() {
    if (!this.$markerObject) {
      return;
    }

    if (this.$clusterObject) {
      // Repaint will be performed in `updated()` of cluster
      this.$clusterObject.removeMarker(this.$markerObject, true);
    } else {
      this.$markerObject.setMap(null);
    }
  },
  beforeCreate: function beforeCreate(options) {
    if (this.$clusterPromise) {
      options.map = null;
    }

    return this.$clusterPromise;
  },
  afterCreate: function afterCreate(inst) {
    var _this = this;

    if (this.$clusterPromise) {
      this.$clusterPromise.then(function (co) {
        co.addMarker(inst);
        _this.$clusterObject = co;
      });
    }
  }
});

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mapElementFactory = __webpack_require__(49);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    twoWay: false,
    type: Object
  },
  path: {
    type: Array,
    twoWay: true
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  props: {
    deepWatch: {
      type: Boolean,
      default: false
    }
  },
  events: events,

  name: 'polyline',
  ctr: function ctr() {
    return google.maps.Polyline;
  },

  afterCreate: function afterCreate() {
    var _this = this;

    var clearEvents = function () {};

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        _this.$polylineObject.setPath(path);

        var mvcPath = _this.$polylineObject.getPath();
        var eventListeners = [];

        var updatePaths = function () {
          _this.$emit('path_changed', _this.$polylineObject.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });
  }
});

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mapElementFactory = __webpack_require__(49);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    type: Object
  },
  path: {
    type: Array,
    twoWay: true,
    noBind: true
  },
  paths: {
    type: Array,
    twoWay: true,
    noBind: true
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  props: {
    deepWatch: {
      type: Boolean,
      default: false
    }
  },
  events: events,
  mappedProps: props,
  name: 'polygon',
  ctr: function ctr() {
    return google.maps.Polygon;
  },

  beforeCreate: function beforeCreate(options) {
    if (!options.path) delete options.path;
    if (!options.paths) delete options.paths;
  },
  afterCreate: function afterCreate(inst) {
    var _this = this;

    var clearEvents = function () {};

    // Watch paths, on our own, because we do not want to set either when it is
    // empty
    this.$watch('paths', function (paths) {
      if (paths) {
        clearEvents();

        inst.setPaths(paths);

        var updatePaths = function () {
          _this.$emit('paths_changed', inst.getPaths());
        };
        var eventListeners = [];

        var mvcArray = inst.getPaths();
        for (var i = 0; i < mvcArray.getLength(); i++) {
          var mvcPath = mvcArray.getAt(i);
          eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);
        }
        eventListeners.push([mvcArray, mvcArray.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        inst.setPaths(path);

        var mvcPath = inst.getPath();
        var eventListeners = [];

        var updatePaths = function () {
          _this.$emit('path_changed', inst.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                obj = _ref4[0],
                listenerHandle = _ref4[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });
  }
});

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(49);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    type: Object,
    twoWay: true,
    required: true
  },
  radius: {
    type: Number,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  name: 'circle',
  ctr: function ctr() {
    return google.maps.Circle;
  },
  events: events
});

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(49);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  bounds: {
    type: Object,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  name: 'rectangle',
  ctr: function ctr() {
    return google.maps.Rectangle;
  },
  events: events
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__(242);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(593);
var normalizeComponent = __webpack_require__(48)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(49);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  options: {
    type: Object,
    required: false,
    default: function _default() {
      return {};
    }
  },
  position: {
    type: Object,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  }
};

var events = ['domready', 'closeclick', 'content_changed'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'infoWindow',
  ctr: function ctr() {
    return google.maps.InfoWindow;
  },
  props: {
    opened: {
      type: Boolean,
      default: true
    }
  },

  inject: {
    '$markerPromise': {
      default: null
    }
  },

  mounted: function mounted() {
    var el = this.$refs.flyaway;
    el.parentNode.removeChild(el);
  },
  beforeCreate: function beforeCreate(options) {
    var _this = this;

    options.content = this.$refs.flyaway;

    if (this.$markerPromise) {
      delete options.position;
      return this.$markerPromise.then(function (mo) {
        _this.$markerObject = mo;
        return mo;
      });
    }
  },


  methods: {
    _openInfoWindow: function _openInfoWindow() {
      if (this.opened) {
        if (this.$markerObject !== null) {
          this.$infoWindowObject.open(this.$map, this.$markerObject);
        } else {
          this.$infoWindowObject.open(this.$map);
        }
      } else {
        this.$infoWindowObject.close();
      }
    }
  },

  afterCreate: function afterCreate() {
    var _this2 = this;

    this._openInfoWindow();
    this.$watch('opened', function () {
      _this2._openInfoWindow();
    });
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__(243);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(598);
function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var normalizeComponent = __webpack_require__(48)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(596);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(67)("36912544", content, true, {});

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(66)(false);
// imports


// module
exports.push([module.i, ".vue-map-container{position:relative}.vue-map-container .vue-map{left:0;right:0;top:0;bottom:0;position:absolute}.vue-map-hidden{display:none}", ""]);

// exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindEvents = __webpack_require__(166);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(99);

var _mountableMixin = __webpack_require__(168);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = __webpack_require__(244);

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

var _WatchPrimitiveProperties = __webpack_require__(167);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

var _mapElementFactory = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    required: true,
    twoWay: true,
    type: Object,
    noBind: true
  },
  zoom: {
    required: false,
    twoWay: true,
    type: Number,
    noBind: true
  },
  heading: {
    type: Number,
    twoWay: true
  },
  mapTypeId: {
    twoWay: true,
    type: String
  },
  tilt: {
    twoWay: true,
    type: Number
  },
  options: {
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['bounds_changed', 'click', 'dblclick', 'drag', 'dragend', 'dragstart', 'idle', 'mousemove', 'mouseout', 'mouseover', 'resize', 'rightclick', 'tilesloaded'];

// Plain Google Maps methods exposed here for convenience
var linkedMethods = ['panBy', 'panTo', 'panToBounds', 'fitBounds'].reduce(function (all, methodName) {
  all[methodName] = function () {
    if (this.$mapObject) {
      this.$mapObject[methodName].apply(this.$mapObject, arguments);
    }
  };
  return all;
}, {});

// Other convenience methods exposed by Vue Google Maps
var customMethods = {
  resize: function resize() {
    if (this.$mapObject) {
      google.maps.event.trigger(this.$mapObject, 'resize');
    }
  },
  resizePreserveCenter: function resizePreserveCenter() {
    if (!this.$mapObject) {
      return;
    }

    var oldCenter = this.$mapObject.getCenter();
    google.maps.event.trigger(this.$mapObject, 'resize');
    this.$mapObject.setCenter(oldCenter);
  },


  /// Override mountableMixin::_resizeCallback
  /// because resizePreserveCenter is usually the
  /// expected behaviour
  _resizeCallback: function _resizeCallback() {
    this.resizePreserveCenter();
  }
};

exports.default = {
  mixins: [_mountableMixin2.default],
  props: (0, _mapElementFactory.mappedPropsToVueProps)(props),

  provide: function provide() {
    var _this = this;

    this.$mapPromise = new Promise(function (resolve, reject) {
      _this.$mapPromiseDeferred = { resolve: resolve, reject: reject };
    });
    return {
      '$mapPromise': this.$mapPromise
    };
  },


  computed: {
    finalLat: function finalLat() {
      return this.center && typeof this.center.lat === 'function' ? this.center.lat() : this.center.lat;
    },
    finalLng: function finalLng() {
      return this.center && typeof this.center.lng === 'function' ? this.center.lng() : this.center.lng;
    },
    finalLatLng: function finalLatLng() {
      return { lat: this.finalLat, lng: this.finalLng };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$mapObject) {
        this.$mapObject.setZoom(_zoom);
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return this.$gmapApiPromiseLazy().then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-map'];

      // creating the map
      var options = _extends({}, _this2.options, (0, _bindProps.getPropsValues)(_this2, props));
      delete options.options;
      _this2.$mapObject = new google.maps.Map(element, options);

      // binding properties (two and one way)
      (0, _bindProps.bindProps)(_this2, _this2.$mapObject, props);
      // binding events
      (0, _bindEvents2.default)(_this2, _this2.$mapObject, events);

      // manually trigger center and zoom
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        _this2.$mapObject.addListener('center_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('center_changed', _this2.$mapObject.getCenter());
          }
          decrement();
        });

        (0, _WatchPrimitiveProperties2.default)(_this2, ['finalLat', 'finalLng'], function updateCenter() {
          increment();
          _this2.$mapObject.setCenter(_this2.finalLatLng);
        });
      });
      _this2.$mapObject.addListener('zoom_changed', function () {
        _this2.$emit('zoom_changed', _this2.$mapObject.getZoom());
      });
      _this2.$mapObject.addListener('bounds_changed', function () {
        _this2.$emit('bounds_changed', _this2.$mapObject.getBounds());
      });

      _this2.$mapPromiseDeferred.resolve(_this2.$mapObject);

      return _this2.$mapObject;
    }).catch(function (error) {
      throw error;
    });
  },

  methods: _extends({}, customMethods, linkedMethods)
};

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__(245);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(603);
function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var normalizeComponent = __webpack_require__(48)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(601);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(67)("2f9c3920", content, true, {});

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(66)(false);
// imports


// module
exports.push([module.i, ".vue-street-view-pano-container{position:relative}.vue-street-view-pano-container .vue-street-view-pano{left:0;right:0;top:0;bottom:0;position:absolute}", ""]);

// exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindEvents = __webpack_require__(166);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(99);

var _mountableMixin = __webpack_require__(168);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = __webpack_require__(244);

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

var _WatchPrimitiveProperties = __webpack_require__(167);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

var _mapElementFactory = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  zoom: {
    twoWay: true,
    type: Number
  },
  pov: {
    twoWay: true,
    type: Object,
    trackProperties: ['pitch', 'heading']
  },
  position: {
    twoWay: true,
    type: Object,
    noBind: true
  },
  pano: {
    twoWay: true,
    type: String
  },
  motionTracking: {
    twoWay: false,
    type: Boolean
  },
  visible: {
    twoWay: true,
    type: Boolean,
    default: true
  },
  options: {
    twoWay: false,
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['closeclick', 'status_changed'];

exports.default = {
  mixins: [_mountableMixin2.default],
  props: (0, _mapElementFactory.mappedPropsToVueProps)(props),
  replace: false, // necessary for css styles
  methods: {
    resize: function resize() {
      if (this.$panoObject) {
        google.maps.event.trigger(this.$panoObject, 'resize');
      }
    }
  },

  provide: function provide() {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _this.$panoPromiseDeferred = { resolve: resolve, reject: reject };
    });
    return {
      '$panoPromise': promise,
      '$mapPromise': promise // so that we can use it with markers
    };
  },


  computed: {
    finalLat: function finalLat() {
      return this.position && typeof this.position.lat === 'function' ? this.position.lat() : this.position.lat;
    },
    finalLng: function finalLng() {
      return this.position && typeof this.position.lng === 'function' ? this.position.lng() : this.position.lng;
    },
    finalLatLng: function finalLatLng() {
      return {
        lat: this.finalLat,
        lng: this.finalLng
      };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$panoObject) {
        this.$panoObject.setZoom(_zoom);
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return this.$gmapApiPromiseLazy().then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-street-view-pano'];

      // creating the map
      var options = _extends({}, _this2.options, (0, _bindProps.getPropsValues)(_this2, props));
      delete options.options;

      _this2.$panoObject = new google.maps.StreetViewPanorama(element, options);

      // binding properties (two and one way)
      (0, _bindProps.bindProps)(_this2, _this2.$panoObject, props);
      // binding events
      (0, _bindEvents2.default)(_this2, _this2.$panoObject, events);

      // manually trigger position
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        // Panos take a while to load
        increment();

        _this2.$panoObject.addListener('position_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('position_changed', _this2.$panoObject.getPosition());
          }
          decrement();
        });

        (0, _WatchPrimitiveProperties2.default)(_this2, ['finalLat', 'finalLng'], function updateCenter() {
          increment();
          _this2.$panoObject.setPosition(_this2.finalLatLng);
        });
      });

      _this2.$panoPromiseDeferred.resolve(_this2.$panoObject);

      return _this2.$panoPromise;
    }).catch(function (error) {
      throw error;
    });
  }
};

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(605);
var normalizeComponent = __webpack_require__(48)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__(248);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(608);
var normalizeComponent = __webpack_require__(48)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindProps = __webpack_require__(99);

var _simulateArrowDown = __webpack_require__(247);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

var _mapElementFactory = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mappedProps = {
  bounds: {
    type: Object
  },
  componentRestrictions: {
    type: Object,
    // Do not bind -- must check for undefined
    // in the property
    noBind: true
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  }
};

var props = {
  selectFirstOnEnter: {
    required: false,
    type: Boolean,
    default: false
  },
  options: {
    type: Object
  }
};

exports.default = {
  mounted: function mounted() {
    var _this = this;

    this.$gmapApiPromiseLazy().then(function () {
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      /* eslint-disable no-unused-vars */
      var finalOptions = _extends({}, (0, _bindProps.getPropsValues)(_this, mappedProps), _this.options);

      _this.$autocomplete = new google.maps.places.Autocomplete(_this.$refs.input, finalOptions);
      (0, _bindProps.bindProps)(_this, _this.$autocomplete, mappedProps);

      _this.$watch('componentRestrictions', function (v) {
        if (v !== undefined) {
          _this.$autocomplete.setComponentRestrictions(v);
        }
      });

      // Not using `bindEvents` because we also want
      // to return the result of `getPlace()`
      _this.$autocomplete.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.$autocomplete.getPlace());
      });
    });
  },

  props: _extends({}, (0, _mapElementFactory.mappedPropsToVueProps)(mappedProps), props)
};

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js